export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AccountsDateTime: any;
  BattlePassDateTime: any;
  Borderlands4DocumentContentInputBase64Json: any;
  Borderlands4StructDocumentInputBase64Json: any;
  Borderlands4UserGeneratedDocumentInputBase64Json: any;
  Borderlands4WikiDocumentInputBase64Json: any;
  ChallengeDateTime: any;
  /** Named after, and bound like, the Comments subgraph's scalar, so CommentsPayload.cutoffDate composes. */
  DateTime: any;
  DeadlockDocumentContentInputBase64Json: any;
  DeadlockStructDocumentInputBase64Json: any;
  DeadlockUserGeneratedDocumentInputBase64Json: any;
  DeadlockWikiDocumentInputBase64Json: any;
  Destiny2NgfDocumentContentInputBase64Json: any;
  Destiny2NgfStructDocumentInputBase64Json: any;
  Destiny2NgfUserGeneratedDocumentInputBase64Json: any;
  Destiny2NgfWikiDocumentInputBase64Json: any;
  DestinyDateTime: any;
  DestinyHexColor: any;
  DestinyLocale: any;
  DestinyUrl: any;
  Diablo4DocumentContentInputBase64Json: any;
  Diablo4StructDocumentInputBase64Json: any;
  Diablo4UserGeneratedDocumentInputBase64Json: any;
  Diablo4WikiDocumentInputBase64Json: any;
  EldenRingNightreignDocumentContentInputBase64Json: any;
  EldenRingNightreignStructDocumentInputBase64Json: any;
  EldenRingNightreignUserGeneratedDocumentInputBase64Json: any;
  EldenRingNightreignWikiDocumentInputBase64Json: any;
  EndfieldDocumentContentInputBase64Json: any;
  EndfieldStructDocumentInputBase64Json: any;
  EndfieldUserGeneratedDocumentInputBase64Json: any;
  EndfieldWikiDocumentInputBase64Json: any;
  ExampleGameDocumentContentInputBase64Json: any;
  ExampleGameStructDocumentInputBase64Json: any;
  ExampleGameUserGeneratedDocumentInputBase64Json: any;
  ExampleGameWikiDocumentInputBase64Json: any;
  GiDocumentContentInputBase64Json: any;
  GiStructDocumentInputBase64Json: any;
  GiUserGeneratedDocumentInputBase64Json: any;
  GiWikiDocumentInputBase64Json: any;
  Hades2DocumentContentInputBase64Json: any;
  Hades2StructDocumentInputBase64Json: any;
  Hades2UserGeneratedDocumentInputBase64Json: any;
  Hades2WikiDocumentInputBase64Json: any;
  Int64: any;
  JSON: any;
  LolNgfDocumentContentInputBase64Json: any;
  LolNgfStructDocumentInputBase64Json: any;
  LolNgfUserGeneratedDocumentInputBase64Json: any;
  LolNgfWikiDocumentInputBase64Json: any;
  Map: any;
  MarathonDocumentContentInputBase64Json: any;
  MarathonStructDocumentInputBase64Json: any;
  MarathonUserGeneratedDocumentInputBase64Json: any;
  MarathonWikiDocumentInputBase64Json: any;
  MarvelRivalsDocumentContentInputBase64Json: any;
  MarvelRivalsStructDocumentInputBase64Json: any;
  MarvelRivalsUserGeneratedDocumentInputBase64Json: any;
  MarvelRivalsWikiDocumentInputBase64Json: any;
  MhwDocumentContentInputBase64Json: any;
  MhwStructDocumentInputBase64Json: any;
  MhwUserGeneratedDocumentInputBase64Json: any;
  MhwWikiDocumentInputBase64Json: any;
  NewsDocumentContentInputBase64Json: any;
  NewsStructDocumentInputBase64Json: any;
  NewsUserGeneratedDocumentInputBase64Json: any;
  NewsWikiDocumentInputBase64Json: any;
  /** ISO-8601 timestamp string. */
  NgfDateTime: any;
  /** Schema.org JSON-LD blob serialized as a string. */
  NgfDocumentStrJsonLd: any;
  /**
   * NgfDocumentRichTextContent is an arbitrary JSON output of a rich text editor, which is used to store rich text content.
   * - Golang representation - json.RawMessage
   * - Typescript representation - any
   */
  NgfDocumentWidgetRichTextContentJson: any;
  NteDocumentContentInputBase64Json: any;
  NteStructDocumentInputBase64Json: any;
  NteUserGeneratedDocumentInputBase64Json: any;
  NteWikiDocumentInputBase64Json: any;
  OverwatchDocumentContentInputBase64Json: any;
  OverwatchStructDocumentInputBase64Json: any;
  OverwatchUserGeneratedDocumentInputBase64Json: any;
  OverwatchWikiDocumentInputBase64Json: any;
  Poe2DocumentContentInputBase64Json: any;
  Poe2StructDocumentInputBase64Json: any;
  Poe2UserGeneratedDocumentInputBase64Json: any;
  Poe2WikiDocumentInputBase64Json: any;
  PoeDocumentContentInputBase64Json: any;
  PoeStructDocumentInputBase64Json: any;
  PoeUserGeneratedDocumentInputBase64Json: any;
  PoeWikiDocumentInputBase64Json: any;
  /**
   * Puuid is unique identifier for a player regionwise.
   * Fixed length 78 characters.
   * https://riot-api-libraries.readthedocs.io/en/latest/ids.htmlr
   */
  Puuid: any;
  RewardDateTime: any;
  RiftboundDocumentContentInputBase64Json: any;
  RiftboundStructDocumentInputBase64Json: any;
  RiftboundUserGeneratedDocumentInputBase64Json: any;
  RiftboundWikiDocumentInputBase64Json: any;
  Sts2DocumentContentInputBase64Json: any;
  Sts2StructDocumentInputBase64Json: any;
  Sts2UserGeneratedDocumentInputBase64Json: any;
  Sts2WikiDocumentInputBase64Json: any;
  /** Coordinate type for unit position in composition. */
  TftCoordinates: any;
  /**
   * DateTime in RFC3339
   * i.e "2006-01-02T15:04:05Z07:00"
   */
  TftDateTime: any;
  TftNgfDocumentContentInputBase64Json: any;
  TftNgfStructDocumentInputBase64Json: any;
  TftNgfUserGeneratedDocumentInputBase64Json: any;
  TftNgfWikiDocumentInputBase64Json: any;
  /**
   * Set is an alias for a season of TFT.
   * Must be positive integer.
   */
  TftSet: any;
  TheBazaarDocumentContentInputBase64Json: any;
  TheBazaarStructDocumentInputBase64Json: any;
  TheBazaarUserGeneratedDocumentInputBase64Json: any;
  TheBazaarWikiDocumentInputBase64Json: any;
  Timestamp: any;
  TreasuryFlowTime: any;
  TreasuryFlowTimeDuration: any;
  /**
   * Treasury Payments API duration type
   * Implements ISO8601 duration format
   */
  TreasuryPaymentsDuration: any;
  /**
   * Treasury Payments API time type
   * Implements RFC3999 time format
   */
  TreasuryPaymentsTime: any;
  UUID: any;
  ValorantNgfDocumentContentInputBase64Json: any;
  ValorantNgfStructDocumentInputBase64Json: any;
  ValorantNgfUserGeneratedDocumentInputBase64Json: any;
  ValorantNgfWikiDocumentInputBase64Json: any;
  WowforDocumentContentInputBase64Json: any;
  WowforStructDocumentInputBase64Json: any;
  WowforUserGeneratedDocumentInputBase64Json: any;
  WowforWikiDocumentInputBase64Json: any;
  XkoDocumentContentInputBase64Json: any;
  XkoStructDocumentInputBase64Json: any;
  XkoUserGeneratedDocumentInputBase64Json: any;
  XkoWikiDocumentInputBase64Json: any;
  ZzzDocumentContentInputBase64Json: any;
  ZzzStructDocumentInputBase64Json: any;
  ZzzUserGeneratedDocumentInputBase64Json: any;
  ZzzWikiDocumentInputBase64Json: any;
};

/** Supported auth providers. */
export enum AccountsAuthProviderType {
  DISCORD = 'DISCORD',
  GGG = 'GGG',
  GOOGLE = 'GOOGLE',
  RIOT = 'RIOT',
  STEAM = 'STEAM',
  TWITCH = 'TWITCH',
}

export type AccountsBadRequestError = AccountsError & {
  __typename?: 'AccountsBadRequestError';
  message: Scalars['String'];
};

export type AccountsConnectedProvider = {
  __typename?: 'AccountsConnectedProvider';
  type: AccountsAuthProviderType;
  userName: Scalars['String'];
};

export type AccountsConnectedProvidersError = AccountsInternalError | AccountsUnauthorizedError;

export type AccountsConnectedProvidersPayload = {
  __typename?: 'AccountsConnectedProvidersPayload';
  error?: Maybe<AccountsConnectedProvidersError>;
  providers?: Maybe<Array<AccountsConnectedProvider>>;
};

export type AccountsCurrentUserError = AccountsInternalError | AccountsUnauthorizedError;

export type AccountsCurrentUserPayload = {
  __typename?: 'AccountsCurrentUserPayload';
  error?: Maybe<AccountsCurrentUserError>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum AccountsDeleteUserError {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type AccountsDeleteUserPayload = {
  __typename?: 'AccountsDeleteUserPayload';
  error?: Maybe<AccountsDeleteUserError>;
};

export type AccountsDisconnectProviderError = AccountsInternalError | AccountsUnauthorizedError;

export type AccountsDisconnectProviderInput = {
  type: AccountsAuthProviderType;
};

export type AccountsDisconnectProviderPayload = {
  __typename?: 'AccountsDisconnectProviderPayload';
  error?: Maybe<AccountsDisconnectProviderError>;
  result: Scalars['Boolean'];
};

export type AccountsError = {
  message: Scalars['String'];
};

export type AccountsInternalError = AccountsError & {
  __typename?: 'AccountsInternalError';
  message: Scalars['String'];
};

export type AccountsMutation = {
  __typename?: 'AccountsMutation';
  /** Deletes all data of currently logged in user and performs a logout */
  deleteUser?: Maybe<AccountsDeleteUserPayload>;
  /** Disconnect the provider from the profile */
  disconnectProvider: AccountsDisconnectProviderPayload;
  /** Provide new password after password reset request */
  passwordReset?: Maybe<AccountsPasswordResetPayload>;
  /** Request password reset email */
  passwordResetRequest?: Maybe<AccountsPasswordResetRequestPayload>;
  /** Login user, create web session */
  signIn?: Maybe<AccountsSignInPayload>;
  /** Logout user, destroy web session */
  signOut?: Maybe<AccountsSignOutPayload>;
  /** Create user account and login user */
  signUp?: Maybe<AccountsSignUpPayload>;
  /** Updates data of currently logged in user */
  updateUser?: Maybe<AccountsUpdateUserPayload>;
};

export type AccountsMutationdisconnectProviderArgs = {
  input: AccountsDisconnectProviderInput;
};

export type AccountsMutationpasswordResetArgs = {
  input: AccountsPasswordResetInput;
};

export type AccountsMutationpasswordResetRequestArgs = {
  input: AccountsPasswordResetRequestInput;
};

export type AccountsMutationsignInArgs = {
  input?: InputMaybe<AccountsSignInInput>;
};

export type AccountsMutationsignUpArgs = {
  input?: InputMaybe<AccountsSignUpInput>;
};

export type AccountsMutationupdateUserArgs = {
  input?: InputMaybe<AccountsUpdateUserInput>;
};

export enum AccountsPasswordResetError {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type AccountsPasswordResetInput = {
  password: Scalars['String'];
  repeatPassword: Scalars['String'];
  token: Scalars['String'];
};

export type AccountsPasswordResetPayload = {
  __typename?: 'AccountsPasswordResetPayload';
  error?: Maybe<AccountsPasswordResetError>;
  success: Scalars['Boolean'];
};

export enum AccountsPasswordResetRequestError {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}

export type AccountsPasswordResetRequestInput = {
  email: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
  redirectURL: Scalars['String'];
  theme?: InputMaybe<Scalars['String']>;
};

export type AccountsPasswordResetRequestPayload = {
  __typename?: 'AccountsPasswordResetRequestPayload';
  error?: Maybe<AccountsPasswordResetRequestError>;
  success: Scalars['Boolean'];
};

export type AccountsQuery = {
  __typename?: 'AccountsQuery';
  /** Returns the providers connected to the user */
  connectedProviders?: Maybe<AccountsConnectedProvidersPayload>;
  /** Returns data regarding logged in user */
  currentUser?: Maybe<AccountsCurrentUserPayload>;
  /**
   *  Return token used in URL query params during redirect from desktop to web.
   * This token ensures that in web the same user will be logged in as in desktop.
   */
  redirectToken?: Maybe<AccountsRedirectTokenPayload>;
  /** Returns public data regarding any Accounts user */
  users?: Maybe<AccountsUsersPayload>;
};

export type AccountsQueryusersArgs = {
  filter?: InputMaybe<AccountsUsersFilter>;
};

export enum AccountsRedirectTokenError {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type AccountsRedirectTokenPayload = {
  __typename?: 'AccountsRedirectTokenPayload';
  error?: Maybe<AccountsRedirectTokenError>;
  token?: Maybe<Scalars['String']>;
};

export enum AccountsSignInError {
  EMPTY_INPUT = 'EMPTY_INPUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
}

export type AccountsSignInInput = {
  continueFrom?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AccountsSignInPayload = {
  __typename?: 'AccountsSignInPayload';
  error?: Maybe<AccountsSignInError>;
  user?: Maybe<User>;
};

export enum AccountsSignOutError {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}

export type AccountsSignOutPayload = {
  __typename?: 'AccountsSignOutPayload';
  error?: Maybe<AccountsSignOutError>;
  success: Scalars['Boolean'];
};

export enum AccountsSignUpError {
  EMPTY_INPUT = 'EMPTY_INPUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS',
}

export type AccountsSignUpInput = {
  continueFrom?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type AccountsSignUpPayload = {
  __typename?: 'AccountsSignUpPayload';
  error?: Maybe<AccountsSignUpError>;
  user?: Maybe<User>;
};

/** Social link with network name and URL */
export type AccountsSocialLink = {
  __typename?: 'AccountsSocialLink';
  /** Name of the social network (e.g. youtube, discord, twitch) */
  name: Scalars['String'];
  /** URL of the link */
  url: Scalars['String'];
};

export type AccountsUnauthorizedError = AccountsError & {
  __typename?: 'AccountsUnauthorizedError';
  message: Scalars['String'];
};

export enum AccountsUpdateUserError {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  INVALID_USERNAME = 'INVALID_USERNAME',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UPDATE_USERNAME_COOLDOWN = 'UPDATE_USERNAME_COOLDOWN',
}

export type AccountsUpdateUserInput = {
  attributes?: InputMaybe<Array<AccountsUserAttributeInput>>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<AccountsUpdateUserPasswordInput>;
  username?: InputMaybe<Scalars['String']>;
};

export type AccountsUpdateUserPasswordInput = {
  new: Scalars['String'];
  old: Scalars['String'];
};

export type AccountsUpdateUserPayload = {
  __typename?: 'AccountsUpdateUserPayload';
  data?: Maybe<User>;
  error?: Maybe<AccountsUpdateUserError>;
};

export type AccountsUserAttribute = {
  __typename?: 'AccountsUserAttribute';
  expire?: Maybe<Scalars['AccountsDateTime']>;
  id: Scalars['ID'];
  key: AccountsUserAttributeKey;
  user?: Maybe<User>;
  userId: Scalars['ID'];
  value?: Maybe<Scalars['String']>;
};

export type AccountsUserAttributeInput = {
  /** Empty value makes attribute non-expiring (nullifies value) */
  expire?: InputMaybe<Scalars['AccountsDateTime']>;
  key: AccountsUserAttributeKey;
  /** Empty value nullifies the attribute value if it exists */
  value?: InputMaybe<Scalars['String']>;
};

export enum AccountsUserAttributeKey {
  ACCOUNT_NAME = 'ACCOUNT_NAME',
  ACCOUNT_ONBOARDING_INFO = 'ACCOUNT_ONBOARDING_INFO',
  DISCORD_PROFILE_URL = 'DISCORD_PROFILE_URL',
  SUMMONER_NAME_TAGLINE = 'SUMMONER_NAME_TAGLINE',
  SUMMONER_PROFILE_ICON = 'SUMMONER_PROFILE_ICON',
  SUMMONER_REGION = 'SUMMONER_REGION',
  TWITCH_PROFILE_URL = 'TWITCH_PROFILE_URL',
  USER_STATUS_AD_FREE = 'USER_STATUS_AD_FREE',
  USER_STATUS_EMPLOYEE = 'USER_STATUS_EMPLOYEE',
  USER_STATUS_PREMIUM = 'USER_STATUS_PREMIUM',
  X_PROFILE_URL = 'X_PROFILE_URL',
  YOUTUBE_PROFILE_URL = 'YOUTUBE_PROFILE_URL',
}

export type AccountsUserAttributeKeyValue = {
  key: AccountsUserAttributeKey;
  value: Scalars['String'];
};

export type AccountsUserAttributesFilter = {
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  keys?: InputMaybe<Array<AccountsUserAttributeKey>>;
};

export type AccountsUsersError = AccountsInternalError;

/** Filter users' profiles. All users that match at least one of the filters are returned */
export type AccountsUsersFilter = {
  /** Case insensitive search for users by attributes' values */
  attributesEqual?: InputMaybe<Array<AccountsUserAttributeKeyValue>>;
  /** Case insensitive search for users by a part of attributes' values */
  attributesLike?: InputMaybe<Array<AccountsUserAttributeKeyValue>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  usernames?: InputMaybe<Array<Scalars['String']>>;
};

export type AccountsUsersPayload = {
  __typename?: 'AccountsUsersPayload';
  data?: Maybe<Array<User>>;
  error?: Maybe<AccountsUsersError>;
};

export type AccountsWebSession = {
  __typename?: 'AccountsWebSession';
  id: Scalars['ID'];
};

export enum AckSignalsError {
  INTERNAL = 'INTERNAL',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type AckSignalsPayload = {
  __typename?: 'AckSignalsPayload';
  error?: Maybe<AckSignalsError>;
  errorMessage?: Maybe<Scalars['String']>;
  signalCount?: Maybe<Scalars['Int']>;
};

export type AtlasKeystoneNode = {
  __typename?: 'AtlasKeystoneNode';
  nodeIcon: Scalars['String'];
  nodeName: Scalars['String'];
  nodeSlug: Scalars['String'];
  selectionDescription: Scalars['String'];
  selectionName: Scalars['String'];
  selectionSlug: Scalars['String'];
};

export type AtlasMaster = {
  __typename?: 'AtlasMaster';
  icon: Scalars['String'];
  name: Scalars['String'];
  skills?: Maybe<Array<AtlasMasterSkill>>;
  slug: Scalars['String'];
};

export type AtlasMasterSkill = {
  __typename?: 'AtlasMasterSkill';
  icon: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type AttributeNode = {
  __typename?: 'AttributeNode';
  attribute: Scalars['String'];
  nodeSlug: Scalars['String'];
};

/** !!! DEPRECATED !!! */
export enum AugmentTier {
  A = 'A',
  B = 'B',
  S = 'S',
}

export type AuthorMeta = {
  __typename?: 'AuthorMeta';
  id: Scalars['ID'];
  /** Favorites the author's published NGF documents have received, per game and type. */
  receivedFavorites: AuthorReceivedFavorites;
};

export type AuthorReceivedFavorites = {
  __typename?: 'AuthorReceivedFavorites';
  /** Game and type pairs with at least one favorite, most favorites first. */
  byType: Array<AuthorReceivedFavoritesByType>;
  total: Scalars['Int'];
};

export type AuthorReceivedFavoritesByType = {
  __typename?: 'AuthorReceivedFavoritesByType';
  count: Scalars['Int'];
  /** The slug the game publishes in its NGF events. */
  game: Scalars['String'];
  type: Scalars['String'];
};

export type AuthorSuggestion = {
  __typename?: 'AuthorSuggestion';
  name: Scalars['String'];
  score: Scalars['Float'];
};

export type AutocompleteAuthorRequestInput = {
  game?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
};

export type AutocompleteAuthorResponse = {
  __typename?: 'AutocompleteAuthorResponse';
  authorNames: Array<Scalars['String']>;
  requestId: Scalars['String'];
};

export type AutocompleteDocument = {
  __typename?: 'AutocompleteDocument';
  authorName?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  game?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  originalTags?: Maybe<Array<OriginalTag>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['Int64'];
  url: Scalars['String'];
};

export type AutocompleteRequestInput = {
  authors?: InputMaybe<Array<Scalars['String']>>;
  docType?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
};

export type AutocompleteResponse = {
  __typename?: 'AutocompleteResponse';
  documents: Array<AutocompleteDocument>;
  requestId: Scalars['String'];
};

export type AvailableWidget = {
  __typename?: 'AvailableWidget';
  meta: WidgetMeta;
  /** @deprecated Use userRoleRequiredForAccess instead */
  prohibitedForRegularUser: Scalars['Boolean'];
  userRoleRequiredForAccess: Scalars['String'];
};

export enum BadgeVar {
  ARCHETYPE_ID = 'ARCHETYPE_ID',
  CHAMPION_SLUG = 'CHAMPION_SLUG',
  LOSE_NUMBER = 'LOSE_NUMBER',
  LP_NUMBER = 'LP_NUMBER',
  PLACE_NUMBER = 'PLACE_NUMBER',
  WINS_NUMBER = 'WINS_NUMBER',
}

export type BattlePass = {
  __typename?: 'BattlePass';
  booster: BattlePassBooster;
  canPurchasePremium: Scalars['Boolean'];
  createdAt: Scalars['BattlePassDateTime'];
  displayParams: BattlePassDisplayParams;
  endAt: Scalars['BattlePassDateTime'];
  enrollment?: Maybe<BattlePassEnrollment>;
  graceEndAt: Scalars['BattlePassDateTime'];
  gracePeriodDays: Scalars['Int'];
  id: Scalars['ID'];
  levels?: Maybe<Array<BattlePassLevel>>;
  name: Scalars['String'];
  startAt: Scalars['BattlePassDateTime'];
  status: BattlePassStatus;
  updatedAt?: Maybe<Scalars['BattlePassDateTime']>;
  version: Scalars['Int'];
};

export type BattlePassActivatedPayload = NotificationPayload & {
  __typename?: 'BattlePassActivatedPayload';
  bpId: Scalars['ID'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export enum BattlePassAddDeltaXPError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassAddDeltaXPInput = {
  desiredXP: Scalars['Int'];
  provider: BattlePassProvider;
};

export type BattlePassAddDeltaXPPayload = {
  __typename?: 'BattlePassAddDeltaXPPayload';
  error?: Maybe<BattlePassAddDeltaXPError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassAddXPError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassAddXPInput = {
  bpID: Scalars['String'];
  deltaXP: Scalars['Int'];
};

export type BattlePassAddXPPayload = {
  __typename?: 'BattlePassAddXPPayload';
  error?: Maybe<BattlePassAddXPError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassAdminChangeStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export enum BattlePassAdminCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassAdminCreateInput = {
  displayParams: BattlePassDisplayParamsInput;
  endAt: Scalars['BattlePassDateTime'];
  gracePeriodDays?: InputMaybe<Scalars['Int']>;
  levels?: InputMaybe<Array<BattlePassAdminCreateLevelInput>>;
  name: Scalars['String'];
  startAt: Scalars['BattlePassDateTime'];
};

export type BattlePassAdminCreateLevelInput = {
  requiredXP: Scalars['Int'];
  rewards?: InputMaybe<Array<BattlePassAdminCreateLevelRewardInput>>;
};

export type BattlePassAdminCreateLevelRewardInput = {
  coverID: Scalars['String'];
  requiredAccess: BattlePassRewardsAccess;
  rewardID: Scalars['ID'];
};

export type BattlePassAdminCreatePayload = {
  __typename?: 'BattlePassAdminCreatePayload';
  bp?: Maybe<BattlePass>;
  error?: Maybe<BattlePassAdminCreateError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassAdminEditError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassAdminEditInput = {
  displayParams: BattlePassDisplayParamsInput;
  endAt: Scalars['BattlePassDateTime'];
  gracePeriodDays?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  levels?: InputMaybe<Array<BattlePassAdminCreateLevelInput>>;
  name: Scalars['String'];
  startAt: Scalars['BattlePassDateTime'];
  version: Scalars['Int'];
};

export type BattlePassAdminEditPayload = {
  __typename?: 'BattlePassAdminEditPayload';
  bp?: Maybe<BattlePass>;
  error?: Maybe<BattlePassAdminEditError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassAdminListRewardCoversError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassAdminMutation = {
  __typename?: 'BattlePassAdminMutation';
  addDeltaXPToEnrollment: BattlePassAddDeltaXPPayload;
  addXPToEnrollment: BattlePassAddXPPayload;
  bpChangeStatus: BattlePassChangeStatusPayload;
  bpCreate: BattlePassAdminCreatePayload;
  bpEdit: BattlePassAdminEditPayload;
  changeEnrRewardAccess: BattlePassChangeEnrRewardAccessPayload;
  createLevelRewardCover: BattlePassCreateLevelRewardCoverPayload;
  editLevelRewardCover: BattlePassEditLevelRewardCoverPayload;
  testNotification: BattlePassTestNotificationPayload;
};

export type BattlePassAdminMutationaddDeltaXPToEnrollmentArgs = {
  input: BattlePassAddDeltaXPInput;
};

export type BattlePassAdminMutationaddXPToEnrollmentArgs = {
  input: BattlePassAddXPInput;
};

export type BattlePassAdminMutationbpChangeStatusArgs = {
  input: BattlePassChangeStatusInput;
};

export type BattlePassAdminMutationbpCreateArgs = {
  input: BattlePassAdminCreateInput;
};

export type BattlePassAdminMutationbpEditArgs = {
  input: BattlePassAdminEditInput;
};

export type BattlePassAdminMutationchangeEnrRewardAccessArgs = {
  input: BattlePassChangeEnrRewardAccessInput;
};

export type BattlePassAdminMutationcreateLevelRewardCoverArgs = {
  input: BattlePassCreateLevelRewardCoverInput;
};

export type BattlePassAdminMutationeditLevelRewardCoverArgs = {
  input: BattlePassEditLevelRewardCoverInput;
};

export type BattlePassAdminMutationtestNotificationArgs = {
  input: BattlePassTestNotificationInput;
};

export type BattlePassAdminRewardCoversPayload = {
  __typename?: 'BattlePassAdminRewardCoversPayload';
  data?: Maybe<Array<BattlePassLevelRewardCover>>;
  error?: Maybe<BattlePassAdminListRewardCoversError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassBooster = {
  __typename?: 'BattlePassBooster';
  active: Scalars['Boolean'];
  endAt?: Maybe<Scalars['BattlePassDateTime']>;
};

export enum BattlePassCancelEnrollmentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassCancelEnrollmentInput = {
  enrollmentID: Scalars['ID'];
};

export type BattlePassCancelEnrollmentPayload = {
  __typename?: 'BattlePassCancelEnrollmentPayload';
  enrollment?: Maybe<BattlePassEnrollment>;
  error?: Maybe<BattlePassCancelEnrollmentError>;
  errorMsg?: Maybe<Scalars['String']>;
};

/** Sent once per player and challenge when the last mission is finished; title is the challenge name. */
export type BattlePassChallengeCompletedPayload = NotificationPayload & {
  __typename?: 'BattlePassChallengeCompletedPayload';
  challengeId: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export enum BattlePassChangeEnrRewardAccessError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassChangeEnrRewardAccessInput = {
  access: BattlePassRewardsAccess;
  enrollmentID: Scalars['String'];
};

export type BattlePassChangeEnrRewardAccessPayload = {
  __typename?: 'BattlePassChangeEnrRewardAccessPayload';
  error?: Maybe<BattlePassChangeEnrRewardAccessError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassChangeStatusInput = {
  id: Scalars['String'];
  status: BattlePassStatus;
  version: Scalars['Int'];
};

export type BattlePassChangeStatusPayload = {
  __typename?: 'BattlePassChangeStatusPayload';
  bp?: Maybe<BattlePass>;
  error?: Maybe<BattlePassAdminChangeStatusError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassClaimRewardError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassClaimRewardInput = {
  earnedRewardID: Scalars['ID'];
  selectedOptionID?: InputMaybe<Scalars['String']>;
};

export type BattlePassClaimRewardPayload = {
  __typename?: 'BattlePassClaimRewardPayload';
  earnedReward?: Maybe<BattlePassEarnedReward>;
  error?: Maybe<BattlePassClaimRewardError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassCompletedPayload = NotificationPayload & {
  __typename?: 'BattlePassCompletedPayload';
  bpId: Scalars['ID'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export enum BattlePassCreateEnrollmentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassCreateEnrollmentInput = {
  bpID: Scalars['String'];
};

export type BattlePassCreateEnrollmentPayload = {
  __typename?: 'BattlePassCreateEnrollmentPayload';
  enrollment?: Maybe<BattlePassEnrollment>;
  error?: Maybe<BattlePassCreateEnrollmentError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassCreateLevelRewardCoverError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassCreateLevelRewardCoverInput = {
  description?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

export type BattlePassCreateLevelRewardCoverPayload = {
  __typename?: 'BattlePassCreateLevelRewardCoverPayload';
  error?: Maybe<BattlePassCreateLevelRewardCoverError>;
  errorMsg?: Maybe<Scalars['String']>;
  type?: Maybe<BattlePassLevelRewardCover>;
};

export type BattlePassDisplayParams = {
  __typename?: 'BattlePassDisplayParams';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  introInfo?: Maybe<BattlePassIntroInfo>;
  promoInfo?: Maybe<BattlePassPromoInfo>;
  promoVideoUrl?: Maybe<Scalars['String']>;
  rewardsDescription?: Maybe<Scalars['Map']>;
  slotCardBackImageUrl?: Maybe<Scalars['String']>;
  statusBarColor?: Maybe<Scalars['String']>;
  statusBarIconUrl?: Maybe<Scalars['String']>;
};

export type BattlePassDisplayParamsInput = {
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  introInfo?: InputMaybe<BattlePassIntroInfoInput>;
  promoInfo?: InputMaybe<BattlePassPromoInfoInput>;
  promoVideoUrl?: InputMaybe<Scalars['String']>;
  rewardsDescription?: InputMaybe<Scalars['Map']>;
  slotCardBackImageUrl?: InputMaybe<Scalars['String']>;
  statusBarColor?: InputMaybe<Scalars['String']>;
  statusBarIconUrl?: InputMaybe<Scalars['String']>;
};

export type BattlePassEarnedReward = {
  __typename?: 'BattlePassEarnedReward';
  claimedLogID?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  result?: Maybe<RewardClaimedResult>;
  status: BattlePassEarnedRewardStatus;
};

export enum BattlePassEarnedRewardStatus {
  AVAILABLE = 'AVAILABLE',
  CLAIMED = 'CLAIMED',
  LOCKED = 'LOCKED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export enum BattlePassEditLevelRewardCoverError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassEditLevelRewardCoverInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BattlePassEditLevelRewardCoverPayload = {
  __typename?: 'BattlePassEditLevelRewardCoverPayload';
  error?: Maybe<BattlePassEditLevelRewardCoverError>;
  errorMsg?: Maybe<Scalars['String']>;
  type?: Maybe<BattlePassLevelRewardCover>;
};

export type BattlePassEndingSoonPayload = NotificationPayload & {
  __typename?: 'BattlePassEndingSoonPayload';
  bpId: Scalars['ID'];
  /** The reminder threshold that fired, in days before endsAt: 7, 3 or 1 by default. */
  daysLeft: Scalars['Int'];
  endsAt: Scalars['DateTime'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export type BattlePassEnrollment = {
  __typename?: 'BattlePassEnrollment';
  currentXP: Scalars['Int'];
  id: Scalars['ID'];
  level: BattlePassLevel;
  /** @deprecated Use state. rewardsAccess stays two-valued; PRESTIGE is only represented in state. */
  rewardsAccess: BattlePassRewardsAccess;
  state: BattlePassEnrollmentState;
  status: BattlePassEnrollmentStatus;
  updatedAt: Scalars['BattlePassDateTime'];
};

export enum BattlePassEnrollmentState {
  PAID = 'PAID',
  PRESTIGE = 'PRESTIGE',
  REGULAR = 'REGULAR',
}

export enum BattlePassEnrollmentStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
}

export enum BattlePassGetEnrollmentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassGetEnrollmentInput = {
  bpID: Scalars['ID'];
};

export type BattlePassGetEnrollmentPayload = {
  __typename?: 'BattlePassGetEnrollmentPayload';
  data?: Maybe<BattlePassEnrollment>;
  error?: Maybe<BattlePassGetEnrollmentError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassGetError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type BattlePassInput = {
  id: Scalars['ID'];
};

export type BattlePassIntroInfo = {
  __typename?: 'BattlePassIntroInfo';
  free?: Maybe<BattlePassIntroInfoTrack>;
  premium?: Maybe<BattlePassIntroInfoTrack>;
};

export type BattlePassIntroInfoInput = {
  free?: InputMaybe<BattlePassIntroInfoTrackInput>;
  premium?: InputMaybe<BattlePassIntroInfoTrackInput>;
};

export type BattlePassIntroInfoTrack = {
  __typename?: 'BattlePassIntroInfoTrack';
  backgroundUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['Map']>;
  title?: Maybe<Scalars['String']>;
};

export type BattlePassIntroInfoTrackInput = {
  backgroundUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['Map']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BattlePassLevel = {
  __typename?: 'BattlePassLevel';
  id: Scalars['ID'];
  requiredXP: Scalars['Int'];
  rewards?: Maybe<Array<BattlePassLevelReward>>;
};

export type BattlePassLevelReward = {
  __typename?: 'BattlePassLevelReward';
  cover: BattlePassLevelRewardCover;
  earned?: Maybe<BattlePassEarnedReward>;
  id: Scalars['ID'];
  requiredAccess: BattlePassRewardsAccess;
  reward?: Maybe<Reward>;
};

export type BattlePassLevelRewardCover = {
  __typename?: 'BattlePassLevelRewardCover';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum BattlePassListEnrollmentsError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassListEnrollmentsInput = {
  statuses?: InputMaybe<Array<BattlePassEnrollmentStatus>>;
};

export type BattlePassListEnrollmentsPayload = {
  __typename?: 'BattlePassListEnrollmentsPayload';
  data?: Maybe<Array<BattlePassEnrollment>>;
  error?: Maybe<BattlePassListEnrollmentsError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassListError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassListInput = {
  enrollmentStatuses?: InputMaybe<Array<BattlePassEnrollmentStatus>>;
  statuses?: InputMaybe<Array<BattlePassStatus>>;
};

export type BattlePassListPayload = {
  __typename?: 'BattlePassListPayload';
  data?: Maybe<Array<BattlePass>>;
  error?: Maybe<BattlePassListError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassMutation = {
  __typename?: 'BattlePassMutation';
  admin?: Maybe<BattlePassAdminMutation>;
  cancelEnrollment: BattlePassCancelEnrollmentPayload;
  claimReward: BattlePassClaimRewardPayload;
  createEnrollment: BattlePassCreateEnrollmentPayload;
  id: Scalars['ID'];
  refreshProfiles: BattlePassRefreshProfilesPayload;
  startPrestige: BattlePassStartPrestigePayload;
  userAttributes: BattlePassUserAttributesMutation;
};

export type BattlePassMutationcancelEnrollmentArgs = {
  input: BattlePassCancelEnrollmentInput;
};

export type BattlePassMutationclaimRewardArgs = {
  input: BattlePassClaimRewardInput;
};

export type BattlePassMutationcreateEnrollmentArgs = {
  input: BattlePassCreateEnrollmentInput;
};

export type BattlePassMutationrefreshProfilesArgs = {
  input: BattlePassRefreshProfilesInput;
};

export type BattlePassMutationstartPrestigeArgs = {
  input: BattlePassStartPrestigeInput;
};

export type BattlePassNewChallengeAvailablePayload = NotificationPayload & {
  __typename?: 'BattlePassNewChallengeAvailablePayload';
  challengeId: Scalars['Int'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/** One message per player when a batch of challenges goes live; the FE text and link are fixed. */
export type BattlePassNewChallengesAvailablePayload = NotificationPayload & {
  __typename?: 'BattlePassNewChallengesAvailablePayload';
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export type BattlePassNewRewardAvailablePayload = NotificationPayload & {
  __typename?: 'BattlePassNewRewardAvailablePayload';
  bpId: Scalars['ID'];
  earnedRewardId: Scalars['ID'];
  levelRewardId: Scalars['ID'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

/**
 * Available events that QA can trigger via the testNotification admin mutation.
 * Each value maps deterministically to a (Kind, Type) pair on the server.
 */
export enum BattlePassNotificationEvent {
  NEW_CHALLENGE_AVAILABLE_NOTIFICATION = 'NEW_CHALLENGE_AVAILABLE_NOTIFICATION',
  NEW_CHALLENGE_AVAILABLE_SIGNAL = 'NEW_CHALLENGE_AVAILABLE_SIGNAL',
  NEW_REWARD_AVAILABLE_SIGNAL = 'NEW_REWARD_AVAILABLE_SIGNAL',
  PASS_ACTIVATED_NOTIFICATION = 'PASS_ACTIVATED_NOTIFICATION',
  PASS_COMPLETED_NOTIFICATION = 'PASS_COMPLETED_NOTIFICATION',
  REWARD_AVAILABLE_NOTIFICATION = 'REWARD_AVAILABLE_NOTIFICATION',
  XP_EARNED_SIGNAL = 'XP_EARNED_SIGNAL',
}

export enum BattlePassOnboardingStep {
  ACTIVATION = 'ACTIVATION',
  INTRO = 'INTRO',
  POST_ACTIVATION = 'POST_ACTIVATION',
}

export type BattlePassOnboardingStepAttribute = {
  __typename?: 'BattlePassOnboardingStepAttribute';
  step: BattlePassOnboardingStep;
  viewed: Scalars['Boolean'];
};

export type BattlePassOnboardingStepInput = {
  step: BattlePassOnboardingStep;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type BattlePassOnboardingStepsPayload = {
  __typename?: 'BattlePassOnboardingStepsPayload';
  data?: Maybe<Array<BattlePassOnboardingStepAttribute>>;
  error?: Maybe<BattlePassUserAttributesError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassPayload = {
  __typename?: 'BattlePassPayload';
  data?: Maybe<BattlePass>;
  error?: Maybe<BattlePassGetError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassPromoInfo = {
  __typename?: 'BattlePassPromoInfo';
  rewardsPreviewList: Array<BattlePassRewardPreview>;
};

export type BattlePassPromoInfoInput = {
  rewardsPreviewList?: InputMaybe<Array<BattlePassRewardPreviewInput>>;
};

export type BattlePassPromoVideoAttribute = {
  __typename?: 'BattlePassPromoVideoAttribute';
  bpID: Scalars['ID'];
  viewed: Scalars['Boolean'];
};

export type BattlePassPromoVideoInput = {
  bpID: Scalars['ID'];
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type BattlePassPromoVideosPayload = {
  __typename?: 'BattlePassPromoVideosPayload';
  data?: Maybe<Array<BattlePassPromoVideoAttribute>>;
  error?: Maybe<BattlePassUserAttributesError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassProvider {
  GGG = 'GGG',
  RIOT = 'RIOT',
  STEAM = 'STEAM',
}

export type BattlePassQuery = {
  __typename?: 'BattlePassQuery';
  battlePass: BattlePassPayload;
  battlePasses: BattlePassListPayload;
  id: Scalars['ID'];
  lastCompletedBattlePass: LastCompletedBattlePassPayload;
  recommendedBattlePass: RecommendedBattlePassPayload;
  rewardCovers: BattlePassAdminRewardCoversPayload;
  userAttributes: BattlePassUserAttributesQuery;
  userBattlePass: UserBattlePassResponse;
};

export type BattlePassQuerybattlePassArgs = {
  input?: InputMaybe<BattlePassInput>;
};

export type BattlePassQuerybattlePassesArgs = {
  input?: InputMaybe<BattlePassListInput>;
};

export type BattlePassQueryuserBattlePassArgs = {
  input: UserBattlePassInput;
};

export enum BattlePassRefreshProfilesError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NO_PROVIDERS = 'NO_PROVIDERS',
}

export type BattlePassRefreshProfilesInput = {
  useFastUpdate: Scalars['Boolean'];
};

export type BattlePassRefreshProfilesPayload = {
  __typename?: 'BattlePassRefreshProfilesPayload';
  error?: Maybe<BattlePassRefreshProfilesError>;
  errorMsg?: Maybe<Scalars['String']>;
  /**
   * An array of Base64-encoded JSON strings containing the data required for listening to
   * profile refresh notifications in Firestore.
   */
  notificationsDetails?: Maybe<Scalars['String']>;
};

export type BattlePassRewardAvailablePayload = NotificationPayload & {
  __typename?: 'BattlePassRewardAvailablePayload';
  bpId: Scalars['ID'];
  earnedRewardId: Scalars['ID'];
  levelRewardId: Scalars['ID'];
  type: Scalars['String'];
  userId: Scalars['ID'];
};

export type BattlePassRewardPreview = {
  __typename?: 'BattlePassRewardPreview';
  image: Scalars['String'];
  title: Scalars['String'];
};

export type BattlePassRewardPreviewInput = {
  image: Scalars['String'];
  title: Scalars['String'];
};

export enum BattlePassRewardsAccess {
  PAID = 'PAID',
  REGULAR = 'REGULAR',
}

export enum BattlePassStartPrestigeError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
}

export type BattlePassStartPrestigeInput = {
  enrollmentID: Scalars['ID'];
};

export type BattlePassStartPrestigePayload = {
  __typename?: 'BattlePassStartPrestigePayload';
  enrollment?: Maybe<BattlePassEnrollment>;
  error?: Maybe<BattlePassStartPrestigeError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum BattlePassStatus {
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum BattlePassTestNotificationError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type BattlePassTestNotificationInput = {
  event: BattlePassNotificationEvent;
  payload?: InputMaybe<Scalars['Map']>;
};

export type BattlePassTestNotificationPayload = {
  __typename?: 'BattlePassTestNotificationPayload';
  error?: Maybe<BattlePassTestNotificationError>;
  errorMsg?: Maybe<Scalars['String']>;
  /** Echoed back so QA can correlate the dispatch with NotificationService logs. */
  idempotenceID?: Maybe<Scalars['String']>;
};

export type BattlePassUpdateOnboardingStepsInput = {
  attributes?: InputMaybe<Array<BattlePassOnboardingStepInput>>;
};

export type BattlePassUpdatePromoVideosInput = {
  attributes?: InputMaybe<Array<BattlePassPromoVideoInput>>;
};

export type BattlePassUserAttributes = {
  __typename?: 'BattlePassUserAttributes';
  onboardingSteps: Array<BattlePassOnboardingStepAttribute>;
  promoVideos: Array<BattlePassPromoVideoAttribute>;
};

export enum BattlePassUserAttributesError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type BattlePassUserAttributesMutation = {
  __typename?: 'BattlePassUserAttributesMutation';
  updateOnboardingSteps: BattlePassOnboardingStepsPayload;
  updatePromoVideos: BattlePassPromoVideosPayload;
};

export type BattlePassUserAttributesMutationupdateOnboardingStepsArgs = {
  input: BattlePassUpdateOnboardingStepsInput;
};

export type BattlePassUserAttributesMutationupdatePromoVideosArgs = {
  input: BattlePassUpdatePromoVideosInput;
};

export type BattlePassUserAttributesPayload = {
  __typename?: 'BattlePassUserAttributesPayload';
  data?: Maybe<BattlePassUserAttributes>;
  error?: Maybe<BattlePassUserAttributesError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type BattlePassUserAttributesQuery = {
  __typename?: 'BattlePassUserAttributesQuery';
  get: BattlePassUserAttributesPayload;
};

export type BattlePassXpEarnedPayload = NotificationPayload & {
  __typename?: 'BattlePassXpEarnedPayload';
  bpId: Scalars['ID'];
  type: Scalars['String'];
  userId: Scalars['ID'];
  xp: Scalars['Int'];
};

export type Borderlands4ActionSkill = Borderlands4GameEntity & {
  __typename?: 'Borderlands4ActionSkill';
  character?: Maybe<Borderlands4Character>;
  characterRef?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  skillTree?: Maybe<Borderlands4SkillTree>;
  skillTreeRef?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stats?: Maybe<Array<Borderlands4Stats>>;
};

export type Borderlands4ActionSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4ActionSkillsResult = {
  __typename?: 'Borderlands4ActionSkillsResult';
  data?: Maybe<Array<Borderlands4ActionSkill>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Character = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Character';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  passive?: Maybe<Borderlands4Passive>;
  passiveRef?: Maybe<Scalars['String']>;
  skillTrees?: Maybe<Array<Borderlands4SkillTree>>;
  skillTreesRef?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type Borderlands4CharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4CharactersResult = {
  __typename?: 'Borderlands4CharactersResult';
  data?: Maybe<Array<Borderlands4Character>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4ClassMod = Borderlands4GameEntity & {
  __typename?: 'Borderlands4ClassMod';
  character?: Maybe<Borderlands4Character>;
  characterRef?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modImage?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rarity?: Maybe<Borderlands4Rarity>;
  rarityRef?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Borderlands4EquipmentType>;
  typeRef?: Maybe<Scalars['String']>;
};

export type Borderlands4ClassModsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4ClassModsResult = {
  __typename?: 'Borderlands4ClassModsResult';
  data?: Maybe<Array<Borderlands4ClassMod>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4DocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'Borderlands4DocumentCmWidgetV1';
  data: Borderlands4DocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Borderlands4DocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'Borderlands4DocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Borderlands4DocumentContent =
  | Borderlands4DocumentCmWidgetV1
  | Borderlands4DocumentUgWidgetSkillTreeV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type Borderlands4DocumentSeason = NgfDocumentSeason & {
  __typename?: 'Borderlands4DocumentSeason';
  slug: Scalars['String'];
};

export type Borderlands4DocumentTags = NgfDocumentTags & {
  __typename?: 'Borderlands4DocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type Borderlands4DocumentUgWidgetSkillTreeDataV1 = NgfDocumentContentData & {
  __typename?: 'Borderlands4DocumentUgWidgetSkillTreeDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isPriorityEnabled?: Maybe<Scalars['Boolean']>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Borderlands4DocumentUgWidgetSkillTreeV1 = NgfDocumentContent & {
  __typename?: 'Borderlands4DocumentUgWidgetSkillTreeV1';
  data: Borderlands4DocumentUgWidgetSkillTreeDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Borderlands4DocumentsMutation = {
  __typename?: 'Borderlands4DocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: Borderlands4StructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: Borderlands4StructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: Borderlands4StructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: Borderlands4StructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: Borderlands4UserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: Borderlands4UserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: Borderlands4UserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: Borderlands4UserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: Borderlands4UserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: Borderlands4UserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: Borderlands4WikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: Borderlands4WikiDocumentUpdatePayload;
};

export type Borderlands4DocumentsMutationstructDocumentCreateArgs = {
  input: Borderlands4StructDocumentCreateInput;
};

export type Borderlands4DocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Borderlands4DocumentsMutationstructDocumentSetStatusArgs = {
  input: Borderlands4StructDocumentSetStatusInput;
};

export type Borderlands4DocumentsMutationstructDocumentUpdateArgs = {
  input: Borderlands4StructDocumentUpdateInput;
};

export type Borderlands4DocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: Borderlands4UserGeneratedDocumentCreateInput;
};

export type Borderlands4DocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: Borderlands4UserGeneratedDocumentSetFavoriteInput;
};

export type Borderlands4DocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: Borderlands4UserGeneratedDocumentSetFeaturedInput;
};

export type Borderlands4DocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Borderlands4DocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: Borderlands4UserGeneratedDocumentSetStatusInput;
};

export type Borderlands4DocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: Borderlands4UserGeneratedDocumentUpdateInput;
};

export type Borderlands4DocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type Borderlands4DocumentsMutationwikiDocumentUpdateArgs = {
  input: Borderlands4WikiDocumentUpdateInput;
};

export type Borderlands4DocumentsQuery = {
  __typename?: 'Borderlands4DocumentsQuery';
  previewDocumentContent: Borderlands4PreviewDocumentContentPayload;
  structDocumentBySlug: Borderlands4StructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: Borderlands4UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: Borderlands4UserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: Borderlands4UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: Borderlands4UserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: Borderlands4TemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: Borderlands4WikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type Borderlands4DocumentsQuerypreviewDocumentContentArgs = {
  input: Borderlands4PreviewDocumentContentInput;
};

export type Borderlands4DocumentsQuerystructDocumentBySlugArgs = {
  input: Borderlands4StructDocumentInputBySlug;
};

export type Borderlands4DocumentsQuerystructDocumentsArgs = {
  input: Borderlands4StructDocumentsInput;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: Borderlands4UserGeneratedDocumentInputById;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: Borderlands4UserGeneratedDocumentInputBySlug;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: Borderlands4TemplateDocumentInput;
};

export type Borderlands4DocumentsQueryuserGeneratedDocumentsArgs = {
  input: Borderlands4UserGeneratedDocumentsListInput;
  page: Borderlands4UserGeneratedDocumentsListPage;
};

export type Borderlands4DocumentsQuerywikiDocumentArgs = {
  input: Borderlands4WikiDocumentInput;
};

export type Borderlands4DocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<Borderlands4WikiDocumentsListInput>;
  page: Borderlands4WikiDocumentsListPage;
};

export type Borderlands4ElementType = Borderlands4GameEntity & {
  __typename?: 'Borderlands4ElementType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4ElementTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4ElementTypesResult = {
  __typename?: 'Borderlands4ElementTypesResult';
  data?: Maybe<Array<Borderlands4ElementType>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4EnhancementsPerk = Borderlands4GameEntity & {
  __typename?: 'Borderlands4EnhancementsPerk';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  manufacturer?: Maybe<Borderlands4Manufacturer>;
  manufacturerRef?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4EnhancementsPerksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4EnhancementsPerksResult = {
  __typename?: 'Borderlands4EnhancementsPerksResult';
  data?: Maybe<Array<Borderlands4EnhancementsPerk>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4EnhancementsStat = Borderlands4GameEntity & {
  __typename?: 'Borderlands4EnhancementsStat';
  deprecated?: Maybe<Scalars['Boolean']>;
  gameId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4EnhancementsStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4EnhancementsStatsResult = {
  __typename?: 'Borderlands4EnhancementsStatsResult';
  data?: Maybe<Array<Borderlands4EnhancementsStat>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Borderlands4EntitiesEnum {
  actionSkills = 'actionSkills',
  characters = 'characters',
  classMods = 'classMods',
  elementTypes = 'elementTypes',
  enhancementsPerks = 'enhancementsPerks',
  enhancementsStats = 'enhancementsStats',
  equipmentType = 'equipmentType',
  firmwarePerks = 'firmwarePerks',
  legendaryRepkits = 'legendaryRepkits',
  manufacturers = 'manufacturers',
  ordnance = 'ordnance',
  passives = 'passives',
  rarities = 'rarities',
  repkitPerks = 'repkitPerks',
  shieldComponents = 'shieldComponents',
  shields = 'shields',
  skillTrees = 'skillTrees',
  skillTypes = 'skillTypes',
  skills = 'skills',
  specializationBranches = 'specializationBranches',
  specializations = 'specializations',
  statsDetails = 'statsDetails',
  weaponParts = 'weaponParts',
  weapons = 'weapons',
  weaponsLicensedParts = 'weaponsLicensedParts',
}

export type Borderlands4EntityObject = NGFEntityObject & {
  __typename?: 'Borderlands4EntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<Borderlands4GameEntity>;
  enumType?: Maybe<Borderlands4EntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Borderlands4EquipmentType = Borderlands4GameEntity & {
  __typename?: 'Borderlands4EquipmentType';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4EquipmentTypeFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4EquipmentTypeResult = {
  __typename?: 'Borderlands4EquipmentTypeResult';
  data?: Maybe<Array<Borderlands4EquipmentType>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4FirmwarePerk = Borderlands4GameEntity & {
  __typename?: 'Borderlands4FirmwarePerk';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4FirmwarePerksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4FirmwarePerksResult = {
  __typename?: 'Borderlands4FirmwarePerksResult';
  data?: Maybe<Array<Borderlands4FirmwarePerk>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4GameEntity = {
  slug: Scalars['String'];
};

export type Borderlands4LegendaryRepkit = Borderlands4GameEntity & {
  __typename?: 'Borderlands4LegendaryRepkit';
  deprecated?: Maybe<Scalars['Boolean']>;
  flavorText?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legendaryPart?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Borderlands4Manufacturer>;
  manufacturerRef?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rarity?: Maybe<Borderlands4Rarity>;
  rarityRef?: Maybe<Scalars['String']>;
  repkitImage?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Borderlands4EquipmentType>;
  typeRef?: Maybe<Scalars['String']>;
};

export type Borderlands4LegendaryRepkitsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4LegendaryRepkitsResult = {
  __typename?: 'Borderlands4LegendaryRepkitsResult';
  data?: Maybe<Array<Borderlands4LegendaryRepkit>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Manufacturer = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Manufacturer';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4ManufacturersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4ManufacturersResult = {
  __typename?: 'Borderlands4ManufacturersResult';
  data?: Maybe<Array<Borderlands4Manufacturer>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Mutation = {
  __typename?: 'Borderlands4Mutation';
  documents?: Maybe<Borderlands4DocumentsMutation>;
  id: Scalars['ID'];
};

export type Borderlands4Ordnance = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Ordnance';
  deprecated?: Maybe<Scalars['Boolean']>;
  flavorText?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legendaryPart?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Borderlands4Manufacturer>;
  manufacturerRef?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ordnanceImage?: Maybe<Scalars['String']>;
  rarity?: Maybe<Borderlands4Rarity>;
  rarityRef?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Borderlands4EquipmentType>;
  typeRef?: Maybe<Scalars['String']>;
};

export type Borderlands4OrdnanceFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4OrdnanceResult = {
  __typename?: 'Borderlands4OrdnanceResult';
  data?: Maybe<Array<Borderlands4Ordnance>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Passive = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Passive';
  character?: Maybe<Borderlands4Character>;
  characterRef?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<Borderlands4Stats>>;
};

export type Borderlands4PassivesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4PassivesResult = {
  __typename?: 'Borderlands4PassivesResult';
  data?: Maybe<Array<Borderlands4Passive>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Borderlands4PreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4PreviewDocumentContentInput = {
  content: Scalars['Borderlands4DocumentContentInputBase64Json'];
};

export type Borderlands4PreviewDocumentContentPayload = {
  __typename?: 'Borderlands4PreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<Borderlands4DocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<Borderlands4PreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4Profile = NgfProfile & {
  __typename?: 'Borderlands4Profile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type Borderlands4ProfileuserGeneratedDocumentsArgs = {
  input: Borderlands4UserGeneratedDocumentsListInput;
  page: Borderlands4UserGeneratedDocumentsListPage;
};

export type Borderlands4ProfilePayload = {
  __typename?: 'Borderlands4ProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<Borderlands4Profile>;
};

export type Borderlands4ProfilesQuery = {
  __typename?: 'Borderlands4ProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: Borderlands4ProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type Borderlands4ProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type Borderlands4Query = {
  __typename?: 'Borderlands4Query';
  documents?: Maybe<Borderlands4DocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<Borderlands4ProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<Borderlands4StaticDataQuery>;
};

export type Borderlands4RaritiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4RaritiesResult = {
  __typename?: 'Borderlands4RaritiesResult';
  data?: Maybe<Array<Borderlands4Rarity>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Rarity = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Rarity';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4RepkitPerk = Borderlands4GameEntity & {
  __typename?: 'Borderlands4RepkitPerk';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  prefix?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type Borderlands4RepkitPerksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4RepkitPerksResult = {
  __typename?: 'Borderlands4RepkitPerksResult';
  data?: Maybe<Array<Borderlands4RepkitPerk>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4SectionFourSkills = {
  __typename?: 'Borderlands4SectionFourSkills';
  order?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  skill?: Maybe<Borderlands4Skill>;
};

export type Borderlands4SectionOneSkills = {
  __typename?: 'Borderlands4SectionOneSkills';
  order?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  skill?: Maybe<Borderlands4Skill>;
};

export type Borderlands4SectionThreeSkills = {
  __typename?: 'Borderlands4SectionThreeSkills';
  order?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  skill?: Maybe<Borderlands4Skill>;
};

export type Borderlands4SectionTwoSkills = {
  __typename?: 'Borderlands4SectionTwoSkills';
  order?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
  skill?: Maybe<Borderlands4Skill>;
};

export type Borderlands4Shield = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Shield';
  deprecated?: Maybe<Scalars['Boolean']>;
  flavorText?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legendaryPart?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Borderlands4Manufacturer>;
  manufacturerRef?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rarity?: Maybe<Borderlands4Rarity>;
  rarityRef?: Maybe<Scalars['String']>;
  shieldImage?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Borderlands4EquipmentType>;
  typeRef?: Maybe<Scalars['String']>;
};

export type Borderlands4ShieldComponent = Borderlands4GameEntity & {
  __typename?: 'Borderlands4ShieldComponent';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4ShieldComponentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4ShieldComponentsResult = {
  __typename?: 'Borderlands4ShieldComponentsResult';
  data?: Maybe<Array<Borderlands4ShieldComponent>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4ShieldsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4ShieldsResult = {
  __typename?: 'Borderlands4ShieldsResult';
  data?: Maybe<Array<Borderlands4Shield>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Skill = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Skill';
  character?: Maybe<Borderlands4Character>;
  characterRef?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxRanks?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position?: Maybe<Array<Scalars['String']>>;
  requiredSkill?: Maybe<Array<Borderlands4Skill>>;
  requiredSkillRef?: Maybe<Array<Scalars['String']>>;
  section?: Maybe<Scalars['String']>;
  skillTree?: Maybe<Borderlands4SkillTree>;
  skillTreeRef?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stats?: Maybe<Array<Borderlands4Stats>>;
  type?: Maybe<Borderlands4SkillType>;
  typeRef?: Maybe<Scalars['String']>;
};

export type Borderlands4SkillTree = Borderlands4GameEntity & {
  __typename?: 'Borderlands4SkillTree';
  augmentsAmount?: Maybe<Scalars['String']>;
  character?: Maybe<Borderlands4Character>;
  characterRef?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  sectionFourSkills?: Maybe<Array<Borderlands4SectionFourSkills>>;
  sectionOneSkills?: Maybe<Array<Borderlands4SectionOneSkills>>;
  sectionThreeSkills?: Maybe<Array<Borderlands4SectionThreeSkills>>;
  sectionTwoSkills?: Maybe<Array<Borderlands4SectionTwoSkills>>;
  slug: Scalars['String'];
};

export type Borderlands4SkillTreesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4SkillTreesResult = {
  __typename?: 'Borderlands4SkillTreesResult';
  data?: Maybe<Array<Borderlands4SkillTree>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4SkillType = Borderlands4GameEntity & {
  __typename?: 'Borderlands4SkillType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4SkillTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4SkillTypesResult = {
  __typename?: 'Borderlands4SkillTypesResult';
  data?: Maybe<Array<Borderlands4SkillType>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4SkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4SkillsResult = {
  __typename?: 'Borderlands4SkillsResult';
  data?: Maybe<Array<Borderlands4Skill>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4Specialization = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Specialization';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  requirements?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  specializationBranch?: Maybe<Borderlands4SpecializationBranch>;
  specializationBranchRef?: Maybe<Scalars['String']>;
  stats?: Maybe<Array<Borderlands4Stats>>;
};

export type Borderlands4SpecializationBranch = Borderlands4GameEntity & {
  __typename?: 'Borderlands4SpecializationBranch';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  requirements?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<Borderlands4Stats>>;
};

export type Borderlands4SpecializationBranchesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4SpecializationBranchesResult = {
  __typename?: 'Borderlands4SpecializationBranchesResult';
  data?: Maybe<Array<Borderlands4SpecializationBranch>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4SpecializationsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4SpecializationsResult = {
  __typename?: 'Borderlands4SpecializationsResult';
  data?: Maybe<Array<Borderlands4Specialization>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Borderlands4StaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type Borderlands4StaticDataQuery = {
  __typename?: 'Borderlands4StaticDataQuery';
  borderlands4ActionSkills: Borderlands4ActionSkillsResult;
  borderlands4Characters: Borderlands4CharactersResult;
  borderlands4ClassMods: Borderlands4ClassModsResult;
  borderlands4ElementTypes: Borderlands4ElementTypesResult;
  borderlands4EnhancementsPerks: Borderlands4EnhancementsPerksResult;
  borderlands4EnhancementsStats: Borderlands4EnhancementsStatsResult;
  borderlands4EquipmentType: Borderlands4EquipmentTypeResult;
  borderlands4FirmwarePerks: Borderlands4FirmwarePerksResult;
  borderlands4LegendaryRepkits: Borderlands4LegendaryRepkitsResult;
  borderlands4Manufacturers: Borderlands4ManufacturersResult;
  borderlands4Ordnance: Borderlands4OrdnanceResult;
  borderlands4Passives: Borderlands4PassivesResult;
  borderlands4Rarities: Borderlands4RaritiesResult;
  borderlands4RepkitPerks: Borderlands4RepkitPerksResult;
  borderlands4ShieldComponents: Borderlands4ShieldComponentsResult;
  borderlands4Shields: Borderlands4ShieldsResult;
  borderlands4SkillTrees: Borderlands4SkillTreesResult;
  borderlands4SkillTypes: Borderlands4SkillTypesResult;
  borderlands4Skills: Borderlands4SkillsResult;
  borderlands4SpecializationBranches: Borderlands4SpecializationBranchesResult;
  borderlands4Specializations: Borderlands4SpecializationsResult;
  borderlands4StatsDetails: Borderlands4StatsDetailsResult;
  borderlands4WeaponParts: Borderlands4WeaponPartsResult;
  borderlands4Weapons: Borderlands4WeaponsResult;
  borderlands4WeaponsLicensedParts: Borderlands4WeaponsLicensedPartsResult;
};

export type Borderlands4StaticDataQueryborderlands4ActionSkillsArgs = {
  filter?: InputMaybe<Borderlands4ActionSkillsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4CharactersArgs = {
  filter?: InputMaybe<Borderlands4CharactersFilter>;
};

export type Borderlands4StaticDataQueryborderlands4ClassModsArgs = {
  filter?: InputMaybe<Borderlands4ClassModsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4ElementTypesArgs = {
  filter?: InputMaybe<Borderlands4ElementTypesFilter>;
};

export type Borderlands4StaticDataQueryborderlands4EnhancementsPerksArgs = {
  filter?: InputMaybe<Borderlands4EnhancementsPerksFilter>;
};

export type Borderlands4StaticDataQueryborderlands4EnhancementsStatsArgs = {
  filter?: InputMaybe<Borderlands4EnhancementsStatsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4EquipmentTypeArgs = {
  filter?: InputMaybe<Borderlands4EquipmentTypeFilter>;
};

export type Borderlands4StaticDataQueryborderlands4FirmwarePerksArgs = {
  filter?: InputMaybe<Borderlands4FirmwarePerksFilter>;
};

export type Borderlands4StaticDataQueryborderlands4LegendaryRepkitsArgs = {
  filter?: InputMaybe<Borderlands4LegendaryRepkitsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4ManufacturersArgs = {
  filter?: InputMaybe<Borderlands4ManufacturersFilter>;
};

export type Borderlands4StaticDataQueryborderlands4OrdnanceArgs = {
  filter?: InputMaybe<Borderlands4OrdnanceFilter>;
};

export type Borderlands4StaticDataQueryborderlands4PassivesArgs = {
  filter?: InputMaybe<Borderlands4PassivesFilter>;
};

export type Borderlands4StaticDataQueryborderlands4RaritiesArgs = {
  filter?: InputMaybe<Borderlands4RaritiesFilter>;
};

export type Borderlands4StaticDataQueryborderlands4RepkitPerksArgs = {
  filter?: InputMaybe<Borderlands4RepkitPerksFilter>;
};

export type Borderlands4StaticDataQueryborderlands4ShieldComponentsArgs = {
  filter?: InputMaybe<Borderlands4ShieldComponentsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4ShieldsArgs = {
  filter?: InputMaybe<Borderlands4ShieldsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4SkillTreesArgs = {
  filter?: InputMaybe<Borderlands4SkillTreesFilter>;
};

export type Borderlands4StaticDataQueryborderlands4SkillTypesArgs = {
  filter?: InputMaybe<Borderlands4SkillTypesFilter>;
};

export type Borderlands4StaticDataQueryborderlands4SkillsArgs = {
  filter?: InputMaybe<Borderlands4SkillsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4SpecializationBranchesArgs = {
  filter?: InputMaybe<Borderlands4SpecializationBranchesFilter>;
};

export type Borderlands4StaticDataQueryborderlands4SpecializationsArgs = {
  filter?: InputMaybe<Borderlands4SpecializationsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4StatsDetailsArgs = {
  filter?: InputMaybe<Borderlands4StatsDetailsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4WeaponPartsArgs = {
  filter?: InputMaybe<Borderlands4WeaponPartsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4WeaponsArgs = {
  filter?: InputMaybe<Borderlands4WeaponsFilter>;
};

export type Borderlands4StaticDataQueryborderlands4WeaponsLicensedPartsArgs = {
  filter?: InputMaybe<Borderlands4WeaponsLicensedPartsFilter>;
};

export type Borderlands4Stats = {
  __typename?: 'Borderlands4Stats';
  details?: Maybe<Borderlands4StatsDetail>;
  ref?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Borderlands4StatsDetail = Borderlands4GameEntity & {
  __typename?: 'Borderlands4StatsDetail';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4StatsDetailsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4StatsDetailsResult = {
  __typename?: 'Borderlands4StatsDetailsResult';
  data?: Maybe<Array<Borderlands4StatsDetail>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4StructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'Borderlands4StructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Borderlands4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Borderlands4StructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum Borderlands4StructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Borderlands4StructDocumentCreateInput = {
  document: Scalars['Borderlands4StructDocumentInputBase64Json'];
};

export type Borderlands4StructDocumentCreatePayload = {
  __typename?: 'Borderlands4StructDocumentCreatePayload';
  data?: Maybe<Borderlands4StructDocument>;
  error?: Maybe<Borderlands4StructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4StructDocumentData = NgfStructDocumentData & {
  __typename?: 'Borderlands4StructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Borderlands4DocumentSeason;
  tags?: Maybe<Borderlands4DocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum Borderlands4StructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Borderlands4StructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Borderlands4StructDocumentPayload = {
  __typename?: 'Borderlands4StructDocumentPayload';
  data?: Maybe<Borderlands4StructDocument>;
  error?: Maybe<Borderlands4StructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4StructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Borderlands4StructDocumentSetSeoPayload = {
  __typename?: 'Borderlands4StructDocumentSetSeoPayload';
  data?: Maybe<Borderlands4StructDocument>;
  error?: Maybe<Borderlands4StructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4StructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4StructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type Borderlands4StructDocumentSetStatusPayload = {
  __typename?: 'Borderlands4StructDocumentSetStatusPayload';
  data?: Maybe<Borderlands4StructDocument>;
  error?: Maybe<Borderlands4StructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4StructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4StructDocumentUpdateInput = {
  document: Scalars['Borderlands4StructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Borderlands4StructDocumentUpdatePayload = {
  __typename?: 'Borderlands4StructDocumentUpdatePayload';
  data?: Maybe<Borderlands4StructDocument>;
  error?: Maybe<Borderlands4StructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4StructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type Borderlands4TemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'Borderlands4TemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<Borderlands4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: Borderlands4TemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type Borderlands4TemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'Borderlands4TemplateDocumentData';
  buildVariants?: Maybe<Borderlands4UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Borderlands4DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Borderlands4TemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4TemplateDocumentInput = {
  type: Scalars['String'];
};

export type Borderlands4TemplateDocumentPayload = {
  __typename?: 'Borderlands4TemplateDocumentPayload';
  data?: Maybe<Borderlands4TemplateDocument>;
  error?: Maybe<Borderlands4TemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4UGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'Borderlands4UGDocumentGenericBuilder';
  slots?: Maybe<Array<Borderlands4UGDocumentGenericBuilderSlot>>;
};

export type Borderlands4UGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'Borderlands4UGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<Borderlands4EntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type Borderlands4UserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'Borderlands4UserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<Borderlands4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Borderlands4UserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<Borderlands4DocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Borderlands4UserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'Borderlands4UserGeneratedDocumentBuildVariant';
  genericBuilder: Borderlands4UGDocumentGenericBuilder;
  id: Scalars['ID'];
  skillTree?: Maybe<Borderlands4UserGeneratedDocumentBuildVariantSkillTree>;
};

export type Borderlands4UserGeneratedDocumentBuildVariantSkillTree = {
  __typename?: 'Borderlands4UserGeneratedDocumentBuildVariantSkillTree';
  actionSkill?: Maybe<Borderlands4EntityObject>;
  activeTree?: Maybe<Borderlands4EntityObject>;
  augment?: Maybe<Array<Borderlands4EntityObject>>;
  capstone?: Maybe<Borderlands4EntityObject>;
  description?: Maybe<NgfDocumentRichTextContent>;
  skills?: Maybe<Array<Borderlands4UserGeneratedDocumentBuildVariantSkillTreeLeveledSkill>>;
};

export type Borderlands4UserGeneratedDocumentBuildVariantSkillTreeLeveledSkill = {
  __typename?: 'Borderlands4UserGeneratedDocumentBuildVariantSkillTreeLeveledSkill';
  level: Scalars['Int'];
  skill: Borderlands4EntityObject;
};

export type Borderlands4UserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'Borderlands4UserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<Borderlands4UserGeneratedDocumentBuildVariant>>;
};

export enum Borderlands4UserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Borderlands4UserGeneratedDocumentCreateInput = {
  document: Scalars['Borderlands4UserGeneratedDocumentInputBase64Json'];
};

export type Borderlands4UserGeneratedDocumentCreatePayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentCreatePayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4UserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'Borderlands4UserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<Borderlands4UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Borderlands4DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Borderlands4UserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Borderlands4UserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Borderlands4UserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Borderlands4UserGeneratedDocumentPayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentPayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4UserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4UserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type Borderlands4UserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4UserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Borderlands4UserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type Borderlands4UserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4UserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Borderlands4UserGeneratedDocumentSetSeoPayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentSetSeoPayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4UserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4UserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type Borderlands4UserGeneratedDocumentSetStatusPayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentSetStatusPayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4UserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Borderlands4UserGeneratedDocumentUpdateInput = {
  document: Scalars['Borderlands4UserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Borderlands4UserGeneratedDocumentUpdatePayload = {
  __typename?: 'Borderlands4UserGeneratedDocumentUpdatePayload';
  data?: Maybe<Borderlands4UserGeneratedDocument>;
  error?: Maybe<Borderlands4UserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4UserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type Borderlands4UserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Borderlands4Weapon = Borderlands4GameEntity & {
  __typename?: 'Borderlands4Weapon';
  deprecated?: Maybe<Scalars['Boolean']>;
  flavorText?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legendaryPart?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Borderlands4Manufacturer>;
  manufacturerRef?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ornanceImage?: Maybe<Scalars['String']>;
  rarity?: Maybe<Borderlands4Rarity>;
  rarityRef?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Borderlands4EquipmentType>;
  typeRef?: Maybe<Scalars['String']>;
  weaponImage?: Maybe<Scalars['String']>;
};

export type Borderlands4WeaponPart = Borderlands4GameEntity & {
  __typename?: 'Borderlands4WeaponPart';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4WeaponPartsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4WeaponPartsResult = {
  __typename?: 'Borderlands4WeaponPartsResult';
  data?: Maybe<Array<Borderlands4WeaponPart>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4WeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4WeaponsLicensedPart = Borderlands4GameEntity & {
  __typename?: 'Borderlands4WeaponsLicensedPart';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  licensedPart?: Maybe<Borderlands4WeaponPart>;
  licensedPartRef?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Borderlands4Manufacturer>;
  manufacturerRef?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Borderlands4WeaponsLicensedPartsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Borderlands4WeaponsLicensedPartsResult = {
  __typename?: 'Borderlands4WeaponsLicensedPartsResult';
  data?: Maybe<Array<Borderlands4WeaponsLicensedPart>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4WeaponsResult = {
  __typename?: 'Borderlands4WeaponsResult';
  data?: Maybe<Array<Borderlands4Weapon>>;
  error?: Maybe<Borderlands4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Borderlands4WikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'Borderlands4WikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Borderlands4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Borderlands4WikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<Borderlands4DocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Borderlands4WikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'Borderlands4WikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: Borderlands4EntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum Borderlands4WikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4WikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Borderlands4WikiDocumentPayload = {
  __typename?: 'Borderlands4WikiDocumentPayload';
  data?: Maybe<Borderlands4WikiDocument>;
  error?: Maybe<Borderlands4WikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4WikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Borderlands4WikiDocumentSetSeoPayload = {
  __typename?: 'Borderlands4WikiDocumentSetSeoPayload';
  data?: Maybe<Borderlands4WikiDocument>;
  error?: Maybe<Borderlands4WikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Borderlands4WikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Borderlands4WikiDocumentUpdateInput = {
  document: Scalars['Borderlands4WikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type Borderlands4WikiDocumentUpdatePayload = {
  __typename?: 'Borderlands4WikiDocumentUpdatePayload';
  data?: Maybe<Borderlands4WikiDocument>;
  error?: Maybe<Borderlands4WikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Borderlands4WikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type Borderlands4WikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type BuilderV1Settings = {
  __typename?: 'BuilderV1Settings';
  validSlots?: Maybe<Array<BuilderV1ValidSlot>>;
};

export type BuilderV1ValidSlot = {
  __typename?: 'BuilderV1ValidSlot';
  slug: Scalars['String'];
};

export type Challenge = {
  __typename?: 'Challenge';
  backgroundUrl?: Maybe<Scalars['String']>;
  endDate: Scalars['ChallengeDateTime'];
  game: ChallengeGame;
  id: Scalars['ID'];
  missions: Array<ChallengeMission>;
  progression: ChallengeProgression;
  reward?: Maybe<ChallengeReward>;
  startDate: Scalars['ChallengeDateTime'];
  title: Scalars['String'];
};

export type ChallengeAddXP = {
  currentValue: Scalars['Float'];
  missionID: Scalars['Int'];
  ruleID: Scalars['Int'];
  targetValue: Scalars['Float'];
};

export enum ChallengeAddXpError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ChallengeAddXpPayload = {
  __typename?: 'ChallengeAddXpPayload';
  error?: Maybe<ChallengeAddXpError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum ChallengeGame {
  DEADLOCK = 'DEADLOCK',
  LOL = 'LOL',
  POE_2 = 'POE_2',
  TFT = 'TFT',
  UNKNOWN = 'UNKNOWN',
  VALORANT = 'VALORANT',
}

export type ChallengeMission = {
  __typename?: 'ChallengeMission';
  id: Scalars['ID'];
  progression?: Maybe<ChallengeMissionProgression>;
  reward?: Maybe<ChallengeReward>;
  title: Scalars['String'];
};

export type ChallengeMissionProgression = {
  __typename?: 'ChallengeMissionProgression';
  progress: ChallengeMissionProgressionProgressbar;
  status: ChallengeMissionProgressionStatus;
};

export type ChallengeMissionProgressionProgressbar = {
  id: Scalars['ID'];
};

export type ChallengeMissionProgressionProgressbarLinear = ChallengeMissionProgressionProgressbar & {
  __typename?: 'ChallengeMissionProgressionProgressbarLinear';
  id: Scalars['ID'];
  progress: Scalars['Float'];
};

export type ChallengeMissionProgressionProgressbarSegmented = ChallengeMissionProgressionProgressbar & {
  __typename?: 'ChallengeMissionProgressionProgressbarSegmented';
  completedSegments: Scalars['Int'];
  id: Scalars['ID'];
  totalSegments: Scalars['Int'];
};

export enum ChallengeMissionProgressionStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
}

export type ChallengeMutation = {
  __typename?: 'ChallengeMutation';
  addMissionXP: ChallengeAddXpPayload;
  id: Scalars['ID'];
};

export type ChallengeMutationaddMissionXPArgs = {
  input: ChallengeAddXP;
};

export type ChallengePayload = {
  __typename?: 'ChallengePayload';
  challenges?: Maybe<Array<Challenge>>;
  game: ChallengeGame;
};

export type ChallengeProgression = {
  __typename?: 'ChallengeProgression';
  status: ChallengeProgressionStatus;
};

export enum ChallengeProgressionStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  NOT_STARTED = 'NOT_STARTED',
}

export type ChallengeQuery = {
  __typename?: 'ChallengeQuery';
  challenges: ChallengesListPayload;
  id: Scalars['ID'];
};

export type ChallengeReward = {
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum ChallengeRewardStatus {
  AVAILABLE = 'AVAILABLE',
  CLAIMED = 'CLAIMED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export type ChallengeXPReward = ChallengeReward & {
  __typename?: 'ChallengeXPReward';
  amount: Scalars['Int'];
  earnedStatus?: Maybe<ChallengeRewardStatus>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum ChallengesListError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type ChallengesListPayload = {
  __typename?: 'ChallengesListPayload';
  data?: Maybe<Array<ChallengePayload>>;
  error?: Maybe<ChallengesListError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type CommentCreatedPayload = NotificationPayload & {
  __typename?: 'CommentCreatedPayload';
  author?: Maybe<MgpProfile>;
  comment?: Maybe<CommentsComment>;
  document: DocumentInfo;
  type: Scalars['String'];
};

export type CommentRepliedPayload = NotificationPayload & {
  __typename?: 'CommentRepliedPayload';
  author?: Maybe<MgpProfile>;
  comment?: Maybe<CommentsComment>;
  document: DocumentInfo;
  type: Scalars['String'];
};

export type CommentsAdminAccount = {
  __typename?: 'CommentsAdminAccount';
  accountId: Scalars['ID'];
  rateLimitOverrideSeconds?: Maybe<Scalars['Int']>;
  readOnly: Scalars['Boolean'];
};

export type CommentsAdminAccountPayload = {
  __typename?: 'CommentsAdminAccountPayload';
  data?: Maybe<CommentsAdminAccount>;
  error?: Maybe<CommentsError>;
};

export type CommentsAdminComment = {
  __typename?: 'CommentsAdminComment';
  aiCategory?: Maybe<CommentsAiCategory>;
  aiModel?: Maybe<Scalars['String']>;
  aiOffensiveness?: Maybe<Scalars['Float']>;
  aiRejectionReason?: Maybe<Scalars['String']>;
  aiSentiment?: Maybe<Scalars['Float']>;
  aiSeverity?: Maybe<CommentsAiSeverity>;
  aiSpoilerLabel?: Maybe<Scalars['String']>;
  aiUsefulness?: Maybe<Scalars['Float']>;
  comment: CommentsComment;
  deletedBy?: Maybe<Scalars['ID']>;
  deletedNote?: Maybe<Scalars['String']>;
  originalContent?: Maybe<Scalars['Map']>;
  relevanceScore?: Maybe<Scalars['Float']>;
};

export type CommentsAdminCommentPayload = {
  __typename?: 'CommentsAdminCommentPayload';
  data?: Maybe<CommentsAdminComment>;
  error?: Maybe<CommentsError>;
};

export type CommentsAdminCommentsFilter = {
  accountId?: InputMaybe<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  resourceId?: InputMaybe<Scalars['ID']>;
  statuses?: InputMaybe<Array<CommentsStatus>>;
  text?: InputMaybe<Scalars['String']>;
};

export type CommentsAdminCommentsPayload = {
  __typename?: 'CommentsAdminCommentsPayload';
  data?: Maybe<Array<CommentsAdminComment>>;
  error?: Maybe<CommentsError>;
  page: CommentsPageInfo;
};

export type CommentsAdminDeleteCommentInput = {
  commentId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  reason: CommentsDeletionReason;
};

export type CommentsAdminMutation = {
  __typename?: 'CommentsAdminMutation';
  deleteComment: CommentsAdminCommentPayload;
  pinComment: CommentsAdminCommentPayload;
  restoreComment: CommentsAdminCommentPayload;
  setAccountRateLimit: CommentsAdminAccountPayload;
  setAccountReadOnly: CommentsAdminAccountPayload;
  suppressComment: CommentsAdminCommentPayload;
  unpinComment: CommentsAdminCommentPayload;
  unsuppressComment: CommentsAdminCommentPayload;
};

export type CommentsAdminMutationdeleteCommentArgs = {
  input: CommentsAdminDeleteCommentInput;
};

export type CommentsAdminMutationpinCommentArgs = {
  input: CommentsAdminPinCommentInput;
};

export type CommentsAdminMutationrestoreCommentArgs = {
  input: CommentsAdminRestoreCommentInput;
};

export type CommentsAdminMutationsetAccountRateLimitArgs = {
  input: CommentsAdminSetRateLimitInput;
};

export type CommentsAdminMutationsetAccountReadOnlyArgs = {
  input: CommentsAdminSetReadOnlyInput;
};

export type CommentsAdminMutationsuppressCommentArgs = {
  input: CommentsAdminSuppressCommentInput;
};

export type CommentsAdminMutationunpinCommentArgs = {
  input: CommentsAdminUnpinCommentInput;
};

export type CommentsAdminMutationunsuppressCommentArgs = {
  input: CommentsAdminUnsuppressCommentInput;
};

export type CommentsAdminPinCommentInput = {
  commentId: Scalars['ID'];
};

export type CommentsAdminQuery = {
  __typename?: 'CommentsAdminQuery';
  account?: Maybe<CommentsAdminAccount>;
  comments: CommentsAdminCommentsPayload;
  resources: Array<CommentsAdminResource>;
};

export type CommentsAdminQueryaccountArgs = {
  accountId: Scalars['ID'];
};

export type CommentsAdminQuerycommentsArgs = {
  filter: CommentsAdminCommentsFilter;
};

export type CommentsAdminQueryresourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  recentDays?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CommentsAdminResourceSort>;
};

export type CommentsAdminResource = {
  __typename?: 'CommentsAdminResource';
  lastCommentAt: Scalars['DateTime'];
  recentComments: Scalars['Int'];
  rejectedComments: Scalars['Int'];
  resourceId: Scalars['ID'];
  totalComments: Scalars['Int'];
};

export enum CommentsAdminResourceSort {
  ACTIVITY = 'ACTIVITY',
  RECENT = 'RECENT',
  REJECTED = 'REJECTED',
  TOTAL = 'TOTAL',
}

export type CommentsAdminRestoreCommentInput = {
  commentId: Scalars['ID'];
};

export type CommentsAdminSetRateLimitInput = {
  accountId: Scalars['ID'];
  seconds?: InputMaybe<Scalars['Int']>;
};

export type CommentsAdminSetReadOnlyInput = {
  accountId: Scalars['ID'];
  readOnly: Scalars['Boolean'];
};

export type CommentsAdminSuppressCommentInput = {
  commentId: Scalars['ID'];
};

export type CommentsAdminUnpinCommentInput = {
  commentId: Scalars['ID'];
};

export type CommentsAdminUnsuppressCommentInput = {
  commentId: Scalars['ID'];
};

export enum CommentsAiCategory {
  APPROVED = 'APPROVED',
  CONSTRUCTIVE_NEGATIVE = 'CONSTRUCTIVE_NEGATIVE',
  EXTERNAL_LINKS = 'EXTERNAL_LINKS',
  IRRELEVANT = 'IRRELEVANT',
  MOBALYTICS_ROAST = 'MOBALYTICS_ROAST',
  OFFENSIVE = 'OFFENSIVE',
  SPAM = 'SPAM',
}

export enum CommentsAiSeverity {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
}

export type CommentsComment = {
  __typename?: 'CommentsComment';
  accountId: Scalars['ID'];
  content: Scalars['Map'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedByModerator: Scalars['Boolean'];
  deletedReason?: Maybe<CommentsDeletionReason>;
  depth: Scalars['Int'];
  downvotes: Scalars['Int'];
  id: Scalars['ID'];
  isBeforeCutoff: Scalars['Boolean'];
  isPinned: Scalars['Boolean'];
  isSpoiler: Scalars['Boolean'];
  isSuppressed: Scalars['Boolean'];
  parentId?: Maybe<Scalars['ID']>;
  plainTextContent: Scalars['String'];
  profile?: Maybe<MgpProfile>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  rejectionReason?: Maybe<Scalars['String']>;
  replyCount: Scalars['Int'];
  resourceId: Scalars['ID'];
  score: Scalars['Int'];
  spoilerLabel?: Maybe<Scalars['String']>;
  status: CommentsStatus;
  transformedText?: Maybe<Scalars['Map']>;
  updatedAt: Scalars['DateTime'];
  upvotes: Scalars['Int'];
  viewerVote?: Maybe<CommentsVoteType>;
};

export type CommentsCommentPayload = {
  __typename?: 'CommentsCommentPayload';
  data?: Maybe<CommentsComment>;
  error?: Maybe<CommentsError>;
};

export type CommentsCommentatorInfo = {
  __typename?: 'CommentsCommentatorInfo';
  stats: CommentsCommentatorStats;
};

export type CommentsCommentatorStats = {
  __typename?: 'CommentsCommentatorStats';
  downvotesReceived: Scalars['Int'];
  totalComments: Scalars['Int'];
  upvotesReceived: Scalars['Int'];
};

export type CommentsCreateCommentInput = {
  content: Scalars['Map'];
  resourceId: Scalars['ID'];
  sourceUrl?: InputMaybe<Scalars['String']>;
};

export type CommentsCreateReplyInput = {
  content: Scalars['Map'];
  parentId: Scalars['ID'];
  sourceUrl?: InputMaybe<Scalars['String']>;
};

export type CommentsDeleteCommentInput = {
  commentId: Scalars['ID'];
};

export type CommentsDeleteVoteInput = {
  commentId: Scalars['ID'];
};

export enum CommentsDeletionReason {
  HARASSMENT = 'HARASSMENT',
  HATE_SPEECH = 'HATE_SPEECH',
  NSFW = 'NSFW',
  OFF_TOPIC = 'OFF_TOPIC',
  SPAM = 'SPAM',
}

export type CommentsEditCommentInput = {
  commentId: Scalars['ID'];
  content: Scalars['Map'];
};

export type CommentsError = {
  __typename?: 'CommentsError';
  code: CommentsErrorCode;
  message: Scalars['String'];
  retryAfterSeconds?: Maybe<Scalars['Int']>;
};

export enum CommentsErrorCode {
  CONTENT_TOO_LONG = 'CONTENT_TOO_LONG',
  FORBIDDEN = 'FORBIDDEN',
  INTERNAL = 'INTERNAL',
  INVALID_INPUT = 'INVALID_INPUT',
  NOT_FOUND = 'NOT_FOUND',
  RATE_LIMITED = 'RATE_LIMITED',
}

export type CommentsListInput = {
  cursor?: InputMaybe<Scalars['String']>;
  cutoffDate?: InputMaybe<Scalars['DateTime']>;
  limit: Scalars['Int'];
  resourceId: Scalars['ID'];
  sortBy: CommentsSortBy;
};

export type CommentsMutation = {
  __typename?: 'CommentsMutation';
  admin?: Maybe<CommentsAdminMutation>;
  createComment: CommentsCommentPayload;
  createReply: CommentsCommentPayload;
  deleteComment: CommentsCommentPayload;
  deleteVote: CommentsVotePayload;
  editComment: CommentsCommentPayload;
  vote: CommentsVotePayload;
};

export type CommentsMutationcreateCommentArgs = {
  input: CommentsCreateCommentInput;
};

export type CommentsMutationcreateReplyArgs = {
  input: CommentsCreateReplyInput;
};

export type CommentsMutationdeleteCommentArgs = {
  input: CommentsDeleteCommentInput;
};

export type CommentsMutationdeleteVoteArgs = {
  input: CommentsDeleteVoteInput;
};

export type CommentsMutationeditCommentArgs = {
  input: CommentsEditCommentInput;
};

export type CommentsMutationvoteArgs = {
  input: CommentsVoteInput;
};

export type CommentsPageInfo = {
  __typename?: 'CommentsPageInfo';
  hasMoreItems: Scalars['Boolean'];
  nextCursor?: Maybe<Scalars['String']>;
};

export type CommentsPayload = {
  __typename?: 'CommentsPayload';
  commentId: Scalars['ID'];
  cutoffDate?: Maybe<Scalars['DateTime']>;
  data?: Maybe<CommentsPayloadData>;
  error?: Maybe<CommentsError>;
  page: CommentsPageInfo;
  pinned: Array<CommentsComment>;
  resourceId: Scalars['ID'];
};

export type CommentsPayloadData = {
  __typename?: 'CommentsPayloadData';
  comments: Array<CommentsComment>;
  limit: Scalars['Int'];
  parentId?: Maybe<Scalars['ID']>;
  sortBy: CommentsSortBy;
};

export type CommentsQuery = {
  __typename?: 'CommentsQuery';
  admin?: Maybe<CommentsAdminQuery>;
  comment?: Maybe<CommentsComment>;
  comments: CommentsPayload;
  replies: CommentsPayload;
  resourceStats: CommentsResourceStats;
};

export type CommentsQuerycommentArgs = {
  commentId: Scalars['ID'];
};

export type CommentsQuerycommentsArgs = {
  input: CommentsListInput;
};

export type CommentsQueryrepliesArgs = {
  input: CommentsRepliesInput;
};

export type CommentsQueryresourceStatsArgs = {
  resourceId: Scalars['ID'];
};

export type CommentsRepliesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  parentId: Scalars['ID'];
  sortBy: CommentsSortBy;
};

export type CommentsResourceStats = {
  __typename?: 'CommentsResourceStats';
  isHot: Scalars['Boolean'];
  lastCommentAt?: Maybe<Scalars['DateTime']>;
  resourceId: Scalars['ID'];
  totalComments: Scalars['Int'];
};

export enum CommentsSortBy {
  NEW = 'NEW',
  OLD = 'OLD',
  TOP = 'TOP',
}

export enum CommentsStatus {
  DELETED = 'DELETED',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
}

export type CommentsVoteData = {
  __typename?: 'CommentsVoteData';
  commentId: Scalars['ID'];
  downvotes: Scalars['Int'];
  upvotes: Scalars['Int'];
};

export type CommentsVoteInput = {
  commentId: Scalars['ID'];
  value: CommentsVoteType;
};

export type CommentsVotePayload = {
  __typename?: 'CommentsVotePayload';
  data?: Maybe<CommentsVoteData>;
  error?: Maybe<CommentsError>;
};

export enum CommentsVoteType {
  DOWNVOTE = 'DOWNVOTE',
  UPVOTE = 'UPVOTE',
}

export type CursorPage = {
  count: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
};

export type CursorPaginationInfo = {
  __typename?: 'CursorPaginationInfo';
  cursor: Scalars['String'];
  hasMoreItems: Scalars['Boolean'];
};

export type D4Aspect = D4GameEntity & {
  __typename?: 'D4Aspect';
  campaign?: Maybe<Scalars['Boolean']>;
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  dungeon?: Maybe<D4Dungeon>;
  dungeonSlug?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<D4Location>;
  locationSlug?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  type?: Maybe<D4AspectType>;
  typeSlug?: Maybe<Scalars['String']>;
};

export type D4AspectSlot = D4GameEntity & {
  __typename?: 'D4AspectSlot';
  bonusPercent?: Maybe<Scalars['Int']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4AspectSlotsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4AspectSlotsResult = {
  __typename?: 'D4AspectSlotsResult';
  data?: Maybe<Array<D4AspectSlot>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4AspectType = D4GameEntity & {
  __typename?: 'D4AspectType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4AspectTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4AspectTypesResult = {
  __typename?: 'D4AspectTypesResult';
  data?: Maybe<Array<D4AspectType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4AspectsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4AspectsResult = {
  __typename?: 'D4AspectsResult';
  data?: Maybe<Array<D4Aspect>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4BloodiedAffix = D4GameEntity & {
  __typename?: 'D4BloodiedAffix';
  all?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slot?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4BloodiedAffixesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4BloodiedAffixesResult = {
  __typename?: 'D4BloodiedAffixesResult';
  data?: Maybe<Array<D4BloodiedAffix>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Bonuses = {
  __typename?: 'D4Bonuses';
  description?: Maybe<Scalars['String']>;
  slot?: Maybe<D4GemType>;
  slotSlug?: Maybe<Scalars['String']>;
};

export type D4BossPower = D4GameEntity & {
  __typename?: 'D4BossPower';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['String']>;
  modifier?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type D4BossPowersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4BossPowersResult = {
  __typename?: 'D4BossPowersResult';
  data?: Maybe<Array<D4BossPower>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4BuildSlot = D4GameEntity & {
  __typename?: 'D4BuildSlot';
  aspectBonuses?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4BuildSlotsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4BuildSlotsResult = {
  __typename?: 'D4BuildSlotsResult';
  data?: Maybe<Array<D4BuildSlot>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4ChaosPerk = D4GameEntity & {
  __typename?: 'D4ChaosPerk';
  class?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Array<Scalars['String']>>;
  filters?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4ChaosPerksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ChaosPerksResult = {
  __typename?: 'D4ChaosPerksResult';
  data?: Maybe<Array<D4ChaosPerk>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Charm = D4GameEntity & {
  __typename?: 'D4Charm';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  effects?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  set?: Maybe<D4CharmSet>;
  setSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
};

export type D4CharmBonuses = {
  __typename?: 'D4CharmBonuses';
  count?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type D4CharmSet = D4GameEntity & {
  __typename?: 'D4CharmSet';
  bonuses?: Maybe<Array<D4CharmBonuses>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  piecesCount?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  snoId?: Maybe<Scalars['String']>;
};

export type D4CharmSetsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4CharmSetsResult = {
  __typename?: 'D4CharmSetsResult';
  data?: Maybe<Array<D4CharmSet>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4CharmStat = {
  __typename?: 'D4CharmStat';
  id: Scalars['String'];
};

export type D4CharmsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4CharmsResult = {
  __typename?: 'D4CharmsResult';
  data?: Maybe<Array<D4Charm>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Class = D4GameEntity & {
  __typename?: 'D4Class';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  dex?: Maybe<Scalars['Int']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  int?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  primaryStat?: Maybe<D4Stat>;
  primaryStatSlug?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  str?: Maybe<Scalars['Int']>;
  uniqueSystemName?: Maybe<Scalars['String']>;
  will?: Maybe<Scalars['Int']>;
};

export type D4ClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ClassesResult = {
  __typename?: 'D4ClassesResult';
  data?: Maybe<Array<D4Class>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Connector = D4GameEntity & {
  __typename?: 'D4Connector';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  dependsOnSlugs?: Maybe<Array<Scalars['String']>>;
  dependsOnSlugsV2?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  disablesSlugs?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  requiredRank?: Maybe<Scalars['Int']>;
  season?: Maybe<Scalars['String']>;
  section?: Maybe<D4SkillSection>;
  sectionSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type D4ConnectorsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ConnectorsResult = {
  __typename?: 'D4ConnectorsResult';
  data?: Maybe<Array<D4Connector>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4DivineGift = D4GameEntity & {
  __typename?: 'D4DivineGift';
  boss?: Maybe<Scalars['String']>;
  corrupted?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  purified?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  rewards?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4DivineGiftsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4DivineGiftsResult = {
  __typename?: 'D4DivineGiftsResult';
  data?: Maybe<Array<D4DivineGift>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Dungeon = D4GameEntity & {
  __typename?: 'D4Dungeon';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4DungeonsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4DungeonsResult = {
  __typename?: 'D4DungeonsResult';
  data?: Maybe<Array<D4Dungeon>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Elixir = D4GameEntity & {
  __typename?: 'D4Elixir';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type D4ElixirsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ElixirsResult = {
  __typename?: 'D4ElixirsResult';
  data?: Maybe<Array<D4Elixir>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum D4EntitiesEnum {
  aspectSlots = 'aspectSlots',
  aspectTypes = 'aspectTypes',
  aspects = 'aspects',
  bloodiedAffixes = 'bloodiedAffixes',
  bossPowers = 'bossPowers',
  buildSlots = 'buildSlots',
  chaosPerks = 'chaosPerks',
  charmSets = 'charmSets',
  charms = 'charms',
  classes = 'classes',
  connectors = 'connectors',
  divineGifts = 'divineGifts',
  dungeons = 'dungeons',
  elixirs = 'elixirs',
  gemTypes = 'gemTypes',
  gems = 'gems',
  governingStones = 'governingStones',
  hearts = 'hearts',
  horadricSpells = 'horadricSpells',
  locations = 'locations',
  mapItemTypes = 'mapItemTypes',
  mapItems = 'mapItems',
  mapZones = 'mapZones',
  mercenaries = 'mercenaries',
  mercenarySkills = 'mercenarySkills',
  opportunities = 'opportunities',
  paragonBoards = 'paragonBoards',
  paragonGlyphRarities = 'paragonGlyphRarities',
  paragonGlyphs = 'paragonGlyphs',
  paragonNodeTypes = 'paragonNodeTypes',
  paragonNodes = 'paragonNodes',
  runes = 'runes',
  sanctificationStats = 'sanctificationStats',
  seals = 'seals',
  skillResources = 'skillResources',
  skillSections = 'skillSections',
  skillTags = 'skillTags',
  skillTypes = 'skillTypes',
  skills = 'skills',
  soulShards = 'soulShards',
  statImplicit = 'statImplicit',
  statTempering = 'statTempering',
  statTypes = 'statTypes',
  stats = 'stats',
  stoneRarities = 'stoneRarities',
  tiers = 'tiers',
  transfiguredStats = 'transfiguredStats',
  triadPowers = 'triadPowers',
  triadSplinters = 'triadSplinters',
  tuningStones = 'tuningStones',
  uniqueItemTypes = 'uniqueItemTypes',
  uniqueItems = 'uniqueItems',
  vampirePowers = 'vampirePowers',
  warplanNodes = 'warplanNodes',
  warplanTrees = 'warplanTrees',
  witchcraftPowers = 'witchcraftPowers',
}

export type D4EntityObject = NGFEntityObject & {
  __typename?: 'D4EntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<D4GameEntity>;
  enumType?: Maybe<D4EntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  modifiers?: Maybe<D4Modifiers>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type D4GameEntity = {
  slug: Scalars['String'];
};

export type D4GearStat = {
  __typename?: 'D4GearStat';
  id: Scalars['String'];
  isGreater?: Maybe<Scalars['Boolean']>;
  isMasterwork?: Maybe<Scalars['Boolean']>;
};

export type D4Gem = D4GameEntity & {
  __typename?: 'D4Gem';
  bonuses?: Maybe<Array<D4Bonuses>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  occult?: Maybe<Scalars['Boolean']>;
  rarity?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
};

export type D4GemType = D4GameEntity & {
  __typename?: 'D4GemType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4GemTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4GemTypesResult = {
  __typename?: 'D4GemTypesResult';
  data?: Maybe<Array<D4GemType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4GemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4GemsResult = {
  __typename?: 'D4GemsResult';
  data?: Maybe<Array<D4Gem>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4GoverningStone = D4GameEntity & {
  __typename?: 'D4GoverningStone';
  damageTypes?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  maxLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  rarity?: Maybe<D4StoneRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stoneStats?: Maybe<Array<D4StoneStats>>;
  tags?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type D4GoverningStonesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4GoverningStonesResult = {
  __typename?: 'D4GoverningStonesResult';
  data?: Maybe<Array<D4GoverningStone>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Heart = D4GameEntity & {
  __typename?: 'D4Heart';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4HeartsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4HeartsResult = {
  __typename?: 'D4HeartsResult';
  data?: Maybe<Array<D4Heart>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4HoradricSpell = D4GameEntity & {
  __typename?: 'D4HoradricSpell';
  cooldown?: Maybe<Scalars['Float']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Array<Scalars['String']>>;
  effect?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  luckyHit?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  spawnRate?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type D4HoradricSpellsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4HoradricSpellsResult = {
  __typename?: 'D4HoradricSpellsResult';
  data?: Maybe<Array<D4HoradricSpell>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Location = D4GameEntity & {
  __typename?: 'D4Location';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4LocationsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4LocationsResult = {
  __typename?: 'D4LocationsResult';
  data?: Maybe<Array<D4Location>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4MapItem = D4GameEntity & {
  __typename?: 'D4MapItem';
  armoryID?: Maybe<Scalars['Int']>;
  chestIndex?: Maybe<Scalars['Int']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  mapItemType?: Maybe<D4MapItemType>;
  mapItemTypeSlug?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type D4MapItemType = D4GameEntity & {
  __typename?: 'D4MapItemType';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4MapItemTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4MapItemTypesResult = {
  __typename?: 'D4MapItemTypesResult';
  data?: Maybe<Array<D4MapItemType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4MapItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4MapItemsResult = {
  __typename?: 'D4MapItemsResult';
  data?: Maybe<Array<D4MapItem>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4MapZone = D4GameEntity & {
  __typename?: 'D4MapZone';
  centerX?: Maybe<Scalars['Int']>;
  centerY?: Maybe<Scalars['Int']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4MapZonesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4MapZonesResult = {
  __typename?: 'D4MapZonesResult';
  data?: Maybe<Array<D4MapZone>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4MercenariesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4MercenariesResult = {
  __typename?: 'D4MercenariesResult';
  data?: Maybe<Array<D4Mercenary>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Mercenary = D4GameEntity & {
  __typename?: 'D4Mercenary';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type D4MercenarySkill = D4GameEntity & {
  __typename?: 'D4MercenarySkill';
  attackDescription?: Maybe<Scalars['String']>;
  depends?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  disables?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mercenary?: Maybe<D4Mercenary>;
  mercenarySlug?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nodeTypeSlug?: Maybe<Scalars['String']>;
  outs?: Maybe<Array<Scalars['String']>>;
  resources?: Maybe<Array<D4Resources>>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type D4MercenarySkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4MercenarySkillsResult = {
  __typename?: 'D4MercenarySkillsResult';
  data?: Maybe<Array<D4MercenarySkill>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Modifiers = {
  __typename?: 'D4Modifiers';
  bloodiedAffixes?: Maybe<Array<Maybe<D4ModifiersBloodiedAffix>>>;
  charmStats?: Maybe<Array<Maybe<D4CharmStat>>>;
  gearStats?: Maybe<Array<Maybe<D4GearStat>>>;
  implicitStats?: Maybe<Array<Maybe<D4StatImplicit>>>;
  isMythic?: Maybe<Scalars['Boolean']>;
  kulleanTransfiguredStats?: Maybe<Array<Maybe<D4ModifiersKulleanTransfiguredStat>>>;
  sanctificationStats?: Maybe<Array<Maybe<D4SanctificationStat>>>;
  sealStats?: Maybe<Array<Maybe<D4SealStat>>>;
  socketStats?: Maybe<Array<Maybe<D4EntityObject>>>;
  temperingStats?: Maybe<Array<Maybe<D4TemperingStat>>>;
  transfiguredStats?: Maybe<Array<Maybe<D4ModifiersTransfiguredStat>>>;
};

export type D4ModifiersBloodiedAffix = {
  __typename?: 'D4ModifiersBloodiedAffix';
  id: Scalars['String'];
  isGreater?: Maybe<Scalars['Boolean']>;
  isMasterwork?: Maybe<Scalars['Boolean']>;
};

export type D4ModifiersKulleanTransfiguredStat = {
  __typename?: 'D4ModifiersKulleanTransfiguredStat';
  id: Scalars['String'];
};

export type D4ModifiersTransfiguredStat = {
  __typename?: 'D4ModifiersTransfiguredStat';
  id: Scalars['String'];
};

export type D4NodeStats = {
  __typename?: 'D4NodeStats';
  type?: Maybe<D4StatType>;
  typeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type D4OpportunitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4OpportunitiesResult = {
  __typename?: 'D4OpportunitiesResult';
  data?: Maybe<Array<D4Opportunity>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Opportunity = D4GameEntity & {
  __typename?: 'D4Opportunity';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4Pacts = {
  __typename?: 'D4Pacts';
  divinity?: Maybe<Scalars['Int']>;
  eternity?: Maybe<Scalars['Int']>;
  ferocity?: Maybe<Scalars['Int']>;
};

export type D4ParagonBoard = D4GameEntity & {
  __typename?: 'D4ParagonBoard';
  classes?: Maybe<Array<D4Class>>;
  classesSlugs?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  nodes?: Maybe<Array<D4ParagonNode>>;
  nodesSlugs?: Maybe<Array<Scalars['String']>>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  stats?: Maybe<Array<D4Stats>>;
  title?: Maybe<Scalars['String']>;
};

export type D4ParagonBoardsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ParagonBoardsResult = {
  __typename?: 'D4ParagonBoardsResult';
  data?: Maybe<Array<D4ParagonBoard>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4ParagonGlyph = D4GameEntity & {
  __typename?: 'D4ParagonGlyph';
  additionalBonus?: Maybe<Array<Scalars['String']>>;
  affectedType?: Maybe<D4ParagonNodeType>;
  affectedTypeSlug?: Maybe<Scalars['String']>;
  bonus?: Maybe<Array<Scalars['String']>>;
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  legendaryBonus?: Maybe<Array<Scalars['String']>>;
  legendaryValue?: Maybe<Scalars['String']>;
  maxLevel?: Maybe<Scalars['Int']>;
  maxRadius?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  radiusDistribution?: Maybe<Array<D4RadiusDistribution>>;
  rarity?: Maybe<D4ParagonGlyphRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  requirementsStats?: Maybe<Array<D4RequirementsStats>>;
  scaling?: Maybe<Scalars['Float']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  statName?: Maybe<Scalars['String']>;
  statScaling?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type D4ParagonGlyphRaritiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ParagonGlyphRaritiesResult = {
  __typename?: 'D4ParagonGlyphRaritiesResult';
  data?: Maybe<Array<D4ParagonGlyphRarity>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4ParagonGlyphRarity = D4GameEntity & {
  __typename?: 'D4ParagonGlyphRarity';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4ParagonGlyphsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ParagonGlyphsResult = {
  __typename?: 'D4ParagonGlyphsResult';
  data?: Maybe<Array<D4ParagonGlyph>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4ParagonNode = D4GameEntity & {
  __typename?: 'D4ParagonNode';
  bonusAmount?: Maybe<Array<Scalars['String']>>;
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  effects?: Maybe<Array<Scalars['String']>>;
  iconUrlActive?: Maybe<Scalars['String']>;
  iconUrlNormal?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  nodeStats?: Maybe<Array<D4NodeStats>>;
  requiredStats?: Maybe<Array<D4RequiredStats>>;
  requires?: Maybe<Array<Scalars['String']>>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  type?: Maybe<D4ParagonNodeType>;
  typeSlug?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type D4ParagonNodeType = D4GameEntity & {
  __typename?: 'D4ParagonNodeType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4ParagonNodeTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ParagonNodeTypesResult = {
  __typename?: 'D4ParagonNodeTypesResult';
  data?: Maybe<Array<D4ParagonNodeType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4ParagonNodesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4ParagonNodesResult = {
  __typename?: 'D4ParagonNodesResult';
  data?: Maybe<Array<D4ParagonNode>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4RadiusDistribution = {
  __typename?: 'D4RadiusDistribution';
  level?: Maybe<Scalars['Int']>;
  radius?: Maybe<Scalars['Int']>;
};

export type D4RequiredStats = {
  __typename?: 'D4RequiredStats';
  step?: Maybe<Scalars['String']>;
  type?: Maybe<D4StatType>;
  typeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type D4RequirementsStats = {
  __typename?: 'D4RequirementsStats';
  type?: Maybe<D4StatType>;
  typeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type D4Resources = {
  __typename?: 'D4Resources';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type D4Rune = D4GameEntity & {
  __typename?: 'D4Rune';
  bonus?: Maybe<Scalars['String']>;
  cooldown?: Maybe<Scalars['Int']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  gain?: Maybe<Scalars['Int']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  overflow?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  requires?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type D4RunesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4RunesResult = {
  __typename?: 'D4RunesResult';
  data?: Maybe<Array<D4Rune>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4SanctificationStat = D4GameEntity & {
  __typename?: 'D4SanctificationStat';
  all?: Maybe<Array<Scalars['String']>>;
  barbarian?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  druid?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  necromancer?: Maybe<Array<Scalars['String']>>;
  paladin?: Maybe<Array<Scalars['String']>>;
  rogue?: Maybe<Array<Scalars['String']>>;
  slot?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  sorcerer?: Maybe<Array<Scalars['String']>>;
  spiritborn?: Maybe<Array<Scalars['String']>>;
};

export type D4SanctificationStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SanctificationStatsResult = {
  __typename?: 'D4SanctificationStatsResult';
  data?: Maybe<Array<D4SanctificationStat>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Seal = D4GameEntity & {
  __typename?: 'D4Seal';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId?: Maybe<Scalars['String']>;
};

export type D4SealStat = {
  __typename?: 'D4SealStat';
  id: Scalars['String'];
};

export type D4SealsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SealsResult = {
  __typename?: 'D4SealsResult';
  data?: Maybe<Array<D4Seal>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Skill = D4GameEntity & {
  __typename?: 'D4Skill';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  dependsOn?: Maybe<Array<D4Skill>>;
  dependsOnSlugs?: Maybe<Array<Scalars['String']>>;
  dependsOnV2?: Maybe<Array<D4Skill>>;
  dependsOnV2Slugs?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  disables?: Maybe<Array<D4Skill>>;
  disablesSlugs?: Maybe<Array<Scalars['String']>>;
  enchantment?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxRank?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  requiredRank?: Maybe<Scalars['Int']>;
  resources?: Maybe<Array<D4Resources>>;
  season?: Maybe<Scalars['String']>;
  section?: Maybe<D4SkillSection>;
  sectionSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  substitutions?: Maybe<Array<D4Substitutions>>;
  tags?: Maybe<Array<D4SkillTag>>;
  tagsSlugs?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<D4SkillType>;
  typeSlug?: Maybe<Scalars['String']>;
  typeV2?: Maybe<D4SkillType>;
  typeV2Slug?: Maybe<Scalars['String']>;
  weaponArsenalSlots?: Maybe<Array<D4BuildSlot>>;
  weaponArsenalSlotsSlugs?: Maybe<Array<Scalars['String']>>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type D4SkillResource = D4GameEntity & {
  __typename?: 'D4SkillResource';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type D4SkillResourcesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SkillResourcesResult = {
  __typename?: 'D4SkillResourcesResult';
  data?: Maybe<Array<D4SkillResource>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4SkillSection = D4GameEntity & {
  __typename?: 'D4SkillSection';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  requiredRank?: Maybe<Scalars['Int']>;
  season?: Maybe<Scalars['String']>;
  skills?: Maybe<Array<D4Skill>>;
  skillsSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type D4SkillSectionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SkillSectionsResult = {
  __typename?: 'D4SkillSectionsResult';
  data?: Maybe<Array<D4SkillSection>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4SkillTag = D4GameEntity & {
  __typename?: 'D4SkillTag';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4SkillTagsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SkillTagsResult = {
  __typename?: 'D4SkillTagsResult';
  data?: Maybe<Array<D4SkillTag>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4SkillType = D4GameEntity & {
  __typename?: 'D4SkillType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4SkillTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SkillTypesResult = {
  __typename?: 'D4SkillTypesResult';
  data?: Maybe<Array<D4SkillType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4SkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SkillsResult = {
  __typename?: 'D4SkillsResult';
  data?: Maybe<Array<D4Skill>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4SoulShard = D4GameEntity & {
  __typename?: 'D4SoulShard';
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Array<Scalars['String']>>;
  fragments?: Maybe<Array<D4SoulShard>>;
  fragmentsSlugs?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4SoulShardsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4SoulShardsResult = {
  __typename?: 'D4SoulShardsResult';
  data?: Maybe<Array<D4SoulShard>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4Stat = D4GameEntity & {
  __typename?: 'D4Stat';
  buildSlots?: Maybe<Array<D4BuildSlot>>;
  buildSlotsSlugs?: Maybe<Array<Scalars['String']>>;
  classes?: Maybe<Array<D4Class>>;
  classesSlugs?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isUniqueItemStat?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
};

export type D4StatImplicit = D4GameEntity & {
  __typename?: 'D4StatImplicit';
  buildSlots?: Maybe<Array<D4BuildSlot>>;
  buildSlotsSlugs?: Maybe<Array<Scalars['String']>>;
  classes?: Maybe<Array<D4Class>>;
  classesSlugs?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isUniqueItemStat?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4StatImplicitFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4StatImplicitResult = {
  __typename?: 'D4StatImplicitResult';
  data?: Maybe<Array<D4StatImplicit>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4StatTempering = D4GameEntity & {
  __typename?: 'D4StatTempering';
  buildSlots?: Maybe<Array<D4BuildSlot>>;
  buildSlotsSlugs?: Maybe<Array<Scalars['String']>>;
  classes?: Maybe<Array<D4Class>>;
  classesSlugs?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUniqueItemStat?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
};

export type D4StatTemperingFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4StatTemperingResult = {
  __typename?: 'D4StatTemperingResult';
  data?: Maybe<Array<D4StatTempering>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4StatType = D4GameEntity & {
  __typename?: 'D4StatType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4StatTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4StatTypesResult = {
  __typename?: 'D4StatTypesResult';
  data?: Maybe<Array<D4StatType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum D4StaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type D4Stats = {
  __typename?: 'D4Stats';
  type?: Maybe<D4StatType>;
  typeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type D4StatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4StatsResult = {
  __typename?: 'D4StatsResult';
  data?: Maybe<Array<D4Stat>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4StoneRaritiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4StoneRaritiesResult = {
  __typename?: 'D4StoneRaritiesResult';
  data?: Maybe<Array<D4StoneRarity>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4StoneRarity = D4GameEntity & {
  __typename?: 'D4StoneRarity';
  color?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4StoneStats = {
  __typename?: 'D4StoneStats';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type D4Substitutions = {
  __typename?: 'D4Substitutions';
  key?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Scalars['String']>>;
};

export type D4TemperingStat = {
  __typename?: 'D4TemperingStat';
  id: Scalars['String'];
  isGreater?: Maybe<Scalars['Boolean']>;
  isMasterwork?: Maybe<Scalars['Boolean']>;
};

export type D4Tier = D4GameEntity & {
  __typename?: 'D4Tier';
  color?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4TiersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4TiersResult = {
  __typename?: 'D4TiersResult';
  data?: Maybe<Array<D4Tier>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4TransfiguredStat = D4GameEntity & {
  __typename?: 'D4TransfiguredStat';
  buildSlots?: Maybe<Array<D4BuildSlot>>;
  buildSlotsSlugs?: Maybe<Array<Scalars['String']>>;
  classes?: Maybe<Array<D4Class>>;
  classesSlugs?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUniqueItemStat?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId?: Maybe<Scalars['String']>;
};

export type D4TransfiguredStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4TransfiguredStatsResult = {
  __typename?: 'D4TransfiguredStatsResult';
  data?: Maybe<Array<D4TransfiguredStat>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4TriadPower = D4GameEntity & {
  __typename?: 'D4TriadPower';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  splinter?: Maybe<D4TriadSplinter>;
  splinterSlug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unlock?: Maybe<Scalars['String']>;
};

export type D4TriadPowersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4TriadPowersResult = {
  __typename?: 'D4TriadPowersResult';
  data?: Maybe<Array<D4TriadPower>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4TriadSplinter = D4GameEntity & {
  __typename?: 'D4TriadSplinter';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  requirement?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
};

export type D4TriadSplintersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4TriadSplintersResult = {
  __typename?: 'D4TriadSplintersResult';
  data?: Maybe<Array<D4TriadSplinter>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4TuningStone = D4GameEntity & {
  __typename?: 'D4TuningStone';
  compatibleTypes?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  maxLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  rarity?: Maybe<D4StoneRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type D4TuningStonesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4TuningStonesResult = {
  __typename?: 'D4TuningStonesResult';
  data?: Maybe<Array<D4TuningStone>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4UniqueItem = D4GameEntity & {
  __typename?: 'D4UniqueItem';
  chaos?: Maybe<Scalars['Boolean']>;
  class?: Maybe<D4Class>;
  classSlug?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  dropSource?: Maybe<Scalars['String']>;
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mainStats?: Maybe<Array<Scalars['String']>>;
  mythic?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  secondaryStats?: Maybe<Array<Scalars['String']>>;
  secondaryStatsSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  type?: Maybe<D4UniqueItemType>;
  typeSlug?: Maybe<Scalars['String']>;
};

export type D4UniqueItemType = D4GameEntity & {
  __typename?: 'D4UniqueItemType';
  deprecated?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId?: Maybe<Scalars['String']>;
};

export type D4UniqueItemTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4UniqueItemTypesResult = {
  __typename?: 'D4UniqueItemTypesResult';
  data?: Maybe<Array<D4UniqueItemType>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4UniqueItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4UniqueItemsResult = {
  __typename?: 'D4UniqueItemsResult';
  data?: Maybe<Array<D4UniqueItem>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4VampirePower = D4GameEntity & {
  __typename?: 'D4VampirePower';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  pacts?: Maybe<D4Pacts>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type D4VampirePowersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4VampirePowersResult = {
  __typename?: 'D4VampirePowersResult';
  data?: Maybe<Array<D4VampirePower>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4WarplanNode = D4GameEntity & {
  __typename?: 'D4WarplanNode';
  depends?: Maybe<Array<Scalars['String']>>;
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  disables?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  nodeTypeSlug?: Maybe<Scalars['String']>;
  outs?: Maybe<Array<Scalars['String']>>;
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
  tree?: Maybe<D4WarplanTree>;
  treeSlug?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type D4WarplanNodesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4WarplanNodesResult = {
  __typename?: 'D4WarplanNodesResult';
  data?: Maybe<Array<D4WarplanNode>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4WarplanTree = D4GameEntity & {
  __typename?: 'D4WarplanTree';
  deprecated?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxPoints?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  snoId: Scalars['String'];
};

export type D4WarplanTreesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4WarplanTreesResult = {
  __typename?: 'D4WarplanTreesResult';
  data?: Maybe<Array<D4WarplanTree>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type D4WitchcraftPower = D4GameEntity & {
  __typename?: 'D4WitchcraftPower';
  deprecated?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  season?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  unique?: Maybe<Scalars['Boolean']>;
};

export type D4WitchcraftPowersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type D4WitchcraftPowersResult = {
  __typename?: 'D4WitchcraftPowersResult';
  data?: Maybe<Array<D4WitchcraftPower>>;
  error?: Maybe<D4StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockAbilityStat = DeadlockGameEntity & {
  __typename?: 'DeadlockAbilityStat';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DeadlockAbilityStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockAbilityStatsResult = {
  __typename?: 'DeadlockAbilityStatsResult';
  data?: Maybe<Array<DeadlockAbilityStat>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockActive = {
  __typename?: 'DeadlockActive';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Array<DeadlockValue>>;
};

export type DeadlockBoxstats = {
  __typename?: 'DeadlockBoxstats';
  description?: Maybe<Scalars['String']>;
  spiritAffected?: Maybe<Scalars['Boolean']>;
};

export type DeadlockDocumentCmWidgetBuildsStatsV1 = NgfDocumentContent & {
  __typename?: 'DeadlockDocumentCmWidgetBuildsStatsV1';
  data: DeadlockDocumentCmWidgetBuildsStatsV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type DeadlockDocumentCmWidgetBuildsStatsV1Data = NgfDocumentContentData & {
  __typename?: 'DeadlockDocumentCmWidgetBuildsStatsV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  hero: DeadlockHero;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type DeadlockDocumentCmWidgetHeroHeaderV1 = NgfDocumentContent & {
  __typename?: 'DeadlockDocumentCmWidgetHeroHeaderV1';
  data: DeadlockDocumentCmWidgetHeroHeaderV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type DeadlockDocumentCmWidgetHeroHeaderV1Data = NgfDocumentContentData & {
  __typename?: 'DeadlockDocumentCmWidgetHeroHeaderV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  hero: DeadlockHero;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type DeadlockDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'DeadlockDocumentCmWidgetV1';
  data: DeadlockDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type DeadlockDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'DeadlockDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type DeadlockDocumentContent =
  | DeadlockDocumentCmWidgetBuildsStatsV1
  | DeadlockDocumentCmWidgetHeroHeaderV1
  | DeadlockDocumentCmWidgetV1
  | DeadlockDocumentUgWidgetAbilityPointV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type DeadlockDocumentSeason = NgfDocumentSeason & {
  __typename?: 'DeadlockDocumentSeason';
  slug: Scalars['String'];
};

export type DeadlockDocumentTags = NgfDocumentTags & {
  __typename?: 'DeadlockDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type DeadlockDocumentUgWidgetAbilityPointDataV1 = NgfDocumentContentData & {
  __typename?: 'DeadlockDocumentUgWidgetAbilityPointDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type DeadlockDocumentUgWidgetAbilityPointV1 = NgfDocumentContent & {
  __typename?: 'DeadlockDocumentUgWidgetAbilityPointV1';
  data: DeadlockDocumentUgWidgetAbilityPointDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type DeadlockDocumentsMutation = {
  __typename?: 'DeadlockDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: DeadlockStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: DeadlockStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: DeadlockStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: DeadlockStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: DeadlockUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: DeadlockUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: DeadlockUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: DeadlockUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: DeadlockUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: DeadlockUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: DeadlockWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: DeadlockWikiDocumentUpdatePayload;
};

export type DeadlockDocumentsMutationstructDocumentCreateArgs = {
  input: DeadlockStructDocumentCreateInput;
};

export type DeadlockDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type DeadlockDocumentsMutationstructDocumentSetStatusArgs = {
  input: DeadlockStructDocumentSetStatusInput;
};

export type DeadlockDocumentsMutationstructDocumentUpdateArgs = {
  input: DeadlockStructDocumentUpdateInput;
};

export type DeadlockDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: DeadlockUserGeneratedDocumentCreateInput;
};

export type DeadlockDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: DeadlockUserGeneratedDocumentSetFavoriteInput;
};

export type DeadlockDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: DeadlockUserGeneratedDocumentSetFeaturedInput;
};

export type DeadlockDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type DeadlockDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: DeadlockUserGeneratedDocumentSetStatusInput;
};

export type DeadlockDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: DeadlockUserGeneratedDocumentUpdateInput;
};

export type DeadlockDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type DeadlockDocumentsMutationwikiDocumentUpdateArgs = {
  input: DeadlockWikiDocumentUpdateInput;
};

export type DeadlockDocumentsQuery = {
  __typename?: 'DeadlockDocumentsQuery';
  previewDocumentContent: DeadlockPreviewDocumentContentPayload;
  structDocumentBySlug: DeadlockStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: DeadlockUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: DeadlockUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: DeadlockUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: DeadlockUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: DeadlockTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: DeadlockWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type DeadlockDocumentsQuerypreviewDocumentContentArgs = {
  input: DeadlockPreviewDocumentContentInput;
};

export type DeadlockDocumentsQuerystructDocumentBySlugArgs = {
  input: DeadlockStructDocumentInputBySlug;
};

export type DeadlockDocumentsQuerystructDocumentsArgs = {
  input: DeadlockStructDocumentsInput;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: DeadlockUserGeneratedDocumentInputById;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: DeadlockUserGeneratedDocumentInputBySlug;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: DeadlockTemplateDocumentInput;
};

export type DeadlockDocumentsQueryuserGeneratedDocumentsArgs = {
  input: DeadlockUserGeneratedDocumentsListInput;
  page: DeadlockUserGeneratedDocumentsListPage;
};

export type DeadlockDocumentsQuerywikiDocumentArgs = {
  input: DeadlockWikiDocumentInput;
};

export type DeadlockDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<DeadlockWikiDocumentsListInput>;
  page: DeadlockWikiDocumentsListPage;
};

export type DeadlockDynamicBuild = {
  __typename?: 'DeadlockDynamicBuild';
  abilityOrder?: Maybe<Array<DeadlockHeroAbility>>;
  abilityPickRates?: Maybe<Array<DeadlockDynamicBuildAbilityPickRates>>;
  buildID: Scalars['String'];
  earlyGameItems?: Maybe<Array<DeadlockDynamicBuildItemPickRate>>;
  firstMaxedAbility: DeadlockHeroAbility;
  lateGameItems?: Maybe<Array<DeadlockDynamicBuildItemPickRate>>;
  matches: Scalars['Int64'];
  midGameItems?: Maybe<Array<DeadlockDynamicBuildItemPickRate>>;
  wins: Scalars['Int64'];
};

export type DeadlockDynamicBuildAbilityPickRates = {
  __typename?: 'DeadlockDynamicBuildAbilityPickRates';
  ability: DeadlockHeroAbility;
  rates?: Maybe<Array<Scalars['Float']>>;
};

export type DeadlockDynamicBuildItemPickRate = {
  __typename?: 'DeadlockDynamicBuildItemPickRate';
  item: DeadlockItem;
  rate: Scalars['Float'];
};

export type DeadlockDynamicBuildsFilter = {
  buildId?: InputMaybe<Scalars['String']>;
  heroId: Scalars['String'];
};

export type DeadlockDynamicBuildsPayload = {
  __typename?: 'DeadlockDynamicBuildsPayload';
  builds?: Maybe<Array<DeadlockDynamicBuild>>;
  hero?: Maybe<DeadlockHero>;
};

export enum DeadlockEntitiesEnum {
  abilityStats = 'abilityStats',
  heroAbilities = 'heroAbilities',
  heroStats = 'heroStats',
  heroes = 'heroes',
  itemStats = 'itemStats',
  itemTypes = 'itemTypes',
  items = 'items',
  ranks = 'ranks',
}

export type DeadlockEntity = DeadlockHero;

export type DeadlockEntityObject = NGFEntityObject & {
  __typename?: 'DeadlockEntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<DeadlockGameEntity>;
  enumType?: Maybe<DeadlockEntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DeadlockGameDataQuery = {
  __typename?: 'DeadlockGameDataQuery';
  deadlockAbilityStats: DeadlockAbilityStatsResult;
  deadlockHeroAbilities: DeadlockHeroAbilitiesResult;
  deadlockHeroStats: DeadlockHeroStatsResult;
  deadlockHeroes: DeadlockHeroesResult;
  deadlockItemStats: DeadlockItemStatsResult;
  deadlockItemTypes: DeadlockItemTypesResult;
  deadlockItems: DeadlockItemsResult;
  deadlockRanks: DeadlockRanksResult;
};

export type DeadlockGameDataQuerydeadlockAbilityStatsArgs = {
  filter?: InputMaybe<DeadlockAbilityStatsFilter>;
};

export type DeadlockGameDataQuerydeadlockHeroAbilitiesArgs = {
  filter?: InputMaybe<DeadlockHeroAbilitiesFilter>;
};

export type DeadlockGameDataQuerydeadlockHeroStatsArgs = {
  filter?: InputMaybe<DeadlockHeroStatsFilter>;
};

export type DeadlockGameDataQuerydeadlockHeroesArgs = {
  filter?: InputMaybe<DeadlockHeroesFilter>;
};

export type DeadlockGameDataQuerydeadlockItemStatsArgs = {
  filter?: InputMaybe<DeadlockItemStatsFilter>;
};

export type DeadlockGameDataQuerydeadlockItemTypesArgs = {
  filter?: InputMaybe<DeadlockItemTypesFilter>;
};

export type DeadlockGameDataQuerydeadlockItemsArgs = {
  filter?: InputMaybe<DeadlockItemsFilter>;
};

export type DeadlockGameDataQuerydeadlockRanksArgs = {
  filter?: InputMaybe<DeadlockRanksFilter>;
};

export type DeadlockGameEntity = {
  slug: Scalars['String'];
};

export type DeadlockGameProfile = {
  __typename?: 'DeadlockGameProfile';
  generalStats: DeadlockProfileGeneralStatsPayload;
  mgp?: Maybe<MgpProfile>;
  ngf?: Maybe<DeadlockProfile>;
  recentMatches: DeadlockProfileRecentMatchesPayload;
};

export type DeadlockGameProfilerecentMatchesArgs = {
  page: DeadlockStatsCursorPage;
};

/** Profile lookup filter. Exactly one of steamId or username must be provided. */
export type DeadlockGameProfileFilter = {
  steamId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type DeadlockGameProfilePayload = {
  __typename?: 'DeadlockGameProfilePayload';
  data?: Maybe<DeadlockGameProfile>;
  error?: Maybe<DeadlockStatsError>;
};

export type DeadlockGeneralStats = {
  __typename?: 'DeadlockGeneralStats';
  slug: Scalars['String'];
  spiritAffected?: Maybe<Scalars['Boolean']>;
  stat?: Maybe<DeadlockAbilityStat>;
  value?: Maybe<Scalars['String']>;
};

export type DeadlockHero = DeadlockGameEntity & {
  __typename?: 'DeadlockHero';
  abilities?: Maybe<Array<Scalars['String']>>;
  fullDescription?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  heroBuildsStats?: Maybe<Array<DeadlockDynamicBuild>>;
  heroStats?: Maybe<DeadlockHeroStatsData>;
  heroStatsValues?: Maybe<Array<DeadlockHeroStatsValues>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  quickDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type DeadlockHeroheroStatsArgs = {
  filter?: InputMaybe<DeadlockHeroHeroStatsFilter>;
};

export type DeadlockHeroAbilitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockHeroAbilitiesResult = {
  __typename?: 'DeadlockHeroAbilitiesResult';
  data?: Maybe<Array<DeadlockHeroAbility>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockHeroAbility = DeadlockGameEntity & {
  __typename?: 'DeadlockHeroAbility';
  boxstats?: Maybe<Array<DeadlockBoxstats>>;
  description?: Maybe<Scalars['String']>;
  generalStats?: Maybe<Array<DeadlockGeneralStats>>;
  hero?: Maybe<Scalars['String']>;
  hotkey?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  powerUp?: Maybe<Array<DeadlockPowerUp>>;
  slug: Scalars['String'];
};

export type DeadlockHeroHeroStatsFilter = {
  region?: InputMaybe<Scalars['String']>;
};

export type DeadlockHeroStat = DeadlockGameEntity & {
  __typename?: 'DeadlockHeroStat';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DeadlockHeroStatsData = {
  __typename?: 'DeadlockHeroStatsData';
  avgDenies: Scalars['Float'];
  avgKda: Scalars['Float'];
  avgLastHitPerMinute: Scalars['Float'];
  avgNetWorthPerMinute: Scalars['Float'];
  gamesAmount: Scalars['Int64'];
  hero?: Maybe<DeadlockHero>;
  pickRate: Scalars['Float'];
  winRate: Scalars['Float'];
};

export type DeadlockHeroStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockHeroStatsResult = {
  __typename?: 'DeadlockHeroStatsResult';
  data?: Maybe<Array<DeadlockHeroStat>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockHeroStatsValues = {
  __typename?: 'DeadlockHeroStatsValues';
  powerUp?: Maybe<Scalars['Float']>;
  slug: Scalars['String'];
  spiritAffected?: Maybe<Scalars['Boolean']>;
  stat?: Maybe<DeadlockHeroStat>;
  value?: Maybe<Scalars['String']>;
};

export type DeadlockHeroTierListFilter = {
  heroID?: InputMaybe<Scalars['Int']>;
};

export type DeadlockHeroesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockHeroesResult = {
  __typename?: 'DeadlockHeroesResult';
  data?: Maybe<Array<DeadlockHero>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockItem = DeadlockGameEntity & {
  __typename?: 'DeadlockItem';
  active?: Maybe<Array<DeadlockActive>>;
  componentOf?: Maybe<Array<DeadlockItem>>;
  componentOfSlugs?: Maybe<Array<Scalars['String']>>;
  components?: Maybe<Array<DeadlockItem>>;
  componentsSlugs?: Maybe<Array<Scalars['String']>>;
  cost?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemStatsValues?: Maybe<Array<DeadlockItemStatsValues>>;
  itemType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  passive?: Maybe<Array<DeadlockPassive>>;
  slug: Scalars['String'];
};

export type DeadlockItemStat = DeadlockGameEntity & {
  __typename?: 'DeadlockItemStat';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DeadlockItemStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockItemStatsResult = {
  __typename?: 'DeadlockItemStatsResult';
  data?: Maybe<Array<DeadlockItemStat>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockItemStatsValues = {
  __typename?: 'DeadlockItemStatsValues';
  slug: Scalars['String'];
  stat?: Maybe<DeadlockItemStat>;
  value?: Maybe<Scalars['String']>;
};

export type DeadlockItemType = DeadlockGameEntity & {
  __typename?: 'DeadlockItemType';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DeadlockItemTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockItemTypesResult = {
  __typename?: 'DeadlockItemTypesResult';
  data?: Maybe<Array<DeadlockItemType>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockItemsResult = {
  __typename?: 'DeadlockItemsResult';
  data?: Maybe<Array<DeadlockItem>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockMutation = {
  __typename?: 'DeadlockMutation';
  documents?: Maybe<DeadlockDocumentsMutation>;
  id: Scalars['ID'];
};

export type DeadlockPassive = {
  __typename?: 'DeadlockPassive';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Array<DeadlockValue>>;
};

export type DeadlockPowerUp = {
  __typename?: 'DeadlockPowerUp';
  description?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
};

export enum DeadlockPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockPreviewDocumentContentInput = {
  content: Scalars['DeadlockDocumentContentInputBase64Json'];
};

export type DeadlockPreviewDocumentContentPayload = {
  __typename?: 'DeadlockPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<DeadlockDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<DeadlockPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockProfile = NgfProfile & {
  __typename?: 'DeadlockProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type DeadlockProfileuserGeneratedDocumentsArgs = {
  input: DeadlockUserGeneratedDocumentsListInput;
  page: DeadlockUserGeneratedDocumentsListPage;
};

export type DeadlockProfileGeneralStats = {
  __typename?: 'DeadlockProfileGeneralStats';
  accuracy: Scalars['Int'];
  assists: Scalars['Float'];
  creepsPerMin: Scalars['Float'];
  deaths: Scalars['Float'];
  denies: Scalars['Float'];
  gamesAmount: Scalars['Int'];
  headshots: Scalars['Float'];
  heroDamagePerMin: Scalars['Float'];
  heroesStats: Array<DeadlockProfileHeroStats>;
  kda: Scalars['Float'];
  kills: Scalars['Float'];
  killsPerMin: Scalars['Float'];
  netWorthPerMin: Scalars['Float'];
  objDamage: Scalars['Int'];
  objDamagePerMin: Scalars['Float'];
  percentiles?: Maybe<DeadlockProfileGeneralStatsPercentiles>;
  steamAccount: DeadlockProfileSteamAccountInfo;
  winRate: Scalars['Float'];
};

export type DeadlockProfileGeneralStatsFilter = {
  steamId: Scalars['String'];
};

export type DeadlockProfileGeneralStatsPayload = {
  __typename?: 'DeadlockProfileGeneralStatsPayload';
  data?: Maybe<DeadlockProfileGeneralStats>;
  error?: Maybe<DeadlockStatsError>;
};

export type DeadlockProfileGeneralStatsPercentiles = {
  __typename?: 'DeadlockProfileGeneralStatsPercentiles';
  kda: Scalars['Float'];
  winRate: Scalars['Float'];
};

export type DeadlockProfileHeroStats = {
  __typename?: 'DeadlockProfileHeroStats';
  creepsPerMin: Scalars['Float'];
  gamesAmount: Scalars['Int'];
  headshots: Scalars['Float'];
  hero?: Maybe<DeadlockHero>;
  heroDamagePerMin: Scalars['Float'];
  kda: Scalars['Float'];
  netWorthPerMin: Scalars['Float'];
  winRate: Scalars['Float'];
};

export type DeadlockProfileMatchStatsPercentiles = {
  __typename?: 'DeadlockProfileMatchStatsPercentiles';
  kda: Scalars['Float'];
};

export type DeadlockProfilePayload = {
  __typename?: 'DeadlockProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<DeadlockProfile>;
};

export type DeadlockProfileQuery = {
  __typename?: 'DeadlockProfileQuery';
  generalStats: DeadlockProfileGeneralStatsPayload;
  recentMatches: DeadlockProfileRecentMatchesPayload;
};

export type DeadlockProfileQuerygeneralStatsArgs = {
  filter: DeadlockProfileGeneralStatsFilter;
};

export type DeadlockProfileQueryrecentMatchesArgs = {
  filter: DeadlockProfileRecentMatchesFilter;
  page: DeadlockStatsCursorPage;
};

export type DeadlockProfileRecentMatch = {
  __typename?: 'DeadlockProfileRecentMatch';
  assists: Scalars['Int'];
  deaths: Scalars['Int'];
  denies: Scalars['Int'];
  duration: Scalars['Int'];
  hero?: Maybe<DeadlockHero>;
  heroDamage: Scalars['Int'];
  kda: Scalars['Float'];
  kills: Scalars['Int'];
  lastHits: Scalars['Int'];
  losingTeam: Array<DeadlockProfileTeamPlayerInfo>;
  matchId: Scalars['ID'];
  netWorth: Scalars['Int'];
  percentiles?: Maybe<DeadlockProfileMatchStatsPercentiles>;
  slug: Scalars['String'];
  timestamp: Scalars['Int'];
  win: Scalars['Boolean'];
  winningTeam: Array<DeadlockProfileTeamPlayerInfo>;
};

export type DeadlockProfileRecentMatchesFilter = {
  steamId: Scalars['String'];
};

export type DeadlockProfileRecentMatchesPayload = {
  __typename?: 'DeadlockProfileRecentMatchesPayload';
  data?: Maybe<Array<DeadlockProfileRecentMatch>>;
  error?: Maybe<DeadlockStatsError>;
  paginationInfo?: Maybe<DeadlockStatsCursorPaginationInfo>;
};

export type DeadlockProfileSteamAccountInfo = {
  __typename?: 'DeadlockProfileSteamAccountInfo';
  avatarURL?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  steamId: Scalars['ID'];
};

export type DeadlockProfileTeamPlayerInfo = {
  __typename?: 'DeadlockProfileTeamPlayerInfo';
  hero?: Maybe<DeadlockHero>;
  items: Array<DeadlockProfileTeamPlayerItem>;
  stats?: Maybe<DeadlockProfileTeamPlayerStats>;
  steamAccount: DeadlockProfileSteamAccountInfo;
};

export type DeadlockProfileTeamPlayerItem = {
  __typename?: 'DeadlockProfileTeamPlayerItem';
  item: DeadlockItem;
};

export type DeadlockProfileTeamPlayerStats = {
  __typename?: 'DeadlockProfileTeamPlayerStats';
  assists: Scalars['Int'];
  deaths: Scalars['Int'];
  denies: Scalars['Int'];
  heroDamage: Scalars['Int'];
  kills: Scalars['Int'];
  lastHits: Scalars['Int'];
  netWorth: Scalars['Int'];
};

export type DeadlockProfilesQuery = {
  __typename?: 'DeadlockProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: DeadlockProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type DeadlockProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type DeadlockQuery = {
  __typename?: 'DeadlockQuery';
  documents?: Maybe<DeadlockDocumentsQuery>;
  gameData?: Maybe<DeadlockGameDataQuery>;
  gameProfile: DeadlockGameProfilePayload;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  /** @deprecated Use `gameProfile` instead */
  profile?: Maybe<DeadlockProfileQuery>;
  profiles?: Maybe<DeadlockProfilesQuery>;
  search?: Maybe<DeadlockSearchResultPayload>;
  settings?: Maybe<NgfGameSettings>;
  stats?: Maybe<DeadlockStatsQuery>;
};

export type DeadlockQuerygameProfileArgs = {
  filter: DeadlockGameProfileFilter;
};

export type DeadlockQuerysearchArgs = {
  query: Scalars['String'];
  top?: InputMaybe<Scalars['Int']>;
};

export type DeadlockRank = DeadlockGameEntity & {
  __typename?: 'DeadlockRank';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type DeadlockRanksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type DeadlockRanksResult = {
  __typename?: 'DeadlockRanksResult';
  data?: Maybe<Array<DeadlockRank>>;
  error?: Maybe<DeadlockStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type DeadlockSearchResultPayload = {
  __typename?: 'DeadlockSearchResultPayload';
  players?: Maybe<Array<DeadlockProfileSteamAccountInfo>>;
};

export enum DeadlockStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type DeadlockStatsBadRequestError = DeadlockStatsError & {
  __typename?: 'DeadlockStatsBadRequestError';
  message?: Maybe<Scalars['String']>;
};

export type DeadlockStatsCursorPage = {
  count: Scalars['Int'];
  cursor?: InputMaybe<Scalars['String']>;
};

export type DeadlockStatsCursorPaginationInfo = {
  __typename?: 'DeadlockStatsCursorPaginationInfo';
  cursor: Scalars['String'];
  hasMoreItems: Scalars['Boolean'];
};

export type DeadlockStatsError = {
  message?: Maybe<Scalars['String']>;
};

export type DeadlockStatsHeroCounter = {
  __typename?: 'DeadlockStatsHeroCounter';
  hero?: Maybe<DeadlockHero>;
  winRate: Scalars['Float'];
  /** @deprecated Use `winRate` instead, already in percent */
  winRateFactor: Scalars['Float'];
};

export type DeadlockStatsHeroCountersData = {
  __typename?: 'DeadlockStatsHeroCountersData';
  counters: Array<DeadlockStatsHeroCounter>;
  hero?: Maybe<DeadlockHero>;
  winRate: Scalars['Float'];
};

export type DeadlockStatsInternalError = DeadlockStatsError & {
  __typename?: 'DeadlockStatsInternalError';
  message?: Maybe<Scalars['String']>;
};

export type DeadlockStatsNotFoundError = DeadlockStatsError & {
  __typename?: 'DeadlockStatsNotFoundError';
  message?: Maybe<Scalars['String']>;
};

export type DeadlockStatsQuery = {
  __typename?: 'DeadlockStatsQuery';
  builds: DeadlockDynamicBuildsPayload;
  heroCounters: Array<DeadlockStatsHeroCountersData>;
  heroTierList: Array<DeadlockHeroStatsData>;
  synergies: DeadlockStatsSynergiesPayload;
};

export type DeadlockStatsQuerybuildsArgs = {
  filter: DeadlockDynamicBuildsFilter;
};

export type DeadlockStatsQueryheroTierListArgs = {
  filter?: InputMaybe<DeadlockHeroTierListFilter>;
};

export type DeadlockStatsQuerysynergiesArgs = {
  filter: DeadlockStatsSynergiesFilter;
  page: DeadlockStatsCursorPage;
};

export type DeadlockStatsSynergiesFilter = {
  heroID?: InputMaybe<Scalars['Int']>;
};

export type DeadlockStatsSynergiesPayload = {
  __typename?: 'DeadlockStatsSynergiesPayload';
  data: Array<DeadlockStatsSynergyData>;
  paginationInfo: DeadlockStatsCursorPaginationInfo;
};

export type DeadlockStatsSynergyData = {
  __typename?: 'DeadlockStatsSynergyData';
  avgDenies: Scalars['Float'];
  avgKda: Scalars['Float'];
  avgLastHitPerMinute: Scalars['Float'];
  avgNetWorthPerMinute: Scalars['Float'];
  hero1?: Maybe<DeadlockHero>;
  hero2?: Maybe<DeadlockHero>;
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  winRate: Scalars['Float'];
  winRateFactor: Scalars['Float'];
};

export type DeadlockStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'DeadlockStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<DeadlockDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: DeadlockStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum DeadlockStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type DeadlockStructDocumentCreateInput = {
  document: Scalars['DeadlockStructDocumentInputBase64Json'];
};

export type DeadlockStructDocumentCreatePayload = {
  __typename?: 'DeadlockStructDocumentCreatePayload';
  data?: Maybe<DeadlockStructDocument>;
  error?: Maybe<DeadlockStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockStructDocumentData = NgfStructDocumentData & {
  __typename?: 'DeadlockStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: DeadlockDocumentSeason;
  tags?: Maybe<DeadlockDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum DeadlockStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type DeadlockStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type DeadlockStructDocumentPayload = {
  __typename?: 'DeadlockStructDocumentPayload';
  data?: Maybe<DeadlockStructDocument>;
  error?: Maybe<DeadlockStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type DeadlockStructDocumentSetSeoPayload = {
  __typename?: 'DeadlockStructDocumentSetSeoPayload';
  data?: Maybe<DeadlockStructDocument>;
  error?: Maybe<DeadlockStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type DeadlockStructDocumentSetStatusPayload = {
  __typename?: 'DeadlockStructDocumentSetStatusPayload';
  data?: Maybe<DeadlockStructDocument>;
  error?: Maybe<DeadlockStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockStructDocumentUpdateInput = {
  document: Scalars['DeadlockStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type DeadlockStructDocumentUpdatePayload = {
  __typename?: 'DeadlockStructDocumentUpdatePayload';
  data?: Maybe<DeadlockStructDocument>;
  error?: Maybe<DeadlockStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type DeadlockTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'DeadlockTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<DeadlockDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: DeadlockTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type DeadlockTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'DeadlockTemplateDocumentData';
  buildVariants?: Maybe<DeadlockUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: DeadlockDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum DeadlockTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockTemplateDocumentInput = {
  type: Scalars['String'];
};

export type DeadlockTemplateDocumentPayload = {
  __typename?: 'DeadlockTemplateDocumentPayload';
  data?: Maybe<DeadlockTemplateDocument>;
  error?: Maybe<DeadlockTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'DeadlockUGDocumentGenericBuilder';
  slots?: Maybe<Array<DeadlockUGDocumentGenericBuilderSlot>>;
};

export type DeadlockUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'DeadlockUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<DeadlockEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type DeadlockUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'DeadlockUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<DeadlockDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: DeadlockUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<DeadlockDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type DeadlockUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'DeadlockUserGeneratedDocumentBuildVariant';
  abilityPoints?: Maybe<Array<DeadlockEntityObject>>;
  genericBuilder: DeadlockUGDocumentGenericBuilder;
  heroAbilities?: Maybe<Array<DeadlockHeroAbility>>;
  id: Scalars['ID'];
};

export type DeadlockUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'DeadlockUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<DeadlockUserGeneratedDocumentBuildVariant>>;
};

export enum DeadlockUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type DeadlockUserGeneratedDocumentCreateInput = {
  document: Scalars['DeadlockUserGeneratedDocumentInputBase64Json'];
};

export type DeadlockUserGeneratedDocumentCreatePayload = {
  __typename?: 'DeadlockUserGeneratedDocumentCreatePayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'DeadlockUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<DeadlockUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: DeadlockDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum DeadlockUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type DeadlockUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type DeadlockUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type DeadlockUserGeneratedDocumentPayload = {
  __typename?: 'DeadlockUserGeneratedDocumentPayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type DeadlockUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'DeadlockUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type DeadlockUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type DeadlockUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'DeadlockUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type DeadlockUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'DeadlockUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type DeadlockUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'DeadlockUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type DeadlockUserGeneratedDocumentUpdateInput = {
  document: Scalars['DeadlockUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type DeadlockUserGeneratedDocumentUpdatePayload = {
  __typename?: 'DeadlockUserGeneratedDocumentUpdatePayload';
  data?: Maybe<DeadlockUserGeneratedDocument>;
  error?: Maybe<DeadlockUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type DeadlockUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type DeadlockValue = {
  __typename?: 'DeadlockValue';
  slug: Scalars['String'];
  stat?: Maybe<DeadlockItemStat>;
  value?: Maybe<Scalars['String']>;
};

export type DeadlockWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'DeadlockWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<DeadlockDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: DeadlockWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<DeadlockDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type DeadlockWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'DeadlockWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: DeadlockEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum DeadlockWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type DeadlockWikiDocumentPayload = {
  __typename?: 'DeadlockWikiDocumentPayload';
  data?: Maybe<DeadlockWikiDocument>;
  error?: Maybe<DeadlockWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type DeadlockWikiDocumentSetSeoPayload = {
  __typename?: 'DeadlockWikiDocumentSetSeoPayload';
  data?: Maybe<DeadlockWikiDocument>;
  error?: Maybe<DeadlockWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum DeadlockWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type DeadlockWikiDocumentUpdateInput = {
  document: Scalars['DeadlockWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type DeadlockWikiDocumentUpdatePayload = {
  __typename?: 'DeadlockWikiDocumentUpdatePayload';
  data?: Maybe<DeadlockWikiDocument>;
  error?: Maybe<DeadlockWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeadlockWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type DeadlockWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Destiny2NgfDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'Destiny2NgfDocumentCmWidgetV1';
  data: Destiny2NgfDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Destiny2NgfDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'Destiny2NgfDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Destiny2NgfDocumentContent =
  | Destiny2NgfDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type Destiny2NgfDocumentSeason = NgfDocumentSeason & {
  __typename?: 'Destiny2NgfDocumentSeason';
  slug: Scalars['String'];
};

export type Destiny2NgfDocumentTags = NgfDocumentTags & {
  __typename?: 'Destiny2NgfDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type Destiny2NgfDocumentsMutation = {
  __typename?: 'Destiny2NgfDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: Destiny2NgfStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: Destiny2NgfStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: Destiny2NgfStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: Destiny2NgfStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: Destiny2NgfUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: Destiny2NgfUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: Destiny2NgfUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: Destiny2NgfUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: Destiny2NgfUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: Destiny2NgfUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: Destiny2NgfWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: Destiny2NgfWikiDocumentUpdatePayload;
};

export type Destiny2NgfDocumentsMutationstructDocumentCreateArgs = {
  input: Destiny2NgfStructDocumentCreateInput;
};

export type Destiny2NgfDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Destiny2NgfDocumentsMutationstructDocumentSetStatusArgs = {
  input: Destiny2NgfStructDocumentSetStatusInput;
};

export type Destiny2NgfDocumentsMutationstructDocumentUpdateArgs = {
  input: Destiny2NgfStructDocumentUpdateInput;
};

export type Destiny2NgfDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: Destiny2NgfUserGeneratedDocumentCreateInput;
};

export type Destiny2NgfDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: Destiny2NgfUserGeneratedDocumentSetFavoriteInput;
};

export type Destiny2NgfDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: Destiny2NgfUserGeneratedDocumentSetFeaturedInput;
};

export type Destiny2NgfDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Destiny2NgfDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: Destiny2NgfUserGeneratedDocumentSetStatusInput;
};

export type Destiny2NgfDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: Destiny2NgfUserGeneratedDocumentUpdateInput;
};

export type Destiny2NgfDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type Destiny2NgfDocumentsMutationwikiDocumentUpdateArgs = {
  input: Destiny2NgfWikiDocumentUpdateInput;
};

export type Destiny2NgfDocumentsQuery = {
  __typename?: 'Destiny2NgfDocumentsQuery';
  previewDocumentContent: Destiny2NgfPreviewDocumentContentPayload;
  structDocumentBySlug: Destiny2NgfStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: Destiny2NgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: Destiny2NgfUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: Destiny2NgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: Destiny2NgfUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: Destiny2NgfTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: Destiny2NgfWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type Destiny2NgfDocumentsQuerypreviewDocumentContentArgs = {
  input: Destiny2NgfPreviewDocumentContentInput;
};

export type Destiny2NgfDocumentsQuerystructDocumentBySlugArgs = {
  input: Destiny2NgfStructDocumentInputBySlug;
};

export type Destiny2NgfDocumentsQuerystructDocumentsArgs = {
  input: Destiny2NgfStructDocumentsInput;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: Destiny2NgfUserGeneratedDocumentInputById;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: Destiny2NgfUserGeneratedDocumentInputBySlug;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: Destiny2NgfTemplateDocumentInput;
};

export type Destiny2NgfDocumentsQueryuserGeneratedDocumentsArgs = {
  input: Destiny2NgfUserGeneratedDocumentsListInput;
  page: Destiny2NgfUserGeneratedDocumentsListPage;
};

export type Destiny2NgfDocumentsQuerywikiDocumentArgs = {
  input: Destiny2NgfWikiDocumentInput;
};

export type Destiny2NgfDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<Destiny2NgfWikiDocumentsListInput>;
  page: Destiny2NgfWikiDocumentsListPage;
};

export type Destiny2NgfEntityObject = NGFEntityObject & {
  __typename?: 'Destiny2NgfEntityObject';
  color?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Destiny2NgfMutation = {
  __typename?: 'Destiny2NgfMutation';
  documents?: Maybe<Destiny2NgfDocumentsMutation>;
  id: Scalars['ID'];
};

export enum Destiny2NgfPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfPreviewDocumentContentInput = {
  content: Scalars['Destiny2NgfDocumentContentInputBase64Json'];
};

export type Destiny2NgfPreviewDocumentContentPayload = {
  __typename?: 'Destiny2NgfPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<Destiny2NgfDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<Destiny2NgfPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfProfile = NgfProfile & {
  __typename?: 'Destiny2NgfProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type Destiny2NgfProfileuserGeneratedDocumentsArgs = {
  input: Destiny2NgfUserGeneratedDocumentsListInput;
  page: Destiny2NgfUserGeneratedDocumentsListPage;
};

export type Destiny2NgfProfilePayload = {
  __typename?: 'Destiny2NgfProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<Destiny2NgfProfile>;
};

export type Destiny2NgfProfilesQuery = {
  __typename?: 'Destiny2NgfProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: Destiny2NgfProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type Destiny2NgfProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type Destiny2NgfQuery = {
  __typename?: 'Destiny2NgfQuery';
  documents?: Maybe<Destiny2NgfDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<Destiny2NgfProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
};

export type Destiny2NgfStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'Destiny2NgfStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Destiny2NgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Destiny2NgfStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum Destiny2NgfStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Destiny2NgfStructDocumentCreateInput = {
  document: Scalars['Destiny2NgfStructDocumentInputBase64Json'];
};

export type Destiny2NgfStructDocumentCreatePayload = {
  __typename?: 'Destiny2NgfStructDocumentCreatePayload';
  data?: Maybe<Destiny2NgfStructDocument>;
  error?: Maybe<Destiny2NgfStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfStructDocumentData = NgfStructDocumentData & {
  __typename?: 'Destiny2NgfStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Destiny2NgfDocumentSeason;
  tags?: Maybe<Destiny2NgfDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum Destiny2NgfStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Destiny2NgfStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Destiny2NgfStructDocumentPayload = {
  __typename?: 'Destiny2NgfStructDocumentPayload';
  data?: Maybe<Destiny2NgfStructDocument>;
  error?: Maybe<Destiny2NgfStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Destiny2NgfStructDocumentSetSeoPayload = {
  __typename?: 'Destiny2NgfStructDocumentSetSeoPayload';
  data?: Maybe<Destiny2NgfStructDocument>;
  error?: Maybe<Destiny2NgfStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type Destiny2NgfStructDocumentSetStatusPayload = {
  __typename?: 'Destiny2NgfStructDocumentSetStatusPayload';
  data?: Maybe<Destiny2NgfStructDocument>;
  error?: Maybe<Destiny2NgfStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfStructDocumentUpdateInput = {
  document: Scalars['Destiny2NgfStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Destiny2NgfStructDocumentUpdatePayload = {
  __typename?: 'Destiny2NgfStructDocumentUpdatePayload';
  data?: Maybe<Destiny2NgfStructDocument>;
  error?: Maybe<Destiny2NgfStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type Destiny2NgfTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'Destiny2NgfTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<Destiny2NgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: Destiny2NgfTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type Destiny2NgfTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'Destiny2NgfTemplateDocumentData';
  buildVariants?: Maybe<Destiny2NgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Destiny2NgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Destiny2NgfTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfTemplateDocumentInput = {
  type: Scalars['String'];
};

export type Destiny2NgfTemplateDocumentPayload = {
  __typename?: 'Destiny2NgfTemplateDocumentPayload';
  data?: Maybe<Destiny2NgfTemplateDocument>;
  error?: Maybe<Destiny2NgfTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'Destiny2NgfUGDocumentGenericBuilder';
  slots?: Maybe<Array<Destiny2NgfUGDocumentGenericBuilderSlot>>;
};

export type Destiny2NgfUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'Destiny2NgfUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<Destiny2NgfEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type Destiny2NgfUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'Destiny2NgfUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<Destiny2NgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Destiny2NgfUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<Destiny2NgfDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Destiny2NgfUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'Destiny2NgfUserGeneratedDocumentBuildVariant';
  genericBuilder: Destiny2NgfUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type Destiny2NgfUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'Destiny2NgfUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<Destiny2NgfUserGeneratedDocumentBuildVariant>>;
};

export enum Destiny2NgfUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Destiny2NgfUserGeneratedDocumentCreateInput = {
  document: Scalars['Destiny2NgfUserGeneratedDocumentInputBase64Json'];
};

export type Destiny2NgfUserGeneratedDocumentCreatePayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentCreatePayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'Destiny2NgfUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<Destiny2NgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Destiny2NgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Destiny2NgfUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Destiny2NgfUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Destiny2NgfUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Destiny2NgfUserGeneratedDocumentPayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentPayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type Destiny2NgfUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Destiny2NgfUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type Destiny2NgfUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Destiny2NgfUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type Destiny2NgfUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Destiny2NgfUserGeneratedDocumentUpdateInput = {
  document: Scalars['Destiny2NgfUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Destiny2NgfUserGeneratedDocumentUpdatePayload = {
  __typename?: 'Destiny2NgfUserGeneratedDocumentUpdatePayload';
  data?: Maybe<Destiny2NgfUserGeneratedDocument>;
  error?: Maybe<Destiny2NgfUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type Destiny2NgfUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Destiny2NgfWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'Destiny2NgfWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Destiny2NgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Destiny2NgfWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<Destiny2NgfDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Destiny2NgfWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'Destiny2NgfWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: Destiny2NgfEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum Destiny2NgfWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Destiny2NgfWikiDocumentPayload = {
  __typename?: 'Destiny2NgfWikiDocumentPayload';
  data?: Maybe<Destiny2NgfWikiDocument>;
  error?: Maybe<Destiny2NgfWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Destiny2NgfWikiDocumentSetSeoPayload = {
  __typename?: 'Destiny2NgfWikiDocumentSetSeoPayload';
  data?: Maybe<Destiny2NgfWikiDocument>;
  error?: Maybe<Destiny2NgfWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Destiny2NgfWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Destiny2NgfWikiDocumentUpdateInput = {
  document: Scalars['Destiny2NgfWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type Destiny2NgfWikiDocumentUpdatePayload = {
  __typename?: 'Destiny2NgfWikiDocumentUpdatePayload';
  data?: Maybe<Destiny2NgfWikiDocument>;
  error?: Maybe<Destiny2NgfWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Destiny2NgfWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type Destiny2NgfWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type DestinyAbilityInput = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type DestinyAmmoType = {
  __typename?: 'DestinyAmmoType';
  color?: Maybe<Scalars['DestinyHexColor']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DestinyAmmoTypeOrError = DestinyAmmoType | DestinyGenericError;

export type DestinyAppSettings = {
  __typename?: 'DestinyAppSettings';
  currentPromoPupupIds?: Maybe<Array<Scalars['ID']>>;
  currentReleaseNoteIds?: Maybe<Array<Scalars['ID']>>;
  currentTopBannerIds?: Maybe<Array<Scalars['ID']>>;
  promoPopups?: Maybe<Array<DestinyPromoPopupOrError>>;
  releaseNotes?: Maybe<Array<DestinyReleaseNoteOrError>>;
  season?: Maybe<Scalars['String']>;
  topBanners?: Maybe<Array<DestinyTopBannerOrError>>;
};

export type DestinyAppSettingsOrError = DestinyAppSettings | DestinyGenericError;

export type DestinyArmorInput = {
  id: Scalars['ID'];
};

export type DestinyArtifact = {
  __typename?: 'DestinyArtifact';
  description: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  perks?: Maybe<Array<DestinyArtifactPerk>>;
  type: Scalars['String'];
};

export type DestinyArtifactInput = {
  id: Scalars['ID'];
};

export type DestinyArtifactPerk = {
  __typename?: 'DestinyArtifactPerk';
  description: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type DestinyArtifactPerkV2Input = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type DestinyArtifactPerksInput = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type DestinyArtifactsPayload = {
  __typename?: 'DestinyArtifactsPayload';
  data?: Maybe<Array<DestinyArtifact>>;
  error?: Maybe<DestinyGenericError>;
};

export type DestinyAspectInput = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type DestinyAssignedArtifactPerk = {
  __typename?: 'DestinyAssignedArtifactPerk';
  perk: DestinyArtifactPerk;
  position: Scalars['Int'];
};

export type DestinyAssignedItem = {
  __typename?: 'DestinyAssignedItem';
  item: DestinyItem;
  position: Scalars['Int'];
};

export type DestinyAssignedPerk = {
  __typename?: 'DestinyAssignedPerk';
  perk: DestinyItem;
  position: Scalars['Int'];
};

export type DestinyAssignedStatsPriority = {
  __typename?: 'DestinyAssignedStatsPriority';
  isEnhanced?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  stat: DestinyStat;
};

export type DestinyAssignedWeapon = {
  __typename?: 'DestinyAssignedWeapon';
  perks?: Maybe<Array<Maybe<DestinyAssignedPerk>>>;
  slotType: DestinyBuilderSlotType;
  weapon: DestinyItem;
};

export type DestinyAuthor = {
  __typename?: 'DestinyAuthor';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  socialLinks?: Maybe<Array<DestinyAuthorSocialLinkOrError>>;
};

export type DestinyAuthorLink = {
  __typename?: 'DestinyAuthorLink';
  network?: Maybe<DestinySocialLinkType>;
  url?: Maybe<Scalars['String']>;
};

export type DestinyAuthorOrError = DestinyAuthor | DestinyGenericError | DestinyNotFoundError;

export type DestinyAuthorSocialLink = {
  __typename?: 'DestinyAuthorSocialLink';
  link?: Maybe<Scalars['DestinyUrl']>;
  type?: Maybe<DestinySocialLinkType>;
};

export type DestinyAuthorSocialLinkOrError = DestinyAuthorSocialLink | DestinyGenericError;

export type DestinyAuthorV2 = {
  __typename?: 'DestinyAuthorV2';
  id: Scalars['ID'];
  links?: Maybe<Array<DestinyAuthorLink>>;
  name?: Maybe<Scalars['String']>;
  twitch?: Maybe<Twitch>;
  user?: Maybe<User>;
};

export type DestinyAuthorsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type DestinyBucketType = {
  __typename?: 'DestinyBucketType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyBucketTypeOrError = DestinyBucketType | DestinyGenericError;

export type DestinyBuild = {
  __typename?: 'DestinyBuild';
  abilityItems?: Maybe<Array<DestinyItemOrError>>;
  armMods?: Maybe<Array<DestinyItemOrError>>;
  armor?: Maybe<DestinyItemOrError>;
  armorDescription?: Maybe<Scalars['String']>;
  artifactItems?: Maybe<Array<DestinyItemOrError>>;
  aspectItems?: Maybe<Array<DestinyItemOrError>>;
  author?: Maybe<DestinyAuthorOrError>;
  buildType?: Maybe<DestinyBuildTypeOrError>;
  chestMods?: Maybe<Array<DestinyItemOrError>>;
  class?: Maybe<DestinyClassOrError>;
  classItems?: Maybe<Array<DestinyItemOrError>>;
  damageType?: Maybe<DestinyDamageTypeOrError>;
  fragmentItems?: Maybe<Array<DestinyItemOrError>>;
  gameplayLoopDescription?: Maybe<Scalars['String']>;
  headMods?: Maybe<Array<DestinyItemOrError>>;
  howItWorksDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isFeatured?: Maybe<Scalars['Boolean']>;
  legsMods?: Maybe<Array<DestinyItemOrError>>;
  name?: Maybe<Scalars['String']>;
  screenshot?: Maybe<Scalars['DestinyUrl']>;
  statsPriority?: Maybe<Array<DestinyPrioritizedStatOrError>>;
  superItems?: Maybe<Array<DestinyItemOrError>>;
  video?: Maybe<Scalars['DestinyUrl']>;
  weapons?: Maybe<Array<DestinyDescribedItemOrError>>;
};

export type DestinyBuildFilter = {
  buildTypes?: InputMaybe<Array<Scalars['ID']>>;
  classes?: InputMaybe<Array<Scalars['ID']>>;
  damageTypes?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
};

/** Filter for getting single build */
export type DestinyBuildFilterV2 = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type DestinyBuildListPage = {
  __typename?: 'DestinyBuildListPage';
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyBuildListPageOrError = DestinyBuildListPage | DestinyGenericError;

export type DestinyBuildPage = {
  __typename?: 'DestinyBuildPage';
  communityWidgetLinkText?: Maybe<Scalars['String']>;
  communityWidgetLinkUrl?: Maybe<Scalars['DestinyUrl']>;
  communityWidgetText?: Maybe<Scalars['String']>;
  communityWidgetTitle?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyBuildPageOrError = DestinyBuildPage | DestinyGenericError;

export type DestinyBuildPagination = {
  __typename?: 'DestinyBuildPagination';
  builds?: Maybe<Array<DestinyBuild>>;
  pageInfo?: Maybe<DestinyPaginationInfo>;
};

export type DestinyBuildPaginationOrError = DestinyBuildPagination | DestinyGenericError;

export type DestinyBuildPayload = {
  __typename?: 'DestinyBuildPayload';
  build?: Maybe<DestinyBuildV2>;
  error?: Maybe<DestinyCustomBuildPayloadError>;
};

export type DestinyBuildTag = {
  __typename?: 'DestinyBuildTag';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DestinyBuildType = {
  __typename?: 'DestinyBuildType';
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyBuildTypeOrError = DestinyBuildType | DestinyGenericError;

export type DestinyBuildV2 = {
  __typename?: 'DestinyBuildV2';
  abilities?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  /** @deprecated No longer supported */
  armor?: Maybe<DestinyItem>;
  artifact?: Maybe<DestinyArtifact>;
  /** @deprecated No longer supported */
  artifactPerks?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  /** Use artifactPerksV2 instead. These reference DestinyItem, not the artifact's own perks. */
  artifactPerksV2?: Maybe<Array<Maybe<DestinyAssignedArtifactPerk>>>;
  aspects?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  author: DestinyAuthorV2;
  buildType?: Maybe<DestinyBuildType>;
  chestArmor?: Maybe<DestinyItem>;
  chestMods?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  class: DestinyClass;
  classItemArmor?: Maybe<DestinyItem>;
  classItemMods?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  createdAt: Scalars['DestinyDateTime'];
  dimLink?: Maybe<Scalars['DestinyUrl']>;
  favoriteCounter: Scalars['Int'];
  fragments?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  gameplayLoop?: Maybe<Scalars['String']>;
  handArmor?: Maybe<DestinyItem>;
  handMods?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  headArmor?: Maybe<DestinyItem>;
  headMods?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  howItWorks?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inDepthExplanation?: Maybe<Array<DestinyInDepthExplanationBlock>>;
  isFavorite: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  legsArmor?: Maybe<DestinyItem>;
  legsMods?: Maybe<Array<Maybe<DestinyAssignedItem>>>;
  metaInfo?: Maybe<MetaInfo>;
  name: Scalars['String'];
  /** Use HeadArmor, HandArmor, ChestArmor, etc fields instead. */
  statsPriority?: Maybe<Array<Maybe<DestinyAssignedStatsPriority>>>;
  strengthsWeaknesses?: Maybe<DestinyStrengthsWeaknesses>;
  subclass: DestinyDamageType;
  superAbility?: Maybe<DestinyItem>;
  tags?: Maybe<Array<Maybe<DestinyBuildTag>>>;
  updatedAt: Scalars['DestinyDateTime'];
  videoGuide?: Maybe<Scalars['DestinyUrl']>;
  weapons?: Maybe<Array<Maybe<DestinyAssignedWeapon>>>;
};

export type DestinyBuilderSettings = {
  __typename?: 'DestinyBuilderSettings';
  artifactPerksAmount: Scalars['Int'];
  subclassFragmentsAmount: Scalars['Int'];
};

export type DestinyBuilderSlotCategories = {
  __typename?: 'DestinyBuilderSlotCategories';
  categoryIDs?: Maybe<Array<Scalars['ID']>>;
  slotType: DestinyBuilderSlotType;
};

export enum DestinyBuilderSlotType {
  ARMOR = 'ARMOR',
  ARTIFACT_PERKS = 'ARTIFACT_PERKS',
  CHEST = 'CHEST',
  CHEST_ARMOR = 'CHEST_ARMOR',
  CLASS_ITEM = 'CLASS_ITEM',
  CLASS_ITEM_ARMOR = 'CLASS_ITEM_ARMOR',
  HANDS = 'HANDS',
  HANDS_ARMOR = 'HANDS_ARMOR',
  HEAD = 'HEAD',
  HEAD_ARMOR = 'HEAD_ARMOR',
  LEGS = 'LEGS',
  LEGS_ARMOR = 'LEGS_ARMOR',
  SUBCLASS = 'SUBCLASS',
  WEAPON_ENERGY = 'WEAPON_ENERGY',
  WEAPON_KINETIC = 'WEAPON_KINETIC',
  WEAPON_POWER = 'WEAPON_POWER',
}

/** Filter for getting list of builds */
export type DestinyBuildsListFilter = {
  armorId?: InputMaybe<Scalars['ID']>;
  /**
   * Creator of the build (User) IDs.
   * 1. empty - means any author.
   * 2. 'me' means current logged in user
   * 3. UUID means specific user
   */
  author?: InputMaybe<Scalars['String']>;
  buildType?: InputMaybe<Scalars['ID']>;
  class?: InputMaybe<Scalars['ID']>;
  /** Featured builds you can see only if meta builds are provided */
  featuredBuilds?: InputMaybe<Scalars['Boolean']>;
  /**
   * 1. empty means do not consider favorite status.
   * 2. false == empty
   * 3. true - also include deleted (validate - author MUST BE 'me')
   */
  isFavourite?: InputMaybe<Scalars['Boolean']>;
  /**
   * 1. empty means all (published and unpublished)
   * 2. if false - validate, author must be 'me'
   */
  isPublished?: InputMaybe<Scalars['Boolean']>;
  /** Show only meta builds */
  metaBuilds?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the date build was first time published. Empty value returns all records */
  publishedDuring?: InputMaybe<DestinyTimeframe>;
  subClass?: InputMaybe<Scalars['ID']>;
  /** Filter by tags. Multiple tags are treated as AND. Build will be returned if it matches all tags */
  tags?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter builds by author username. If both `author` and `username` are
   * provided and the username resolves to a user, the resolved user ID
   * overrides `author`.
   */
  username?: InputMaybe<Scalars['String']>;
  weaponId?: InputMaybe<Scalars['ID']>;
};

export type DestinyBuildsListPayload = {
  __typename?: 'DestinyBuildsListPayload';
  author?: Maybe<DestinyAuthorV2>;
  builds?: Maybe<Array<DestinyBuildV2>>;
  error?: Maybe<DestinyCustomBuildsListPayloadError>;
  pageInfo?: Maybe<DestinyCursorPaginationInfo>;
};

export enum DestinyBuildsListSortingOption {
  DEFAULT = 'DEFAULT',
  IS_FEATURED = 'IS_FEATURED',
  /** Sort by first published date */
  NEW = 'NEW',
  /** Sort by favorites count */
  TOP = 'TOP',
  /** Sort by trending index */
  TRENDING = 'TRENDING',
}

export type DestinyBuildsListSortingOptions = {
  option?: DestinyBuildsListSortingOption;
};

export type DestinyCatalystPerk = {
  __typename?: 'DestinyCatalystPerk';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  isDisplayable?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyCatalystPerkOrError = DestinyCatalystPerk | DestinyGenericError;

export type DestinyCategory = {
  __typename?: 'DestinyCategory';
  ammoType?: Maybe<Array<DestinyAmmoTypeOrError>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  pluralTitle?: Maybe<Scalars['String']>;
  shortTitle?: Maybe<Scalars['String']>;
};

export type DestinyCategoryOrError = DestinyCategory | DestinyGenericError;

export type DestinyClass = {
  __typename?: 'DestinyClass';
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyClassOrError = DestinyClass | DestinyGenericError;

export type DestinyCommonBuildData = {
  abilities?: InputMaybe<Array<InputMaybe<DestinyAbilityInput>>>;
  artifact?: InputMaybe<DestinyArtifactInput>;
  /** Use artifactPerksV2 instead. These reference DestinyItem, not the artifact's own perks. */
  artifactPerksV2?: InputMaybe<Array<InputMaybe<DestinyArtifactPerkV2Input>>>;
  aspects?: InputMaybe<Array<InputMaybe<DestinyAspectInput>>>;
  buildType?: InputMaybe<Scalars['ID']>;
  chestArmor?: InputMaybe<DestinyArmorInput>;
  chestMods?: InputMaybe<Array<InputMaybe<DestinyGearModInput>>>;
  classID: Scalars['ID'];
  classItemArmor?: InputMaybe<DestinyArmorInput>;
  classItemMods?: InputMaybe<Array<InputMaybe<DestinyGearModInput>>>;
  dimLink?: InputMaybe<Scalars['DestinyUrl']>;
  fragments?: InputMaybe<Array<InputMaybe<DestinyFragmentInput>>>;
  gameplayLoop?: InputMaybe<Scalars['String']>;
  handArmor?: InputMaybe<DestinyArmorInput>;
  handMods?: InputMaybe<Array<InputMaybe<DestinyGearModInput>>>;
  headArmor?: InputMaybe<DestinyArmorInput>;
  headMods?: InputMaybe<Array<InputMaybe<DestinyGearModInput>>>;
  howItWorks?: InputMaybe<Scalars['String']>;
  inDepthExplanation?: InputMaybe<Array<DestinyInDepthExplanationBlockInput>>;
  legsArmor?: InputMaybe<DestinyArmorInput>;
  legsMods?: InputMaybe<Array<InputMaybe<DestinyGearModInput>>>;
  /** Use HeadArmor, HandArmor, ChestArmor, etc fields instead. */
  statsPriority?: InputMaybe<Array<InputMaybe<DestinyStatsPriorityInput>>>;
  strengthsWeaknesses?: InputMaybe<DestinyStrengthsWeaknessesInput>;
  subClassID: Scalars['ID'];
  superAbility?: InputMaybe<DestinyAbilityInput>;
  videoGuide?: InputMaybe<Scalars['DestinyUrl']>;
  weapons?: InputMaybe<Array<InputMaybe<DestinyWeaponInput>>>;
};

export type DestinyCreateBuildInput = {
  common: DestinyCommonBuildData;
  name: Scalars['String'];
  publish?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['ID']>>;
};

export type DestinyCreateBuildPayload = {
  __typename?: 'DestinyCreateBuildPayload';
  build?: Maybe<DestinyBuildV2>;
  error?: Maybe<DestinyCustomBuildPayloadError>;
};

export type DestinyCreateBuildPayloadError = DestinyGenericError;

export type DestinyCursorPage = {
  count?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
};

export type DestinyCursorPaginationInfo = {
  __typename?: 'DestinyCursorPaginationInfo';
  cursor?: Maybe<Scalars['String']>;
  hasMoreItems?: Maybe<Scalars['Boolean']>;
};

export type DestinyCustomBuildPayloadError = DestinyGenericError | DestinyNotFoundError;

export type DestinyCustomBuildsListPayloadError = DestinyGenericError;

export type DestinyDamageType = {
  __typename?: 'DestinyDamageType';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  transperentIconUrl?: Maybe<Scalars['DestinyUrl']>;
};

export type DestinyDamageTypeOrError = DestinyDamageType | DestinyGenericError;

export type DestinyDefinitions = {
  __typename?: 'DestinyDefinitions';
  buildTypes?: Maybe<Array<DestinyBuildTypeOrError>>;
  builderSettings: DestinyBuilderSettings;
  /** Mapping between builder slots on UI to Item Categories that fit into this slot */
  builderSlotCategories?: Maybe<Array<DestinyBuilderSlotCategories>>;
  classes?: Maybe<Array<DestinyClassOrError>>;
  damageTypes?: Maybe<Array<DestinyDamageTypeOrError>>;
  statsPriority?: Maybe<Array<DestinyStat>>;
  tags?: Maybe<Array<DestinyBuildTag>>;
  weaponCategories?: Maybe<Array<DestinyCategoryOrError>>;
  weaponSlots?: Maybe<Array<DestinyCategoryOrError>>;
};

export type DestinyDeleteBuildInput = {
  /** ID of the build */
  id: Scalars['ID'];
};

export type DestinyDeleteBuildPayload = {
  __typename?: 'DestinyDeleteBuildPayload';
  error?: Maybe<DestinyCustomBuildPayloadError>;
  success: Scalars['Boolean'];
};

export type DestinyDeleteBuildPayloadError = DestinyGenericError;

export type DestinyDescribedItem = {
  __typename?: 'DestinyDescribedItem';
  description?: Maybe<Scalars['String']>;
  item?: Maybe<DestinyItemOrError>;
  itemSlug?: Maybe<Scalars['String']>;
};

export type DestinyDescribedItemOrError = DestinyDescribedItem | DestinyGenericError;

export type DestinyDimItemsError = DestinyGenericError;

export type DestinyDimItemsFilter = {
  categories?: InputMaybe<Array<Scalars['ID']>>;
  dimLink: Scalars['DestinyUrl'];
};

export type DestinyDimItemsPayload = {
  __typename?: 'DestinyDimItemsPayload';
  error?: Maybe<DestinyDimItemsError>;
  items?: Maybe<Array<DestinyItem>>;
};

export type DestinyDuplicateBuildError = DestinyGenericError | DestinyNotFoundError;

export type DestinyDuplicateBuildInput = {
  /** ID of the build to duplicate */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DestinyDuplicateBuildPayload = {
  __typename?: 'DestinyDuplicateBuildPayload';
  build?: Maybe<DestinyBuildV2>;
  error?: Maybe<DestinyDuplicateBuildError>;
};

export type DestinyEquipmentSlot = {
  __typename?: 'DestinyEquipmentSlot';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyEquipmentSlotOrError = DestinyEquipmentSlot | DestinyGenericError;

export type DestinyError = {
  message?: Maybe<Scalars['String']>;
};

export type DestinyExoticWeaponPage = {
  __typename?: 'DestinyExoticWeaponPage';
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyExoticWeaponPageOrError = DestinyExoticWeaponPage | DestinyGenericError;

export type DestinyFragmentInput = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type DestinyGame = {
  __typename?: 'DestinyGame';
  artifacts?: Maybe<DestinyArtifactsPayload>;
  /** Returns single build. V2 is due to pre existing builds in strapi */
  build?: Maybe<DestinyBuildPayload>;
  builds?: Maybe<DestinyBuildPaginationOrError>;
  /** Returns filtered & paginated list of builds. V2 is due to pre existing builds in strapi */
  buildsV2?: Maybe<DestinyBuildsListPayload>;
  definitions?: Maybe<DestinyDefinitions>;
  dimItems?: Maybe<DestinyDimItemsPayload>;
  id: Scalars['ID'];
  items?: Maybe<DestinyItemPaginationOrError>;
  vendors?: Maybe<Array<DestinyVendorOrError>>;
};

export type DestinyGamebuildArgs = {
  filter?: InputMaybe<DestinyBuildFilterV2>;
};

export type DestinyGamebuildsArgs = {
  filter?: InputMaybe<DestinyBuildFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type DestinyGamebuildsV2Args = {
  filter?: InputMaybe<DestinyBuildsListFilter>;
  page?: InputMaybe<DestinyCursorPage>;
  sort?: InputMaybe<DestinyBuildsListSortingOption>;
};

export type DestinyGamedimItemsArgs = {
  filter?: InputMaybe<DestinyDimItemsFilter>;
};

export type DestinyGameitemsArgs = {
  filter?: InputMaybe<DestinyItemFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type DestinyGamevendorsArgs = {
  filter?: InputMaybe<DestinyVendorFilter>;
};

export type DestinyGearModInput = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type DestinyGenericError = DestinyError & {
  __typename?: 'DestinyGenericError';
  message?: Maybe<Scalars['String']>;
};

export type DestinyHomePage = {
  __typename?: 'DestinyHomePage';
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyHomePageOrError = DestinyGenericError | DestinyHomePage;

export type DestinyInDepthExplanationBlock = {
  __typename?: 'DestinyInDepthExplanationBlock';
  content?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DestinyInDepthExplanationBlockInput = {
  content?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DestinyItem = {
  __typename?: 'DestinyItem';
  alternatives?: Maybe<Array<DestinyItemOrError>>;
  ammoType?: Maybe<DestinyAmmoTypeOrError>;
  ammoTypeV2?: Maybe<DestinyAmmoType>;
  bestInClass?: Maybe<Scalars['Boolean']>;
  bucketType?: Maybe<DestinyBucketTypeOrError>;
  bucketTypeV2?: Maybe<DestinyBucketType>;
  catalystPerks?: Maybe<Array<DestinyCatalystPerkOrError>>;
  categories?: Maybe<Array<DestinyCategoryOrError>>;
  class?: Maybe<DestinyClassOrError>;
  classV2?: Maybe<DestinyClass>;
  damageTypes?: Maybe<Array<DestinyDamageTypeOrError>>;
  /** if it is an Engram (box with drop), then this attribute will contain the items this Engram contains */
  derivedItems?: Maybe<Array<DestinyItemOrError>>;
  description?: Maybe<Scalars['String']>;
  equipmentSlot?: Maybe<DestinyEquipmentSlotOrError>;
  equipmentSlotV2?: Maybe<DestinyEquipmentSlot>;
  flavourText?: Maybe<Scalars['String']>;
  howToGetDescription?: Maybe<Scalars['String']>;
  howToObtainCatalyst?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  iconWatermarkShelvedUrl?: Maybe<Scalars['DestinyUrl']>;
  iconWatermarkUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  /** Stats given by the item (if if is a Weapon Mod/Perk etc.) */
  investmentStats?: Maybe<Array<DestinyValuedInvestmentStatOrError>>;
  itemSet?: Maybe<DestinyItemSet>;
  itemTypeAndTierDisplayName?: Maybe<Scalars['String']>;
  itemTypeDisplayName?: Maybe<Scalars['String']>;
  lore?: Maybe<DestinyLoreOrError>;
  loreV2?: Maybe<DestinyLore>;
  name?: Maybe<Scalars['String']>;
  /**
   * Objective represents how much of some action you have to do to achive the item.
   * Like defeat 400 targets to unlock the weapon
   */
  objectives?: Maybe<Array<DestinyItemObjectiveOrError>>;
  perkCombinations?: Maybe<Array<DestinyPerkCombinationOrError>>;
  pveTier?: Maybe<DestinyTierOrError>;
  pvpTier?: Maybe<DestinyTierOrError>;
  rarity?: Maybe<DestinyRarityOrError>;
  rarityV2?: Maybe<DestinyRarity>;
  screenshotUrl?: Maybe<Scalars['DestinyUrl']>;
  sockets?: Maybe<Array<DestinySocketOrError>>;
  source?: Maybe<Scalars['String']>;
  /** item stats (only for weapons and maybe gear) */
  stats?: Maybe<Array<DestinyValuedStatOrError>>;
  weaponDescription?: Maybe<Scalars['String']>;
};

export type DestinyItemFilter = {
  ammoTypes?: InputMaybe<Array<Scalars['ID']>>;
  bestInClass?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<Scalars['ID']>>;
  classes?: InputMaybe<Array<Scalars['ID']>>;
  damageTypes?: InputMaybe<Array<Scalars['ID']>>;
  equipmentSlots?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  pveTiers?: InputMaybe<Array<Scalars['ID']>>;
  pvpTiers?: InputMaybe<Array<Scalars['ID']>>;
  rarities?: InputMaybe<Array<Scalars['ID']>>;
};

export type DestinyItemObjective = {
  __typename?: 'DestinyItemObjective';
  completionValue?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  progressDescription?: Maybe<Scalars['String']>;
};

export type DestinyItemObjectiveOrError = DestinyGenericError | DestinyItemObjective;

export type DestinyItemOrError = DestinyGenericError | DestinyItem;

export type DestinyItemPagination = {
  __typename?: 'DestinyItemPagination';
  items?: Maybe<Array<DestinyItem>>;
  pageInfo?: Maybe<DestinyPaginationInfo>;
};

export type DestinyItemPaginationOrError = DestinyGenericError | DestinyItemPagination;

export type DestinyItemSet = {
  __typename?: 'DestinyItemSet';
  id: Scalars['ID'];
  name: Scalars['String'];
  setPerks?: Maybe<Array<DestinyItemSetPerk>>;
};

export type DestinyItemSetPerk = {
  __typename?: 'DestinyItemSetPerk';
  description: Scalars['String'];
  iconURL?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  requiredSetCount: Scalars['Int'];
};

export type DestinyLegendaryWeaponPage = {
  __typename?: 'DestinyLegendaryWeaponPage';
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyLegendaryWeaponPageOrError = DestinyGenericError | DestinyLegendaryWeaponPage;

export type DestinyLink = {
  __typename?: 'DestinyLink';
  linkText?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['DestinyUrl']>;
};

export type DestinyLore = {
  __typename?: 'DestinyLore';
  id: Scalars['ID'];
  lore?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
};

export type DestinyLoreOrError = DestinyGenericError | DestinyLore;

export type DestinyMarketing = {
  __typename?: 'DestinyMarketing';
  appSettings?: Maybe<DestinyAppSettingsOrError>;
  promoPopups?: Maybe<Array<DestinyPromoPopupOrError>>;
  releaseNotes?: Maybe<Array<DestinyReleaseNoteOrError>>;
  topBanners?: Maybe<Array<DestinyTopBannerOrError>>;
};

export type DestinyMarketingpromoPopupsArgs = {
  filter?: InputMaybe<DestinyPromoPopupFilter>;
};

export type DestinyMarketingreleaseNotesArgs = {
  filter?: InputMaybe<DestinyReleaseNoteFilter>;
};

export type DestinyMarketingtopBannersArgs = {
  filter?: InputMaybe<DestinyTopBannerFilter>;
};

export type DestinyMutation = {
  __typename?: 'DestinyMutation';
  /** Create custom build with variants for registered user */
  createBuild: DestinyCreateBuildPayload;
  /** Delete custom build of registered user */
  deleteBuild: DestinyDeleteBuildPayload;
  /** Duplicate custom build of registered user */
  duplicateBuild: DestinyDuplicateBuildPayload;
  /** Add/remove custom build to favourites */
  setFavourite: DestinySetFavouritePayload;
  /** Publish/unpublish custom build */
  setPublished: DestinySetPublishedPayload;
  /** Update custom build of registered user */
  updateBuild: DestinyUpdateBuildPayload;
};

export type DestinyMutationcreateBuildArgs = {
  input: DestinyCreateBuildInput;
};

export type DestinyMutationdeleteBuildArgs = {
  input: DestinyDeleteBuildInput;
};

export type DestinyMutationduplicateBuildArgs = {
  input?: InputMaybe<DestinyDuplicateBuildInput>;
};

export type DestinyMutationsetFavouriteArgs = {
  input: DestinySetFavouriteInput;
};

export type DestinyMutationsetPublishedArgs = {
  input: DestinySetPublishedInput;
};

export type DestinyMutationupdateBuildArgs = {
  input: DestinyUpdateBuildInput;
};

export type DestinyNotFoundError = DestinyError & {
  __typename?: 'DestinyNotFoundError';
  message?: Maybe<Scalars['String']>;
};

export type DestinyPages = {
  __typename?: 'DestinyPages';
  buildListPage?: Maybe<DestinyBuildListPageOrError>;
  buildPage?: Maybe<DestinyBuildPageOrError>;
  exoticWeaponPage?: Maybe<DestinyExoticWeaponPageOrError>;
  homePage?: Maybe<DestinyHomePageOrError>;
  legendaryWeaponPage?: Maybe<DestinyLegendaryWeaponPageOrError>;
  tierListPage?: Maybe<DestinyTierListPageOrError>;
  weaponListPage?: Maybe<DestinyWeaponListPageOrError>;
};

export type DestinyPaginationInfo = {
  __typename?: 'DestinyPaginationInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type DestinyPaginationInfoOrError = DestinyGenericError | DestinyPaginationInfo;

export type DestinyPerkCombination = {
  __typename?: 'DestinyPerkCombination';
  alternativePerks?: Maybe<Array<DestinyItemOrError>>;
  componentId?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  name?: Maybe<Scalars['String']>;
  optionalPerks?: Maybe<Array<DestinyItemOrError>>;
  requiredPerks?: Maybe<Array<DestinyItemOrError>>;
};

export type DestinyPerkCombinationOrError = DestinyGenericError | DestinyPerkCombination;

/** Represent possible platforms for the game. Commonly used to separate banners by platform. */
export enum DestinyPlatform {
  DESKTOP = 'DESKTOP',
  WEB = 'WEB',
}

export type DestinyPrioritizedStat = {
  __typename?: 'DestinyPrioritizedStat';
  priority?: Maybe<Scalars['Int']>;
  stat?: Maybe<DestinyStatOrError>;
  statSlug?: Maybe<Scalars['String']>;
};

export type DestinyPrioritizedStatOrError = DestinyGenericError | DestinyPrioritizedStat;

export type DestinyPromoPopup = {
  __typename?: 'DestinyPromoPopup';
  button?: Maybe<DestinyPromoPopupButton>;
  disallowedUserAttributes?: Maybe<Array<DestinyUserAttribute>>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  labelBackground?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['DestinyLocale']>;
  mixpanelName?: Maybe<Scalars['String']>;
  modalBackground?: Maybe<Scalars['String']>;
  platforms?: Maybe<Array<DestinyPlatform>>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userLevels?: Maybe<Array<DestinyUserLevel>>;
  value?: Maybe<Scalars['String']>;
};

export type DestinyPromoPopupButton = {
  __typename?: 'DestinyPromoPopupButton';
  link?: Maybe<Scalars['DestinyUrl']>;
  title?: Maybe<Scalars['String']>;
};

export type DestinyPromoPopupFilter = {
  disallowedUserAttribute?: InputMaybe<DestinyUserAttribute>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  locale?: InputMaybe<Scalars['DestinyLocale']>;
  platform?: InputMaybe<DestinyPlatform>;
  userLevel?: InputMaybe<DestinyUserLevel>;
};

export type DestinyPromoPopupOrError = DestinyGenericError | DestinyPromoPopup;

export type DestinyPromoPopupOrNotFoundError = DestinyGenericError | DestinyNotFoundError | DestinyPromoPopup;

export type DestinyQuery = {
  __typename?: 'DestinyQuery';
  game?: Maybe<DestinyGame>;
  marketing?: Maybe<DestinyMarketing>;
  page?: Maybe<DestinyPages>;
};

export type DestinyRarity = {
  __typename?: 'DestinyRarity';
  color?: Maybe<Scalars['DestinyHexColor']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DestinyRarityOrError = DestinyGenericError | DestinyRarity;

/** Represent a list of changes in the game. Usually comes out with a new patch. */
export type DestinyReleaseNote = {
  __typename?: 'DestinyReleaseNote';
  button?: Maybe<DestinyReleaseNoteButton>;
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['DestinyLocale']>;
  platforms?: Maybe<Array<DestinyPlatform>>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userLevels?: Maybe<Array<DestinyUserLevel>>;
};

export type DestinyReleaseNoteButton = {
  __typename?: 'DestinyReleaseNoteButton';
  link?: Maybe<Scalars['DestinyUrl']>;
  title?: Maybe<Scalars['String']>;
};

export type DestinyReleaseNoteFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  locale?: InputMaybe<Scalars['DestinyLocale']>;
  platform?: InputMaybe<DestinyPlatform>;
  userLevel?: InputMaybe<DestinyUserLevel>;
};

export type DestinyReleaseNoteOrError = DestinyGenericError | DestinyReleaseNote;

export type DestinyReleaseNoteOrNotFoundError = DestinyGenericError | DestinyNotFoundError | DestinyReleaseNote;

/** Metadata for correct page indexing by search engines */
export type DestinySeoMetaData = {
  __typename?: 'DestinySeoMetaData';
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  ogImage?: Maybe<Scalars['DestinyUrl']>;
  title?: Maybe<Scalars['String']>;
};

export type DestinySetFavouriteInput = {
  /** Flag that indicates if build has to be added to favourites */
  favourite: Scalars['Boolean'];
  /** ID of the build */
  id: Scalars['ID'];
};

export type DestinySetFavouritePayload = {
  __typename?: 'DestinySetFavouritePayload';
  error?: Maybe<DestinySetFavouritePayloadError>;
  success: Scalars['Boolean'];
};

export type DestinySetFavouritePayloadError = DestinyGenericError;

export type DestinySetPublishedInput = {
  /** ID of the build */
  id: Scalars['ID'];
  /** Flag that indicates if build has to be published */
  published: Scalars['Boolean'];
};

export type DestinySetPublishedPayload = {
  __typename?: 'DestinySetPublishedPayload';
  error?: Maybe<DestinySetPublishedPayloadError>;
  success: Scalars['Boolean'];
};

export type DestinySetPublishedPayloadError = DestinyGenericError | DestinyNotFoundError;

export type DestinySocialLinkType = {
  __typename?: 'DestinySocialLinkType';
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DestinySocket = {
  __typename?: 'DestinySocket';
  /**
   * The technical field required for 'reusableItems' resolving.
   * ComponentID representing internal Strapi ID for the 'Socket' component.
   */
  componentId?: Maybe<Scalars['Int']>;
  plugSetItems?: Maybe<Array<DestinyItemOrError>>;
  predefinedItem?: Maybe<DestinyItemOrError>;
  /** The technical field required for 'predefinedItem' resolving */
  predefinedItemSlug?: Maybe<Scalars['String']>;
  reusableItems?: Maybe<Array<DestinyItemOrError>>;
  socketType?: Maybe<DestinySocketTypeOrError>;
  /** The technical field required for 'predefinedItem' resolving */
  socketTypeSlug?: Maybe<Scalars['String']>;
};

export type DestinySocketOrError = DestinyGenericError | DestinySocket;

export type DestinySocketType = {
  __typename?: 'DestinySocketType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinySocketTypeOrError = DestinyGenericError | DestinySocketType;

export type DestinyStat = {
  __typename?: 'DestinyStat';
  description?: Maybe<Scalars['String']>;
  displayAsNumeric?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyStatInterpolation = {
  __typename?: 'DestinyStatInterpolation';
  value?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type DestinyStatOrError = DestinyGenericError | DestinyStat;

export type DestinyStatsPriorityInput = {
  isEnhanced?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  statID: Scalars['ID'];
};

export type DestinyStrengthsWeaknesses = {
  __typename?: 'DestinyStrengthsWeaknesses';
  strengths?: Maybe<Array<Scalars['String']>>;
  weaknesses?: Maybe<Array<Scalars['String']>>;
};

export type DestinyStrengthsWeaknessesInput = {
  strengths?: InputMaybe<Array<Scalars['String']>>;
  weaknesses?: InputMaybe<Array<Scalars['String']>>;
};

export type DestinyTier = {
  __typename?: 'DestinyTier';
  color?: Maybe<Scalars['DestinyHexColor']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type DestinyTierListPage = {
  __typename?: 'DestinyTierListPage';
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyTierListPageOrError = DestinyGenericError | DestinyTierListPage;

export type DestinyTierOrError = DestinyGenericError | DestinyTier;

export enum DestinyTimeframe {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

/** Banner which is displayed on the top of the web-page throughout the site. */
export type DestinyTopBanner = {
  __typename?: 'DestinyTopBanner';
  background?: Maybe<Scalars['String']>;
  disallowedUserAttributes?: Maybe<Array<DestinyUserAttribute>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link?: Maybe<DestinyTopBannerLink>;
  locale?: Maybe<Scalars['DestinyLocale']>;
  mixpanelName?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  platforms?: Maybe<Array<DestinyPlatform>>;
  text?: Maybe<Scalars['String']>;
  userLevels?: Maybe<Array<DestinyUserLevel>>;
  withCloseButton?: Maybe<Scalars['Boolean']>;
};

export type DestinyTopBannerFilter = {
  disallowedUserAttribute?: InputMaybe<DestinyUserAttribute>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  locale?: InputMaybe<Scalars['DestinyLocale']>;
  platform?: InputMaybe<DestinyPlatform>;
  userLevel?: InputMaybe<DestinyUserLevel>;
};

export type DestinyTopBannerLink = {
  __typename?: 'DestinyTopBannerLink';
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['DestinyUrl']>;
};

export type DestinyTopBannerOrError = DestinyGenericError | DestinyTopBanner;

export type DestinyTopBannerOrNotFoundError = DestinyGenericError | DestinyNotFoundError | DestinyTopBanner;

export type DestinyUpdateBuildInput = {
  /** UUID of the build */
  id: Scalars['ID'];
  /** New build full data */
  newBuild: DestinyCreateBuildInput;
};

export type DestinyUpdateBuildPayload = {
  __typename?: 'DestinyUpdateBuildPayload';
  build?: Maybe<DestinyBuildV2>;
  error?: Maybe<DestinyCustomBuildPayloadError>;
};

export type DestinyUpdateBuildPayloadError = DestinyGenericError;

/** Represent user attributes. Typically used to display banners to specific user groups. */
export enum DestinyUserAttribute {
  LESSON_PLAN = 'LESSON_PLAN',
}

/** Represent user attributes. Typically used to display banners to specific user levels. */
export enum DestinyUserLevel {
  CARRY = 'CARRY',
  CHURN = 'CHURN',
  COLLECTOR_EDITION = 'COLLECTOR_EDITION',
  GUEST = 'GUEST',
  REGULAR = 'REGULAR',
  SUPPORTER = 'SUPPORTER',
  TRIAL = 'TRIAL',
}

export type DestinyValuedInvestmentStat = {
  __typename?: 'DestinyValuedInvestmentStat';
  stat?: Maybe<DestinyStatOrError>;
  statSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type DestinyValuedInvestmentStatOrError = DestinyGenericError | DestinyValuedInvestmentStat;

export type DestinyValuedStat = {
  __typename?: 'DestinyValuedStat';
  displayMaximum?: Maybe<Scalars['Int']>;
  interpolation?: Maybe<Array<DestinyStatInterpolation>>;
  maximum?: Maybe<Scalars['Int']>;
  minimum?: Maybe<Scalars['Int']>;
  stat?: Maybe<DestinyStatOrError>;
  statSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type DestinyValuedStatOrError = DestinyGenericError | DestinyValuedStat;

export type DestinyVendor = {
  __typename?: 'DestinyVendor';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['DestinyUrl']>;
  id: Scalars['ID'];
  /** items list that vendor contains */
  items?: Maybe<Array<DestinyVendorItemOrError>>;
  name?: Maybe<Scalars['String']>;
};

export type DestinyVendorFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type DestinyVendorItem = {
  __typename?: 'DestinyVendorItem';
  category?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  item?: Maybe<DestinyItemOrError>;
  quantity?: Maybe<Scalars['Int']>;
};

export type DestinyVendorItemOrError = DestinyGenericError | DestinyVendorItem;

export type DestinyVendorOrError = DestinyGenericError | DestinyVendor;

export type DestinyVideo = {
  __typename?: 'DestinyVideo';
  placeholderUrl?: Maybe<Scalars['DestinyUrl']>;
  videoUrl?: Maybe<Scalars['DestinyUrl']>;
};

export type DestinyWeaponInput = {
  id: Scalars['ID'];
  perks?: InputMaybe<Array<DestinyWeaponPerkInput>>;
  /** KINETIC / ENERGY / POWER */
  slotTypeID: Scalars['ID'];
};

export type DestinyWeaponListPage = {
  __typename?: 'DestinyWeaponListPage';
  header?: Maybe<Scalars['String']>;
  metadata?: Maybe<DestinySeoMetaData>;
};

export type DestinyWeaponListPageOrError = DestinyGenericError | DestinyWeaponListPage;

export type DestinyWeaponPerkInput = {
  id: Scalars['ID'];
  position: Scalars['Int'];
};

export type Diablo4BlankStaticEntity = {
  __typename?: 'Diablo4BlankStaticEntity';
  id: Scalars['ID'];
};

export type Diablo4BuildTrackerAffix = {
  __typename?: 'Diablo4BuildTrackerAffix';
  /** Affix stat slug. */
  slug: Scalars['String'];
  /** Modifier type (implicit / gear / tempering / …). */
  type: Scalars['String'];
};

/** How many affixes the build expects for the slot's item and which were recognized from the tooltip. */
export type Diablo4BuildTrackerAffixes = {
  __typename?: 'Diablo4BuildTrackerAffixes';
  /** The recognized affixes. */
  matched: Array<Diablo4BuildTrackerAffix>;
  /** How many of them were recognized from the tooltip. */
  recognized: Scalars['Int'];
  /** Affixes the build recommends for this slot's item. */
  total: Scalars['Int'];
};

/** The tracked build and the recognized identity placed into one of its slots. */
export type Diablo4BuildTrackerBuild = {
  __typename?: 'Diablo4BuildTrackerBuild';
  /** Affix recognition for the slot's item; absent when the build recommends no affixes for it. */
  affixes?: Maybe<Diablo4BuildTrackerAffixes>;
  /** The aspect in the slot, set when the slot's identity is an aspect. */
  aspect?: Maybe<Diablo4BuildTrackerItem>;
  /** Hero class slug, when the build has one. */
  class?: Maybe<Scalars['String']>;
  /** Human-readable build name. */
  name: Scalars['String'];
  slot: Diablo4BuildTrackerSlot;
  /** The unique item in the slot, set when the slot's identity is a unique item. */
  uniqueItem?: Maybe<Diablo4BuildTrackerItem>;
};

export type Diablo4BuildTrackerItem = {
  __typename?: 'Diablo4BuildTrackerItem';
  /** Human-readable title. */
  name: Scalars['String'];
  /** Slug — the stable identity. */
  slug: Scalars['String'];
};

export type Diablo4BuildTrackerPayload = NotificationPayload & {
  __typename?: 'Diablo4BuildTrackerPayload';
  build: Diablo4BuildTrackerBuild;
  type: Scalars['String'];
};

export type Diablo4BuildTrackerSlot = {
  __typename?: 'Diablo4BuildTrackerSlot';
  /** Slot slug (gameSlotSlug) — the undo target. */
  id: Scalars['String'];
  /** Human-readable slot name. */
  name: Scalars['String'];
};

export type Diablo4CustomAuthor = {
  __typename?: 'Diablo4CustomAuthor';
  id: Scalars['ID'];
  twitch?: Maybe<Twitch>;
};

export type Diablo4DocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentCmWidgetV1';
  data: Diablo4DocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Diablo4DocumentContent =
  | Diablo4DocumentCmWidgetV1
  | Diablo4DocumentUgWidgetAssignedSkillsV1
  | Diablo4DocumentUgWidgetLootFilterV1
  | Diablo4DocumentUgWidgetMercenaryV1
  | Diablo4DocumentUgWidgetParagonV1
  | Diablo4DocumentUgWidgetSkillTreeV1
  | Diablo4DocumentUgWidgetSkillTreeV2
  | Diablo4DocumentUgWidgetTrackingV1
  | Diablo4DocumentUgWidgetWarPlansV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type Diablo4DocumentSeason = NgfDocumentSeason & {
  __typename?: 'Diablo4DocumentSeason';
  slug: Scalars['String'];
};

export type Diablo4DocumentTags = NgfDocumentTags & {
  __typename?: 'Diablo4DocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type Diablo4DocumentUgWidgetAssignedSkill = {
  __typename?: 'Diablo4DocumentUgWidgetAssignedSkill';
  position: Scalars['Int'];
  skill: D4Skill;
  weaponArsenalSlot?: Maybe<D4BuildSlot>;
};

export type Diablo4DocumentUgWidgetAssignedSkillsDataV1 = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetAssignedSkillsDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetAssignedSkillsPriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Diablo4DocumentUgWidgetAssignedSkillsPriorityListItem';
  iconURL?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Diablo4DocumentUgWidgetAssignedSkillsV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetAssignedSkillsV1';
  data: Diablo4DocumentUgWidgetAssignedSkillsDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentUgWidgetEquipmentModifierPriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Diablo4DocumentUgWidgetEquipmentModifierPriorityListItem';
  iconURL?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Diablo4DocumentUgWidgetEquipmentPriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Diablo4DocumentUgWidgetEquipmentPriorityListItem';
  iconURL?: Maybe<Scalars['String']>;
  modifiers?: Maybe<Array<Diablo4DocumentUgWidgetEquipmentModifierPriorityListItem>>;
  notes?: Maybe<NgfDocumentRichTextContent>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Diablo4DocumentUgWidgetLootFilterV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetLootFilterV1';
  data: Diablo4DocumentUgWidgetLootFilterV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentUgWidgetLootFilterV1Data = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetLootFilterV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetMercenaryAssignedOpportunity = {
  __typename?: 'Diablo4DocumentUgWidgetMercenaryAssignedOpportunity';
  opportunity?: Maybe<D4Opportunity>;
  skill?: Maybe<D4Skill>;
};

export type Diablo4DocumentUgWidgetMercenaryDataV1 = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetMercenaryDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetMercenaryLeveledMercenarySkill = {
  __typename?: 'Diablo4DocumentUgWidgetMercenaryLeveledMercenarySkill';
  actionType: Diablo4DocumentUgWidgetSkillTreeActionType;
  skill: D4MercenarySkill;
};

export type Diablo4DocumentUgWidgetMercenaryV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetMercenaryV1';
  data: Diablo4DocumentUgWidgetMercenaryDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentUgWidgetParagonDataV1 = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetParagonDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  paragonNodesLimit?: Maybe<Scalars['Int']>;
  renownValue?: Maybe<Scalars['Int']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetParagonGlyphPriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Diablo4DocumentUgWidgetParagonGlyphPriorityListItem';
  iconURL?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Diablo4DocumentUgWidgetParagonV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetParagonV1';
  data: Diablo4DocumentUgWidgetParagonDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export enum Diablo4DocumentUgWidgetSkillTreeActionType {
  ACTIVATE = 'ACTIVATE',
  REFUND = 'REFUND',
}

export type Diablo4DocumentUgWidgetSkillTreeDataV1 = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetSkillTreeDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  maxLevel?: Maybe<Scalars['Int']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetSkillTreeLeveledSkill = {
  __typename?: 'Diablo4DocumentUgWidgetSkillTreeLeveledSkill';
  actionType: Diablo4DocumentUgWidgetSkillTreeActionType;
  skill: D4Skill;
};

export type Diablo4DocumentUgWidgetSkillTreePriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Diablo4DocumentUgWidgetSkillTreePriorityListItem';
  iconURL?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Diablo4DocumentUgWidgetSkillTreeV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetSkillTreeV1';
  data: Diablo4DocumentUgWidgetSkillTreeDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentUgWidgetSkillTreeV2 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetSkillTreeV2';
  data: Diablo4DocumentUgWidgetSkillTreeDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentUgWidgetTrackingDataV1 = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetTrackingDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetTrackingV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetTrackingV1';
  data: Diablo4DocumentUgWidgetTrackingDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentUgWidgetWarPlansDataV1 = NgfDocumentContentData & {
  __typename?: 'Diablo4DocumentUgWidgetWarPlansDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type Diablo4DocumentUgWidgetWarPlansV1 = NgfDocumentContent & {
  __typename?: 'Diablo4DocumentUgWidgetWarPlansV1';
  data: Diablo4DocumentUgWidgetWarPlansDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Diablo4DocumentsMutation = {
  __typename?: 'Diablo4DocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: Diablo4StructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: Diablo4StructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: Diablo4StructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: Diablo4StructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: Diablo4UserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: Diablo4UserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: Diablo4UserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: Diablo4UserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: Diablo4UserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: Diablo4UserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: Diablo4WikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: Diablo4WikiDocumentUpdatePayload;
};

export type Diablo4DocumentsMutationstructDocumentCreateArgs = {
  input: Diablo4StructDocumentCreateInput;
};

export type Diablo4DocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Diablo4DocumentsMutationstructDocumentSetStatusArgs = {
  input: Diablo4StructDocumentSetStatusInput;
};

export type Diablo4DocumentsMutationstructDocumentUpdateArgs = {
  input: Diablo4StructDocumentUpdateInput;
};

export type Diablo4DocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: Diablo4UserGeneratedDocumentCreateInput;
};

export type Diablo4DocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: Diablo4UserGeneratedDocumentSetFavoriteInput;
};

export type Diablo4DocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: Diablo4UserGeneratedDocumentSetFeaturedInput;
};

export type Diablo4DocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Diablo4DocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: Diablo4UserGeneratedDocumentSetStatusInput;
};

export type Diablo4DocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: Diablo4UserGeneratedDocumentUpdateInput;
};

export type Diablo4DocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type Diablo4DocumentsMutationwikiDocumentUpdateArgs = {
  input: Diablo4WikiDocumentUpdateInput;
};

export type Diablo4DocumentsQuery = {
  __typename?: 'Diablo4DocumentsQuery';
  previewDocumentContent: Diablo4PreviewDocumentContentPayload;
  structDocumentBySlug: Diablo4StructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: Diablo4UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: Diablo4UserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: Diablo4UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: Diablo4UserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: Diablo4TemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: Diablo4WikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type Diablo4DocumentsQuerypreviewDocumentContentArgs = {
  input: Diablo4PreviewDocumentContentInput;
};

export type Diablo4DocumentsQuerystructDocumentBySlugArgs = {
  input: Diablo4StructDocumentInputBySlug;
};

export type Diablo4DocumentsQuerystructDocumentsArgs = {
  input: Diablo4StructDocumentsInput;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: Diablo4UserGeneratedDocumentInputById;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: Diablo4UserGeneratedDocumentInputBySlug;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: Diablo4TemplateDocumentInput;
};

export type Diablo4DocumentsQueryuserGeneratedDocumentsArgs = {
  input: Diablo4UserGeneratedDocumentsListInput;
  page: Diablo4UserGeneratedDocumentsListPage;
};

export type Diablo4DocumentsQuerywikiDocumentArgs = {
  input: Diablo4WikiDocumentInput;
};

export type Diablo4DocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<Diablo4WikiDocumentsListInput>;
  page: Diablo4WikiDocumentsListPage;
};

export type Diablo4Entity = Diablo4BlankStaticEntity;

export type Diablo4Mutation = {
  __typename?: 'Diablo4Mutation';
  documents?: Maybe<Diablo4DocumentsMutation>;
  id: Scalars['ID'];
  tracking?: Maybe<Diablo4TrackingMutation>;
};

export enum Diablo4PreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4PreviewDocumentContentInput = {
  content: Scalars['Diablo4DocumentContentInputBase64Json'];
};

export type Diablo4PreviewDocumentContentPayload = {
  __typename?: 'Diablo4PreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<Diablo4DocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<Diablo4PreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4Profile = NgfProfile & {
  __typename?: 'Diablo4Profile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type Diablo4ProfileuserGeneratedDocumentsArgs = {
  input: Diablo4UserGeneratedDocumentsListInput;
  page: Diablo4UserGeneratedDocumentsListPage;
};

export type Diablo4ProfilePayload = {
  __typename?: 'Diablo4ProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<Diablo4Profile>;
};

export type Diablo4ProfilesQuery = {
  __typename?: 'Diablo4ProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: Diablo4ProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type Diablo4ProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type Diablo4Query = {
  __typename?: 'Diablo4Query';
  documents?: Maybe<Diablo4DocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<Diablo4ProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticDataV2?: Maybe<Diablo4StaticDataV2Query>;
  trackedUgDocuments?: Maybe<NgfUserGeneratedDocumentsListPayload>;
};

export type Diablo4StaticDataV2Query = {
  __typename?: 'Diablo4StaticDataV2Query';
  d4AspectSlots: D4AspectSlotsResult;
  d4AspectTypes: D4AspectTypesResult;
  d4Aspects: D4AspectsResult;
  d4BloodiedAffixes: D4BloodiedAffixesResult;
  d4BossPowers: D4BossPowersResult;
  d4BuildSlots: D4BuildSlotsResult;
  d4ChaosPerks: D4ChaosPerksResult;
  d4CharmSets: D4CharmSetsResult;
  d4Charms: D4CharmsResult;
  d4Classes: D4ClassesResult;
  d4Connectors: D4ConnectorsResult;
  d4DivineGifts: D4DivineGiftsResult;
  d4Dungeons: D4DungeonsResult;
  d4Elixirs: D4ElixirsResult;
  d4GemTypes: D4GemTypesResult;
  d4Gems: D4GemsResult;
  d4GoverningStones: D4GoverningStonesResult;
  d4Hearts: D4HeartsResult;
  d4HoradricSpells: D4HoradricSpellsResult;
  d4Locations: D4LocationsResult;
  d4MapItemTypes: D4MapItemTypesResult;
  d4MapItems: D4MapItemsResult;
  d4MapZones: D4MapZonesResult;
  d4Mercenaries: D4MercenariesResult;
  d4MercenarySkills: D4MercenarySkillsResult;
  d4Opportunities: D4OpportunitiesResult;
  d4ParagonBoards: D4ParagonBoardsResult;
  d4ParagonGlyphRarities: D4ParagonGlyphRaritiesResult;
  d4ParagonGlyphs: D4ParagonGlyphsResult;
  d4ParagonNodeTypes: D4ParagonNodeTypesResult;
  d4ParagonNodes: D4ParagonNodesResult;
  d4Runes: D4RunesResult;
  d4SanctificationStats: D4SanctificationStatsResult;
  d4Seals: D4SealsResult;
  d4SkillResources: D4SkillResourcesResult;
  d4SkillSections: D4SkillSectionsResult;
  d4SkillTags: D4SkillTagsResult;
  d4SkillTypes: D4SkillTypesResult;
  d4Skills: D4SkillsResult;
  d4SoulShards: D4SoulShardsResult;
  d4StatImplicit: D4StatImplicitResult;
  d4StatTempering: D4StatTemperingResult;
  d4StatTypes: D4StatTypesResult;
  d4Stats: D4StatsResult;
  d4StoneRarities: D4StoneRaritiesResult;
  d4Tiers: D4TiersResult;
  d4TransfiguredStats: D4TransfiguredStatsResult;
  d4TriadPowers: D4TriadPowersResult;
  d4TriadSplinters: D4TriadSplintersResult;
  d4TuningStones: D4TuningStonesResult;
  d4UniqueItemTypes: D4UniqueItemTypesResult;
  d4UniqueItems: D4UniqueItemsResult;
  d4VampirePowers: D4VampirePowersResult;
  d4WarplanNodes: D4WarplanNodesResult;
  d4WarplanTrees: D4WarplanTreesResult;
  d4WitchcraftPowers: D4WitchcraftPowersResult;
};

export type Diablo4StaticDataV2Queryd4AspectSlotsArgs = {
  filter?: InputMaybe<D4AspectSlotsFilter>;
};

export type Diablo4StaticDataV2Queryd4AspectTypesArgs = {
  filter?: InputMaybe<D4AspectTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4AspectsArgs = {
  filter?: InputMaybe<D4AspectsFilter>;
};

export type Diablo4StaticDataV2Queryd4BloodiedAffixesArgs = {
  filter?: InputMaybe<D4BloodiedAffixesFilter>;
};

export type Diablo4StaticDataV2Queryd4BossPowersArgs = {
  filter?: InputMaybe<D4BossPowersFilter>;
};

export type Diablo4StaticDataV2Queryd4BuildSlotsArgs = {
  filter?: InputMaybe<D4BuildSlotsFilter>;
};

export type Diablo4StaticDataV2Queryd4ChaosPerksArgs = {
  filter?: InputMaybe<D4ChaosPerksFilter>;
};

export type Diablo4StaticDataV2Queryd4CharmSetsArgs = {
  filter?: InputMaybe<D4CharmSetsFilter>;
};

export type Diablo4StaticDataV2Queryd4CharmsArgs = {
  filter?: InputMaybe<D4CharmsFilter>;
};

export type Diablo4StaticDataV2Queryd4ClassesArgs = {
  filter?: InputMaybe<D4ClassesFilter>;
};

export type Diablo4StaticDataV2Queryd4ConnectorsArgs = {
  filter?: InputMaybe<D4ConnectorsFilter>;
};

export type Diablo4StaticDataV2Queryd4DivineGiftsArgs = {
  filter?: InputMaybe<D4DivineGiftsFilter>;
};

export type Diablo4StaticDataV2Queryd4DungeonsArgs = {
  filter?: InputMaybe<D4DungeonsFilter>;
};

export type Diablo4StaticDataV2Queryd4ElixirsArgs = {
  filter?: InputMaybe<D4ElixirsFilter>;
};

export type Diablo4StaticDataV2Queryd4GemTypesArgs = {
  filter?: InputMaybe<D4GemTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4GemsArgs = {
  filter?: InputMaybe<D4GemsFilter>;
};

export type Diablo4StaticDataV2Queryd4GoverningStonesArgs = {
  filter?: InputMaybe<D4GoverningStonesFilter>;
};

export type Diablo4StaticDataV2Queryd4HeartsArgs = {
  filter?: InputMaybe<D4HeartsFilter>;
};

export type Diablo4StaticDataV2Queryd4HoradricSpellsArgs = {
  filter?: InputMaybe<D4HoradricSpellsFilter>;
};

export type Diablo4StaticDataV2Queryd4LocationsArgs = {
  filter?: InputMaybe<D4LocationsFilter>;
};

export type Diablo4StaticDataV2Queryd4MapItemTypesArgs = {
  filter?: InputMaybe<D4MapItemTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4MapItemsArgs = {
  filter?: InputMaybe<D4MapItemsFilter>;
};

export type Diablo4StaticDataV2Queryd4MapZonesArgs = {
  filter?: InputMaybe<D4MapZonesFilter>;
};

export type Diablo4StaticDataV2Queryd4MercenariesArgs = {
  filter?: InputMaybe<D4MercenariesFilter>;
};

export type Diablo4StaticDataV2Queryd4MercenarySkillsArgs = {
  filter?: InputMaybe<D4MercenarySkillsFilter>;
};

export type Diablo4StaticDataV2Queryd4OpportunitiesArgs = {
  filter?: InputMaybe<D4OpportunitiesFilter>;
};

export type Diablo4StaticDataV2Queryd4ParagonBoardsArgs = {
  filter?: InputMaybe<D4ParagonBoardsFilter>;
};

export type Diablo4StaticDataV2Queryd4ParagonGlyphRaritiesArgs = {
  filter?: InputMaybe<D4ParagonGlyphRaritiesFilter>;
};

export type Diablo4StaticDataV2Queryd4ParagonGlyphsArgs = {
  filter?: InputMaybe<D4ParagonGlyphsFilter>;
};

export type Diablo4StaticDataV2Queryd4ParagonNodeTypesArgs = {
  filter?: InputMaybe<D4ParagonNodeTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4ParagonNodesArgs = {
  filter?: InputMaybe<D4ParagonNodesFilter>;
};

export type Diablo4StaticDataV2Queryd4RunesArgs = {
  filter?: InputMaybe<D4RunesFilter>;
};

export type Diablo4StaticDataV2Queryd4SanctificationStatsArgs = {
  filter?: InputMaybe<D4SanctificationStatsFilter>;
};

export type Diablo4StaticDataV2Queryd4SealsArgs = {
  filter?: InputMaybe<D4SealsFilter>;
};

export type Diablo4StaticDataV2Queryd4SkillResourcesArgs = {
  filter?: InputMaybe<D4SkillResourcesFilter>;
};

export type Diablo4StaticDataV2Queryd4SkillSectionsArgs = {
  filter?: InputMaybe<D4SkillSectionsFilter>;
};

export type Diablo4StaticDataV2Queryd4SkillTagsArgs = {
  filter?: InputMaybe<D4SkillTagsFilter>;
};

export type Diablo4StaticDataV2Queryd4SkillTypesArgs = {
  filter?: InputMaybe<D4SkillTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4SkillsArgs = {
  filter?: InputMaybe<D4SkillsFilter>;
};

export type Diablo4StaticDataV2Queryd4SoulShardsArgs = {
  filter?: InputMaybe<D4SoulShardsFilter>;
};

export type Diablo4StaticDataV2Queryd4StatImplicitArgs = {
  filter?: InputMaybe<D4StatImplicitFilter>;
};

export type Diablo4StaticDataV2Queryd4StatTemperingArgs = {
  filter?: InputMaybe<D4StatTemperingFilter>;
};

export type Diablo4StaticDataV2Queryd4StatTypesArgs = {
  filter?: InputMaybe<D4StatTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4StatsArgs = {
  filter?: InputMaybe<D4StatsFilter>;
};

export type Diablo4StaticDataV2Queryd4StoneRaritiesArgs = {
  filter?: InputMaybe<D4StoneRaritiesFilter>;
};

export type Diablo4StaticDataV2Queryd4TiersArgs = {
  filter?: InputMaybe<D4TiersFilter>;
};

export type Diablo4StaticDataV2Queryd4TransfiguredStatsArgs = {
  filter?: InputMaybe<D4TransfiguredStatsFilter>;
};

export type Diablo4StaticDataV2Queryd4TriadPowersArgs = {
  filter?: InputMaybe<D4TriadPowersFilter>;
};

export type Diablo4StaticDataV2Queryd4TriadSplintersArgs = {
  filter?: InputMaybe<D4TriadSplintersFilter>;
};

export type Diablo4StaticDataV2Queryd4TuningStonesArgs = {
  filter?: InputMaybe<D4TuningStonesFilter>;
};

export type Diablo4StaticDataV2Queryd4UniqueItemTypesArgs = {
  filter?: InputMaybe<D4UniqueItemTypesFilter>;
};

export type Diablo4StaticDataV2Queryd4UniqueItemsArgs = {
  filter?: InputMaybe<D4UniqueItemsFilter>;
};

export type Diablo4StaticDataV2Queryd4VampirePowersArgs = {
  filter?: InputMaybe<D4VampirePowersFilter>;
};

export type Diablo4StaticDataV2Queryd4WarplanNodesArgs = {
  filter?: InputMaybe<D4WarplanNodesFilter>;
};

export type Diablo4StaticDataV2Queryd4WarplanTreesArgs = {
  filter?: InputMaybe<D4WarplanTreesFilter>;
};

export type Diablo4StaticDataV2Queryd4WitchcraftPowersArgs = {
  filter?: InputMaybe<D4WitchcraftPowersFilter>;
};

export type Diablo4StructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'Diablo4StructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Diablo4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Diablo4StructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum Diablo4StructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Diablo4StructDocumentCreateInput = {
  document: Scalars['Diablo4StructDocumentInputBase64Json'];
};

export type Diablo4StructDocumentCreatePayload = {
  __typename?: 'Diablo4StructDocumentCreatePayload';
  data?: Maybe<Diablo4StructDocument>;
  error?: Maybe<Diablo4StructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4StructDocumentData = NgfStructDocumentData & {
  __typename?: 'Diablo4StructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Diablo4DocumentSeason;
  tags?: Maybe<Diablo4DocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum Diablo4StructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Diablo4StructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Diablo4StructDocumentPayload = {
  __typename?: 'Diablo4StructDocumentPayload';
  data?: Maybe<Diablo4StructDocument>;
  error?: Maybe<Diablo4StructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4StructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Diablo4StructDocumentSetSeoPayload = {
  __typename?: 'Diablo4StructDocumentSetSeoPayload';
  data?: Maybe<Diablo4StructDocument>;
  error?: Maybe<Diablo4StructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4StructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4StructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type Diablo4StructDocumentSetStatusPayload = {
  __typename?: 'Diablo4StructDocumentSetStatusPayload';
  data?: Maybe<Diablo4StructDocument>;
  error?: Maybe<Diablo4StructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4StructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4StructDocumentUpdateInput = {
  document: Scalars['Diablo4StructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Diablo4StructDocumentUpdatePayload = {
  __typename?: 'Diablo4StructDocumentUpdatePayload';
  data?: Maybe<Diablo4StructDocument>;
  error?: Maybe<Diablo4StructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4StructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type Diablo4TemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'Diablo4TemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<Diablo4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: Diablo4TemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type Diablo4TemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'Diablo4TemplateDocumentData';
  buildVariants?: Maybe<Diablo4UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Diablo4DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Diablo4TemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4TemplateDocumentInput = {
  type: Scalars['String'];
};

export type Diablo4TemplateDocumentPayload = {
  __typename?: 'Diablo4TemplateDocumentPayload';
  data?: Maybe<Diablo4TemplateDocument>;
  error?: Maybe<Diablo4TemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4TrackingEquipmentSlotInput = {
  autoTrackingDisabled?: InputMaybe<Scalars['Boolean']>;
  itemSlug?: InputMaybe<Scalars['String']>;
  /**
   * Each element aligns positionally with the flat document modifier expansion
   * (canonical order: implicit → gear → tempering → sanctification → bloodied → socket → seal → charm).
   * Null at index i means the modifier at that position is not yet checked.
   */
  modifiers?: InputMaybe<Array<InputMaybe<Diablo4TrackingEquipmentSlotModifierInput>>>;
  slotSlug: Scalars['String'];
};

export type Diablo4TrackingEquipmentSlotModifierInput = {
  slug: Scalars['String'];
  /** Modifier category. Use backend constants: implicit, gear, tempering, sanctification, bloodied, socket. */
  type: Scalars['String'];
};

export type Diablo4TrackingMutation = {
  __typename?: 'Diablo4TrackingMutation';
  /** Start tracking a document variant. */
  track: NgfTrackingTrackPayload;
  /** Stop tracking. */
  untrack: NgfTrackingUntrackPayload;
  /** Update character state (equipment, skills, paragon glyphs). */
  updateCharacterState: NgfTrackingTrackPayload;
};

export type Diablo4TrackingMutationtrackArgs = {
  input: NgfTrackingTrackInput;
};

export type Diablo4TrackingMutationuntrackArgs = {
  input: NgfTrackingUntrackInput;
};

export type Diablo4TrackingMutationupdateCharacterStateArgs = {
  input: Diablo4TrackingUpdateCharacterStateInput;
};

/**
 * A single skill tree node entry in the character state.
 * The action field mirrors the document's ActionType values (e.g. ACTIVATE, REFUND).
 */
export type Diablo4TrackingSkillActionInput = {
  action: Scalars['String'];
  slug: Scalars['String'];
};

/**
 * Each array mirrors the corresponding priority list:
 * same length, with null at positions the user has not yet acquired.
 * Null preserves position semantics — non-null entries must match the priority list item
 * at the same index (slug/type) to count as matched.
 */
export type Diablo4TrackingUpdateCharacterStateInput = {
  assignedSkills?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autoTrackingDisabled?: InputMaybe<Scalars['Boolean']>;
  equipment?: InputMaybe<Array<Diablo4TrackingEquipmentSlotInput>>;
  paragonGlyphs?: InputMaybe<Array<Scalars['String']>>;
  skillTree?: InputMaybe<Array<InputMaybe<Diablo4TrackingSkillActionInput>>>;
  talismans?: InputMaybe<Array<Diablo4TrackingEquipmentSlotInput>>;
};

export type Diablo4UGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'Diablo4UGDocumentGenericBuilder';
  slots?: Maybe<Array<Diablo4UGDocumentGenericBuilderSlot>>;
};

export type Diablo4UGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'Diablo4UGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<D4EntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type Diablo4UserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'Diablo4UserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<Diablo4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Diablo4UserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    matchingInfo?: Maybe<NgfMatchingInfo>;
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<Diablo4DocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Diablo4UserGeneratedDocumentBuildParagonBoard = {
  __typename?: 'Diablo4UserGeneratedDocumentBuildParagonBoard';
  board: D4ParagonBoard;
  glyph?: Maybe<D4ParagonGlyph>;
  glyphLevel?: Maybe<Scalars['Int']>;
  rotation?: Maybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type Diablo4UserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariant';
  assignedSkills?: Maybe<Diablo4UserGeneratedDocumentBuildVariantAssignedSkills>;
  equipmentPriorityList?: Maybe<Array<Diablo4DocumentUgWidgetEquipmentPriorityListItem>>;
  genericBuilder: Diablo4UGDocumentGenericBuilder;
  id: Scalars['ID'];
  mercenary?: Maybe<Diablo4UserGeneratedDocumentBuildVariantMercenary>;
  paragon?: Maybe<Diablo4UserGeneratedDocumentBuildVariantParagon>;
  skillTree?: Maybe<Diablo4UserGeneratedDocumentBuildVariantSkillTree>;
  talismansPriorityList?: Maybe<Array<Diablo4DocumentUgWidgetEquipmentPriorityListItem>>;
  warPlan?: Maybe<Diablo4UserGeneratedDocumentBuildVariantWarPlan>;
};

export type Diablo4UserGeneratedDocumentBuildVariantAssignedSkills = NgfDocumentWidgetPrioritizable & {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariantAssignedSkills';
  boons?: Maybe<Array<Diablo4VariantAssignedSkillsDruidBoon>>;
  description?: Maybe<NgfDocumentRichTextContent>;
  enchantments?: Maybe<Array<D4Skill>>;
  expertise?: Maybe<Array<D4Skill>>;
  priorityList?: Maybe<Array<Diablo4DocumentUgWidgetAssignedSkillsPriorityListItem>>;
  skills?: Maybe<Array<Diablo4DocumentUgWidgetAssignedSkill>>;
  soulShards?: Maybe<Array<Diablo4VariantAssignedSkillsSoulShards>>;
  specialization?: Maybe<Array<D4Skill>>;
  spiritGuardians?: Maybe<Diablo4VariantAssignedSkillsSpiritGuardians>;
  summons?: Maybe<Array<Diablo4VariantAssignedSkillsNecromancerSummon>>;
};

export type Diablo4UserGeneratedDocumentBuildVariantMercenary = {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariantMercenary';
  opportunity?: Maybe<Diablo4DocumentUgWidgetMercenaryAssignedOpportunity>;
  primaryMercenary?: Maybe<D4Mercenary>;
  reinforcementMercenary?: Maybe<D4Mercenary>;
  skill?: Maybe<D4MercenarySkill>;
  skillTree?: Maybe<Array<Diablo4DocumentUgWidgetMercenaryLeveledMercenarySkill>>;
};

export type Diablo4UserGeneratedDocumentBuildVariantParagon = NgfDocumentWidgetPrioritizable & {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariantParagon';
  boards?: Maybe<Array<Diablo4UserGeneratedDocumentBuildParagonBoard>>;
  nodes?: Maybe<Array<D4ParagonNode>>;
  priorityList?: Maybe<Array<Diablo4DocumentUgWidgetParagonGlyphPriorityListItem>>;
};

export type Diablo4UserGeneratedDocumentBuildVariantSkillTree = NgfDocumentWidgetPrioritizable & {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariantSkillTree';
  priorityList?: Maybe<Array<Diablo4DocumentUgWidgetSkillTreePriorityListItem>>;
  skillTreeDescription?: Maybe<NgfDocumentRichTextContent>;
  skills?: Maybe<Array<Diablo4DocumentUgWidgetSkillTreeLeveledSkill>>;
};

export type Diablo4UserGeneratedDocumentBuildVariantWarPlan = {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariantWarPlan';
  warplanTrees?: Maybe<Array<Diablo4UserGeneratedDocumentBuildWarplanTree>>;
};

export type Diablo4UserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'Diablo4UserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<Diablo4UserGeneratedDocumentBuildVariant>>;
};

export type Diablo4UserGeneratedDocumentBuildWarplanTree = {
  __typename?: 'Diablo4UserGeneratedDocumentBuildWarplanTree';
  warplanNodes?: Maybe<Array<D4WarplanNode>>;
  warplanTree: D4WarplanTree;
};

export enum Diablo4UserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Diablo4UserGeneratedDocumentCreateInput = {
  document: Scalars['Diablo4UserGeneratedDocumentInputBase64Json'];
};

export type Diablo4UserGeneratedDocumentCreatePayload = {
  __typename?: 'Diablo4UserGeneratedDocumentCreatePayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4UserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'Diablo4UserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<Diablo4UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  lootFilter?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Diablo4DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Diablo4UserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Diablo4UserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Diablo4UserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Diablo4UserGeneratedDocumentPayload = {
  __typename?: 'Diablo4UserGeneratedDocumentPayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4UserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4UserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type Diablo4UserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'Diablo4UserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4UserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Diablo4UserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type Diablo4UserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'Diablo4UserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4UserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Diablo4UserGeneratedDocumentSetSeoPayload = {
  __typename?: 'Diablo4UserGeneratedDocumentSetSeoPayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4UserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4UserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type Diablo4UserGeneratedDocumentSetStatusPayload = {
  __typename?: 'Diablo4UserGeneratedDocumentSetStatusPayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4UserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Diablo4UserGeneratedDocumentUpdateInput = {
  document: Scalars['Diablo4UserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Diablo4UserGeneratedDocumentUpdatePayload = {
  __typename?: 'Diablo4UserGeneratedDocumentUpdatePayload';
  data?: Maybe<Diablo4UserGeneratedDocument>;
  error?: Maybe<Diablo4UserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4UserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type Diablo4UserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Diablo4VariantAssignedSkillsDruidBoon = {
  __typename?: 'Diablo4VariantAssignedSkillsDruidBoon';
  type: Diablo4VariantAssignedSkillsDruidBoonType;
  value?: Maybe<Array<D4Skill>>;
};

export enum Diablo4VariantAssignedSkillsDruidBoonType {
  DEER = 'DEER',
  EAGLE = 'EAGLE',
  SNAKE = 'SNAKE',
  WOLF = 'WOLF',
}

export type Diablo4VariantAssignedSkillsNecromancerSummon = {
  __typename?: 'Diablo4VariantAssignedSkillsNecromancerSummon';
  spec: D4Skill;
  type: Diablo4VariantAssignedSkillsNecromancerSummonType;
  upgrade: Scalars['Int'];
};

export enum Diablo4VariantAssignedSkillsNecromancerSummonType {
  GOLEMS = 'GOLEMS',
  SKELETAL_MAGES = 'SKELETAL_MAGES',
  SKELETAL_WARRIORS = 'SKELETAL_WARRIORS',
}

export type Diablo4VariantAssignedSkillsSoulShards = {
  __typename?: 'Diablo4VariantAssignedSkillsSoulShards';
  fragments?: Maybe<Array<D4SoulShard>>;
  shard: D4SoulShard;
};

export type Diablo4VariantAssignedSkillsSpiritGuardians = {
  __typename?: 'Diablo4VariantAssignedSkillsSpiritGuardians';
  primaryId?: Maybe<Scalars['ID']>;
  secondaryId?: Maybe<Scalars['ID']>;
};

export type Diablo4WikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'Diablo4WikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Diablo4DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Diablo4WikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<Diablo4DocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Diablo4WikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'Diablo4WikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: D4EntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum Diablo4WikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4WikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Diablo4WikiDocumentPayload = {
  __typename?: 'Diablo4WikiDocumentPayload';
  data?: Maybe<Diablo4WikiDocument>;
  error?: Maybe<Diablo4WikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4WikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Diablo4WikiDocumentSetSeoPayload = {
  __typename?: 'Diablo4WikiDocumentSetSeoPayload';
  data?: Maybe<Diablo4WikiDocument>;
  error?: Maybe<Diablo4WikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Diablo4WikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Diablo4WikiDocumentUpdateInput = {
  document: Scalars['Diablo4WikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type Diablo4WikiDocumentUpdatePayload = {
  __typename?: 'Diablo4WikiDocumentUpdatePayload';
  data?: Maybe<Diablo4WikiDocument>;
  error?: Maybe<Diablo4WikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Diablo4WikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type Diablo4WikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type DisplayMetadata = {
  __typename?: 'DisplayMetadata';
  coverImageUrlPattern?: Maybe<Scalars['String']>;
  iconTagGroupSlug: Scalars['String'];
  subTitleTagGroupSlug: Scalars['String'];
};

/**
 * Identifying triple `(id, category, game)` returned by NGF document types.
 * A value type — not a federation entity. Clients that need to dereference
 * to the concrete-typed document call `Query.documentEntity` on the
 * doctyperesolver subgraph.
 */
export type DocumentDescriptor = {
  __typename?: 'DocumentDescriptor';
  /** Document kind classification. */
  category: NgfDocumentCategory;
  /** Game slug (e.g. `POE2`, `Deadlock`). Case-insensitive when computing the typename. */
  game: Scalars['String'];
  /** Stable identifier of the underlying document. */
  id: Scalars['ID'];
};

export type DocumentInfo = {
  __typename?: 'DocumentInfo';
  commentsWidgetID?: Maybe<Scalars['String']>;
  featuredSlug?: Maybe<Scalars['String']>;
  game: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slugifiedName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type DocumentUpdatedPayload = NotificationPayload & {
  __typename?: 'DocumentUpdatedPayload';
  author?: Maybe<MgpProfile>;
  document: DocumentInfo;
  event: Scalars['String'];
  type: Scalars['String'];
};

export type EldenRingNightreignAshesOfWar = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignAshesOfWar';
  availableShieldTypeSlugs?: Maybe<Array<Scalars['String']>>;
  availableShieldTypes?: Maybe<Array<EldenRingNightreignShieldType>>;
  availableUniqueShieldSlugs?: Maybe<Array<Scalars['String']>>;
  availableUniqueShields?: Maybe<Array<EldenRingNightreignShield>>;
  availableUniqueWeaponSlugs?: Maybe<Array<Scalars['String']>>;
  availableUniqueWeapons?: Maybe<Array<EldenRingNightreignWeapon>>;
  availableWeaponTypeSlugs?: Maybe<Array<Scalars['String']>>;
  availableWeaponTypes?: Maybe<Array<EldenRingNightreignWeaponType>>;
  effectDescription?: Maybe<Scalars['String']>;
  fpCost?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  usabilityDescription?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignAshesOfWarFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignAshesOfWarResult = {
  __typename?: 'EldenRingNightreignAshesOfWarResult';
  data?: Maybe<Array<EldenRingNightreignAshesOfWar>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignAttackAffinityType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignAttackAffinityType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignAttackAffinityTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignAttackAffinityTypesResult = {
  __typename?: 'EldenRingNightreignAttackAffinityTypesResult';
  data?: Maybe<Array<EldenRingNightreignAttackAffinityType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignAttackPower = {
  __typename?: 'EldenRingNightreignAttackPower';
  damageType?: Maybe<EldenRingNightreignDamageType>;
  damageTypeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type EldenRingNightreignAttribute = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignAttribute';
  id: Scalars['String'];
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type EldenRingNightreignAttributeScaling = {
  __typename?: 'EldenRingNightreignAttributeScaling';
  attribute?: Maybe<EldenRingNightreignAttribute>;
  attributeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignAttributesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignAttributesResult = {
  __typename?: 'EldenRingNightreignAttributesResult';
  data?: Maybe<Array<EldenRingNightreignAttribute>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignCatalyst = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignCatalyst';
  ashOfWar?: Maybe<EldenRingNightreignAshesOfWar>;
  ashOfWarSlug?: Maybe<Scalars['String']>;
  attackAffinity?: Maybe<EldenRingNightreignAttackAffinityType>;
  attackAffinityTypeSlug?: Maybe<Scalars['String']>;
  attackPower?: Maybe<Array<EldenRingNightreignAttackPower>>;
  attributeScaling?: Maybe<Array<EldenRingNightreignAttributeScaling>>;
  catalystType?: Maybe<EldenRingNightreignCatalystType>;
  catalystTypeSlug?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  guardedNegation?: Maybe<Array<EldenRingNightreignGuardedNegation>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  levelRequired?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  spellPowerScaling?: Maybe<Scalars['Int']>;
  statusAilment?: Maybe<EldenRingNightreignStatusAilment>;
  weaponPassive?: Maybe<EldenRingNightreignWeaponPassive>;
  weaponPassiveSlug?: Maybe<Scalars['String']>;
  wikiCatalystDescriptionText?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignCatalystType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignCatalystType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignCatalystTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignCatalystTypesResult = {
  __typename?: 'EldenRingNightreignCatalystTypesResult';
  data?: Maybe<Array<EldenRingNightreignCatalystType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignCatalystsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignCatalystsResult = {
  __typename?: 'EldenRingNightreignCatalystsResult';
  data?: Maybe<Array<EldenRingNightreignCatalyst>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignConsumable = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignConsumable';
  effectDescription?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  fpCost?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  maxAmountPerSlot?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignConsumablesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignConsumablesResult = {
  __typename?: 'EldenRingNightreignConsumablesResult';
  data?: Maybe<Array<EldenRingNightreignConsumable>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignDamageType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignDamageType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignDamageTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignDamageTypesResult = {
  __typename?: 'EldenRingNightreignDamageTypesResult';
  data?: Maybe<Array<EldenRingNightreignDamageType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'EldenRingNightreignDocumentCmWidgetV1';
  data: EldenRingNightreignDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type EldenRingNightreignDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'EldenRingNightreignDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type EldenRingNightreignDocumentContent =
  | EldenRingNightreignDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type EldenRingNightreignDocumentSeason = NgfDocumentSeason & {
  __typename?: 'EldenRingNightreignDocumentSeason';
  slug: Scalars['String'];
};

export type EldenRingNightreignDocumentTags = NgfDocumentTags & {
  __typename?: 'EldenRingNightreignDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type EldenRingNightreignDocumentsMutation = {
  __typename?: 'EldenRingNightreignDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: EldenRingNightreignStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: EldenRingNightreignStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: EldenRingNightreignStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: EldenRingNightreignStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: EldenRingNightreignUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: EldenRingNightreignUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: EldenRingNightreignUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: EldenRingNightreignUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: EldenRingNightreignUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: EldenRingNightreignUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: EldenRingNightreignWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: EldenRingNightreignWikiDocumentUpdatePayload;
};

export type EldenRingNightreignDocumentsMutationstructDocumentCreateArgs = {
  input: EldenRingNightreignStructDocumentCreateInput;
};

export type EldenRingNightreignDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type EldenRingNightreignDocumentsMutationstructDocumentSetStatusArgs = {
  input: EldenRingNightreignStructDocumentSetStatusInput;
};

export type EldenRingNightreignDocumentsMutationstructDocumentUpdateArgs = {
  input: EldenRingNightreignStructDocumentUpdateInput;
};

export type EldenRingNightreignDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: EldenRingNightreignUserGeneratedDocumentCreateInput;
};

export type EldenRingNightreignDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: EldenRingNightreignUserGeneratedDocumentSetFavoriteInput;
};

export type EldenRingNightreignDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: EldenRingNightreignUserGeneratedDocumentSetFeaturedInput;
};

export type EldenRingNightreignDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type EldenRingNightreignDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: EldenRingNightreignUserGeneratedDocumentSetStatusInput;
};

export type EldenRingNightreignDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: EldenRingNightreignUserGeneratedDocumentUpdateInput;
};

export type EldenRingNightreignDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type EldenRingNightreignDocumentsMutationwikiDocumentUpdateArgs = {
  input: EldenRingNightreignWikiDocumentUpdateInput;
};

export type EldenRingNightreignDocumentsQuery = {
  __typename?: 'EldenRingNightreignDocumentsQuery';
  previewDocumentContent: EldenRingNightreignPreviewDocumentContentPayload;
  structDocumentBySlug: EldenRingNightreignStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: EldenRingNightreignUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: EldenRingNightreignUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: EldenRingNightreignUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: EldenRingNightreignUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: EldenRingNightreignTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: EldenRingNightreignWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type EldenRingNightreignDocumentsQuerypreviewDocumentContentArgs = {
  input: EldenRingNightreignPreviewDocumentContentInput;
};

export type EldenRingNightreignDocumentsQuerystructDocumentBySlugArgs = {
  input: EldenRingNightreignStructDocumentInputBySlug;
};

export type EldenRingNightreignDocumentsQuerystructDocumentsArgs = {
  input: EldenRingNightreignStructDocumentsInput;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: EldenRingNightreignUserGeneratedDocumentInputById;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: EldenRingNightreignUserGeneratedDocumentInputBySlug;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: EldenRingNightreignTemplateDocumentInput;
};

export type EldenRingNightreignDocumentsQueryuserGeneratedDocumentsArgs = {
  input: EldenRingNightreignUserGeneratedDocumentsListInput;
  page: EldenRingNightreignUserGeneratedDocumentsListPage;
};

export type EldenRingNightreignDocumentsQuerywikiDocumentArgs = {
  input: EldenRingNightreignWikiDocumentInput;
};

export type EldenRingNightreignDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<EldenRingNightreignWikiDocumentsListInput>;
  page: EldenRingNightreignWikiDocumentsListPage;
};

export type EldenRingNightreignDormantPower = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignDormantPower';
  effectDescription?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignDormantPowersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignDormantPowersResult = {
  __typename?: 'EldenRingNightreignDormantPowersResult';
  data?: Maybe<Array<EldenRingNightreignDormantPower>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignEntitiesEnum {
  ashesOfWar = 'ashesOfWar',
  attackAffinityTypes = 'attackAffinityTypes',
  attributes = 'attributes',
  catalystTypes = 'catalystTypes',
  catalysts = 'catalysts',
  consumables = 'consumables',
  damageTypes = 'damageTypes',
  dormantPowers = 'dormantPowers',
  nightfarers = 'nightfarers',
  relicEffects = 'relicEffects',
  relics = 'relics',
  shieldTypes = 'shieldTypes',
  shields = 'shields',
  spellTypes = 'spellTypes',
  spells = 'spells',
  statusAilmentTypes = 'statusAilmentTypes',
  talismans = 'talismans',
  weaponPassives = 'weaponPassives',
  weaponTypes = 'weaponTypes',
  weapons = 'weapons',
}

export type EldenRingNightreignEntityObject = NGFEntityObject & {
  __typename?: 'EldenRingNightreignEntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<EldenRingNightreignGameEntity>;
  enumType?: Maybe<EldenRingNightreignEntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EldenRingNightreignGameEntity = {
  slug: Scalars['String'];
};

export type EldenRingNightreignGuardedNegation = {
  __typename?: 'EldenRingNightreignGuardedNegation';
  damageType?: Maybe<EldenRingNightreignDamageType>;
  damageTypeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type EldenRingNightreignMutation = {
  __typename?: 'EldenRingNightreignMutation';
  documents?: Maybe<EldenRingNightreignDocumentsMutation>;
  id: Scalars['ID'];
};

export type EldenRingNightreignNightfarer = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignNightfarer';
  entityType?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignNightfarersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignNightfarersResult = {
  __typename?: 'EldenRingNightreignNightfarersResult';
  data?: Maybe<Array<EldenRingNightreignNightfarer>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignPreviewDocumentContentInput = {
  content: Scalars['EldenRingNightreignDocumentContentInputBase64Json'];
};

export type EldenRingNightreignPreviewDocumentContentPayload = {
  __typename?: 'EldenRingNightreignPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<EldenRingNightreignDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<EldenRingNightreignPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignProfile = NgfProfile & {
  __typename?: 'EldenRingNightreignProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type EldenRingNightreignProfileuserGeneratedDocumentsArgs = {
  input: EldenRingNightreignUserGeneratedDocumentsListInput;
  page: EldenRingNightreignUserGeneratedDocumentsListPage;
};

export type EldenRingNightreignProfilePayload = {
  __typename?: 'EldenRingNightreignProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<EldenRingNightreignProfile>;
};

export type EldenRingNightreignProfilesQuery = {
  __typename?: 'EldenRingNightreignProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: EldenRingNightreignProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type EldenRingNightreignProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type EldenRingNightreignQuery = {
  __typename?: 'EldenRingNightreignQuery';
  documents?: Maybe<EldenRingNightreignDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<EldenRingNightreignProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<EldenRingNightreignStaticDataQuery>;
};

export type EldenRingNightreignRelic = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignRelic';
  effectDescriptionList?: Maybe<Array<Scalars['String']>>;
  flavorText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  relicColor?: Maybe<Scalars['String']>;
  relicUsability?: Maybe<Scalars['String']>;
  relicVersion?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  wikiTextDescription?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignRelicEffect = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignRelicEffect';
  effectDescription?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  relicSlugs?: Maybe<Array<Scalars['String']>>;
  relics?: Maybe<Array<EldenRingNightreignRelic>>;
  slug: Scalars['String'];
};

export type EldenRingNightreignRelicEffectsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignRelicEffectsResult = {
  __typename?: 'EldenRingNightreignRelicEffectsResult';
  data?: Maybe<Array<EldenRingNightreignRelicEffect>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignRelicsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignRelicsResult = {
  __typename?: 'EldenRingNightreignRelicsResult';
  data?: Maybe<Array<EldenRingNightreignRelic>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignShield = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignShield';
  ashOfWar?: Maybe<EldenRingNightreignAshesOfWar>;
  ashOfWarSlug?: Maybe<Scalars['String']>;
  attackAffinity?: Maybe<EldenRingNightreignAttackAffinityType>;
  attackAffinityTypeSlug?: Maybe<Scalars['String']>;
  attackPower?: Maybe<Array<EldenRingNightreignAttackPower>>;
  attributeScaling?: Maybe<Array<EldenRingNightreignAttributeScaling>>;
  flavorText?: Maybe<Scalars['String']>;
  guardedNegation?: Maybe<Array<EldenRingNightreignGuardedNegation>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  levelRequired?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  shieldType?: Maybe<EldenRingNightreignShieldType>;
  shieldTypeSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statusAilment?: Maybe<EldenRingNightreignStatusAilment>;
  wikiShieldDescriptionText?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignShieldType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignShieldType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignShieldTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignShieldTypesResult = {
  __typename?: 'EldenRingNightreignShieldTypesResult';
  data?: Maybe<Array<EldenRingNightreignShieldType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignShieldsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignShieldsResult = {
  __typename?: 'EldenRingNightreignShieldsResult';
  data?: Maybe<Array<EldenRingNightreignShield>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignSpell = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignSpell';
  effectDescription?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  fpCost?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  spellType?: Maybe<EldenRingNightreignSpellType>;
  spellTypeSlug?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignSpellType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignSpellType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignSpellTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignSpellTypesResult = {
  __typename?: 'EldenRingNightreignSpellTypesResult';
  data?: Maybe<Array<EldenRingNightreignSpellType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignSpellsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignSpellsResult = {
  __typename?: 'EldenRingNightreignSpellsResult';
  data?: Maybe<Array<EldenRingNightreignSpell>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type EldenRingNightreignStaticDataQuery = {
  __typename?: 'EldenRingNightreignStaticDataQuery';
  eldenRingNightreignAshesOfWar: EldenRingNightreignAshesOfWarResult;
  eldenRingNightreignAttackAffinityTypes: EldenRingNightreignAttackAffinityTypesResult;
  eldenRingNightreignAttributes: EldenRingNightreignAttributesResult;
  eldenRingNightreignCatalystTypes: EldenRingNightreignCatalystTypesResult;
  eldenRingNightreignCatalysts: EldenRingNightreignCatalystsResult;
  eldenRingNightreignConsumables: EldenRingNightreignConsumablesResult;
  eldenRingNightreignDamageTypes: EldenRingNightreignDamageTypesResult;
  eldenRingNightreignDormantPowers: EldenRingNightreignDormantPowersResult;
  eldenRingNightreignNightfarers: EldenRingNightreignNightfarersResult;
  eldenRingNightreignRelicEffects: EldenRingNightreignRelicEffectsResult;
  eldenRingNightreignRelics: EldenRingNightreignRelicsResult;
  eldenRingNightreignShieldTypes: EldenRingNightreignShieldTypesResult;
  eldenRingNightreignShields: EldenRingNightreignShieldsResult;
  eldenRingNightreignSpellTypes: EldenRingNightreignSpellTypesResult;
  eldenRingNightreignSpells: EldenRingNightreignSpellsResult;
  eldenRingNightreignStatusAilmentTypes: EldenRingNightreignStatusAilmentTypesResult;
  eldenRingNightreignTalismans: EldenRingNightreignTalismansResult;
  eldenRingNightreignWeaponPassives: EldenRingNightreignWeaponPassivesResult;
  eldenRingNightreignWeaponTypes: EldenRingNightreignWeaponTypesResult;
  eldenRingNightreignWeapons: EldenRingNightreignWeaponsResult;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignAshesOfWarArgs = {
  filter?: InputMaybe<EldenRingNightreignAshesOfWarFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignAttackAffinityTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignAttackAffinityTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignAttributesArgs = {
  filter?: InputMaybe<EldenRingNightreignAttributesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignCatalystTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignCatalystTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignCatalystsArgs = {
  filter?: InputMaybe<EldenRingNightreignCatalystsFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignConsumablesArgs = {
  filter?: InputMaybe<EldenRingNightreignConsumablesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignDamageTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignDamageTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignDormantPowersArgs = {
  filter?: InputMaybe<EldenRingNightreignDormantPowersFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignNightfarersArgs = {
  filter?: InputMaybe<EldenRingNightreignNightfarersFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignRelicEffectsArgs = {
  filter?: InputMaybe<EldenRingNightreignRelicEffectsFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignRelicsArgs = {
  filter?: InputMaybe<EldenRingNightreignRelicsFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignShieldTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignShieldTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignShieldsArgs = {
  filter?: InputMaybe<EldenRingNightreignShieldsFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignSpellTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignSpellTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignSpellsArgs = {
  filter?: InputMaybe<EldenRingNightreignSpellsFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignStatusAilmentTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignStatusAilmentTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignTalismansArgs = {
  filter?: InputMaybe<EldenRingNightreignTalismansFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignWeaponPassivesArgs = {
  filter?: InputMaybe<EldenRingNightreignWeaponPassivesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignWeaponTypesArgs = {
  filter?: InputMaybe<EldenRingNightreignWeaponTypesFilter>;
};

export type EldenRingNightreignStaticDataQueryeldenRingNightreignWeaponsArgs = {
  filter?: InputMaybe<EldenRingNightreignWeaponsFilter>;
};

export type EldenRingNightreignStatusAilment = {
  __typename?: 'EldenRingNightreignStatusAilment';
  statusAilmentType?: Maybe<EldenRingNightreignStatusAilmentType>;
  statusAilmentTypeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type EldenRingNightreignStatusAilmentType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignStatusAilmentType';
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignStatusAilmentTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignStatusAilmentTypesResult = {
  __typename?: 'EldenRingNightreignStatusAilmentTypesResult';
  data?: Maybe<Array<EldenRingNightreignStatusAilmentType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'EldenRingNightreignStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<EldenRingNightreignDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: EldenRingNightreignStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum EldenRingNightreignStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EldenRingNightreignStructDocumentCreateInput = {
  document: Scalars['EldenRingNightreignStructDocumentInputBase64Json'];
};

export type EldenRingNightreignStructDocumentCreatePayload = {
  __typename?: 'EldenRingNightreignStructDocumentCreatePayload';
  data?: Maybe<EldenRingNightreignStructDocument>;
  error?: Maybe<EldenRingNightreignStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignStructDocumentData = NgfStructDocumentData & {
  __typename?: 'EldenRingNightreignStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: EldenRingNightreignDocumentSeason;
  tags?: Maybe<EldenRingNightreignDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum EldenRingNightreignStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type EldenRingNightreignStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EldenRingNightreignStructDocumentPayload = {
  __typename?: 'EldenRingNightreignStructDocumentPayload';
  data?: Maybe<EldenRingNightreignStructDocument>;
  error?: Maybe<EldenRingNightreignStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type EldenRingNightreignStructDocumentSetSeoPayload = {
  __typename?: 'EldenRingNightreignStructDocumentSetSeoPayload';
  data?: Maybe<EldenRingNightreignStructDocument>;
  error?: Maybe<EldenRingNightreignStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type EldenRingNightreignStructDocumentSetStatusPayload = {
  __typename?: 'EldenRingNightreignStructDocumentSetStatusPayload';
  data?: Maybe<EldenRingNightreignStructDocument>;
  error?: Maybe<EldenRingNightreignStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignStructDocumentUpdateInput = {
  document: Scalars['EldenRingNightreignStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type EldenRingNightreignStructDocumentUpdatePayload = {
  __typename?: 'EldenRingNightreignStructDocumentUpdatePayload';
  data?: Maybe<EldenRingNightreignStructDocument>;
  error?: Maybe<EldenRingNightreignStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type EldenRingNightreignTalisman = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignTalisman';
  effectDescription?: Maybe<Scalars['String']>;
  effectDescriptionList?: Maybe<Array<Scalars['String']>>;
  flavorText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignTalismansFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignTalismansResult = {
  __typename?: 'EldenRingNightreignTalismansResult';
  data?: Maybe<Array<EldenRingNightreignTalisman>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'EldenRingNightreignTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<EldenRingNightreignDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: EldenRingNightreignTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type EldenRingNightreignTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'EldenRingNightreignTemplateDocumentData';
  buildVariants?: Maybe<EldenRingNightreignUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: EldenRingNightreignDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum EldenRingNightreignTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignTemplateDocumentInput = {
  type: Scalars['String'];
};

export type EldenRingNightreignTemplateDocumentPayload = {
  __typename?: 'EldenRingNightreignTemplateDocumentPayload';
  data?: Maybe<EldenRingNightreignTemplateDocument>;
  error?: Maybe<EldenRingNightreignTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'EldenRingNightreignUGDocumentGenericBuilder';
  slots?: Maybe<Array<EldenRingNightreignUGDocumentGenericBuilderSlot>>;
};

export type EldenRingNightreignUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'EldenRingNightreignUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<EldenRingNightreignEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type EldenRingNightreignUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'EldenRingNightreignUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<EldenRingNightreignDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: EldenRingNightreignUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<EldenRingNightreignDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type EldenRingNightreignUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentBuildVariant';
  genericBuilder: EldenRingNightreignUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type EldenRingNightreignUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<EldenRingNightreignUserGeneratedDocumentBuildVariant>>;
};

export enum EldenRingNightreignUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EldenRingNightreignUserGeneratedDocumentCreateInput = {
  document: Scalars['EldenRingNightreignUserGeneratedDocumentInputBase64Json'];
};

export type EldenRingNightreignUserGeneratedDocumentCreatePayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentCreatePayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<EldenRingNightreignUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: EldenRingNightreignDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum EldenRingNightreignUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type EldenRingNightreignUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EldenRingNightreignUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EldenRingNightreignUserGeneratedDocumentPayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentPayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type EldenRingNightreignUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EldenRingNightreignUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type EldenRingNightreignUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type EldenRingNightreignUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type EldenRingNightreignUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EldenRingNightreignUserGeneratedDocumentUpdateInput = {
  document: Scalars['EldenRingNightreignUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type EldenRingNightreignUserGeneratedDocumentUpdatePayload = {
  __typename?: 'EldenRingNightreignUserGeneratedDocumentUpdatePayload';
  data?: Maybe<EldenRingNightreignUserGeneratedDocument>;
  error?: Maybe<EldenRingNightreignUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type EldenRingNightreignUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type EldenRingNightreignWeapon = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignWeapon';
  ashOfWar?: Maybe<EldenRingNightreignAshesOfWar>;
  ashOfWarSlug?: Maybe<Scalars['String']>;
  attackAffinity?: Maybe<EldenRingNightreignAttackAffinityType>;
  attackAffinityTypeSlug?: Maybe<Scalars['String']>;
  attackPower?: Maybe<Array<EldenRingNightreignAttackPower>>;
  attributeScaling?: Maybe<Array<EldenRingNightreignAttributeScaling>>;
  flavorText?: Maybe<Scalars['String']>;
  guardedNegation?: Maybe<Array<EldenRingNightreignGuardedNegation>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  levelRequired?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  range?: Maybe<Scalars['Int']>;
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statusAilment?: Maybe<EldenRingNightreignStatusAilment>;
  weaponPassive?: Maybe<EldenRingNightreignWeaponPassive>;
  weaponPassiveSlug?: Maybe<Scalars['String']>;
  weaponType?: Maybe<EldenRingNightreignWeaponType>;
  weaponTypeSlug?: Maybe<Scalars['String']>;
  wikiWeaponDescriptionText?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignWeaponPassive = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignWeaponPassive';
  effectDescription?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeprecated?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignWeaponPassivesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignWeaponPassivesResult = {
  __typename?: 'EldenRingNightreignWeaponPassivesResult';
  data?: Maybe<Array<EldenRingNightreignWeaponPassive>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignWeaponType = EldenRingNightreignGameEntity & {
  __typename?: 'EldenRingNightreignWeaponType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EldenRingNightreignWeaponTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignWeaponTypesResult = {
  __typename?: 'EldenRingNightreignWeaponTypesResult';
  data?: Maybe<Array<EldenRingNightreignWeaponType>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type EldenRingNightreignWeaponsResult = {
  __typename?: 'EldenRingNightreignWeaponsResult';
  data?: Maybe<Array<EldenRingNightreignWeapon>>;
  error?: Maybe<EldenRingNightreignStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'EldenRingNightreignWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<EldenRingNightreignDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: EldenRingNightreignWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<EldenRingNightreignDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type EldenRingNightreignWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'EldenRingNightreignWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: EldenRingNightreignEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum EldenRingNightreignWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EldenRingNightreignWikiDocumentPayload = {
  __typename?: 'EldenRingNightreignWikiDocumentPayload';
  data?: Maybe<EldenRingNightreignWikiDocument>;
  error?: Maybe<EldenRingNightreignWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type EldenRingNightreignWikiDocumentSetSeoPayload = {
  __typename?: 'EldenRingNightreignWikiDocumentSetSeoPayload';
  data?: Maybe<EldenRingNightreignWikiDocument>;
  error?: Maybe<EldenRingNightreignWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EldenRingNightreignWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EldenRingNightreignWikiDocumentUpdateInput = {
  document: Scalars['EldenRingNightreignWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type EldenRingNightreignWikiDocumentUpdatePayload = {
  __typename?: 'EldenRingNightreignWikiDocumentUpdatePayload';
  data?: Maybe<EldenRingNightreignWikiDocument>;
  error?: Maybe<EldenRingNightreignWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EldenRingNightreignWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type EldenRingNightreignWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type EndfieldAttributes = EndfieldGameEntity & {
  __typename?: 'EndfieldAttributes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldAttributesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldAttributesResult = {
  __typename?: 'EndfieldAttributesResult';
  data?: Maybe<Array<EndfieldAttributes>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldClass = EndfieldGameEntity & {
  __typename?: 'EndfieldClass';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldClassFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldClassResult = {
  __typename?: 'EndfieldClassResult';
  data?: Maybe<Array<EndfieldClass>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'EndfieldDocumentCmWidgetV1';
  data: EndfieldDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type EndfieldDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'EndfieldDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type EndfieldDocumentContent =
  | EndfieldDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type EndfieldDocumentSeason = NgfDocumentSeason & {
  __typename?: 'EndfieldDocumentSeason';
  slug: Scalars['String'];
};

export type EndfieldDocumentTags = NgfDocumentTags & {
  __typename?: 'EndfieldDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type EndfieldDocumentsMutation = {
  __typename?: 'EndfieldDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: EndfieldStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: EndfieldStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: EndfieldStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: EndfieldStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: EndfieldUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: EndfieldUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: EndfieldUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: EndfieldUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: EndfieldUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: EndfieldUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: EndfieldWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: EndfieldWikiDocumentUpdatePayload;
};

export type EndfieldDocumentsMutationstructDocumentCreateArgs = {
  input: EndfieldStructDocumentCreateInput;
};

export type EndfieldDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type EndfieldDocumentsMutationstructDocumentSetStatusArgs = {
  input: EndfieldStructDocumentSetStatusInput;
};

export type EndfieldDocumentsMutationstructDocumentUpdateArgs = {
  input: EndfieldStructDocumentUpdateInput;
};

export type EndfieldDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: EndfieldUserGeneratedDocumentCreateInput;
};

export type EndfieldDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: EndfieldUserGeneratedDocumentSetFavoriteInput;
};

export type EndfieldDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: EndfieldUserGeneratedDocumentSetFeaturedInput;
};

export type EndfieldDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type EndfieldDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: EndfieldUserGeneratedDocumentSetStatusInput;
};

export type EndfieldDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: EndfieldUserGeneratedDocumentUpdateInput;
};

export type EndfieldDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type EndfieldDocumentsMutationwikiDocumentUpdateArgs = {
  input: EndfieldWikiDocumentUpdateInput;
};

export type EndfieldDocumentsQuery = {
  __typename?: 'EndfieldDocumentsQuery';
  previewDocumentContent: EndfieldPreviewDocumentContentPayload;
  structDocumentBySlug: EndfieldStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: EndfieldUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: EndfieldUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: EndfieldUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: EndfieldUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: EndfieldTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: EndfieldWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type EndfieldDocumentsQuerypreviewDocumentContentArgs = {
  input: EndfieldPreviewDocumentContentInput;
};

export type EndfieldDocumentsQuerystructDocumentBySlugArgs = {
  input: EndfieldStructDocumentInputBySlug;
};

export type EndfieldDocumentsQuerystructDocumentsArgs = {
  input: EndfieldStructDocumentsInput;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: EndfieldUserGeneratedDocumentInputById;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: EndfieldUserGeneratedDocumentInputBySlug;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: EndfieldTemplateDocumentInput;
};

export type EndfieldDocumentsQueryuserGeneratedDocumentsArgs = {
  input: EndfieldUserGeneratedDocumentsListInput;
  page: EndfieldUserGeneratedDocumentsListPage;
};

export type EndfieldDocumentsQuerywikiDocumentArgs = {
  input: EndfieldWikiDocumentInput;
};

export type EndfieldDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<EndfieldWikiDocumentsListInput>;
  page: EndfieldWikiDocumentsListPage;
};

export type EndfieldElements = EndfieldGameEntity & {
  __typename?: 'EndfieldElements';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldElementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldElementsResult = {
  __typename?: 'EndfieldElementsResult';
  data?: Maybe<Array<EndfieldElements>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum EndfieldEntitiesEnum {
  attributes = 'attributes',
  class = 'class',
  elements = 'elements',
  gear = 'gear',
  gearSets = 'gearSets',
  operators = 'operators',
  primaryAttributes = 'primaryAttributes',
  secondaryAttributes = 'secondaryAttributes',
  skills = 'skills',
  weaponType = 'weaponType',
  weapons = 'weapons',
}

export type EndfieldEntityObject = NGFEntityObject & {
  __typename?: 'EndfieldEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<EndfieldGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type EndfieldGameEntity = {
  slug: Scalars['String'];
};

export type EndfieldGear = EndfieldGameEntity & {
  __typename?: 'EndfieldGear';
  defence?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  gearAttributes?: Maybe<Array<Scalars['String']>>;
  gearSet?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type EndfieldGearFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldGearResult = {
  __typename?: 'EndfieldGearResult';
  data?: Maybe<Array<EndfieldGear>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldGearSets = EndfieldGameEntity & {
  __typename?: 'EndfieldGearSets';
  deprecated: Scalars['Boolean'];
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldGearSetsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldGearSetsResult = {
  __typename?: 'EndfieldGearSetsResult';
  data?: Maybe<Array<EndfieldGearSets>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldMutation = {
  __typename?: 'EndfieldMutation';
  documents?: Maybe<EndfieldDocumentsMutation>;
  id: Scalars['ID'];
};

export type EndfieldOperators = EndfieldGameEntity & {
  __typename?: 'EndfieldOperators';
  class?: Maybe<EndfieldClass>;
  deprecated: Scalars['Boolean'];
  element?: Maybe<EndfieldElements>;
  faction?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  operatorStats?: Maybe<Array<EndfieldOperatorsOperatorStats>>;
  primaryAttribute?: Maybe<EndfieldPrimaryAttributes>;
  rarity?: Maybe<Scalars['String']>;
  secondaryAttribute?: Maybe<EndfieldSecondaryAttributes>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  weaponType?: Maybe<EndfieldWeaponType>;
};

export type EndfieldOperatorsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldOperatorsOperatorStats = {
  __typename?: 'EndfieldOperatorsOperatorStats';
  attribute?: Maybe<EndfieldAttributes>;
  value?: Maybe<Scalars['String']>;
};

export type EndfieldOperatorsResult = {
  __typename?: 'EndfieldOperatorsResult';
  data?: Maybe<Array<EndfieldOperators>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum EndfieldPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldPreviewDocumentContentInput = {
  content: Scalars['EndfieldDocumentContentInputBase64Json'];
};

export type EndfieldPreviewDocumentContentPayload = {
  __typename?: 'EndfieldPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<EndfieldDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<EndfieldPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldPrimaryAttributes = EndfieldGameEntity & {
  __typename?: 'EndfieldPrimaryAttributes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldPrimaryAttributesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldPrimaryAttributesResult = {
  __typename?: 'EndfieldPrimaryAttributesResult';
  data?: Maybe<Array<EndfieldPrimaryAttributes>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldProfile = NgfProfile & {
  __typename?: 'EndfieldProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type EndfieldProfileuserGeneratedDocumentsArgs = {
  input: EndfieldUserGeneratedDocumentsListInput;
  page: EndfieldUserGeneratedDocumentsListPage;
};

export type EndfieldProfilePayload = {
  __typename?: 'EndfieldProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<EndfieldProfile>;
};

export type EndfieldProfilesQuery = {
  __typename?: 'EndfieldProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: EndfieldProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type EndfieldProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type EndfieldQuery = {
  __typename?: 'EndfieldQuery';
  documents?: Maybe<EndfieldDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<EndfieldProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<EndfieldStaticDataQuery>;
};

export type EndfieldSecondaryAttributes = EndfieldGameEntity & {
  __typename?: 'EndfieldSecondaryAttributes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldSecondaryAttributesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldSecondaryAttributesResult = {
  __typename?: 'EndfieldSecondaryAttributesResult';
  data?: Maybe<Array<EndfieldSecondaryAttributes>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldSkills = EndfieldGameEntity & {
  __typename?: 'EndfieldSkills';
  cooldown?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  effects?: Maybe<Scalars['String']>;
  energyCost?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  multipliers?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  operator?: Maybe<EndfieldOperators>;
  slug: Scalars['String'];
  spCost?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variants?: Maybe<Array<EndfieldSkillsVariants>>;
};

export type EndfieldSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldSkillsResult = {
  __typename?: 'EndfieldSkillsResult';
  data?: Maybe<Array<EndfieldSkills>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldSkillsVariants = {
  __typename?: 'EndfieldSkillsVariants';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum EndfieldStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type EndfieldStaticDataGroups = {
  __typename?: 'EndfieldStaticDataGroups';
  attributes: EndfieldAttributesResult;
  class: EndfieldClassResult;
  elements: EndfieldElementsResult;
  gear: EndfieldGearResult;
  gearSets: EndfieldGearSetsResult;
  operators: EndfieldOperatorsResult;
  primaryAttributes: EndfieldPrimaryAttributesResult;
  secondaryAttributes: EndfieldSecondaryAttributesResult;
  skills: EndfieldSkillsResult;
  weaponType: EndfieldWeaponTypeResult;
  weapons: EndfieldWeaponsResult;
};

export type EndfieldStaticDataGroupsattributesArgs = {
  filter?: InputMaybe<EndfieldAttributesFilter>;
};

export type EndfieldStaticDataGroupsclassArgs = {
  filter?: InputMaybe<EndfieldClassFilter>;
};

export type EndfieldStaticDataGroupselementsArgs = {
  filter?: InputMaybe<EndfieldElementsFilter>;
};

export type EndfieldStaticDataGroupsgearArgs = {
  filter?: InputMaybe<EndfieldGearFilter>;
};

export type EndfieldStaticDataGroupsgearSetsArgs = {
  filter?: InputMaybe<EndfieldGearSetsFilter>;
};

export type EndfieldStaticDataGroupsoperatorsArgs = {
  filter?: InputMaybe<EndfieldOperatorsFilter>;
};

export type EndfieldStaticDataGroupsprimaryAttributesArgs = {
  filter?: InputMaybe<EndfieldPrimaryAttributesFilter>;
};

export type EndfieldStaticDataGroupssecondaryAttributesArgs = {
  filter?: InputMaybe<EndfieldSecondaryAttributesFilter>;
};

export type EndfieldStaticDataGroupsskillsArgs = {
  filter?: InputMaybe<EndfieldSkillsFilter>;
};

export type EndfieldStaticDataGroupsweaponTypeArgs = {
  filter?: InputMaybe<EndfieldWeaponTypeFilter>;
};

export type EndfieldStaticDataGroupsweaponsArgs = {
  filter?: InputMaybe<EndfieldWeaponsFilter>;
};

export type EndfieldStaticDataQuery = {
  __typename?: 'EndfieldStaticDataQuery';
  groups: EndfieldStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type EndfieldStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'EndfieldStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<EndfieldDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: EndfieldStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum EndfieldStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EndfieldStructDocumentCreateInput = {
  document: Scalars['EndfieldStructDocumentInputBase64Json'];
};

export type EndfieldStructDocumentCreatePayload = {
  __typename?: 'EndfieldStructDocumentCreatePayload';
  data?: Maybe<EndfieldStructDocument>;
  error?: Maybe<EndfieldStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldStructDocumentData = NgfStructDocumentData & {
  __typename?: 'EndfieldStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: EndfieldDocumentSeason;
  tags?: Maybe<EndfieldDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum EndfieldStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type EndfieldStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EndfieldStructDocumentPayload = {
  __typename?: 'EndfieldStructDocumentPayload';
  data?: Maybe<EndfieldStructDocument>;
  error?: Maybe<EndfieldStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type EndfieldStructDocumentSetSeoPayload = {
  __typename?: 'EndfieldStructDocumentSetSeoPayload';
  data?: Maybe<EndfieldStructDocument>;
  error?: Maybe<EndfieldStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type EndfieldStructDocumentSetStatusPayload = {
  __typename?: 'EndfieldStructDocumentSetStatusPayload';
  data?: Maybe<EndfieldStructDocument>;
  error?: Maybe<EndfieldStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldStructDocumentUpdateInput = {
  document: Scalars['EndfieldStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type EndfieldStructDocumentUpdatePayload = {
  __typename?: 'EndfieldStructDocumentUpdatePayload';
  data?: Maybe<EndfieldStructDocument>;
  error?: Maybe<EndfieldStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type EndfieldTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'EndfieldTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<EndfieldDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: EndfieldTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type EndfieldTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'EndfieldTemplateDocumentData';
  buildVariants?: Maybe<EndfieldUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: EndfieldDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum EndfieldTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldTemplateDocumentInput = {
  type: Scalars['String'];
};

export type EndfieldTemplateDocumentPayload = {
  __typename?: 'EndfieldTemplateDocumentPayload';
  data?: Maybe<EndfieldTemplateDocument>;
  error?: Maybe<EndfieldTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'EndfieldUGDocumentGenericBuilder';
  slots?: Maybe<Array<EndfieldUGDocumentGenericBuilderSlot>>;
};

export type EndfieldUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'EndfieldUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<EndfieldEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type EndfieldUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'EndfieldUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<EndfieldDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: EndfieldUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<EndfieldDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type EndfieldUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'EndfieldUserGeneratedDocumentBuildVariant';
  genericBuilder: EndfieldUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type EndfieldUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'EndfieldUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<EndfieldUserGeneratedDocumentBuildVariant>>;
};

export enum EndfieldUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EndfieldUserGeneratedDocumentCreateInput = {
  document: Scalars['EndfieldUserGeneratedDocumentInputBase64Json'];
};

export type EndfieldUserGeneratedDocumentCreatePayload = {
  __typename?: 'EndfieldUserGeneratedDocumentCreatePayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'EndfieldUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<EndfieldUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: EndfieldDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum EndfieldUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type EndfieldUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EndfieldUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EndfieldUserGeneratedDocumentPayload = {
  __typename?: 'EndfieldUserGeneratedDocumentPayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type EndfieldUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'EndfieldUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EndfieldUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type EndfieldUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'EndfieldUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type EndfieldUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'EndfieldUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type EndfieldUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'EndfieldUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type EndfieldUserGeneratedDocumentUpdateInput = {
  document: Scalars['EndfieldUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type EndfieldUserGeneratedDocumentUpdatePayload = {
  __typename?: 'EndfieldUserGeneratedDocumentUpdatePayload';
  data?: Maybe<EndfieldUserGeneratedDocument>;
  error?: Maybe<EndfieldUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type EndfieldUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type EndfieldWeaponType = EndfieldGameEntity & {
  __typename?: 'EndfieldWeaponType';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type EndfieldWeaponTypeFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldWeaponTypeResult = {
  __typename?: 'EndfieldWeaponTypeResult';
  data?: Maybe<Array<EndfieldWeaponType>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldWeapons = EndfieldGameEntity & {
  __typename?: 'EndfieldWeapons';
  attack?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  effects?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  passiveBoost?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  skillName?: Maybe<Scalars['String']>;
  skillType?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statsBoost?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type EndfieldWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type EndfieldWeaponsResult = {
  __typename?: 'EndfieldWeaponsResult';
  data?: Maybe<Array<EndfieldWeapons>>;
  error?: Maybe<EndfieldStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type EndfieldWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'EndfieldWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<EndfieldDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: EndfieldWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<EndfieldDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type EndfieldWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'EndfieldWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: EndfieldEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum EndfieldWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type EndfieldWikiDocumentPayload = {
  __typename?: 'EndfieldWikiDocumentPayload';
  data?: Maybe<EndfieldWikiDocument>;
  error?: Maybe<EndfieldWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type EndfieldWikiDocumentSetSeoPayload = {
  __typename?: 'EndfieldWikiDocumentSetSeoPayload';
  data?: Maybe<EndfieldWikiDocument>;
  error?: Maybe<EndfieldWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum EndfieldWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type EndfieldWikiDocumentUpdateInput = {
  document: Scalars['EndfieldWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type EndfieldWikiDocumentUpdatePayload = {
  __typename?: 'EndfieldWikiDocumentUpdatePayload';
  data?: Maybe<EndfieldWikiDocument>;
  error?: Maybe<EndfieldWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type EndfieldWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type EndfieldWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type EnhancedSearchInput = {
  authors?: InputMaybe<Array<Scalars['String']>>;
  docType?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};

export type EnhancedSearchResponse = {
  __typename?: 'EnhancedSearchResponse';
  main: MainResults;
  side: SideResults;
};

export type EventLog = {
  __typename?: 'EventLog';
  eventPublicId: Scalars['UUID'];
  eventTime: Scalars['Timestamp'];
  eventType: Scalars['String'];
  metadata: Scalars['JSON'];
  xpDelta: Scalars['Int64'];
};

export type EventLogResponse = {
  __typename?: 'EventLogResponse';
  events: Array<EventLog>;
  total: Scalars['Int'];
};

export type ExampleGameCharacters = ExampleGameGameEntity & {
  __typename?: 'ExampleGameCharacters';
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  playstyle?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type ExampleGameCharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type ExampleGameCharactersResult = {
  __typename?: 'ExampleGameCharactersResult';
  data?: Maybe<Array<ExampleGameCharacters>>;
  error?: Maybe<ExampleGameStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type ExampleGameDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'ExampleGameDocumentCmWidgetV1';
  data: ExampleGameDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type ExampleGameDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'ExampleGameDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ExampleGameDocumentContent =
  | ExampleGameDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type ExampleGameDocumentSeason = NgfDocumentSeason & {
  __typename?: 'ExampleGameDocumentSeason';
  slug: Scalars['String'];
};

export type ExampleGameDocumentTags = NgfDocumentTags & {
  __typename?: 'ExampleGameDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type ExampleGameDocumentsMutation = {
  __typename?: 'ExampleGameDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: ExampleGameStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: ExampleGameStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: ExampleGameStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: ExampleGameStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: ExampleGameUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: ExampleGameUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: ExampleGameUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: ExampleGameUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: ExampleGameUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: ExampleGameUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: ExampleGameWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: ExampleGameWikiDocumentUpdatePayload;
};

export type ExampleGameDocumentsMutationstructDocumentCreateArgs = {
  input: ExampleGameStructDocumentCreateInput;
};

export type ExampleGameDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type ExampleGameDocumentsMutationstructDocumentSetStatusArgs = {
  input: ExampleGameStructDocumentSetStatusInput;
};

export type ExampleGameDocumentsMutationstructDocumentUpdateArgs = {
  input: ExampleGameStructDocumentUpdateInput;
};

export type ExampleGameDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: ExampleGameUserGeneratedDocumentCreateInput;
};

export type ExampleGameDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: ExampleGameUserGeneratedDocumentSetFavoriteInput;
};

export type ExampleGameDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: ExampleGameUserGeneratedDocumentSetFeaturedInput;
};

export type ExampleGameDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type ExampleGameDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: ExampleGameUserGeneratedDocumentSetStatusInput;
};

export type ExampleGameDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: ExampleGameUserGeneratedDocumentUpdateInput;
};

export type ExampleGameDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type ExampleGameDocumentsMutationwikiDocumentUpdateArgs = {
  input: ExampleGameWikiDocumentUpdateInput;
};

export type ExampleGameDocumentsQuery = {
  __typename?: 'ExampleGameDocumentsQuery';
  previewDocumentContent: ExampleGamePreviewDocumentContentPayload;
  structDocumentBySlug: ExampleGameStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: ExampleGameUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: ExampleGameUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: ExampleGameUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: ExampleGameUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: ExampleGameTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: ExampleGameWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type ExampleGameDocumentsQuerypreviewDocumentContentArgs = {
  input: ExampleGamePreviewDocumentContentInput;
};

export type ExampleGameDocumentsQuerystructDocumentBySlugArgs = {
  input: ExampleGameStructDocumentInputBySlug;
};

export type ExampleGameDocumentsQuerystructDocumentsArgs = {
  input: ExampleGameStructDocumentsInput;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: ExampleGameUserGeneratedDocumentInputById;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: ExampleGameUserGeneratedDocumentInputBySlug;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: ExampleGameTemplateDocumentInput;
};

export type ExampleGameDocumentsQueryuserGeneratedDocumentsArgs = {
  input: ExampleGameUserGeneratedDocumentsListInput;
  page: ExampleGameUserGeneratedDocumentsListPage;
};

export type ExampleGameDocumentsQuerywikiDocumentArgs = {
  input: ExampleGameWikiDocumentInput;
};

export type ExampleGameDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<ExampleGameWikiDocumentsListInput>;
  page: ExampleGameWikiDocumentsListPage;
};

export enum ExampleGameEntitiesEnum {
  characters = 'characters',
  fuses = 'fuses',
  inputs = 'inputs',
}

export type ExampleGameEntityObject = NGFEntityObject & {
  __typename?: 'ExampleGameEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<ExampleGameGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ExampleGameFuses = ExampleGameGameEntity & {
  __typename?: 'ExampleGameFuses';
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ExampleGameFusesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type ExampleGameFusesResult = {
  __typename?: 'ExampleGameFusesResult';
  data?: Maybe<Array<ExampleGameFuses>>;
  error?: Maybe<ExampleGameStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type ExampleGameGameEntity = {
  slug: Scalars['String'];
};

export type ExampleGameInputs = ExampleGameGameEntity & {
  __typename?: 'ExampleGameInputs';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ExampleGameInputsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type ExampleGameInputsResult = {
  __typename?: 'ExampleGameInputsResult';
  data?: Maybe<Array<ExampleGameInputs>>;
  error?: Maybe<ExampleGameStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type ExampleGameMutation = {
  __typename?: 'ExampleGameMutation';
  documents?: Maybe<ExampleGameDocumentsMutation>;
  id: Scalars['ID'];
};

export enum ExampleGamePreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGamePreviewDocumentContentInput = {
  content: Scalars['ExampleGameDocumentContentInputBase64Json'];
};

export type ExampleGamePreviewDocumentContentPayload = {
  __typename?: 'ExampleGamePreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<ExampleGameDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<ExampleGamePreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameProfile = NgfProfile & {
  __typename?: 'ExampleGameProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type ExampleGameProfileuserGeneratedDocumentsArgs = {
  input: ExampleGameUserGeneratedDocumentsListInput;
  page: ExampleGameUserGeneratedDocumentsListPage;
};

export type ExampleGameProfilePayload = {
  __typename?: 'ExampleGameProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<ExampleGameProfile>;
};

export type ExampleGameProfilesQuery = {
  __typename?: 'ExampleGameProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: ExampleGameProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type ExampleGameProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type ExampleGameQuery = {
  __typename?: 'ExampleGameQuery';
  documents?: Maybe<ExampleGameDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<ExampleGameProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<ExampleGameStaticDataQuery>;
};

export enum ExampleGameStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type ExampleGameStaticDataGroups = {
  __typename?: 'ExampleGameStaticDataGroups';
  characters: ExampleGameCharactersResult;
  fuses: ExampleGameFusesResult;
  inputs: ExampleGameInputsResult;
};

export type ExampleGameStaticDataGroupscharactersArgs = {
  filter?: InputMaybe<ExampleGameCharactersFilter>;
};

export type ExampleGameStaticDataGroupsfusesArgs = {
  filter?: InputMaybe<ExampleGameFusesFilter>;
};

export type ExampleGameStaticDataGroupsinputsArgs = {
  filter?: InputMaybe<ExampleGameInputsFilter>;
};

export type ExampleGameStaticDataQuery = {
  __typename?: 'ExampleGameStaticDataQuery';
  groups: ExampleGameStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type ExampleGameStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'ExampleGameStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<ExampleGameDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ExampleGameStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum ExampleGameStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ExampleGameStructDocumentCreateInput = {
  document: Scalars['ExampleGameStructDocumentInputBase64Json'];
};

export type ExampleGameStructDocumentCreatePayload = {
  __typename?: 'ExampleGameStructDocumentCreatePayload';
  data?: Maybe<ExampleGameStructDocument>;
  error?: Maybe<ExampleGameStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameStructDocumentData = NgfStructDocumentData & {
  __typename?: 'ExampleGameStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ExampleGameDocumentSeason;
  tags?: Maybe<ExampleGameDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum ExampleGameStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type ExampleGameStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ExampleGameStructDocumentPayload = {
  __typename?: 'ExampleGameStructDocumentPayload';
  data?: Maybe<ExampleGameStructDocument>;
  error?: Maybe<ExampleGameStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ExampleGameStructDocumentSetSeoPayload = {
  __typename?: 'ExampleGameStructDocumentSetSeoPayload';
  data?: Maybe<ExampleGameStructDocument>;
  error?: Maybe<ExampleGameStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type ExampleGameStructDocumentSetStatusPayload = {
  __typename?: 'ExampleGameStructDocumentSetStatusPayload';
  data?: Maybe<ExampleGameStructDocument>;
  error?: Maybe<ExampleGameStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameStructDocumentUpdateInput = {
  document: Scalars['ExampleGameStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type ExampleGameStructDocumentUpdatePayload = {
  __typename?: 'ExampleGameStructDocumentUpdatePayload';
  data?: Maybe<ExampleGameStructDocument>;
  error?: Maybe<ExampleGameStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type ExampleGameTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'ExampleGameTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<ExampleGameDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: ExampleGameTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type ExampleGameTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'ExampleGameTemplateDocumentData';
  buildVariants?: Maybe<ExampleGameUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ExampleGameDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum ExampleGameTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameTemplateDocumentInput = {
  type: Scalars['String'];
};

export type ExampleGameTemplateDocumentPayload = {
  __typename?: 'ExampleGameTemplateDocumentPayload';
  data?: Maybe<ExampleGameTemplateDocument>;
  error?: Maybe<ExampleGameTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'ExampleGameUGDocumentGenericBuilder';
  slots?: Maybe<Array<ExampleGameUGDocumentGenericBuilderSlot>>;
};

export type ExampleGameUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'ExampleGameUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<ExampleGameEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type ExampleGameUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'ExampleGameUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<ExampleGameDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ExampleGameUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<ExampleGameDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type ExampleGameUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'ExampleGameUserGeneratedDocumentBuildVariant';
  genericBuilder: ExampleGameUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type ExampleGameUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'ExampleGameUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<ExampleGameUserGeneratedDocumentBuildVariant>>;
};

export enum ExampleGameUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ExampleGameUserGeneratedDocumentCreateInput = {
  document: Scalars['ExampleGameUserGeneratedDocumentInputBase64Json'];
};

export type ExampleGameUserGeneratedDocumentCreatePayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentCreatePayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'ExampleGameUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<ExampleGameUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ExampleGameDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum ExampleGameUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type ExampleGameUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ExampleGameUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ExampleGameUserGeneratedDocumentPayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentPayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type ExampleGameUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ExampleGameUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type ExampleGameUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ExampleGameUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type ExampleGameUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ExampleGameUserGeneratedDocumentUpdateInput = {
  document: Scalars['ExampleGameUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type ExampleGameUserGeneratedDocumentUpdatePayload = {
  __typename?: 'ExampleGameUserGeneratedDocumentUpdatePayload';
  data?: Maybe<ExampleGameUserGeneratedDocument>;
  error?: Maybe<ExampleGameUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type ExampleGameUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type ExampleGameWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'ExampleGameWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<ExampleGameDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ExampleGameWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<ExampleGameDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type ExampleGameWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'ExampleGameWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: ExampleGameEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum ExampleGameWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ExampleGameWikiDocumentPayload = {
  __typename?: 'ExampleGameWikiDocumentPayload';
  data?: Maybe<ExampleGameWikiDocument>;
  error?: Maybe<ExampleGameWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ExampleGameWikiDocumentSetSeoPayload = {
  __typename?: 'ExampleGameWikiDocumentSetSeoPayload';
  data?: Maybe<ExampleGameWikiDocument>;
  error?: Maybe<ExampleGameWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ExampleGameWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ExampleGameWikiDocumentUpdateInput = {
  document: Scalars['ExampleGameWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type ExampleGameWikiDocumentUpdatePayload = {
  __typename?: 'ExampleGameWikiDocumentUpdatePayload';
  data?: Maybe<ExampleGameWikiDocument>;
  error?: Maybe<ExampleGameWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExampleGameWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type ExampleGameWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type GiArtifactSets = GiGameEntity & {
  __typename?: 'GiArtifactSets';
  deprecated: Scalars['Boolean'];
  effect?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type GiArtifactSetsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiArtifactSetsResult = {
  __typename?: 'GiArtifactSetsResult';
  data?: Maybe<Array<GiArtifactSets>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type GiCharacters = GiGameEntity & {
  __typename?: 'GiCharacters';
  baseStats?: Maybe<Array<GiCharactersBaseStats>>;
  deprecated: Scalars['Boolean'];
  element?: Maybe<GiElements>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  resonance?: Maybe<GiResonances>;
  slug: Scalars['String'];
  weaponType?: Maybe<GiWeaponTypes>;
};

export type GiCharactersBaseStats = {
  __typename?: 'GiCharactersBaseStats';
  stat?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type GiCharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiCharactersResult = {
  __typename?: 'GiCharactersResult';
  data?: Maybe<Array<GiCharacters>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type GiDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'GiDocumentCmWidgetV1';
  data: GiDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type GiDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'GiDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type GiDocumentContent =
  | GiDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type GiDocumentSeason = NgfDocumentSeason & {
  __typename?: 'GiDocumentSeason';
  slug: Scalars['String'];
};

export type GiDocumentTags = NgfDocumentTags & {
  __typename?: 'GiDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type GiDocumentsMutation = {
  __typename?: 'GiDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: GiStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: GiStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: GiStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: GiStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: GiUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: GiUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: GiUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: GiUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: GiUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: GiUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: GiWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: GiWikiDocumentUpdatePayload;
};

export type GiDocumentsMutationstructDocumentCreateArgs = {
  input: GiStructDocumentCreateInput;
};

export type GiDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type GiDocumentsMutationstructDocumentSetStatusArgs = {
  input: GiStructDocumentSetStatusInput;
};

export type GiDocumentsMutationstructDocumentUpdateArgs = {
  input: GiStructDocumentUpdateInput;
};

export type GiDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: GiUserGeneratedDocumentCreateInput;
};

export type GiDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: GiUserGeneratedDocumentSetFavoriteInput;
};

export type GiDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: GiUserGeneratedDocumentSetFeaturedInput;
};

export type GiDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type GiDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: GiUserGeneratedDocumentSetStatusInput;
};

export type GiDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: GiUserGeneratedDocumentUpdateInput;
};

export type GiDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type GiDocumentsMutationwikiDocumentUpdateArgs = {
  input: GiWikiDocumentUpdateInput;
};

export type GiDocumentsQuery = {
  __typename?: 'GiDocumentsQuery';
  previewDocumentContent: GiPreviewDocumentContentPayload;
  structDocumentBySlug: GiStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: GiUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: GiUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: GiUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: GiUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: GiTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: GiWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type GiDocumentsQuerypreviewDocumentContentArgs = {
  input: GiPreviewDocumentContentInput;
};

export type GiDocumentsQuerystructDocumentBySlugArgs = {
  input: GiStructDocumentInputBySlug;
};

export type GiDocumentsQuerystructDocumentsArgs = {
  input: GiStructDocumentsInput;
};

export type GiDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: GiUserGeneratedDocumentInputById;
};

export type GiDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: GiUserGeneratedDocumentInputBySlug;
};

export type GiDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type GiDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type GiDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type GiDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type GiDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: GiTemplateDocumentInput;
};

export type GiDocumentsQueryuserGeneratedDocumentsArgs = {
  input: GiUserGeneratedDocumentsListInput;
  page: GiUserGeneratedDocumentsListPage;
};

export type GiDocumentsQuerywikiDocumentArgs = {
  input: GiWikiDocumentInput;
};

export type GiDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<GiWikiDocumentsListInput>;
  page: GiWikiDocumentsListPage;
};

export type GiElements = GiGameEntity & {
  __typename?: 'GiElements';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type GiElementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiElementsResult = {
  __typename?: 'GiElementsResult';
  data?: Maybe<Array<GiElements>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum GiEntitiesEnum {
  artifactSets = 'artifactSets',
  characters = 'characters',
  elements = 'elements',
  resonances = 'resonances',
  skills = 'skills',
  stats = 'stats',
  weaponTypes = 'weaponTypes',
  weapons = 'weapons',
}

export type GiEntityObject = NGFEntityObject & {
  __typename?: 'GiEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<GiGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type GiGameEntity = {
  slug: Scalars['String'];
};

export type GiMutation = {
  __typename?: 'GiMutation';
  documents?: Maybe<GiDocumentsMutation>;
  id: Scalars['ID'];
};

export enum GiPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiPreviewDocumentContentInput = {
  content: Scalars['GiDocumentContentInputBase64Json'];
};

export type GiPreviewDocumentContentPayload = {
  __typename?: 'GiPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<GiDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<GiPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiProfile = NgfProfile & {
  __typename?: 'GiProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type GiProfileuserGeneratedDocumentsArgs = {
  input: GiUserGeneratedDocumentsListInput;
  page: GiUserGeneratedDocumentsListPage;
};

export type GiProfilePayload = {
  __typename?: 'GiProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<GiProfile>;
};

export type GiProfilesQuery = {
  __typename?: 'GiProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: GiProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type GiProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type GiQuery = {
  __typename?: 'GiQuery';
  documents?: Maybe<GiDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<GiProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<GiStaticDataQuery>;
};

export type GiResonances = GiGameEntity & {
  __typename?: 'GiResonances';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type GiResonancesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiResonancesResult = {
  __typename?: 'GiResonancesResult';
  data?: Maybe<Array<GiResonances>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type GiSkills = GiGameEntity & {
  __typename?: 'GiSkills';
  character?: Maybe<GiCharacters>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  multipliers?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type GiSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiSkillsResult = {
  __typename?: 'GiSkillsResult';
  data?: Maybe<Array<GiSkills>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum GiStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type GiStaticDataGroups = {
  __typename?: 'GiStaticDataGroups';
  artifactSets: GiArtifactSetsResult;
  characters: GiCharactersResult;
  elements: GiElementsResult;
  resonances: GiResonancesResult;
  skills: GiSkillsResult;
  stats: GiStatsResult;
  weaponTypes: GiWeaponTypesResult;
  weapons: GiWeaponsResult;
};

export type GiStaticDataGroupsartifactSetsArgs = {
  filter?: InputMaybe<GiArtifactSetsFilter>;
};

export type GiStaticDataGroupscharactersArgs = {
  filter?: InputMaybe<GiCharactersFilter>;
};

export type GiStaticDataGroupselementsArgs = {
  filter?: InputMaybe<GiElementsFilter>;
};

export type GiStaticDataGroupsresonancesArgs = {
  filter?: InputMaybe<GiResonancesFilter>;
};

export type GiStaticDataGroupsskillsArgs = {
  filter?: InputMaybe<GiSkillsFilter>;
};

export type GiStaticDataGroupsstatsArgs = {
  filter?: InputMaybe<GiStatsFilter>;
};

export type GiStaticDataGroupsweaponTypesArgs = {
  filter?: InputMaybe<GiWeaponTypesFilter>;
};

export type GiStaticDataGroupsweaponsArgs = {
  filter?: InputMaybe<GiWeaponsFilter>;
};

export type GiStaticDataQuery = {
  __typename?: 'GiStaticDataQuery';
  groups: GiStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type GiStats = GiGameEntity & {
  __typename?: 'GiStats';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type GiStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiStatsResult = {
  __typename?: 'GiStatsResult';
  data?: Maybe<Array<GiStats>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type GiStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'GiStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<GiDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: GiStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum GiStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type GiStructDocumentCreateInput = {
  document: Scalars['GiStructDocumentInputBase64Json'];
};

export type GiStructDocumentCreatePayload = {
  __typename?: 'GiStructDocumentCreatePayload';
  data?: Maybe<GiStructDocument>;
  error?: Maybe<GiStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiStructDocumentData = NgfStructDocumentData & {
  __typename?: 'GiStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: GiDocumentSeason;
  tags?: Maybe<GiDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum GiStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type GiStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type GiStructDocumentPayload = {
  __typename?: 'GiStructDocumentPayload';
  data?: Maybe<GiStructDocument>;
  error?: Maybe<GiStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type GiStructDocumentSetSeoPayload = {
  __typename?: 'GiStructDocumentSetSeoPayload';
  data?: Maybe<GiStructDocument>;
  error?: Maybe<GiStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type GiStructDocumentSetStatusPayload = {
  __typename?: 'GiStructDocumentSetStatusPayload';
  data?: Maybe<GiStructDocument>;
  error?: Maybe<GiStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiStructDocumentUpdateInput = {
  document: Scalars['GiStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type GiStructDocumentUpdatePayload = {
  __typename?: 'GiStructDocumentUpdatePayload';
  data?: Maybe<GiStructDocument>;
  error?: Maybe<GiStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type GiTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'GiTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<GiDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: GiTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type GiTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'GiTemplateDocumentData';
  buildVariants?: Maybe<GiUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: GiDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum GiTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiTemplateDocumentInput = {
  type: Scalars['String'];
};

export type GiTemplateDocumentPayload = {
  __typename?: 'GiTemplateDocumentPayload';
  data?: Maybe<GiTemplateDocument>;
  error?: Maybe<GiTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'GiUGDocumentGenericBuilder';
  slots?: Maybe<Array<GiUGDocumentGenericBuilderSlot>>;
};

export type GiUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'GiUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<GiEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type GiUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'GiUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<GiDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: GiUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<GiDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type GiUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'GiUserGeneratedDocumentBuildVariant';
  genericBuilder: GiUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type GiUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'GiUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<GiUserGeneratedDocumentBuildVariant>>;
};

export enum GiUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type GiUserGeneratedDocumentCreateInput = {
  document: Scalars['GiUserGeneratedDocumentInputBase64Json'];
};

export type GiUserGeneratedDocumentCreatePayload = {
  __typename?: 'GiUserGeneratedDocumentCreatePayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'GiUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<GiUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: GiDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum GiUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type GiUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type GiUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type GiUserGeneratedDocumentPayload = {
  __typename?: 'GiUserGeneratedDocumentPayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type GiUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'GiUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type GiUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type GiUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'GiUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type GiUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'GiUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type GiUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'GiUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type GiUserGeneratedDocumentUpdateInput = {
  document: Scalars['GiUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type GiUserGeneratedDocumentUpdatePayload = {
  __typename?: 'GiUserGeneratedDocumentUpdatePayload';
  data?: Maybe<GiUserGeneratedDocument>;
  error?: Maybe<GiUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type GiUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type GiWeaponTypes = GiGameEntity & {
  __typename?: 'GiWeaponTypes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type GiWeaponTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiWeaponTypesResult = {
  __typename?: 'GiWeaponTypesResult';
  data?: Maybe<Array<GiWeaponTypes>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type GiWeapons = GiGameEntity & {
  __typename?: 'GiWeapons';
  attack?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  passiveBoost?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  skillName?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statsBoost?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type GiWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type GiWeaponsResult = {
  __typename?: 'GiWeaponsResult';
  data?: Maybe<Array<GiWeapons>>;
  error?: Maybe<GiStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type GiWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'GiWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<GiDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: GiWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<GiDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type GiWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'GiWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: GiEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum GiWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type GiWikiDocumentPayload = {
  __typename?: 'GiWikiDocumentPayload';
  data?: Maybe<GiWikiDocument>;
  error?: Maybe<GiWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type GiWikiDocumentSetSeoPayload = {
  __typename?: 'GiWikiDocumentSetSeoPayload';
  data?: Maybe<GiWikiDocument>;
  error?: Maybe<GiWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum GiWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type GiWikiDocumentUpdateInput = {
  document: Scalars['GiWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type GiWikiDocumentUpdatePayload = {
  __typename?: 'GiWikiDocumentUpdatePayload';
  data?: Maybe<GiWikiDocument>;
  error?: Maybe<GiWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type GiWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type GiWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Hades2AnimalFamiliar = Hades2GameEntity & {
  __typename?: 'Hades2AnimalFamiliar';
  base?: Maybe<Array<Scalars['String']>>;
  bond?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2AnimalFamiliarsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2AnimalFamiliarsResult = {
  __typename?: 'Hades2AnimalFamiliarsResult';
  data?: Maybe<Array<Hades2AnimalFamiliar>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2ArcanaCard = Hades2GameEntity & {
  __typename?: 'Hades2ArcanaCard';
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  graspCost?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type Hades2ArcanaCardsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2ArcanaCardsResult = {
  __typename?: 'Hades2ArcanaCardsResult';
  data?: Maybe<Array<Hades2ArcanaCard>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2Boon = Hades2GameEntity & {
  __typename?: 'Hades2Boon';
  character?: Maybe<Array<Hades2Character>>;
  characterRef?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  element?: Maybe<Hades2Element>;
  elementRef?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Hades2BoonType>;
  typeRef?: Maybe<Scalars['String']>;
};

export type Hades2BoonType = Hades2GameEntity & {
  __typename?: 'Hades2BoonType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2BoonTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2BoonTypesResult = {
  __typename?: 'Hades2BoonTypesResult';
  data?: Maybe<Array<Hades2BoonType>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2BoonsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2BoonsResult = {
  __typename?: 'Hades2BoonsResult';
  data?: Maybe<Array<Hades2Boon>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2Character = Hades2GameEntity & {
  __typename?: 'Hades2Character';
  group?: Maybe<Hades2CharacterGroup>;
  groupRef?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2CharacterGroup = Hades2GameEntity & {
  __typename?: 'Hades2CharacterGroup';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2CharacterGroupsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2CharacterGroupsResult = {
  __typename?: 'Hades2CharacterGroupsResult';
  data?: Maybe<Array<Hades2CharacterGroup>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2CharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2CharactersResult = {
  __typename?: 'Hades2CharactersResult';
  data?: Maybe<Array<Hades2Character>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2Cost = {
  __typename?: 'Hades2Cost';
  rank?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Hades2Description = {
  __typename?: 'Hades2Description';
  rank?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Hades2DocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'Hades2DocumentCmWidgetV1';
  data: Hades2DocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Hades2DocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'Hades2DocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Hades2DocumentContent =
  | Hades2DocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type Hades2DocumentSeason = NgfDocumentSeason & {
  __typename?: 'Hades2DocumentSeason';
  slug: Scalars['String'];
};

export type Hades2DocumentTags = NgfDocumentTags & {
  __typename?: 'Hades2DocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type Hades2DocumentsMutation = {
  __typename?: 'Hades2DocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: Hades2StructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: Hades2StructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: Hades2StructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: Hades2StructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: Hades2UserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: Hades2UserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: Hades2UserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: Hades2UserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: Hades2UserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: Hades2UserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: Hades2WikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: Hades2WikiDocumentUpdatePayload;
};

export type Hades2DocumentsMutationstructDocumentCreateArgs = {
  input: Hades2StructDocumentCreateInput;
};

export type Hades2DocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Hades2DocumentsMutationstructDocumentSetStatusArgs = {
  input: Hades2StructDocumentSetStatusInput;
};

export type Hades2DocumentsMutationstructDocumentUpdateArgs = {
  input: Hades2StructDocumentUpdateInput;
};

export type Hades2DocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: Hades2UserGeneratedDocumentCreateInput;
};

export type Hades2DocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: Hades2UserGeneratedDocumentSetFavoriteInput;
};

export type Hades2DocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: Hades2UserGeneratedDocumentSetFeaturedInput;
};

export type Hades2DocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Hades2DocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: Hades2UserGeneratedDocumentSetStatusInput;
};

export type Hades2DocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: Hades2UserGeneratedDocumentUpdateInput;
};

export type Hades2DocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type Hades2DocumentsMutationwikiDocumentUpdateArgs = {
  input: Hades2WikiDocumentUpdateInput;
};

export type Hades2DocumentsQuery = {
  __typename?: 'Hades2DocumentsQuery';
  previewDocumentContent: Hades2PreviewDocumentContentPayload;
  structDocumentBySlug: Hades2StructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: Hades2UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: Hades2UserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: Hades2UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: Hades2UserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: Hades2TemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: Hades2WikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type Hades2DocumentsQuerypreviewDocumentContentArgs = {
  input: Hades2PreviewDocumentContentInput;
};

export type Hades2DocumentsQuerystructDocumentBySlugArgs = {
  input: Hades2StructDocumentInputBySlug;
};

export type Hades2DocumentsQuerystructDocumentsArgs = {
  input: Hades2StructDocumentsInput;
};

export type Hades2DocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: Hades2UserGeneratedDocumentInputById;
};

export type Hades2DocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: Hades2UserGeneratedDocumentInputBySlug;
};

export type Hades2DocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type Hades2DocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type Hades2DocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type Hades2DocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type Hades2DocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: Hades2TemplateDocumentInput;
};

export type Hades2DocumentsQueryuserGeneratedDocumentsArgs = {
  input: Hades2UserGeneratedDocumentsListInput;
  page: Hades2UserGeneratedDocumentsListPage;
};

export type Hades2DocumentsQuerywikiDocumentArgs = {
  input: Hades2WikiDocumentInput;
};

export type Hades2DocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<Hades2WikiDocumentsListInput>;
  page: Hades2WikiDocumentsListPage;
};

export type Hades2Element = Hades2GameEntity & {
  __typename?: 'Hades2Element';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2ElementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2ElementsResult = {
  __typename?: 'Hades2ElementsResult';
  data?: Maybe<Array<Hades2Element>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Hades2EntitiesEnum {
  animalFamiliars = 'animalFamiliars',
  arcanaCards = 'arcanaCards',
  boonTypes = 'boonTypes',
  boons = 'boons',
  characterGroups = 'characterGroups',
  characters = 'characters',
  elements = 'elements',
  hammerUpgrades = 'hammerUpgrades',
  hexUpgradeTypes = 'hexUpgradeTypes',
  hexUpgrades = 'hexUpgrades',
  hexes = 'hexes',
  keepsakes = 'keepsakes',
  nocturnalArms = 'nocturnalArms',
  nocturnalAspects = 'nocturnalAspects',
  unseenOaths = 'unseenOaths',
}

export type Hades2EntityObject = NGFEntityObject & {
  __typename?: 'Hades2EntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<Hades2GameEntity>;
  enumType?: Maybe<Hades2EntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Hades2Fear = {
  __typename?: 'Hades2Fear';
  rank?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Hades2GameEntity = {
  slug: Scalars['String'];
};

export type Hades2HammerUpgrade = Hades2GameEntity & {
  __typename?: 'Hades2HammerUpgrade';
  description?: Maybe<Array<Hades2Description>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  weapon?: Maybe<Hades2NocturnalArm>;
  weaponRef?: Maybe<Scalars['String']>;
};

export type Hades2HammerUpgradesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2HammerUpgradesResult = {
  __typename?: 'Hades2HammerUpgradesResult';
  data?: Maybe<Array<Hades2HammerUpgrade>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2Hex = Hades2GameEntity & {
  __typename?: 'Hades2Hex';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  upgrades?: Maybe<Array<Hades2HexUpgrade>>;
  upgradesRef?: Maybe<Array<Scalars['String']>>;
};

export type Hades2HexUpgrade = Hades2GameEntity & {
  __typename?: 'Hades2HexUpgrade';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  upgradeType?: Maybe<Hades2HexUpgradeType>;
  upgradeTypeRef?: Maybe<Scalars['String']>;
};

export type Hades2HexUpgradeType = Hades2GameEntity & {
  __typename?: 'Hades2HexUpgradeType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2HexUpgradeTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2HexUpgradeTypesResult = {
  __typename?: 'Hades2HexUpgradeTypesResult';
  data?: Maybe<Array<Hades2HexUpgradeType>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2HexUpgradesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2HexUpgradesResult = {
  __typename?: 'Hades2HexUpgradesResult';
  data?: Maybe<Array<Hades2HexUpgrade>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2HexesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2HexesResult = {
  __typename?: 'Hades2HexesResult';
  data?: Maybe<Array<Hades2Hex>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2Keepsake = Hades2GameEntity & {
  __typename?: 'Hades2Keepsake';
  character?: Maybe<Hades2Character>;
  characterRef?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2KeepsakesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2KeepsakesResult = {
  __typename?: 'Hades2KeepsakesResult';
  data?: Maybe<Array<Hades2Keepsake>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2Mutation = {
  __typename?: 'Hades2Mutation';
  documents?: Maybe<Hades2DocumentsMutation>;
  id: Scalars['ID'];
};

export type Hades2NocturnalArm = Hades2GameEntity & {
  __typename?: 'Hades2NocturnalArm';
  description?: Maybe<Scalars['String']>;
  entity?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  formerWielder?: Maybe<Hades2Character>;
  formerWielderRef?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  unlock?: Maybe<Scalars['String']>;
};

export type Hades2NocturnalArmsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2NocturnalArmsResult = {
  __typename?: 'Hades2NocturnalArmsResult';
  data?: Maybe<Array<Hades2NocturnalArm>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2NocturnalAspect = Hades2GameEntity & {
  __typename?: 'Hades2NocturnalAspect';
  cost?: Maybe<Array<Hades2Cost>>;
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  weapon?: Maybe<Hades2NocturnalArm>;
  weaponRef?: Maybe<Scalars['String']>;
};

export type Hades2NocturnalAspectsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2NocturnalAspectsResult = {
  __typename?: 'Hades2NocturnalAspectsResult';
  data?: Maybe<Array<Hades2NocturnalAspect>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Hades2PreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2PreviewDocumentContentInput = {
  content: Scalars['Hades2DocumentContentInputBase64Json'];
};

export type Hades2PreviewDocumentContentPayload = {
  __typename?: 'Hades2PreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<Hades2DocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<Hades2PreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2Profile = NgfProfile & {
  __typename?: 'Hades2Profile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type Hades2ProfileuserGeneratedDocumentsArgs = {
  input: Hades2UserGeneratedDocumentsListInput;
  page: Hades2UserGeneratedDocumentsListPage;
};

export type Hades2ProfilePayload = {
  __typename?: 'Hades2ProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<Hades2Profile>;
};

export type Hades2ProfilesQuery = {
  __typename?: 'Hades2ProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: Hades2ProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type Hades2ProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type Hades2Query = {
  __typename?: 'Hades2Query';
  documents?: Maybe<Hades2DocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<Hades2ProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<Hades2StaticDataQuery>;
};

export enum Hades2StaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type Hades2StaticDataQuery = {
  __typename?: 'Hades2StaticDataQuery';
  hades2AnimalFamiliars: Hades2AnimalFamiliarsResult;
  hades2ArcanaCards: Hades2ArcanaCardsResult;
  hades2BoonTypes: Hades2BoonTypesResult;
  hades2Boons: Hades2BoonsResult;
  hades2CharacterGroups: Hades2CharacterGroupsResult;
  hades2Characters: Hades2CharactersResult;
  hades2Elements: Hades2ElementsResult;
  hades2HammerUpgrades: Hades2HammerUpgradesResult;
  hades2HexUpgradeTypes: Hades2HexUpgradeTypesResult;
  hades2HexUpgrades: Hades2HexUpgradesResult;
  hades2Hexes: Hades2HexesResult;
  hades2Keepsakes: Hades2KeepsakesResult;
  hades2NocturnalArms: Hades2NocturnalArmsResult;
  hades2NocturnalAspects: Hades2NocturnalAspectsResult;
  hades2UnseenOaths: Hades2UnseenOathsResult;
};

export type Hades2StaticDataQueryhades2AnimalFamiliarsArgs = {
  filter?: InputMaybe<Hades2AnimalFamiliarsFilter>;
};

export type Hades2StaticDataQueryhades2ArcanaCardsArgs = {
  filter?: InputMaybe<Hades2ArcanaCardsFilter>;
};

export type Hades2StaticDataQueryhades2BoonTypesArgs = {
  filter?: InputMaybe<Hades2BoonTypesFilter>;
};

export type Hades2StaticDataQueryhades2BoonsArgs = {
  filter?: InputMaybe<Hades2BoonsFilter>;
};

export type Hades2StaticDataQueryhades2CharacterGroupsArgs = {
  filter?: InputMaybe<Hades2CharacterGroupsFilter>;
};

export type Hades2StaticDataQueryhades2CharactersArgs = {
  filter?: InputMaybe<Hades2CharactersFilter>;
};

export type Hades2StaticDataQueryhades2ElementsArgs = {
  filter?: InputMaybe<Hades2ElementsFilter>;
};

export type Hades2StaticDataQueryhades2HammerUpgradesArgs = {
  filter?: InputMaybe<Hades2HammerUpgradesFilter>;
};

export type Hades2StaticDataQueryhades2HexUpgradeTypesArgs = {
  filter?: InputMaybe<Hades2HexUpgradeTypesFilter>;
};

export type Hades2StaticDataQueryhades2HexUpgradesArgs = {
  filter?: InputMaybe<Hades2HexUpgradesFilter>;
};

export type Hades2StaticDataQueryhades2HexesArgs = {
  filter?: InputMaybe<Hades2HexesFilter>;
};

export type Hades2StaticDataQueryhades2KeepsakesArgs = {
  filter?: InputMaybe<Hades2KeepsakesFilter>;
};

export type Hades2StaticDataQueryhades2NocturnalArmsArgs = {
  filter?: InputMaybe<Hades2NocturnalArmsFilter>;
};

export type Hades2StaticDataQueryhades2NocturnalAspectsArgs = {
  filter?: InputMaybe<Hades2NocturnalAspectsFilter>;
};

export type Hades2StaticDataQueryhades2UnseenOathsArgs = {
  filter?: InputMaybe<Hades2UnseenOathsFilter>;
};

export type Hades2StructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'Hades2StructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Hades2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Hades2StructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum Hades2StructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Hades2StructDocumentCreateInput = {
  document: Scalars['Hades2StructDocumentInputBase64Json'];
};

export type Hades2StructDocumentCreatePayload = {
  __typename?: 'Hades2StructDocumentCreatePayload';
  data?: Maybe<Hades2StructDocument>;
  error?: Maybe<Hades2StructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2StructDocumentData = NgfStructDocumentData & {
  __typename?: 'Hades2StructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Hades2DocumentSeason;
  tags?: Maybe<Hades2DocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum Hades2StructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Hades2StructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Hades2StructDocumentPayload = {
  __typename?: 'Hades2StructDocumentPayload';
  data?: Maybe<Hades2StructDocument>;
  error?: Maybe<Hades2StructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2StructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Hades2StructDocumentSetSeoPayload = {
  __typename?: 'Hades2StructDocumentSetSeoPayload';
  data?: Maybe<Hades2StructDocument>;
  error?: Maybe<Hades2StructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2StructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2StructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type Hades2StructDocumentSetStatusPayload = {
  __typename?: 'Hades2StructDocumentSetStatusPayload';
  data?: Maybe<Hades2StructDocument>;
  error?: Maybe<Hades2StructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2StructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2StructDocumentUpdateInput = {
  document: Scalars['Hades2StructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Hades2StructDocumentUpdatePayload = {
  __typename?: 'Hades2StructDocumentUpdatePayload';
  data?: Maybe<Hades2StructDocument>;
  error?: Maybe<Hades2StructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2StructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type Hades2TemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'Hades2TemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<Hades2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: Hades2TemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type Hades2TemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'Hades2TemplateDocumentData';
  buildVariants?: Maybe<Hades2UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Hades2DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Hades2TemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2TemplateDocumentInput = {
  type: Scalars['String'];
};

export type Hades2TemplateDocumentPayload = {
  __typename?: 'Hades2TemplateDocumentPayload';
  data?: Maybe<Hades2TemplateDocument>;
  error?: Maybe<Hades2TemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2UGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'Hades2UGDocumentGenericBuilder';
  slots?: Maybe<Array<Hades2UGDocumentGenericBuilderSlot>>;
};

export type Hades2UGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'Hades2UGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<Hades2EntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type Hades2UnseenOath = Hades2GameEntity & {
  __typename?: 'Hades2UnseenOath';
  description?: Maybe<Scalars['String']>;
  fear?: Maybe<Array<Hades2Fear>>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Hades2UnseenOathsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Hades2UnseenOathsResult = {
  __typename?: 'Hades2UnseenOathsResult';
  data?: Maybe<Array<Hades2UnseenOath>>;
  error?: Maybe<Hades2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Hades2UserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'Hades2UserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<Hades2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Hades2UserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<Hades2DocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Hades2UserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'Hades2UserGeneratedDocumentBuildVariant';
  genericBuilder: Hades2UGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type Hades2UserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'Hades2UserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<Hades2UserGeneratedDocumentBuildVariant>>;
};

export enum Hades2UserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Hades2UserGeneratedDocumentCreateInput = {
  document: Scalars['Hades2UserGeneratedDocumentInputBase64Json'];
};

export type Hades2UserGeneratedDocumentCreatePayload = {
  __typename?: 'Hades2UserGeneratedDocumentCreatePayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2UserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'Hades2UserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<Hades2UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Hades2DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Hades2UserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Hades2UserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Hades2UserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Hades2UserGeneratedDocumentPayload = {
  __typename?: 'Hades2UserGeneratedDocumentPayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2UserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2UserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type Hades2UserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'Hades2UserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2UserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Hades2UserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type Hades2UserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'Hades2UserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2UserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Hades2UserGeneratedDocumentSetSeoPayload = {
  __typename?: 'Hades2UserGeneratedDocumentSetSeoPayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2UserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2UserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type Hades2UserGeneratedDocumentSetStatusPayload = {
  __typename?: 'Hades2UserGeneratedDocumentSetStatusPayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2UserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Hades2UserGeneratedDocumentUpdateInput = {
  document: Scalars['Hades2UserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Hades2UserGeneratedDocumentUpdatePayload = {
  __typename?: 'Hades2UserGeneratedDocumentUpdatePayload';
  data?: Maybe<Hades2UserGeneratedDocument>;
  error?: Maybe<Hades2UserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2UserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type Hades2UserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Hades2WikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'Hades2WikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Hades2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Hades2WikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<Hades2DocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Hades2WikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'Hades2WikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: Hades2EntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum Hades2WikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2WikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Hades2WikiDocumentPayload = {
  __typename?: 'Hades2WikiDocumentPayload';
  data?: Maybe<Hades2WikiDocument>;
  error?: Maybe<Hades2WikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2WikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Hades2WikiDocumentSetSeoPayload = {
  __typename?: 'Hades2WikiDocumentSetSeoPayload';
  data?: Maybe<Hades2WikiDocument>;
  error?: Maybe<Hades2WikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Hades2WikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Hades2WikiDocumentUpdateInput = {
  document: Scalars['Hades2WikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type Hades2WikiDocumentUpdatePayload = {
  __typename?: 'Hades2WikiDocumentUpdatePayload';
  data?: Maybe<Hades2WikiDocument>;
  error?: Maybe<Hades2WikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Hades2WikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type Hades2WikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export enum LastCompletedBattlePassError {
  INTERNAL = 'INTERNAL',
}

export type LastCompletedBattlePassPayload = {
  __typename?: 'LastCompletedBattlePassPayload';
  data?: Maybe<BattlePass>;
  error?: Maybe<LastCompletedBattlePassError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type LolNgfAbilities = LolNgfGameEntity & {
  __typename?: 'LolNgfAbilities';
  button?: Maybe<Scalars['String']>;
  champion?: Maybe<LolNgfChampions>;
  cooldown?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type LolNgfAbilitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type LolNgfAbilitiesResult = {
  __typename?: 'LolNgfAbilitiesResult';
  data?: Maybe<Array<LolNgfAbilities>>;
  error?: Maybe<LolNgfStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type LolNgfChampions = LolNgfGameEntity & {
  __typename?: 'LolNgfChampions';
  abilities?: Maybe<Array<LolNgfAbilities>>;
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type LolNgfChampionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type LolNgfChampionsResult = {
  __typename?: 'LolNgfChampionsResult';
  data?: Maybe<Array<LolNgfChampions>>;
  error?: Maybe<LolNgfStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type LolNgfDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'LolNgfDocumentCmWidgetV1';
  data: LolNgfDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type LolNgfDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'LolNgfDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type LolNgfDocumentContent =
  | LolNgfDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type LolNgfDocumentSeason = NgfDocumentSeason & {
  __typename?: 'LolNgfDocumentSeason';
  slug: Scalars['String'];
};

export type LolNgfDocumentTags = NgfDocumentTags & {
  __typename?: 'LolNgfDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type LolNgfDocumentsMutation = {
  __typename?: 'LolNgfDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: LolNgfStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: LolNgfStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: LolNgfStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: LolNgfStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: LolNgfUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: LolNgfUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: LolNgfUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: LolNgfUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: LolNgfUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: LolNgfUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: LolNgfWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: LolNgfWikiDocumentUpdatePayload;
};

export type LolNgfDocumentsMutationstructDocumentCreateArgs = {
  input: LolNgfStructDocumentCreateInput;
};

export type LolNgfDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type LolNgfDocumentsMutationstructDocumentSetStatusArgs = {
  input: LolNgfStructDocumentSetStatusInput;
};

export type LolNgfDocumentsMutationstructDocumentUpdateArgs = {
  input: LolNgfStructDocumentUpdateInput;
};

export type LolNgfDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: LolNgfUserGeneratedDocumentCreateInput;
};

export type LolNgfDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: LolNgfUserGeneratedDocumentSetFavoriteInput;
};

export type LolNgfDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: LolNgfUserGeneratedDocumentSetFeaturedInput;
};

export type LolNgfDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type LolNgfDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: LolNgfUserGeneratedDocumentSetStatusInput;
};

export type LolNgfDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: LolNgfUserGeneratedDocumentUpdateInput;
};

export type LolNgfDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type LolNgfDocumentsMutationwikiDocumentUpdateArgs = {
  input: LolNgfWikiDocumentUpdateInput;
};

export type LolNgfDocumentsQuery = {
  __typename?: 'LolNgfDocumentsQuery';
  previewDocumentContent: LolNgfPreviewDocumentContentPayload;
  structDocumentBySlug: LolNgfStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: LolNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: LolNgfUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: LolNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: LolNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: LolNgfTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: LolNgfWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type LolNgfDocumentsQuerypreviewDocumentContentArgs = {
  input: LolNgfPreviewDocumentContentInput;
};

export type LolNgfDocumentsQuerystructDocumentBySlugArgs = {
  input: LolNgfStructDocumentInputBySlug;
};

export type LolNgfDocumentsQuerystructDocumentsArgs = {
  input: LolNgfStructDocumentsInput;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: LolNgfUserGeneratedDocumentInputById;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: LolNgfUserGeneratedDocumentInputBySlug;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: LolNgfTemplateDocumentInput;
};

export type LolNgfDocumentsQueryuserGeneratedDocumentsArgs = {
  input: LolNgfUserGeneratedDocumentsListInput;
  page: LolNgfUserGeneratedDocumentsListPage;
};

export type LolNgfDocumentsQuerywikiDocumentArgs = {
  input: LolNgfWikiDocumentInput;
};

export type LolNgfDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<LolNgfWikiDocumentsListInput>;
  page: LolNgfWikiDocumentsListPage;
};

export enum LolNgfEntitiesEnum {
  abilities = 'abilities',
  champions = 'champions',
  items = 'items',
  masteries = 'masteries',
  runes = 'runes',
  summonerSpells = 'summonerSpells',
}

export type LolNgfEntityObject = NGFEntityObject & {
  __typename?: 'LolNgfEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<LolNgfGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type LolNgfGameEntity = {
  slug: Scalars['String'];
};

export type LolNgfItems = LolNgfGameEntity & {
  __typename?: 'LolNgfItems';
  components?: Maybe<Array<LolNgfItems>>;
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  effects?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<Scalars['String']>>;
};

export type LolNgfItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type LolNgfItemsResult = {
  __typename?: 'LolNgfItemsResult';
  data?: Maybe<Array<LolNgfItems>>;
  error?: Maybe<LolNgfStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type LolNgfMasteries = LolNgfGameEntity & {
  __typename?: 'LolNgfMasteries';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxRank?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  tree?: Maybe<Scalars['String']>;
};

export type LolNgfMasteriesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type LolNgfMasteriesResult = {
  __typename?: 'LolNgfMasteriesResult';
  data?: Maybe<Array<LolNgfMasteries>>;
  error?: Maybe<LolNgfStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type LolNgfMutation = {
  __typename?: 'LolNgfMutation';
  documents?: Maybe<LolNgfDocumentsMutation>;
  id: Scalars['ID'];
};

export enum LolNgfPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfPreviewDocumentContentInput = {
  content: Scalars['LolNgfDocumentContentInputBase64Json'];
};

export type LolNgfPreviewDocumentContentPayload = {
  __typename?: 'LolNgfPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<LolNgfDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<LolNgfPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfProfile = NgfProfile & {
  __typename?: 'LolNgfProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type LolNgfProfileuserGeneratedDocumentsArgs = {
  input: LolNgfUserGeneratedDocumentsListInput;
  page: LolNgfUserGeneratedDocumentsListPage;
};

export type LolNgfProfilePayload = {
  __typename?: 'LolNgfProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<LolNgfProfile>;
};

export type LolNgfProfilesQuery = {
  __typename?: 'LolNgfProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: LolNgfProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type LolNgfProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type LolNgfQuery = {
  __typename?: 'LolNgfQuery';
  documents?: Maybe<LolNgfDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<LolNgfProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<LolNgfStaticDataQuery>;
};

export type LolNgfRunes = LolNgfGameEntity & {
  __typename?: 'LolNgfRunes';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type LolNgfRunesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type LolNgfRunesResult = {
  __typename?: 'LolNgfRunesResult';
  data?: Maybe<Array<LolNgfRunes>>;
  error?: Maybe<LolNgfStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum LolNgfStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type LolNgfStaticDataGroups = {
  __typename?: 'LolNgfStaticDataGroups';
  abilities: LolNgfAbilitiesResult;
  champions: LolNgfChampionsResult;
  items: LolNgfItemsResult;
  masteries: LolNgfMasteriesResult;
  runes: LolNgfRunesResult;
  summonerSpells: LolNgfSummonerSpellsResult;
};

export type LolNgfStaticDataGroupsabilitiesArgs = {
  filter?: InputMaybe<LolNgfAbilitiesFilter>;
};

export type LolNgfStaticDataGroupschampionsArgs = {
  filter?: InputMaybe<LolNgfChampionsFilter>;
};

export type LolNgfStaticDataGroupsitemsArgs = {
  filter?: InputMaybe<LolNgfItemsFilter>;
};

export type LolNgfStaticDataGroupsmasteriesArgs = {
  filter?: InputMaybe<LolNgfMasteriesFilter>;
};

export type LolNgfStaticDataGroupsrunesArgs = {
  filter?: InputMaybe<LolNgfRunesFilter>;
};

export type LolNgfStaticDataGroupssummonerSpellsArgs = {
  filter?: InputMaybe<LolNgfSummonerSpellsFilter>;
};

export type LolNgfStaticDataQuery = {
  __typename?: 'LolNgfStaticDataQuery';
  groups: LolNgfStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type LolNgfStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'LolNgfStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<LolNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: LolNgfStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum LolNgfStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type LolNgfStructDocumentCreateInput = {
  document: Scalars['LolNgfStructDocumentInputBase64Json'];
};

export type LolNgfStructDocumentCreatePayload = {
  __typename?: 'LolNgfStructDocumentCreatePayload';
  data?: Maybe<LolNgfStructDocument>;
  error?: Maybe<LolNgfStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfStructDocumentData = NgfStructDocumentData & {
  __typename?: 'LolNgfStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: LolNgfDocumentSeason;
  tags?: Maybe<LolNgfDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum LolNgfStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type LolNgfStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type LolNgfStructDocumentPayload = {
  __typename?: 'LolNgfStructDocumentPayload';
  data?: Maybe<LolNgfStructDocument>;
  error?: Maybe<LolNgfStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type LolNgfStructDocumentSetSeoPayload = {
  __typename?: 'LolNgfStructDocumentSetSeoPayload';
  data?: Maybe<LolNgfStructDocument>;
  error?: Maybe<LolNgfStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type LolNgfStructDocumentSetStatusPayload = {
  __typename?: 'LolNgfStructDocumentSetStatusPayload';
  data?: Maybe<LolNgfStructDocument>;
  error?: Maybe<LolNgfStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfStructDocumentUpdateInput = {
  document: Scalars['LolNgfStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type LolNgfStructDocumentUpdatePayload = {
  __typename?: 'LolNgfStructDocumentUpdatePayload';
  data?: Maybe<LolNgfStructDocument>;
  error?: Maybe<LolNgfStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type LolNgfSummonerSpells = LolNgfGameEntity & {
  __typename?: 'LolNgfSummonerSpells';
  cooldown?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type LolNgfSummonerSpellsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type LolNgfSummonerSpellsResult = {
  __typename?: 'LolNgfSummonerSpellsResult';
  data?: Maybe<Array<LolNgfSummonerSpells>>;
  error?: Maybe<LolNgfStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type LolNgfTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'LolNgfTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<LolNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: LolNgfTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type LolNgfTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'LolNgfTemplateDocumentData';
  buildVariants?: Maybe<LolNgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: LolNgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum LolNgfTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfTemplateDocumentInput = {
  type: Scalars['String'];
};

export type LolNgfTemplateDocumentPayload = {
  __typename?: 'LolNgfTemplateDocumentPayload';
  data?: Maybe<LolNgfTemplateDocument>;
  error?: Maybe<LolNgfTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'LolNgfUGDocumentGenericBuilder';
  slots?: Maybe<Array<LolNgfUGDocumentGenericBuilderSlot>>;
};

export type LolNgfUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'LolNgfUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<LolNgfEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type LolNgfUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'LolNgfUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<LolNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: LolNgfUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<LolNgfDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type LolNgfUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'LolNgfUserGeneratedDocumentBuildVariant';
  genericBuilder: LolNgfUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type LolNgfUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'LolNgfUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<LolNgfUserGeneratedDocumentBuildVariant>>;
};

export enum LolNgfUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type LolNgfUserGeneratedDocumentCreateInput = {
  document: Scalars['LolNgfUserGeneratedDocumentInputBase64Json'];
};

export type LolNgfUserGeneratedDocumentCreatePayload = {
  __typename?: 'LolNgfUserGeneratedDocumentCreatePayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'LolNgfUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<LolNgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: LolNgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum LolNgfUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type LolNgfUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type LolNgfUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type LolNgfUserGeneratedDocumentPayload = {
  __typename?: 'LolNgfUserGeneratedDocumentPayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type LolNgfUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'LolNgfUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type LolNgfUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type LolNgfUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'LolNgfUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type LolNgfUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'LolNgfUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type LolNgfUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'LolNgfUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type LolNgfUserGeneratedDocumentUpdateInput = {
  document: Scalars['LolNgfUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type LolNgfUserGeneratedDocumentUpdatePayload = {
  __typename?: 'LolNgfUserGeneratedDocumentUpdatePayload';
  data?: Maybe<LolNgfUserGeneratedDocument>;
  error?: Maybe<LolNgfUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type LolNgfUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type LolNgfWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'LolNgfWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<LolNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: LolNgfWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<LolNgfDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type LolNgfWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'LolNgfWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: LolNgfEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum LolNgfWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type LolNgfWikiDocumentPayload = {
  __typename?: 'LolNgfWikiDocumentPayload';
  data?: Maybe<LolNgfWikiDocument>;
  error?: Maybe<LolNgfWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type LolNgfWikiDocumentSetSeoPayload = {
  __typename?: 'LolNgfWikiDocumentSetSeoPayload';
  data?: Maybe<LolNgfWikiDocument>;
  error?: Maybe<LolNgfWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum LolNgfWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type LolNgfWikiDocumentUpdateInput = {
  document: Scalars['LolNgfWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type LolNgfWikiDocumentUpdatePayload = {
  __typename?: 'LolNgfWikiDocumentUpdatePayload';
  data?: Maybe<LolNgfWikiDocument>;
  error?: Maybe<LolNgfWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type LolNgfWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type LolNgfWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type MainResults = {
  __typename?: 'MainResults';
  documents: Array<SearchDocument>;
  requestId: Scalars['String'];
};

export type MarathonAbilities = MarathonGameEntity & {
  __typename?: 'MarathonAbilities';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  runner?: Maybe<MarathonRunners>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type MarathonAbilitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonAbilitiesResult = {
  __typename?: 'MarathonAbilitiesResult';
  data?: Maybe<Array<MarathonAbilities>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonAmmo = MarathonGameEntity & {
  __typename?: 'MarathonAmmo';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type MarathonAmmoFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonAmmoResult = {
  __typename?: 'MarathonAmmoResult';
  data?: Maybe<Array<MarathonAmmo>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonBackpacks = MarathonGameEntity & {
  __typename?: 'MarathonBackpacks';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type MarathonBackpacksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonBackpacksResult = {
  __typename?: 'MarathonBackpacksResult';
  data?: Maybe<Array<MarathonBackpacks>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonConsumables = MarathonGameEntity & {
  __typename?: 'MarathonConsumables';
  consumableType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type MarathonConsumablesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonConsumablesResult = {
  __typename?: 'MarathonConsumablesResult';
  data?: Maybe<Array<MarathonConsumables>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonCores = MarathonGameEntity & {
  __typename?: 'MarathonCores';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  runner?: Maybe<MarathonRunners>;
  slug: Scalars['String'];
};

export type MarathonCoresFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonCoresResult = {
  __typename?: 'MarathonCoresResult';
  data?: Maybe<Array<MarathonCores>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'MarathonDocumentCmWidgetV1';
  data: MarathonDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type MarathonDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'MarathonDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type MarathonDocumentContent =
  | MarathonDocumentCmWidgetV1
  | MarathonDocumentUgWidgetStatsV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type MarathonDocumentSeason = NgfDocumentSeason & {
  __typename?: 'MarathonDocumentSeason';
  slug: Scalars['String'];
};

export type MarathonDocumentTags = NgfDocumentTags & {
  __typename?: 'MarathonDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type MarathonDocumentUgWidgetStatsDataV1 = NgfDocumentContentData & {
  __typename?: 'MarathonDocumentUgWidgetStatsDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type MarathonDocumentUgWidgetStatsV1 = NgfDocumentContent & {
  __typename?: 'MarathonDocumentUgWidgetStatsV1';
  data: MarathonDocumentUgWidgetStatsDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type MarathonDocumentsMutation = {
  __typename?: 'MarathonDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: MarathonStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: MarathonStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: MarathonStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: MarathonStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: MarathonUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: MarathonUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: MarathonUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: MarathonUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: MarathonUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: MarathonUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: MarathonWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: MarathonWikiDocumentUpdatePayload;
};

export type MarathonDocumentsMutationstructDocumentCreateArgs = {
  input: MarathonStructDocumentCreateInput;
};

export type MarathonDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type MarathonDocumentsMutationstructDocumentSetStatusArgs = {
  input: MarathonStructDocumentSetStatusInput;
};

export type MarathonDocumentsMutationstructDocumentUpdateArgs = {
  input: MarathonStructDocumentUpdateInput;
};

export type MarathonDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: MarathonUserGeneratedDocumentCreateInput;
};

export type MarathonDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: MarathonUserGeneratedDocumentSetFavoriteInput;
};

export type MarathonDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: MarathonUserGeneratedDocumentSetFeaturedInput;
};

export type MarathonDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type MarathonDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: MarathonUserGeneratedDocumentSetStatusInput;
};

export type MarathonDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: MarathonUserGeneratedDocumentUpdateInput;
};

export type MarathonDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type MarathonDocumentsMutationwikiDocumentUpdateArgs = {
  input: MarathonWikiDocumentUpdateInput;
};

export type MarathonDocumentsQuery = {
  __typename?: 'MarathonDocumentsQuery';
  previewDocumentContent: MarathonPreviewDocumentContentPayload;
  structDocumentBySlug: MarathonStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: MarathonUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: MarathonUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: MarathonUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: MarathonUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: MarathonTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: MarathonWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type MarathonDocumentsQuerypreviewDocumentContentArgs = {
  input: MarathonPreviewDocumentContentInput;
};

export type MarathonDocumentsQuerystructDocumentBySlugArgs = {
  input: MarathonStructDocumentInputBySlug;
};

export type MarathonDocumentsQuerystructDocumentsArgs = {
  input: MarathonStructDocumentsInput;
};

export type MarathonDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: MarathonUserGeneratedDocumentInputById;
};

export type MarathonDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: MarathonUserGeneratedDocumentInputBySlug;
};

export type MarathonDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type MarathonDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type MarathonDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type MarathonDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type MarathonDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: MarathonTemplateDocumentInput;
};

export type MarathonDocumentsQueryuserGeneratedDocumentsArgs = {
  input: MarathonUserGeneratedDocumentsListInput;
  page: MarathonUserGeneratedDocumentsListPage;
};

export type MarathonDocumentsQuerywikiDocumentArgs = {
  input: MarathonWikiDocumentInput;
};

export type MarathonDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<MarathonWikiDocumentsListInput>;
  page: MarathonWikiDocumentsListPage;
};

export enum MarathonEntitiesEnum {
  abilities = 'abilities',
  ammo = 'ammo',
  backpacks = 'backpacks',
  consumables = 'consumables',
  cores = 'cores',
  equipment = 'equipment',
  implants = 'implants',
  mods = 'mods',
  pointsOfInterest = 'pointsOfInterest',
  runners = 'runners',
  salvage = 'salvage',
  shields = 'shields',
  stats = 'stats',
  upgrades = 'upgrades',
  weaponStats = 'weaponStats',
  weaponTypes = 'weaponTypes',
  weapons = 'weapons',
}

export type MarathonEntityObject = NGFEntityObject & {
  __typename?: 'MarathonEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<MarathonGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  modifiers?: Maybe<MarathonModifiers>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MarathonEquipment = MarathonGameEntity & {
  __typename?: 'MarathonEquipment';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  equipmentType?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type MarathonEquipmentFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonEquipmentResult = {
  __typename?: 'MarathonEquipmentResult';
  data?: Maybe<Array<MarathonEquipment>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonGameEntity = {
  slug: Scalars['String'];
};

export type MarathonImplants = MarathonGameEntity & {
  __typename?: 'MarathonImplants';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implantType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statistics?: Maybe<Array<MarathonImplantsStatistics>>;
  traits?: Maybe<Array<Scalars['String']>>;
};

export type MarathonImplantsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonImplantsResult = {
  __typename?: 'MarathonImplantsResult';
  data?: Maybe<Array<MarathonImplants>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonImplantsStatistics = {
  __typename?: 'MarathonImplantsStatistics';
  stats?: Maybe<MarathonStats>;
  value?: Maybe<Scalars['String']>;
};

export type MarathonModifiers = {
  __typename?: 'MarathonModifiers';
  barrelMod?: Maybe<MarathonEntityObject>;
  chipMod?: Maybe<MarathonEntityObject>;
  gripMod?: Maybe<MarathonEntityObject>;
  magazineMod?: Maybe<MarathonEntityObject>;
  opticMod?: Maybe<MarathonEntityObject>;
};

export type MarathonMods = MarathonGameEntity & {
  __typename?: 'MarathonMods';
  ability?: Maybe<Array<Scalars['String']>>;
  compatibleWeapons?: Maybe<Array<MarathonWeapons>>;
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modSlot?: Maybe<Scalars['String']>;
  modStats?: Maybe<Array<MarathonModsModStats>>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  weaponType?: Maybe<Array<MarathonWeaponTypes>>;
};

export type MarathonModsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonModsModStats = {
  __typename?: 'MarathonModsModStats';
  stats?: Maybe<MarathonWeaponStats>;
  value?: Maybe<Scalars['String']>;
};

export type MarathonModsResult = {
  __typename?: 'MarathonModsResult';
  data?: Maybe<Array<MarathonMods>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonMutation = {
  __typename?: 'MarathonMutation';
  documents?: Maybe<MarathonDocumentsMutation>;
  id: Scalars['ID'];
};

export type MarathonPointsOfInterest = MarathonGameEntity & {
  __typename?: 'MarathonPointsOfInterest';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MarathonPointsOfInterestFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonPointsOfInterestResult = {
  __typename?: 'MarathonPointsOfInterestResult';
  data?: Maybe<Array<MarathonPointsOfInterest>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum MarathonPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonPreviewDocumentContentInput = {
  content: Scalars['MarathonDocumentContentInputBase64Json'];
};

export type MarathonPreviewDocumentContentPayload = {
  __typename?: 'MarathonPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<MarathonDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<MarathonPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonProfile = NgfProfile & {
  __typename?: 'MarathonProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type MarathonProfileuserGeneratedDocumentsArgs = {
  input: MarathonUserGeneratedDocumentsListInput;
  page: MarathonUserGeneratedDocumentsListPage;
};

export type MarathonProfilePayload = {
  __typename?: 'MarathonProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<MarathonProfile>;
};

export type MarathonProfilesQuery = {
  __typename?: 'MarathonProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: MarathonProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type MarathonProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type MarathonQuery = {
  __typename?: 'MarathonQuery';
  documents?: Maybe<MarathonDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<MarathonProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<MarathonStaticDataQuery>;
};

export type MarathonRunners = MarathonGameEntity & {
  __typename?: 'MarathonRunners';
  abilities?: Maybe<Array<Scalars['String']>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  origin?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  runnerAbilities?: Maybe<Array<MarathonAbilities>>;
  slug: Scalars['String'];
  statistics?: Maybe<Array<MarathonRunnersStatistics>>;
  tech?: Maybe<Scalars['String']>;
};

export type MarathonRunnersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonRunnersResult = {
  __typename?: 'MarathonRunnersResult';
  data?: Maybe<Array<MarathonRunners>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonRunnersStatistics = {
  __typename?: 'MarathonRunnersStatistics';
  stats?: Maybe<MarathonStats>;
  value?: Maybe<Scalars['String']>;
};

export type MarathonSalvage = MarathonGameEntity & {
  __typename?: 'MarathonSalvage';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  sources?: Maybe<Array<Scalars['String']>>;
  usage?: Maybe<Array<Scalars['String']>>;
};

export type MarathonSalvageFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonSalvageResult = {
  __typename?: 'MarathonSalvageResult';
  data?: Maybe<Array<MarathonSalvage>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonShields = MarathonGameEntity & {
  __typename?: 'MarathonShields';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statistics?: Maybe<Array<MarathonShieldsStatistics>>;
  traits?: Maybe<Array<Scalars['String']>>;
};

export type MarathonShieldsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonShieldsResult = {
  __typename?: 'MarathonShieldsResult';
  data?: Maybe<Array<MarathonShields>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonShieldsStatistics = {
  __typename?: 'MarathonShieldsStatistics';
  stats?: Maybe<MarathonStats>;
  value?: Maybe<Scalars['String']>;
};

export enum MarathonStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type MarathonStaticDataGroups = {
  __typename?: 'MarathonStaticDataGroups';
  abilities: MarathonAbilitiesResult;
  ammo: MarathonAmmoResult;
  backpacks: MarathonBackpacksResult;
  consumables: MarathonConsumablesResult;
  cores: MarathonCoresResult;
  equipment: MarathonEquipmentResult;
  implants: MarathonImplantsResult;
  mods: MarathonModsResult;
  pointsOfInterest: MarathonPointsOfInterestResult;
  runners: MarathonRunnersResult;
  salvage: MarathonSalvageResult;
  shields: MarathonShieldsResult;
  stats: MarathonStatsResult;
  upgrades: MarathonUpgradesResult;
  weaponStats: MarathonWeaponStatsResult;
  weaponTypes: MarathonWeaponTypesResult;
  weapons: MarathonWeaponsResult;
};

export type MarathonStaticDataGroupsabilitiesArgs = {
  filter?: InputMaybe<MarathonAbilitiesFilter>;
};

export type MarathonStaticDataGroupsammoArgs = {
  filter?: InputMaybe<MarathonAmmoFilter>;
};

export type MarathonStaticDataGroupsbackpacksArgs = {
  filter?: InputMaybe<MarathonBackpacksFilter>;
};

export type MarathonStaticDataGroupsconsumablesArgs = {
  filter?: InputMaybe<MarathonConsumablesFilter>;
};

export type MarathonStaticDataGroupscoresArgs = {
  filter?: InputMaybe<MarathonCoresFilter>;
};

export type MarathonStaticDataGroupsequipmentArgs = {
  filter?: InputMaybe<MarathonEquipmentFilter>;
};

export type MarathonStaticDataGroupsimplantsArgs = {
  filter?: InputMaybe<MarathonImplantsFilter>;
};

export type MarathonStaticDataGroupsmodsArgs = {
  filter?: InputMaybe<MarathonModsFilter>;
};

export type MarathonStaticDataGroupspointsOfInterestArgs = {
  filter?: InputMaybe<MarathonPointsOfInterestFilter>;
};

export type MarathonStaticDataGroupsrunnersArgs = {
  filter?: InputMaybe<MarathonRunnersFilter>;
};

export type MarathonStaticDataGroupssalvageArgs = {
  filter?: InputMaybe<MarathonSalvageFilter>;
};

export type MarathonStaticDataGroupsshieldsArgs = {
  filter?: InputMaybe<MarathonShieldsFilter>;
};

export type MarathonStaticDataGroupsstatsArgs = {
  filter?: InputMaybe<MarathonStatsFilter>;
};

export type MarathonStaticDataGroupsupgradesArgs = {
  filter?: InputMaybe<MarathonUpgradesFilter>;
};

export type MarathonStaticDataGroupsweaponStatsArgs = {
  filter?: InputMaybe<MarathonWeaponStatsFilter>;
};

export type MarathonStaticDataGroupsweaponTypesArgs = {
  filter?: InputMaybe<MarathonWeaponTypesFilter>;
};

export type MarathonStaticDataGroupsweaponsArgs = {
  filter?: InputMaybe<MarathonWeaponsFilter>;
};

export type MarathonStaticDataQuery = {
  __typename?: 'MarathonStaticDataQuery';
  groups: MarathonStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type MarathonStats = MarathonGameEntity & {
  __typename?: 'MarathonStats';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MarathonStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonStatsResult = {
  __typename?: 'MarathonStatsResult';
  data?: Maybe<Array<MarathonStats>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'MarathonStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<MarathonDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MarathonStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum MarathonStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarathonStructDocumentCreateInput = {
  document: Scalars['MarathonStructDocumentInputBase64Json'];
};

export type MarathonStructDocumentCreatePayload = {
  __typename?: 'MarathonStructDocumentCreatePayload';
  data?: Maybe<MarathonStructDocument>;
  error?: Maybe<MarathonStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonStructDocumentData = NgfStructDocumentData & {
  __typename?: 'MarathonStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MarathonDocumentSeason;
  tags?: Maybe<MarathonDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum MarathonStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MarathonStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarathonStructDocumentPayload = {
  __typename?: 'MarathonStructDocumentPayload';
  data?: Maybe<MarathonStructDocument>;
  error?: Maybe<MarathonStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MarathonStructDocumentSetSeoPayload = {
  __typename?: 'MarathonStructDocumentSetSeoPayload';
  data?: Maybe<MarathonStructDocument>;
  error?: Maybe<MarathonStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type MarathonStructDocumentSetStatusPayload = {
  __typename?: 'MarathonStructDocumentSetStatusPayload';
  data?: Maybe<MarathonStructDocument>;
  error?: Maybe<MarathonStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonStructDocumentUpdateInput = {
  document: Scalars['MarathonStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type MarathonStructDocumentUpdatePayload = {
  __typename?: 'MarathonStructDocumentUpdatePayload';
  data?: Maybe<MarathonStructDocument>;
  error?: Maybe<MarathonStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type MarathonTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'MarathonTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<MarathonDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: MarathonTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type MarathonTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'MarathonTemplateDocumentData';
  buildVariants?: Maybe<MarathonUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MarathonDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum MarathonTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonTemplateDocumentInput = {
  type: Scalars['String'];
};

export type MarathonTemplateDocumentPayload = {
  __typename?: 'MarathonTemplateDocumentPayload';
  data?: Maybe<MarathonTemplateDocument>;
  error?: Maybe<MarathonTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'MarathonUGDocumentGenericBuilder';
  slots?: Maybe<Array<MarathonUGDocumentGenericBuilderSlot>>;
};

export type MarathonUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'MarathonUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<MarathonEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type MarathonUpgrades = MarathonGameEntity & {
  __typename?: 'MarathonUpgrades';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  faction?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  requirements?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<Scalars['String']>>;
  superType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type MarathonUpgradesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonUpgradesResult = {
  __typename?: 'MarathonUpgradesResult';
  data?: Maybe<Array<MarathonUpgrades>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'MarathonUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<MarathonDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MarathonUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<MarathonDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type MarathonUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'MarathonUserGeneratedDocumentBuildVariant';
  genericBuilder: MarathonUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type MarathonUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'MarathonUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<MarathonUserGeneratedDocumentBuildVariant>>;
};

export enum MarathonUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarathonUserGeneratedDocumentCreateInput = {
  document: Scalars['MarathonUserGeneratedDocumentInputBase64Json'];
};

export type MarathonUserGeneratedDocumentCreatePayload = {
  __typename?: 'MarathonUserGeneratedDocumentCreatePayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'MarathonUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<MarathonUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  runner?: Maybe<MarathonEntityObject>;
  /** @deprecated Season functionality is no longer used */
  season: MarathonDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum MarathonUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MarathonUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarathonUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarathonUserGeneratedDocumentPayload = {
  __typename?: 'MarathonUserGeneratedDocumentPayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type MarathonUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'MarathonUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarathonUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type MarathonUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'MarathonUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MarathonUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'MarathonUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type MarathonUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'MarathonUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarathonUserGeneratedDocumentUpdateInput = {
  document: Scalars['MarathonUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type MarathonUserGeneratedDocumentUpdatePayload = {
  __typename?: 'MarathonUserGeneratedDocumentUpdatePayload';
  data?: Maybe<MarathonUserGeneratedDocument>;
  error?: Maybe<MarathonUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type MarathonUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type MarathonWeaponStats = MarathonGameEntity & {
  __typename?: 'MarathonWeaponStats';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MarathonWeaponStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonWeaponStatsResult = {
  __typename?: 'MarathonWeaponStatsResult';
  data?: Maybe<Array<MarathonWeaponStats>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonWeaponTypes = MarathonGameEntity & {
  __typename?: 'MarathonWeaponTypes';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MarathonWeaponTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonWeaponTypesResult = {
  __typename?: 'MarathonWeaponTypesResult';
  data?: Maybe<Array<MarathonWeaponTypes>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonWeapons = MarathonGameEntity & {
  __typename?: 'MarathonWeapons';
  ammoType?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modslots?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  weaponStatistics?: Maybe<Array<MarathonWeaponsWeaponStatistics>>;
  weaponType?: Maybe<MarathonWeaponTypes>;
};

export type MarathonWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MarathonWeaponsResult = {
  __typename?: 'MarathonWeaponsResult';
  data?: Maybe<Array<MarathonWeapons>>;
  error?: Maybe<MarathonStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MarathonWeaponsWeaponStatistics = {
  __typename?: 'MarathonWeaponsWeaponStatistics';
  value?: Maybe<Scalars['String']>;
  weaponStats?: Maybe<MarathonWeaponStats>;
};

export type MarathonWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'MarathonWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<MarathonDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MarathonWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<MarathonDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type MarathonWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'MarathonWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: MarathonEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum MarathonWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarathonWikiDocumentPayload = {
  __typename?: 'MarathonWikiDocumentPayload';
  data?: Maybe<MarathonWikiDocument>;
  error?: Maybe<MarathonWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MarathonWikiDocumentSetSeoPayload = {
  __typename?: 'MarathonWikiDocumentSetSeoPayload';
  data?: Maybe<MarathonWikiDocument>;
  error?: Maybe<MarathonWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarathonWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarathonWikiDocumentUpdateInput = {
  document: Scalars['MarathonWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type MarathonWikiDocumentUpdatePayload = {
  __typename?: 'MarathonWikiDocumentUpdatePayload';
  data?: Maybe<MarathonWikiDocument>;
  error?: Maybe<MarathonWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarathonWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type MarathonWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export enum MarkNotificationsSeenError {
  INTERNAL = 'INTERNAL',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MarkNotificationsSeenPayload = {
  __typename?: 'MarkNotificationsSeenPayload';
  error?: Maybe<MarkNotificationsSeenError>;
  errorMessage?: Maybe<Scalars['String']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export type MarvelRivalsDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'MarvelRivalsDocumentCmWidgetV1';
  data: MarvelRivalsDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type MarvelRivalsDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'MarvelRivalsDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type MarvelRivalsDocumentContent =
  | MarvelRivalsDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type MarvelRivalsDocumentSeason = NgfDocumentSeason & {
  __typename?: 'MarvelRivalsDocumentSeason';
  slug: Scalars['String'];
};

export type MarvelRivalsDocumentTags = NgfDocumentTags & {
  __typename?: 'MarvelRivalsDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type MarvelRivalsDocumentsMutation = {
  __typename?: 'MarvelRivalsDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: MarvelRivalsStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: MarvelRivalsStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: MarvelRivalsStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: MarvelRivalsStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: MarvelRivalsUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: MarvelRivalsUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: MarvelRivalsUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: MarvelRivalsUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: MarvelRivalsUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: MarvelRivalsUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: MarvelRivalsWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: MarvelRivalsWikiDocumentUpdatePayload;
};

export type MarvelRivalsDocumentsMutationstructDocumentCreateArgs = {
  input: MarvelRivalsStructDocumentCreateInput;
};

export type MarvelRivalsDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type MarvelRivalsDocumentsMutationstructDocumentSetStatusArgs = {
  input: MarvelRivalsStructDocumentSetStatusInput;
};

export type MarvelRivalsDocumentsMutationstructDocumentUpdateArgs = {
  input: MarvelRivalsStructDocumentUpdateInput;
};

export type MarvelRivalsDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: MarvelRivalsUserGeneratedDocumentCreateInput;
};

export type MarvelRivalsDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: MarvelRivalsUserGeneratedDocumentSetFavoriteInput;
};

export type MarvelRivalsDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: MarvelRivalsUserGeneratedDocumentSetFeaturedInput;
};

export type MarvelRivalsDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type MarvelRivalsDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: MarvelRivalsUserGeneratedDocumentSetStatusInput;
};

export type MarvelRivalsDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: MarvelRivalsUserGeneratedDocumentUpdateInput;
};

export type MarvelRivalsDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type MarvelRivalsDocumentsMutationwikiDocumentUpdateArgs = {
  input: MarvelRivalsWikiDocumentUpdateInput;
};

export type MarvelRivalsDocumentsQuery = {
  __typename?: 'MarvelRivalsDocumentsQuery';
  previewDocumentContent: MarvelRivalsPreviewDocumentContentPayload;
  structDocumentBySlug: MarvelRivalsStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: MarvelRivalsUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: MarvelRivalsUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: MarvelRivalsUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: MarvelRivalsUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: MarvelRivalsTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: MarvelRivalsWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type MarvelRivalsDocumentsQuerypreviewDocumentContentArgs = {
  input: MarvelRivalsPreviewDocumentContentInput;
};

export type MarvelRivalsDocumentsQuerystructDocumentBySlugArgs = {
  input: MarvelRivalsStructDocumentInputBySlug;
};

export type MarvelRivalsDocumentsQuerystructDocumentsArgs = {
  input: MarvelRivalsStructDocumentsInput;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: MarvelRivalsUserGeneratedDocumentInputById;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: MarvelRivalsUserGeneratedDocumentInputBySlug;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: MarvelRivalsTemplateDocumentInput;
};

export type MarvelRivalsDocumentsQueryuserGeneratedDocumentsArgs = {
  input: MarvelRivalsUserGeneratedDocumentsListInput;
  page: MarvelRivalsUserGeneratedDocumentsListPage;
};

export type MarvelRivalsDocumentsQuerywikiDocumentArgs = {
  input: MarvelRivalsWikiDocumentInput;
};

export type MarvelRivalsDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<MarvelRivalsWikiDocumentsListInput>;
  page: MarvelRivalsWikiDocumentsListPage;
};

export type MarvelRivalsEntityObject = NGFEntityObject & {
  __typename?: 'MarvelRivalsEntityObject';
  color?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MarvelRivalsMutation = {
  __typename?: 'MarvelRivalsMutation';
  documents?: Maybe<MarvelRivalsDocumentsMutation>;
  id: Scalars['ID'];
};

export enum MarvelRivalsPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsPreviewDocumentContentInput = {
  content: Scalars['MarvelRivalsDocumentContentInputBase64Json'];
};

export type MarvelRivalsPreviewDocumentContentPayload = {
  __typename?: 'MarvelRivalsPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<MarvelRivalsDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<MarvelRivalsPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsProfile = NgfProfile & {
  __typename?: 'MarvelRivalsProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type MarvelRivalsProfileuserGeneratedDocumentsArgs = {
  input: MarvelRivalsUserGeneratedDocumentsListInput;
  page: MarvelRivalsUserGeneratedDocumentsListPage;
};

export type MarvelRivalsProfilePayload = {
  __typename?: 'MarvelRivalsProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<MarvelRivalsProfile>;
};

export type MarvelRivalsProfilesQuery = {
  __typename?: 'MarvelRivalsProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: MarvelRivalsProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type MarvelRivalsProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type MarvelRivalsQuery = {
  __typename?: 'MarvelRivalsQuery';
  documents?: Maybe<MarvelRivalsDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<MarvelRivalsProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
};

export type MarvelRivalsStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'MarvelRivalsStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<MarvelRivalsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MarvelRivalsStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum MarvelRivalsStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarvelRivalsStructDocumentCreateInput = {
  document: Scalars['MarvelRivalsStructDocumentInputBase64Json'];
};

export type MarvelRivalsStructDocumentCreatePayload = {
  __typename?: 'MarvelRivalsStructDocumentCreatePayload';
  data?: Maybe<MarvelRivalsStructDocument>;
  error?: Maybe<MarvelRivalsStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsStructDocumentData = NgfStructDocumentData & {
  __typename?: 'MarvelRivalsStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MarvelRivalsDocumentSeason;
  tags?: Maybe<MarvelRivalsDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum MarvelRivalsStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MarvelRivalsStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarvelRivalsStructDocumentPayload = {
  __typename?: 'MarvelRivalsStructDocumentPayload';
  data?: Maybe<MarvelRivalsStructDocument>;
  error?: Maybe<MarvelRivalsStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MarvelRivalsStructDocumentSetSeoPayload = {
  __typename?: 'MarvelRivalsStructDocumentSetSeoPayload';
  data?: Maybe<MarvelRivalsStructDocument>;
  error?: Maybe<MarvelRivalsStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type MarvelRivalsStructDocumentSetStatusPayload = {
  __typename?: 'MarvelRivalsStructDocumentSetStatusPayload';
  data?: Maybe<MarvelRivalsStructDocument>;
  error?: Maybe<MarvelRivalsStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsStructDocumentUpdateInput = {
  document: Scalars['MarvelRivalsStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type MarvelRivalsStructDocumentUpdatePayload = {
  __typename?: 'MarvelRivalsStructDocumentUpdatePayload';
  data?: Maybe<MarvelRivalsStructDocument>;
  error?: Maybe<MarvelRivalsStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type MarvelRivalsTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'MarvelRivalsTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<MarvelRivalsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: MarvelRivalsTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type MarvelRivalsTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'MarvelRivalsTemplateDocumentData';
  buildVariants?: Maybe<MarvelRivalsUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MarvelRivalsDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum MarvelRivalsTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsTemplateDocumentInput = {
  type: Scalars['String'];
};

export type MarvelRivalsTemplateDocumentPayload = {
  __typename?: 'MarvelRivalsTemplateDocumentPayload';
  data?: Maybe<MarvelRivalsTemplateDocument>;
  error?: Maybe<MarvelRivalsTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'MarvelRivalsUGDocumentGenericBuilder';
  slots?: Maybe<Array<MarvelRivalsUGDocumentGenericBuilderSlot>>;
};

export type MarvelRivalsUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'MarvelRivalsUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<MarvelRivalsEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type MarvelRivalsUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'MarvelRivalsUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<MarvelRivalsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MarvelRivalsUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<MarvelRivalsDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type MarvelRivalsUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'MarvelRivalsUserGeneratedDocumentBuildVariant';
  genericBuilder: MarvelRivalsUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type MarvelRivalsUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'MarvelRivalsUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<MarvelRivalsUserGeneratedDocumentBuildVariant>>;
};

export enum MarvelRivalsUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarvelRivalsUserGeneratedDocumentCreateInput = {
  document: Scalars['MarvelRivalsUserGeneratedDocumentInputBase64Json'];
};

export type MarvelRivalsUserGeneratedDocumentCreatePayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentCreatePayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'MarvelRivalsUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<MarvelRivalsUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MarvelRivalsDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum MarvelRivalsUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MarvelRivalsUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarvelRivalsUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarvelRivalsUserGeneratedDocumentPayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentPayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type MarvelRivalsUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarvelRivalsUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type MarvelRivalsUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MarvelRivalsUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type MarvelRivalsUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MarvelRivalsUserGeneratedDocumentUpdateInput = {
  document: Scalars['MarvelRivalsUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type MarvelRivalsUserGeneratedDocumentUpdatePayload = {
  __typename?: 'MarvelRivalsUserGeneratedDocumentUpdatePayload';
  data?: Maybe<MarvelRivalsUserGeneratedDocument>;
  error?: Maybe<MarvelRivalsUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type MarvelRivalsUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type MarvelRivalsWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'MarvelRivalsWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<MarvelRivalsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MarvelRivalsWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<MarvelRivalsDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type MarvelRivalsWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'MarvelRivalsWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: MarvelRivalsEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum MarvelRivalsWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MarvelRivalsWikiDocumentPayload = {
  __typename?: 'MarvelRivalsWikiDocumentPayload';
  data?: Maybe<MarvelRivalsWikiDocument>;
  error?: Maybe<MarvelRivalsWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MarvelRivalsWikiDocumentSetSeoPayload = {
  __typename?: 'MarvelRivalsWikiDocumentSetSeoPayload';
  data?: Maybe<MarvelRivalsWikiDocument>;
  error?: Maybe<MarvelRivalsWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MarvelRivalsWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MarvelRivalsWikiDocumentUpdateInput = {
  document: Scalars['MarvelRivalsWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type MarvelRivalsWikiDocumentUpdatePayload = {
  __typename?: 'MarvelRivalsWikiDocumentUpdatePayload';
  data?: Maybe<MarvelRivalsWikiDocument>;
  error?: Maybe<MarvelRivalsWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarvelRivalsWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type MarvelRivalsWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type MetaInfo = {
  __typename?: 'MetaInfo';
  isFeatured: Scalars['Boolean'];
  slug: Scalars['String'];
  status: MetaStatus;
};

export type MetaQuery = {
  __typename?: 'MetaQuery';
  author?: Maybe<AuthorMeta>;
  resource?: Maybe<ResourceMeta>;
};

export type MetaQueryauthorArgs = {
  id: Scalars['ID'];
};

export type MetaQueryresourceArgs = {
  id: Scalars['ID'];
};

export enum MetaStatus {
  ARCHIVED = 'ARCHIVED',
  NORMAL = 'NORMAL',
}

export enum MetricTier {
  A = 'A',
  B = 'B',
  C = 'C',
  S = 'S',
}

export type MgpBioPayload = {
  __typename?: 'MgpBioPayload';
  bio?: Maybe<Scalars['Map']>;
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MgpDeadlockGameStats = {
  __typename?: 'MgpDeadlockGameStats';
  steamName: Scalars['String'];
  steamProfileIcon: Scalars['String'];
};

export type MgpDeadlockProfile = MgpGameProfile & {
  __typename?: 'MgpDeadlockProfile';
  gameSlug: Scalars['String'];
  gameStats?: Maybe<MgpDeadlockGameStats>;
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MgpDestiny2BuildsCount = {
  __typename?: 'MgpDestiny2BuildsCount';
  favoriteBuildsCount: Scalars['Int'];
  publishedBuildsCount: Scalars['Int'];
};

export type MgpDestiny2Profile = MgpGameProfile & {
  __typename?: 'MgpDestiny2Profile';
  buildsCount?: Maybe<MgpDestiny2BuildsCount>;
  gameSlug: Scalars['String'];
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MgpEquipInput = {
  inventoryItemID: Scalars['ID'];
};

export type MgpEquipPayload = {
  __typename?: 'MgpEquipPayload';
  data?: Maybe<MgpProfile>;
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MgpError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MgpFollowInfoPayload = {
  __typename?: 'MgpFollowInfoPayload';
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
  followersCount?: Maybe<Scalars['Int']>;
  followingCount?: Maybe<Scalars['Int']>;
  /** Whether the requesting user follows this profile. False for anonymous viewers. */
  isFollowing?: Maybe<Scalars['Boolean']>;
};

export type MgpFollowee = {
  __typename?: 'MgpFollowee';
  /** Selecting gameProfiles here calls several upstream services per followee. Use publishedGames for document counts. */
  profile: MgpProfile;
  /** Games this user has published documents in, most documents first. Games without published documents are left out. */
  publishedGames?: Maybe<Array<MgpPublishedGame>>;
};

export type MgpFollowingPayload = {
  __typename?: 'MgpFollowingPayload';
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
  /** Users this profile follows, most recently followed first, at most 1000. */
  followees?: Maybe<Array<MgpFollowee>>;
  /**
   * Filled only when followees is empty: at most 4 authors with the most published documents in the
   * games where this user published or favorited documents, or in any game when there are none.
   */
  suggestions?: Maybe<Array<MgpFollowee>>;
};

export type MgpFormattedGameStat = MgpGameStat & {
  __typename?: 'MgpFormattedGameStat';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type MgpGameProfile = {
  gameSlug: Scalars['String'];
};

export type MgpGameProfilesFilter = {
  userID: Scalars['ID'];
};

export type MgpGameProfilesPayload = {
  __typename?: 'MgpGameProfilesPayload';
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
  profiles?: Maybe<Array<MgpGameProfile>>;
  /** Published documents this user has favorited across all NGF games. */
  totalFavorites?: Maybe<Scalars['Int']>;
};

export type MgpGameStat = {
  name: Scalars['String'];
};

export type MgpInventoryFilter = {
  /** Filters equipment by type. */
  equipmentType?: InputMaybe<Scalars['String']>;
};

export type MgpInventoryItem = {
  __typename?: 'MgpInventoryItem';
  equipment: MobaEquipmentEntityObject;
  inventoryItemID: Scalars['ID'];
};

export type MgpInventoryMutation = {
  __typename?: 'MgpInventoryMutation';
  equip: MgpEquipPayload;
  unequip: MgpUnequipPayload;
};

export type MgpInventoryMutationequipArgs = {
  input: MgpEquipInput;
};

export type MgpInventoryMutationunequipArgs = {
  input: MgpUnequipInput;
};

export type MgpInventoryPage = {
  /**
   * If specified, returns items after the given cursor (forward pagination).
   * Backward cursor pagination is not supported.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of items to return. */
  limit: Scalars['Int'];
};

export type MgpInventoryPaginationInfo = {
  __typename?: 'MgpInventoryPaginationInfo';
  cursor?: Maybe<Scalars['String']>;
  hasMoreItems?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<MgpInventoryPaginationInfoOffset>;
};

export type MgpInventoryPaginationInfoOffset = {
  __typename?: 'MgpInventoryPaginationInfoOffset';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type MgpInventoryPayload = {
  __typename?: 'MgpInventoryPayload';
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
  items?: Maybe<Array<MgpInventoryItem>>;
  pageInfo?: Maybe<MgpInventoryPaginationInfo>;
};

export type MgpInventoryStat = {
  __typename?: 'MgpInventoryStat';
  count: Scalars['Int'];
  equipmentTypeInfo?: Maybe<MobaEquipmentTypes>;
  /** @deprecated use equipmentTypeInfo instead */
  groupName: Scalars['String'];
};

export type MgpLolGameStats = {
  __typename?: 'MgpLolGameStats';
  rank?: Maybe<MgpSummonerRank>;
  summoner: MgpRiotSummoner;
};

export type MgpLolProfile = MgpGameProfile & {
  __typename?: 'MgpLolProfile';
  gameSlug: Scalars['String'];
  gameStats?: Maybe<MgpLolGameStats>;
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MgpMutation = {
  __typename?: 'MgpMutation';
  inventory: MgpInventoryMutation;
  /**
   * Sets whether the requesting user follows the given user. Idempotent.
   * Following yourself is BAD_REQUEST; an unknown user is NOT_FOUND.
   */
  setFollow: MgpSetFollowPayload;
  updateBio: MgpUpdateBioPayload;
};

export type MgpMutationsetFollowArgs = {
  input: MgpSetFollowInput;
};

export type MgpMutationupdateBioArgs = {
  input: MgpUpdateBioInput;
};

export type MgpNgfProfile = MgpGameProfile & {
  __typename?: 'MgpNgfProfile';
  gameSlug: Scalars['String'];
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MgpNgfUgDocsStats = {
  __typename?: 'MgpNgfUgDocsStats';
  documentName: Scalars['String'];
  documentsCount: Scalars['Int'];
  favoritesCount?: Maybe<Scalars['Int']>;
};

export type MgpPoeGameInfo = {
  __typename?: 'MgpPoeGameInfo';
  username: Scalars['String'];
};

export type MgpPoeProfile = MgpGameProfile & {
  __typename?: 'MgpPoeProfile';
  gameInfo?: Maybe<MgpPoeGameInfo>;
  gameSlug: Scalars['String'];
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MgpProfile = {
  __typename?: 'MgpProfile';
  appIcon?: Maybe<MobaEquipmentAppIcons>;
  avatar?: Maybe<MobaEquipmentAvatars>;
  avatarFrame?: Maybe<MobaEquipmentAvatarFrames>;
  battlePasses: BattlePassListPayload;
  bio?: Maybe<MgpBioPayload>;
  commentator?: Maybe<CommentsCommentatorInfo>;
  cursorIcon?: Maybe<MobaEquipmentCursorIcons>;
  followInfo: MgpFollowInfoPayload;
  /** Visible to the profile owner only. */
  following: MgpFollowingPayload;
  gameProfiles: MgpGameProfilesPayload;
  inventory: MgpInventoryPayload;
  inventoryStats?: Maybe<Array<MgpInventoryStat>>;
  profileCover?: Maybe<MobaEquipmentProfileCovers>;
  profilePlate?: Maybe<MobaEquipmentProfilePlates>;
  theme?: Maybe<MobaEquipmentThemes>;
  title?: Maybe<MobaEquipmentTitles>;
  user?: Maybe<User>;
};

export type MgpProfilebattlePassesArgs = {
  input?: InputMaybe<BattlePassListInput>;
};

export type MgpProfileinventoryArgs = {
  filter?: InputMaybe<MgpInventoryFilter>;
  page: MgpInventoryPage;
};

export type MgpProfileInput = {
  username?: InputMaybe<Scalars['String']>;
};

export type MgpProfilePayload = {
  __typename?: 'MgpProfilePayload';
  data?: Maybe<MgpProfile>;
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MgpPublishedDocumentType = {
  __typename?: 'MgpPublishedDocumentType';
  count: Scalars['Int'];
  /** The NGF document type slug, for example builds. */
  slug: Scalars['String'];
};

export type MgpPublishedGame = {
  __typename?: 'MgpPublishedGame';
  /** Published documents per type, most first. Types without published documents are left out. */
  documentTypes?: Maybe<Array<MgpPublishedDocumentType>>;
  gameSlug: Scalars['String'];
};

export type MgpQuery = {
  __typename?: 'MgpQuery';
  profile: MgpProfilePayload;
};

export type MgpQueryprofileArgs = {
  input?: InputMaybe<MgpProfileInput>;
};

export type MgpRiotSummoner = {
  __typename?: 'MgpRiotSummoner';
  gameName: Scalars['String'];
  profileIcon: Scalars['String'];
  puuid: Scalars['String'];
  region: Scalars['String'];
  tagLine: Scalars['String'];
};

export type MgpSetFollowInput = {
  isFollowing: Scalars['Boolean'];
  userId: Scalars['ID'];
};

export type MgpSetFollowPayload = {
  __typename?: 'MgpSetFollowPayload';
  /** The target user's profile after the change. */
  data?: Maybe<MgpProfile>;
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MgpSummonerRank = {
  __typename?: 'MgpSummonerRank';
  division: Scalars['String'];
  tier: Scalars['String'];
};

export type MgpTftGameStats = {
  __typename?: 'MgpTftGameStats';
  rank?: Maybe<MgpSummonerRank>;
  summoner: MgpRiotSummoner;
};

export type MgpTftProfile = MgpGameProfile & {
  __typename?: 'MgpTftProfile';
  gameSlug: Scalars['String'];
  gameStats?: Maybe<MgpTftGameStats>;
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MgpUnequipInput = {
  equipmentType: Scalars['String'];
};

export type MgpUnequipPayload = {
  __typename?: 'MgpUnequipPayload';
  data?: Maybe<MgpProfile>;
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MgpUpdateBioInput = {
  bio?: InputMaybe<Scalars['Map']>;
};

export type MgpUpdateBioPayload = {
  __typename?: 'MgpUpdateBioPayload';
  data?: Maybe<MgpProfile>;
  error?: Maybe<MgpError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MgpValorantGameStats = {
  __typename?: 'MgpValorantGameStats';
  rank?: Maybe<MgpSummonerRank>;
  summoner: MgpRiotSummoner;
};

export type MgpValorantProfile = MgpGameProfile & {
  __typename?: 'MgpValorantProfile';
  gameSlug: Scalars['String'];
  gameStats?: Maybe<MgpValorantGameStats>;
  ugDocumentsStats?: Maybe<Array<MgpNgfUgDocsStats>>;
};

export type MhwAilment = MhwGameEntity & {
  __typename?: 'MhwAilment';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwAilmentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwAilmentsResult = {
  __typename?: 'MhwAilmentsResult';
  data?: Maybe<Array<MhwAilment>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwArmor = MhwGameEntity & {
  __typename?: 'MhwArmor';
  armorType?: Maybe<MhwArmorType>;
  armorTypeSlug?: Maybe<Scalars['String']>;
  defense?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  groupSkills?: Maybe<Array<MhwGroupSkills>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  resistance?: Maybe<Array<MhwResistance>>;
  setBonuses?: Maybe<Array<MhwSetBonuses>>;
  skills?: Maybe<Array<MhwSkill>>;
  slots?: Maybe<Array<MhwSlots>>;
  slug: Scalars['String'];
};

export type MhwArmorType = MhwGameEntity & {
  __typename?: 'MhwArmorType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwArmorTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwArmorTypesResult = {
  __typename?: 'MhwArmorTypesResult';
  data?: Maybe<Array<MhwArmorType>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwArmorsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwArmorsResult = {
  __typename?: 'MhwArmorsResult';
  data?: Maybe<Array<MhwArmor>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwArtianValue = {
  __typename?: 'MhwArtianValue';
  affinityBonus?: Maybe<Scalars['Int']>;
  affinityPart?: Maybe<Scalars['Int']>;
  attackBonus?: Maybe<Scalars['Int']>;
  attackPart?: Maybe<Scalars['Int']>;
  blastPart?: Maybe<Scalars['Int']>;
  capacityBonus?: Maybe<Scalars['Int']>;
  elementBonus?: Maybe<Scalars['Int']>;
  elementPart?: Maybe<Scalars['Int']>;
  paralysisPart?: Maybe<Scalars['Int']>;
  poisonPart?: Maybe<Scalars['Int']>;
  sharpnessBonus?: Maybe<Scalars['Int']>;
  sleepPart?: Maybe<Scalars['Int']>;
};

export type MhwArtianValues = {
  __typename?: 'MhwArtianValues';
  affinityBonus?: Maybe<Scalars['Int']>;
  affinityPart?: Maybe<Scalars['Int']>;
  attackBonus?: Maybe<Scalars['Int']>;
  attackPart?: Maybe<Scalars['Int']>;
  blastPart?: Maybe<Scalars['Int']>;
  capacityBonus?: Maybe<Scalars['Int']>;
  elementBonus?: Maybe<Scalars['Int']>;
  elementPart?: Maybe<Scalars['Int']>;
  paralysisPart?: Maybe<Scalars['Int']>;
  poisonPart?: Maybe<Scalars['Int']>;
  sharpnessBonus?: Maybe<Scalars['Int']>;
  sleepPart?: Maybe<Scalars['Int']>;
};

export type MhwBlankStaticEntity = {
  __typename?: 'MhwBlankStaticEntity';
  id: Scalars['ID'];
};

export type MhwCharm = MhwGameEntity & {
  __typename?: 'MhwCharm';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  levels?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  skills?: Maybe<Array<MhwSkill>>;
  slug: Scalars['String'];
};

export type MhwCharmsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwCharmsResult = {
  __typename?: 'MhwCharmsResult';
  data?: Maybe<Array<MhwCharm>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwDecoration = MhwGameEntity & {
  __typename?: 'MhwDecoration';
  decorationType?: Maybe<MhwDecorationType>;
  decorationTypeSlug?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  skills?: Maybe<Array<MhwSkill>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type MhwDecorationType = MhwGameEntity & {
  __typename?: 'MhwDecorationType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwDecorationTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwDecorationTypesResult = {
  __typename?: 'MhwDecorationTypesResult';
  data?: Maybe<Array<MhwDecorationType>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwDecorationsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwDecorationsResult = {
  __typename?: 'MhwDecorationsResult';
  data?: Maybe<Array<MhwDecoration>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'MhwDocumentCmWidgetV1';
  data: MhwDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type MhwDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'MhwDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type MhwDocumentContent =
  | MhwDocumentCmWidgetV1
  | MhwDocumentUgWidgetEquipmentV1
  | MhwDocumentUgWidgetStatsAndSkillsV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type MhwDocumentSeason = NgfDocumentSeason & {
  __typename?: 'MhwDocumentSeason';
  slug: Scalars['String'];
};

export type MhwDocumentTags = NgfDocumentTags & {
  __typename?: 'MhwDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type MhwDocumentUgWidgetEquipmenForge = {
  __typename?: 'MhwDocumentUgWidgetEquipmenForge';
  damageType: Scalars['String'];
  parts?: Maybe<Array<Scalars['String']>>;
  reinforcements?: Maybe<Array<Scalars['String']>>;
};

export type MhwDocumentUgWidgetEquipmentAilment = {
  __typename?: 'MhwDocumentUgWidgetEquipmentAilment';
  iconUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Most of the fields are deprecated as contained in armor field */
export type MhwDocumentUgWidgetEquipmentArmorSlot = {
  __typename?: 'MhwDocumentUgWidgetEquipmentArmorSlot';
  armor?: Maybe<MhwArmor>;
  /** DEPRECATED. Use decorationsV2 */
  decorations?: Maybe<Array<Maybe<MhwDocumentUgWidgetEquipmentDecoration>>>;
  decorationsV2?: Maybe<Array<Maybe<MhwDecoration>>>;
  defense?: Maybe<Array<Scalars['Int']>>;
  dragonResist?: Maybe<Scalars['Int']>;
  fireResist?: Maybe<Scalars['Int']>;
  groupSkills?: Maybe<Array<MhwDocumentUgWidgetEquipmentGroupSkill>>;
  health?: Maybe<Scalars['Int']>;
  iceResist?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  setBonuses?: Maybe<Array<MhwDocumentUgWidgetEquipmentSetBonus>>;
  skills?: Maybe<Array<MhwDocumentUgWidgetEquipmentSkill>>;
  slots?: Maybe<Array<Scalars['Int']>>;
  slug: Scalars['String'];
  stamina?: Maybe<Scalars['Int']>;
  thunderResist?: Maybe<Scalars['Int']>;
  waterResist?: Maybe<Scalars['Int']>;
};

export type MhwDocumentUgWidgetEquipmentCharmSlot = {
  __typename?: 'MhwDocumentUgWidgetEquipmentCharmSlot';
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  skills?: Maybe<Array<MhwDocumentUgWidgetEquipmentSkill>>;
  slug: Scalars['String'];
};

export type MhwDocumentUgWidgetEquipmentDataV1 = NgfDocumentContentData & {
  __typename?: 'MhwDocumentUgWidgetEquipmentDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type MhwDocumentUgWidgetEquipmentDecoration = {
  __typename?: 'MhwDocumentUgWidgetEquipmentDecoration';
  iconUrl: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  skills?: Maybe<Array<MhwDocumentUgWidgetEquipmentSkill>>;
  slug: Scalars['String'];
};

export type MhwDocumentUgWidgetEquipmentElement = {
  __typename?: 'MhwDocumentUgWidgetEquipmentElement';
  iconUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** DEPRECATED */
export type MhwDocumentUgWidgetEquipmentGroupLevel = {
  __typename?: 'MhwDocumentUgWidgetEquipmentGroupLevel';
  equipmentSkill?: Maybe<MhwDocumentUgWidgetSkill>;
  pieces?: Maybe<Scalars['Int']>;
};

export type MhwDocumentUgWidgetEquipmentGroupSkill = {
  __typename?: 'MhwDocumentUgWidgetEquipmentGroupSkill';
  slug: Scalars['String'];
};

export type MhwDocumentUgWidgetEquipmentMantleSlot = {
  __typename?: 'MhwDocumentUgWidgetEquipmentMantleSlot';
  iconColor?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type MhwDocumentUgWidgetEquipmentSetBonus = {
  __typename?: 'MhwDocumentUgWidgetEquipmentSetBonus';
  slug: Scalars['String'];
};

export type MhwDocumentUgWidgetEquipmentSkill = {
  __typename?: 'MhwDocumentUgWidgetEquipmentSkill';
  level: Scalars['Int'];
  slug: Scalars['String'];
};

export type MhwDocumentUgWidgetEquipmentStat = {
  __typename?: 'MhwDocumentUgWidgetEquipmentStat';
  name: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type MhwDocumentUgWidgetEquipmentToolSlot = {
  __typename?: 'MhwDocumentUgWidgetEquipmentToolSlot';
  decorations?: Maybe<Array<Maybe<MhwDocumentUgWidgetEquipmentDecoration>>>;
  name: Scalars['String'];
  /** DEPRECATED. Unused. */
  skills?: Maybe<Array<MhwDocumentUgWidgetEquipmentSkill>>;
  slots?: Maybe<Array<Scalars['Int']>>;
  slug: Scalars['String'];
  tool?: Maybe<MhwTool>;
};

export type MhwDocumentUgWidgetEquipmentV1 = NgfDocumentContent & {
  __typename?: 'MhwDocumentUgWidgetEquipmentV1';
  data: MhwDocumentUgWidgetEquipmentDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

/** Most of the fields are deprecated as contained in weapon field */
export type MhwDocumentUgWidgetEquipmentWeaponSlot = {
  __typename?: 'MhwDocumentUgWidgetEquipmentWeaponSlot';
  affinity?: Maybe<Scalars['Int']>;
  ailment?: Maybe<MhwDocumentUgWidgetEquipmentAilment>;
  ailmentBaseAttack?: Maybe<Scalars['Int']>;
  ailmentHidden?: Maybe<Scalars['Boolean']>;
  artianValues?: Maybe<MhwArtianValues>;
  attack?: Maybe<Scalars['Int']>;
  /** DEPRECATED. Unused. */
  critElementModifier?: Maybe<Scalars['Float']>;
  /** DEPRECATED. Unused. */
  critStatusModifier?: Maybe<Scalars['Float']>;
  /** DEPRECATED. Use decorationsV2 */
  decorations?: Maybe<Array<Maybe<MhwDocumentUgWidgetEquipmentDecoration>>>;
  decorationsV2?: Maybe<Array<Maybe<MhwDecoration>>>;
  defense?: Maybe<Scalars['Int']>;
  element?: Maybe<MhwDocumentUgWidgetEquipmentElement>;
  elementBaseAttack?: Maybe<Scalars['Int']>;
  elementHidden?: Maybe<Scalars['Boolean']>;
  forge?: Maybe<MhwDocumentUgWidgetEquipmenForge>;
  handicraft?: Maybe<Array<Scalars['Int']>>;
  iconUrl?: Maybe<Scalars['String']>;
  isArtian?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  sharpness?: Maybe<Array<Scalars['Int']>>;
  skills?: Maybe<Array<MhwDocumentUgWidgetEquipmentSkill>>;
  slots?: Maybe<Array<Scalars['Int']>>;
  slug: Scalars['String'];
  /** DEPRECATED. Unused. */
  trueCritElementModifier?: Maybe<Scalars['Float']>;
  /** DEPRECATED. Unused. */
  trueCritStatusModifier?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  upgrades?: Maybe<Array<MhwDocumentUgWidgetEquipmentStat>>;
  weapon?: Maybe<MhwWeapon>;
  weaponModifier?: Maybe<Scalars['Float']>;
};

/** DEPRECATED. Use MhwGroupSkill */
export type MhwDocumentUgWidgetGroupSkill = {
  __typename?: 'MhwDocumentUgWidgetGroupSkill';
  groupLevels?: Maybe<Array<MhwDocumentUgWidgetEquipmentGroupLevel>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** DEPRECATED. Use MhwSetBonus */
export type MhwDocumentUgWidgetSetBonus = {
  __typename?: 'MhwDocumentUgWidgetSetBonus';
  groupLevels?: Maybe<Array<MhwDocumentUgWidgetEquipmentGroupLevel>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** DEPRECATED. Use MhwEquipmentSkill */
export type MhwDocumentUgWidgetSkill = {
  __typename?: 'MhwDocumentUgWidgetSkill';
  iconUrl?: Maybe<Scalars['String']>;
  levels?: Maybe<Array<MhwMhwDocumentUgWidgetSkillLevel>>;
  maxLevel: Scalars['Int'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwDocumentUgWidgetStatsAndSkillsDataV1 = NgfDocumentContentData & {
  __typename?: 'MhwDocumentUgWidgetStatsAndSkillsDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type MhwDocumentUgWidgetStatsAndSkillsV1 = NgfDocumentContent & {
  __typename?: 'MhwDocumentUgWidgetStatsAndSkillsV1';
  data: MhwDocumentUgWidgetStatsAndSkillsDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type MhwDocumentsMutation = {
  __typename?: 'MhwDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: MhwStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: MhwStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: MhwStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: MhwStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: MhwUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: MhwUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: MhwUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: MhwUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: MhwUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: MhwUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: MhwWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: MhwWikiDocumentUpdatePayload;
};

export type MhwDocumentsMutationstructDocumentCreateArgs = {
  input: MhwStructDocumentCreateInput;
};

export type MhwDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type MhwDocumentsMutationstructDocumentSetStatusArgs = {
  input: MhwStructDocumentSetStatusInput;
};

export type MhwDocumentsMutationstructDocumentUpdateArgs = {
  input: MhwStructDocumentUpdateInput;
};

export type MhwDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: MhwUserGeneratedDocumentCreateInput;
};

export type MhwDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: MhwUserGeneratedDocumentSetFavoriteInput;
};

export type MhwDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: MhwUserGeneratedDocumentSetFeaturedInput;
};

export type MhwDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type MhwDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: MhwUserGeneratedDocumentSetStatusInput;
};

export type MhwDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: MhwUserGeneratedDocumentUpdateInput;
};

export type MhwDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type MhwDocumentsMutationwikiDocumentUpdateArgs = {
  input: MhwWikiDocumentUpdateInput;
};

export type MhwDocumentsQuery = {
  __typename?: 'MhwDocumentsQuery';
  previewDocumentContent: MhwPreviewDocumentContentPayload;
  structDocumentBySlug: MhwStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: MhwUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: MhwUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: MhwUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: MhwUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: MhwTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: MhwWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type MhwDocumentsQuerypreviewDocumentContentArgs = {
  input: MhwPreviewDocumentContentInput;
};

export type MhwDocumentsQuerystructDocumentBySlugArgs = {
  input: MhwStructDocumentInputBySlug;
};

export type MhwDocumentsQuerystructDocumentsArgs = {
  input: MhwStructDocumentsInput;
};

export type MhwDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: MhwUserGeneratedDocumentInputById;
};

export type MhwDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: MhwUserGeneratedDocumentInputBySlug;
};

export type MhwDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type MhwDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type MhwDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type MhwDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type MhwDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: MhwTemplateDocumentInput;
};

export type MhwDocumentsQueryuserGeneratedDocumentsArgs = {
  input: MhwUserGeneratedDocumentsListInput;
  page: MhwUserGeneratedDocumentsListPage;
};

export type MhwDocumentsQuerywikiDocumentArgs = {
  input: MhwWikiDocumentInput;
};

export type MhwDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<MhwWikiDocumentsListInput>;
  page: MhwWikiDocumentsListPage;
};

export type MhwElement = MhwGameEntity & {
  __typename?: 'MhwElement';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwElementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwElementsResult = {
  __typename?: 'MhwElementsResult';
  data?: Maybe<Array<MhwElement>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum MhwEntitiesEnum {
  ailments = 'ailments',
  armorTypes = 'armorTypes',
  armors = 'armors',
  charms = 'charms',
  decorationTypes = 'decorationTypes',
  decorations = 'decorations',
  elements = 'elements',
  equipmentGroupSkills = 'equipmentGroupSkills',
  equipmentSetBonuses = 'equipmentSetBonuses',
  equipmentSkills = 'equipmentSkills',
  items = 'items',
  tools = 'tools',
  weaponTypes = 'weaponTypes',
  weapons = 'weapons',
}

export type MhwEntity = MhwBlankStaticEntity;

export type MhwEntityObject = NGFEntityObject & {
  __typename?: 'MhwEntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<MhwGameEntity>;
  enumType?: Maybe<MhwEntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type MhwEquipmentGroupSkill = MhwGameEntity & {
  __typename?: 'MhwEquipmentGroupSkill';
  groupLevels?: Maybe<Array<MhwGroupLevels>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwEquipmentGroupSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwEquipmentGroupSkillsResult = {
  __typename?: 'MhwEquipmentGroupSkillsResult';
  data?: Maybe<Array<MhwEquipmentGroupSkill>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwEquipmentSetBonus = MhwGameEntity & {
  __typename?: 'MhwEquipmentSetBonus';
  groupLevels?: Maybe<Array<MhwGroupLevels>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwEquipmentSetBonusesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwEquipmentSetBonusesResult = {
  __typename?: 'MhwEquipmentSetBonusesResult';
  data?: Maybe<Array<MhwEquipmentSetBonus>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwEquipmentSkill = MhwGameEntity & {
  __typename?: 'MhwEquipmentSkill';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  levels?: Maybe<Array<MhwLevels>>;
  maxLevel?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MhwEquipmentSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwEquipmentSkillsResult = {
  __typename?: 'MhwEquipmentSkillsResult';
  data?: Maybe<Array<MhwEquipmentSkill>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwGameEntity = {
  slug: Scalars['String'];
};

export type MhwGroupLevels = {
  __typename?: 'MhwGroupLevels';
  equipmentSkill?: Maybe<MhwEquipmentSkill>;
  pieces?: Maybe<Scalars['Int']>;
  skillSlug?: Maybe<Scalars['String']>;
};

export type MhwGroupSkills = {
  __typename?: 'MhwGroupSkills';
  equipmentGroupSkill?: Maybe<MhwEquipmentGroupSkill>;
  equipmentGroupSkillSlug?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
};

export type MhwItem = MhwGameEntity & {
  __typename?: 'MhwItem';
  description?: Maybe<Scalars['String']>;
  iconColor?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type MhwItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwItemsResult = {
  __typename?: 'MhwItemsResult';
  data?: Maybe<Array<MhwItem>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwLevels = {
  __typename?: 'MhwLevels';
  description?: Maybe<Scalars['String']>;
  stats?: Maybe<Array<MhwLevelsStats>>;
};

export type MhwLevelsStats = {
  __typename?: 'MhwLevelsStats';
  name: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

/** DEPRECATED */
export type MhwMhwDocumentUgWidgetSkillLevel = {
  __typename?: 'MhwMhwDocumentUgWidgetSkillLevel';
  description?: Maybe<Scalars['String']>;
  stats?: Maybe<Array<MhwDocumentUgWidgetEquipmentStat>>;
};

export type MhwMutation = {
  __typename?: 'MhwMutation';
  documents?: Maybe<MhwDocumentsMutation>;
  id: Scalars['ID'];
};

export enum MhwPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwPreviewDocumentContentInput = {
  content: Scalars['MhwDocumentContentInputBase64Json'];
};

export type MhwPreviewDocumentContentPayload = {
  __typename?: 'MhwPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<MhwDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<MhwPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwProfile = NgfProfile & {
  __typename?: 'MhwProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type MhwProfileuserGeneratedDocumentsArgs = {
  input: MhwUserGeneratedDocumentsListInput;
  page: MhwUserGeneratedDocumentsListPage;
};

export type MhwProfilePayload = {
  __typename?: 'MhwProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<MhwProfile>;
};

export type MhwProfilesQuery = {
  __typename?: 'MhwProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: MhwProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type MhwProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type MhwQuery = {
  __typename?: 'MhwQuery';
  documents?: Maybe<MhwDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<MhwProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<MhwStaticDataQuery>;
};

export type MhwResistance = {
  __typename?: 'MhwResistance';
  element?: Maybe<MhwElement>;
  elementSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type MhwSetBonuses = {
  __typename?: 'MhwSetBonuses';
  equipmentSetBonus?: Maybe<MhwEquipmentSetBonus>;
  equipmentSetBonusSlug?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
};

export type MhwSkill = {
  __typename?: 'MhwSkill';
  equipmentSkill?: Maybe<MhwEquipmentSkill>;
  level?: Maybe<Scalars['Int']>;
  skillSlug?: Maybe<Scalars['String']>;
};

export type MhwSlots = {
  __typename?: 'MhwSlots';
  decorationType?: Maybe<MhwDecorationType>;
  decorationTypeSlug?: Maybe<Scalars['String']>;
};

export enum MhwStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type MhwStaticDataQuery = {
  __typename?: 'MhwStaticDataQuery';
  mhwAilments: MhwAilmentsResult;
  mhwArmorTypes: MhwArmorTypesResult;
  mhwArmors: MhwArmorsResult;
  mhwCharms: MhwCharmsResult;
  mhwDecorationTypes: MhwDecorationTypesResult;
  mhwDecorations: MhwDecorationsResult;
  mhwElements: MhwElementsResult;
  mhwEquipmentGroupSkills: MhwEquipmentGroupSkillsResult;
  mhwEquipmentSetBonuses: MhwEquipmentSetBonusesResult;
  mhwEquipmentSkills: MhwEquipmentSkillsResult;
  mhwItems: MhwItemsResult;
  mhwTools: MhwToolsResult;
  mhwWeaponTypes: MhwWeaponTypesResult;
  mhwWeapons: MhwWeaponsResult;
};

export type MhwStaticDataQuerymhwAilmentsArgs = {
  filter?: InputMaybe<MhwAilmentsFilter>;
};

export type MhwStaticDataQuerymhwArmorTypesArgs = {
  filter?: InputMaybe<MhwArmorTypesFilter>;
};

export type MhwStaticDataQuerymhwArmorsArgs = {
  filter?: InputMaybe<MhwArmorsFilter>;
};

export type MhwStaticDataQuerymhwCharmsArgs = {
  filter?: InputMaybe<MhwCharmsFilter>;
};

export type MhwStaticDataQuerymhwDecorationTypesArgs = {
  filter?: InputMaybe<MhwDecorationTypesFilter>;
};

export type MhwStaticDataQuerymhwDecorationsArgs = {
  filter?: InputMaybe<MhwDecorationsFilter>;
};

export type MhwStaticDataQuerymhwElementsArgs = {
  filter?: InputMaybe<MhwElementsFilter>;
};

export type MhwStaticDataQuerymhwEquipmentGroupSkillsArgs = {
  filter?: InputMaybe<MhwEquipmentGroupSkillsFilter>;
};

export type MhwStaticDataQuerymhwEquipmentSetBonusesArgs = {
  filter?: InputMaybe<MhwEquipmentSetBonusesFilter>;
};

export type MhwStaticDataQuerymhwEquipmentSkillsArgs = {
  filter?: InputMaybe<MhwEquipmentSkillsFilter>;
};

export type MhwStaticDataQuerymhwItemsArgs = {
  filter?: InputMaybe<MhwItemsFilter>;
};

export type MhwStaticDataQuerymhwToolsArgs = {
  filter?: InputMaybe<MhwToolsFilter>;
};

export type MhwStaticDataQuerymhwWeaponTypesArgs = {
  filter?: InputMaybe<MhwWeaponTypesFilter>;
};

export type MhwStaticDataQuerymhwWeaponsArgs = {
  filter?: InputMaybe<MhwWeaponsFilter>;
};

export type MhwStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'MhwStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<MhwDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MhwStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum MhwStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MhwStructDocumentCreateInput = {
  document: Scalars['MhwStructDocumentInputBase64Json'];
};

export type MhwStructDocumentCreatePayload = {
  __typename?: 'MhwStructDocumentCreatePayload';
  data?: Maybe<MhwStructDocument>;
  error?: Maybe<MhwStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwStructDocumentData = NgfStructDocumentData & {
  __typename?: 'MhwStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MhwDocumentSeason;
  tags?: Maybe<MhwDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum MhwStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MhwStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MhwStructDocumentPayload = {
  __typename?: 'MhwStructDocumentPayload';
  data?: Maybe<MhwStructDocument>;
  error?: Maybe<MhwStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MhwStructDocumentSetSeoPayload = {
  __typename?: 'MhwStructDocumentSetSeoPayload';
  data?: Maybe<MhwStructDocument>;
  error?: Maybe<MhwStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type MhwStructDocumentSetStatusPayload = {
  __typename?: 'MhwStructDocumentSetStatusPayload';
  data?: Maybe<MhwStructDocument>;
  error?: Maybe<MhwStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwStructDocumentUpdateInput = {
  document: Scalars['MhwStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type MhwStructDocumentUpdatePayload = {
  __typename?: 'MhwStructDocumentUpdatePayload';
  data?: Maybe<MhwStructDocument>;
  error?: Maybe<MhwStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type MhwTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'MhwTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<MhwDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: MhwTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type MhwTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'MhwTemplateDocumentData';
  buildVariants?: Maybe<MhwUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MhwDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum MhwTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwTemplateDocumentInput = {
  type: Scalars['String'];
};

export type MhwTemplateDocumentPayload = {
  __typename?: 'MhwTemplateDocumentPayload';
  data?: Maybe<MhwTemplateDocument>;
  error?: Maybe<MhwTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwTool = MhwGameEntity & {
  __typename?: 'MhwTool';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  slots?: Maybe<Array<MhwSlots>>;
  slug: Scalars['String'];
  toolType?: Maybe<Scalars['String']>;
};

export type MhwToolsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwToolsResult = {
  __typename?: 'MhwToolsResult';
  data?: Maybe<Array<MhwTool>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'MhwUGDocumentGenericBuilder';
  slots?: Maybe<Array<MhwUGDocumentGenericBuilderSlot>>;
};

export type MhwUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'MhwUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<MhwEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type MhwUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'MhwUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<MhwDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MhwUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<MhwDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type MhwUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'MhwUserGeneratedDocumentBuildVariant';
  equipment?: Maybe<MhwUserGeneratedDocumentBuildVariantEquipment>;
  genericBuilder: MhwUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type MhwUserGeneratedDocumentBuildVariantEquipment = {
  __typename?: 'MhwUserGeneratedDocumentBuildVariantEquipment';
  arms?: Maybe<MhwDocumentUgWidgetEquipmentArmorSlot>;
  /** DEPRECATED. Use charmV2 */
  charm?: Maybe<MhwDocumentUgWidgetEquipmentCharmSlot>;
  charmV2?: Maybe<MhwCharm>;
  chest?: Maybe<MhwDocumentUgWidgetEquipmentArmorSlot>;
  /** DEPRECATED. Use groupSkillsV2 */
  groupSkills?: Maybe<Array<MhwDocumentUgWidgetGroupSkill>>;
  groupSkillsV2?: Maybe<Array<MhwEquipmentGroupSkill>>;
  head?: Maybe<MhwDocumentUgWidgetEquipmentArmorSlot>;
  legs?: Maybe<MhwDocumentUgWidgetEquipmentArmorSlot>;
  /** DEPRECATED. Use mantleV2 */
  mantle?: Maybe<MhwDocumentUgWidgetEquipmentMantleSlot>;
  mantleV2?: Maybe<MhwItem>;
  secondaryWeapon?: Maybe<MhwDocumentUgWidgetEquipmentWeaponSlot>;
  /** DEPRECATED. Use setBonusesV2 */
  setBonuses?: Maybe<Array<MhwDocumentUgWidgetSetBonus>>;
  setBonusesV2?: Maybe<Array<MhwEquipmentSetBonus>>;
  /** DEPRECATED. Use skillsV2 */
  skills?: Maybe<Array<MhwDocumentUgWidgetSkill>>;
  skillsV2?: Maybe<Array<MhwEquipmentSkill>>;
  tool1?: Maybe<MhwDocumentUgWidgetEquipmentToolSlot>;
  tool2?: Maybe<MhwDocumentUgWidgetEquipmentToolSlot>;
  waist?: Maybe<MhwDocumentUgWidgetEquipmentArmorSlot>;
  weapon?: Maybe<MhwDocumentUgWidgetEquipmentWeaponSlot>;
};

export type MhwUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'MhwUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<MhwUserGeneratedDocumentBuildVariant>>;
};

export enum MhwUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MhwUserGeneratedDocumentCreateInput = {
  document: Scalars['MhwUserGeneratedDocumentInputBase64Json'];
};

export type MhwUserGeneratedDocumentCreatePayload = {
  __typename?: 'MhwUserGeneratedDocumentCreatePayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'MhwUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<MhwUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: MhwDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum MhwUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type MhwUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MhwUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MhwUserGeneratedDocumentPayload = {
  __typename?: 'MhwUserGeneratedDocumentPayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type MhwUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'MhwUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MhwUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type MhwUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'MhwUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MhwUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'MhwUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type MhwUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'MhwUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type MhwUserGeneratedDocumentUpdateInput = {
  document: Scalars['MhwUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type MhwUserGeneratedDocumentUpdatePayload = {
  __typename?: 'MhwUserGeneratedDocumentUpdatePayload';
  data?: Maybe<MhwUserGeneratedDocument>;
  error?: Maybe<MhwUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type MhwUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type MhwWeapon = MhwGameEntity & {
  __typename?: 'MhwWeapon';
  ailment?: Maybe<MhwAilment>;
  ailmentBaseAttack?: Maybe<Scalars['Int']>;
  ailmentHidden?: Maybe<Scalars['Boolean']>;
  ailmentSlug?: Maybe<Scalars['String']>;
  artianValues?: Maybe<MhwArtianValue>;
  attackModifier?: Maybe<Scalars['Float']>;
  baseAffinityPercent?: Maybe<Scalars['Int']>;
  baseAttack?: Maybe<Scalars['Int']>;
  defense?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  element?: Maybe<MhwElement>;
  elementBaseAttack?: Maybe<Scalars['Int']>;
  elementHidden?: Maybe<Scalars['Boolean']>;
  elementSlug?: Maybe<Scalars['String']>;
  handicraft?: Maybe<Array<Scalars['Int']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isArtian?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['Int']>;
  sharpnessLevelsBar?: Maybe<Array<Scalars['Int']>>;
  skills?: Maybe<Array<MhwSkill>>;
  slots?: Maybe<Array<MhwSlots>>;
  slug: Scalars['String'];
  weaponType?: Maybe<MhwWeaponType>;
  weaponTypeSlug?: Maybe<Scalars['String']>;
};

export type MhwWeaponType = MhwGameEntity & {
  __typename?: 'MhwWeaponType';
  affinityBonus?: Maybe<Scalars['Int']>;
  affinityPart?: Maybe<Scalars['Int']>;
  attackBonus?: Maybe<Scalars['Int']>;
  attackModifier?: Maybe<Scalars['Float']>;
  attackPart?: Maybe<Scalars['Int']>;
  blastPart?: Maybe<Scalars['Int']>;
  capacityBonus?: Maybe<Scalars['Int']>;
  elementBonus?: Maybe<Scalars['Int']>;
  elementPart?: Maybe<Scalars['Int']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paralysisPart?: Maybe<Scalars['Int']>;
  poisonPart?: Maybe<Scalars['Int']>;
  sharpnessBonus?: Maybe<Scalars['Int']>;
  sleepPart?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
};

export type MhwWeaponTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwWeaponTypesResult = {
  __typename?: 'MhwWeaponTypesResult';
  data?: Maybe<Array<MhwWeaponType>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type MhwWeaponsResult = {
  __typename?: 'MhwWeaponsResult';
  data?: Maybe<Array<MhwWeapon>>;
  error?: Maybe<MhwStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type MhwWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'MhwWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<MhwDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: MhwWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<MhwDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type MhwWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'MhwWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: MhwEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum MhwWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type MhwWikiDocumentPayload = {
  __typename?: 'MhwWikiDocumentPayload';
  data?: Maybe<MhwWikiDocument>;
  error?: Maybe<MhwWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type MhwWikiDocumentSetSeoPayload = {
  __typename?: 'MhwWikiDocumentSetSeoPayload';
  data?: Maybe<MhwWikiDocument>;
  error?: Maybe<MhwWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum MhwWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type MhwWikiDocumentUpdateInput = {
  document: Scalars['MhwWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type MhwWikiDocumentUpdatePayload = {
  __typename?: 'MhwWikiDocumentUpdatePayload';
  data?: Maybe<MhwWikiDocument>;
  error?: Maybe<MhwWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type MhwWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type MhwWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

/**
 * EXAMPLE — adjust the fields or replace entirely for your real event. Shows a
 * fully typed payload mapped from the stored JSONB body.
 */
export type MissionCompletedPayload = NotificationPayload & {
  __typename?: 'MissionCompletedPayload';
  missionId: Scalars['ID'];
  rewardXp: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type MobaAchievementBuildTracking = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementBuildTracking';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ownersPercent?: Maybe<Scalars['String']>;
  series: Scalars['String'];
  slug: Scalars['String'];
  threshold?: Maybe<Scalars['String']>;
  thresholdUnit?: Maybe<Scalars['String']>;
  tier: Scalars['String'];
};

export type MobaAchievementBuildTrackingFilter = {
  displayName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  series?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
};

export type MobaAchievementBuildTrackingResult = {
  __typename?: 'MobaAchievementBuildTrackingResult';
  data?: Maybe<Array<MobaAchievementBuildTracking>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaAchievementCategories = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementCategories';
  deprecated: Scalars['Boolean'];
  displayName?: Maybe<Scalars['String']>;
  groupName: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MobaAchievementCategoriesFilter = {
  displayName?: InputMaybe<OneOfString>;
  groupName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaAchievementCategoriesResult = {
  __typename?: 'MobaAchievementCategoriesResult';
  data?: Maybe<Array<MobaAchievementCategories>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaAchievementComments = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementComments';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ownersPercent?: Maybe<Scalars['String']>;
  series: Scalars['String'];
  slug: Scalars['String'];
  threshold?: Maybe<Scalars['String']>;
  thresholdUnit?: Maybe<Scalars['String']>;
  tier: Scalars['String'];
};

export type MobaAchievementCommentsFilter = {
  displayName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  series?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
};

export type MobaAchievementCommentsResult = {
  __typename?: 'MobaAchievementCommentsResult';
  data?: Maybe<Array<MobaAchievementComments>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaAchievementDocuments = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementDocuments';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ownersPercent?: Maybe<Scalars['String']>;
  series: Scalars['String'];
  slug: Scalars['String'];
  threshold?: Maybe<Scalars['String']>;
  thresholdUnit?: Maybe<Scalars['String']>;
  tier: Scalars['String'];
};

export type MobaAchievementDocumentsFilter = {
  displayName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  series?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
};

export type MobaAchievementDocumentsResult = {
  __typename?: 'MobaAchievementDocumentsResult';
  data?: Maybe<Array<MobaAchievementDocuments>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum MobaAchievementEntitiesEnum {
  buildTracking = 'buildTracking',
  categories = 'categories',
  comments = 'comments',
  documents = 'documents',
  favorites = 'favorites',
  general = 'general',
  rewardPass = 'rewardPass',
}

export type MobaAchievementEntityObject = {
  __typename?: 'MobaAchievementEntityObject';
  entityV2?: Maybe<MobaAchievementGameEntity>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type MobaAchievementFavorites = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementFavorites';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ownersPercent?: Maybe<Scalars['String']>;
  series: Scalars['String'];
  slug: Scalars['String'];
  threshold?: Maybe<Scalars['String']>;
  thresholdUnit?: Maybe<Scalars['String']>;
  tier: Scalars['String'];
};

export type MobaAchievementFavoritesFilter = {
  displayName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  series?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
};

export type MobaAchievementFavoritesResult = {
  __typename?: 'MobaAchievementFavoritesResult';
  data?: Maybe<Array<MobaAchievementFavorites>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaAchievementGameEntity = {
  slug: Scalars['String'];
};

export type MobaAchievementGeneral = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementGeneral';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ownersPercent?: Maybe<Scalars['String']>;
  series: Scalars['String'];
  slug: Scalars['String'];
  threshold?: Maybe<Scalars['String']>;
  thresholdUnit?: Maybe<Scalars['String']>;
  tier: Scalars['String'];
};

export type MobaAchievementGeneralFilter = {
  displayName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  series?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
};

export type MobaAchievementGeneralResult = {
  __typename?: 'MobaAchievementGeneralResult';
  data?: Maybe<Array<MobaAchievementGeneral>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaAchievementQuery = {
  __typename?: 'MobaAchievementQuery';
  id: Scalars['ID'];
  staticData?: Maybe<MobaAchievementStaticDataQuery>;
};

export type MobaAchievementRewardPass = MobaAchievementGameEntity & {
  __typename?: 'MobaAchievementRewardPass';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  ownersPercent?: Maybe<Scalars['String']>;
  series: Scalars['String'];
  slug: Scalars['String'];
  threshold?: Maybe<Scalars['String']>;
  thresholdUnit?: Maybe<Scalars['String']>;
  tier: Scalars['String'];
};

export type MobaAchievementRewardPassFilter = {
  displayName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  series?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
};

export type MobaAchievementRewardPassResult = {
  __typename?: 'MobaAchievementRewardPassResult';
  data?: Maybe<Array<MobaAchievementRewardPass>>;
  error?: Maybe<MobaAchievementStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum MobaAchievementStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type MobaAchievementStaticDataGroups = {
  __typename?: 'MobaAchievementStaticDataGroups';
  buildTracking: MobaAchievementBuildTrackingResult;
  categories: MobaAchievementCategoriesResult;
  comments: MobaAchievementCommentsResult;
  documents: MobaAchievementDocumentsResult;
  favorites: MobaAchievementFavoritesResult;
  general: MobaAchievementGeneralResult;
  rewardPass: MobaAchievementRewardPassResult;
};

export type MobaAchievementStaticDataGroupsbuildTrackingArgs = {
  filter?: InputMaybe<MobaAchievementBuildTrackingFilter>;
};

export type MobaAchievementStaticDataGroupscategoriesArgs = {
  filter?: InputMaybe<MobaAchievementCategoriesFilter>;
};

export type MobaAchievementStaticDataGroupscommentsArgs = {
  filter?: InputMaybe<MobaAchievementCommentsFilter>;
};

export type MobaAchievementStaticDataGroupsdocumentsArgs = {
  filter?: InputMaybe<MobaAchievementDocumentsFilter>;
};

export type MobaAchievementStaticDataGroupsfavoritesArgs = {
  filter?: InputMaybe<MobaAchievementFavoritesFilter>;
};

export type MobaAchievementStaticDataGroupsgeneralArgs = {
  filter?: InputMaybe<MobaAchievementGeneralFilter>;
};

export type MobaAchievementStaticDataGroupsrewardPassArgs = {
  filter?: InputMaybe<MobaAchievementRewardPassFilter>;
};

export type MobaAchievementStaticDataQuery = {
  __typename?: 'MobaAchievementStaticDataQuery';
  groups: MobaAchievementStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type MobaEquipmentAppIcons = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentAppIcons';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentAppIconsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentAppIconsResult = {
  __typename?: 'MobaEquipmentAppIconsResult';
  data?: Maybe<Array<MobaEquipmentAppIcons>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentAvatarFrames = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentAvatarFrames';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentAvatarFramesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentAvatarFramesResult = {
  __typename?: 'MobaEquipmentAvatarFramesResult';
  data?: Maybe<Array<MobaEquipmentAvatarFrames>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentAvatars = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentAvatars';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentAvatarsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentAvatarsResult = {
  __typename?: 'MobaEquipmentAvatarsResult';
  data?: Maybe<Array<MobaEquipmentAvatars>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentBadges = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentBadges';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentBadgesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentBadgesResult = {
  __typename?: 'MobaEquipmentBadgesResult';
  data?: Maybe<Array<MobaEquipmentBadges>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentCursorIcons = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentCursorIcons';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentCursorIconsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentCursorIconsResult = {
  __typename?: 'MobaEquipmentCursorIconsResult';
  data?: Maybe<Array<MobaEquipmentCursorIcons>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum MobaEquipmentEntitiesEnum {
  appIcons = 'appIcons',
  avatarFrames = 'avatarFrames',
  avatars = 'avatars',
  badges = 'badges',
  cursorIcons = 'cursorIcons',
  profileCovers = 'profileCovers',
  profilePlates = 'profilePlates',
  themes = 'themes',
  titles = 'titles',
  types = 'types',
}

export type MobaEquipmentEntityObject = {
  __typename?: 'MobaEquipmentEntityObject';
  entityV2?: Maybe<MobaEquipmentGameEntity>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type MobaEquipmentGameEntity = {
  slug: Scalars['String'];
};

export type MobaEquipmentProfileCovers = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentProfileCovers';
  coverImageUrl?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentProfileCoversFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentProfileCoversResult = {
  __typename?: 'MobaEquipmentProfileCoversResult';
  data?: Maybe<Array<MobaEquipmentProfileCovers>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentProfilePlates = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentProfilePlates';
  coverImageUrl?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  hexColor: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentProfilePlatesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentProfilePlatesResult = {
  __typename?: 'MobaEquipmentProfilePlatesResult';
  data?: Maybe<Array<MobaEquipmentProfilePlates>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentQuery = {
  __typename?: 'MobaEquipmentQuery';
  id: Scalars['ID'];
  staticData?: Maybe<MobaEquipmentStaticDataQuery>;
};

export enum MobaEquipmentStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type MobaEquipmentStaticDataGroups = {
  __typename?: 'MobaEquipmentStaticDataGroups';
  appIcons: MobaEquipmentAppIconsResult;
  avatarFrames: MobaEquipmentAvatarFramesResult;
  avatars: MobaEquipmentAvatarsResult;
  badges: MobaEquipmentBadgesResult;
  cursorIcons: MobaEquipmentCursorIconsResult;
  profileCovers: MobaEquipmentProfileCoversResult;
  profilePlates: MobaEquipmentProfilePlatesResult;
  themes: MobaEquipmentThemesResult;
  titles: MobaEquipmentTitlesResult;
  types: MobaEquipmentTypesResult;
};

export type MobaEquipmentStaticDataGroupsappIconsArgs = {
  filter?: InputMaybe<MobaEquipmentAppIconsFilter>;
};

export type MobaEquipmentStaticDataGroupsavatarFramesArgs = {
  filter?: InputMaybe<MobaEquipmentAvatarFramesFilter>;
};

export type MobaEquipmentStaticDataGroupsavatarsArgs = {
  filter?: InputMaybe<MobaEquipmentAvatarsFilter>;
};

export type MobaEquipmentStaticDataGroupsbadgesArgs = {
  filter?: InputMaybe<MobaEquipmentBadgesFilter>;
};

export type MobaEquipmentStaticDataGroupscursorIconsArgs = {
  filter?: InputMaybe<MobaEquipmentCursorIconsFilter>;
};

export type MobaEquipmentStaticDataGroupsprofileCoversArgs = {
  filter?: InputMaybe<MobaEquipmentProfileCoversFilter>;
};

export type MobaEquipmentStaticDataGroupsprofilePlatesArgs = {
  filter?: InputMaybe<MobaEquipmentProfilePlatesFilter>;
};

export type MobaEquipmentStaticDataGroupsthemesArgs = {
  filter?: InputMaybe<MobaEquipmentThemesFilter>;
};

export type MobaEquipmentStaticDataGroupstitlesArgs = {
  filter?: InputMaybe<MobaEquipmentTitlesFilter>;
};

export type MobaEquipmentStaticDataGroupstypesArgs = {
  filter?: InputMaybe<MobaEquipmentTypesFilter>;
};

export type MobaEquipmentStaticDataQuery = {
  __typename?: 'MobaEquipmentStaticDataQuery';
  groups: MobaEquipmentStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type MobaEquipmentThemes = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentThemes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentThemesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentThemesResult = {
  __typename?: 'MobaEquipmentThemesResult';
  data?: Maybe<Array<MobaEquipmentThemes>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentTitles = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentTitles';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewardTypes?: Maybe<MobaEquipmentTypes>;
  slug: Scalars['String'];
};

export type MobaEquipmentTitlesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentTitlesResult = {
  __typename?: 'MobaEquipmentTitlesResult';
  data?: Maybe<Array<MobaEquipmentTitles>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type MobaEquipmentTypes = MobaEquipmentGameEntity & {
  __typename?: 'MobaEquipmentTypes';
  deprecated: Scalars['Boolean'];
  groupName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type MobaEquipmentTypesFilter = {
  groupName?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type MobaEquipmentTypesResult = {
  __typename?: 'MobaEquipmentTypesResult';
  data?: Maybe<Array<MobaEquipmentTypes>>;
  error?: Maybe<MobaEquipmentStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accounts?: Maybe<AccountsMutation>;
  battlePass: BattlePassMutation;
  borderlands4: Borderlands4Mutation;
  challenge: ChallengeMutation;
  comments?: Maybe<CommentsMutation>;
  deadlock: DeadlockMutation;
  destiny?: Maybe<DestinyMutation>;
  destiny2Ngf: Destiny2NgfMutation;
  diablo4: Diablo4Mutation;
  eldenRingNightreign: EldenRingNightreignMutation;
  endfield: EndfieldMutation;
  exampleGame: ExampleGameMutation;
  gi: GiMutation;
  hades2: Hades2Mutation;
  lolNgf: LolNgfMutation;
  marathon: MarathonMutation;
  marvelRivals: MarvelRivalsMutation;
  mgp: MgpMutation;
  mhw: MhwMutation;
  news: NewsMutation;
  notifications: NotificationsMutation;
  nte: NteMutation;
  overwatch: OverwatchMutation;
  poe: PoeMutation;
  poe2: Poe2Mutation;
  rewards: RewardMutation;
  riftbound: RiftboundMutation;
  sts2: Sts2Mutation;
  tft?: Maybe<TftMutation>;
  tftNgf: TftNgfMutation;
  theBazaar: TheBazaarMutation;
  treasury?: Maybe<TreasuryMutation>;
  valorantNgf: ValorantNgfMutation;
  wowfor: WowforMutation;
  xko: XkoMutation;
  zzz: ZzzMutation;
};

/**
 * The types, implementing this interface, may be extended in static data of specific game with corresponding entities.
 * For more info take a look at TODO(wiki link).
 */
export type NGFEntityObject = {
  color?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type NewsAion2Classes = NewsGameEntity & {
  __typename?: 'NewsAion2Classes';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsAion2ClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAion2ClassesResult = {
  __typename?: 'NewsAion2ClassesResult';
  data?: Maybe<Array<NewsAion2Classes>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsAion2Skills = NewsGameEntity & {
  __typename?: 'NewsAion2Skills';
  cooldown?: Maybe<Scalars['String']>;
  damageType?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  range?: Maybe<Scalars['String']>;
  requiredWeapons?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NewsAion2SkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAion2SkillsResult = {
  __typename?: 'NewsAion2SkillsResult';
  data?: Maybe<Array<NewsAion2Skills>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsAniimoElements = NewsGameEntity & {
  __typename?: 'NewsAniimoElements';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsAniimoElementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAniimoElementsResult = {
  __typename?: 'NewsAniimoElementsResult';
  data?: Maybe<Array<NewsAniimoElements>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsAniimoHomelandAbilities = NewsGameEntity & {
  __typename?: 'NewsAniimoHomelandAbilities';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsAniimoHomelandAbilitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAniimoHomelandAbilitiesResult = {
  __typename?: 'NewsAniimoHomelandAbilitiesResult';
  data?: Maybe<Array<NewsAniimoHomelandAbilities>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsAniimoRoles = NewsGameEntity & {
  __typename?: 'NewsAniimoRoles';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsAniimoRolesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAniimoRolesResult = {
  __typename?: 'NewsAniimoRolesResult';
  data?: Maybe<Array<NewsAniimoRoles>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsAniimoStages = NewsGameEntity & {
  __typename?: 'NewsAniimoStages';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsAniimoStagesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAniimoStagesResult = {
  __typename?: 'NewsAniimoStagesResult';
  data?: Maybe<Array<NewsAniimoStages>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsAniimos = NewsGameEntity & {
  __typename?: 'NewsAniimos';
  deprecated: Scalars['Boolean'];
  element?: Maybe<Array<Scalars['String']>>;
  homelandAbilities?: Maybe<Array<NewsAniimosHomelandAbilities>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stage?: Maybe<Scalars['String']>;
};

export type NewsAniimosFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsAniimosHomelandAbilities = {
  __typename?: 'NewsAniimosHomelandAbilities';
  aniimoHomelandAbility?: Maybe<NewsAniimoHomelandAbilities>;
  value?: Maybe<Scalars['String']>;
};

export type NewsAniimosResult = {
  __typename?: 'NewsAniimosResult';
  data?: Maybe<Array<NewsAniimos>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'NewsDocumentCmWidgetV1';
  data: NewsDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NewsDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'NewsDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NewsDocumentContent =
  | NewsDocumentCmWidgetV1
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1;

export type NewsDocumentSeason = NgfDocumentSeason & {
  __typename?: 'NewsDocumentSeason';
  slug: Scalars['String'];
};

export type NewsDocumentTags = NgfDocumentTags & {
  __typename?: 'NewsDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type NewsDocumentsMutation = {
  __typename?: 'NewsDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: NewsStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: NewsStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: NewsStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: NewsStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: NewsUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: NewsUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: NewsUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: NewsUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: NewsUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: NewsUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: NewsWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: NewsWikiDocumentUpdatePayload;
};

export type NewsDocumentsMutationstructDocumentCreateArgs = {
  input: NewsStructDocumentCreateInput;
};

export type NewsDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type NewsDocumentsMutationstructDocumentSetStatusArgs = {
  input: NewsStructDocumentSetStatusInput;
};

export type NewsDocumentsMutationstructDocumentUpdateArgs = {
  input: NewsStructDocumentUpdateInput;
};

export type NewsDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: NewsUserGeneratedDocumentCreateInput;
};

export type NewsDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: NewsUserGeneratedDocumentSetFavoriteInput;
};

export type NewsDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: NewsUserGeneratedDocumentSetFeaturedInput;
};

export type NewsDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type NewsDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: NewsUserGeneratedDocumentSetStatusInput;
};

export type NewsDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: NewsUserGeneratedDocumentUpdateInput;
};

export type NewsDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type NewsDocumentsMutationwikiDocumentUpdateArgs = {
  input: NewsWikiDocumentUpdateInput;
};

export type NewsDocumentsQuery = {
  __typename?: 'NewsDocumentsQuery';
  previewDocumentContent: NewsPreviewDocumentContentPayload;
  structDocumentBySlug: NewsStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: NewsUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: NewsUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: NewsUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: NewsUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: NewsTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: NewsWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type NewsDocumentsQuerypreviewDocumentContentArgs = {
  input: NewsPreviewDocumentContentInput;
};

export type NewsDocumentsQuerystructDocumentBySlugArgs = {
  input: NewsStructDocumentInputBySlug;
};

export type NewsDocumentsQuerystructDocumentsArgs = {
  input: NewsStructDocumentsInput;
};

export type NewsDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: NewsUserGeneratedDocumentInputById;
};

export type NewsDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: NewsUserGeneratedDocumentInputBySlug;
};

export type NewsDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type NewsDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type NewsDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type NewsDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type NewsDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: NewsTemplateDocumentInput;
};

export type NewsDocumentsQueryuserGeneratedDocumentsArgs = {
  input: NewsUserGeneratedDocumentsListInput;
  page: NewsUserGeneratedDocumentsListPage;
};

export type NewsDocumentsQuerywikiDocumentArgs = {
  input: NewsWikiDocumentInput;
};

export type NewsDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<NewsWikiDocumentsListInput>;
  page: NewsWikiDocumentsListPage;
};

export type NewsDrgReclaimers = NewsGameEntity & {
  __typename?: 'NewsDrgReclaimers';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsDrgReclaimersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsDrgReclaimersResult = {
  __typename?: 'NewsDrgReclaimersResult';
  data?: Maybe<Array<NewsDrgReclaimers>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsDrgWeapons = NewsGameEntity & {
  __typename?: 'NewsDrgWeapons';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NewsDrgWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsDrgWeaponsResult = {
  __typename?: 'NewsDrgWeaponsResult';
  data?: Maybe<Array<NewsDrgWeapons>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum NewsEntitiesEnum {
  aion2Classes = 'aion2Classes',
  aion2Skills = 'aion2Skills',
  aniimoElements = 'aniimoElements',
  aniimoHomelandAbilities = 'aniimoHomelandAbilities',
  aniimoRoles = 'aniimoRoles',
  aniimoStages = 'aniimoStages',
  aniimos = 'aniimos',
  drgReclaimers = 'drgReclaimers',
  drgWeapons = 'drgWeapons',
  fireEmblemFortunesWeaveCharacters = 'fireEmblemFortunesWeaveCharacters',
  guildrunClassUpgrades = 'guildrunClassUpgrades',
  guildrunClasses = 'guildrunClasses',
  guildrunHeroAbilities = 'guildrunHeroAbilities',
  guildrunHeroes = 'guildrunHeroes',
  guildrunItems = 'guildrunItems',
  guildrunKeywords = 'guildrunKeywords',
  guildrunRelics = 'guildrunRelics',
  heroSiegeClasses = 'heroSiegeClasses',
  marvelTokonFighters = 'marvelTokonFighters',
  minaTrinkets = 'minaTrinkets',
  mistfallHuntersAffixes = 'mistfallHuntersAffixes',
  mistfallHuntersHeroes = 'mistfallHuntersHeroes',
  mistfallHuntersSkills = 'mistfallHuntersSkills',
  mistfallHuntersTalents = 'mistfallHuntersTalents',
  palWork = 'palWork',
  palworldPals = 'palworldPals',
  taskBarHeroClasses = 'taskBarHeroClasses',
  windroseWeapons = 'windroseWeapons',
  zeroCompanySpecializations = 'zeroCompanySpecializations',
}

export type NewsEntityObject = NGFEntityObject & {
  __typename?: 'NewsEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<NewsGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type NewsFireEmblemFortunesWeaveCharacters = NewsGameEntity & {
  __typename?: 'NewsFireEmblemFortunesWeaveCharacters';
  deprecated: Scalars['Boolean'];
  faction?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsFireEmblemFortunesWeaveCharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsFireEmblemFortunesWeaveCharactersResult = {
  __typename?: 'NewsFireEmblemFortunesWeaveCharactersResult';
  data?: Maybe<Array<NewsFireEmblemFortunesWeaveCharacters>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGameEntity = {
  slug: Scalars['String'];
};

export type NewsGuildrunClassUpgrades = NewsGameEntity & {
  __typename?: 'NewsGuildrunClassUpgrades';
  class?: Maybe<Array<NewsGuildrunClasses>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type NewsGuildrunClassUpgradesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunClassUpgradesResult = {
  __typename?: 'NewsGuildrunClassUpgradesResult';
  data?: Maybe<Array<NewsGuildrunClassUpgrades>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGuildrunClasses = NewsGameEntity & {
  __typename?: 'NewsGuildrunClasses';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mechanics?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsGuildrunClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunClassesResult = {
  __typename?: 'NewsGuildrunClassesResult';
  data?: Maybe<Array<NewsGuildrunClasses>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGuildrunHeroAbilities = NewsGameEntity & {
  __typename?: 'NewsGuildrunHeroAbilities';
  abilityType?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  hero?: Maybe<NewsGuildrunHeroes>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rank?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type NewsGuildrunHeroAbilitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunHeroAbilitiesResult = {
  __typename?: 'NewsGuildrunHeroAbilitiesResult';
  data?: Maybe<Array<NewsGuildrunHeroAbilities>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGuildrunHeroes = NewsGameEntity & {
  __typename?: 'NewsGuildrunHeroes';
  attackType?: Maybe<Scalars['String']>;
  class?: Maybe<Array<NewsGuildrunClasses>>;
  deprecated: Scalars['Boolean'];
  guild?: Maybe<Scalars['String']>;
  guildrunHeroesAbilities?: Maybe<Array<NewsGuildrunHeroAbilities>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type NewsGuildrunHeroesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunHeroesResult = {
  __typename?: 'NewsGuildrunHeroesResult';
  data?: Maybe<Array<NewsGuildrunHeroes>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGuildrunItems = NewsGameEntity & {
  __typename?: 'NewsGuildrunItems';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  keywords?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  shopPrice?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statKeys?: Maybe<Array<Scalars['String']>>;
};

export type NewsGuildrunItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunItemsResult = {
  __typename?: 'NewsGuildrunItemsResult';
  data?: Maybe<Array<NewsGuildrunItems>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGuildrunKeywords = NewsGameEntity & {
  __typename?: 'NewsGuildrunKeywords';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsGuildrunKeywordsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunKeywordsResult = {
  __typename?: 'NewsGuildrunKeywordsResult';
  data?: Maybe<Array<NewsGuildrunKeywords>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsGuildrunRelics = NewsGameEntity & {
  __typename?: 'NewsGuildrunRelics';
  class?: Maybe<Array<NewsGuildrunClasses>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Array<Scalars['String']>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  keywords?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  shopPrice?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statKeys?: Maybe<Array<Scalars['String']>>;
};

export type NewsGuildrunRelicsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsGuildrunRelicsResult = {
  __typename?: 'NewsGuildrunRelicsResult';
  data?: Maybe<Array<NewsGuildrunRelics>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsHeroSiegeClasses = NewsGameEntity & {
  __typename?: 'NewsHeroSiegeClasses';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsHeroSiegeClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsHeroSiegeClassesResult = {
  __typename?: 'NewsHeroSiegeClassesResult';
  data?: Maybe<Array<NewsHeroSiegeClasses>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMarvelTokonFighters = NewsGameEntity & {
  __typename?: 'NewsMarvelTokonFighters';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  easeOfUse?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsMarvelTokonFightersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsMarvelTokonFightersResult = {
  __typename?: 'NewsMarvelTokonFightersResult';
  data?: Maybe<Array<NewsMarvelTokonFighters>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMinaTrinkets = NewsGameEntity & {
  __typename?: 'NewsMinaTrinkets';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsMinaTrinketsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsMinaTrinketsResult = {
  __typename?: 'NewsMinaTrinketsResult';
  data?: Maybe<Array<NewsMinaTrinkets>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMistfallHuntersAffixes = NewsGameEntity & {
  __typename?: 'NewsMistfallHuntersAffixes';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsMistfallHuntersAffixesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsMistfallHuntersAffixesResult = {
  __typename?: 'NewsMistfallHuntersAffixesResult';
  data?: Maybe<Array<NewsMistfallHuntersAffixes>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMistfallHuntersHeroes = NewsGameEntity & {
  __typename?: 'NewsMistfallHuntersHeroes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsMistfallHuntersHeroesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsMistfallHuntersHeroesResult = {
  __typename?: 'NewsMistfallHuntersHeroesResult';
  data?: Maybe<Array<NewsMistfallHuntersHeroes>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMistfallHuntersSkills = NewsGameEntity & {
  __typename?: 'NewsMistfallHuntersSkills';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  weapon?: Maybe<Scalars['String']>;
};

export type NewsMistfallHuntersSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsMistfallHuntersSkillsResult = {
  __typename?: 'NewsMistfallHuntersSkillsResult';
  data?: Maybe<Array<NewsMistfallHuntersSkills>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMistfallHuntersTalents = NewsGameEntity & {
  __typename?: 'NewsMistfallHuntersTalents';
  class?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  levelRequired?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NewsMistfallHuntersTalentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsMistfallHuntersTalentsResult = {
  __typename?: 'NewsMistfallHuntersTalentsResult';
  data?: Maybe<Array<NewsMistfallHuntersTalents>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsMutation = {
  __typename?: 'NewsMutation';
  documents?: Maybe<NewsDocumentsMutation>;
  id: Scalars['ID'];
};

export type NewsPalWork = NewsGameEntity & {
  __typename?: 'NewsPalWork';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsPalWorkFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsPalWorkResult = {
  __typename?: 'NewsPalWorkResult';
  data?: Maybe<Array<NewsPalWork>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsPalworldPals = NewsGameEntity & {
  __typename?: 'NewsPalworldPals';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  partnerSkill?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<Array<Scalars['String']>>;
  workSuitability?: Maybe<Array<NewsPalworldPalsWorkSuitability>>;
};

export type NewsPalworldPalsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsPalworldPalsResult = {
  __typename?: 'NewsPalworldPalsResult';
  data?: Maybe<Array<NewsPalworldPals>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsPalworldPalsWorkSuitability = {
  __typename?: 'NewsPalworldPalsWorkSuitability';
  palWork?: Maybe<NewsPalWork>;
  value?: Maybe<Scalars['String']>;
};

export enum NewsPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsPreviewDocumentContentInput = {
  content: Scalars['NewsDocumentContentInputBase64Json'];
};

export type NewsPreviewDocumentContentPayload = {
  __typename?: 'NewsPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<NewsDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<NewsPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsProfile = NgfProfile & {
  __typename?: 'NewsProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type NewsProfileuserGeneratedDocumentsArgs = {
  input: NewsUserGeneratedDocumentsListInput;
  page: NewsUserGeneratedDocumentsListPage;
};

export type NewsProfilePayload = {
  __typename?: 'NewsProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<NewsProfile>;
};

export type NewsProfilesQuery = {
  __typename?: 'NewsProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: NewsProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type NewsProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type NewsQuery = {
  __typename?: 'NewsQuery';
  documents?: Maybe<NewsDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<NewsProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<NewsStaticDataQuery>;
};

export enum NewsStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type NewsStaticDataGroups = {
  __typename?: 'NewsStaticDataGroups';
  aion2Classes: NewsAion2ClassesResult;
  aion2Skills: NewsAion2SkillsResult;
  aniimoElements: NewsAniimoElementsResult;
  aniimoHomelandAbilities: NewsAniimoHomelandAbilitiesResult;
  aniimoRoles: NewsAniimoRolesResult;
  aniimoStages: NewsAniimoStagesResult;
  aniimos: NewsAniimosResult;
  drgReclaimers: NewsDrgReclaimersResult;
  drgWeapons: NewsDrgWeaponsResult;
  fireEmblemFortunesWeaveCharacters: NewsFireEmblemFortunesWeaveCharactersResult;
  guildrunClassUpgrades: NewsGuildrunClassUpgradesResult;
  guildrunClasses: NewsGuildrunClassesResult;
  guildrunHeroAbilities: NewsGuildrunHeroAbilitiesResult;
  guildrunHeroes: NewsGuildrunHeroesResult;
  guildrunItems: NewsGuildrunItemsResult;
  guildrunKeywords: NewsGuildrunKeywordsResult;
  guildrunRelics: NewsGuildrunRelicsResult;
  heroSiegeClasses: NewsHeroSiegeClassesResult;
  marvelTokonFighters: NewsMarvelTokonFightersResult;
  minaTrinkets: NewsMinaTrinketsResult;
  mistfallHuntersAffixes: NewsMistfallHuntersAffixesResult;
  mistfallHuntersHeroes: NewsMistfallHuntersHeroesResult;
  mistfallHuntersSkills: NewsMistfallHuntersSkillsResult;
  mistfallHuntersTalents: NewsMistfallHuntersTalentsResult;
  palWork: NewsPalWorkResult;
  palworldPals: NewsPalworldPalsResult;
  taskBarHeroClasses: NewsTaskBarHeroClassesResult;
  windroseWeapons: NewsWindroseWeaponsResult;
  zeroCompanySpecializations: NewsZeroCompanySpecializationsResult;
};

export type NewsStaticDataGroupsaion2ClassesArgs = {
  filter?: InputMaybe<NewsAion2ClassesFilter>;
};

export type NewsStaticDataGroupsaion2SkillsArgs = {
  filter?: InputMaybe<NewsAion2SkillsFilter>;
};

export type NewsStaticDataGroupsaniimoElementsArgs = {
  filter?: InputMaybe<NewsAniimoElementsFilter>;
};

export type NewsStaticDataGroupsaniimoHomelandAbilitiesArgs = {
  filter?: InputMaybe<NewsAniimoHomelandAbilitiesFilter>;
};

export type NewsStaticDataGroupsaniimoRolesArgs = {
  filter?: InputMaybe<NewsAniimoRolesFilter>;
};

export type NewsStaticDataGroupsaniimoStagesArgs = {
  filter?: InputMaybe<NewsAniimoStagesFilter>;
};

export type NewsStaticDataGroupsaniimosArgs = {
  filter?: InputMaybe<NewsAniimosFilter>;
};

export type NewsStaticDataGroupsdrgReclaimersArgs = {
  filter?: InputMaybe<NewsDrgReclaimersFilter>;
};

export type NewsStaticDataGroupsdrgWeaponsArgs = {
  filter?: InputMaybe<NewsDrgWeaponsFilter>;
};

export type NewsStaticDataGroupsfireEmblemFortunesWeaveCharactersArgs = {
  filter?: InputMaybe<NewsFireEmblemFortunesWeaveCharactersFilter>;
};

export type NewsStaticDataGroupsguildrunClassUpgradesArgs = {
  filter?: InputMaybe<NewsGuildrunClassUpgradesFilter>;
};

export type NewsStaticDataGroupsguildrunClassesArgs = {
  filter?: InputMaybe<NewsGuildrunClassesFilter>;
};

export type NewsStaticDataGroupsguildrunHeroAbilitiesArgs = {
  filter?: InputMaybe<NewsGuildrunHeroAbilitiesFilter>;
};

export type NewsStaticDataGroupsguildrunHeroesArgs = {
  filter?: InputMaybe<NewsGuildrunHeroesFilter>;
};

export type NewsStaticDataGroupsguildrunItemsArgs = {
  filter?: InputMaybe<NewsGuildrunItemsFilter>;
};

export type NewsStaticDataGroupsguildrunKeywordsArgs = {
  filter?: InputMaybe<NewsGuildrunKeywordsFilter>;
};

export type NewsStaticDataGroupsguildrunRelicsArgs = {
  filter?: InputMaybe<NewsGuildrunRelicsFilter>;
};

export type NewsStaticDataGroupsheroSiegeClassesArgs = {
  filter?: InputMaybe<NewsHeroSiegeClassesFilter>;
};

export type NewsStaticDataGroupsmarvelTokonFightersArgs = {
  filter?: InputMaybe<NewsMarvelTokonFightersFilter>;
};

export type NewsStaticDataGroupsminaTrinketsArgs = {
  filter?: InputMaybe<NewsMinaTrinketsFilter>;
};

export type NewsStaticDataGroupsmistfallHuntersAffixesArgs = {
  filter?: InputMaybe<NewsMistfallHuntersAffixesFilter>;
};

export type NewsStaticDataGroupsmistfallHuntersHeroesArgs = {
  filter?: InputMaybe<NewsMistfallHuntersHeroesFilter>;
};

export type NewsStaticDataGroupsmistfallHuntersSkillsArgs = {
  filter?: InputMaybe<NewsMistfallHuntersSkillsFilter>;
};

export type NewsStaticDataGroupsmistfallHuntersTalentsArgs = {
  filter?: InputMaybe<NewsMistfallHuntersTalentsFilter>;
};

export type NewsStaticDataGroupspalWorkArgs = {
  filter?: InputMaybe<NewsPalWorkFilter>;
};

export type NewsStaticDataGroupspalworldPalsArgs = {
  filter?: InputMaybe<NewsPalworldPalsFilter>;
};

export type NewsStaticDataGroupstaskBarHeroClassesArgs = {
  filter?: InputMaybe<NewsTaskBarHeroClassesFilter>;
};

export type NewsStaticDataGroupswindroseWeaponsArgs = {
  filter?: InputMaybe<NewsWindroseWeaponsFilter>;
};

export type NewsStaticDataGroupszeroCompanySpecializationsArgs = {
  filter?: InputMaybe<NewsZeroCompanySpecializationsFilter>;
};

export type NewsStaticDataQuery = {
  __typename?: 'NewsStaticDataQuery';
  groups: NewsStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type NewsStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'NewsStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<NewsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: NewsStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum NewsStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NewsStructDocumentCreateInput = {
  document: Scalars['NewsStructDocumentInputBase64Json'];
};

export type NewsStructDocumentCreatePayload = {
  __typename?: 'NewsStructDocumentCreatePayload';
  data?: Maybe<NewsStructDocument>;
  error?: Maybe<NewsStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsStructDocumentData = NgfStructDocumentData & {
  __typename?: 'NewsStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: NewsDocumentSeason;
  tags?: Maybe<NewsDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum NewsStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NewsStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NewsStructDocumentPayload = {
  __typename?: 'NewsStructDocumentPayload';
  data?: Maybe<NewsStructDocument>;
  error?: Maybe<NewsStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NewsStructDocumentSetSeoPayload = {
  __typename?: 'NewsStructDocumentSetSeoPayload';
  data?: Maybe<NewsStructDocument>;
  error?: Maybe<NewsStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type NewsStructDocumentSetStatusPayload = {
  __typename?: 'NewsStructDocumentSetStatusPayload';
  data?: Maybe<NewsStructDocument>;
  error?: Maybe<NewsStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsStructDocumentUpdateInput = {
  document: Scalars['NewsStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type NewsStructDocumentUpdatePayload = {
  __typename?: 'NewsStructDocumentUpdatePayload';
  data?: Maybe<NewsStructDocument>;
  error?: Maybe<NewsStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type NewsTaskBarHeroClasses = NewsGameEntity & {
  __typename?: 'NewsTaskBarHeroClasses';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsTaskBarHeroClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsTaskBarHeroClassesResult = {
  __typename?: 'NewsTaskBarHeroClassesResult';
  data?: Maybe<Array<NewsTaskBarHeroClasses>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'NewsTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<NewsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: NewsTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type NewsTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'NewsTemplateDocumentData';
  buildVariants?: Maybe<NewsUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: NewsDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum NewsTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsTemplateDocumentInput = {
  type: Scalars['String'];
};

export type NewsTemplateDocumentPayload = {
  __typename?: 'NewsTemplateDocumentPayload';
  data?: Maybe<NewsTemplateDocument>;
  error?: Maybe<NewsTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'NewsUGDocumentGenericBuilder';
  slots?: Maybe<Array<NewsUGDocumentGenericBuilderSlot>>;
};

export type NewsUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'NewsUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<NewsEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type NewsUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'NewsUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<NewsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: NewsUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<NewsDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type NewsUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'NewsUserGeneratedDocumentBuildVariant';
  genericBuilder: NewsUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type NewsUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'NewsUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<NewsUserGeneratedDocumentBuildVariant>>;
};

export enum NewsUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NewsUserGeneratedDocumentCreateInput = {
  document: Scalars['NewsUserGeneratedDocumentInputBase64Json'];
};

export type NewsUserGeneratedDocumentCreatePayload = {
  __typename?: 'NewsUserGeneratedDocumentCreatePayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'NewsUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<NewsUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: NewsDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum NewsUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NewsUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NewsUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NewsUserGeneratedDocumentPayload = {
  __typename?: 'NewsUserGeneratedDocumentPayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type NewsUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'NewsUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NewsUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type NewsUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'NewsUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NewsUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'NewsUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type NewsUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'NewsUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NewsUserGeneratedDocumentUpdateInput = {
  document: Scalars['NewsUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type NewsUserGeneratedDocumentUpdatePayload = {
  __typename?: 'NewsUserGeneratedDocumentUpdatePayload';
  data?: Maybe<NewsUserGeneratedDocument>;
  error?: Maybe<NewsUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type NewsUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type NewsWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'NewsWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<NewsDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: NewsWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<NewsDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type NewsWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'NewsWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: NewsEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum NewsWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NewsWikiDocumentPayload = {
  __typename?: 'NewsWikiDocumentPayload';
  data?: Maybe<NewsWikiDocument>;
  error?: Maybe<NewsWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NewsWikiDocumentSetSeoPayload = {
  __typename?: 'NewsWikiDocumentSetSeoPayload';
  data?: Maybe<NewsWikiDocument>;
  error?: Maybe<NewsWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NewsWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NewsWikiDocumentUpdateInput = {
  document: Scalars['NewsWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type NewsWikiDocumentUpdatePayload = {
  __typename?: 'NewsWikiDocumentUpdatePayload';
  data?: Maybe<NewsWikiDocument>;
  error?: Maybe<NewsWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NewsWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NewsWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type NewsWindroseWeapons = NewsGameEntity & {
  __typename?: 'NewsWindroseWeapons';
  ability?: Maybe<Scalars['String']>;
  attack?: Maybe<Array<Scalars['String']>>;
  canAscend?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  epicPower?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarities?: Maybe<Array<Scalars['String']>>;
  rarity?: Maybe<Scalars['String']>;
  scaling?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NewsWindroseWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsWindroseWeaponsResult = {
  __typename?: 'NewsWindroseWeaponsResult';
  data?: Maybe<Array<NewsWindroseWeapons>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NewsZeroCompanySpecializations = NewsGameEntity & {
  __typename?: 'NewsZeroCompanySpecializations';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NewsZeroCompanySpecializationsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NewsZeroCompanySpecializationsResult = {
  __typename?: 'NewsZeroCompanySpecializationsResult';
  data?: Maybe<Array<NewsZeroCompanySpecializations>>;
  error?: Maybe<NewsStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NgfBannerBackground = {
  __typename?: 'NgfBannerBackground';
  advanced?: Maybe<Scalars['String']>;
  simple?: Maybe<Scalars['String']>;
};

export type NgfBannerContent = {
  __typename?: 'NgfBannerContent';
  background: NgfBannerBackground;
  linkText?: Maybe<Scalars['String']>;
  linkURL?: Maybe<Scalars['String']>;
  openLinkInNewTab: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  withCloseButton: Scalars['Boolean'];
};

export type NgfBannerDisplay = {
  __typename?: 'NgfBannerDisplay';
  abTestKey?: Maybe<Scalars['String']>;
  allowedUserLevels?: Maybe<Array<NgfBannerUserLevel>>;
  countries?: Maybe<Array<Scalars['String']>>;
  distribution?: Maybe<Scalars['Int']>;
  minScreenWidth?: Maybe<Scalars['String']>;
  platform?: Maybe<Array<Scalars['String']>>;
  regions?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  urlExcludePatterns?: Maybe<Array<Scalars['String']>>;
  urlMatchPatterns?: Maybe<Array<Scalars['String']>>;
  whiteListUserIds?: Maybe<Array<Scalars['String']>>;
};

export enum NgfBannerUserLevel {
  AD_FREE = 'AD_FREE',
  GUEST = 'GUEST',
  PLUS = 'PLUS',
  REGULAR = 'REGULAR',
  TRIAL = 'TRIAL',
}

export type NgfBanners = {
  __typename?: 'NgfBanners';
  takeovers?: Maybe<Array<NgfTakeoverBanner>>;
  topBanners?: Maybe<Array<NgfTopBanner>>;
};

export type NgfBuildVariantGenericBuilder = {
  slots?: Maybe<Array<NgfBuildVariantGenericBuilderSlot>>;
};

export type NgfBuildVariantGenericBuilderSlot = {
  gameEntity?: Maybe<NGFEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export enum NgfCommentsSortingOption {
  NEW = 'NEW',
  OLD = 'OLD',
  TOP = 'TOP',
}

export type NgfCommonWidgetsOverride = {
  NgfDocumentCmWidgetCommentsV1?: InputMaybe<NgfDocumentCmWidgetCommentsOverrideV1>;
  NgfDocumentCmWidgetUGTierListV1?: InputMaybe<NgfDocumentCmWidgetUGTierListOverrideV1>;
  NgfDocumentCmWidgetUGTierListV2?: InputMaybe<NgfDocumentCmWidgetUGTierListOverrideV2>;
  NgfDocumentCmWidgetWikiDiscoveryDetailedV1?: InputMaybe<NgfDocumentCmWidgetWikiDiscoveryDetailedOverrideV1>;
  NgfDocumentStWidgetDocumentsDiscoveryV1?: InputMaybe<NgfDocumentWidgetDocumentsDiscoveryOverrideV1>;
  widgetID: Scalars['String'];
};

export type NgfCreatorsPayload = {
  __typename?: 'NgfCreatorsPayload';
  data?: Maybe<Array<NgfDocumentAuthorCreator>>;
};

/**
 * Common contract every NGF document type is expected to implement. The strict
 * intersection of fields shared by NgfUserGeneratedDocument, NgfStructDocument
 * and NgfWikiDocument.
 */
export type NgfDocument = {
  /** Document kind classification (UG / ST / WIKI). */
  category: NgfDocumentCategory;
  createdAt: Scalars['NgfDateTime'];
  /** Stable identifier. */
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  /** SEO metadata (title, description, og:image, etc.). */
  seo?: Maybe<NgfDocumentSeo>;
  updatedAt: Scalars['NgfDateTime'];
  /** Monotonic document version. */
  version: Scalars['Int'];
};

export type NgfDocumentAuthor = {
  __typename?: 'NgfDocumentAuthor';
  /**
   * DEPRECATED: Use 'user' field instead.
   * @deprecated Use 'user' field instead.
   */
  creator?: Maybe<NgfDocumentAuthorCreator>;
  eligibleForIndex?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isCreator?: Maybe<Scalars['Boolean']>;
  /**
   * DEPRECATED: Use 'user' field instead.
   * @deprecated Use 'user' field instead.
   */
  links?: Maybe<Array<NgfDocumentAuthorLink>>;
  /**
   * DEPRECATED: Use 'user' field instead.
   * @deprecated Use 'user' field instead.
   */
  name: Scalars['String'];
  twitchLive?: Maybe<Twitch>;
  user?: Maybe<User>;
};

export type NgfDocumentAuthorCreator = {
  __typename?: 'NgfDocumentAuthorCreator';
  /**
   * DEPRECATED: It's not supported anymore.
   * @deprecated It's not supported anymore
   */
  previousProfileName?: Maybe<Scalars['String']>;
  profileName: Scalars['String'];
};

export type NgfDocumentAuthorLink = {
  __typename?: 'NgfDocumentAuthorLink';
  network: NgfDocumentAuthorNetwork;
  url: Scalars['String'];
};

export type NgfDocumentAuthorNetwork = {
  __typename?: 'NgfDocumentAuthorNetwork';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Document kind classification used across NGF games. */
export enum NgfDocumentCategory {
  /** Structured (curated) content. */
  ST = 'ST',
  /** User-generated content. */
  UG = 'UG',
  /** Wiki content. */
  WIKI = 'WIKI',
}

export enum NgfDocumentCmIconStyle {
  CIRCLE = 'CIRCLE',
  RHOMBUS = 'RHOMBUS',
  SQUARE = 'SQUARE',
  SQUARE_ROUNDED = 'SQUARE_ROUNDED',
}

export type NgfDocumentCmSectionAuto1V1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmSectionAuto1V1';
  data: NgfDocumentCmSectionAuto1V1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmSectionAuto1V1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmSectionAuto1V1Data';
  childrenIds: Array<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type NgfDocumentCmSectionAuto3V1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmSectionAuto3V1';
  data: NgfDocumentCmSectionAuto3V1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmSectionAuto3V1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmSectionAuto3V1Data';
  childrenIds: Array<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type NgfDocumentCmSectionAuto400V1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmSectionAuto400V1';
  data: NgfDocumentCmSectionAuto400V1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmSectionAuto400V1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmSectionAuto400V1Data';
  childrenIds: Array<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type NgfDocumentCmSectionVideoAdV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmSectionVideoAdV1';
  data: NgfDocumentCmSectionVideoAdV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmSectionVideoAdV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmSectionVideoAdV1Data';
  childrenIds: Array<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type NgfDocumentCmWidgetCardGridV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetCardGridV1';
  data: NgfDocumentCmWidgetCardGridV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetCardGridV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetCardGridV1Data';
  cardLayout: NgfDocumentCmWidgetCardGridV1Layout;
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentCmWidgetCardGridV1DataItem>;
  subTitle?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetCardGridV1DataItem = {
  __typename?: 'NgfDocumentCmWidgetCardGridV1DataItem';
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum NgfDocumentCmWidgetCardGridV1Layout {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export type NgfDocumentCmWidgetCardGridV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetCardGridV2';
  data: NgfDocumentCmWidgetCardGridV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetCardGridV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetCardGridV2Data';
  cardLayout: NgfDocumentCmWidgetCardGridV2Layout;
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentCmWidgetCardGridV2DataItem>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetCardGridV2DataItem = {
  __typename?: 'NgfDocumentCmWidgetCardGridV2DataItem';
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum NgfDocumentCmWidgetCardGridV2Layout {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

/**
 * Override applied by the FE when a page is opened on a specific comment. The commentId is
 * forwarded into the widget's CommentsPayload so the Comments subgraph can build the payload
 * around that comment.
 */
export type NgfDocumentCmWidgetCommentsOverrideV1 = {
  commentId?: InputMaybe<Scalars['ID']>;
};

/**
 * NgfDocumentCmWidgetCommentsV1 renders a CommentsPayload owned by the Comments subgraph
 * for the editor-defined `resourceId`. Federation handles loading the first page; the resulting
 * CommentsPayload reports the `sortBy`/`limit` that was applied so the FE can chain pagination.
 */
export type NgfDocumentCmWidgetCommentsV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetCommentsV1';
  data: NgfDocumentCmWidgetCommentsV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetCommentsV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetCommentsV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isDisabled: Scalars['Boolean'];
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  /**
   * Resolved separately. Returns a stub CommentsPayload (resourceId only) so federation
   * routes to the Comments subgraph for first-page resolution. The returned payload
   * carries the actual `sortBy` and `limit` it was loaded with.
   */
  payload?: Maybe<CommentsPayload>;
  /**
   * Editor-defined UI behaviour for the comments widget (loading strategy, sorting controls).
   * Pure presentation config — the comments themselves are owned by the Comments subgraph and
   * reached via `payload`.
   */
  uiCapabilities?: Maybe<NgfDocumentCmWidgetCommentsV1UICapabilities>;
};

export type NgfDocumentCmWidgetCommentsV1DataSorting = {
  __typename?: 'NgfDocumentCmWidgetCommentsV1DataSorting';
  defaultSortingOption?: Maybe<NgfCommentsSortingOption>;
  enabled: Scalars['Boolean'];
};

export type NgfDocumentCmWidgetCommentsV1UICapabilities = {
  __typename?: 'NgfDocumentCmWidgetCommentsV1UICapabilities';
  loadingBehaviour?: Maybe<NgfDocumentLoadingBehaviour>;
  sorting?: Maybe<NgfDocumentCmWidgetCommentsV1DataSorting>;
};

export type NgfDocumentCmWidgetContentVariantsV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetContentVariantsV1';
  data: NgfDocumentCmWidgetContentVariantsV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetContentVariantsV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetContentVariantsV1Data';
  childrenVariants: Array<NgfDocumentCmWidgetContentVariantsV1DataChildVariant>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetContentVariantsV1DataChildVariant = {
  __typename?: 'NgfDocumentCmWidgetContentVariantsV1DataChildVariant';
  childrenIds: Array<Scalars['String']>;
  description?: Maybe<NgfDocumentRichTextContent>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetCrossPageTabBarV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetCrossPageTabBarV1';
  data: NgfDocumentCmWidgetCrossPageTabBarV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetCrossPageTabBarV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetCrossPageTabBarV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentCmWidgetCrossPageTabBarV1Item>;
};

export type NgfDocumentCmWidgetCrossPageTabBarV1Item = {
  __typename?: 'NgfDocumentCmWidgetCrossPageTabBarV1Item';
  path: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/**
 * NgfDocumentCmWidgetDiscoveryPersonalFeedV1 lists documents personal to the viewer: their favorites or documents of creators they follow.
 * discovery.isFavorite or discovery.isFollowing picks the list; discovery.featuredStatuses is the fallback list shown to guests.
 */
export type NgfDocumentCmWidgetDiscoveryPersonalFeedV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPersonalFeedV1';
  data: NgfDocumentCmWidgetDiscoveryPersonalFeedV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDiscoveryPersonalFeedV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPersonalFeedV1Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
  visual: NgfDocumentCmWidgetDiscoveryPreviewCompactV2Visual;
};

export type NgfDocumentCmWidgetDiscoveryPreviewCompactOverrideV1 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NgfDocumentCmWidgetDiscoveryPreviewCompactOverrideV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

/** NgfDocumentCmWidgetDiscoveryPreviewCompactV1 is useful to promote specific types of documents e.g. Popular Guides in UG documents (Builds, Guides). */
export type NgfDocumentCmWidgetDiscoveryPreviewCompactV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewCompactV1';
  data: NgfDocumentCmWidgetDiscoveryPreviewCompactV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDiscoveryPreviewCompactV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewCompactV1Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  uiCapabilities?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
  visual: NgfDocumentCmWidgetDiscoveryPreviewCompactV1Visual;
};

export enum NgfDocumentCmWidgetDiscoveryPreviewCompactV1Visual {
  COUNTER = 'COUNTER',
  IMAGE = 'IMAGE',
}

/** NgfDocumentCmWidgetDiscoveryPreviewCompactV2 is useful to promote specific types of documents e.g. Popular Guides in UG documents (Builds, Guides). */
export type NgfDocumentCmWidgetDiscoveryPreviewCompactV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewCompactV2';
  data: NgfDocumentCmWidgetDiscoveryPreviewCompactV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDiscoveryPreviewCompactV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewCompactV2Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
  uiCapabilities?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
  visual: NgfDocumentCmWidgetDiscoveryPreviewCompactV2Visual;
};

export enum NgfDocumentCmWidgetDiscoveryPreviewCompactV2Visual {
  COUNTER = 'COUNTER',
  IMAGE = 'IMAGE',
}

export type NgfDocumentCmWidgetDiscoveryPreviewOverrideV1 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NgfDocumentCmWidgetDiscoveryPreviewOverrideV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

/** NgfDocumentCmWidgetDiscoveryPreviewV1 is useful to promote specific types of documents e.g. Featured or Community Builds on pages like Home Page or Wiki Pages.. */
export type NgfDocumentCmWidgetDiscoveryPreviewV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewV1';
  data: NgfDocumentCmWidgetDiscoveryPreviewV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDiscoveryPreviewV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewV1Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  uiCapabilities?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
};

/** NgfDocumentCmWidgetDiscoveryPreviewV2 is useful to promote specific types of documents e.g. Featured or Community Builds on pages like Home Page or Wiki Pages.. */
export type NgfDocumentCmWidgetDiscoveryPreviewV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewV2';
  data: NgfDocumentCmWidgetDiscoveryPreviewV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDiscoveryPreviewV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDiscoveryPreviewV2Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
  uiCapabilities?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
};

export type NgfDocumentCmWidgetDisplayAdsV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDisplayAdsV1';
  data: NgfDocumentCmWidgetDisplayAdsV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDisplayAdsV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDisplayAdsV1Data';
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  platform: Array<NgfDocumentCmWidgetDisplayAdsV1DataPlatform>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetDisplayAdsV1DataPlatform = {
  __typename?: 'NgfDocumentCmWidgetDisplayAdsV1DataPlatform';
  size?: Maybe<NgfDocumentCmWidgetDisplayAdsV1DataSize>;
  type: NgfDocumentCmWidgetDisplayAdsV1DataPlatformType;
};

export enum NgfDocumentCmWidgetDisplayAdsV1DataPlatformType {
  DESKTOP_WEB = 'DESKTOP_WEB',
  MOBILE = 'MOBILE',
  OW_ELECTRON_APP = 'OW_ELECTRON_APP',
}

export enum NgfDocumentCmWidgetDisplayAdsV1DataSize {
  DESKTOP_300x250 = 'DESKTOP_300x250',
  DESKTOP_728x90 = 'DESKTOP_728x90',
  MOBILE_300x100 = 'MOBILE_300x100',
  MOBILE_300x250 = 'MOBILE_300x250',
  MOBILE_320x50 = 'MOBILE_320x50',
}

export type NgfDocumentCmWidgetDocumentsFeedV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDocumentsFeedV1';
  data: NgfDocumentCmWidgetDocumentsFeedV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDocumentsFeedV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDocumentsFeedV1Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetDocumentsFeedV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetDocumentsFeedV2';
  data: NgfDocumentCmWidgetDocumentsFeedV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetDocumentsFeedV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetDocumentsFeedV2Data';
  buttonLinkUrl?: Maybe<Scalars['String']>;
  buttonTitle?: Maybe<Scalars['String']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  openButtonLinkInNewTab?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetErrorV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetErrorV1';
  data: NgfDocumentCmWidgetErrorV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetErrorV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetErrorV1Data';
  error: NgfDocumentCmWidgetErrorV1DataError;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export enum NgfDocumentCmWidgetErrorV1DataError {
  INTERNAL = 'INTERNAL',
}

export type NgfDocumentCmWidgetGameDataCardGridV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetGameDataCardGridV1';
  data: NgfDocumentCmWidgetGameDataCardGridV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetGameDataCardGridV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetGameDataCardGridV1Data';
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentCmWidgetGameDataCardGridV1DataItem>;
  layout: NgfDocumentCmWidgetGameDataCardGridV1Layout;
  subTitle?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetGameDataCardGridV1DataItem = {
  __typename?: 'NgfDocumentCmWidgetGameDataCardGridV1DataItem';
  groupSlug: Scalars['String'];
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum NgfDocumentCmWidgetGameDataCardGridV1Layout {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export type NgfDocumentCmWidgetGameDataCardGridV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetGameDataCardGridV2';
  data: NgfDocumentCmWidgetGameDataCardGridV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetGameDataCardGridV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetGameDataCardGridV2Data';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentCmWidgetGameDataCardGridV2DataItem>;
  layout: NgfDocumentCmWidgetGameDataCardGridV2Layout;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetGameDataCardGridV2DataItem = {
  __typename?: 'NgfDocumentCmWidgetGameDataCardGridV2DataItem';
  groupSlug: Scalars['String'];
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum NgfDocumentCmWidgetGameDataCardGridV2Layout {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export type NgfDocumentCmWidgetMapV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetMapV1';
  data: NgfDocumentCmWidgetMapV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetMapV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetMapV1Data';
  description?: Maybe<NgfDocumentRichTextContent>;
  featureEntities?: Maybe<Array<NgfDocumentMapFeatureEntity>>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  mapConfig: Scalars['Map'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetPromoBannerHorizontalV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetPromoBannerHorizontalV1';
  data: NgfDocumentCmWidgetPromoBannerHorizontalV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetPromoBannerHorizontalV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetPromoBannerHorizontalV1Data';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  buttonTextColor?: Maybe<Scalars['String']>;
  buttonTitle: Scalars['String'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  linkUrl: Scalars['String'];
  mixpanelSlug: Scalars['String'];
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  platforms?: Maybe<Array<NgfPlatform>>;
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  userLevels?: Maybe<Array<NgfUserLevel>>;
};

export type NgfDocumentCmWidgetPromoBannerNetboardV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetPromoBannerNetboardV1';
  data: NgfDocumentCmWidgetPromoBannerNetboardV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetPromoBannerNetboardV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetPromoBannerNetboardV1Data';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  buttonColor?: Maybe<Scalars['String']>;
  buttonTextColor?: Maybe<Scalars['String']>;
  buttonTitle: Scalars['String'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  linkUrl: Scalars['String'];
  mixpanelSlug: Scalars['String'];
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  platforms?: Maybe<Array<NgfPlatform>>;
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  userLevels?: Maybe<Array<NgfUserLevel>>;
};

export type NgfDocumentCmWidgetRichTextSimplifiedV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetRichTextSimplifiedV1';
  data: NgfDocumentCmWidgetRichTextSimplifiedV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetRichTextSimplifiedV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetRichTextSimplifiedV1Data';
  content?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetRichTextSimplifiedV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetRichTextSimplifiedV2';
  data: NgfDocumentCmWidgetRichTextSimplifiedV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetRichTextSimplifiedV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetRichTextSimplifiedV2Data';
  content?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetRichTextV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetRichTextV1';
  data: NgfDocumentCmWidgetRichTextV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetRichTextV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetRichTextV1Data';
  content?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetRichTextV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetRichTextV2';
  data: NgfDocumentCmWidgetRichTextV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetRichTextV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetRichTextV2Data';
  content?: Maybe<Scalars['Map']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetStrengthsAndWeaknessesV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetStrengthsAndWeaknessesV1';
  data: NgfDocumentCmWidgetStrengthsAndWeaknessesV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetStrengthsAndWeaknessesV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetStrengthsAndWeaknessesV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  layout: NgfDocumentCmWidgetStrengthsAndWeaknessesV1Layout;
  pointsLimit: Scalars['Int'];
  strengths: NgfDocumentRichTextContent;
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
  weaknesses: NgfDocumentRichTextContent;
};

export enum NgfDocumentCmWidgetStrengthsAndWeaknessesV1Layout {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}

export type NgfDocumentCmWidgetTableOfContentV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetTableOfContentV1';
  data: NgfDocumentCmWidgetTableOfContentV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetTableOfContentV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetTableOfContentV1Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  stub?: Maybe<Scalars['String']>;
};

export enum NgfDocumentCmWidgetTierListMakerDataSourceType {
  STATIC_DATA = 'STATIC_DATA',
  UG_DOC = 'UG_DOC',
}

export type NgfDocumentCmWidgetTierListMakerV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1';
  data: NgfDocumentCmWidgetTierListMakerV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetTierListMakerV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1Data';
  description?: Maybe<Scalars['Map']>;
  descriptionCharacterLimit: Scalars['Int'];
  descriptionPlaceholder: Scalars['String'];
  filtersEnabled?: Maybe<Scalars['Boolean']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  searchByName?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByName>;
  tagFilters?: Maybe<Array<NgfDocumentCmWidgetTierListMakerV1TagFilter>>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetTierListMakerV1DataSourceTags = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1DataSourceTags';
  groupSlug: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type NgfDocumentCmWidgetTierListMakerV1DocumentItem = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1DocumentItem';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkUrl: Scalars['String'];
  subTitle?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<NgfDocumentCmWidgetTierListMakerV1DataSourceTags>>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetTierListMakerV1DocumentSource = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1DocumentSource';
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  index: Scalars['Int'];
  slug: Scalars['String'];
  tags?: Maybe<Array<NgfDocumentCmWidgetTierListMakerV1DataSourceTags>>;
  uiCapabilities?: Maybe<NgfDocumentCmWidgetTierListMakerV1UICapabilities>;
};

export type NgfDocumentCmWidgetTierListMakerV1StaticDataItem = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1StaticDataItem';
  iconUrl: Scalars['String'];
  linkUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type NgfDocumentCmWidgetTierListMakerV1StaticDataSource = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1StaticDataSource';
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  index: Scalars['Int'];
  showTitles: Scalars['Boolean'];
  slug: Scalars['String'];
  tags?: Maybe<Array<NgfDocumentCmWidgetTierListMakerV1DataSourceTags>>;
  uiCapabilities?: Maybe<NgfDocumentCmWidgetTierListMakerV1UICapabilities>;
};

export type NgfDocumentCmWidgetTierListMakerV1TagFilter = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1TagFilter';
  groupSlug: Scalars['String'];
  ui: NgfDocumentCmWidgetTierListMakerV1TagFilterUi;
};

export type NgfDocumentCmWidgetTierListMakerV1TagFilterUi = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1TagFilterUi';
  enabled: Scalars['Boolean'];
  type: NgfDocumentCmWidgetTierListMakerV1TagFilterUiType;
};

export enum NgfDocumentCmWidgetTierListMakerV1TagFilterUiType {
  SEARCH_BOX = 'SEARCH_BOX',
  SELECT_BAR = 'SELECT_BAR',
  SELECT_BOX = 'SELECT_BOX',
}

export type NgfDocumentCmWidgetTierListMakerV1TierSection = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1TierSection';
  color: Scalars['String'];
  description?: Maybe<Scalars['Map']>;
  name: Scalars['String'];
  staticDataItems: Array<NgfDocumentCmWidgetTierListMakerV1StaticDataItem>;
  ugDataItems: Array<NgfDocumentCmWidgetTierListMakerV1DocumentItem>;
};

export type NgfDocumentCmWidgetTierListMakerV1UICapabilities = {
  __typename?: 'NgfDocumentCmWidgetTierListMakerV1UICapabilities';
  tagFilters?: Maybe<Array<NgfDocumentCmWidgetTierListMakerV1TagFilter>>;
};

export type NgfDocumentCmWidgetUGTierListOverrideV1 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NgfDocumentCmWidgetUGTierListOverrideV2 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NgfDocumentCmWidgetUGTierListV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetUGTierListV1';
  data: NgfDocumentCmWidgetUGTierListV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetUGTierListV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetUGTierListV1Data';
  childrenIds: Array<Scalars['String']>;
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  searchByAuthor?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByAuthor>;
  searchByName?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByName>;
  tagFilters?: Maybe<Array<NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilter>>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetUGTierListV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetUGTierListV2';
  data: NgfDocumentCmWidgetUGTierListV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetUGTierListV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetUGTierListV2Data';
  childrenIds: Array<Scalars['String']>;
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  iconStyle?: Maybe<NgfDocumentCmIconStyle>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  searchByAuthor?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByAuthor>;
  searchByName?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByName>;
  subTitle?: Maybe<Scalars['Map']>;
  tagFilters?: Maybe<Array<NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilter>>;
  title: Scalars['String'];
};

export type NgfDocumentCmWidgetVideoV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetVideoV1';
  data: NgfDocumentCmWidgetVideoV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetVideoV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetVideoV1Data';
  autoplay?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

export type NgfDocumentCmWidgetVideoV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetVideoV2';
  data: NgfDocumentCmWidgetVideoV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetVideoV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetVideoV2Data';
  autoplay?: Maybe<Scalars['Boolean']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  loop?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

export type NgfDocumentCmWidgetWikiDiscoveryDetailedOverrideV1 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NgfDocumentCmWidgetWikiDiscoveryDetailedV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentCmWidgetWikiDiscoveryDetailedV1';
  data: NgfDocumentCmWidgetWikiDiscoveryDetailedV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentCmWidgetWikiDiscoveryDetailedV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentCmWidgetWikiDiscoveryDetailedV1Data';
  discovery: NgfWikiDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  uiCapabilities?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
};

export type NgfDocumentComments = {
  __typename?: 'NgfDocumentComments';
  stats: CommentsResourceStats;
};

export type NgfDocumentContent = {
  data: NgfDocumentContentData;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentContentData = {
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type NgfDocumentContentDataFocusMode = {
  __typename?: 'NgfDocumentContentDataFocusMode';
  enabled: Scalars['Boolean'];
};

export type NgfDocumentContentMeta = {
  __typename?: 'NgfDocumentContentMeta';
  /** @deprecated No longer supported */
  config?: Maybe<NgfDocumentContentMetaConfig>;
};

export type NgfDocumentContentMetaConfig = {
  __typename?: 'NgfDocumentContentMetaConfig';
  editable?: Maybe<Scalars['Boolean']>;
  movable?: Maybe<Scalars['Boolean']>;
  removable?: Maybe<Scalars['Boolean']>;
};

export type NgfDocumentFavorites = {
  __typename?: 'NgfDocumentFavorites';
  favoritesCount: Scalars['Int'];
  isFavorite: Scalars['Boolean'];
};

export type NgfDocumentFeatured = {
  __typename?: 'NgfDocumentFeatured';
  slug: Scalars['String'];
  status: NgfDocumentFeaturedStatus;
};

export enum NgfDocumentFeaturedStatus {
  ARCHIVED = 'ARCHIVED',
  DEFAULT = 'DEFAULT',
  FEATURED = 'FEATURED',
}

export type NgfDocumentLinkedTag = {
  __typename?: 'NgfDocumentLinkedTag';
  groupSlug: Scalars['String'];
  slugs: Array<Scalars['String']>;
};

export enum NgfDocumentLoadingBehaviour {
  SCROLL = 'SCROLL',
  SHOW_MORE = 'SHOW_MORE',
}

export type NgfDocumentMapFeatureEntity = {
  __typename?: 'NgfDocumentMapFeatureEntity';
  featureId: Scalars['ID'];
  gameEntity?: Maybe<NGFEntityObject>;
};

/** Per-document permission flags. */
export enum NgfDocumentPermission {
  /** Defines whenever a user can delete the document. Usually, this is only allowed for document owners and admin users. */
  DELETE = 'DELETE',
  /** Defines whenever a user can feature/unfeature the document. Usually, this is only allowed for admin users. */
  FEATURE = 'FEATURE',
  /** Defines whenever a user can publish/unpublish the document. Usually, this is only allowed for document owners and admin users. */
  PUBLISH = 'PUBLISH',
  /** Defines whenever a user can update document content e.g. widgets. Usually, this is only allowed for document owners. */
  UPDATE_CONTENT = 'UPDATE_CONTENT',
  /** Defines whenever a user can update document SEO e.g. title, description, etc. */
  UPDATE_SEO = 'UPDATE_SEO',
}

/** Permissions container for a document. */
export type NgfDocumentPermissions = {
  __typename?: 'NgfDocumentPermissions';
  data?: Maybe<Array<NgfDocumentPermission>>;
};

export type NgfDocumentRichTextContent = {
  __typename?: 'NgfDocumentRichTextContent';
  charLimit?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Map']>;
};

export type NgfDocumentSeason = {
  slug: Scalars['String'];
};

export enum NgfDocumentSectionLayout {
  /** AUTO - full width section layout (width: 100%). */
  AUTO = 'AUTO',
  /** AUTO_AUTO_AUTO - three columns layout, where each column has equal width. */
  AUTO_AUTO_AUTO = 'AUTO_AUTO_AUTO',
  /** AUTO_PX400 - two columns layout, where left column is stretched to whatever space remains and right column has fixed 400px width. */
  AUTO_PX400 = 'AUTO_PX400',
  /** PX400 - one column layout with fixed 400px width. */
  PX400 = 'PX400',
}

/** SEO metadata exposed for SERP / social previews. */
export type NgfDocumentSeo = {
  __typename?: 'NgfDocumentSeo';
  canonicalUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  noIndex?: Maybe<Scalars['Boolean']>;
  ogImage?: Maybe<Scalars['String']>;
  schemaMarkup?: Maybe<Scalars['NgfDocumentStrJsonLd']>;
  title?: Maybe<Scalars['String']>;
};

export type NgfDocumentSeoDataInput = {
  canonicalUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  ogImage?: InputMaybe<Scalars['String']>;
  schemaMarkup?: InputMaybe<Scalars['NgfDocumentStrJsonLd']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NgfDocumentSetSeoInput = {
  id: Scalars['ID'];
  seo: NgfDocumentSeoDataInput;
};

/** NgfDocumentStWidgetDocumentsDiscoveryV1 widget displays infinity list of documents according to the discovery configuration. */
export type NgfDocumentStWidgetDocumentsDiscoveryV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1';
  data: NgfDocumentStWidgetDocumentsDiscoveryV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1Data';
  discovery: NgfUserGeneratedDocumentsDiscovery;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  uiCapabilities?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1DataPublishedTimeframe = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1DataPublishedTimeframe';
  defaultTimeFrame?: Maybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  enabled: Scalars['Boolean'];
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByAuthor = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByAuthor';
  enabled: Scalars['Boolean'];
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByName = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByName';
  enabled: Scalars['Boolean'];
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1DataSorting = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1DataSorting';
  defaultSortingOption?: Maybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  enabled: Scalars['Boolean'];
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilter = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilter';
  groupSlug: Scalars['String'];
  ui: NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilterUi;
};

export type NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilterUi = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilterUi';
  enabled: Scalars['Boolean'];
  type: NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilterUiType;
};

export enum NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilterUiType {
  SEARCH_BOX = 'SEARCH_BOX',
  SELECT_BAR = 'SELECT_BAR',
  SELECT_BOX = 'SELECT_BOX',
}

export type NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities = {
  __typename?: 'NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities';
  loadingBehaviour?: Maybe<NgfDocumentLoadingBehaviour>;
  publishedTimeframe?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataPublishedTimeframe>;
  searchByAuthor?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByAuthor>;
  searchByName?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSearchByName>;
  sorting?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1DataSorting>;
  tagFilters?: Maybe<Array<NgfDocumentStWidgetDocumentsDiscoveryV1DataTagFilter>>;
};

export type NgfDocumentStWidgetHeaderV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetHeaderV1';
  data: NgfDocumentStWidgetHeaderV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetHeaderV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetHeaderV1Data';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  description: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NgfDocumentStWidgetHeaderV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetHeaderV2';
  data: NgfDocumentStWidgetHeaderV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetHeaderV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetHeaderV2Data';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentStWidgetHomePageHeaderV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetHomePageHeaderV1';
  data: NgfDocumentStWidgetHomePageHeaderV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetHomePageHeaderV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetHomePageHeaderV1Data';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  description: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NgfDocumentStWidgetHomePageHeaderV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetHomePageHeaderV2';
  data: NgfDocumentStWidgetHomePageHeaderV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetHomePageHeaderV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetHomePageHeaderV2Data';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentStWidgetLinksGridManualV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetLinksGridManualV1';
  data: NgfDocumentStWidgetLinksGridManualV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetLinksGridManualV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetLinksGridManualV1Data';
  description?: Maybe<Scalars['NgfDocumentWidgetRichTextContentJson']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentStWidgetLinksGridManualV1DataItem>;
  title: Scalars['String'];
};

export type NgfDocumentStWidgetLinksGridManualV1DataItem = {
  __typename?: 'NgfDocumentStWidgetLinksGridManualV1DataItem';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  linkUrl: Scalars['String'];
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type NgfDocumentStWidgetLinksGridManualV2 = NgfDocumentContent & {
  __typename?: 'NgfDocumentStWidgetLinksGridManualV2';
  data: NgfDocumentStWidgetLinksGridManualV2Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentStWidgetLinksGridManualV2Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentStWidgetLinksGridManualV2Data';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  items: Array<NgfDocumentStWidgetLinksGridManualV2DataItem>;
  subTitle?: Maybe<Scalars['Map']>;
  title: Scalars['String'];
};

export type NgfDocumentStWidgetLinksGridManualV2DataItem = {
  __typename?: 'NgfDocumentStWidgetLinksGridManualV2DataItem';
  backgroundCss?: Maybe<Scalars['String']>;
  backgroundImageMask?: Maybe<Scalars['String']>;
  linkUrl: Scalars['String'];
  openLinkInNewTab?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type NgfDocumentTag = {
  __typename?: 'NgfDocumentTag';
  archived?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  groupSlug: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  /** Tags from other groups linked to this tag, e.g. ascendancies linked to a class. */
  linkedTags?: Maybe<Array<NgfDocumentLinkedTag>>;
  manual?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pluralName?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type NgfDocumentTagGroup = {
  __typename?: 'NgfDocumentTagGroup';
  archived: Scalars['Boolean'];
  defaultSlug?: Maybe<Scalars['String']>;
  inputProhibitedForRegularUser: Scalars['Boolean'];
  isHidden?: Maybe<Scalars['Boolean']>;
  multiselect: Scalars['Boolean'];
  name: Scalars['String'];
  noValue?: Maybe<NgfDocumentTagGroupNoValue>;
  required: Scalars['Boolean'];
  slug: Scalars['String'];
  useGroupName: Scalars['Boolean'];
  values?: Maybe<Array<NgfDocumentTag>>;
};

export type NgfDocumentTagGroupNoValue = {
  __typename?: 'NgfDocumentTagGroupNoValue';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type NgfDocumentTags = {
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type NgfDocumentTier = {
  __typename?: 'NgfDocumentTier';
  color: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NgfDocumentTierListData = {
  __typename?: 'NgfDocumentTierListData';
  values: Array<NgfTierListDocumentTierListDataItem>;
};

export type NgfDocumentType = {
  __typename?: 'NgfDocumentType';
  availableWidgets: Array<AvailableWidget>;
  creationIsAllowed: Scalars['Boolean'];
  description: Scalars['String'];
  displayMetadata: DisplayMetadata;
  documentsCount?: Maybe<Scalars['Int']>;
  index: Scalars['Int'];
  name: Scalars['String'];
  pluralName: Scalars['String'];
  slug: Scalars['String'];
  specificWidgets: SpecificWidgets;
  tagGroups?: Maybe<Array<NgfDocumentTagGroup>>;
};

export type NgfDocumentTypedocumentsCountArgs = {
  input?: InputMaybe<NgfProfileInput>;
};

export type NgfDocumentUgWidgetBuilderV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentUgWidgetBuilderV1';
  data: NgfDocumentUgWidgetBuilderV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentUgWidgetBuilderV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentUgWidgetBuilderV1Data';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  groups?: Maybe<Array<NgfWidgetBuilderV1Group>>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  showEmptyGroups?: Maybe<Scalars['Boolean']>;
  showEmptySlots?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  subTitle?: Maybe<Scalars['Map']>;
  theme?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type NgfDocumentUgWidgetHeaderV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentUgWidgetHeaderV1';
  data: NgfDocumentUgWidgetHeaderV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentUgWidgetHeaderV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentUgWidgetHeaderV1Data';
  backgroundImageMask?: Maybe<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NgfDocumentWidgetDocumentsDiscoveryInputTagV1 = {
  groupSlug: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
};

export type NgfDocumentWidgetDocumentsDiscoveryOverrideV1 = {
  cursor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NgfDocumentWidgetPrioritizable = {
  priorityList?: Maybe<Array<NgfDocumentWidgetPriorityListItem>>;
};

export type NgfDocumentWidgetPriorityListItem = {
  iconURL?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type NgfDocumentWkSectionSlotV1 = NgfDocumentContent & {
  __typename?: 'NgfDocumentWkSectionSlotV1';
  data: NgfDocumentWkSectionSlotV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NgfDocumentWkSectionSlotV1Data = NgfDocumentContentData & {
  __typename?: 'NgfDocumentWkSectionSlotV1Data';
  childrenIds: Array<Scalars['String']>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
};

export type NgfGameSettings = {
  __typename?: 'NgfGameSettings';
  availableColors?: Maybe<Array<NgfGameSettingsColor>>;
  banners?: Maybe<NgfBanners>;
};

export type NgfGameSettingsColor = {
  __typename?: 'NgfGameSettingsColor';
  hex: Scalars['String'];
  slug: Scalars['String'];
};

export type NgfIndexableProfile = {
  __typename?: 'NgfIndexableProfile';
  documentTypes?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** NgfMatchableEntity represents either a single item that can be matched or a group of such items. */
export type NgfMatchableEntity = {
  __typename?: 'NgfMatchableEntity';
  autoTrackingDisabled?: Maybe<Scalars['Boolean']>;
  children?: Maybe<Array<NgfMatchableEntity>>;
  id: Scalars['ID'];
  /**
   *  Next is present when the entity is part of group.
   * isNext means that this item has top priority among other members of the group.
   */
  isNext: Scalars['Boolean'];
  lastMatchedTime?: Maybe<Scalars['String']>;
  /** Match rate is a number between 0 and 1 that indicates how well the entity matches the target. */
  matchRate?: Maybe<Scalars['Float']>;
  matched: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** Target Name is a name of the target entity that this entity is matched against. */
  targetName?: Maybe<Scalars['String']>;
  /** Target Slug is a slug of the target entity that this entity is matched against. */
  targetSlug?: Maybe<Scalars['String']>;
  /** Type identifies the type of the entity (e.g. "equipment", "gem", "group", etc.) */
  type: Scalars['String'];
};

export type NgfMatchingInfo = {
  __typename?: 'NgfMatchingInfo';
  autoSyncInterval?: Maybe<Scalars['Int']>;
  autoTrackingDisabled?: Maybe<Scalars['Boolean']>;
  error?: Maybe<NgfTrackingUntrackError>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  items?: Maybe<Array<NgfMatchableEntity>>;
  matchingTarget?: Maybe<NgfMatchingTarget>;
  nextItems?: Maybe<Array<NgfMatchableEntity>>;
  variantId: Scalars['String'];
};

export type NgfMatchingTarget = {
  /** Key identifies the target for matching. For PoE2 this is character name. */
  key: Scalars['String'];
};

export type NgfMatchingTargetInput = {
  /** Key identifies the target for matching. For PoE2 this is character name. */
  key: Scalars['String'];
};

export enum NgfPlatform {
  DESKTOP_OW = 'DESKTOP_OW',
  WEB = 'WEB',
}

export type NgfProfile = {
  author?: Maybe<NgfDocumentAuthor>;
};

export enum NgfProfileError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type NgfProfileInput = {
  id?: InputMaybe<Scalars['ID']>;
  profileName?: InputMaybe<Scalars['String']>;
};

export enum NgfProfilePageConfigError {
  INTERNAL = 'INTERNAL',
}

export type NgfProfilePageConfigPayload = {
  __typename?: 'NgfProfilePageConfigPayload';
  data?: Maybe<Array<NgfProfilePageDocumentTypeConfig>>;
  error?: Maybe<NgfProfilePageConfigError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NgfProfilePageDocumentTypeConfig = {
  __typename?: 'NgfProfilePageDocumentTypeConfig';
  docTypeSlug: Scalars['String'];
  filters?: Maybe<NgfDocumentStWidgetDocumentsDiscoveryV1UICapabilities>;
};

export type NgfStaticDataType = {
  __typename?: 'NgfStaticDataType';
  name: Scalars['String'];
  pluralName: Scalars['String'];
  slug: Scalars['String'];
  tagGroups?: Maybe<Array<NgfDocumentTagGroup>>;
};

export type NgfStructDocument = {
  category: NgfDocumentCategory;
  contentV2: Array<NgfDocumentContent>;
  createdAt: Scalars['NgfDateTime'];
  data: NgfStructDocumentData;
  documentDescriptor: DocumentDescriptor;
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  seo?: Maybe<NgfDocumentSeo>;
  slug: Scalars['String'];
  status: NgfStructDocumentStatus;
  updatedAt: Scalars['NgfDateTime'];
  version: Scalars['Int'];
};

export type NgfStructDocumentData = {
  childrenIds: Array<Scalars['String']>;
  tierLists: NgfDocumentTierListData;
};

export type NgfStructDocumentMetadata = {
  category: NgfDocumentCategory;
  createdAt: Scalars['NgfDateTime'];
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  seo?: Maybe<NgfDocumentSeo>;
  slug: Scalars['String'];
  status: NgfStructDocumentStatus;
  updatedAt: Scalars['NgfDateTime'];
  version: Scalars['Int'];
};

export enum NgfStructDocumentStatus {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum NgfStructDocumentWidgetsError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NgfStructDocumentWidgetsPayload = {
  __typename?: 'NgfStructDocumentWidgetsPayload';
  data?: Maybe<Array<WidgetMeta>>;
  error?: Maybe<NgfStructDocumentWidgetsError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NgfStructDocumentsListError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NgfStructDocumentsListPayload = {
  __typename?: 'NgfStructDocumentsListPayload';
  documents?: Maybe<Array<NgfStructDocument>>;
  error?: Maybe<NgfStructDocumentsListError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NgfTakeoverBanner = {
  __typename?: 'NgfTakeoverBanner';
  content: NgfTakeoverContent;
  display: NgfBannerDisplay;
  enabled: Scalars['Boolean'];
};

export type NgfTakeoverContent = {
  __typename?: 'NgfTakeoverContent';
  imageAlt?: Maybe<Scalars['String']>;
  images?: Maybe<Array<NgfTakeoverImage>>;
  navigationUrl?: Maybe<Scalars['String']>;
};

export type NgfTakeoverImage = {
  __typename?: 'NgfTakeoverImage';
  fallbackImageUrl?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  screenWidth: Scalars['Int'];
};

export type NgfTemplateDocument = {
  contentV2: Array<NgfDocumentContent>;
  data: NgfTemplateDocumentData;
  type: Scalars['String'];
  typeData: NgfDocumentType;
};

export type NgfTemplateDocumentData = {
  buildVariants?: Maybe<NgfUserGeneratedDocumentDataBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  tierLists: NgfDocumentTierListData;
};

export type NgfTemplateDocumentMetadata = {
  type: Scalars['String'];
  typeData: NgfDocumentType;
};

export type NgfTierListDocumentTierListDataItem = {
  __typename?: 'NgfTierListDocumentTierListDataItem';
  id: Scalars['String'];
  staticDataSources?: Maybe<Array<Maybe<NgfDocumentCmWidgetTierListMakerV1StaticDataSource>>>;
  tierSections?: Maybe<Array<NgfDocumentCmWidgetTierListMakerV1TierSection>>;
  ugDocSources?: Maybe<Array<Maybe<NgfDocumentCmWidgetTierListMakerV1DocumentSource>>>;
};

export type NgfTopBanner = {
  __typename?: 'NgfTopBanner';
  content: NgfBannerContent;
  display: NgfBannerDisplay;
  enabled: Scalars['Boolean'];
};

export type NgfTrackingMutation = {
  __typename?: 'NgfTrackingMutation';
  /** Start tracking a document. */
  track: NgfTrackingTrackPayload;
  /** Stop tracking a document. */
  untrack: NgfTrackingUntrackPayload;
};

export type NgfTrackingMutationtrackArgs = {
  input: NgfTrackingTrackInput;
};

export type NgfTrackingMutationuntrackArgs = {
  input: NgfTrackingUntrackInput;
};

export enum NgfTrackingTrackError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NgfTrackingTrackInput = {
  /** ID of the document to track. */
  documentId: Scalars['ID'];
  /** Matching target identifies an entity that is going to be matched against tracked document. */
  matchingTarget?: InputMaybe<NgfMatchingTargetInput>;
  /** Specify variant ID if you want to track a specific variant of the document. */
  variantId?: InputMaybe<Scalars['String']>;
};

export type NgfTrackingTrackPayload = {
  __typename?: 'NgfTrackingTrackPayload';
  error?: Maybe<NgfTrackingTrackError>;
  errorMessage?: Maybe<Scalars['String']>;
  matchingInfo?: Maybe<NgfMatchingInfo>;
};

export enum NgfTrackingUntrackError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NgfTrackingUntrackInput = {
  documentId: Scalars['ID'];
};

export type NgfTrackingUntrackPayload = {
  __typename?: 'NgfTrackingUntrackPayload';
  error?: Maybe<NgfTrackingUntrackError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NgfUser = {
  __typename?: 'NgfUser';
  id?: Maybe<Scalars['ID']>;
  role: NgfUserRole;
};

export type NgfUserGeneratedDocument = {
  author: NgfDocumentAuthor;
  category: NgfDocumentCategory;
  comments?: Maybe<NgfDocumentComments>;
  contentV2: Array<NgfDocumentContent>;
  createdAt: Scalars['NgfDateTime'];
  data: NgfUserGeneratedDocumentData;
  documentDescriptor: DocumentDescriptor;
  favorites: NgfDocumentFavorites;
  featured?: Maybe<NgfDocumentFeatured>;
  firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  seo?: Maybe<NgfDocumentSeo>;
  slugifiedName?: Maybe<Scalars['String']>;
  status: NgfUserGeneratedDocumentStatus;
  tags?: Maybe<NgfDocumentTags>;
  type: Scalars['String'];
  typeData: NgfDocumentType;
  updatedAt: Scalars['NgfDateTime'];
  version: Scalars['Int'];
};

export type NgfUserGeneratedDocumentData = {
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<NgfUserGeneratedDocumentDataBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  season: NgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export type NgfUserGeneratedDocumentDataBuildVariant = {
  genericBuilder: NgfBuildVariantGenericBuilder;
  id: Scalars['ID'];
};

export type NgfUserGeneratedDocumentDataBuildVariants = {
  values?: Maybe<Array<NgfUserGeneratedDocumentDataBuildVariant>>;
};

export type NgfUserGeneratedDocumentGroup = {
  __typename?: 'NgfUserGeneratedDocumentGroup';
  /**
   * Top N preview, ordered by input.sortBy. The full group is userGeneratedDocuments with the
   * same type / relation / statuses / sortBy.
   */
  documents: Array<NgfUserGeneratedDocument>;
  relation: NgfUserGeneratedDocumentGroupRelation;
  /** Total documents in this group, regardless of preview size. */
  totalCount: Scalars['Int'];
  /** Document type slug, one of userGeneratedDocumentTypes at request time. */
  type: Scalars['String'];
  typeData: NgfDocumentType;
};

/** Which relation between the requesting user and the documents a group represents. */
export enum NgfUserGeneratedDocumentGroupRelation {
  /** Documents authored by the requesting user, drafts included. */
  AUTHORED = 'AUTHORED',
  /** Published documents the requesting user added to favorites. */
  FAVORITED = 'FAVORITED',
}

export enum NgfUserGeneratedDocumentGroupsError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  /** The requesting user is not authorized; groups describe the requesting user's own library. */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

/** Groups the requesting user's own library: authored documents (drafts included) and favorites. */
export type NgfUserGeneratedDocumentGroupsInput = {
  /** Preview size per group. Omitted or 0 means the default of 3; maximum 20 (BAD_REQUEST above). */
  limitPerGroup?: InputMaybe<Scalars['Int']>;
  /** Default: [AUTHORED, FAVORITED]. */
  relations?: InputMaybe<Array<NgfUserGeneratedDocumentGroupRelation>>;
  /** Same enum the list query uses so cursors stay compatible. Default NEW. NAME is rejected. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** Restrict to these type slugs. Default: every type currently configured for the game. */
  types?: InputMaybe<Array<Scalars['String']>>;
};

export type NgfUserGeneratedDocumentGroupsPayload = {
  __typename?: 'NgfUserGeneratedDocumentGroupsPayload';
  error?: Maybe<NgfUserGeneratedDocumentGroupsError>;
  errorMessage?: Maybe<Scalars['String']>;
  /** Ordered by relation, then by NgfDocumentType.index. Empty groups are omitted. */
  groups?: Maybe<Array<NgfUserGeneratedDocumentGroup>>;
};

export type NgfUserGeneratedDocumentInputBySlugifiedName = {
  authorProfileName: Scalars['String'];
  slugifiedName: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NgfUserGeneratedDocumentInputBySlugifiedNameV2 = {
  authorProfileName: Scalars['String'];
  slugifiedName: Scalars['String'];
  /** Document type. Slugified names are unique per (author, type). */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NgfUserGeneratedDocumentMetadata = {
  author: NgfDocumentAuthor;
  category: NgfDocumentCategory;
  comments?: Maybe<NgfDocumentComments>;
  createdAt: Scalars['NgfDateTime'];
  favorites: NgfDocumentFavorites;
  featured?: Maybe<NgfDocumentFeatured>;
  firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  seo?: Maybe<NgfDocumentSeo>;
  slugifiedName?: Maybe<Scalars['String']>;
  status: NgfUserGeneratedDocumentStatus;
  type: Scalars['String'];
  typeData: NgfDocumentType;
  updatedAt: Scalars['NgfDateTime'];
  version: Scalars['Int'];
};

export enum NgfUserGeneratedDocumentStatus {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum NgfUserGeneratedDocumentTagGroupsError {
  INTERNAL = 'INTERNAL',
}

export type NgfUserGeneratedDocumentTagGroupsInput = {
  type: Scalars['String'];
};

export type NgfUserGeneratedDocumentTagGroupsPayload = {
  __typename?: 'NgfUserGeneratedDocumentTagGroupsPayload';
  data?: Maybe<Array<NgfDocumentTagGroup>>;
  error?: Maybe<NgfUserGeneratedDocumentTagGroupsError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NgfUserGeneratedDocumentTypesError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NgfUserGeneratedDocumentTypesPayload = {
  __typename?: 'NgfUserGeneratedDocumentTypesPayload';
  data?: Maybe<Array<NgfDocumentType>>;
  error?: Maybe<NgfUserGeneratedDocumentTypesError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NgfUserGeneratedDocumentsDiscovery = {
  __typename?: 'NgfUserGeneratedDocumentsDiscovery';
  /** If specified, filters by author id. */
  authorId?: Maybe<Scalars['ID']>;
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: Maybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: Maybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: Maybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: Maybe<Array<Scalars['ID']>>;
  /**
   * initialState represents the original state of Discovery.
   * It cannot be overridden.
   * It's used by the frontend to determine what the initial Discovery configuration was, before any overrides like filters or sorting were applied.
   */
  initialState: NgfUserGeneratedDocumentsDiscoveryInitialState;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: Maybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: Maybe<Scalars['Boolean']>;
  items: NgfUserGeneratedDocumentsListPayload;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
  /** If specified, filters by name of the document. */
  name?: Maybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: Maybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: Maybe<Scalars['String']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: Maybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: Maybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: Maybe<Array<NgfUserGeneratedDocumentsDiscoveryTag>>;
  /** If specified, filters by document tier. */
  tierSlug?: Maybe<Scalars['String']>;
  /** If specified, filters by document type. */
  type?: Maybe<Scalars['String']>;
};

export type NgfUserGeneratedDocumentsDiscoveryInitialState = {
  __typename?: 'NgfUserGeneratedDocumentsDiscoveryInitialState';
  publishedTimeframe?: Maybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  sortBy?: Maybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  tags?: Maybe<Array<NgfUserGeneratedDocumentsDiscoveryTag>>;
};

export enum NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe {
  ALL = 'ALL',
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
}

export enum NgfUserGeneratedDocumentsDiscoverySortingOption {
  NAME = 'NAME',
  NEW = 'NEW',
  TOP = 'TOP',
  TRENDING = 'TRENDING',
}

export type NgfUserGeneratedDocumentsDiscoveryTag = {
  __typename?: 'NgfUserGeneratedDocumentsDiscoveryTag';
  groupSlug: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export enum NgfUserGeneratedDocumentsListError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type NgfUserGeneratedDocumentsListPaginationInfo = {
  __typename?: 'NgfUserGeneratedDocumentsListPaginationInfo';
  cursor?: Maybe<Scalars['String']>;
  hasMoreItems?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type NgfUserGeneratedDocumentsListPayload = {
  __typename?: 'NgfUserGeneratedDocumentsListPayload';
  documents?: Maybe<Array<NgfUserGeneratedDocument>>;
  error?: Maybe<NgfUserGeneratedDocumentsListError>;
  errorMessage?: Maybe<Scalars['String']>;
  pageInfo?: Maybe<NgfUserGeneratedDocumentsListPaginationInfo>;
};

export enum NgfUserLevel {
  AD_FREE = 'AD_FREE',
  CARRY = 'CARRY',
  CHURN = 'CHURN',
  COLLECTOR_EDITION = 'COLLECTOR_EDITION',
  GUEST = 'GUEST',
  REGULAR = 'REGULAR',
  SUPPORTER = 'SUPPORTER',
  TRIAL = 'TRIAL',
}

export type NgfUserPermissions = {
  __typename?: 'NgfUserPermissions';
  user: NgfUser;
};

export enum NgfUserProfilesError {
  INTERNAL = 'INTERNAL',
}

export type NgfUserProfilesPayload = {
  __typename?: 'NgfUserProfilesPayload';
  data?: Maybe<Array<NgfIndexableProfile>>;
  error?: Maybe<NgfUserProfilesError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NgfUserRole {
  ADMIN = 'ADMIN',
  GAME_MANAGER = 'GAME_MANAGER',
  INTERNAL_WRITER = 'INTERNAL_WRITER',
  REGULAR_USER = 'REGULAR_USER',
  UNAUTHORIZED_USER = 'UNAUTHORIZED_USER',
}

export type NgfWidgetBuilderV1AllowedGameDataGroup = {
  __typename?: 'NgfWidgetBuilderV1AllowedGameDataGroup';
  groupName: Scalars['String'];
};

export type NgfWidgetBuilderV1DependableTag = {
  __typename?: 'NgfWidgetBuilderV1DependableTag';
  groupSlug: Scalars['String'];
  slug: Scalars['String'];
};

export type NgfWidgetBuilderV1Group = {
  __typename?: 'NgfWidgetBuilderV1Group';
  dependableTags?: Maybe<Array<NgfWidgetBuilderV1DependableTag>>;
  displayTitle?: Maybe<Scalars['Boolean']>;
  slotIconFill?: Maybe<NgfWidgetBuilderV1SlotIconView>;
  slotIconStyle?: Maybe<NgfWidgetBuilderV1GroupSlotIconStyle>;
  slotView?: Maybe<NgfWidgetBuilderV1GroupSlotView>;
  slots?: Maybe<Array<NgfWidgetBuilderV1GroupSlot>>;
  slotsPerRow?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type NgfWidgetBuilderV1GroupSlot = {
  __typename?: 'NgfWidgetBuilderV1GroupSlot';
  allowedGameDataGroups?: Maybe<Array<NgfWidgetBuilderV1AllowedGameDataGroup>>;
  dependableTags?: Maybe<Array<NgfWidgetBuilderV1DependableTag>>;
  gameSlotSlug: Scalars['String'];
  title: Scalars['String'];
};

export enum NgfWidgetBuilderV1GroupSlotIconStyle {
  CIRCLE = 'CIRCLE',
  HEXAGON = 'HEXAGON',
  OCTAGON = 'OCTAGON',
  RHOMBUS = 'RHOMBUS',
  SQUARE = 'SQUARE',
  SQUARE_ROUNDED = 'SQUARE_ROUNDED',
}

export enum NgfWidgetBuilderV1GroupSlotView {
  COLLAPSED = 'COLLAPSED',
  EXPANDED = 'EXPANDED',
}

export enum NgfWidgetBuilderV1SlotIconView {
  CENTERED = 'CENTERED',
  FULL = 'FULL',
}

export enum NgfWidgetMetaType {
  SECTION = 'SECTION',
  UNKNOWN = 'UNKNOWN',
  WIDGET = 'WIDGET',
}

export type NgfWikiDocument = {
  category: NgfDocumentCategory;
  contentV2: Array<NgfDocumentContent>;
  createdAt: Scalars['NgfDateTime'];
  data: NgfWikiDocumentData;
  documentDescriptor: DocumentDescriptor;
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  seo?: Maybe<NgfDocumentSeo>;
  slug: Scalars['String'];
  tags?: Maybe<NgfDocumentTags>;
  type: Scalars['String'];
  updatedAt: Scalars['NgfDateTime'];
  version: Scalars['Int'];
};

export type NgfWikiDocumentCrossLinking = {
  __typename?: 'NgfWikiDocumentCrossLinking';
  discovery: NgfWikiDocumentsDiscovery;
  referenceTag: NgfDocumentTag;
};

export type NgfWikiDocumentData = {
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  tierLists: NgfDocumentTierListData;
};

export type NgfWikiDocumentMetadata = {
  category: NgfDocumentCategory;
  createdAt: Scalars['NgfDateTime'];
  id: Scalars['ID'];
  /** @deprecated Use permissions from the root object */
  permissions?: Maybe<NgfDocumentPermissions>;
  seo?: Maybe<NgfDocumentSeo>;
  slug: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['NgfDateTime'];
  version: Scalars['Int'];
};

export type NgfWikiDocumentSetSeoInput = {
  id: Scalars['String'];
  seo: NgfDocumentSeoDataInput;
};

export type NgfWikiDocumentType = {
  __typename?: 'NgfWikiDocumentType';
  availableWidgets: Array<AvailableWidget>;
  staticDataTypes?: Maybe<Array<NgfStaticDataType>>;
};

export enum NgfWikiDocumentTypeError {
  INTERNAL = 'INTERNAL',
}

export type NgfWikiDocumentTypePayload = {
  __typename?: 'NgfWikiDocumentTypePayload';
  data?: Maybe<NgfWikiDocumentType>;
  error?: Maybe<NgfWikiDocumentTypeError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NgfWikiDocumentsDiscovery = {
  __typename?: 'NgfWikiDocumentsDiscovery';
  /** If specified, returns all items without pagination. */
  all?: Maybe<Scalars['Boolean']>;
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: Maybe<Scalars['String']>;
  /**
   * initialState represents the original state of Discovery.
   * It cannot be overridden.
   * It's used by the frontend to determine what the initial Discovery configuration was, before any overrides like filters or sorting were applied.
   */
  initialState: NgfWikiDocumentsDiscoveryInitialState;
  items: NgfWikiDocumentsListPayload;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
  /** If specified, filters by name of the document. */
  name?: Maybe<Scalars['String']>;
  /** If specified, offset pagination will be used. If not - cursor will be used as default. */
  page?: Maybe<Scalars['Int']>;
  /** Defines the way output list is sorted. */
  sortBy?: Maybe<NgfWikiDocumentsDiscoverySortingOption>;
  /** If specified, filters by static data type. */
  staticDataType?: Maybe<Scalars['String']>;
  /** If specified, filters by document tags. */
  tags?: Maybe<Array<NgfWikiDocumentsDiscoveryTag>>;
};

export type NgfWikiDocumentsDiscoveryInitialState = {
  __typename?: 'NgfWikiDocumentsDiscoveryInitialState';
  sortBy?: Maybe<NgfWikiDocumentsDiscoverySortingOption>;
  tags?: Maybe<Array<NgfWikiDocumentsDiscoveryTag>>;
};

export enum NgfWikiDocumentsDiscoverySortingOption {
  NAME = 'NAME',
}

export type NgfWikiDocumentsDiscoveryTag = {
  __typename?: 'NgfWikiDocumentsDiscoveryTag';
  groupSlug: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type NgfWikiDocumentsListPaginationInfo = {
  __typename?: 'NgfWikiDocumentsListPaginationInfo';
  cursor?: Maybe<Scalars['String']>;
  hasMoreItems?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<NgfWikiDocumentsListPaginationInfoOffset>;
  total?: Maybe<Scalars['Int']>;
};

export type NgfWikiDocumentsListPaginationInfoOffset = {
  __typename?: 'NgfWikiDocumentsListPaginationInfoOffset';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type NgfWikiDocumentsListPayload = {
  __typename?: 'NgfWikiDocumentsListPayload';
  documents?: Maybe<Array<NgfWikiDocument>>;
  error?: Maybe<NgfUserGeneratedDocumentsListError>;
  errorMessage?: Maybe<Scalars['String']>;
  pageInfo?: Maybe<NgfWikiDocumentsListPaginationInfo>;
};

/**
 * A user-visible notification rendered in the bell feed. Persisted in Postgres,
 * seen/unseen state is server-owned via `seenAt`.
 */
export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /**
   * Typed body, resolved to a concrete NotificationPayload via `type`. Null when
   * the event `type` has no registered payload schema yet (see payload/).
   */
  payload?: Maybe<NotificationPayload>;
  seenAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
};

/**
 * NotificationPayload is the typed body of a notification or signal. The
 * notification service selects the concrete type from the top-level `type` field
 * via the payload registry
 * (internal/notifications/ports/graphql/resolvers/payloads.go).
 *
 * How to add a new event type:
 *   1. add a concrete `type X implements NotificationPayload` below
 *   2. add a Go builder in resolvers/payloads.go that decodes the stored JSONB
 *      body into the typed fields (the builder owns the stored-shape -> schema
 *      mapping, so producers stay decoupled from this schema)
 *   3. register `"<type>": buildX` in payloadRegistry
 *   4. `make gen-notifications-gql` and redeploy
 *
 * There is NO generic/JSON payload: every event MUST have a fully typed concrete
 * type. An unregistered `type` resolves to a null payload plus a per-item error, so
 * a new backend event ships with its schema + registry entry before it goes live.
 */
export type NotificationPayload = {
  /** Mirrors the notification's top-level type, e.g. "mission_completed". */
  type: Scalars['String'];
};

export enum NotificationsInitError {
  INTERNAL = 'INTERNAL',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NotificationsInitPayload = {
  __typename?: 'NotificationsInitPayload';
  error?: Maybe<NotificationsInitError>;
  errorMessage?: Maybe<Scalars['String']>;
  /**
   * Base64-encoded JSON envelope for the notifications meta doc — same shape as
   * battlepass refresh: `{ project_id, web_api_key, database_id, collection_id,
   * document_id, auth_token }`. Decode → JSON parse → initialise Firebase with
   * project_id/web_api_key → open onSnapshot on collection_id/document_id with
   * auth_token. Null when `error` is set.
   */
  notificationsDetails?: Maybe<Scalars['String']>;
  /**
   * Same envelope shape as notificationsDetails, pointing at the signals meta
   * doc instead. `auth_token` is **identical** in both envelopes (one Firebase
   * custom token per user covers both paths); only `document_id` differs. The
   * frontend signs in once and opens two onSnapshot listeners.
   */
  signalsDetails?: Maybe<Scalars['String']>;
};

export type NotificationsMutation = {
  __typename?: 'NotificationsMutation';
  /**
   * Acks signals after the frontend has applied them. Backend sets
   * `seenAt = NOW()` and resets `signal_count` on the meta document.
   */
  ackSignals: AckSignalsPayload;
  id: Scalars['ID'];
  /**
   * Session-start handshake: mints a Firebase Auth custom token the frontend
   * uses to subscribe to `users/{uid}/meta/notifications` via onSnapshot.
   * Call once per session. Idempotent — calling twice issues two valid tokens.
   */
  init: NotificationsInitPayload;
  /**
   * Marks the given notifications as seen for the current user. Backend sets
   * `seenAt = NOW()` on those rows, recomputes `unread_count`, and pushes the
   * new value to the Firestore meta document so the badge clears across all of
   * the user's devices via onSnapshot.
   */
  markSeen: MarkNotificationsSeenPayload;
};

export type NotificationsMutationackSignalsArgs = {
  ids: Array<Scalars['ID']>;
};

export type NotificationsMutationmarkSeenArgs = {
  ids: Array<Scalars['ID']>;
};

export type NotificationsPage = {
  __typename?: 'NotificationsPage';
  error?: Maybe<NotificationsPageError>;
  errorMessage?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Notification>>;
  nextCursor?: Maybe<Scalars['String']>;
};

export enum NotificationsPageError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NotificationsQuery = {
  __typename?: 'NotificationsQuery';
  id: Scalars['ID'];
  /**
   * Returns the bell feed: full history (seen + unseen), newest first. Pagination
   * is cursor-based — pass back `nextCursor` from the previous page.
   */
  notifications: NotificationsPage;
  /**
   * Returns signals that have not yet been ack'd by the frontend, oldest first.
   * Pass `since` (session start) on the first call; subsequent calls use the
   * `nextCursor` returned by the previous response.
   */
  signals: SignalsPage;
};

export type NotificationsQuerynotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type NotificationsQuerysignalsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['DateTime']>;
};

export type NteArcTypes = NteGameEntity & {
  __typename?: 'NteArcTypes';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NteArcTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteArcTypesResult = {
  __typename?: 'NteArcTypesResult';
  data?: Maybe<Array<NteArcTypes>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteAwakenings = NteGameEntity & {
  __typename?: 'NteAwakenings';
  character?: Maybe<NteCharacters>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NteAwakeningsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteAwakeningsResult = {
  __typename?: 'NteAwakeningsResult';
  data?: Maybe<Array<NteAwakenings>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteAwakeningsSkillUpgrades = {
  __typename?: 'NteAwakeningsSkillUpgrades';
  skill?: Maybe<Scalars['String']>;
};

export type NteCartridges = NteGameEntity & {
  __typename?: 'NteCartridges';
  category?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  geometry?: Maybe<Array<NteModules>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<NteRarities>;
  setBonus?: Maybe<Array<NteCartridgesSetBonus>>;
  slug: Scalars['String'];
};

export type NteCartridgesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteCartridgesResult = {
  __typename?: 'NteCartridgesResult';
  data?: Maybe<Array<NteCartridges>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteCartridgesSetBonus = {
  __typename?: 'NteCartridgesSetBonus';
  description?: Maybe<Scalars['String']>;
};

export type NteCharacters = NteGameEntity & {
  __typename?: 'NteCharacters';
  arcType?: Maybe<NteArcTypes>;
  deprecated: Scalars['Boolean'];
  element?: Maybe<NteElements>;
  faction?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<NteRarities>;
  slug: Scalars['String'];
  tags?: Maybe<Array<NteCharactersTags>>;
};

export type NteCharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteCharactersResult = {
  __typename?: 'NteCharactersResult';
  data?: Maybe<Array<NteCharacters>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteCharactersTags = {
  __typename?: 'NteCharactersTags';
  role?: Maybe<Scalars['String']>;
};

export type NteDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'NteDocumentCmWidgetV1';
  data: NteDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type NteDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'NteDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type NteDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | NteDocumentCmWidgetV1;

export type NteDocumentSeason = NgfDocumentSeason & {
  __typename?: 'NteDocumentSeason';
  slug: Scalars['String'];
};

export type NteDocumentTags = NgfDocumentTags & {
  __typename?: 'NteDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type NteDocumentsMutation = {
  __typename?: 'NteDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: NteStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: NteStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: NteStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: NteStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: NteUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: NteUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: NteUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: NteUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: NteUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: NteUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: NteWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: NteWikiDocumentUpdatePayload;
};

export type NteDocumentsMutationstructDocumentCreateArgs = {
  input: NteStructDocumentCreateInput;
};

export type NteDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type NteDocumentsMutationstructDocumentSetStatusArgs = {
  input: NteStructDocumentSetStatusInput;
};

export type NteDocumentsMutationstructDocumentUpdateArgs = {
  input: NteStructDocumentUpdateInput;
};

export type NteDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: NteUserGeneratedDocumentCreateInput;
};

export type NteDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: NteUserGeneratedDocumentSetFavoriteInput;
};

export type NteDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: NteUserGeneratedDocumentSetFeaturedInput;
};

export type NteDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type NteDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: NteUserGeneratedDocumentSetStatusInput;
};

export type NteDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: NteUserGeneratedDocumentUpdateInput;
};

export type NteDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type NteDocumentsMutationwikiDocumentUpdateArgs = {
  input: NteWikiDocumentUpdateInput;
};

export type NteDocumentsQuery = {
  __typename?: 'NteDocumentsQuery';
  previewDocumentContent: NtePreviewDocumentContentPayload;
  structDocumentBySlug: NteStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: NteUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: NteUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: NteUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: NteUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: NteTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: NteWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type NteDocumentsQuerypreviewDocumentContentArgs = {
  input: NtePreviewDocumentContentInput;
};

export type NteDocumentsQuerystructDocumentBySlugArgs = {
  input: NteStructDocumentInputBySlug;
};

export type NteDocumentsQuerystructDocumentsArgs = {
  input: NteStructDocumentsInput;
};

export type NteDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: NteUserGeneratedDocumentInputById;
};

export type NteDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: NteUserGeneratedDocumentInputBySlug;
};

export type NteDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type NteDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type NteDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type NteDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type NteDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: NteTemplateDocumentInput;
};

export type NteDocumentsQueryuserGeneratedDocumentsArgs = {
  input: NteUserGeneratedDocumentsListInput;
  page: NteUserGeneratedDocumentsListPage;
};

export type NteDocumentsQuerywikiDocumentArgs = {
  input: NteWikiDocumentInput;
};

export type NteDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<NteWikiDocumentsListInput>;
  page: NteWikiDocumentsListPage;
};

export type NteElements = NteGameEntity & {
  __typename?: 'NteElements';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NteElementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteElementsResult = {
  __typename?: 'NteElementsResult';
  data?: Maybe<Array<NteElements>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum NteEntitiesEnum {
  arcTypes = 'arcTypes',
  awakenings = 'awakenings',
  cartridges = 'cartridges',
  characters = 'characters',
  elements = 'elements',
  modules = 'modules',
  rarities = 'rarities',
  skills = 'skills',
  stats = 'stats',
  weapons = 'weapons',
}

export type NteEntityObject = NGFEntityObject & {
  __typename?: 'NteEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<NteGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type NteGameEntity = {
  slug: Scalars['String'];
};

export type NteModules = NteGameEntity & {
  __typename?: 'NteModules';
  code?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<NteRarities>;
  shape?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type NteModulesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteModulesResult = {
  __typename?: 'NteModulesResult';
  data?: Maybe<Array<NteModules>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteMutation = {
  __typename?: 'NteMutation';
  documents?: Maybe<NteDocumentsMutation>;
  id: Scalars['ID'];
};

export enum NtePreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NtePreviewDocumentContentInput = {
  content: Scalars['NteDocumentContentInputBase64Json'];
};

export type NtePreviewDocumentContentPayload = {
  __typename?: 'NtePreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<NteDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<NtePreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteProfile = NgfProfile & {
  __typename?: 'NteProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type NteProfileuserGeneratedDocumentsArgs = {
  input: NteUserGeneratedDocumentsListInput;
  page: NteUserGeneratedDocumentsListPage;
};

export type NteProfilePayload = {
  __typename?: 'NteProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<NteProfile>;
};

export type NteProfilesQuery = {
  __typename?: 'NteProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: NteProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type NteProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type NteQuery = {
  __typename?: 'NteQuery';
  documents?: Maybe<NteDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<NteProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<NteStaticDataQuery>;
};

export type NteRarities = NteGameEntity & {
  __typename?: 'NteRarities';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NteRaritiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteRaritiesResult = {
  __typename?: 'NteRaritiesResult';
  data?: Maybe<Array<NteRarities>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteSkills = NteGameEntity & {
  __typename?: 'NteSkills';
  character?: Maybe<NteCharacters>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Array<Scalars['String']>>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NteSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteSkillsResult = {
  __typename?: 'NteSkillsResult';
  data?: Maybe<Array<NteSkills>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum NteStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type NteStaticDataGroups = {
  __typename?: 'NteStaticDataGroups';
  arcTypes: NteArcTypesResult;
  awakenings: NteAwakeningsResult;
  cartridges: NteCartridgesResult;
  characters: NteCharactersResult;
  elements: NteElementsResult;
  modules: NteModulesResult;
  rarities: NteRaritiesResult;
  skills: NteSkillsResult;
  stats: NteStatsResult;
  weapons: NteWeaponsResult;
};

export type NteStaticDataGroupsarcTypesArgs = {
  filter?: InputMaybe<NteArcTypesFilter>;
};

export type NteStaticDataGroupsawakeningsArgs = {
  filter?: InputMaybe<NteAwakeningsFilter>;
};

export type NteStaticDataGroupscartridgesArgs = {
  filter?: InputMaybe<NteCartridgesFilter>;
};

export type NteStaticDataGroupscharactersArgs = {
  filter?: InputMaybe<NteCharactersFilter>;
};

export type NteStaticDataGroupselementsArgs = {
  filter?: InputMaybe<NteElementsFilter>;
};

export type NteStaticDataGroupsmodulesArgs = {
  filter?: InputMaybe<NteModulesFilter>;
};

export type NteStaticDataGroupsraritiesArgs = {
  filter?: InputMaybe<NteRaritiesFilter>;
};

export type NteStaticDataGroupsskillsArgs = {
  filter?: InputMaybe<NteSkillsFilter>;
};

export type NteStaticDataGroupsstatsArgs = {
  filter?: InputMaybe<NteStatsFilter>;
};

export type NteStaticDataGroupsweaponsArgs = {
  filter?: InputMaybe<NteWeaponsFilter>;
};

export type NteStaticDataQuery = {
  __typename?: 'NteStaticDataQuery';
  groups: NteStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type NteStats = NteGameEntity & {
  __typename?: 'NteStats';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type NteStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteStatsResult = {
  __typename?: 'NteStatsResult';
  data?: Maybe<Array<NteStats>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'NteStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<NteDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: NteStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum NteStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NteStructDocumentCreateInput = {
  document: Scalars['NteStructDocumentInputBase64Json'];
};

export type NteStructDocumentCreatePayload = {
  __typename?: 'NteStructDocumentCreatePayload';
  data?: Maybe<NteStructDocument>;
  error?: Maybe<NteStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteStructDocumentData = NgfStructDocumentData & {
  __typename?: 'NteStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: NteDocumentSeason;
  tags?: Maybe<NteDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum NteStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NteStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NteStructDocumentPayload = {
  __typename?: 'NteStructDocumentPayload';
  data?: Maybe<NteStructDocument>;
  error?: Maybe<NteStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NteStructDocumentSetSeoPayload = {
  __typename?: 'NteStructDocumentSetSeoPayload';
  data?: Maybe<NteStructDocument>;
  error?: Maybe<NteStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type NteStructDocumentSetStatusPayload = {
  __typename?: 'NteStructDocumentSetStatusPayload';
  data?: Maybe<NteStructDocument>;
  error?: Maybe<NteStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteStructDocumentUpdateInput = {
  document: Scalars['NteStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type NteStructDocumentUpdatePayload = {
  __typename?: 'NteStructDocumentUpdatePayload';
  data?: Maybe<NteStructDocument>;
  error?: Maybe<NteStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type NteTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'NteTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<NteDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: NteTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type NteTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'NteTemplateDocumentData';
  buildVariants?: Maybe<NteUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: NteDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum NteTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteTemplateDocumentInput = {
  type: Scalars['String'];
};

export type NteTemplateDocumentPayload = {
  __typename?: 'NteTemplateDocumentPayload';
  data?: Maybe<NteTemplateDocument>;
  error?: Maybe<NteTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'NteUGDocumentGenericBuilder';
  slots?: Maybe<Array<NteUGDocumentGenericBuilderSlot>>;
};

export type NteUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'NteUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<NteEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type NteUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'NteUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<NteDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: NteUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<NteDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type NteUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'NteUserGeneratedDocumentBuildVariant';
  genericBuilder: NteUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type NteUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'NteUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<NteUserGeneratedDocumentBuildVariant>>;
};

export enum NteUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NteUserGeneratedDocumentCreateInput = {
  document: Scalars['NteUserGeneratedDocumentInputBase64Json'];
};

export type NteUserGeneratedDocumentCreatePayload = {
  __typename?: 'NteUserGeneratedDocumentCreatePayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'NteUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<NteUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: NteDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum NteUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type NteUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NteUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NteUserGeneratedDocumentPayload = {
  __typename?: 'NteUserGeneratedDocumentPayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type NteUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'NteUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NteUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type NteUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'NteUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NteUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'NteUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type NteUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'NteUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type NteUserGeneratedDocumentUpdateInput = {
  document: Scalars['NteUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type NteUserGeneratedDocumentUpdatePayload = {
  __typename?: 'NteUserGeneratedDocumentUpdatePayload';
  data?: Maybe<NteUserGeneratedDocument>;
  error?: Maybe<NteUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type NteUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type NteWeapons = NteGameEntity & {
  __typename?: 'NteWeapons';
  arcType?: Maybe<NteArcTypes>;
  attack?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<NteRarities>;
  slug: Scalars['String'];
  stats?: Maybe<Scalars['String']>;
};

export type NteWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type NteWeaponsResult = {
  __typename?: 'NteWeaponsResult';
  data?: Maybe<Array<NteWeapons>>;
  error?: Maybe<NteStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type NteWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'NteWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<NteDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: NteWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<NteDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type NteWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'NteWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: NteEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum NteWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type NteWikiDocumentPayload = {
  __typename?: 'NteWikiDocumentPayload';
  data?: Maybe<NteWikiDocument>;
  error?: Maybe<NteWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type NteWikiDocumentSetSeoPayload = {
  __typename?: 'NteWikiDocumentSetSeoPayload';
  data?: Maybe<NteWikiDocument>;
  error?: Maybe<NteWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum NteWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type NteWikiDocumentUpdateInput = {
  document: Scalars['NteWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type NteWikiDocumentUpdatePayload = {
  __typename?: 'NteWikiDocumentUpdatePayload';
  data?: Maybe<NteWikiDocument>;
  error?: Maybe<NteWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type NteWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type NteWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type OneOfString = {
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type OriginalTag = {
  __typename?: 'OriginalTag';
  groupSlug: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OverwatchButtons = OverwatchGameEntity & {
  __typename?: 'OverwatchButtons';
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OverwatchButtonsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchButtonsResult = {
  __typename?: 'OverwatchButtonsResult';
  data?: Maybe<Array<OverwatchButtons>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'OverwatchDocumentCmWidgetV1';
  data: OverwatchDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type OverwatchDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'OverwatchDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type OverwatchDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | OverwatchDocumentCmWidgetV1;

export type OverwatchDocumentSeason = NgfDocumentSeason & {
  __typename?: 'OverwatchDocumentSeason';
  slug: Scalars['String'];
};

export type OverwatchDocumentTags = NgfDocumentTags & {
  __typename?: 'OverwatchDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type OverwatchDocumentsMutation = {
  __typename?: 'OverwatchDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: OverwatchStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: OverwatchStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: OverwatchStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: OverwatchStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: OverwatchUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: OverwatchUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: OverwatchUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: OverwatchUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: OverwatchUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: OverwatchUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: OverwatchWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: OverwatchWikiDocumentUpdatePayload;
};

export type OverwatchDocumentsMutationstructDocumentCreateArgs = {
  input: OverwatchStructDocumentCreateInput;
};

export type OverwatchDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type OverwatchDocumentsMutationstructDocumentSetStatusArgs = {
  input: OverwatchStructDocumentSetStatusInput;
};

export type OverwatchDocumentsMutationstructDocumentUpdateArgs = {
  input: OverwatchStructDocumentUpdateInput;
};

export type OverwatchDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: OverwatchUserGeneratedDocumentCreateInput;
};

export type OverwatchDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: OverwatchUserGeneratedDocumentSetFavoriteInput;
};

export type OverwatchDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: OverwatchUserGeneratedDocumentSetFeaturedInput;
};

export type OverwatchDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type OverwatchDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: OverwatchUserGeneratedDocumentSetStatusInput;
};

export type OverwatchDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: OverwatchUserGeneratedDocumentUpdateInput;
};

export type OverwatchDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type OverwatchDocumentsMutationwikiDocumentUpdateArgs = {
  input: OverwatchWikiDocumentUpdateInput;
};

export type OverwatchDocumentsQuery = {
  __typename?: 'OverwatchDocumentsQuery';
  previewDocumentContent: OverwatchPreviewDocumentContentPayload;
  structDocumentBySlug: OverwatchStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: OverwatchUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: OverwatchUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: OverwatchUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: OverwatchUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: OverwatchTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: OverwatchWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type OverwatchDocumentsQuerypreviewDocumentContentArgs = {
  input: OverwatchPreviewDocumentContentInput;
};

export type OverwatchDocumentsQuerystructDocumentBySlugArgs = {
  input: OverwatchStructDocumentInputBySlug;
};

export type OverwatchDocumentsQuerystructDocumentsArgs = {
  input: OverwatchStructDocumentsInput;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: OverwatchUserGeneratedDocumentInputById;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: OverwatchUserGeneratedDocumentInputBySlug;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: OverwatchTemplateDocumentInput;
};

export type OverwatchDocumentsQueryuserGeneratedDocumentsArgs = {
  input: OverwatchUserGeneratedDocumentsListInput;
  page: OverwatchUserGeneratedDocumentsListPage;
};

export type OverwatchDocumentsQuerywikiDocumentArgs = {
  input: OverwatchWikiDocumentInput;
};

export type OverwatchDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<OverwatchWikiDocumentsListInput>;
  page: OverwatchWikiDocumentsListPage;
};

export enum OverwatchEntitiesEnum {
  buttons = 'buttons',
  heroAbilties = 'heroAbilties',
  heroPerks = 'heroPerks',
  heroes = 'heroes',
  itemTypes = 'itemTypes',
  items = 'items',
  roles = 'roles',
  subroles = 'subroles',
}

export type OverwatchEntityObject = NGFEntityObject & {
  __typename?: 'OverwatchEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<OverwatchGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type OverwatchGameEntity = {
  slug: Scalars['String'];
};

export type OverwatchHeroAbilties = OverwatchGameEntity & {
  __typename?: 'OverwatchHeroAbilties';
  buttonPressed?: Maybe<OverwatchButtons>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  hero?: Maybe<Array<OverwatchHeroes>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type OverwatchHeroAbiltiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchHeroAbiltiesResult = {
  __typename?: 'OverwatchHeroAbiltiesResult';
  data?: Maybe<Array<OverwatchHeroAbilties>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchHeroPerks = OverwatchGameEntity & {
  __typename?: 'OverwatchHeroPerks';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  hero?: Maybe<OverwatchHeroes>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type OverwatchHeroPerksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchHeroPerksResult = {
  __typename?: 'OverwatchHeroPerksResult';
  data?: Maybe<Array<OverwatchHeroPerks>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchHeroes = OverwatchGameEntity & {
  __typename?: 'OverwatchHeroes';
  abilities?: Maybe<Array<OverwatchHeroAbilties>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  perks?: Maybe<Array<OverwatchHeroPerks>>;
  role?: Maybe<OverwatchRoles>;
  slug: Scalars['String'];
  subrole?: Maybe<OverwatchSubroles>;
};

export type OverwatchHeroesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchHeroesResult = {
  __typename?: 'OverwatchHeroesResult';
  data?: Maybe<Array<OverwatchHeroes>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchItemTypes = OverwatchGameEntity & {
  __typename?: 'OverwatchItemTypes';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OverwatchItemTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchItemTypesResult = {
  __typename?: 'OverwatchItemTypesResult';
  data?: Maybe<Array<OverwatchItemTypes>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchItems = OverwatchGameEntity & {
  __typename?: 'OverwatchItems';
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  hero?: Maybe<Array<OverwatchHeroes>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type?: Maybe<OverwatchItemTypes>;
};

export type OverwatchItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchItemsResult = {
  __typename?: 'OverwatchItemsResult';
  data?: Maybe<Array<OverwatchItems>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchMutation = {
  __typename?: 'OverwatchMutation';
  documents?: Maybe<OverwatchDocumentsMutation>;
  id: Scalars['ID'];
};

export enum OverwatchPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchPreviewDocumentContentInput = {
  content: Scalars['OverwatchDocumentContentInputBase64Json'];
};

export type OverwatchPreviewDocumentContentPayload = {
  __typename?: 'OverwatchPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<OverwatchDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<OverwatchPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchProfile = NgfProfile & {
  __typename?: 'OverwatchProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type OverwatchProfileuserGeneratedDocumentsArgs = {
  input: OverwatchUserGeneratedDocumentsListInput;
  page: OverwatchUserGeneratedDocumentsListPage;
};

export type OverwatchProfilePayload = {
  __typename?: 'OverwatchProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<OverwatchProfile>;
};

export type OverwatchProfilesQuery = {
  __typename?: 'OverwatchProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: OverwatchProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type OverwatchProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type OverwatchQuery = {
  __typename?: 'OverwatchQuery';
  documents?: Maybe<OverwatchDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<OverwatchProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<OverwatchStaticDataQuery>;
};

export type OverwatchRoles = OverwatchGameEntity & {
  __typename?: 'OverwatchRoles';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OverwatchRolesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchRolesResult = {
  __typename?: 'OverwatchRolesResult';
  data?: Maybe<Array<OverwatchRoles>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum OverwatchStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type OverwatchStaticDataGroups = {
  __typename?: 'OverwatchStaticDataGroups';
  buttons: OverwatchButtonsResult;
  heroAbilties: OverwatchHeroAbiltiesResult;
  heroPerks: OverwatchHeroPerksResult;
  heroes: OverwatchHeroesResult;
  itemTypes: OverwatchItemTypesResult;
  items: OverwatchItemsResult;
  roles: OverwatchRolesResult;
  subroles: OverwatchSubrolesResult;
};

export type OverwatchStaticDataGroupsbuttonsArgs = {
  filter?: InputMaybe<OverwatchButtonsFilter>;
};

export type OverwatchStaticDataGroupsheroAbiltiesArgs = {
  filter?: InputMaybe<OverwatchHeroAbiltiesFilter>;
};

export type OverwatchStaticDataGroupsheroPerksArgs = {
  filter?: InputMaybe<OverwatchHeroPerksFilter>;
};

export type OverwatchStaticDataGroupsheroesArgs = {
  filter?: InputMaybe<OverwatchHeroesFilter>;
};

export type OverwatchStaticDataGroupsitemTypesArgs = {
  filter?: InputMaybe<OverwatchItemTypesFilter>;
};

export type OverwatchStaticDataGroupsitemsArgs = {
  filter?: InputMaybe<OverwatchItemsFilter>;
};

export type OverwatchStaticDataGroupsrolesArgs = {
  filter?: InputMaybe<OverwatchRolesFilter>;
};

export type OverwatchStaticDataGroupssubrolesArgs = {
  filter?: InputMaybe<OverwatchSubrolesFilter>;
};

export type OverwatchStaticDataQuery = {
  __typename?: 'OverwatchStaticDataQuery';
  groups: OverwatchStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type OverwatchStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'OverwatchStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<OverwatchDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: OverwatchStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum OverwatchStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type OverwatchStructDocumentCreateInput = {
  document: Scalars['OverwatchStructDocumentInputBase64Json'];
};

export type OverwatchStructDocumentCreatePayload = {
  __typename?: 'OverwatchStructDocumentCreatePayload';
  data?: Maybe<OverwatchStructDocument>;
  error?: Maybe<OverwatchStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchStructDocumentData = NgfStructDocumentData & {
  __typename?: 'OverwatchStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: OverwatchDocumentSeason;
  tags?: Maybe<OverwatchDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum OverwatchStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type OverwatchStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type OverwatchStructDocumentPayload = {
  __typename?: 'OverwatchStructDocumentPayload';
  data?: Maybe<OverwatchStructDocument>;
  error?: Maybe<OverwatchStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type OverwatchStructDocumentSetSeoPayload = {
  __typename?: 'OverwatchStructDocumentSetSeoPayload';
  data?: Maybe<OverwatchStructDocument>;
  error?: Maybe<OverwatchStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type OverwatchStructDocumentSetStatusPayload = {
  __typename?: 'OverwatchStructDocumentSetStatusPayload';
  data?: Maybe<OverwatchStructDocument>;
  error?: Maybe<OverwatchStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchStructDocumentUpdateInput = {
  document: Scalars['OverwatchStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type OverwatchStructDocumentUpdatePayload = {
  __typename?: 'OverwatchStructDocumentUpdatePayload';
  data?: Maybe<OverwatchStructDocument>;
  error?: Maybe<OverwatchStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type OverwatchSubroles = OverwatchGameEntity & {
  __typename?: 'OverwatchSubroles';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type OverwatchSubrolesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type OverwatchSubrolesResult = {
  __typename?: 'OverwatchSubrolesResult';
  data?: Maybe<Array<OverwatchSubroles>>;
  error?: Maybe<OverwatchStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type OverwatchTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'OverwatchTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<OverwatchDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: OverwatchTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type OverwatchTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'OverwatchTemplateDocumentData';
  buildVariants?: Maybe<OverwatchUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: OverwatchDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum OverwatchTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchTemplateDocumentInput = {
  type: Scalars['String'];
};

export type OverwatchTemplateDocumentPayload = {
  __typename?: 'OverwatchTemplateDocumentPayload';
  data?: Maybe<OverwatchTemplateDocument>;
  error?: Maybe<OverwatchTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'OverwatchUGDocumentGenericBuilder';
  slots?: Maybe<Array<OverwatchUGDocumentGenericBuilderSlot>>;
};

export type OverwatchUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'OverwatchUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<OverwatchEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type OverwatchUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'OverwatchUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<OverwatchDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: OverwatchUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<OverwatchDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type OverwatchUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'OverwatchUserGeneratedDocumentBuildVariant';
  genericBuilder: OverwatchUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type OverwatchUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'OverwatchUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<OverwatchUserGeneratedDocumentBuildVariant>>;
};

export enum OverwatchUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type OverwatchUserGeneratedDocumentCreateInput = {
  document: Scalars['OverwatchUserGeneratedDocumentInputBase64Json'];
};

export type OverwatchUserGeneratedDocumentCreatePayload = {
  __typename?: 'OverwatchUserGeneratedDocumentCreatePayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'OverwatchUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<OverwatchUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: OverwatchDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum OverwatchUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type OverwatchUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type OverwatchUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type OverwatchUserGeneratedDocumentPayload = {
  __typename?: 'OverwatchUserGeneratedDocumentPayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type OverwatchUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'OverwatchUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type OverwatchUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type OverwatchUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'OverwatchUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type OverwatchUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'OverwatchUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type OverwatchUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'OverwatchUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type OverwatchUserGeneratedDocumentUpdateInput = {
  document: Scalars['OverwatchUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type OverwatchUserGeneratedDocumentUpdatePayload = {
  __typename?: 'OverwatchUserGeneratedDocumentUpdatePayload';
  data?: Maybe<OverwatchUserGeneratedDocument>;
  error?: Maybe<OverwatchUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type OverwatchUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type OverwatchWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'OverwatchWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<OverwatchDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: OverwatchWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<OverwatchDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type OverwatchWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'OverwatchWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: OverwatchEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum OverwatchWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type OverwatchWikiDocumentPayload = {
  __typename?: 'OverwatchWikiDocumentPayload';
  data?: Maybe<OverwatchWikiDocument>;
  error?: Maybe<OverwatchWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type OverwatchWikiDocumentSetSeoPayload = {
  __typename?: 'OverwatchWikiDocumentSetSeoPayload';
  data?: Maybe<OverwatchWikiDocument>;
  error?: Maybe<OverwatchWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum OverwatchWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type OverwatchWikiDocumentUpdateInput = {
  document: Scalars['OverwatchWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type OverwatchWikiDocumentUpdatePayload = {
  __typename?: 'OverwatchWikiDocumentUpdatePayload';
  data?: Maybe<OverwatchWikiDocument>;
  error?: Maybe<OverwatchWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OverwatchWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type OverwatchWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Page = {
  all?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type PageInput = {
  all?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export enum PlanExtraFeature {
  EGG_SKIN = 'EGG_SKIN',
  SKIN_CODE = 'SKIN_CODE',
}

export enum PlanFrameOption {
  BEST_CHOICE = 'BEST_CHOICE',
  CURRENT_SEASON = 'CURRENT_SEASON',
}

/** Options for showing plan to the clients */
export type PlanViewOptions = {
  __typename?: 'PlanViewOptions';
  backgroundURL?: Maybe<Scalars['String']>;
  extraFeatures?: Maybe<Array<PlanExtraFeature>>;
  frame?: Maybe<PlanFrameOption>;
  frameText?: Maybe<Scalars['String']>;
};

export type Poe2Amulet = Poe2GameEntity & {
  __typename?: 'Poe2Amulet';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2AmuletsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AmuletsResult = {
  __typename?: 'Poe2AmuletsResult';
  data?: Maybe<Array<Poe2Amulet>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Anointment = Poe2GameEntity & {
  __typename?: 'Poe2Anointment';
  baseItemSlugs?: Maybe<Array<Scalars['String']>>;
  baseItems?: Maybe<Array<Poe2BaseItem>>;
  id: Scalars['String'];
  name: Scalars['String'];
  passiveSkill?: Maybe<Poe2PassiveSkill>;
  passiveSkillSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type Poe2AnointmentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AnointmentsResult = {
  __typename?: 'Poe2AnointmentsResult';
  data?: Maybe<Array<Poe2Anointment>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Armour = Poe2GameEntity & {
  __typename?: 'Poe2Armour';
  armourStats?: Maybe<Array<Poe2ArmourStats>>;
  backedStatDescriptions?: Maybe<Array<Poe2BackedStatDescriptions>>;
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2ArmourStats = {
  __typename?: 'Poe2ArmourStats';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['Float']>;
};

export type Poe2ArmoursFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2ArmoursResult = {
  __typename?: 'Poe2ArmoursResult';
  data?: Maybe<Array<Poe2Armour>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2AscendanciesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AscendanciesResult = {
  __typename?: 'Poe2AscendanciesResult';
  data?: Maybe<Array<Poe2Ascendancy>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Ascendancy = Poe2GameEntity & {
  __typename?: 'Poe2Ascendancy';
  ascendancyId?: Maybe<Scalars['Int']>;
  ascendancySlug?: Maybe<Scalars['String']>;
  classTag?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isReal?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2AscendancyToClass = Poe2GameEntity & {
  __typename?: 'Poe2AscendancyToClass';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2AscendancyToClassFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AscendancyToClassResult = {
  __typename?: 'Poe2AscendancyToClassResult';
  data?: Maybe<Array<Poe2AscendancyToClass>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2AtlasMaster = Poe2GameEntity & {
  __typename?: 'Poe2AtlasMaster';
  description: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  skillSlugs?: Maybe<Array<Scalars['String']>>;
  skills?: Maybe<Array<Poe2AtlasMasterSkill>>;
  slug: Scalars['String'];
};

export type Poe2AtlasMasterSkill = Poe2GameEntity & {
  __typename?: 'Poe2AtlasMasterSkill';
  activeIcon?: Maybe<Scalars['String']>;
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  master?: Maybe<Poe2AtlasMaster>;
  masterSlug?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2AtlasMasterSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AtlasMasterSkillsResult = {
  __typename?: 'Poe2AtlasMasterSkillsResult';
  data?: Maybe<Array<Poe2AtlasMasterSkill>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2AtlasMastersFilter = {
  description?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AtlasMastersResult = {
  __typename?: 'Poe2AtlasMastersResult';
  data?: Maybe<Array<Poe2AtlasMaster>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2AtlasSubtree = Poe2GameEntity & {
  __typename?: 'Poe2AtlasSubtree';
  background?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name: Scalars['String'];
  nodeSlugs?: Maybe<Array<Scalars['String']>>;
  rootNodeSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type Poe2AtlasSubtreesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AtlasSubtreesResult = {
  __typename?: 'Poe2AtlasSubtreesResult';
  data?: Maybe<Array<Poe2AtlasSubtree>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2AtlasTreeRestriction = Poe2GameEntity & {
  __typename?: 'Poe2AtlasTreeRestriction';
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2AtlasTreeRestrictionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2AtlasTreeRestrictionsResult = {
  __typename?: 'Poe2AtlasTreeRestrictionsResult';
  data?: Maybe<Array<Poe2AtlasTreeRestriction>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2BackedMinMaxRequires = {
  __typename?: 'Poe2BackedMinMaxRequires';
  description?: Maybe<Poe2Dictionary>;
  slug: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Poe2BackedStatDescriptions = {
  __typename?: 'Poe2BackedStatDescriptions';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['String']>;
};

export type Poe2BakedMinMaxStatsDescriptions = {
  __typename?: 'Poe2BakedMinMaxStatsDescriptions';
  description?: Maybe<Poe2Dictionary>;
  slug: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Poe2BaseItem = Poe2GameEntity & {
  __typename?: 'Poe2BaseItem';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  domain?: Maybe<Scalars['Int']>;
  dropLevel?: Maybe<Scalars['Int']>;
  gameId?: Maybe<Scalars['String']>;
  grantedSkillSlugs?: Maybe<Array<Scalars['String']>>;
  height?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemClass?: Maybe<Poe2ItemClass>;
  itemClassSlug?: Maybe<Scalars['String']>;
  itemRequiredStats?: Maybe<Array<Poe2ItemRequiredStats>>;
  itemStatSlugs?: Maybe<Array<Scalars['String']>>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixes?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  suffixes?: Maybe<Array<Scalars['String']>>;
  width?: Maybe<Scalars['Int']>;
};

export type Poe2BaseItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2BaseItemsResult = {
  __typename?: 'Poe2BaseItemsResult';
  data?: Maybe<Array<Poe2BaseItem>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2BaseStats = {
  __typename?: 'Poe2BaseStats';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['Int']>;
};

export type Poe2BlankStaticEntity = {
  __typename?: 'Poe2BlankStaticEntity';
  id: Scalars['ID'];
};

export type Poe2BuildsAffix = {
  __typename?: 'Poe2BuildsAffix';
  /** modifiers are the mod types of the item mods this affix covers: crafted/desecrated/fractured/corrupted. */
  modifiers?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2BuildsAnointment = {
  __typename?: 'Poe2BuildsAnointment';
  slug: Scalars['String'];
};

export type Poe2BuildsAttributeOverride = {
  __typename?: 'Poe2BuildsAttributeOverride';
  attribute?: Maybe<Scalars['String']>;
  selectedSlugs?: Maybe<Array<Scalars['String']>>;
};

export type Poe2BuildsBuildVariant = {
  __typename?: 'Poe2BuildsBuildVariant';
  equipment: Poe2BuildsEquipment;
  gems: Poe2BuildsGems;
  name?: Maybe<Scalars['String']>;
  passiveTree: Poe2BuildsPassiveTree;
};

export type Poe2BuildsClass = {
  __typename?: 'Poe2BuildsClass';
  ascendancy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Poe2BuildsEquipment = {
  __typename?: 'Poe2BuildsEquipment';
  items?: Maybe<Array<Poe2BuildsItem>>;
};

export type Poe2BuildsGem = {
  __typename?: 'Poe2BuildsGem';
  activeSkill: Poe2BuildsGemActive;
  subSkills?: Maybe<Array<Poe2BuildsGemSupport>>;
  weaponSet?: Maybe<Scalars['String']>;
};

export type Poe2BuildsGemActive = {
  __typename?: 'Poe2BuildsGemActive';
  gemSlug: Scalars['String'];
  level?: Maybe<Scalars['String']>;
};

export type Poe2BuildsGemSupport = {
  __typename?: 'Poe2BuildsGemSupport';
  gemSlug: Scalars['String'];
  level?: Maybe<Scalars['String']>;
};

export type Poe2BuildsGems = {
  __typename?: 'Poe2BuildsGems';
  gems?: Maybe<Array<Poe2BuildsGem>>;
};

export type Poe2BuildsItem = {
  __typename?: 'Poe2BuildsItem';
  anointment?: Maybe<Poe2BuildsAnointment>;
  baseItemClassSlug: Scalars['String'];
  explicits?: Maybe<Array<Poe2BuildsItemDescription>>;
  implicits?: Maybe<Array<Poe2BuildsItemDescription>>;
  isUnique: Scalars['Boolean'];
  modifiers?: Maybe<Array<Scalars['String']>>;
  prefixes?: Maybe<Array<Poe2BuildsAffix>>;
  /**
   * DEPRECATED
   * processedDescriptions are the descriptions after processing for human readability, e.g. removing characteristics alternatives.
   * @deprecated use explicits instead
   */
  processedDescriptions?: Maybe<Array<Scalars['String']>>;
  /**
   * DEPRECATED
   * rawDescriptions are the descriptions as they appear in game API, including characteristics alternatives like [Resistances|Lightning Resistance]
   * @deprecated use explicits instead
   */
  rawDescriptions?: Maybe<Array<Scalars['String']>>;
  requirements?: Maybe<Array<Poe2BuildsItemStat>>;
  runes?: Maybe<Array<Poe2BuildsRune>>;
  set: Scalars['String'];
  slot: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<Poe2BuildsItemStat>>;
  suffixes?: Maybe<Array<Poe2BuildsAffix>>;
};

export type Poe2BuildsItemDescription = {
  __typename?: 'Poe2BuildsItemDescription';
  /** description is the final form of the description after processing for human readability, e.g. removing characteristics alternatives. */
  description: Scalars['String'];
  modifiers?: Maybe<Array<Scalars['String']>>;
  /** rawDescription is the description as it appears in game API or PoB, including characteristics alternatives like [Resistances|Lightning Resistance]. */
  rawDescription?: Maybe<Scalars['String']>;
};

export type Poe2BuildsItemStat = {
  __typename?: 'Poe2BuildsItemStat';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Poe2BuildsJewel = {
  __typename?: 'Poe2BuildsJewel';
  baseItemClassSlug: Scalars['String'];
  isUnique: Scalars['Boolean'];
  nodeID: Scalars['String'];
  prefixes?: Maybe<Array<Poe2BuildsAffix>>;
  rawDescriptions?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  suffixes?: Maybe<Array<Poe2BuildsAffix>>;
};

export type Poe2BuildsPassiveTree = {
  __typename?: 'Poe2BuildsPassiveTree';
  allNodes?: Maybe<Poe2BuildsPassiveTreeNodes>;
  attributeOverrides?: Maybe<Array<Maybe<Poe2BuildsAttributeOverride>>>;
  jewels?: Maybe<Array<Poe2BuildsJewel>>;
  weaponSet1Nodes?: Maybe<Poe2BuildsPassiveTreeNodes>;
  weaponSet2Nodes?: Maybe<Poe2BuildsPassiveTreeNodes>;
};

export type Poe2BuildsPassiveTreeNodes = {
  __typename?: 'Poe2BuildsPassiveTreeNodes';
  selectedSlugs?: Maybe<Array<Scalars['String']>>;
};

export type Poe2BuildsQuery = {
  __typename?: 'Poe2BuildsQuery';
  variantsByPoB: Poe2BuildsVariantsByPoBPayload;
};

export type Poe2BuildsQueryvariantsByPoBArgs = {
  input: Poe2BuildsVariantsByPoBInput;
};

export type Poe2BuildsQuestReward = {
  __typename?: 'Poe2BuildsQuestReward';
  questSlug: Scalars['String'];
  rewardSlug?: Maybe<Scalars['String']>;
};

export type Poe2BuildsRune = {
  __typename?: 'Poe2BuildsRune';
  slug: Scalars['String'];
};

export enum Poe2BuildsVariantsByPoBError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type Poe2BuildsVariantsByPoBInput = {
  rawPoB: Scalars['String'];
};

export type Poe2BuildsVariantsByPoBPayload = {
  __typename?: 'Poe2BuildsVariantsByPoBPayload';
  buildVariants?: Maybe<Array<Poe2BuildsBuildVariant>>;
  class?: Maybe<Poe2BuildsClass>;
  error?: Maybe<Poe2BuildsVariantsByPoBError>;
  errorMessage?: Maybe<Scalars['String']>;
  questRewards?: Maybe<Array<Poe2BuildsQuestReward>>;
};

export type Poe2Character = Poe2GameEntity & {
  __typename?: 'Poe2Character';
  baseStats?: Maybe<Array<Poe2BaseStats>>;
  desc?: Maybe<Scalars['String']>;
  genderSlug?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  startItemSlugs?: Maybe<Array<Scalars['String']>>;
  startSkillGemSlug?: Maybe<Scalars['String']>;
  startingNodeSlug?: Maybe<Scalars['String']>;
  traitDescription?: Maybe<Scalars['String']>;
};

export type Poe2CharacterStartStatess = Poe2GameEntity & {
  __typename?: 'Poe2CharacterStartStatess';
  character?: Maybe<Poe2Character>;
  characterSlug?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  passiveSkillSlugs?: Maybe<Array<Scalars['String']>>;
  passiveSkills?: Maybe<Array<Poe2PassiveSkill>>;
  slug: Scalars['String'];
};

export type Poe2CharacterStartStatessFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2CharacterStartStatessResult = {
  __typename?: 'Poe2CharacterStartStatessResult';
  data?: Maybe<Array<Poe2CharacterStartStatess>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2CharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2CharactersResult = {
  __typename?: 'Poe2CharactersResult';
  data?: Maybe<Array<Poe2Character>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Description = Poe2GameEntity & {
  __typename?: 'Poe2Description';
  descriptions?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2DescriptionFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2DescriptionResult = {
  __typename?: 'Poe2DescriptionResult';
  data?: Maybe<Array<Poe2Description>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Dictionary = Poe2GameEntity & {
  __typename?: 'Poe2Dictionary';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2DictionaryFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2DictionaryResult = {
  __typename?: 'Poe2DictionaryResult';
  data?: Maybe<Array<Poe2Dictionary>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2DocumentCmWidgetGemsRequirementsV1 = {
  __typename?: 'Poe2DocumentCmWidgetGemsRequirementsV1';
  dex?: Maybe<Scalars['Int']>;
  int?: Maybe<Scalars['Int']>;
  str?: Maybe<Scalars['Int']>;
};

export type Poe2DocumentCmWidgetGemsSlotV1 = {
  __typename?: 'Poe2DocumentCmWidgetGemsSlotV1';
  activeSkill: Poe2DocumentCmWidgetSkillGemsSlotActiveV1;
  grantedByWeaponSet?: Maybe<Scalars['String']>;
  subSkills?: Maybe<Array<Poe2DocumentCmWidgetSkillGemsSlotSubV1>>;
  weaponSet?: Maybe<Scalars['String']>;
};

export type Poe2DocumentCmWidgetSkillGemsSlotActiveV1 = {
  __typename?: 'Poe2DocumentCmWidgetSkillGemsSlotActiveV1';
  gemIconURL: Scalars['String'];
  gemSlug: Scalars['String'];
  iconURL: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export enum Poe2DocumentCmWidgetSkillGemsSlotSubType {
  ACTIVE = 'ACTIVE',
  SUPPORT = 'SUPPORT',
}

export type Poe2DocumentCmWidgetSkillGemsSlotSubV1 = {
  __typename?: 'Poe2DocumentCmWidgetSkillGemsSlotSubV1';
  description?: Maybe<Scalars['String']>;
  gemSlug: Scalars['String'];
  gemType: Poe2DocumentCmWidgetSkillGemsSlotSubType;
  iconURL: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  parentActiveSkillGemSlug?: Maybe<Scalars['String']>;
};

export type Poe2DocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentCmWidgetV1';
  data: Poe2DocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Poe2DocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | Poe2DocumentCmWidgetV1
  | Poe2DocumentStWidgetTopCharactersV1
  | Poe2DocumentUgWidgetAtlasTreeV1
  | Poe2DocumentUgWidgetBuildPlannerExportV1
  | Poe2DocumentUgWidgetEquipmentV1
  | Poe2DocumentUgWidgetImportCharacterV1
  | Poe2DocumentUgWidgetLiveCharactersV1
  | Poe2DocumentUgWidgetLootFilterV1
  | Poe2DocumentUgWidgetPassiveTreeV1
  | Poe2DocumentUgWidgetPoBImportV1
  | Poe2DocumentUgWidgetPoeNinjaLinkV1
  | Poe2DocumentUgWidgetQuestRewardsV1
  | Poe2DocumentUgWidgetSkillGemsV1
  | Poe2DocumentUgWidgetTrackingV1;

export type Poe2DocumentSeason = NgfDocumentSeason & {
  __typename?: 'Poe2DocumentSeason';
  slug: Scalars['String'];
};

export type Poe2DocumentStWidgetTopCharactersDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentStWidgetTopCharactersDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Poe2DocumentStWidgetTopCharactersV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentStWidgetTopCharactersV1';
  data: Poe2DocumentStWidgetTopCharactersDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentTags = NgfDocumentTags & {
  __typename?: 'Poe2DocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type Poe2DocumentUgWidgetAtlasTreeDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetAtlasTreeDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetAtlasTreeV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetAtlasTreeV1';
  data: Poe2DocumentUgWidgetAtlasTreeDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetBuildPlannerExportDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetBuildPlannerExportDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetBuildPlannerExportV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetBuildPlannerExportV1';
  data: Poe2DocumentUgWidgetBuildPlannerExportDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetEquipmentAmuletAnointmentV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentAmuletAnointmentV1';
  slug: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentAmuletV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentAmuletV1';
  anointment?: Maybe<Poe2DocumentUgWidgetEquipmentAmuletAnointmentV1>;
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
};

export type Poe2DocumentUgWidgetEquipmentArmourV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentArmourV1';
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
  runes?: Maybe<Array<Poe2DocumentUgWidgetEquipmentRuneV1>>;
};

export type Poe2DocumentUgWidgetEquipmentCharmV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentCharmV1';
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
};

export type Poe2DocumentUgWidgetEquipmentCommonPrefix = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentCommonPrefix';
  modifiers?: Maybe<Array<Scalars['String']>>;
  mustHave?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentCommonSuffix = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentCommonSuffix';
  modifiers?: Maybe<Array<Scalars['String']>>;
  mustHave?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentCommonV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentCommonV1';
  explicitDescriptions?: Maybe<Array<Poe2DocumentUgWidgetEquipmentDescription>>;
  iconURL?: Maybe<Scalars['String']>;
  /** DEPRECATED: always fetch from static data */
  implicitDescriptions?: Maybe<Array<Poe2DocumentUgWidgetEquipmentDescription>>;
  /** isImported is used to determine whether to display descriptions as is or take them from affixes */
  isImported?: Maybe<Scalars['Boolean']>;
  isUnique?: Maybe<Scalars['Boolean']>;
  itemClassSlug?: Maybe<Scalars['String']>;
  modifiers?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  poe2TradeRequest?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1TradeRequest>;
  /**
   * DEPRECATED: use prefixes instead
   * @deprecated use prefixes instead
   */
  prefixSlugs?: Maybe<Array<Scalars['String']>>;
  prefixes?: Maybe<Array<Poe2DocumentUgWidgetEquipmentCommonPrefix>>;
  /** Level, str, dex, int, etc */
  requirements?: Maybe<Array<Poe2DocumentUgWidgetEquipmentStat>>;
  slug: Scalars['String'];
  /** Item level, quality, physical damage, armor, etc */
  stats?: Maybe<Array<Poe2DocumentUgWidgetEquipmentStat>>;
  /**
   * DEPRECATED: use suffixes instead
   * @deprecated use suffixes instead
   */
  suffixSlugs?: Maybe<Array<Scalars['String']>>;
  suffixes?: Maybe<Array<Poe2DocumentUgWidgetEquipmentCommonSuffix>>;
};

export type Poe2DocumentUgWidgetEquipmentCommonV1TradeRequest = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentCommonV1TradeRequest';
  currentLeague: Scalars['String'];
  query: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetEquipmentDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isPriorityEnabled?: Maybe<Scalars['Boolean']>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentDescription = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentDescription';
  description: Scalars['String'];
  modifiers?: Maybe<Array<Scalars['String']>>;
  mustHave?: Maybe<Scalars['Boolean']>;
  /**
   * rawDescription is the description as it appears in game API or PoB, including characteristics alternatives like [Resistances|Lightning Resistance].
   * Optional.
   */
  rawDescription?: Maybe<Scalars['String']>;
};

export type Poe2DocumentUgWidgetEquipmentFlaskV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentFlaskV1';
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
};

export type Poe2DocumentUgWidgetEquipmentPriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Poe2DocumentUgWidgetEquipmentPriorityListItem';
  description?: Maybe<Scalars['String']>;
  iconURL: Scalars['String'];
  isExcluded?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<NgfDocumentRichTextContent>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentRingV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentRingV1';
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
};

export type Poe2DocumentUgWidgetEquipmentRuneV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentRuneV1';
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** Key-value pair for any item characteristic */
export type Poe2DocumentUgWidgetEquipmentStat = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentStat';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetEquipmentV1';
  data: Poe2DocumentUgWidgetEquipmentDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetEquipmentWeaponMainV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentWeaponMainV1';
  set1?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponSetMainV1>;
  set2?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponSetMainV1>;
};

export type Poe2DocumentUgWidgetEquipmentWeaponOffV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentWeaponOffV1';
  set1?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponSetOffV1>;
  set2?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponSetOffV1>;
};

export type Poe2DocumentUgWidgetEquipmentWeaponProvidedSkill = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentWeaponProvidedSkill';
  gemIconURL: Scalars['String'];
  gemSlug: Scalars['String'];
  iconURL: Scalars['String'];
  name: Scalars['String'];
};

export type Poe2DocumentUgWidgetEquipmentWeaponSetMainV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentWeaponSetMainV1';
  blocksOffHand?: Maybe<Scalars['Boolean']>;
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
  providedSkill?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponProvidedSkill>;
  runes?: Maybe<Array<Poe2DocumentUgWidgetEquipmentRuneV1>>;
};

export type Poe2DocumentUgWidgetEquipmentWeaponSetOffV1 = {
  __typename?: 'Poe2DocumentUgWidgetEquipmentWeaponSetOffV1';
  commonItem?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1>;
  providedSkill?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponProvidedSkill>;
  runes?: Maybe<Array<Poe2DocumentUgWidgetEquipmentRuneV1>>;
};

export type Poe2DocumentUgWidgetImportCharacterDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetImportCharacterDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetImportCharacterV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetImportCharacterV1';
  data: Poe2DocumentUgWidgetImportCharacterDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetLiveCharactersDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetLiveCharactersDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetLiveCharactersV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetLiveCharactersV1';
  data: Poe2DocumentUgWidgetLiveCharactersDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetLootFilterDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetLootFilterDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetLootFilterV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetLootFilterV1';
  data: Poe2DocumentUgWidgetLootFilterDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetPassiveTreeDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetPassiveTreeDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isPriorityEnabled?: Maybe<Scalars['Boolean']>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetPassiveTreeV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetPassiveTreeV1';
  data: Poe2DocumentUgWidgetPassiveTreeDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetPoBImportDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetPoBImportDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetPoBImportV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetPoBImportV1';
  data: Poe2DocumentUgWidgetPoBImportDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetPoeNinjaLinkDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetPoeNinjaLinkDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  link?: Maybe<Scalars['String']>;
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetPoeNinjaLinkV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetPoeNinjaLinkV1';
  data: Poe2DocumentUgWidgetPoeNinjaLinkDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetQuestRewardsV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetQuestRewardsV1';
  data: Poe2DocumentUgWidgetQuestRewardsV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetQuestRewardsV1Data = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetQuestRewardsV1Data';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetSkillGemsDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetSkillGemsDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isPriorityEnabled?: Maybe<Scalars['Boolean']>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetSkillGemsV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetSkillGemsV1';
  data: Poe2DocumentUgWidgetSkillGemsDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentUgWidgetTrackingDataV1 = NgfDocumentContentData & {
  __typename?: 'Poe2DocumentUgWidgetTrackingDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type Poe2DocumentUgWidgetTrackingV1 = NgfDocumentContent & {
  __typename?: 'Poe2DocumentUgWidgetTrackingV1';
  data: Poe2DocumentUgWidgetTrackingDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Poe2DocumentsMutation = {
  __typename?: 'Poe2DocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: Poe2StructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: Poe2StructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: Poe2StructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: Poe2StructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: Poe2UserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: Poe2UserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: Poe2UserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: Poe2UserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: Poe2UserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: Poe2UserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: Poe2WikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: Poe2WikiDocumentUpdatePayload;
};

export type Poe2DocumentsMutationstructDocumentCreateArgs = {
  input: Poe2StructDocumentCreateInput;
};

export type Poe2DocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Poe2DocumentsMutationstructDocumentSetStatusArgs = {
  input: Poe2StructDocumentSetStatusInput;
};

export type Poe2DocumentsMutationstructDocumentUpdateArgs = {
  input: Poe2StructDocumentUpdateInput;
};

export type Poe2DocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: Poe2UserGeneratedDocumentCreateInput;
};

export type Poe2DocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: Poe2UserGeneratedDocumentSetFavoriteInput;
};

export type Poe2DocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: Poe2UserGeneratedDocumentSetFeaturedInput;
};

export type Poe2DocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Poe2DocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: Poe2UserGeneratedDocumentSetStatusInput;
};

export type Poe2DocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: Poe2UserGeneratedDocumentUpdateInput;
};

export type Poe2DocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type Poe2DocumentsMutationwikiDocumentUpdateArgs = {
  input: Poe2WikiDocumentUpdateInput;
};

export type Poe2DocumentsQuery = {
  __typename?: 'Poe2DocumentsQuery';
  previewDocumentContent: Poe2PreviewDocumentContentPayload;
  structDocumentBySlug: Poe2StructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: Poe2UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: Poe2UserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: Poe2UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: Poe2UserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: Poe2TemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: Poe2WikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type Poe2DocumentsQuerypreviewDocumentContentArgs = {
  input: Poe2PreviewDocumentContentInput;
};

export type Poe2DocumentsQuerystructDocumentBySlugArgs = {
  input: Poe2StructDocumentInputBySlug;
};

export type Poe2DocumentsQuerystructDocumentsArgs = {
  input: Poe2StructDocumentsInput;
};

export type Poe2DocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: Poe2UserGeneratedDocumentInputById;
};

export type Poe2DocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: Poe2UserGeneratedDocumentInputBySlug;
};

export type Poe2DocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type Poe2DocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type Poe2DocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type Poe2DocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type Poe2DocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: Poe2TemplateDocumentInput;
};

export type Poe2DocumentsQueryuserGeneratedDocumentsArgs = {
  input: Poe2UserGeneratedDocumentsListInput;
  page: Poe2UserGeneratedDocumentsListPage;
};

export type Poe2DocumentsQuerywikiDocumentArgs = {
  input: Poe2WikiDocumentInput;
};

export type Poe2DocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<Poe2WikiDocumentsListInput>;
  page: Poe2WikiDocumentsListPage;
};

export enum Poe2EntitiesEnum {
  amulets = 'amulets',
  anointments = 'anointments',
  armours = 'armours',
  ascendancies = 'ascendancies',
  ascendancyToClass = 'ascendancyToClass',
  atlasMasterSkills = 'atlasMasterSkills',
  atlasMasters = 'atlasMasters',
  atlasSubtrees = 'atlasSubtrees',
  atlasTreeRestrictions = 'atlasTreeRestrictions',
  baseItems = 'baseItems',
  characterStartStatess = 'characterStartStatess',
  characters = 'characters',
  description = 'description',
  dictionary = 'dictionary',
  equipmentGems = 'equipmentGems',
  equipmentRestrictions = 'equipmentRestrictions',
  flasks = 'flasks',
  focuses = 'focuses',
  gemTags = 'gemTags',
  gems = 'gems',
  itemClasses = 'itemClasses',
  jewelRadii = 'jewelRadii',
  jewels = 'jewels',
  passiveSkillOverrides = 'passiveSkillOverrides',
  passiveSkillTreeRestrictions = 'passiveSkillTreeRestrictions',
  passiveSkills = 'passiveSkills',
  passiveSkillsGraph = 'passiveSkillsGraph',
  prefixes = 'prefixes',
  questRewards = 'questRewards',
  questTypeFilter = 'questTypeFilter',
  quests = 'quests',
  quivers = 'quivers',
  rings = 'rings',
  runeRestrictions = 'runeRestrictions',
  shields = 'shields',
  skillTypes = 'skillTypes',
  soulCores = 'soulCores',
  spriteSheets = 'spriteSheets',
  spriteSheetsData = 'spriteSheetsData',
  suffixes = 'suffixes',
  talismans = 'talismans',
  weapons = 'weapons',
}

export type Poe2Entity = Poe2BlankStaticEntity;

export type Poe2EntityObject = NGFEntityObject & {
  __typename?: 'Poe2EntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<Poe2GameEntity>;
  enumType?: Maybe<Poe2EntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Poe2EquipmentGem = Poe2GameEntity & {
  __typename?: 'Poe2EquipmentGem';
  baseItemClass1Slug?: Maybe<Scalars['String']>;
  baseItemClass2Slug?: Maybe<Scalars['String']>;
  gem?: Maybe<Poe2Gem>;
  gemSlug?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2EquipmentGemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2EquipmentGemsResult = {
  __typename?: 'Poe2EquipmentGemsResult';
  data?: Maybe<Array<Poe2EquipmentGem>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2EquipmentRestriction = Poe2GameEntity & {
  __typename?: 'Poe2EquipmentRestriction';
  baseItemClass?: Maybe<Scalars['String']>;
  extraOccupancies?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
  properSlots?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2EquipmentRestrictionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2EquipmentRestrictionsResult = {
  __typename?: 'Poe2EquipmentRestrictionsResult';
  data?: Maybe<Array<Poe2EquipmentRestriction>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Flask = Poe2GameEntity & {
  __typename?: 'Poe2Flask';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flaskStats?: Maybe<Array<Poe2FlaskStats>>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2FlaskStats = {
  __typename?: 'Poe2FlaskStats';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['Float']>;
};

export type Poe2FlasksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2FlasksResult = {
  __typename?: 'Poe2FlasksResult';
  data?: Maybe<Array<Poe2Flask>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Focus = Poe2GameEntity & {
  __typename?: 'Poe2Focus';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2FocusesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2FocusesResult = {
  __typename?: 'Poe2FocusesResult';
  data?: Maybe<Array<Poe2Focus>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Poe2GameApiCharacterError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  MISSING_GAME_API_AUTH = 'MISSING_GAME_API_AUTH',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Poe2GameApiCharacterInfo = {
  __typename?: 'Poe2GameApiCharacterInfo';
  class?: Maybe<Poe2BuildsClass>;
  league: Scalars['String'];
  level: Scalars['Int'];
  name: Scalars['String'];
};

export type Poe2GameApiCharacterInput = {
  characterName: Scalars['String'];
  /**
   * Optional RFC3339 timestamp identifying a historical snapshot (must be a
   * `timestamp` value returned by `Poe2GameProfileData.history`). When omitted
   * the latest snapshot is used. Ignored by `Poe2GameBuildsQuery.character`,
   * which always queries the live game API.
   */
  date?: InputMaybe<Scalars['String']>;
};

export type Poe2GameApiCharacterPayload = {
  __typename?: 'Poe2GameApiCharacterPayload';
  build?: Maybe<Poe2BuildsBuildVariant>;
  class?: Maybe<Poe2BuildsClass>;
  error?: Maybe<Poe2GameApiCharacterError>;
  errorMessage?: Maybe<Scalars['String']>;
  league?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
  questRewards?: Maybe<Array<Poe2BuildsQuestReward>>;
};

export enum Poe2GameApiCharactersListError {
  INTERNAL = 'INTERNAL',
  MISSING_GAME_API_AUTH = 'MISSING_GAME_API_AUTH',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Poe2GameApiCharactersListPayload = {
  __typename?: 'Poe2GameApiCharactersListPayload';
  characters?: Maybe<Array<Poe2GameApiCharacterInfo>>;
  error?: Maybe<Poe2GameApiCharactersListError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2GameBuildsQuery = {
  __typename?: 'Poe2GameBuildsQuery';
  character: Poe2GameApiCharacterPayload;
  characters: Poe2GameApiCharactersListPayload;
  topAscendancies: Poe2TopAscendanciesPayload;
  topCharacters: Poe2TopCharactersPayload;
};

export type Poe2GameBuildsQuerycharacterArgs = {
  input: Poe2GameApiCharacterInput;
};

export type Poe2GameBuildsQuerytopAscendanciesArgs = {
  input?: InputMaybe<Poe2TopAscendanciesInput>;
};

export type Poe2GameBuildsQuerytopCharactersArgs = {
  input: Poe2TopCharactersInput;
};

export type Poe2GameEntity = {
  slug: Scalars['String'];
};

export type Poe2GameProfileCharacterBuild = {
  __typename?: 'Poe2GameProfileCharacterBuild';
  equipment?: Maybe<Poe2UserGeneratedDocumentBuildVariantEquipment>;
  passiveTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTree>;
  skillGems?: Maybe<Poe2UserGeneratedDocumentBuildVariantSkillGems>;
};

export type Poe2GameProfileCharacterPayload = {
  __typename?: 'Poe2GameProfileCharacterPayload';
  build?: Maybe<Poe2GameProfileCharacterBuild>;
  class?: Maybe<Poe2BuildsClass>;
  error?: Maybe<Poe2GameApiCharacterError>;
  errorMessage?: Maybe<Scalars['String']>;
  league?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Int']>;
};

export type Poe2GameProfileData = {
  __typename?: 'Poe2GameProfileData';
  character?: Maybe<Poe2GameProfileCharacterPayload>;
  characters?: Maybe<Poe2GameApiCharactersListPayload>;
  history?: Maybe<Array<Poe2GameProfileHistoryEntry>>;
};

export type Poe2GameProfileDatacharacterArgs = {
  input: Poe2GameApiCharacterInput;
};

export type Poe2GameProfileDatahistoryArgs = {
  input: Poe2GameProfileHistoryInput;
};

export type Poe2GameProfileHistoryEntry = {
  __typename?: 'Poe2GameProfileHistoryEntry';
  characterLevel: Scalars['Int'];
  /**
   * RFC3339 timestamp of the snapshot, including nanoseconds when present.
   * Pass this verbatim as `Poe2GameApiCharacterInput.date` to fetch the full
   * snapshot via `Poe2GameProfileData.character`.
   */
  date: Scalars['String'];
  hash: Scalars['String'];
  relativeTime: Scalars['String'];
};

export type Poe2GameProfileHistoryInput = {
  characterName: Scalars['String'];
};

export type Poe2Gem = Poe2GameEntity & {
  __typename?: 'Poe2Gem';
  backedMinMaxRequires?: Maybe<Array<Poe2BackedMinMaxRequires>>;
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  bakedMinMaxStatsDescriptions?: Maybe<Array<Poe2BakedMinMaxStatsDescriptions>>;
  baseItem?: Maybe<Poe2BaseItem>;
  baseItemSlug?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Scalars['Int']>>;
  gemStats?: Maybe<Array<Poe2GemStats>>;
  gemsTagSlugs?: Maybe<Array<Scalars['String']>>;
  gemsTags?: Maybe<Array<Poe2GemTag>>;
  hoverImage?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSupport?: Maybe<Scalars['Boolean']>;
  isWeaponGranted?: Maybe<Scalars['Boolean']>;
  mainDescription?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  qualityBakedDescriptions?: Maybe<Array<Scalars['String']>>;
  qualityDescriptions?: Maybe<Array<Scalars['Int']>>;
  qualityStatSlugs?: Maybe<Array<Scalars['String']>>;
  qualitySubstitutions?: Maybe<Array<Scalars['Float']>>;
  skillTypeSlugs?: Maybe<Array<Scalars['String']>>;
  skillTypes?: Maybe<Array<Poe2SkillType>>;
  slug: Scalars['String'];
  statsPerLevel?: Maybe<Array<Poe2StatsPerLevel>>;
  weaponRestrictionSlugs?: Maybe<Array<Scalars['String']>>;
  weaponRestrictions?: Maybe<Array<Poe2ItemClass>>;
};

export type Poe2GemStats = {
  __typename?: 'Poe2GemStats';
  slug: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

export type Poe2GemTag = Poe2GameEntity & {
  __typename?: 'Poe2GemTag';
  backedName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2GemTagsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2GemTagsResult = {
  __typename?: 'Poe2GemTagsResult';
  data?: Maybe<Array<Poe2GemTag>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2GemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2GemsResult = {
  __typename?: 'Poe2GemsResult';
  data?: Maybe<Array<Poe2Gem>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Groups = {
  __typename?: 'Poe2Groups';
  centerX?: Maybe<Scalars['Float']>;
  centerY?: Maybe<Scalars['Float']>;
  groupAssociationKey?: Maybe<Scalars['Int']>;
  groupBackgroundOverride?: Maybe<Scalars['Int']>;
  isJewelPositionReference?: Maybe<Scalars['Boolean']>;
  nodes?: Maybe<Array<Poe2GroupsNodes>>;
  slug: Scalars['String'];
};

export type Poe2GroupsNodes = {
  __typename?: 'Poe2GroupsNodes';
  edgeSlugs?: Maybe<Array<Scalars['String']>>;
  edges2?: Maybe<Array<Scalars['Int']>>;
  orbit?: Maybe<Scalars['Int']>;
  orbitIndex?: Maybe<Scalars['Int']>;
  passiveSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type Poe2ItemClass = Poe2GameEntity & {
  __typename?: 'Poe2ItemClass';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2ItemClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2ItemClassesResult = {
  __typename?: 'Poe2ItemClassesResult';
  data?: Maybe<Array<Poe2ItemClass>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2ItemRequiredStats = {
  __typename?: 'Poe2ItemRequiredStats';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['Int']>;
};

export type Poe2Jewel = Poe2GameEntity & {
  __typename?: 'Poe2Jewel';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  equippedIcon?: Maybe<Scalars['String']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  itemRequiredStats?: Maybe<Array<Poe2ItemRequiredStats>>;
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  prefixes?: Maybe<Array<Scalars['String']>>;
  radiusSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  suffixes?: Maybe<Array<Scalars['String']>>;
};

export type Poe2JewelRadiiFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2JewelRadiiResult = {
  __typename?: 'Poe2JewelRadiiResult';
  data?: Maybe<Array<Poe2JewelRadius>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2JewelRadius = Poe2GameEntity & {
  __typename?: 'Poe2JewelRadius';
  id: Scalars['String'];
  name: Scalars['String'];
  radius?: Maybe<Scalars['Int']>;
  ringInner?: Maybe<Scalars['Int']>;
  ringOuter?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
};

export type Poe2JewelsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2JewelsResult = {
  __typename?: 'Poe2JewelsResult';
  data?: Maybe<Array<Poe2Jewel>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2MatchingTarget = NgfMatchingTarget & {
  __typename?: 'Poe2MatchingTarget';
  build?: Maybe<Poe2BuildsBuildVariant>;
  character?: Maybe<Poe2GameApiCharacterInfo>;
  /** Key identifies the target for matching. For PoE2 this is character name. */
  key: Scalars['String'];
};

export type Poe2Mutation = {
  __typename?: 'Poe2Mutation';
  documents?: Maybe<Poe2DocumentsMutation>;
  id: Scalars['ID'];
  tracking?: Maybe<NgfTrackingMutation>;
};

export type Poe2PassiveSkill = Poe2GameEntity & {
  __typename?: 'Poe2PassiveSkill';
  ascendancy?: Maybe<Scalars['Int']>;
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  character?: Maybe<Array<Scalars['Int']>>;
  descriptions?: Maybe<Array<Scalars['Int']>>;
  flavourText?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  grantedSkillSlug?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jewelSocket?: Maybe<Scalars['Boolean']>;
  justIcon?: Maybe<Scalars['Boolean']>;
  keystone?: Maybe<Scalars['Boolean']>;
  masteryBackgroundImage?: Maybe<Scalars['String']>;
  multipleChoice?: Maybe<Scalars['Boolean']>;
  multipleChoiceOption?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notable?: Maybe<Scalars['Boolean']>;
  optionSlugs?: Maybe<Array<Scalars['String']>>;
  options?: Maybe<Array<Poe2PassiveSkill>>;
  skillPointsGranted?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  statSlugs?: Maybe<Array<Scalars['String']>>;
  substitutions?: Maybe<Array<Scalars['Float']>>;
  tiledIconRect?: Maybe<Poe2TiledIconRect>;
};

export type Poe2PassiveSkillOverride = Poe2GameEntity & {
  __typename?: 'Poe2PassiveSkillOverride';
  ascendancySlug?: Maybe<Scalars['String']>;
  classSlug?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  originalSlug?: Maybe<Scalars['String']>;
  overrideSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type Poe2PassiveSkillOverridesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2PassiveSkillOverridesResult = {
  __typename?: 'Poe2PassiveSkillOverridesResult';
  data?: Maybe<Array<Poe2PassiveSkillOverride>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2PassiveSkillTreeRestriction = Poe2GameEntity & {
  __typename?: 'Poe2PassiveSkillTreeRestriction';
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2PassiveSkillTreeRestrictionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2PassiveSkillTreeRestrictionsResult = {
  __typename?: 'Poe2PassiveSkillTreeRestrictionsResult';
  data?: Maybe<Array<Poe2PassiveSkillTreeRestriction>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2PassiveSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2PassiveSkillsGraph = Poe2GameEntity & {
  __typename?: 'Poe2PassiveSkillsGraph';
  groups?: Maybe<Array<Poe2Groups>>;
  id: Scalars['String'];
  name: Scalars['String'];
  orbits?: Maybe<Array<Scalars['Int']>>;
  radii?: Maybe<Array<Scalars['Int']>>;
  rootEdgeSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

export type Poe2PassiveSkillsGraphFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2PassiveSkillsGraphResult = {
  __typename?: 'Poe2PassiveSkillsGraphResult';
  data?: Maybe<Array<Poe2PassiveSkillsGraph>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2PassiveSkillsResult = {
  __typename?: 'Poe2PassiveSkillsResult';
  data?: Maybe<Array<Poe2PassiveSkill>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Prefix = Poe2GameEntity & {
  __typename?: 'Poe2Prefix';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  combinedDescription?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  tier?: Maybe<Scalars['String']>;
};

export type Poe2PrefixesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2PrefixesResult = {
  __typename?: 'Poe2PrefixesResult';
  data?: Maybe<Array<Poe2Prefix>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum Poe2PreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2PreviewDocumentContentInput = {
  content: Scalars['Poe2DocumentContentInputBase64Json'];
};

export type Poe2PreviewDocumentContentPayload = {
  __typename?: 'Poe2PreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<Poe2DocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<Poe2PreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2Profile = NgfProfile & {
  __typename?: 'Poe2Profile';
  author?: Maybe<NgfDocumentAuthor>;
  data?: Maybe<Poe2GameProfileData>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type Poe2ProfileuserGeneratedDocumentsArgs = {
  input: Poe2UserGeneratedDocumentsListInput;
  page: Poe2UserGeneratedDocumentsListPage;
};

export type Poe2ProfilePayload = {
  __typename?: 'Poe2ProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<Poe2Profile>;
};

export type Poe2ProfilesQuery = {
  __typename?: 'Poe2ProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: Poe2ProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type Poe2ProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type Poe2Query = {
  __typename?: 'Poe2Query';
  builds?: Maybe<Poe2BuildsQuery>;
  documents?: Maybe<Poe2DocumentsQuery>;
  gameBuilds?: Maybe<Poe2GameBuildsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<Poe2ProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<Poe2StaticDataQuery>;
  trackedUgDocuments?: Maybe<NgfUserGeneratedDocumentsListPayload>;
};

export type Poe2Quest = Poe2GameEntity & {
  __typename?: 'Poe2Quest';
  act?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  flavourText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rewards?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type Poe2QuestReward = Poe2GameEntity & {
  __typename?: 'Poe2QuestReward';
  bakedDescription?: Maybe<Scalars['String']>;
  flavourText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modifiers?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  questSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  statSlugs?: Maybe<Array<Scalars['String']>>;
  substitutions?: Maybe<Array<Scalars['Float']>>;
};

export type Poe2QuestRewardsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2QuestRewardsResult = {
  __typename?: 'Poe2QuestRewardsResult';
  data?: Maybe<Array<Poe2QuestReward>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2QuestTypeFilter = Poe2GameEntity & {
  __typename?: 'Poe2QuestTypeFilter';
  id: Scalars['String'];
  name: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
};

export type Poe2QuestTypeFilterFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2QuestTypeFilterResult = {
  __typename?: 'Poe2QuestTypeFilterResult';
  data?: Maybe<Array<Poe2QuestTypeFilter>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2QuestsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2QuestsResult = {
  __typename?: 'Poe2QuestsResult';
  data?: Maybe<Array<Poe2Quest>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Quiver = Poe2GameEntity & {
  __typename?: 'Poe2Quiver';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2QuiversFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2QuiversResult = {
  __typename?: 'Poe2QuiversResult';
  data?: Maybe<Array<Poe2Quiver>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Ring = Poe2GameEntity & {
  __typename?: 'Poe2Ring';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2RingsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2RingsResult = {
  __typename?: 'Poe2RingsResult';
  data?: Maybe<Array<Poe2Ring>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2RuneRestriction = Poe2GameEntity & {
  __typename?: 'Poe2RuneRestriction';
  equipmentSlot?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxSlotsAmount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2RuneRestrictionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2RuneRestrictionsResult = {
  __typename?: 'Poe2RuneRestrictionsResult';
  data?: Maybe<Array<Poe2RuneRestriction>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Shield = Poe2GameEntity & {
  __typename?: 'Poe2Shield';
  backedStatDescriptions?: Maybe<Array<Poe2BackedStatDescriptions>>;
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  shieldStats?: Maybe<Array<Poe2ShieldStats>>;
  slug: Scalars['String'];
};

export type Poe2ShieldStats = {
  __typename?: 'Poe2ShieldStats';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['Float']>;
};

export type Poe2ShieldsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2ShieldsResult = {
  __typename?: 'Poe2ShieldsResult';
  data?: Maybe<Array<Poe2Shield>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2SkillType = Poe2GameEntity & {
  __typename?: 'Poe2SkillType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2SkillTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2SkillTypesResult = {
  __typename?: 'Poe2SkillTypesResult';
  data?: Maybe<Array<Poe2SkillType>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2SoulCore = Poe2GameEntity & {
  __typename?: 'Poe2SoulCore';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Scalars['Int']>>;
  equippedIcon?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  statSlugs?: Maybe<Array<Scalars['String']>>;
  substitutions?: Maybe<Array<Scalars['Float']>>;
};

export type Poe2SoulCoresFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2SoulCoresResult = {
  __typename?: 'Poe2SoulCoresResult';
  data?: Maybe<Array<Poe2SoulCore>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2SpriteSheet = Poe2GameEntity & {
  __typename?: 'Poe2SpriteSheet';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type Poe2SpriteSheetsDataFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2SpriteSheetsDataResult = {
  __typename?: 'Poe2SpriteSheetsDataResult';
  data?: Maybe<Array<Poe2SpriteSheetsDatum>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2SpriteSheetsDatum = Poe2GameEntity & {
  __typename?: 'Poe2SpriteSheetsDatum';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  spritesData?: Maybe<Array<Poe2SpritesData>>;
};

export type Poe2SpriteSheetsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2SpriteSheetsResult = {
  __typename?: 'Poe2SpriteSheetsResult';
  data?: Maybe<Array<Poe2SpriteSheet>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2SpritesData = {
  __typename?: 'Poe2SpritesData';
  height?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export enum Poe2StaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type Poe2StaticDataQuery = {
  __typename?: 'Poe2StaticDataQuery';
  poe2Amulets: Poe2AmuletsResult;
  poe2Anointments: Poe2AnointmentsResult;
  poe2Armours: Poe2ArmoursResult;
  poe2Ascendancies: Poe2AscendanciesResult;
  poe2AscendancyToClass: Poe2AscendancyToClassResult;
  poe2AtlasMasterSkills: Poe2AtlasMasterSkillsResult;
  poe2AtlasMasters: Poe2AtlasMastersResult;
  poe2AtlasSubtrees: Poe2AtlasSubtreesResult;
  poe2AtlasTreeRestrictions: Poe2AtlasTreeRestrictionsResult;
  poe2BaseItems: Poe2BaseItemsResult;
  poe2CharacterStartStatess: Poe2CharacterStartStatessResult;
  poe2Characters: Poe2CharactersResult;
  poe2Description: Poe2DescriptionResult;
  poe2Dictionary: Poe2DictionaryResult;
  poe2EquipmentGems: Poe2EquipmentGemsResult;
  poe2EquipmentRestrictions: Poe2EquipmentRestrictionsResult;
  poe2Flasks: Poe2FlasksResult;
  poe2Focuses: Poe2FocusesResult;
  poe2GemTags: Poe2GemTagsResult;
  poe2Gems: Poe2GemsResult;
  poe2ItemClasses: Poe2ItemClassesResult;
  poe2JewelRadii: Poe2JewelRadiiResult;
  poe2Jewels: Poe2JewelsResult;
  poe2PassiveSkillOverrides: Poe2PassiveSkillOverridesResult;
  poe2PassiveSkillTreeRestrictions: Poe2PassiveSkillTreeRestrictionsResult;
  poe2PassiveSkills: Poe2PassiveSkillsResult;
  poe2PassiveSkillsGraph: Poe2PassiveSkillsGraphResult;
  poe2Prefixes: Poe2PrefixesResult;
  poe2QuestRewards: Poe2QuestRewardsResult;
  poe2QuestTypeFilter: Poe2QuestTypeFilterResult;
  poe2Quests: Poe2QuestsResult;
  poe2Quivers: Poe2QuiversResult;
  poe2Rings: Poe2RingsResult;
  poe2RuneRestrictions: Poe2RuneRestrictionsResult;
  poe2Shields: Poe2ShieldsResult;
  poe2SkillTypes: Poe2SkillTypesResult;
  poe2SoulCores: Poe2SoulCoresResult;
  poe2SpriteSheets: Poe2SpriteSheetsResult;
  poe2SpriteSheetsData: Poe2SpriteSheetsDataResult;
  poe2Suffixes: Poe2SuffixesResult;
  poe2Talismans: Poe2TalismansResult;
  poe2Weapons: Poe2WeaponsResult;
};

export type Poe2StaticDataQuerypoe2AmuletsArgs = {
  filter?: InputMaybe<Poe2AmuletsFilter>;
};

export type Poe2StaticDataQuerypoe2AnointmentsArgs = {
  filter?: InputMaybe<Poe2AnointmentsFilter>;
};

export type Poe2StaticDataQuerypoe2ArmoursArgs = {
  filter?: InputMaybe<Poe2ArmoursFilter>;
};

export type Poe2StaticDataQuerypoe2AscendanciesArgs = {
  filter?: InputMaybe<Poe2AscendanciesFilter>;
};

export type Poe2StaticDataQuerypoe2AscendancyToClassArgs = {
  filter?: InputMaybe<Poe2AscendancyToClassFilter>;
};

export type Poe2StaticDataQuerypoe2AtlasMasterSkillsArgs = {
  filter?: InputMaybe<Poe2AtlasMasterSkillsFilter>;
};

export type Poe2StaticDataQuerypoe2AtlasMastersArgs = {
  filter?: InputMaybe<Poe2AtlasMastersFilter>;
};

export type Poe2StaticDataQuerypoe2AtlasSubtreesArgs = {
  filter?: InputMaybe<Poe2AtlasSubtreesFilter>;
};

export type Poe2StaticDataQuerypoe2AtlasTreeRestrictionsArgs = {
  filter?: InputMaybe<Poe2AtlasTreeRestrictionsFilter>;
};

export type Poe2StaticDataQuerypoe2BaseItemsArgs = {
  filter?: InputMaybe<Poe2BaseItemsFilter>;
};

export type Poe2StaticDataQuerypoe2CharacterStartStatessArgs = {
  filter?: InputMaybe<Poe2CharacterStartStatessFilter>;
};

export type Poe2StaticDataQuerypoe2CharactersArgs = {
  filter?: InputMaybe<Poe2CharactersFilter>;
};

export type Poe2StaticDataQuerypoe2DescriptionArgs = {
  filter?: InputMaybe<Poe2DescriptionFilter>;
};

export type Poe2StaticDataQuerypoe2DictionaryArgs = {
  filter?: InputMaybe<Poe2DictionaryFilter>;
};

export type Poe2StaticDataQuerypoe2EquipmentGemsArgs = {
  filter?: InputMaybe<Poe2EquipmentGemsFilter>;
};

export type Poe2StaticDataQuerypoe2EquipmentRestrictionsArgs = {
  filter?: InputMaybe<Poe2EquipmentRestrictionsFilter>;
};

export type Poe2StaticDataQuerypoe2FlasksArgs = {
  filter?: InputMaybe<Poe2FlasksFilter>;
};

export type Poe2StaticDataQuerypoe2FocusesArgs = {
  filter?: InputMaybe<Poe2FocusesFilter>;
};

export type Poe2StaticDataQuerypoe2GemTagsArgs = {
  filter?: InputMaybe<Poe2GemTagsFilter>;
};

export type Poe2StaticDataQuerypoe2GemsArgs = {
  filter?: InputMaybe<Poe2GemsFilter>;
};

export type Poe2StaticDataQuerypoe2ItemClassesArgs = {
  filter?: InputMaybe<Poe2ItemClassesFilter>;
};

export type Poe2StaticDataQuerypoe2JewelRadiiArgs = {
  filter?: InputMaybe<Poe2JewelRadiiFilter>;
};

export type Poe2StaticDataQuerypoe2JewelsArgs = {
  filter?: InputMaybe<Poe2JewelsFilter>;
};

export type Poe2StaticDataQuerypoe2PassiveSkillOverridesArgs = {
  filter?: InputMaybe<Poe2PassiveSkillOverridesFilter>;
};

export type Poe2StaticDataQuerypoe2PassiveSkillTreeRestrictionsArgs = {
  filter?: InputMaybe<Poe2PassiveSkillTreeRestrictionsFilter>;
};

export type Poe2StaticDataQuerypoe2PassiveSkillsArgs = {
  filter?: InputMaybe<Poe2PassiveSkillsFilter>;
};

export type Poe2StaticDataQuerypoe2PassiveSkillsGraphArgs = {
  filter?: InputMaybe<Poe2PassiveSkillsGraphFilter>;
};

export type Poe2StaticDataQuerypoe2PrefixesArgs = {
  filter?: InputMaybe<Poe2PrefixesFilter>;
};

export type Poe2StaticDataQuerypoe2QuestRewardsArgs = {
  filter?: InputMaybe<Poe2QuestRewardsFilter>;
};

export type Poe2StaticDataQuerypoe2QuestTypeFilterArgs = {
  filter?: InputMaybe<Poe2QuestTypeFilterFilter>;
};

export type Poe2StaticDataQuerypoe2QuestsArgs = {
  filter?: InputMaybe<Poe2QuestsFilter>;
};

export type Poe2StaticDataQuerypoe2QuiversArgs = {
  filter?: InputMaybe<Poe2QuiversFilter>;
};

export type Poe2StaticDataQuerypoe2RingsArgs = {
  filter?: InputMaybe<Poe2RingsFilter>;
};

export type Poe2StaticDataQuerypoe2RuneRestrictionsArgs = {
  filter?: InputMaybe<Poe2RuneRestrictionsFilter>;
};

export type Poe2StaticDataQuerypoe2ShieldsArgs = {
  filter?: InputMaybe<Poe2ShieldsFilter>;
};

export type Poe2StaticDataQuerypoe2SkillTypesArgs = {
  filter?: InputMaybe<Poe2SkillTypesFilter>;
};

export type Poe2StaticDataQuerypoe2SoulCoresArgs = {
  filter?: InputMaybe<Poe2SoulCoresFilter>;
};

export type Poe2StaticDataQuerypoe2SpriteSheetsArgs = {
  filter?: InputMaybe<Poe2SpriteSheetsFilter>;
};

export type Poe2StaticDataQuerypoe2SpriteSheetsDataArgs = {
  filter?: InputMaybe<Poe2SpriteSheetsDataFilter>;
};

export type Poe2StaticDataQuerypoe2SuffixesArgs = {
  filter?: InputMaybe<Poe2SuffixesFilter>;
};

export type Poe2StaticDataQuerypoe2TalismansArgs = {
  filter?: InputMaybe<Poe2TalismansFilter>;
};

export type Poe2StaticDataQuerypoe2WeaponsArgs = {
  filter?: InputMaybe<Poe2WeaponsFilter>;
};

export type Poe2StatsPerLevel = {
  __typename?: 'Poe2StatsPerLevel';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  descriptions?: Maybe<Array<Scalars['Int']>>;
  level?: Maybe<Scalars['Int']>;
  requiredSkillLevelStats?: Maybe<Array<Poe2StatsPerLevelRequiredSkillLevelStats>>;
  skillLevelStatSlugs?: Maybe<Array<Scalars['String']>>;
  skillLevelStats?: Maybe<Array<Poe2StatsPerLevelSkillLevelStats>>;
  substitutions?: Maybe<Array<Scalars['Float']>>;
};

export type Poe2StatsPerLevelRequiredSkillLevelStats = {
  __typename?: 'Poe2StatsPerLevelRequiredSkillLevelStats';
  slug: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type Poe2StatsPerLevelSkillLevelStats = {
  __typename?: 'Poe2StatsPerLevelSkillLevelStats';
  slug: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type Poe2StructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'Poe2StructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Poe2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Poe2StructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum Poe2StructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Poe2StructDocumentCreateInput = {
  document: Scalars['Poe2StructDocumentInputBase64Json'];
};

export type Poe2StructDocumentCreatePayload = {
  __typename?: 'Poe2StructDocumentCreatePayload';
  data?: Maybe<Poe2StructDocument>;
  error?: Maybe<Poe2StructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2StructDocumentData = NgfStructDocumentData & {
  __typename?: 'Poe2StructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Poe2DocumentSeason;
  tags?: Maybe<Poe2DocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum Poe2StructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Poe2StructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Poe2StructDocumentPayload = {
  __typename?: 'Poe2StructDocumentPayload';
  data?: Maybe<Poe2StructDocument>;
  error?: Maybe<Poe2StructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2StructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Poe2StructDocumentSetSeoPayload = {
  __typename?: 'Poe2StructDocumentSetSeoPayload';
  data?: Maybe<Poe2StructDocument>;
  error?: Maybe<Poe2StructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2StructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2StructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type Poe2StructDocumentSetStatusPayload = {
  __typename?: 'Poe2StructDocumentSetStatusPayload';
  data?: Maybe<Poe2StructDocument>;
  error?: Maybe<Poe2StructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2StructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2StructDocumentUpdateInput = {
  document: Scalars['Poe2StructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Poe2StructDocumentUpdatePayload = {
  __typename?: 'Poe2StructDocumentUpdatePayload';
  data?: Maybe<Poe2StructDocument>;
  error?: Maybe<Poe2StructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2StructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type Poe2Suffix = Poe2GameEntity & {
  __typename?: 'Poe2Suffix';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  combinedDescription?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
  suffixStatSlugs?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  tier?: Maybe<Scalars['String']>;
};

export type Poe2SuffixesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2SuffixesResult = {
  __typename?: 'Poe2SuffixesResult';
  data?: Maybe<Array<Poe2Suffix>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2Talisman = Poe2GameEntity & {
  __typename?: 'Poe2Talisman';
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2TalismansFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2TalismansResult = {
  __typename?: 'Poe2TalismansResult';
  data?: Maybe<Array<Poe2Talisman>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2TemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'Poe2TemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<Poe2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: Poe2TemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type Poe2TemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'Poe2TemplateDocumentData';
  buildVariants?: Maybe<Poe2UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Poe2DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Poe2TemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2TemplateDocumentInput = {
  type: Scalars['String'];
};

export type Poe2TemplateDocumentPayload = {
  __typename?: 'Poe2TemplateDocumentPayload';
  data?: Maybe<Poe2TemplateDocument>;
  error?: Maybe<Poe2TemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2TiledIconRect = {
  __typename?: 'Poe2TiledIconRect';
  Height?: Maybe<Scalars['Int']>;
  Width?: Maybe<Scalars['Int']>;
  X?: Maybe<Scalars['Int']>;
  Y?: Maybe<Scalars['Int']>;
};

export type Poe2TopAscendanciesInput = {
  leagueType: Poe2TopCharactersLeagueType;
};

export type Poe2TopAscendanciesPayload = {
  __typename?: 'Poe2TopAscendanciesPayload';
  league?: Maybe<Scalars['String']>;
  leagueType?: Maybe<Poe2TopCharactersLeagueType>;
  list?: Maybe<Array<Poe2TopAscendancy>>;
  total?: Maybe<Scalars['Int']>;
};

export type Poe2TopAscendancy = {
  __typename?: 'Poe2TopAscendancy';
  charactersNumber?: Maybe<Scalars['Int']>;
  class?: Maybe<Poe2BuildsClass>;
  percentage?: Maybe<Scalars['Float']>;
};

export type Poe2TopCharacter = {
  __typename?: 'Poe2TopCharacter';
  activeSkills?: Maybe<Array<Poe2DocumentCmWidgetSkillGemsSlotActiveV1>>;
  character: Poe2GameApiCharacterInfo;
  keystones?: Maybe<Array<Poe2UgDocumentBuildVariantPassiveTreeKeystone>>;
  user: NgfDocumentAuthor;
};

export type Poe2TopCharactersInput = {
  /**
   * Ascendancy display name as returned by topAscendancies (class.ascendancy).
   * Empty = all ascendancies; unknown names match nothing.
   */
  ascendancy?: InputMaybe<Scalars['String']>;
  leagueType?: InputMaybe<Poe2TopCharactersLeagueType>;
  page?: InputMaybe<Poe2TopCharactersInputPage>;
};

export type Poe2TopCharactersInputPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export enum Poe2TopCharactersLeagueType {
  HC = 'HC',
  HCSSF = 'HCSSF',
  NORMAL = 'NORMAL',
  SSF = 'SSF',
}

export type Poe2TopCharactersPaginationInfo = {
  __typename?: 'Poe2TopCharactersPaginationInfo';
  cursor?: Maybe<Scalars['String']>;
  hasMoreItems?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type Poe2TopCharactersPayload = {
  __typename?: 'Poe2TopCharactersPayload';
  league?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Poe2TopCharacter>>;
  pageInfo?: Maybe<Poe2TopCharactersPaginationInfo>;
};

export type Poe2UGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'Poe2UGDocumentGenericBuilder';
  slots?: Maybe<Array<Poe2UGDocumentGenericBuilderSlot>>;
};

export type Poe2UGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'Poe2UGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<Poe2EntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type Poe2UgDocumentBuildVariantPassiveTreeKeystone = {
  __typename?: 'Poe2UgDocumentBuildVariantPassiveTreeKeystone';
  iconURL: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2UgDocumentBuildVariantPassiveTreePriorityListItem = NgfDocumentWidgetPriorityListItem & {
  __typename?: 'Poe2UgDocumentBuildVariantPassiveTreePriorityListItem';
  description?: Maybe<Scalars['String']>;
  iconURL: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type Poe2UserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'Poe2UserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<Poe2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Poe2UserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    exportToGame?: Maybe<Scalars['String']>;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    matchingInfo?: Maybe<NgfMatchingInfo>;
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<Poe2DocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Poe2UserGeneratedDocumentexportToGameArgs = {
  variantId: Scalars['String'];
};

export type Poe2UserGeneratedDocumentmatchingInfoArgs = {
  autoSync?: InputMaybe<Scalars['Boolean']>;
};

export type Poe2UserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariant';
  atlasTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantAtlasTree>;
  equipment?: Maybe<Poe2UserGeneratedDocumentBuildVariantEquipment>;
  genericBuilder: Poe2UGDocumentGenericBuilder;
  id: Scalars['ID'];
  passiveTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTree>;
  skillGems?: Maybe<Poe2UserGeneratedDocumentBuildVariantSkillGems>;
};

export type Poe2UserGeneratedDocumentBuildVariantAtlasTree = {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantAtlasTree';
  abyssalTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  bossTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  breachTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  deliriumTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  expeditionTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  incursionTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  keystoneNodes?: Maybe<Array<AtlasKeystoneNode>>;
  mainTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  masters?: Maybe<Array<AtlasMaster>>;
  pinnacleBossTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  ritualTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
};

export type Poe2UserGeneratedDocumentBuildVariantAtlasTreeNodes = {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantAtlasTreeNodes';
  selectedSlugs?: Maybe<Array<Scalars['String']>>;
};

export type Poe2UserGeneratedDocumentBuildVariantEquipment = NgfDocumentWidgetPrioritizable & {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantEquipment';
  amulet?: Maybe<Poe2DocumentUgWidgetEquipmentAmuletV1>;
  belt?: Maybe<Poe2DocumentUgWidgetEquipmentArmourV1>;
  body?: Maybe<Poe2DocumentUgWidgetEquipmentArmourV1>;
  boots?: Maybe<Poe2DocumentUgWidgetEquipmentArmourV1>;
  chakras?: Maybe<Array<Poe2DocumentUgWidgetEquipmentRuneV1>>;
  charm1?: Maybe<Poe2DocumentUgWidgetEquipmentCharmV1>;
  charm2?: Maybe<Poe2DocumentUgWidgetEquipmentCharmV1>;
  charm3?: Maybe<Poe2DocumentUgWidgetEquipmentCharmV1>;
  extraRing?: Maybe<Poe2DocumentUgWidgetEquipmentRingV1>;
  flask1?: Maybe<Poe2DocumentUgWidgetEquipmentFlaskV1>;
  flask2?: Maybe<Poe2DocumentUgWidgetEquipmentFlaskV1>;
  gloves?: Maybe<Poe2DocumentUgWidgetEquipmentArmourV1>;
  helmet?: Maybe<Poe2DocumentUgWidgetEquipmentArmourV1>;
  leftRing?: Maybe<Poe2DocumentUgWidgetEquipmentRingV1>;
  mainHand?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponMainV1>;
  offHand?: Maybe<Poe2DocumentUgWidgetEquipmentWeaponOffV1>;
  priorityList?: Maybe<Array<Poe2DocumentUgWidgetEquipmentPriorityListItem>>;
  rightRing?: Maybe<Poe2DocumentUgWidgetEquipmentRingV1>;
};

export type Poe2UserGeneratedDocumentBuildVariantPassiveTree = {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantPassiveTree';
  ascendancyTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  attributeNodes?: Maybe<Array<AttributeNode>>;
  jewels?: Maybe<Array<Poe2UserGeneratedDocumentBuildVariantPassiveTreeJewel>>;
  mainTree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  set1Tree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
  set2Tree?: Maybe<Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes>;
};

export type Poe2UserGeneratedDocumentBuildVariantPassiveTreeJewel = {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantPassiveTreeJewel';
  iconURL: Scalars['String'];
  isUnique: Scalars['Boolean'];
  jewelSlug: Scalars['String'];
  nodeSlug: Scalars['String'];
  poe2TradeRequest?: Maybe<Poe2DocumentUgWidgetEquipmentCommonV1TradeRequest>;
  prefixSlugs?: Maybe<Array<Scalars['String']>>;
  suffixSlugs?: Maybe<Array<Scalars['String']>>;
};

export type Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes = NgfDocumentWidgetPrioritizable & {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantPassiveTreeNodes';
  /** Read only node. Derived from selectedSlugs */
  keystones?: Maybe<Array<Poe2UgDocumentBuildVariantPassiveTreeKeystone>>;
  /**
   * priorityList contains a list of nodes ordered by priority usually determined by build creator.
   * Currently is filled for main tree only but contains all sets's and ascendancies nodes too.
   */
  priorityList?: Maybe<Array<Poe2UgDocumentBuildVariantPassiveTreePriorityListItem>>;
  selectedSlugs?: Maybe<Array<Scalars['String']>>;
};

export type Poe2UserGeneratedDocumentBuildVariantSkillGems = {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariantSkillGems';
  gemRequirements?: Maybe<Poe2DocumentCmWidgetGemsRequirementsV1>;
  gems?: Maybe<Array<Poe2DocumentCmWidgetGemsSlotV1>>;
  priorityGems?: Maybe<Array<Poe2DocumentCmWidgetSkillGemsSlotSubV1>>;
};

export type Poe2UserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'Poe2UserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<Poe2UserGeneratedDocumentBuildVariant>>;
};

export enum Poe2UserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Poe2UserGeneratedDocumentCreateInput = {
  document: Scalars['Poe2UserGeneratedDocumentInputBase64Json'];
};

export type Poe2UserGeneratedDocumentCreatePayload = {
  __typename?: 'Poe2UserGeneratedDocumentCreatePayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2UserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'Poe2UserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<Poe2UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  lootFilter?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pobCode?: Maybe<Scalars['String']>;
  questRewards?: Maybe<Poe2UserGeneratedDocumentQuestRewards>;
  /** @deprecated Season functionality is no longer used */
  season: Poe2DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Poe2UserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Poe2UserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Poe2UserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Poe2UserGeneratedDocumentPayload = {
  __typename?: 'Poe2UserGeneratedDocumentPayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2UserGeneratedDocumentQuest = {
  __typename?: 'Poe2UserGeneratedDocumentQuest';
  act?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rewards?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type Poe2UserGeneratedDocumentQuestReward = {
  __typename?: 'Poe2UserGeneratedDocumentQuestReward';
  quest: Poe2UserGeneratedDocumentQuest;
  reward?: Maybe<Poe2UserGeneratedDocumentQuestRewardData>;
};

export type Poe2UserGeneratedDocumentQuestRewardData = {
  __typename?: 'Poe2UserGeneratedDocumentQuestRewardData';
  bakedDescription?: Maybe<Scalars['String']>;
  modifiers?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Poe2UserGeneratedDocumentQuestRewards = {
  __typename?: 'Poe2UserGeneratedDocumentQuestRewards';
  quests: Array<Poe2UserGeneratedDocumentQuestReward>;
};

export enum Poe2UserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2UserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type Poe2UserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'Poe2UserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2UserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Poe2UserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type Poe2UserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'Poe2UserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2UserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Poe2UserGeneratedDocumentSetSeoPayload = {
  __typename?: 'Poe2UserGeneratedDocumentSetSeoPayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2UserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2UserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type Poe2UserGeneratedDocumentSetStatusPayload = {
  __typename?: 'Poe2UserGeneratedDocumentSetStatusPayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2UserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Poe2UserGeneratedDocumentUpdateInput = {
  document: Scalars['Poe2UserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Poe2UserGeneratedDocumentUpdatePayload = {
  __typename?: 'Poe2UserGeneratedDocumentUpdatePayload';
  data?: Maybe<Poe2UserGeneratedDocument>;
  error?: Maybe<Poe2UserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2UserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type Poe2UserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Poe2Weapon = Poe2GameEntity & {
  __typename?: 'Poe2Weapon';
  backedStatDescriptions?: Maybe<Array<Poe2BackedStatDescriptions>>;
  bakedDescriptions?: Maybe<Array<Scalars['String']>>;
  baseItemType?: Maybe<Poe2BaseItem>;
  baseItemTypeSlug?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['Int']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isUnique?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  maxDescriptions?: Maybe<Array<Scalars['Int']>>;
  maxSubstitutions?: Maybe<Array<Scalars['Float']>>;
  minDescriptions?: Maybe<Array<Scalars['Int']>>;
  minSubstitutions?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  prefixStatSlugs?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  weaponStats?: Maybe<Array<Poe2WeaponStats>>;
};

export type Poe2WeaponStats = {
  __typename?: 'Poe2WeaponStats';
  slug: Scalars['String'];
  stat?: Maybe<Poe2Dictionary>;
  value?: Maybe<Scalars['Float']>;
};

export type Poe2WeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type Poe2WeaponsResult = {
  __typename?: 'Poe2WeaponsResult';
  data?: Maybe<Array<Poe2Weapon>>;
  error?: Maybe<Poe2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type Poe2WikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'Poe2WikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Poe2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Poe2WikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<Poe2DocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Poe2WikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'Poe2WikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: Poe2EntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum Poe2WikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2WikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Poe2WikiDocumentPayload = {
  __typename?: 'Poe2WikiDocumentPayload';
  data?: Maybe<Poe2WikiDocument>;
  error?: Maybe<Poe2WikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2WikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Poe2WikiDocumentSetSeoPayload = {
  __typename?: 'Poe2WikiDocumentSetSeoPayload';
  data?: Maybe<Poe2WikiDocument>;
  error?: Maybe<Poe2WikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Poe2WikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Poe2WikiDocumentUpdateInput = {
  document: Scalars['Poe2WikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type Poe2WikiDocumentUpdatePayload = {
  __typename?: 'Poe2WikiDocumentUpdatePayload';
  data?: Maybe<Poe2WikiDocument>;
  error?: Maybe<Poe2WikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Poe2WikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type Poe2WikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type PoeAlternateAscendancies = PoeGameEntity & {
  __typename?: 'PoeAlternateAscendancies';
  ascendancyId: Scalars['String'];
  background?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  gameId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PoeAlternateAscendanciesFilter = {
  ascendancyId?: InputMaybe<OneOfString>;
  gameId?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeAlternateAscendanciesResult = {
  __typename?: 'PoeAlternateAscendanciesResult';
  data?: Maybe<Array<PoeAlternateAscendancies>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeAmulets = PoeGameEntity & {
  __typename?: 'PoeAmulets';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeAmuletsRequiredStats>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PoeAmuletsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeAmuletsRequiredStats = {
  __typename?: 'PoeAmuletsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeAmuletsResult = {
  __typename?: 'PoeAmuletsResult';
  data?: Maybe<Array<PoeAmulets>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeArmours = PoeGameEntity & {
  __typename?: 'PoeArmours';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeArmoursRequiredStats>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeArmoursStats>>;
  type?: Maybe<Scalars['String']>;
};

export type PoeArmoursFilter = {
  baseItemId?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeArmoursRequiredStats = {
  __typename?: 'PoeArmoursRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeArmoursResult = {
  __typename?: 'PoeArmoursResult';
  data?: Maybe<Array<PoeArmours>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeArmoursStats = {
  __typename?: 'PoeArmoursStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeAscendancies = PoeGameEntity & {
  __typename?: 'PoeAscendancies';
  ascendancyId?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  classTag?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  passiveTreeImage?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type PoeAscendanciesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeAscendanciesResult = {
  __typename?: 'PoeAscendanciesResult';
  data?: Maybe<Array<PoeAscendancies>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeBelts = PoeGameEntity & {
  __typename?: 'PoeBelts';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeBeltsRequiredStats>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PoeBeltsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeBeltsRequiredStats = {
  __typename?: 'PoeBeltsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeBeltsResult = {
  __typename?: 'PoeBeltsResult';
  data?: Maybe<Array<PoeBelts>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeBlankStaticEntity = {
  __typename?: 'PoeBlankStaticEntity';
  id: Scalars['ID'];
};

export type PoeBuildClass = {
  __typename?: 'PoeBuildClass';
  ascendancy?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type PoeBuildImportEntity = {
  slug: Scalars['String'];
};

export type PoeBuildImportEntityObject = {
  __typename?: 'PoeBuildImportEntityObject';
  color?: Maybe<Scalars['String']>;
  data?: Maybe<PoeItem>;
  entityV2?: Maybe<PoeBuildImportEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  /** type is service field for federative static data to identify which kind of entity it is, e.g. "amulets", "weapons" etc */
  type: Scalars['String'];
};

export type PoeBuildImportEquipmentItem = PoeBuildImportEntity & {
  __typename?: 'PoeBuildImportEquipmentItem';
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeBuildImportStat>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeBuildImportStat>>;
  /** type is actual item type from static data, e.g. "One Handed Sword", "Body Armour", etc */
  type?: Maybe<Scalars['String']>;
};

export type PoeBuildImportGems = PoeBuildImportEntity & {
  __typename?: 'PoeBuildImportGems';
  description?: Maybe<Scalars['String']>;
  dex?: Maybe<Scalars['String']>;
  gameId?: Maybe<Scalars['String']>;
  gemTags?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  int?: Maybe<Scalars['String']>;
  isSupport?: Maybe<Scalars['Boolean']>;
  itemIcon?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  skill?: Maybe<PoeBuildImportSkills>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeBuildImportStat>>;
  str?: Maybe<Scalars['String']>;
};

export type PoeBuildImportJewelRadii = {
  __typename?: 'PoeBuildImportJewelRadii';
  id: Scalars['String'];
  name: Scalars['String'];
  radius?: Maybe<Scalars['String']>;
  ringInner?: Maybe<Scalars['String']>;
  ringOuter?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type PoeBuildImportJewels = PoeBuildImportEntity & {
  __typename?: 'PoeBuildImportJewels';
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  radius?: Maybe<PoeBuildImportJewelRadii>;
  slug: Scalars['String'];
  subType?: Maybe<Scalars['String']>;
};

export type PoeBuildImportPassiveSkillNodes = PoeBuildImportEntity & {
  __typename?: 'PoeBuildImportPassiveSkillNodes';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  passiveSkill?: Maybe<PoeBuildImportPassiveSkills>;
  slug: Scalars['String'];
};

export type PoeBuildImportPassiveSkills = PoeBuildImportEntity & {
  __typename?: 'PoeBuildImportPassiveSkills';
  descriptions?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PoeBuildImportSkills = PoeBuildImportEntity & {
  __typename?: 'PoeBuildImportSkills';
  description?: Maybe<Scalars['String']>;
  effectFromQuality?: Maybe<Array<Scalars['String']>>;
  gameId?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  intrinsics?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeBuildImportStat>>;
};

export type PoeBuildImportStat = {
  __typename?: 'PoeBuildImportStat';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PoeBuildStat = {
  __typename?: 'PoeBuildStat';
  name: Scalars['String'];
  subStats?: Maybe<Array<PoeBuildStat>>;
  tags?: Maybe<Array<PoeBuildStatTag>>;
  value?: Maybe<Scalars['String']>;
};

export type PoeBuildStatGroup = {
  __typename?: 'PoeBuildStatGroup';
  /** Character, Charges, Defensive, etc */
  name: Scalars['String'];
  stats?: Maybe<Array<PoeBuildStat>>;
};

export type PoeBuildStatTag = {
  __typename?: 'PoeBuildStatTag';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PoeBuildStats = {
  __typename?: 'PoeBuildStats';
  buildVariantTitle?: Maybe<Scalars['String']>;
  /** (sorting order and tag values are defined by /settings/stat_widget/config.json ngf settings) */
  groups?: Maybe<Array<PoeBuildStatGroup>>;
};

export type PoeBuildVariant = {
  __typename?: 'PoeBuildVariant';
  equipmentSlots?: Maybe<Array<PoeEquipmentSlot>>;
  passiveTree?: Maybe<PoePassiveTree>;
  skills?: Maybe<PoeSkillGems>;
  title?: Maybe<Scalars['String']>;
};

export type PoeBuildsQuery = {
  __typename?: 'PoeBuildsQuery';
  pobBuild: PoePobBuildPayload;
};

export type PoeBuildsQuerypobBuildArgs = {
  input: PoePobBuildInput;
};

export type PoeCharacters = PoeGameEntity & {
  __typename?: 'PoeCharacters';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  startNodeIcon?: Maybe<Scalars['String']>;
  startingNode?: Maybe<PoePassiveSkillsNodes>;
  stats?: Maybe<Array<PoeCharactersStats>>;
};

export type PoeCharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeCharactersResult = {
  __typename?: 'PoeCharactersResult';
  data?: Maybe<Array<PoeCharacters>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeCharactersStats = {
  __typename?: 'PoeCharactersStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'PoeDocumentCmWidgetV1';
  data: PoeDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type PoeDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'PoeDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type PoeDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | PoeDocumentCmWidgetV1
  | PoeDocumentUgWidgetPassiveTreeV1
  | PoeDocumentUgWidgetPoBImportV1
  | PoeDocumentUgWidgetSkillsV1
  | PoeDocumentUgWidgetStatsV1;

export type PoeDocumentSeason = NgfDocumentSeason & {
  __typename?: 'PoeDocumentSeason';
  slug: Scalars['String'];
};

export type PoeDocumentTags = NgfDocumentTags & {
  __typename?: 'PoeDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type PoeDocumentUgWidgetPassiveTreeDataV1 = NgfDocumentContentData & {
  __typename?: 'PoeDocumentUgWidgetPassiveTreeDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type PoeDocumentUgWidgetPassiveTreeV1 = NgfDocumentContent & {
  __typename?: 'PoeDocumentUgWidgetPassiveTreeV1';
  data: PoeDocumentUgWidgetPassiveTreeDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type PoeDocumentUgWidgetPoBImportDataV1 = NgfDocumentContentData & {
  __typename?: 'PoeDocumentUgWidgetPoBImportDataV1';
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type PoeDocumentUgWidgetPoBImportV1 = NgfDocumentContent & {
  __typename?: 'PoeDocumentUgWidgetPoBImportV1';
  data: PoeDocumentUgWidgetPoBImportDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type PoeDocumentUgWidgetSkillsDataV1 = NgfDocumentContentData & {
  __typename?: 'PoeDocumentUgWidgetSkillsDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type PoeDocumentUgWidgetSkillsV1 = NgfDocumentContent & {
  __typename?: 'PoeDocumentUgWidgetSkillsV1';
  data: PoeDocumentUgWidgetSkillsDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type PoeDocumentUgWidgetStatsDataV1 = NgfDocumentContentData & {
  __typename?: 'PoeDocumentUgWidgetStatsDataV1';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type PoeDocumentUgWidgetStatsV1 = NgfDocumentContent & {
  __typename?: 'PoeDocumentUgWidgetStatsV1';
  data: PoeDocumentUgWidgetStatsDataV1;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type PoeDocumentsMutation = {
  __typename?: 'PoeDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: PoeStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: PoeStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: PoeStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: PoeStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: PoeUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: PoeUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: PoeUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: PoeUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: PoeUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: PoeUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: PoeWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: PoeWikiDocumentUpdatePayload;
};

export type PoeDocumentsMutationstructDocumentCreateArgs = {
  input: PoeStructDocumentCreateInput;
};

export type PoeDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type PoeDocumentsMutationstructDocumentSetStatusArgs = {
  input: PoeStructDocumentSetStatusInput;
};

export type PoeDocumentsMutationstructDocumentUpdateArgs = {
  input: PoeStructDocumentUpdateInput;
};

export type PoeDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: PoeUserGeneratedDocumentCreateInput;
};

export type PoeDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: PoeUserGeneratedDocumentSetFavoriteInput;
};

export type PoeDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: PoeUserGeneratedDocumentSetFeaturedInput;
};

export type PoeDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type PoeDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: PoeUserGeneratedDocumentSetStatusInput;
};

export type PoeDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: PoeUserGeneratedDocumentUpdateInput;
};

export type PoeDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type PoeDocumentsMutationwikiDocumentUpdateArgs = {
  input: PoeWikiDocumentUpdateInput;
};

export type PoeDocumentsQuery = {
  __typename?: 'PoeDocumentsQuery';
  previewDocumentContent: PoePreviewDocumentContentPayload;
  structDocumentBySlug: PoeStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: PoeUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: PoeUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: PoeUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: PoeUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: PoeTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: PoeWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type PoeDocumentsQuerypreviewDocumentContentArgs = {
  input: PoePreviewDocumentContentInput;
};

export type PoeDocumentsQuerystructDocumentBySlugArgs = {
  input: PoeStructDocumentInputBySlug;
};

export type PoeDocumentsQuerystructDocumentsArgs = {
  input: PoeStructDocumentsInput;
};

export type PoeDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: PoeUserGeneratedDocumentInputById;
};

export type PoeDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: PoeUserGeneratedDocumentInputBySlug;
};

export type PoeDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type PoeDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type PoeDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type PoeDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type PoeDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: PoeTemplateDocumentInput;
};

export type PoeDocumentsQueryuserGeneratedDocumentsArgs = {
  input: PoeUserGeneratedDocumentsListInput;
  page: PoeUserGeneratedDocumentsListPage;
};

export type PoeDocumentsQuerywikiDocumentArgs = {
  input: PoeWikiDocumentInput;
};

export type PoeDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<PoeWikiDocumentsListInput>;
  page: PoeWikiDocumentsListPage;
};

export enum PoeEntitiesEnum {
  alternateAscendancies = 'alternateAscendancies',
  amulets = 'amulets',
  armours = 'armours',
  ascendancies = 'ascendancies',
  belts = 'belts',
  characters = 'characters',
  flasks = 'flasks',
  gems = 'gems',
  grafts = 'grafts',
  jewelRadii = 'jewelRadii',
  jewels = 'jewels',
  keywords = 'keywords',
  masteryEffects = 'masteryEffects',
  passiveSkillTreeRestrictions = 'passiveSkillTreeRestrictions',
  passiveSkills = 'passiveSkills',
  passiveSkillsGraph = 'passiveSkillsGraph',
  passiveSkillsNodes = 'passiveSkillsNodes',
  quivers = 'quivers',
  rings = 'rings',
  shields = 'shields',
  skills = 'skills',
  tinctures = 'tinctures',
  weapons = 'weapons',
}

export type PoeEntity = PoeBlankStaticEntity;

export type PoeEntityObject = NGFEntityObject & {
  __typename?: 'PoeEntityObject';
  color?: Maybe<Scalars['String']>;
  data?: Maybe<PoeUGDocumentItem>;
  entityV2?: Maybe<PoeGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PoeEquipmentSlot = {
  __typename?: 'PoeEquipmentSlot';
  gameEntity?: Maybe<PoeBuildImportEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type PoeFlasks = PoeGameEntity & {
  __typename?: 'PoeFlasks';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeFlasksRequiredStats>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeFlasksStats>>;
  type?: Maybe<Scalars['String']>;
};

export type PoeFlasksFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeFlasksRequiredStats = {
  __typename?: 'PoeFlasksRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeFlasksResult = {
  __typename?: 'PoeFlasksResult';
  data?: Maybe<Array<PoeFlasks>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeFlasksStats = {
  __typename?: 'PoeFlasksStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeGameEntity = {
  slug: Scalars['String'];
};

export type PoeGems = PoeGameEntity & {
  __typename?: 'PoeGems';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  dex?: Maybe<Scalars['String']>;
  gemTags?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  int?: Maybe<Scalars['String']>;
  isSupport?: Maybe<Scalars['Boolean']>;
  itemIcon?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeGemsRequiredStats>>;
  skill?: Maybe<PoeSkills>;
  slug: Scalars['String'];
  str?: Maybe<Scalars['String']>;
};

export type PoeGemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeGemsRequiredStats = {
  __typename?: 'PoeGemsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeGemsResult = {
  __typename?: 'PoeGemsResult';
  data?: Maybe<Array<PoeGems>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeGrafts = PoeGameEntity & {
  __typename?: 'PoeGrafts';
  deprecated: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PoeGraftsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeGraftsResult = {
  __typename?: 'PoeGraftsResult';
  data?: Maybe<Array<PoeGrafts>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

/** Additional data about an item received from another source than our static data */
export type PoeItem = {
  __typename?: 'PoeItem';
  explicitMods?: Maybe<Array<PoeItemDescription>>;
  implicitMods?: Maybe<Array<PoeItemDescription>>;
  /** Corrupted, anything else? */
  modifiers?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  /** Level, str, dex, int, etc */
  requirements?: Maybe<Array<PoeBuildImportStat>>;
  /** Item level, quality, physical damage, armor, etc */
  stats?: Maybe<Array<PoeBuildImportStat>>;
  subTitle?: Maybe<Scalars['String']>;
};

export type PoeItemDescription = {
  __typename?: 'PoeItemDescription';
  /** special modifiers e.g. crafted */
  modifiers?: Maybe<Array<Scalars['String']>>;
  /** main description */
  text: Scalars['String'];
};

export type PoeJewelRadii = PoeGameEntity & {
  __typename?: 'PoeJewelRadii';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  radius?: Maybe<Scalars['String']>;
  ringInner?: Maybe<Scalars['String']>;
  ringOuter?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type PoeJewelRadiiFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeJewelRadiiResult = {
  __typename?: 'PoeJewelRadiiResult';
  data?: Maybe<Array<PoeJewelRadii>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeJewels = PoeGameEntity & {
  __typename?: 'PoeJewels';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  iconSocketBasic?: Maybe<Scalars['String']>;
  iconSocketLarge?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  radius?: Maybe<PoeJewelRadii>;
  requiredStats?: Maybe<Array<PoeJewelsRequiredStats>>;
  slug: Scalars['String'];
  subType?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PoeJewelsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeJewelsRequiredStats = {
  __typename?: 'PoeJewelsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeJewelsResult = {
  __typename?: 'PoeJewelsResult';
  data?: Maybe<Array<PoeJewels>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeKeywords = PoeGameEntity & {
  __typename?: 'PoeKeywords';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  slug: Scalars['String'];
  value: Scalars['String'];
};

export type PoeKeywordsFilter = {
  id?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  value?: InputMaybe<OneOfString>;
};

export type PoeKeywordsResult = {
  __typename?: 'PoeKeywordsResult';
  data?: Maybe<Array<PoeKeywords>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeMasteryEffects = PoeGameEntity & {
  __typename?: 'PoeMasteryEffects';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<Scalars['String']>>;
};

export type PoeMasteryEffectsFilter = {
  id?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeMasteryEffectsResult = {
  __typename?: 'PoeMasteryEffectsResult';
  data?: Maybe<Array<PoeMasteryEffects>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeMutation = {
  __typename?: 'PoeMutation';
  documents?: Maybe<PoeDocumentsMutation>;
  id: Scalars['ID'];
};

export type PoePassiveSkillTreeRestrictions = PoeGameEntity & {
  __typename?: 'PoePassiveSkillTreeRestrictions';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  limit?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type PoePassiveSkillTreeRestrictionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoePassiveSkillTreeRestrictionsResult = {
  __typename?: 'PoePassiveSkillTreeRestrictionsResult';
  data?: Maybe<Array<PoePassiveSkillTreeRestrictions>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoePassiveSkills = PoeGameEntity & {
  __typename?: 'PoePassiveSkills';
  alternateAscendancy?: Maybe<Scalars['String']>;
  ascendancy?: Maybe<Scalars['String']>;
  ascendancyStart?: Maybe<Scalars['Boolean']>;
  character?: Maybe<Array<PoeCharacters>>;
  clusterSize?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  descriptions?: Maybe<Array<Scalars['String']>>;
  flavorText?: Maybe<Scalars['String']>;
  flavourText?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jewelSocket?: Maybe<Scalars['Boolean']>;
  keystone?: Maybe<Scalars['Boolean']>;
  mastery?: Maybe<Scalars['Boolean']>;
  masteryActiveImage?: Maybe<Scalars['String']>;
  masteryEffectImage?: Maybe<Scalars['String']>;
  masteryGroup?: Maybe<Scalars['String']>;
  masteryInactiveImage?: Maybe<Scalars['String']>;
  multipleChoice?: Maybe<Scalars['Boolean']>;
  multipleChoiceOption?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notable?: Maybe<Scalars['Boolean']>;
  skillPointsGranted?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type PoePassiveSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoePassiveSkillsGraph = PoeGameEntity & {
  __typename?: 'PoePassiveSkillsGraph';
  deprecated: Scalars['Boolean'];
  groups?: Maybe<Array<PoePassiveSkillsGraphGroups>>;
  id: Scalars['String'];
  name: Scalars['String'];
  orbits?: Maybe<Array<Scalars['String']>>;
  radii?: Maybe<Array<Scalars['String']>>;
  rootEdge?: Maybe<Array<PoePassiveSkillsNodes>>;
  slug: Scalars['String'];
};

export type PoePassiveSkillsGraphFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoePassiveSkillsGraphGroups = {
  __typename?: 'PoePassiveSkillsGraphGroups';
  background?: Maybe<Scalars['String']>;
  centerX?: Maybe<Scalars['String']>;
  centerY?: Maybe<Scalars['String']>;
  orbits?: Maybe<Array<Scalars['String']>>;
  passiveSkillNode?: Maybe<Array<PoePassiveSkillsNodes>>;
  slug?: Maybe<Scalars['String']>;
};

export type PoePassiveSkillsGraphResult = {
  __typename?: 'PoePassiveSkillsGraphResult';
  data?: Maybe<Array<PoePassiveSkillsGraph>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoePassiveSkillsNodes = PoeGameEntity & {
  __typename?: 'PoePassiveSkillsNodes';
  deprecated: Scalars['Boolean'];
  edge?: Maybe<Array<PoePassiveSkillsNodes>>;
  id: Scalars['String'];
  isBlighted?: Maybe<Scalars['Boolean']>;
  isBloodline?: Maybe<Scalars['Boolean']>;
  isNotable?: Maybe<Scalars['Boolean']>;
  jewelExpansionIndex?: Maybe<Scalars['String']>;
  jewelExpansionParent?: Maybe<Scalars['String']>;
  jewelExpansionProxy?: Maybe<Scalars['String']>;
  jewelExpansionSize?: Maybe<Scalars['String']>;
  masteryEffects?: Maybe<Array<PoeMasteryEffects>>;
  orbit?: Maybe<Scalars['String']>;
  orbitIndex?: Maybe<Scalars['String']>;
  passiveSkill?: Maybe<PoePassiveSkills>;
  slug: Scalars['String'];
};

export type PoePassiveSkillsNodesFilter = {
  id?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoePassiveSkillsNodesResult = {
  __typename?: 'PoePassiveSkillsNodesResult';
  data?: Maybe<Array<PoePassiveSkillsNodes>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoePassiveSkillsResult = {
  __typename?: 'PoePassiveSkillsResult';
  data?: Maybe<Array<PoePassiveSkills>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoePassiveTree = {
  __typename?: 'PoePassiveTree';
  alternateAscendancyTree?: Maybe<PoePassiveTreeNodes>;
  ascendancyTree?: Maybe<PoePassiveTreeNodes>;
  jewels?: Maybe<Array<PoePassiveTreeJewel>>;
  keystones?: Maybe<Array<PoeBuildImportEntityObject>>;
  mainTree?: Maybe<PoePassiveTreeNodes>;
  masteries?: Maybe<Array<PoePassiveTreeMastery>>;
};

export type PoePassiveTreeJewel = {
  __typename?: 'PoePassiveTreeJewel';
  jewel?: Maybe<PoeBuildImportEntityObject>;
  nodeSlug: Scalars['String'];
};

export type PoePassiveTreeMastery = {
  __typename?: 'PoePassiveTreeMastery';
  mastery?: Maybe<PoeBuildImportEntityObject>;
  passiveSkillNode?: Maybe<PoeBuildImportEntityObject>;
};

export type PoePassiveTreeNodes = {
  __typename?: 'PoePassiveTreeNodes';
  selectedSlugs?: Maybe<Array<Scalars['String']>>;
};

export enum PoePobBuildError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type PoePobBuildInput = {
  rawPoB: Scalars['String'];
};

export type PoePobBuildPayload = {
  __typename?: 'PoePobBuildPayload';
  buildVariants?: Maybe<Array<PoeBuildVariant>>;
  characterStats?: Maybe<PoeBuildStats>;
  class?: Maybe<PoeBuildClass>;
  error?: Maybe<PoePobBuildError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoePreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoePreviewDocumentContentInput = {
  content: Scalars['PoeDocumentContentInputBase64Json'];
};

export type PoePreviewDocumentContentPayload = {
  __typename?: 'PoePreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<PoeDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<PoePreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeProfile = NgfProfile & {
  __typename?: 'PoeProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type PoeProfileuserGeneratedDocumentsArgs = {
  input: PoeUserGeneratedDocumentsListInput;
  page: PoeUserGeneratedDocumentsListPage;
};

export type PoeProfilePayload = {
  __typename?: 'PoeProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<PoeProfile>;
};

export type PoeProfilesQuery = {
  __typename?: 'PoeProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: PoeProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type PoeProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type PoeQuery = {
  __typename?: 'PoeQuery';
  builds?: Maybe<PoeBuildsQuery>;
  documents?: Maybe<PoeDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<PoeProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<PoeStaticDataQuery>;
};

export type PoeQuivers = PoeGameEntity & {
  __typename?: 'PoeQuivers';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeQuiversRequiredStats>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PoeQuiversFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeQuiversRequiredStats = {
  __typename?: 'PoeQuiversRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeQuiversResult = {
  __typename?: 'PoeQuiversResult';
  data?: Maybe<Array<PoeQuivers>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeRings = PoeGameEntity & {
  __typename?: 'PoeRings';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeRingsRequiredStats>>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PoeRingsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeRingsRequiredStats = {
  __typename?: 'PoeRingsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeRingsResult = {
  __typename?: 'PoeRingsResult';
  data?: Maybe<Array<PoeRings>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeShields = PoeGameEntity & {
  __typename?: 'PoeShields';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeShieldsRequiredStats>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeShieldsStats>>;
  type?: Maybe<Scalars['String']>;
};

export type PoeShieldsFilter = {
  baseItemId?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeShieldsRequiredStats = {
  __typename?: 'PoeShieldsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeShieldsResult = {
  __typename?: 'PoeShieldsResult';
  data?: Maybe<Array<PoeShields>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeShieldsStats = {
  __typename?: 'PoeShieldsStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeSkillGem = {
  __typename?: 'PoeSkillGem';
  skillGemObject?: Maybe<PoeBuildImportEntityObject>;
  slotSlug: Scalars['String'];
};

export type PoeSkillGemGroup = {
  __typename?: 'PoeSkillGemGroup';
  gems?: Maybe<Array<PoeSkillGem>>;
  label?: Maybe<Scalars['String']>;
  /** Helper field, PoeSkillGem.slotSlug's inside will always be identical */
  slotSlug?: Maybe<Scalars['String']>;
};

export type PoeSkillGems = {
  __typename?: 'PoeSkillGems';
  gemGroups?: Maybe<Array<PoeSkillGemGroup>>;
  /**
   * DEPRECATED: Use only if skills is empty
   * @deprecated Use only if `skills` is empty.
   */
  gems?: Maybe<Array<PoeSkillGem>>;
};

export type PoeSkills = PoeGameEntity & {
  __typename?: 'PoeSkills';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  effectFromQuality?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  intrinsics?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeSkillsStats>>;
};

export type PoeSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeSkillsResult = {
  __typename?: 'PoeSkillsResult';
  data?: Maybe<Array<PoeSkills>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeSkillsStats = {
  __typename?: 'PoeSkillsStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export enum PoeStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type PoeStaticDataGroups = {
  __typename?: 'PoeStaticDataGroups';
  alternateAscendancies: PoeAlternateAscendanciesResult;
  amulets: PoeAmuletsResult;
  armours: PoeArmoursResult;
  ascendancies: PoeAscendanciesResult;
  belts: PoeBeltsResult;
  characters: PoeCharactersResult;
  flasks: PoeFlasksResult;
  gems: PoeGemsResult;
  grafts: PoeGraftsResult;
  jewelRadii: PoeJewelRadiiResult;
  jewels: PoeJewelsResult;
  keywords: PoeKeywordsResult;
  masteryEffects: PoeMasteryEffectsResult;
  passiveSkillTreeRestrictions: PoePassiveSkillTreeRestrictionsResult;
  passiveSkills: PoePassiveSkillsResult;
  passiveSkillsGraph: PoePassiveSkillsGraphResult;
  passiveSkillsNodes: PoePassiveSkillsNodesResult;
  quivers: PoeQuiversResult;
  rings: PoeRingsResult;
  shields: PoeShieldsResult;
  skills: PoeSkillsResult;
  tinctures: PoeTincturesResult;
  weapons: PoeWeaponsResult;
};

export type PoeStaticDataGroupsalternateAscendanciesArgs = {
  filter?: InputMaybe<PoeAlternateAscendanciesFilter>;
};

export type PoeStaticDataGroupsamuletsArgs = {
  filter?: InputMaybe<PoeAmuletsFilter>;
};

export type PoeStaticDataGroupsarmoursArgs = {
  filter?: InputMaybe<PoeArmoursFilter>;
};

export type PoeStaticDataGroupsascendanciesArgs = {
  filter?: InputMaybe<PoeAscendanciesFilter>;
};

export type PoeStaticDataGroupsbeltsArgs = {
  filter?: InputMaybe<PoeBeltsFilter>;
};

export type PoeStaticDataGroupscharactersArgs = {
  filter?: InputMaybe<PoeCharactersFilter>;
};

export type PoeStaticDataGroupsflasksArgs = {
  filter?: InputMaybe<PoeFlasksFilter>;
};

export type PoeStaticDataGroupsgemsArgs = {
  filter?: InputMaybe<PoeGemsFilter>;
};

export type PoeStaticDataGroupsgraftsArgs = {
  filter?: InputMaybe<PoeGraftsFilter>;
};

export type PoeStaticDataGroupsjewelRadiiArgs = {
  filter?: InputMaybe<PoeJewelRadiiFilter>;
};

export type PoeStaticDataGroupsjewelsArgs = {
  filter?: InputMaybe<PoeJewelsFilter>;
};

export type PoeStaticDataGroupskeywordsArgs = {
  filter?: InputMaybe<PoeKeywordsFilter>;
};

export type PoeStaticDataGroupsmasteryEffectsArgs = {
  filter?: InputMaybe<PoeMasteryEffectsFilter>;
};

export type PoeStaticDataGroupspassiveSkillTreeRestrictionsArgs = {
  filter?: InputMaybe<PoePassiveSkillTreeRestrictionsFilter>;
};

export type PoeStaticDataGroupspassiveSkillsArgs = {
  filter?: InputMaybe<PoePassiveSkillsFilter>;
};

export type PoeStaticDataGroupspassiveSkillsGraphArgs = {
  filter?: InputMaybe<PoePassiveSkillsGraphFilter>;
};

export type PoeStaticDataGroupspassiveSkillsNodesArgs = {
  filter?: InputMaybe<PoePassiveSkillsNodesFilter>;
};

export type PoeStaticDataGroupsquiversArgs = {
  filter?: InputMaybe<PoeQuiversFilter>;
};

export type PoeStaticDataGroupsringsArgs = {
  filter?: InputMaybe<PoeRingsFilter>;
};

export type PoeStaticDataGroupsshieldsArgs = {
  filter?: InputMaybe<PoeShieldsFilter>;
};

export type PoeStaticDataGroupsskillsArgs = {
  filter?: InputMaybe<PoeSkillsFilter>;
};

export type PoeStaticDataGroupstincturesArgs = {
  filter?: InputMaybe<PoeTincturesFilter>;
};

export type PoeStaticDataGroupsweaponsArgs = {
  filter?: InputMaybe<PoeWeaponsFilter>;
};

export type PoeStaticDataQuery = {
  __typename?: 'PoeStaticDataQuery';
  groups: PoeStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type PoeStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'PoeStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<PoeDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: PoeStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum PoeStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type PoeStructDocumentCreateInput = {
  document: Scalars['PoeStructDocumentInputBase64Json'];
};

export type PoeStructDocumentCreatePayload = {
  __typename?: 'PoeStructDocumentCreatePayload';
  data?: Maybe<PoeStructDocument>;
  error?: Maybe<PoeStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeStructDocumentData = NgfStructDocumentData & {
  __typename?: 'PoeStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: PoeDocumentSeason;
  tags?: Maybe<PoeDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum PoeStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type PoeStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type PoeStructDocumentPayload = {
  __typename?: 'PoeStructDocumentPayload';
  data?: Maybe<PoeStructDocument>;
  error?: Maybe<PoeStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type PoeStructDocumentSetSeoPayload = {
  __typename?: 'PoeStructDocumentSetSeoPayload';
  data?: Maybe<PoeStructDocument>;
  error?: Maybe<PoeStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type PoeStructDocumentSetStatusPayload = {
  __typename?: 'PoeStructDocumentSetStatusPayload';
  data?: Maybe<PoeStructDocument>;
  error?: Maybe<PoeStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeStructDocumentUpdateInput = {
  document: Scalars['PoeStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type PoeStructDocumentUpdatePayload = {
  __typename?: 'PoeStructDocumentUpdatePayload';
  data?: Maybe<PoeStructDocument>;
  error?: Maybe<PoeStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type PoeTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'PoeTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<PoeDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: PoeTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type PoeTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'PoeTemplateDocumentData';
  buildVariants?: Maybe<PoeUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: PoeDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum PoeTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeTemplateDocumentInput = {
  type: Scalars['String'];
};

export type PoeTemplateDocumentPayload = {
  __typename?: 'PoeTemplateDocumentPayload';
  data?: Maybe<PoeTemplateDocument>;
  error?: Maybe<PoeTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeTinctures = PoeGameEntity & {
  __typename?: 'PoeTinctures';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeTincturesRequiredStats>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeTincturesStats>>;
  type?: Maybe<Scalars['String']>;
};

export type PoeTincturesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeTincturesRequiredStats = {
  __typename?: 'PoeTincturesRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeTincturesResult = {
  __typename?: 'PoeTincturesResult';
  data?: Maybe<Array<PoeTinctures>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeTincturesStats = {
  __typename?: 'PoeTincturesStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeUGDocumentBuildStat = {
  __typename?: 'PoeUGDocumentBuildStat';
  name: Scalars['String'];
  subStats?: Maybe<Array<PoeUGDocumentBuildStat>>;
  tags?: Maybe<Array<PoeUGDocumentBuildStatTag>>;
  value?: Maybe<Scalars['String']>;
};

export type PoeUGDocumentBuildStatGroup = {
  __typename?: 'PoeUGDocumentBuildStatGroup';
  /** Character, Charges, Defensive, etc */
  name: Scalars['String'];
  stats?: Maybe<Array<PoeUGDocumentBuildStat>>;
};

export type PoeUGDocumentBuildStatTag = {
  __typename?: 'PoeUGDocumentBuildStatTag';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type PoeUGDocumentBuildStats = {
  __typename?: 'PoeUGDocumentBuildStats';
  buildVariantTitle?: Maybe<Scalars['String']>;
  /** (sorting order and tag values are defined by /settings/stat_widget/config.json ngf settings) */
  groups?: Maybe<Array<PoeUGDocumentBuildStatGroup>>;
};

export type PoeUGDocumentBuildVariantPassiveTree = {
  __typename?: 'PoeUGDocumentBuildVariantPassiveTree';
  alternateAscendancyTree?: Maybe<PoeUGDocumentBuildVariantPassiveTreeNodes>;
  ascendancyTree?: Maybe<PoeUGDocumentBuildVariantPassiveTreeNodes>;
  jewels?: Maybe<Array<PoeUGDocumentBuildVariantPassiveTreeJewel>>;
  keystones?: Maybe<Array<PoeEntityObject>>;
  mainTree?: Maybe<PoeUGDocumentBuildVariantPassiveTreeNodes>;
  masteries?: Maybe<Array<PoeUGDocumentBuildVariantPassiveTreeMastery>>;
};

export type PoeUGDocumentBuildVariantPassiveTreeJewel = {
  __typename?: 'PoeUGDocumentBuildVariantPassiveTreeJewel';
  jewel?: Maybe<PoeEntityObject>;
  nodeSlug: Scalars['String'];
};

export type PoeUGDocumentBuildVariantPassiveTreeMastery = {
  __typename?: 'PoeUGDocumentBuildVariantPassiveTreeMastery';
  mastery?: Maybe<PoeEntityObject>;
  passiveSkillNode?: Maybe<PoeEntityObject>;
};

export type PoeUGDocumentBuildVariantPassiveTreeNodes = {
  __typename?: 'PoeUGDocumentBuildVariantPassiveTreeNodes';
  selectedSlugs?: Maybe<Array<Scalars['String']>>;
};

export type PoeUGDocumentBuildVariantSkillGem = {
  __typename?: 'PoeUGDocumentBuildVariantSkillGem';
  skillGemObject?: Maybe<PoeEntityObject>;
  slotSlug: Scalars['String'];
};

export type PoeUGDocumentBuildVariantSkillGemGroup = {
  __typename?: 'PoeUGDocumentBuildVariantSkillGemGroup';
  gems?: Maybe<Array<PoeUGDocumentBuildVariantSkillGem>>;
  label?: Maybe<Scalars['String']>;
  /** Helper field, PoeUGDocumentBuildVariantSkillGem.slotSlug's inside will always be identical */
  slotSlug?: Maybe<Scalars['String']>;
};

export type PoeUGDocumentBuildVariantSkillGems = {
  __typename?: 'PoeUGDocumentBuildVariantSkillGems';
  gemGroups?: Maybe<Array<PoeUGDocumentBuildVariantSkillGemGroup>>;
  /**
   * DEPRECATED: Use only if skills is empty
   * Gems contain data only about skill gems.
   * Widget requires also data about items, need to get it from genericBuilder
   * @deprecated Use only if `skills` is empty.
   */
  gems?: Maybe<Array<PoeUGDocumentBuildVariantSkillGem>>;
};

export type PoeUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'PoeUGDocumentGenericBuilder';
  slots?: Maybe<Array<PoeUGDocumentGenericBuilderSlot>>;
};

export type PoeUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'PoeUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<PoeEntityObject>;
  gameSlotSlug: Scalars['String'];
};

/** Additional data about an item received from another source than our static data */
export type PoeUGDocumentItem = {
  __typename?: 'PoeUGDocumentItem';
  explicitMods?: Maybe<Array<PoeUGDocumentItemDescription>>;
  implicitMods?: Maybe<Array<PoeUGDocumentItemDescription>>;
  /** Corrupted, Historic, anything else? */
  modifiers?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  /** Level, str, dex, int, etc */
  requirements?: Maybe<Array<PoeUGDocumentItemStat>>;
  /** Item level, quality, physical damage, armor, etc */
  stats?: Maybe<Array<PoeUGDocumentItemStat>>;
  subTitle?: Maybe<Scalars['String']>;
};

export type PoeUGDocumentItemDescription = {
  __typename?: 'PoeUGDocumentItemDescription';
  /** special modifiers e.g. crafted */
  modifiers?: Maybe<Array<Scalars['String']>>;
  /** main description */
  text: Scalars['String'];
};

/** Key-value pair for any item characteristic */
export type PoeUGDocumentItemStat = {
  __typename?: 'PoeUGDocumentItemStat';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type PoeUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'PoeUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<PoeDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: PoeUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<PoeDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type PoeUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'PoeUserGeneratedDocumentBuildVariant';
  genericBuilder: PoeUGDocumentGenericBuilder;
  id: Scalars['ID'];
  passiveTree?: Maybe<PoeUGDocumentBuildVariantPassiveTree>;
  skills?: Maybe<PoeUGDocumentBuildVariantSkillGems>;
};

export type PoeUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'PoeUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<PoeUserGeneratedDocumentBuildVariant>>;
};

export enum PoeUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type PoeUserGeneratedDocumentCreateInput = {
  document: Scalars['PoeUserGeneratedDocumentInputBase64Json'];
};

export type PoeUserGeneratedDocumentCreatePayload = {
  __typename?: 'PoeUserGeneratedDocumentCreatePayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'PoeUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<PoeUserGeneratedDocumentBuildVariants>;
  characterStats?: Maybe<PoeUGDocumentBuildStats>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  pobCode?: Maybe<Scalars['String']>;
  /** @deprecated Season functionality is no longer used */
  season: PoeDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum PoeUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type PoeUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type PoeUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type PoeUserGeneratedDocumentPayload = {
  __typename?: 'PoeUserGeneratedDocumentPayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type PoeUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'PoeUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type PoeUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type PoeUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'PoeUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type PoeUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'PoeUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type PoeUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'PoeUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type PoeUserGeneratedDocumentUpdateInput = {
  document: Scalars['PoeUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type PoeUserGeneratedDocumentUpdatePayload = {
  __typename?: 'PoeUserGeneratedDocumentUpdatePayload';
  data?: Maybe<PoeUserGeneratedDocument>;
  error?: Maybe<PoeUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type PoeUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type PoeWeapons = PoeGameEntity & {
  __typename?: 'PoeWeapons';
  baseItemId?: Maybe<Scalars['String']>;
  baseItemName?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  explicitMods?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  implicitMods?: Maybe<Array<Scalars['String']>>;
  isUnique?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  requiredStats?: Maybe<Array<PoeWeaponsRequiredStats>>;
  slug: Scalars['String'];
  stats?: Maybe<Array<PoeWeaponsStats>>;
  type?: Maybe<Scalars['String']>;
};

export type PoeWeaponsFilter = {
  baseItemId?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type PoeWeaponsRequiredStats = {
  __typename?: 'PoeWeaponsRequiredStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeWeaponsResult = {
  __typename?: 'PoeWeaponsResult';
  data?: Maybe<Array<PoeWeapons>>;
  error?: Maybe<PoeStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type PoeWeaponsStats = {
  __typename?: 'PoeWeaponsStats';
  keyword?: Maybe<PoeKeywords>;
  value?: Maybe<Scalars['String']>;
};

export type PoeWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'PoeWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<PoeDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: PoeWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<PoeDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type PoeWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'PoeWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: PoeEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum PoeWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type PoeWikiDocumentPayload = {
  __typename?: 'PoeWikiDocumentPayload';
  data?: Maybe<PoeWikiDocument>;
  error?: Maybe<PoeWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type PoeWikiDocumentSetSeoPayload = {
  __typename?: 'PoeWikiDocumentSetSeoPayload';
  data?: Maybe<PoeWikiDocument>;
  error?: Maybe<PoeWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum PoeWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type PoeWikiDocumentUpdateInput = {
  document: Scalars['PoeWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type PoeWikiDocumentUpdatePayload = {
  __typename?: 'PoeWikiDocumentUpdatePayload';
  data?: Maybe<PoeWikiDocument>;
  error?: Maybe<PoeWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type PoeWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type PoeWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type PreSearchInput = {
  game?: InputMaybe<Scalars['String']>;
};

export type PreSearchPayload = {
  __typename?: 'PreSearchPayload';
  popularQueries: Array<Scalars['String']>;
  requestId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  _stub?: Maybe<Scalars['String']>;
  accounts?: Maybe<AccountsQuery>;
  autocomplete: AutocompleteResponse;
  autocompleteAuthor: AutocompleteAuthorResponse;
  battlePass: BattlePassQuery;
  borderlands4: Borderlands4Query;
  challenge: ChallengeQuery;
  comments?: Maybe<CommentsQuery>;
  deadlock: DeadlockQuery;
  destiny?: Maybe<DestinyQuery>;
  destiny2Ngf: Destiny2NgfQuery;
  diablo4: Diablo4Query;
  eldenRingNightreign: EldenRingNightreignQuery;
  endfield: EndfieldQuery;
  enhancedSearch: EnhancedSearchResponse;
  exampleGame: ExampleGameQuery;
  gi: GiQuery;
  hades2: Hades2Query;
  lolNgf: LolNgfQuery;
  marathon: MarathonQuery;
  marvelRivals: MarvelRivalsQuery;
  meta: MetaQuery;
  mgp: MgpQuery;
  mhw: MhwQuery;
  mobaAchievement: MobaAchievementQuery;
  mobaEquipment: MobaEquipmentQuery;
  news: NewsQuery;
  notifications: NotificationsQuery;
  nte: NteQuery;
  overwatch: OverwatchQuery;
  poe: PoeQuery;
  poe2: Poe2Query;
  preSearch: PreSearchPayload;
  rewards: RewardQuery;
  riftbound: RiftboundQuery;
  search: SearchDocumentsResponse;
  sts2: Sts2Query;
  tft?: Maybe<TftQuery>;
  tftNgf: TftNgfQuery;
  theBazaar: TheBazaarQuery;
  treasury?: Maybe<TreasuryQuery>;
  valorantNgf: ValorantNgfQuery;
  wowfor: WowforQuery;
  xko: XkoQuery;
  zzz: ZzzQuery;
};

export type QueryautocompleteArgs = {
  input: AutocompleteRequestInput;
};

export type QueryautocompleteAuthorArgs = {
  input: AutocompleteAuthorRequestInput;
};

export type QueryenhancedSearchArgs = {
  input: EnhancedSearchInput;
};

export type QuerypreSearchArgs = {
  input: PreSearchInput;
};

export type QuerysearchArgs = {
  input: SearchRequestInput;
};

export enum RecommendedBattlePassError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type RecommendedBattlePassPayload = {
  __typename?: 'RecommendedBattlePassPayload';
  data?: Maybe<BattlePass>;
  error?: Maybe<RecommendedBattlePassError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum Region {
  ALL = 'ALL',
  BR = 'BR',
  EUNE = 'EUNE',
  EUW = 'EUW',
  JP = 'JP',
  KR = 'KR',
  LAN = 'LAN',
  LAS = 'LAS',
  ME = 'ME',
  NA = 'NA',
  OCE = 'OCE',
  PBE = 'PBE',
  PH = 'PH',
  RU = 'RU',
  SG = 'SG',
  TH = 'TH',
  TR = 'TR',
  TW = 'TW',
  UNKNOWN = 'UNKNOWN',
  VN = 'VN',
}

export type ResourceMeta = {
  __typename?: 'ResourceMeta';
  author: NgfDocumentAuthor;
  docId: Scalars['ID'];
  featuredSlug?: Maybe<Scalars['String']>;
  featuredStatus?: Maybe<Scalars['String']>;
  firstSeenAt: Scalars['DateTime'];
  game: Scalars['String'];
  lastCommentUpdatedAt?: Maybe<Scalars['DateTime']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  slugifiedName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
};

export type Reward = {
  __typename?: 'Reward';
  displayParams: RewardDisplayParams;
  id: Scalars['ID'];
  name: Scalars['String'];
  options?: Maybe<Array<RewardOption>>;
  processRule: RewardProcessRule;
  status: RewardStatus;
};

export type RewardAdminAlgorithmParamsInput = {
  probability?: InputMaybe<Scalars['Float']>;
};

export enum RewardAdminCodeSetListError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminCodeSetListPayload = {
  __typename?: 'RewardAdminCodeSetListPayload';
  data?: Maybe<Array<RewardCodeSet>>;
  error?: Maybe<RewardAdminCodeSetListError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum RewardAdminCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminCreateInput = {
  displayParams: RewardDisplayParamsInput;
  name: Scalars['String'];
  options?: InputMaybe<Array<RewardAdminToOptionInput>>;
  processRule: RewardAdminProcessRuleInput;
};

export enum RewardAdminCreateOptionError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminCreateOptionInput = {
  displayParams?: InputMaybe<RewardOptionDisplayParamsInput>;
  kind: RewardDropKind;
  notificationCampaignID?: InputMaybe<Scalars['Int']>;
  selectionRules: RewardDropSelectionRuleInput;
};

export type RewardAdminCreateOptionPayload = {
  __typename?: 'RewardAdminCreateOptionPayload';
  data?: Maybe<RewardOption>;
  error?: Maybe<RewardAdminCreateOptionError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type RewardAdminCreatePayload = {
  __typename?: 'RewardAdminCreatePayload';
  data?: Maybe<Reward>;
  error?: Maybe<RewardAdminCreateError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum RewardAdminDeleteOptionError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RewardAdminDeleteOptionInput = {
  id: Scalars['ID'];
};

export type RewardAdminDeleteOptionPayload = {
  __typename?: 'RewardAdminDeleteOptionPayload';
  error?: Maybe<RewardAdminDeleteOptionError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum RewardAdminEditError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminEditInput = {
  displayParams: RewardDisplayParamsInput;
  id: Scalars['ID'];
  name: Scalars['String'];
  options?: InputMaybe<Array<RewardAdminToOptionInput>>;
  processRule: RewardAdminProcessRuleInput;
};

export enum RewardAdminEditOptionError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminEditOptionInput = {
  displayParams?: InputMaybe<RewardOptionDisplayParamsInput>;
  id: Scalars['ID'];
  kind: RewardDropKind;
  notificationCampaignID?: InputMaybe<Scalars['Int']>;
  selectionRules: RewardDropSelectionRuleInput;
};

export type RewardAdminEditOptionPayload = {
  __typename?: 'RewardAdminEditOptionPayload';
  data?: Maybe<RewardOption>;
  error?: Maybe<RewardAdminEditOptionError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type RewardAdminEditPayload = {
  __typename?: 'RewardAdminEditPayload';
  data?: Maybe<Reward>;
  error?: Maybe<RewardAdminEditError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type RewardAdminGetInput = {
  id: Scalars['ID'];
};

export type RewardAdminListInput = {
  statuses?: InputMaybe<Array<RewardStatus>>;
};

export type RewardAdminListPayload = {
  __typename?: 'RewardAdminListPayload';
  data?: Maybe<Array<Reward>>;
  error?: Maybe<RewardAdminRewardsError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type RewardAdminMutation = {
  __typename?: 'RewardAdminMutation';
  createOption: RewardAdminCreateOptionPayload;
  createReward: RewardAdminCreatePayload;
  deleteOption: RewardAdminDeleteOptionPayload;
  editOption: RewardAdminEditOptionPayload;
  editReward: RewardAdminEditPayload;
};

export type RewardAdminMutationcreateOptionArgs = {
  input: RewardAdminCreateOptionInput;
};

export type RewardAdminMutationcreateRewardArgs = {
  input: RewardAdminCreateInput;
};

export type RewardAdminMutationdeleteOptionArgs = {
  input: RewardAdminDeleteOptionInput;
};

export type RewardAdminMutationeditOptionArgs = {
  input: RewardAdminEditOptionInput;
};

export type RewardAdminMutationeditRewardArgs = {
  input: RewardAdminEditInput;
};

export enum RewardAdminOptionsError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminOptionsPayload = {
  __typename?: 'RewardAdminOptionsPayload';
  data?: Maybe<Array<RewardOption>>;
  error?: Maybe<RewardAdminOptionsError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export type RewardAdminProcessRuleInput = {
  algorithm: RewardProcessAlgorithm;
};

export type RewardAdminQuery = {
  __typename?: 'RewardAdminQuery';
  codeSets: RewardAdminCodeSetListPayload;
  options: RewardAdminOptionsPayload;
  reward: RewardAdminRewardPayload;
  rewards: RewardAdminListPayload;
};

export type RewardAdminQueryrewardArgs = {
  input: RewardAdminGetInput;
};

export type RewardAdminQueryrewardsArgs = {
  input: RewardAdminListInput;
};

export enum RewardAdminRewardError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminRewardPayload = {
  __typename?: 'RewardAdminRewardPayload';
  data?: Maybe<Reward>;
  error?: Maybe<RewardAdminRewardError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum RewardAdminRewardsError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardAdminToOptionInput = {
  algorithmParams?: InputMaybe<RewardAdminAlgorithmParamsInput>;
  optionID: Scalars['ID'];
  order: Scalars['Int'];
};

export enum RewardAnimation {
  CONFETTI = 'CONFETTI',
  SLOTS = 'SLOTS',
}

export type RewardBoosterOption = RewardOption & {
  __typename?: 'RewardBoosterOption';
  algorithmParams?: Maybe<RewardOptionAlgorithmParams>;
  boosterRule: RewardBoosterRule;
  displayParams?: Maybe<RewardOptionDisplayParams>;
  id: Scalars['ID'];
  kind: RewardDropKind;
  notificationCampaignID?: Maybe<Scalars['Int']>;
};

export type RewardBoosterRule = {
  __typename?: 'RewardBoosterRule';
  durationHours: Scalars['Int'];
  multiplier: Scalars['Float'];
};

export type RewardClaimedResult = {
  id: Scalars['ID'];
  option?: Maybe<RewardOption>;
};

export type RewardClaimedResultBooster = RewardClaimedResult & {
  __typename?: 'RewardClaimedResultBooster';
  expiredAt: Scalars['RewardDateTime'];
  id: Scalars['ID'];
  multiplier: Scalars['Float'];
  option?: Maybe<RewardBoosterOption>;
};

export type RewardClaimedResultCode = RewardClaimedResult & {
  __typename?: 'RewardClaimedResultCode';
  code: Scalars['String'];
  id: Scalars['ID'];
  option?: Maybe<RewardCodeOption>;
};

export type RewardClaimedResultEquipment = RewardClaimedResult & {
  __typename?: 'RewardClaimedResultEquipment';
  entity?: Maybe<MobaEquipmentEntityObject>;
  id: Scalars['ID'];
  option?: Maybe<RewardEquipmentOption>;
};

export type RewardClaimedResultFreshPlus = RewardClaimedResult & {
  __typename?: 'RewardClaimedResultFreshPlus';
  expiredAt: Scalars['RewardDateTime'];
  id: Scalars['ID'];
  option?: Maybe<RewardFreshPlusOption>;
};

export type RewardCodeOption = RewardOption & {
  __typename?: 'RewardCodeOption';
  algorithmParams?: Maybe<RewardOptionAlgorithmParams>;
  codeRules?: Maybe<Array<RewardCodeSelectionRule>>;
  displayParams?: Maybe<RewardOptionDisplayParams>;
  id: Scalars['ID'];
  kind: RewardDropKind;
  notificationCampaignID?: Maybe<Scalars['Int']>;
};

export type RewardCodeSelectionRule = {
  __typename?: 'RewardCodeSelectionRule';
  setID: Scalars['String'];
};

export type RewardCodeSet = {
  __typename?: 'RewardCodeSet';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RewardDisplayParams = {
  __typename?: 'RewardDisplayParams';
  animation?: Maybe<RewardAnimation>;
  lootBoxVariant?: Maybe<RewardLootBoxVariant>;
};

export type RewardDisplayParamsInput = {
  animation?: InputMaybe<RewardAnimation>;
  lootBoxVariant?: InputMaybe<RewardLootBoxVariant>;
};

export type RewardDropBoosterInput = {
  durationHours: Scalars['Int'];
  multiplier: Scalars['Float'];
};

export type RewardDropCodeSelectionRuleInput = {
  setID: Scalars['ID'];
};

export type RewardDropEquipmentSelectionRuleInput = {
  objects?: InputMaybe<Array<RewardEquipmentSelectedObjectInput>>;
};

export type RewardDropFreshPlusRuleInput = {
  durationHours: Scalars['Int'];
};

export enum RewardDropKind {
  BOOSTER = 'BOOSTER',
  CODE = 'CODE',
  EQUIPMENT = 'EQUIPMENT',
  FRESH_PLUS = 'FRESH_PLUS',
}

export type RewardDropSelectionRuleInput = {
  boosterRule?: InputMaybe<RewardDropBoosterInput>;
  codeRules?: InputMaybe<Array<RewardDropCodeSelectionRuleInput>>;
  equipmentRules?: InputMaybe<Array<RewardDropEquipmentSelectionRuleInput>>;
  freshPlusRule?: InputMaybe<RewardDropFreshPlusRuleInput>;
};

export type RewardEquipmentOption = RewardOption & {
  __typename?: 'RewardEquipmentOption';
  algorithmParams?: Maybe<RewardOptionAlgorithmParams>;
  displayParams?: Maybe<RewardOptionDisplayParams>;
  equipmentRules?: Maybe<Array<RewardEquipmentSelectionRule>>;
  id: Scalars['ID'];
  kind: RewardDropKind;
  notificationCampaignID?: Maybe<Scalars['Int']>;
};

export type RewardEquipmentSelectedObject = {
  __typename?: 'RewardEquipmentSelectedObject';
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type RewardEquipmentSelectedObjectInput = {
  slug: Scalars['String'];
  type: Scalars['String'];
};

export type RewardEquipmentSelectionRule = {
  __typename?: 'RewardEquipmentSelectionRule';
  objects?: Maybe<Array<RewardEquipmentSelectedObject>>;
};

export type RewardFreshPlusOption = RewardOption & {
  __typename?: 'RewardFreshPlusOption';
  algorithmParams?: Maybe<RewardOptionAlgorithmParams>;
  displayParams?: Maybe<RewardOptionDisplayParams>;
  freshPlusRule: RewardFreshPlusRule;
  id: Scalars['ID'];
  kind: RewardDropKind;
  notificationCampaignID?: Maybe<Scalars['Int']>;
};

export type RewardFreshPlusRule = {
  __typename?: 'RewardFreshPlusRule';
  durationHours: Scalars['Int'];
};

export enum RewardGetError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RewardGetInput = {
  id: Scalars['ID'];
};

export type RewardGetPayload = {
  __typename?: 'RewardGetPayload';
  data?: Maybe<Reward>;
  error?: Maybe<RewardGetError>;
  errorMsg?: Maybe<Scalars['String']>;
};

export enum RewardLootBoxVariant {
  BRONZE = 'BRONZE',
  GOLD = 'GOLD',
  PLATINUM = 'PLATINUM',
}

export type RewardMutation = {
  __typename?: 'RewardMutation';
  admin?: Maybe<RewardAdminMutation>;
  id: Scalars['ID'];
};

export type RewardOption = {
  algorithmParams?: Maybe<RewardOptionAlgorithmParams>;
  displayParams?: Maybe<RewardOptionDisplayParams>;
  id: Scalars['ID'];
  kind: RewardDropKind;
  notificationCampaignID?: Maybe<Scalars['Int']>;
};

export type RewardOptionAlgorithmParams = {
  __typename?: 'RewardOptionAlgorithmParams';
  probability?: Maybe<Scalars['Float']>;
};

export type RewardOptionDisplayParams = {
  __typename?: 'RewardOptionDisplayParams';
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type RewardOptionDisplayParamsInput = {
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum RewardProcessAlgorithm {
  FIRST_AVAILABLE = 'FIRST_AVAILABLE',
  LOOT_BOX = 'LOOT_BOX',
  SELECT = 'SELECT',
}

export type RewardProcessRule = {
  __typename?: 'RewardProcessRule';
  algorithm: RewardProcessAlgorithm;
};

export type RewardQuery = {
  __typename?: 'RewardQuery';
  admin?: Maybe<RewardAdminQuery>;
  id: Scalars['ID'];
  reward: RewardGetPayload;
};

export type RewardQueryrewardArgs = {
  input: RewardGetInput;
};

export enum RewardStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export type RiftboundBattlefields = RiftboundGameEntity & {
  __typename?: 'RiftboundBattlefields';
  cardType?: Maybe<Array<Scalars['String']>>;
  collectorNumber?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Scalars['String']>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  illustrationUrl?: Maybe<Scalars['String']>;
  illustrator?: Maybe<Array<Scalars['String']>>;
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orientation?: Maybe<Scalars['String']>;
  publicCode?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  recordType?: Maybe<Array<Scalars['String']>>;
  set?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stats?: Maybe<Array<RiftboundBattlefieldsStats>>;
};

export type RiftboundBattlefieldsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type RiftboundBattlefieldsResult = {
  __typename?: 'RiftboundBattlefieldsResult';
  data?: Maybe<Array<RiftboundBattlefields>>;
  error?: Maybe<RiftboundStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type RiftboundBattlefieldsStats = {
  __typename?: 'RiftboundBattlefieldsStats';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RiftboundCards = RiftboundGameEntity & {
  __typename?: 'RiftboundCards';
  cardType?: Maybe<Array<Scalars['String']>>;
  collectorNumber?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Scalars['String']>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  illustrationUrl?: Maybe<Scalars['String']>;
  illustrator?: Maybe<Array<Scalars['String']>>;
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orientation?: Maybe<Scalars['String']>;
  publicCode?: Maybe<Scalars['String']>;
  rarity?: Maybe<Scalars['String']>;
  recordType?: Maybe<Array<Scalars['String']>>;
  set?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  stats?: Maybe<Array<RiftboundCardsStats>>;
  superType?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type RiftboundCardsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type RiftboundCardsResult = {
  __typename?: 'RiftboundCardsResult';
  data?: Maybe<Array<RiftboundCards>>;
  error?: Maybe<RiftboundStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type RiftboundCardsStats = {
  __typename?: 'RiftboundCardsStats';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RiftboundDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'RiftboundDocumentCmWidgetV1';
  data: RiftboundDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type RiftboundDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'RiftboundDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type RiftboundDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | RiftboundDocumentCmWidgetV1;

export type RiftboundDocumentSeason = NgfDocumentSeason & {
  __typename?: 'RiftboundDocumentSeason';
  slug: Scalars['String'];
};

export type RiftboundDocumentTags = NgfDocumentTags & {
  __typename?: 'RiftboundDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type RiftboundDocumentsMutation = {
  __typename?: 'RiftboundDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: RiftboundStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: RiftboundStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: RiftboundStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: RiftboundStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: RiftboundUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: RiftboundUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: RiftboundUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: RiftboundUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: RiftboundUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: RiftboundUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: RiftboundWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: RiftboundWikiDocumentUpdatePayload;
};

export type RiftboundDocumentsMutationstructDocumentCreateArgs = {
  input: RiftboundStructDocumentCreateInput;
};

export type RiftboundDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type RiftboundDocumentsMutationstructDocumentSetStatusArgs = {
  input: RiftboundStructDocumentSetStatusInput;
};

export type RiftboundDocumentsMutationstructDocumentUpdateArgs = {
  input: RiftboundStructDocumentUpdateInput;
};

export type RiftboundDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: RiftboundUserGeneratedDocumentCreateInput;
};

export type RiftboundDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: RiftboundUserGeneratedDocumentSetFavoriteInput;
};

export type RiftboundDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: RiftboundUserGeneratedDocumentSetFeaturedInput;
};

export type RiftboundDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type RiftboundDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: RiftboundUserGeneratedDocumentSetStatusInput;
};

export type RiftboundDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: RiftboundUserGeneratedDocumentUpdateInput;
};

export type RiftboundDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type RiftboundDocumentsMutationwikiDocumentUpdateArgs = {
  input: RiftboundWikiDocumentUpdateInput;
};

export type RiftboundDocumentsQuery = {
  __typename?: 'RiftboundDocumentsQuery';
  previewDocumentContent: RiftboundPreviewDocumentContentPayload;
  structDocumentBySlug: RiftboundStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: RiftboundUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: RiftboundUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: RiftboundUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: RiftboundUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: RiftboundTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: RiftboundWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type RiftboundDocumentsQuerypreviewDocumentContentArgs = {
  input: RiftboundPreviewDocumentContentInput;
};

export type RiftboundDocumentsQuerystructDocumentBySlugArgs = {
  input: RiftboundStructDocumentInputBySlug;
};

export type RiftboundDocumentsQuerystructDocumentsArgs = {
  input: RiftboundStructDocumentsInput;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: RiftboundUserGeneratedDocumentInputById;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: RiftboundUserGeneratedDocumentInputBySlug;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: RiftboundTemplateDocumentInput;
};

export type RiftboundDocumentsQueryuserGeneratedDocumentsArgs = {
  input: RiftboundUserGeneratedDocumentsListInput;
  page: RiftboundUserGeneratedDocumentsListPage;
};

export type RiftboundDocumentsQuerywikiDocumentArgs = {
  input: RiftboundWikiDocumentInput;
};

export type RiftboundDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<RiftboundWikiDocumentsListInput>;
  page: RiftboundWikiDocumentsListPage;
};

export enum RiftboundEntitiesEnum {
  battlefields = 'battlefields',
  cards = 'cards',
  version = 'version',
}

export type RiftboundEntityObject = NGFEntityObject & {
  __typename?: 'RiftboundEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<RiftboundGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type RiftboundGameEntity = {
  slug: Scalars['String'];
};

export type RiftboundMutation = {
  __typename?: 'RiftboundMutation';
  documents?: Maybe<RiftboundDocumentsMutation>;
  id: Scalars['ID'];
};

export enum RiftboundPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundPreviewDocumentContentInput = {
  content: Scalars['RiftboundDocumentContentInputBase64Json'];
};

export type RiftboundPreviewDocumentContentPayload = {
  __typename?: 'RiftboundPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<RiftboundDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<RiftboundPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundProfile = NgfProfile & {
  __typename?: 'RiftboundProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type RiftboundProfileuserGeneratedDocumentsArgs = {
  input: RiftboundUserGeneratedDocumentsListInput;
  page: RiftboundUserGeneratedDocumentsListPage;
};

export type RiftboundProfilePayload = {
  __typename?: 'RiftboundProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<RiftboundProfile>;
};

export type RiftboundProfilesQuery = {
  __typename?: 'RiftboundProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: RiftboundProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type RiftboundProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type RiftboundQuery = {
  __typename?: 'RiftboundQuery';
  documents?: Maybe<RiftboundDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<RiftboundProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<RiftboundStaticDataQuery>;
};

export enum RiftboundStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type RiftboundStaticDataGroups = {
  __typename?: 'RiftboundStaticDataGroups';
  battlefields: RiftboundBattlefieldsResult;
  cards: RiftboundCardsResult;
  version: RiftboundVersionResult;
};

export type RiftboundStaticDataGroupsbattlefieldsArgs = {
  filter?: InputMaybe<RiftboundBattlefieldsFilter>;
};

export type RiftboundStaticDataGroupscardsArgs = {
  filter?: InputMaybe<RiftboundCardsFilter>;
};

export type RiftboundStaticDataGroupsversionArgs = {
  filter?: InputMaybe<RiftboundVersionFilter>;
};

export type RiftboundStaticDataQuery = {
  __typename?: 'RiftboundStaticDataQuery';
  groups: RiftboundStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type RiftboundStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'RiftboundStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<RiftboundDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: RiftboundStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum RiftboundStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type RiftboundStructDocumentCreateInput = {
  document: Scalars['RiftboundStructDocumentInputBase64Json'];
};

export type RiftboundStructDocumentCreatePayload = {
  __typename?: 'RiftboundStructDocumentCreatePayload';
  data?: Maybe<RiftboundStructDocument>;
  error?: Maybe<RiftboundStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundStructDocumentData = NgfStructDocumentData & {
  __typename?: 'RiftboundStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: RiftboundDocumentSeason;
  tags?: Maybe<RiftboundDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum RiftboundStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type RiftboundStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type RiftboundStructDocumentPayload = {
  __typename?: 'RiftboundStructDocumentPayload';
  data?: Maybe<RiftboundStructDocument>;
  error?: Maybe<RiftboundStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RiftboundStructDocumentSetSeoPayload = {
  __typename?: 'RiftboundStructDocumentSetSeoPayload';
  data?: Maybe<RiftboundStructDocument>;
  error?: Maybe<RiftboundStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type RiftboundStructDocumentSetStatusPayload = {
  __typename?: 'RiftboundStructDocumentSetStatusPayload';
  data?: Maybe<RiftboundStructDocument>;
  error?: Maybe<RiftboundStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundStructDocumentUpdateInput = {
  document: Scalars['RiftboundStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type RiftboundStructDocumentUpdatePayload = {
  __typename?: 'RiftboundStructDocumentUpdatePayload';
  data?: Maybe<RiftboundStructDocument>;
  error?: Maybe<RiftboundStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type RiftboundTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'RiftboundTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<RiftboundDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: RiftboundTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type RiftboundTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'RiftboundTemplateDocumentData';
  buildVariants?: Maybe<RiftboundUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: RiftboundDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum RiftboundTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundTemplateDocumentInput = {
  type: Scalars['String'];
};

export type RiftboundTemplateDocumentPayload = {
  __typename?: 'RiftboundTemplateDocumentPayload';
  data?: Maybe<RiftboundTemplateDocument>;
  error?: Maybe<RiftboundTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'RiftboundUGDocumentGenericBuilder';
  slots?: Maybe<Array<RiftboundUGDocumentGenericBuilderSlot>>;
};

export type RiftboundUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'RiftboundUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<RiftboundEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type RiftboundUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'RiftboundUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<RiftboundDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: RiftboundUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<RiftboundDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type RiftboundUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'RiftboundUserGeneratedDocumentBuildVariant';
  genericBuilder: RiftboundUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type RiftboundUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'RiftboundUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<RiftboundUserGeneratedDocumentBuildVariant>>;
};

export enum RiftboundUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type RiftboundUserGeneratedDocumentCreateInput = {
  document: Scalars['RiftboundUserGeneratedDocumentInputBase64Json'];
};

export type RiftboundUserGeneratedDocumentCreatePayload = {
  __typename?: 'RiftboundUserGeneratedDocumentCreatePayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'RiftboundUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<RiftboundUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: RiftboundDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum RiftboundUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type RiftboundUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type RiftboundUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type RiftboundUserGeneratedDocumentPayload = {
  __typename?: 'RiftboundUserGeneratedDocumentPayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type RiftboundUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'RiftboundUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type RiftboundUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type RiftboundUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'RiftboundUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RiftboundUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'RiftboundUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type RiftboundUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'RiftboundUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type RiftboundUserGeneratedDocumentUpdateInput = {
  document: Scalars['RiftboundUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type RiftboundUserGeneratedDocumentUpdatePayload = {
  __typename?: 'RiftboundUserGeneratedDocumentUpdatePayload';
  data?: Maybe<RiftboundUserGeneratedDocument>;
  error?: Maybe<RiftboundUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type RiftboundUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type RiftboundVersion = RiftboundGameEntity & {
  __typename?: 'RiftboundVersion';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  number?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type RiftboundVersionFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type RiftboundVersionResult = {
  __typename?: 'RiftboundVersionResult';
  data?: Maybe<Array<RiftboundVersion>>;
  error?: Maybe<RiftboundStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type RiftboundWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'RiftboundWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<RiftboundDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: RiftboundWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<RiftboundDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type RiftboundWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'RiftboundWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: RiftboundEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum RiftboundWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type RiftboundWikiDocumentPayload = {
  __typename?: 'RiftboundWikiDocumentPayload';
  data?: Maybe<RiftboundWikiDocument>;
  error?: Maybe<RiftboundWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type RiftboundWikiDocumentSetSeoPayload = {
  __typename?: 'RiftboundWikiDocumentSetSeoPayload';
  data?: Maybe<RiftboundWikiDocument>;
  error?: Maybe<RiftboundWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum RiftboundWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type RiftboundWikiDocumentUpdateInput = {
  document: Scalars['RiftboundWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type RiftboundWikiDocumentUpdatePayload = {
  __typename?: 'RiftboundWikiDocumentUpdatePayload';
  data?: Maybe<RiftboundWikiDocument>;
  error?: Maybe<RiftboundWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RiftboundWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type RiftboundWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type SearchDocument = {
  __typename?: 'SearchDocument';
  authorName?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  docType?: Maybe<Scalars['String']>;
  featured: Scalars['Boolean'];
  game?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  originalTags?: Maybe<Array<OriginalTag>>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['Int64'];
  url: Scalars['String'];
};

export type SearchDocumentsResponse = {
  __typename?: 'SearchDocumentsResponse';
  documents: Array<SearchDocument>;
  requestId: Scalars['String'];
};

export type SearchRequestInput = {
  authors?: InputMaybe<Array<Scalars['String']>>;
  docType?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
};

export type SideResults = {
  __typename?: 'SideResults';
  authors: Array<AuthorSuggestion>;
};

/**
 * A short-lived signal that triggers a UI state change on the frontend (counter,
 * status refresh, etc.). Never shown to the user. Acked by the frontend after
 * processing.
 */
export type Signal = {
  __typename?: 'Signal';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /**
   * Typed body, resolved to a concrete NotificationPayload via `type`. Null when
   * the event `type` has no registered payload schema yet (see payload/).
   */
  payload?: Maybe<NotificationPayload>;
  type: Scalars['String'];
};

export type SignalsPage = {
  __typename?: 'SignalsPage';
  error?: Maybe<SignalsPageError>;
  errorMessage?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Signal>>;
  nextCursor?: Maybe<Scalars['String']>;
};

export enum SignalsPageError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type SpecificWidgets = {
  __typename?: 'SpecificWidgets';
  NgfDocumentUgWidgetBuilderV1?: Maybe<BuilderV1Settings>;
};

export enum StaticDataEntityStatusInput {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
  DEPRECATED = 'DEPRECATED',
}

export type StaticDataMetadata = {
  __typename?: 'StaticDataMetadata';
  dataVersion: Scalars['String'];
  schemaVersion: Scalars['String'];
};

export type Sts2Buffs = Sts2GameEntity & {
  __typename?: 'Sts2Buffs';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Sts2BuffsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type Sts2BuffsResult = {
  __typename?: 'Sts2BuffsResult';
  data?: Maybe<Array<Sts2Buffs>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type Sts2Cards = Sts2GameEntity & {
  __typename?: 'Sts2Cards';
  character?: Maybe<Sts2Characters>;
  color?: Maybe<Sts2Colors>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  energy?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  tier?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type Sts2CardsFilter = {
  energy?: InputMaybe<OneOfString>;
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  rarity?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
  tier?: InputMaybe<OneOfString>;
  type?: InputMaybe<OneOfString>;
  variant?: InputMaybe<OneOfString>;
};

export type Sts2CardsResult = {
  __typename?: 'Sts2CardsResult';
  data?: Maybe<Array<Sts2Cards>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type Sts2Characters = Sts2GameEntity & {
  __typename?: 'Sts2Characters';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  hp?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type Sts2CharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type Sts2CharactersResult = {
  __typename?: 'Sts2CharactersResult';
  data?: Maybe<Array<Sts2Characters>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type Sts2Colors = Sts2GameEntity & {
  __typename?: 'Sts2Colors';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Sts2ColorsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type Sts2ColorsResult = {
  __typename?: 'Sts2ColorsResult';
  data?: Maybe<Array<Sts2Colors>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type Sts2DocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'Sts2DocumentCmWidgetV1';
  data: Sts2DocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type Sts2DocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'Sts2DocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type Sts2DocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | Sts2DocumentCmWidgetV1;

export type Sts2DocumentSeason = NgfDocumentSeason & {
  __typename?: 'Sts2DocumentSeason';
  slug: Scalars['String'];
};

export type Sts2DocumentTags = NgfDocumentTags & {
  __typename?: 'Sts2DocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type Sts2DocumentsMutation = {
  __typename?: 'Sts2DocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: Sts2StructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: Sts2StructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: Sts2StructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: Sts2StructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: Sts2UserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: Sts2UserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: Sts2UserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: Sts2UserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: Sts2UserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: Sts2UserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: Sts2WikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: Sts2WikiDocumentUpdatePayload;
};

export type Sts2DocumentsMutationstructDocumentCreateArgs = {
  input: Sts2StructDocumentCreateInput;
};

export type Sts2DocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Sts2DocumentsMutationstructDocumentSetStatusArgs = {
  input: Sts2StructDocumentSetStatusInput;
};

export type Sts2DocumentsMutationstructDocumentUpdateArgs = {
  input: Sts2StructDocumentUpdateInput;
};

export type Sts2DocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: Sts2UserGeneratedDocumentCreateInput;
};

export type Sts2DocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: Sts2UserGeneratedDocumentSetFavoriteInput;
};

export type Sts2DocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: Sts2UserGeneratedDocumentSetFeaturedInput;
};

export type Sts2DocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type Sts2DocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: Sts2UserGeneratedDocumentSetStatusInput;
};

export type Sts2DocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: Sts2UserGeneratedDocumentUpdateInput;
};

export type Sts2DocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type Sts2DocumentsMutationwikiDocumentUpdateArgs = {
  input: Sts2WikiDocumentUpdateInput;
};

export type Sts2DocumentsQuery = {
  __typename?: 'Sts2DocumentsQuery';
  previewDocumentContent: Sts2PreviewDocumentContentPayload;
  structDocumentBySlug: Sts2StructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: Sts2UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: Sts2UserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: Sts2UserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: Sts2UserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: Sts2TemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: Sts2WikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type Sts2DocumentsQuerypreviewDocumentContentArgs = {
  input: Sts2PreviewDocumentContentInput;
};

export type Sts2DocumentsQuerystructDocumentBySlugArgs = {
  input: Sts2StructDocumentInputBySlug;
};

export type Sts2DocumentsQuerystructDocumentsArgs = {
  input: Sts2StructDocumentsInput;
};

export type Sts2DocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: Sts2UserGeneratedDocumentInputById;
};

export type Sts2DocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: Sts2UserGeneratedDocumentInputBySlug;
};

export type Sts2DocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type Sts2DocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type Sts2DocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type Sts2DocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type Sts2DocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: Sts2TemplateDocumentInput;
};

export type Sts2DocumentsQueryuserGeneratedDocumentsArgs = {
  input: Sts2UserGeneratedDocumentsListInput;
  page: Sts2UserGeneratedDocumentsListPage;
};

export type Sts2DocumentsQuerywikiDocumentArgs = {
  input: Sts2WikiDocumentInput;
};

export type Sts2DocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<Sts2WikiDocumentsListInput>;
  page: Sts2WikiDocumentsListPage;
};

export enum Sts2EntitiesEnum {
  buffs = 'buffs',
  cards = 'cards',
  characters = 'characters',
  colors = 'colors',
  keywords = 'keywords',
  potions = 'potions',
  relics = 'relics',
}

export type Sts2EntityObject = NGFEntityObject & {
  __typename?: 'Sts2EntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<Sts2GameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Sts2GameEntity = {
  slug: Scalars['String'];
};

export type Sts2Keywords = Sts2GameEntity & {
  __typename?: 'Sts2Keywords';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type Sts2KeywordsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type Sts2KeywordsResult = {
  __typename?: 'Sts2KeywordsResult';
  data?: Maybe<Array<Sts2Keywords>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type Sts2Mutation = {
  __typename?: 'Sts2Mutation';
  documents?: Maybe<Sts2DocumentsMutation>;
  id: Scalars['ID'];
};

export type Sts2Potions = Sts2GameEntity & {
  __typename?: 'Sts2Potions';
  character?: Maybe<Sts2Characters>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type Sts2PotionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  rarity?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type Sts2PotionsResult = {
  __typename?: 'Sts2PotionsResult';
  data?: Maybe<Array<Sts2Potions>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum Sts2PreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2PreviewDocumentContentInput = {
  content: Scalars['Sts2DocumentContentInputBase64Json'];
};

export type Sts2PreviewDocumentContentPayload = {
  __typename?: 'Sts2PreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<Sts2DocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<Sts2PreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2Profile = NgfProfile & {
  __typename?: 'Sts2Profile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type Sts2ProfileuserGeneratedDocumentsArgs = {
  input: Sts2UserGeneratedDocumentsListInput;
  page: Sts2UserGeneratedDocumentsListPage;
};

export type Sts2ProfilePayload = {
  __typename?: 'Sts2ProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<Sts2Profile>;
};

export type Sts2ProfilesQuery = {
  __typename?: 'Sts2ProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: Sts2ProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type Sts2ProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type Sts2Query = {
  __typename?: 'Sts2Query';
  documents?: Maybe<Sts2DocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<Sts2ProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<Sts2StaticDataQuery>;
};

export type Sts2Relics = Sts2GameEntity & {
  __typename?: 'Sts2Relics';
  character?: Maybe<Sts2Characters>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type Sts2RelicsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  rarity?: InputMaybe<OneOfString>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type Sts2RelicsResult = {
  __typename?: 'Sts2RelicsResult';
  data?: Maybe<Array<Sts2Relics>>;
  error?: Maybe<Sts2StaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum Sts2StaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type Sts2StaticDataGroups = {
  __typename?: 'Sts2StaticDataGroups';
  buffs: Sts2BuffsResult;
  cards: Sts2CardsResult;
  characters: Sts2CharactersResult;
  colors: Sts2ColorsResult;
  keywords: Sts2KeywordsResult;
  potions: Sts2PotionsResult;
  relics: Sts2RelicsResult;
};

export type Sts2StaticDataGroupsbuffsArgs = {
  filter?: InputMaybe<Sts2BuffsFilter>;
};

export type Sts2StaticDataGroupscardsArgs = {
  filter?: InputMaybe<Sts2CardsFilter>;
};

export type Sts2StaticDataGroupscharactersArgs = {
  filter?: InputMaybe<Sts2CharactersFilter>;
};

export type Sts2StaticDataGroupscolorsArgs = {
  filter?: InputMaybe<Sts2ColorsFilter>;
};

export type Sts2StaticDataGroupskeywordsArgs = {
  filter?: InputMaybe<Sts2KeywordsFilter>;
};

export type Sts2StaticDataGroupspotionsArgs = {
  filter?: InputMaybe<Sts2PotionsFilter>;
};

export type Sts2StaticDataGroupsrelicsArgs = {
  filter?: InputMaybe<Sts2RelicsFilter>;
};

export type Sts2StaticDataQuery = {
  __typename?: 'Sts2StaticDataQuery';
  groups: Sts2StaticDataGroups;
  metadata: StaticDataMetadata;
};

export type Sts2StructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'Sts2StructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Sts2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Sts2StructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum Sts2StructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Sts2StructDocumentCreateInput = {
  document: Scalars['Sts2StructDocumentInputBase64Json'];
};

export type Sts2StructDocumentCreatePayload = {
  __typename?: 'Sts2StructDocumentCreatePayload';
  data?: Maybe<Sts2StructDocument>;
  error?: Maybe<Sts2StructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2StructDocumentData = NgfStructDocumentData & {
  __typename?: 'Sts2StructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Sts2DocumentSeason;
  tags?: Maybe<Sts2DocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum Sts2StructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Sts2StructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Sts2StructDocumentPayload = {
  __typename?: 'Sts2StructDocumentPayload';
  data?: Maybe<Sts2StructDocument>;
  error?: Maybe<Sts2StructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2StructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Sts2StructDocumentSetSeoPayload = {
  __typename?: 'Sts2StructDocumentSetSeoPayload';
  data?: Maybe<Sts2StructDocument>;
  error?: Maybe<Sts2StructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2StructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2StructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type Sts2StructDocumentSetStatusPayload = {
  __typename?: 'Sts2StructDocumentSetStatusPayload';
  data?: Maybe<Sts2StructDocument>;
  error?: Maybe<Sts2StructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2StructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2StructDocumentUpdateInput = {
  document: Scalars['Sts2StructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Sts2StructDocumentUpdatePayload = {
  __typename?: 'Sts2StructDocumentUpdatePayload';
  data?: Maybe<Sts2StructDocument>;
  error?: Maybe<Sts2StructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2StructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type Sts2TemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'Sts2TemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<Sts2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: Sts2TemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type Sts2TemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'Sts2TemplateDocumentData';
  buildVariants?: Maybe<Sts2UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Sts2DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Sts2TemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2TemplateDocumentInput = {
  type: Scalars['String'];
};

export type Sts2TemplateDocumentPayload = {
  __typename?: 'Sts2TemplateDocumentPayload';
  data?: Maybe<Sts2TemplateDocument>;
  error?: Maybe<Sts2TemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2UGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'Sts2UGDocumentGenericBuilder';
  slots?: Maybe<Array<Sts2UGDocumentGenericBuilderSlot>>;
};

export type Sts2UGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'Sts2UGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<Sts2EntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type Sts2UserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'Sts2UserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<Sts2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Sts2UserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<Sts2DocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Sts2UserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'Sts2UserGeneratedDocumentBuildVariant';
  genericBuilder: Sts2UGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type Sts2UserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'Sts2UserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<Sts2UserGeneratedDocumentBuildVariant>>;
};

export enum Sts2UserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Sts2UserGeneratedDocumentCreateInput = {
  document: Scalars['Sts2UserGeneratedDocumentInputBase64Json'];
};

export type Sts2UserGeneratedDocumentCreatePayload = {
  __typename?: 'Sts2UserGeneratedDocumentCreatePayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2UserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'Sts2UserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<Sts2UserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: Sts2DocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum Sts2UserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type Sts2UserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Sts2UserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Sts2UserGeneratedDocumentPayload = {
  __typename?: 'Sts2UserGeneratedDocumentPayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2UserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2UserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type Sts2UserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'Sts2UserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2UserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Sts2UserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type Sts2UserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'Sts2UserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2UserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Sts2UserGeneratedDocumentSetSeoPayload = {
  __typename?: 'Sts2UserGeneratedDocumentSetSeoPayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2UserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2UserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type Sts2UserGeneratedDocumentSetStatusPayload = {
  __typename?: 'Sts2UserGeneratedDocumentSetStatusPayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2UserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type Sts2UserGeneratedDocumentUpdateInput = {
  document: Scalars['Sts2UserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type Sts2UserGeneratedDocumentUpdatePayload = {
  __typename?: 'Sts2UserGeneratedDocumentUpdatePayload';
  data?: Maybe<Sts2UserGeneratedDocument>;
  error?: Maybe<Sts2UserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2UserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type Sts2UserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Sts2WikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'Sts2WikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<Sts2DocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: Sts2WikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<Sts2DocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type Sts2WikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'Sts2WikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: Sts2EntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum Sts2WikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2WikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type Sts2WikiDocumentPayload = {
  __typename?: 'Sts2WikiDocumentPayload';
  data?: Maybe<Sts2WikiDocument>;
  error?: Maybe<Sts2WikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2WikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type Sts2WikiDocumentSetSeoPayload = {
  __typename?: 'Sts2WikiDocumentSetSeoPayload';
  data?: Maybe<Sts2WikiDocument>;
  error?: Maybe<Sts2WikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum Sts2WikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type Sts2WikiDocumentUpdateInput = {
  document: Scalars['Sts2WikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type Sts2WikiDocumentUpdatePayload = {
  __typename?: 'Sts2WikiDocumentUpdatePayload';
  data?: Maybe<Sts2WikiDocument>;
  error?: Maybe<Sts2WikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Sts2WikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type Sts2WikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Payment received events */
  treasuryPaymentsPaymentReceived?: Maybe<TreasuryPaymentsPayment>;
  /** Subscription changed events */
  treasuryPaymentsSubscriptionChanged?: Maybe<TreasuryPaymentsSubscriptionChangedPayload>;
};

export type SubscriptiontreasuryPaymentsPaymentReceivedArgs = {
  input: TreasuryPaymentsPaymentReceivedInput;
};

export type SubscriptiontreasuryPaymentsSubscriptionChangedArgs = {
  input: TreasuryPaymentsSubscriptionChangedInput;
};

export type SummonerRank = {
  __typename?: 'SummonerRank';
  division: Scalars['String'];
  tier: Scalars['String'];
};

/** !!! DEPRECATED !!! */
export type SummonerRankFilter = {
  tier: Scalars['String'];
};

export type TftBadge = {
  __typename?: 'TftBadge';
  metadata: Array<TftBadgeMetadata>;
  slug: Scalars['String'];
};

export type TftBadgeMetadata = {
  __typename?: 'TftBadgeMetadata';
  key?: Maybe<BadgeVar>;
  value?: Maybe<Scalars['String']>;
};

export type TftBadgesFilter = {
  patches?: InputMaybe<Array<Scalars['String']>>;
  queues?: InputMaybe<Array<TftQueue>>;
};

/**
 * Champion unit.
 * Optionally could have summon units.
 *
 * Squidex is used as a source of truth.
 * https://squidex.mobalytics.gg/app/tft-v1/content/champions-v1
 */
export type TftChampion = {
  __typename?: 'TftChampion';
  slug: Scalars['String'];
  summons?: Maybe<Array<TftSummon>>;
  synergies?: Maybe<Array<Scalars['String']>>;
};

/** Champion on position could have items on it. */
export type TftChampionWithItems = {
  __typename?: 'TftChampionWithItems';
  champion?: Maybe<TftChampion>;
  hasAnomaly?: Maybe<Scalars['Boolean']>;
  hasPowerUp?: Maybe<Scalars['Boolean']>;
  headlinerSynergy?: Maybe<Scalars['String']>;
  items?: Maybe<Array<TftItem>>;
  level?: Maybe<Scalars['Int']>;
};

/** Champion with optional items. */
export type TftChampionWithItemsInput = {
  hasAnomaly?: InputMaybe<Scalars['Boolean']>;
  hasPowerUp?: InputMaybe<Scalars['Boolean']>;
  headlinerSynergy?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<Scalars['String']>>;
  level: Scalars['Int'];
  slug: Scalars['String'];
};

/** Chosen synergy for a composition. */
export type TftChosenSynergyInput = {
  slug: Scalars['String'];
};

/**
 * User created composition.
 * Has all required metainformation.
 * TFT-specific information is stored in formation property.
 */
export type TftComposition = {
  __typename?: 'TftComposition';
  createdAt?: Maybe<Scalars['TftDateTime']>;
  description?: Maybe<Scalars['String']>;
  difficulty: Scalars['String'];
  formation?: Maybe<TftFormation>;
  guide?: Maybe<TftCompositionGuide>;
  hasGuide?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isExported?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  patch?: Maybe<Scalars['String']>;
  playstyle?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  set?: Maybe<Scalars['TftSet']>;
  slug: Scalars['String'];
  state?: Maybe<TftCompositionState>;
  tier?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['TftDateTime']>;
  user?: Maybe<TftUser>;
  userVote?: Maybe<TftCompositionVote>;
  video?: Maybe<TftCompositionGuideVideo>;
};

/**
 * Formation to create new composition.
 * Must include positions list.
 * May include core champions and chosen synergy.
 */
export type TftCompositionFormationInput = {
  chosen?: InputMaybe<TftChosenSynergyInput>;
  coreChampions?: InputMaybe<Array<Scalars['TftCoordinates']>>;
  positions: Array<TftCompositionPositionInput>;
};

export type TftCompositionGuide = {
  __typename?: 'TftCompositionGuide';
  alternatives?: Maybe<TftCompositionGuideAlternatives>;
  augments?: Maybe<TftCompositionGuideAugments>;
  carousel?: Maybe<TftCompositionGuideCarousel>;
  composition?: Maybe<TftComposition>;
  compositionId: Scalars['ID'];
  early?: Maybe<TftCompositionGuideGamePlan>;
  legend?: Maybe<TftCompositionLegend>;
  mid?: Maybe<TftCompositionGuideGamePlan>;
  tips?: Maybe<Scalars['String']>;
  video?: Maybe<TftCompositionGuideVideo>;
  whenToMake?: Maybe<Scalars['String']>;
};

export type TftCompositionGuideAlternativeChampWithItems = {
  __typename?: 'TftCompositionGuideAlternativeChampWithItems';
  champion?: Maybe<TftChampion>;
  items?: Maybe<Array<TftItem>>;
};

export type TftCompositionGuideAlternativeChampions = {
  __typename?: 'TftCompositionGuideAlternativeChampions';
  alternative?: Maybe<Array<TftChampion>>;
  base?: Maybe<Array<TftChampion>>;
};

export type TftCompositionGuideAlternativeItems = {
  __typename?: 'TftCompositionGuideAlternativeItems';
  champions?: Maybe<Array<TftCompositionGuideAlternativeChampWithItems>>;
};

export type TftCompositionGuideAlternatives = {
  __typename?: 'TftCompositionGuideAlternatives';
  champions?: Maybe<Array<TftCompositionGuideAlternativeChampions>>;
  items?: Maybe<Array<TftChampionWithItems>>;
};

export type TftCompositionGuideAugments = {
  __typename?: 'TftCompositionGuideAugments';
  augments?: Maybe<Array<TftHextechAugment>>;
};

export type TftCompositionGuideCarousel = {
  __typename?: 'TftCompositionGuideCarousel';
  items?: Maybe<Array<TftItem>>;
};

export type TftCompositionGuideGamePlan = {
  __typename?: 'TftCompositionGuideGamePlan';
  advice?: Maybe<Scalars['String']>;
  formation?: Maybe<TftFormation>;
};

export enum TftCompositionGuideGamePlanType {
  EARLY = 'EARLY',
  MID = 'MID',
}

export type TftCompositionGuideVideo = {
  __typename?: 'TftCompositionGuideVideo';
  isPremium: Scalars['Boolean'];
  previewURL?: Maybe<Scalars['String']>;
  videoURL?: Maybe<Scalars['String']>;
};

export type TftCompositionLegend = {
  __typename?: 'TftCompositionLegend';
  slug?: Maybe<Scalars['String']>;
};

export type TftCompositionPayload = {
  __typename?: 'TftCompositionPayload';
  composition?: Maybe<TftComposition>;
  errors?: Maybe<Array<TftError>>;
};

/** Position links either a champion or a summon to coordinates. */
export type TftCompositionPositionInput = {
  champion?: InputMaybe<TftChampionWithItemsInput>;
  coordinates: Scalars['TftCoordinates'];
  summon?: InputMaybe<TftSummonInput>;
};

export enum TftCompositionState {
  TFT_COMPOSITION_STATE_META = 'TFT_COMPOSITION_STATE_META',
  TFT_COMPOSITION_STATE_PRIVATE = 'TFT_COMPOSITION_STATE_PRIVATE',
  TFT_COMPOSITION_STATE_PUBLIC = 'TFT_COMPOSITION_STATE_PUBLIC',
}

export enum TftCompositionVote {
  TFT_COMPOSITION_VOTE_DOWN = 'TFT_COMPOSITION_VOTE_DOWN',
  TFT_COMPOSITION_VOTE_NONE = 'TFT_COMPOSITION_VOTE_NONE',
  TFT_COMPOSITION_VOTE_UP = 'TFT_COMPOSITION_VOTE_UP',
}

export type TftCreateCompositionGuideInput = {
  compositionId: Scalars['ID'];
  tips?: InputMaybe<Scalars['String']>;
  whenToMake: Scalars['String'];
};

export type TftCreateCompositionGuidePayload = {
  __typename?: 'TftCreateCompositionGuidePayload';
  errors?: Maybe<Array<Maybe<TftError>>>;
  guide?: Maybe<TftCompositionGuide>;
  guideId?: Maybe<Scalars['ID']>;
};

/**
 * Input to create new composition.
 * Must include name, set and unit formation.
 */
export type TftCreateCompositionInput = {
  description?: InputMaybe<Scalars['String']>;
  difficulty: Scalars['String'];
  formation: TftCompositionFormationInput;
  name: Scalars['String'];
  /**
   * Patch is optional only for backward compatibility.
   * It is recommended to set patch proprety.
   * Set to the current patch by default.
   */
  patch?: InputMaybe<Scalars['String']>;
  playstyle?: InputMaybe<Scalars['String']>;
  set: Scalars['TftSet'];
  tier?: InputMaybe<Scalars['String']>;
};

export type TftCreateCompositionPayload = {
  __typename?: 'TftCreateCompositionPayload';
  errors?: Maybe<Array<Maybe<TftError>>>;
  record?: Maybe<TftComposition>;
  recordId?: Maybe<Scalars['ID']>;
};

export type TftDeleteCompositionsInput = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type TftDeleteCompositionsPayload = {
  __typename?: 'TftDeleteCompositionsPayload';
  affected?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<TftError>>;
  myCompositions?: Maybe<TftMyCompositionsInfiniteScroll>;
  publicCompositions?: Maybe<TftPublicCompositionsInfiniteScroll>;
};

export type TftDeleteCompositionsPayloadmyCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMyCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMyCompositionsSort>>;
};

export type TftDeleteCompositionsPayloadpublicCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftPublicCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftPublicCompositionsSort>>;
};

/** All errors must have a message property. */
export type TftError = {
  message?: Maybe<Scalars['String']>;
};

export type TftExportCompositionsInput = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  isExported: Scalars['Boolean'];
};

export type TftExportCompositionsPayload = {
  __typename?: 'TftExportCompositionsPayload';
  affected?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<TftError>>;
  myCompositions?: Maybe<TftMyCompositionsInfiniteScroll>;
  publicCompositions?: Maybe<TftPublicCompositionsInfiniteScroll>;
};

export type TftExportCompositionsPayloadmyCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMyCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMyCompositionsSort>>;
};

export type TftExportCompositionsPayloadpublicCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftPublicCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftPublicCompositionsSort>>;
};

/** TFT-specifit composition information. */
export type TftFormation = {
  __typename?: 'TftFormation';
  chosen?: Maybe<TftSynergy>;
  coreChampions?: Maybe<Array<TftPosition>>;
  positions?: Maybe<Array<TftPosition>>;
};

/** Generic error */
export type TftGenericError = TftError & {
  __typename?: 'TftGenericError';
  message?: Maybe<Scalars['String']>;
};

export type TftGetCompositionGuideFilter = {
  compositionId: Scalars['ID'];
};

export type TftGetCompositionGuidePayload = {
  __typename?: 'TftGetCompositionGuidePayload';
  errors?: Maybe<Array<Maybe<TftError>>>;
  guide?: Maybe<TftCompositionGuide>;
};

/**
 * Hextech augment that could be chosen for a composition.
 *
 * Squidex is used as a source of truth.
 * https://squidex-us.mobalytics.gg/app/tft-v1/content/hextech-augments
 */
export type TftHextechAugment = {
  __typename?: 'TftHextechAugment';
  slug: Scalars['String'];
};

export type TftInfiniteScrollPageInfo = {
  __typename?: 'TftInfiniteScrollPageInfo';
  cursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  totalItems?: Maybe<Scalars['Int']>;
};

/** Invalid parameter */
export type TftInvalidParameterError = TftError & {
  __typename?: 'TftInvalidParameterError';
  message?: Maybe<Scalars['String']>;
  parameter?: Maybe<Scalars['String']>;
};

/**
 * Item that could be placed on champion.
 *
 * Squidex is used as a source of truth.
 * https://squidex.mobalytics.gg/app/tft-v1/content/game-items-v1
 */
export type TftItem = {
  __typename?: 'TftItem';
  slug: Scalars['String'];
};

export type TftLeaderboardFilter = {
  division?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Region>;
  tier?: InputMaybe<Scalars['String']>;
};

export type TftLeaderboardPagination = {
  __typename?: 'TftLeaderboardPagination';
  items?: Maybe<Array<TftLeaderboardStanding>>;
  pageInfo?: Maybe<TftPaginationInfo>;
  updatedAt?: Maybe<Scalars['TftDateTime']>;
};

export type TftLeaderboardStanding = {
  __typename?: 'TftLeaderboardStanding';
  division?: Maybe<Scalars['String']>;
  divisionPosition?: Maybe<Scalars['Int']>;
  globalPosition?: Maybe<Scalars['Int']>;
  lp?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  profile?: Maybe<TftProfile>;
  region: Region;
  regionPosition?: Maybe<Scalars['Int']>;
  summonerId: Scalars['String'];
  tier?: Maybe<Scalars['String']>;
  tierPosition?: Maybe<Scalars['Int']>;
};

export type TftMakeMetaCompositionsInput = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  isMeta: Scalars['Boolean'];
};

export type TftMakeMetaCompositionsPayload = {
  __typename?: 'TftMakeMetaCompositionsPayload';
  affected?: Maybe<Scalars['Int']>;
  compositions?: Maybe<Array<TftComposition>>;
  errors?: Maybe<Array<TftError>>;
  metaCompositions?: Maybe<TftMetaCompositionsInfiniteScroll>;
  myCompositions?: Maybe<TftMyCompositionsInfiniteScroll>;
};

export type TftMakeMetaCompositionsPayloadcompositionsArgs = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type TftMakeMetaCompositionsPayloadmetaCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMetaCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMetaCompositionsSort>>;
};

export type TftMakeMetaCompositionsPayloadmyCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMyCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMyCompositionsSort>>;
};

export type TftMatch = {
  __typename?: 'TftMatch';
  date?: Maybe<Scalars['TftDateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  /** @deprecated Use `matchId` instead */
  id?: Maybe<Scalars['Int']>;
  matchId?: Maybe<Scalars['ID']>;
  participants?: Maybe<Array<TftMatchParticipant>>;
  patch?: Maybe<Scalars['String']>;
  queue?: Maybe<TftQueue>;
  region?: Maybe<Region>;
  set?: Maybe<Scalars['TftSet']>;
};

/** Filter to get summoner match. */
export type TftMatchFilter = {
  matchId: Scalars['ID'];
  region: Region;
};

export type TftMatchParticipant = {
  __typename?: 'TftMatchParticipant';
  archetypeId?: Maybe<Scalars['Int']>;
  augments?: Maybe<Array<TftMatchRegistryAugment>>;
  damageDealt?: Maybe<Scalars['Int']>;
  placement?: Maybe<Scalars['Int']>;
  profile?: Maybe<TftProfile>;
  puuid: Scalars['Puuid'];
  region?: Maybe<Region>;
  set?: Maybe<Scalars['TftSet']>;
  timeEliminatedSeconds?: Maybe<Scalars['Int']>;
  traits?: Maybe<Array<TftMatchRegistryTrait>>;
  units?: Maybe<Array<TftMatchRegistryUnit>>;
};

export type TftMatchPlacement = {
  __typename?: 'TftMatchPlacement';
  placement?: Maybe<Scalars['Int']>;
  profile?: Maybe<TftProfile>;
  puuid: Scalars['Puuid'];
  region?: Maybe<Region>;
  set?: Maybe<Scalars['TftSet']>;
};

export type TftMatchRegistry = {
  __typename?: 'TftMatchRegistry';
  archetypeId?: Maybe<Scalars['Int']>;
  augments?: Maybe<Array<TftMatchRegistryAugment>>;
  damageDealt?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['TftDateTime']>;
  durationSeconds?: Maybe<Scalars['Int']>;
  /** @deprecated Use `matchId` instead */
  id?: Maybe<Scalars['Int']>;
  lp?: Maybe<TftMatchRegistryLP>;
  matchId?: Maybe<Scalars['ID']>;
  patch?: Maybe<Scalars['String']>;
  placement?: Maybe<Scalars['Int']>;
  placements?: Maybe<Array<TftMatchPlacement>>;
  queue?: Maybe<TftQueue>;
  region?: Maybe<Region>;
  timeEliminatedSeconds?: Maybe<Scalars['Int']>;
  traits?: Maybe<Array<TftMatchRegistryTrait>>;
  units?: Maybe<Array<TftMatchRegistryUnit>>;
};

export type TftMatchRegistryAugment = {
  __typename?: 'TftMatchRegistryAugment';
  slug?: Maybe<Scalars['String']>;
};

export type TftMatchRegistryLP = {
  __typename?: 'TftMatchRegistryLP';
  after?: Maybe<TftMatchRegistryLPRecord>;
  before?: Maybe<TftMatchRegistryLPRecord>;
  lpDiff?: Maybe<Scalars['Int']>;
  /** null - no promo, true - promo up, false - promo down */
  promoted?: Maybe<Scalars['Boolean']>;
};

export type TftMatchRegistryLPRecord = {
  __typename?: 'TftMatchRegistryLPRecord';
  lp: Scalars['Int'];
  rank: SummonerRank;
};

export type TftMatchRegistryTrait = {
  __typename?: 'TftMatchRegistryTrait';
  numUnits?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['Int']>;
  tierCurrent?: Maybe<Scalars['Int']>;
  tierTotal?: Maybe<Scalars['Int']>;
};

export type TftMatchRegistryUnit = {
  __typename?: 'TftMatchRegistryUnit';
  chosen?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Scalars['String']>>;
  slug?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['Int']>;
};

export type TftMatchesInfiniteScroll = {
  __typename?: 'TftMatchesInfiniteScroll';
  items?: Maybe<Array<TftMatchRegistry>>;
  pageInfo?: Maybe<TftInfiniteScrollPageInfo>;
};

export type TftMetaCompositionsFilter = {
  carryChampion?: InputMaybe<Array<Scalars['String']>>;
  champion?: InputMaybe<Array<Scalars['String']>>;
  coreChampion?: InputMaybe<Array<Scalars['String']>>;
  item?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['TftSet']>>;
  synergy?: InputMaybe<Array<Scalars['String']>>;
  tier?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TftMetaCompositionsInfiniteScroll = {
  __typename?: 'TftMetaCompositionsInfiniteScroll';
  errors?: Maybe<Array<TftError>>;
  items?: Maybe<Array<TftComposition>>;
  pageInfo?: Maybe<TftInfiniteScrollPageInfo>;
};

/** Available compositions sorting options. */
export enum TftMetaCompositionsSort {
  /** Sort by createdAt ascending. */
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  /** Sort by createdAt descending. */
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  /** Sort by tier ascending. */
  TIER_ASC = 'TIER_ASC',
  /** Sort by tier descending. */
  TIER_DESC = 'TIER_DESC',
  /** Sort by updatedAt ascending. */
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  /** Sort by updatedAt descending. */
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
}

export type TftMetrics = {
  __typename?: 'TftMetrics';
  /** @deprecated No longer supported */
  augments?: Maybe<Array<TftMetricsAugment>>;
  augmentsV2?: Maybe<Array<TftMetricsAugmentData>>;
  champions?: Maybe<Array<TftMetricsChampionData>>;
  /** This node contains all queries related to metrics (statistics) of compositions */
  compositions: TftMetricsCompositions;
  items?: Maybe<Array<TftMetricsItemData>>;
  topChampionsPerItem?: Maybe<Array<TftTopChampionsPerItem>>;
  traits?: Maybe<Array<TftMetricsTraitData>>;
};

export type TftMetricsaugmentsArgs = {
  filter?: InputMaybe<TftMetricsAugmentsFilter>;
};

export type TftMetricsaugmentsV2Args = {
  filter?: InputMaybe<TftMetricsFilter>;
};

export type TftMetricschampionsArgs = {
  filter?: InputMaybe<TftMetricsFilter>;
};

export type TftMetricsitemsArgs = {
  filter?: InputMaybe<TftMetricsFilter>;
};

export type TftMetricstopChampionsPerItemArgs = {
  filter?: InputMaybe<TftTopChampionsPerItemFilter>;
};

export type TftMetricstraitsArgs = {
  filter?: InputMaybe<TftMetricsFilter>;
};

/** !!! DEPRECATED !!! */
export type TftMetricsAugment = {
  __typename?: 'TftMetricsAugment';
  avgPlacement: Scalars['Float'];
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  tier: AugmentTier;
  winRate: Scalars['Float'];
};

export type TftMetricsAugmentData = {
  __typename?: 'TftMetricsAugmentData';
  avgPlacement: Scalars['Float'];
  matches: Scalars['Int'];
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  tier: MetricTier;
  winRate: Scalars['Float'];
};

/** !!! DEPRECATED !!! */
export type TftMetricsAugmentsFilter = {
  ranks?: InputMaybe<Array<SummonerRankFilter>>;
  set?: InputMaybe<Scalars['TftSet']>;
};

export type TftMetricsChampionData = {
  __typename?: 'TftMetricsChampionData';
  avgPlacement: Scalars['Float'];
  matches: Scalars['Int'];
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  tier: MetricTier;
  winRate: Scalars['Float'];
};

export type TftMetricsCompositionData = {
  __typename?: 'TftMetricsCompositionData';
  avgPlace: Scalars['Float'];
  details: TftMetricsCompositionDetailsPayload;
  formation: TftMetricsCompositionFormation;
  id: Scalars['ID'];
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  tier: MetricTier;
  top2Traits: TftMetricsCompositionTop2Traits;
  top4Rate: Scalars['Float'];
  traits: Array<TftMatchRegistryTrait>;
  winRate: Scalars['Float'];
};

export type TftMetricsCompositionDetails = {
  __typename?: 'TftMetricsCompositionDetails';
  id: Scalars['ID'];
  variationLvl8: Array<TftMetricsCompositionVariation>;
  variationLvl9: Array<TftMetricsCompositionVariation>;
  variationLvl10: Array<TftMetricsCompositionVariation>;
};

export type TftMetricsCompositionDetailsPayload = {
  __typename?: 'TftMetricsCompositionDetailsPayload';
  data?: Maybe<TftMetricsCompositionDetails>;
  errors?: Maybe<Array<TftError>>;
};

export type TftMetricsCompositionFormation = {
  __typename?: 'TftMetricsCompositionFormation';
  positions: Array<TftPosition>;
};

export type TftMetricsCompositionTop2Traits = {
  __typename?: 'TftMetricsCompositionTop2Traits';
  trait1Slug: Scalars['String'];
  trait2Slug: Scalars['String'];
};

export type TftMetricsCompositionVariation = {
  __typename?: 'TftMetricsCompositionVariation';
  avgPlace: Scalars['Float'];
  formation: TftMetricsCompositionFormation;
  traits: Array<TftMatchRegistryTrait>;
};

export type TftMetricsCompositions = {
  __typename?: 'TftMetricsCompositions';
  /** Returns a particular composition with metrics by unique slug */
  get: TftMetricsCompositionsPayload;
  /** Returns a list of available compositions with metrics */
  list: TftMetricsListCompositionsPayload;
  /** Returns a paginated list of available compositions with metrics */
  listPaginated: TftMetricsPaginatedListCompositionsPayload;
};

export type TftMetricsCompositionsgetArgs = {
  filter: TftMetricsGetCompositionsFilter;
};

export type TftMetricsCompositionslistArgs = {
  filter: TftMetricsListCompositionsFilter;
};

export type TftMetricsCompositionslistPaginatedArgs = {
  filter: TftMetricsPaginatedListCompositionsFilter;
  page: CursorPage;
};

export type TftMetricsCompositionsPayload = {
  __typename?: 'TftMetricsCompositionsPayload';
  data?: Maybe<TftMetricsCompositionData>;
  errors?: Maybe<Array<TftError>>;
};

export type TftMetricsFilter = {
  patch?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<TftRegion>;
  set?: InputMaybe<Scalars['TftSet']>;
  tiers?: InputMaybe<Array<TftTier>>;
};

export type TftMetricsGetCompositionsFilter = {
  set: Scalars['TftSet'];
  slug: Scalars['String'];
};

export type TftMetricsItemData = {
  __typename?: 'TftMetricsItemData';
  avgPlacement: Scalars['Float'];
  matches: Scalars['Int'];
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  tier: MetricTier;
  winRate: Scalars['Float'];
};

export type TftMetricsListCompositionsFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  set: Scalars['TftSet'];
  tiers: Array<TftTier>;
};

export type TftMetricsListCompositionsPayload = {
  __typename?: 'TftMetricsListCompositionsPayload';
  data?: Maybe<Array<TftMetricsCompositionData>>;
  errors?: Maybe<Array<TftError>>;
};

export type TftMetricsPaginatedListCompositions = {
  __typename?: 'TftMetricsPaginatedListCompositions';
  list: Array<TftMetricsCompositionData>;
  paginationInfo: CursorPaginationInfo;
};

export type TftMetricsPaginatedListCompositionsFilter = {
  /** Filter out compositions that don't contain the specified champion */
  champion?: InputMaybe<Scalars['String']>;
  set: Scalars['TftSet'];
  /** Filter out compositions that don't contain the specified synergy */
  synergy?: InputMaybe<Scalars['String']>;
  tiers: Array<TftTier>;
};

export type TftMetricsPaginatedListCompositionsPayload = {
  __typename?: 'TftMetricsPaginatedListCompositionsPayload';
  data?: Maybe<TftMetricsPaginatedListCompositions>;
  errors?: Maybe<Array<TftError>>;
};

export type TftMetricsTraitData = {
  __typename?: 'TftMetricsTraitData';
  avgPlacement: Scalars['Float'];
  matches: Scalars['Int'];
  pickRate: Scalars['Float'];
  slug: Scalars['String'];
  tier: MetricTier;
  winRate: Scalars['Float'];
};

export type TftMutation = {
  __typename?: 'TftMutation';
  /** Create new TFT composition */
  createComposition: TftCreateCompositionPayload;
  /** Delete existing TFT composition */
  deleteCompositions: TftDeleteCompositionsPayload;
  /** Export compositions to overlay */
  exportCompositions: TftExportCompositionsPayload;
  /** Guides */
  guides?: Maybe<TftMutationCompositionGuides>;
  /** Make compositions meta */
  makeMetaCompositions: TftMakeMetaCompositionsPayload;
  /** Publish compositions */
  publishCompositions: TftPublishCompositionsPayload;
  /** Start asynchronous profile refresh. A Notification about the completion of async operation is sent via Firestore. */
  refreshProfiles: TftRefreshProfilesPayload;
  /** Change existing TFT composition */
  updateComposition: TftUpdateCompositionPayload;
  /** Vote */
  voteForComposition: TftVoteForCompositionPayload;
};

export type TftMutationcreateCompositionArgs = {
  input: TftCreateCompositionInput;
};

export type TftMutationdeleteCompositionsArgs = {
  input: TftDeleteCompositionsInput;
};

export type TftMutationexportCompositionsArgs = {
  input: TftExportCompositionsInput;
};

export type TftMutationmakeMetaCompositionsArgs = {
  input: TftMakeMetaCompositionsInput;
};

export type TftMutationpublishCompositionsArgs = {
  input: TftPublishCompositionsInput;
};

export type TftMutationrefreshProfilesArgs = {
  input: TftRefreshProfilesInput;
};

export type TftMutationupdateCompositionArgs = {
  input: TftUpdateCompositionInput;
};

export type TftMutationvoteForCompositionArgs = {
  input: TftVoteForCompositionInput;
};

export type TftMutationCompositionGuides = {
  __typename?: 'TftMutationCompositionGuides';
  /** Create a guide for a composition */
  create: TftCreateCompositionGuidePayload;
  /** Delete guide video */
  deleteVideo: TftUpdateCompositionGuidePayload;
  /** Update guide for a composition */
  update: TftUpdateCompositionGuidePayload;
  /** Update guide alternative champions */
  updateAlternativeChampions: TftUpdateCompositionGuidePayload;
  /** Update guide alternative items */
  updateAlternativeItems: TftUpdateCompositionGuidePayload;
  /** Update guide carousel */
  updateAugments: TftUpdateCompositionGuidePayload;
  /** Update guide carousel */
  updateCarousel: TftUpdateCompositionGuidePayload;
  /** Update guide carousel */
  updateGamePlan: TftUpdateCompositionGuidePayload;
  updateLegend: TftUpdateCompositionGuidePayload;
  /** Update guide video */
  updateVideo: TftUpdateCompositionGuidePayload;
};

export type TftMutationCompositionGuidescreateArgs = {
  input: TftCreateCompositionGuideInput;
};

export type TftMutationCompositionGuidesdeleteVideoArgs = {
  input: TftUpdateCompositionGuideDeleteVideoInput;
};

export type TftMutationCompositionGuidesupdateArgs = {
  input: TftUpdateCompositionGuideInput;
};

export type TftMutationCompositionGuidesupdateAlternativeChampionsArgs = {
  input: TftUpdateCompositionGuideAlternativeChampionsInput;
};

export type TftMutationCompositionGuidesupdateAlternativeItemsArgs = {
  input: TftUpdateCompositionGuideAlternativeItemsInput;
};

export type TftMutationCompositionGuidesupdateAugmentsArgs = {
  input: TftUpdateCompositionGuideAugmentsInput;
};

export type TftMutationCompositionGuidesupdateCarouselArgs = {
  input: TftUpdateCompositionGuideCarouselInput;
};

export type TftMutationCompositionGuidesupdateGamePlanArgs = {
  input: TftUpdateCompositionGuideGamePlanInput;
};

export type TftMutationCompositionGuidesupdateLegendArgs = {
  input: TftUpdateCompositionGuideLegendInput;
};

export type TftMutationCompositionGuidesupdateVideoArgs = {
  input: TftUpdateCompositionGuideUpdateVideoInput;
};

export type TftMyCompositionsFilter = {
  carryChampion?: InputMaybe<Array<Scalars['String']>>;
  champion?: InputMaybe<Array<Scalars['String']>>;
  coreChampion?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  idNotEqual?: InputMaybe<Array<Scalars['ID']>>;
  isExported?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Array<Scalars['String']>>;
  patch?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['TftSet']>>;
  synergy?: InputMaybe<Array<Scalars['String']>>;
  tierV2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TftMyCompositionsInfiniteScroll = {
  __typename?: 'TftMyCompositionsInfiniteScroll';
  errors?: Maybe<Array<TftError>>;
  items?: Maybe<Array<TftComposition>>;
  pageInfo?: Maybe<TftInfiniteScrollPageInfo>;
};

/** Available compositions sorting options. */
export enum TftMyCompositionsSort {
  /** Sort by createdAt ascending. */
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  /** Sort by createdAt descending. */
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  /** Sort by rating ascending. */
  RATING_ASC = 'RATING_ASC',
  /** Sort by rating descending. */
  RATING_DESC = 'RATING_DESC',
  /** Sort by tier ascending. */
  TIER_ASC = 'TIER_ASC',
  /** Sort by tier descending. */
  TIER_DESC = 'TIER_DESC',
  /** Sort by updatedAt ascending. */
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  /** Sort by updatedAt descending. */
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
}

/** Need premium error returned if user has exhausted non-premium quota. */
export type TftNeedPremiumError = TftError & {
  __typename?: 'TftNeedPremiumError';
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type TftNgfDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'TftNgfDocumentCmWidgetV1';
  data: TftNgfDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type TftNgfDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'TftNgfDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TftNgfDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | TftNgfDocumentCmWidgetV1;

export type TftNgfDocumentSeason = NgfDocumentSeason & {
  __typename?: 'TftNgfDocumentSeason';
  slug: Scalars['String'];
};

export type TftNgfDocumentTags = NgfDocumentTags & {
  __typename?: 'TftNgfDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type TftNgfDocumentsMutation = {
  __typename?: 'TftNgfDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: TftNgfStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: TftNgfStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: TftNgfStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: TftNgfStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: TftNgfUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: TftNgfUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: TftNgfUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: TftNgfUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: TftNgfUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: TftNgfUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: TftNgfWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: TftNgfWikiDocumentUpdatePayload;
};

export type TftNgfDocumentsMutationstructDocumentCreateArgs = {
  input: TftNgfStructDocumentCreateInput;
};

export type TftNgfDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type TftNgfDocumentsMutationstructDocumentSetStatusArgs = {
  input: TftNgfStructDocumentSetStatusInput;
};

export type TftNgfDocumentsMutationstructDocumentUpdateArgs = {
  input: TftNgfStructDocumentUpdateInput;
};

export type TftNgfDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: TftNgfUserGeneratedDocumentCreateInput;
};

export type TftNgfDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: TftNgfUserGeneratedDocumentSetFavoriteInput;
};

export type TftNgfDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: TftNgfUserGeneratedDocumentSetFeaturedInput;
};

export type TftNgfDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type TftNgfDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: TftNgfUserGeneratedDocumentSetStatusInput;
};

export type TftNgfDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: TftNgfUserGeneratedDocumentUpdateInput;
};

export type TftNgfDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type TftNgfDocumentsMutationwikiDocumentUpdateArgs = {
  input: TftNgfWikiDocumentUpdateInput;
};

export type TftNgfDocumentsQuery = {
  __typename?: 'TftNgfDocumentsQuery';
  previewDocumentContent: TftNgfPreviewDocumentContentPayload;
  structDocumentBySlug: TftNgfStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: TftNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: TftNgfUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: TftNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: TftNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: TftNgfTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: TftNgfWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type TftNgfDocumentsQuerypreviewDocumentContentArgs = {
  input: TftNgfPreviewDocumentContentInput;
};

export type TftNgfDocumentsQuerystructDocumentBySlugArgs = {
  input: TftNgfStructDocumentInputBySlug;
};

export type TftNgfDocumentsQuerystructDocumentsArgs = {
  input: TftNgfStructDocumentsInput;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: TftNgfUserGeneratedDocumentInputById;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: TftNgfUserGeneratedDocumentInputBySlug;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: TftNgfTemplateDocumentInput;
};

export type TftNgfDocumentsQueryuserGeneratedDocumentsArgs = {
  input: TftNgfUserGeneratedDocumentsListInput;
  page: TftNgfUserGeneratedDocumentsListPage;
};

export type TftNgfDocumentsQuerywikiDocumentArgs = {
  input: TftNgfWikiDocumentInput;
};

export type TftNgfDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<TftNgfWikiDocumentsListInput>;
  page: TftNgfWikiDocumentsListPage;
};

export type TftNgfEntityObject = NGFEntityObject & {
  __typename?: 'TftNgfEntityObject';
  color?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TftNgfMutation = {
  __typename?: 'TftNgfMutation';
  documents?: Maybe<TftNgfDocumentsMutation>;
  id: Scalars['ID'];
};

export enum TftNgfPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfPreviewDocumentContentInput = {
  content: Scalars['TftNgfDocumentContentInputBase64Json'];
};

export type TftNgfPreviewDocumentContentPayload = {
  __typename?: 'TftNgfPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<TftNgfDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<TftNgfPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfProfile = NgfProfile & {
  __typename?: 'TftNgfProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type TftNgfProfileuserGeneratedDocumentsArgs = {
  input: TftNgfUserGeneratedDocumentsListInput;
  page: TftNgfUserGeneratedDocumentsListPage;
};

export type TftNgfProfilePayload = {
  __typename?: 'TftNgfProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<TftNgfProfile>;
};

export type TftNgfProfilesQuery = {
  __typename?: 'TftNgfProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: TftNgfProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type TftNgfProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type TftNgfQuery = {
  __typename?: 'TftNgfQuery';
  documents?: Maybe<TftNgfDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<TftNgfProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
};

export type TftNgfStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'TftNgfStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<TftNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: TftNgfStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum TftNgfStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TftNgfStructDocumentCreateInput = {
  document: Scalars['TftNgfStructDocumentInputBase64Json'];
};

export type TftNgfStructDocumentCreatePayload = {
  __typename?: 'TftNgfStructDocumentCreatePayload';
  data?: Maybe<TftNgfStructDocument>;
  error?: Maybe<TftNgfStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfStructDocumentData = NgfStructDocumentData & {
  __typename?: 'TftNgfStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: TftNgfDocumentSeason;
  tags?: Maybe<TftNgfDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum TftNgfStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type TftNgfStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TftNgfStructDocumentPayload = {
  __typename?: 'TftNgfStructDocumentPayload';
  data?: Maybe<TftNgfStructDocument>;
  error?: Maybe<TftNgfStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type TftNgfStructDocumentSetSeoPayload = {
  __typename?: 'TftNgfStructDocumentSetSeoPayload';
  data?: Maybe<TftNgfStructDocument>;
  error?: Maybe<TftNgfStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type TftNgfStructDocumentSetStatusPayload = {
  __typename?: 'TftNgfStructDocumentSetStatusPayload';
  data?: Maybe<TftNgfStructDocument>;
  error?: Maybe<TftNgfStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfStructDocumentUpdateInput = {
  document: Scalars['TftNgfStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type TftNgfStructDocumentUpdatePayload = {
  __typename?: 'TftNgfStructDocumentUpdatePayload';
  data?: Maybe<TftNgfStructDocument>;
  error?: Maybe<TftNgfStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type TftNgfTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'TftNgfTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<TftNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: TftNgfTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type TftNgfTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'TftNgfTemplateDocumentData';
  buildVariants?: Maybe<TftNgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: TftNgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum TftNgfTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfTemplateDocumentInput = {
  type: Scalars['String'];
};

export type TftNgfTemplateDocumentPayload = {
  __typename?: 'TftNgfTemplateDocumentPayload';
  data?: Maybe<TftNgfTemplateDocument>;
  error?: Maybe<TftNgfTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'TftNgfUGDocumentGenericBuilder';
  slots?: Maybe<Array<TftNgfUGDocumentGenericBuilderSlot>>;
};

export type TftNgfUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'TftNgfUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<TftNgfEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type TftNgfUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'TftNgfUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<TftNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: TftNgfUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<TftNgfDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type TftNgfUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'TftNgfUserGeneratedDocumentBuildVariant';
  genericBuilder: TftNgfUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type TftNgfUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'TftNgfUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<TftNgfUserGeneratedDocumentBuildVariant>>;
};

export enum TftNgfUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TftNgfUserGeneratedDocumentCreateInput = {
  document: Scalars['TftNgfUserGeneratedDocumentInputBase64Json'];
};

export type TftNgfUserGeneratedDocumentCreatePayload = {
  __typename?: 'TftNgfUserGeneratedDocumentCreatePayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'TftNgfUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<TftNgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: TftNgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum TftNgfUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type TftNgfUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TftNgfUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TftNgfUserGeneratedDocumentPayload = {
  __typename?: 'TftNgfUserGeneratedDocumentPayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type TftNgfUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'TftNgfUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TftNgfUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type TftNgfUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'TftNgfUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type TftNgfUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'TftNgfUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type TftNgfUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'TftNgfUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TftNgfUserGeneratedDocumentUpdateInput = {
  document: Scalars['TftNgfUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type TftNgfUserGeneratedDocumentUpdatePayload = {
  __typename?: 'TftNgfUserGeneratedDocumentUpdatePayload';
  data?: Maybe<TftNgfUserGeneratedDocument>;
  error?: Maybe<TftNgfUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type TftNgfUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type TftNgfWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'TftNgfWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<TftNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: TftNgfWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<TftNgfDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type TftNgfWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'TftNgfWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: TftNgfEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum TftNgfWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TftNgfWikiDocumentPayload = {
  __typename?: 'TftNgfWikiDocumentPayload';
  data?: Maybe<TftNgfWikiDocument>;
  error?: Maybe<TftNgfWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type TftNgfWikiDocumentSetSeoPayload = {
  __typename?: 'TftNgfWikiDocumentSetSeoPayload';
  data?: Maybe<TftNgfWikiDocument>;
  error?: Maybe<TftNgfWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TftNgfWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TftNgfWikiDocumentUpdateInput = {
  document: Scalars['TftNgfWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type TftNgfWikiDocumentUpdatePayload = {
  __typename?: 'TftNgfWikiDocumentUpdatePayload';
  data?: Maybe<TftNgfWikiDocument>;
  error?: Maybe<TftNgfWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TftNgfWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type TftNgfWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

/** Returned when the Mobalytics user exists but has no Riot account linked via OAuth. */
export type TftNoLinkedRiotAccountError = TftError & {
  __typename?: 'TftNoLinkedRiotAccountError';
  message?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Not found */
export type TftNotFoundError = TftError & {
  __typename?: 'TftNotFoundError';
  message?: Maybe<Scalars['String']>;
};

export type TftPaginationInfo = {
  __typename?: 'TftPaginationInfo';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/** Position in composition with coordinates and a unit. */
export type TftPosition = {
  __typename?: 'TftPosition';
  champion?: Maybe<TftChampionWithItems>;
  coordinates?: Maybe<Scalars['TftCoordinates']>;
  summon?: Maybe<TftSummon>;
};

/** TFT Profile page data */
export type TftProfile = {
  __typename?: 'TftProfile';
  badges?: Maybe<Array<Maybe<TftBadge>>>;
  info?: Maybe<TftSummoner>;
  /** @deprecated Leaderboard was removed from the website */
  leaderboardStanding?: Maybe<TftLeaderboardStanding>;
  performance?: Maybe<Array<TftProfilePerformance>>;
  progressTrackingV3?: Maybe<TftProfileProgressTrackingV3>;
  puuid?: Maybe<Scalars['Puuid']>;
  rank?: Maybe<SummonerRank>;
  region?: Maybe<Region>;
  set?: Maybe<Scalars['TftSet']>;
  stats?: Maybe<TftProfileStats>;
};

/** TFT Profile page data */
export type TftProfilebadgesArgs = {
  filter?: InputMaybe<TftBadgesFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** TFT Profile page data */
export type TftProfileperformanceArgs = {
  filters?: InputMaybe<Array<TftProfilePerformanceFilter>>;
};

/** TFT Profile page data */
export type TftProfileprogressTrackingV3Args = {
  filter?: InputMaybe<TftProfileProgressTrackingFilterV3>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

/** TFT Profile page data */
export type TftProfilestatsArgs = {
  filter?: InputMaybe<TftProfileStatsFilter>;
};

export type TftProfileArchetypeStat = {
  __typename?: 'TftProfileArchetypeStat';
  averagePlace?: Maybe<Scalars['Float']>;
  averageRound?: Maybe<Scalars['Float']>;
  averageTimeSeconds?: Maybe<Scalars['Int']>;
  compositions?: Maybe<Array<TftProfileCompositionStat>>;
  formation?: Maybe<TftProfileFormation>;
  games?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lpGained?: Maybe<Scalars['Int']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

export type TftProfileArchetypes = {
  __typename?: 'TftProfileArchetypes';
  items?: Maybe<Array<TftProfileArchetypeStat>>;
};

export type TftProfileAugmentStat = {
  __typename?: 'TftProfileAugmentStat';
  averagePlace?: Maybe<Scalars['Float']>;
  games?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

export type TftProfileAugments = {
  __typename?: 'TftProfileAugments';
  items?: Maybe<Array<TftProfileAugmentStat>>;
};

/** Filter to get player profile by moba username. */
export type TftProfileByUsernameFilter = {
  set?: InputMaybe<Scalars['TftSet']>;
  username: Scalars['String'];
};

export type TftProfileChampionStat = {
  __typename?: 'TftProfileChampionStat';
  averagePlace?: Maybe<Scalars['Float']>;
  games?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

export type TftProfileChampions = {
  __typename?: 'TftProfileChampions';
  items?: Maybe<Array<TftProfileChampionStat>>;
};

export type TftProfileChosenSynergies = {
  __typename?: 'TftProfileChosenSynergies';
  items?: Maybe<Array<TftProfileChosenSynergyStat>>;
};

export type TftProfileChosenSynergyStat = {
  __typename?: 'TftProfileChosenSynergyStat';
  averagePlace?: Maybe<Scalars['Float']>;
  games?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

export type TftProfileCompositionStat = {
  __typename?: 'TftProfileCompositionStat';
  averagePlace?: Maybe<Scalars['Float']>;
  averageRound?: Maybe<Scalars['Float']>;
  averageTimeSeconds?: Maybe<Scalars['Int']>;
  formation?: Maybe<TftProfileFormation>;
  games?: Maybe<Scalars['Int']>;
  lpGained?: Maybe<Scalars['Int']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

/**
 * Filter to get player profile by summoner name.
 * Must include region, gameName, tagLine and set.
 */
export type TftProfileFilter = {
  gameName?: InputMaybe<Scalars['String']>;
  region: Region;
  set: Scalars['TftSet'];
  /** DEPRECATED. Use gameName and tagLine instead. */
  summonerName?: InputMaybe<Scalars['String']>;
  tagLine?: InputMaybe<Scalars['String']>;
};

export type TftProfileFormation = {
  __typename?: 'TftProfileFormation';
  synergies?: Maybe<Array<TftProfileSynergy>>;
  units?: Maybe<Array<TftProfileUnit>>;
};

export type TftProfileItemStat = {
  __typename?: 'TftProfileItemStat';
  averagePlace?: Maybe<Scalars['Float']>;
  games?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

export type TftProfileItems = {
  __typename?: 'TftProfileItems';
  items?: Maybe<Array<TftProfileItemStat>>;
};

export type TftProfilePatches = {
  __typename?: 'TftProfilePatches';
  patches?: Maybe<Array<Scalars['String']>>;
};

export type TftProfilePayload = {
  __typename?: 'TftProfilePayload';
  error?: Maybe<TftError>;
  mgp?: Maybe<MgpProfile>;
  ngf?: Maybe<TftNgfProfile>;
  profile?: Maybe<TftProfile>;
};

export type TftProfilePerformance = {
  __typename?: 'TftProfilePerformance';
  error?: Maybe<TftError>;
  performance?: Maybe<TftProfileQueuePerformance>;
};

export type TftProfilePerformanceFilter = {
  patches?: InputMaybe<Array<Scalars['String']>>;
  queue: TftQueue;
};

export type TftProfilePlacementDistribution = {
  __typename?: 'TftProfilePlacementDistribution';
  items?: Maybe<Array<TftProfilePlacementDistributionItem>>;
};

export type TftProfilePlacementDistributionItem = {
  __typename?: 'TftProfilePlacementDistributionItem';
  games?: Maybe<Scalars['Int']>;
  place?: Maybe<Scalars['Int']>;
};

export type TftProfileProgressTracking = {
  __typename?: 'TftProfileProgressTracking';
  error?: Maybe<TftError>;
  progress?: Maybe<TftProfileQueueProgress>;
};

export type TftProfileProgressTrackingFilter = {
  dateFrom?: InputMaybe<Scalars['TftDateTime']>;
  queue: TftQueue;
};

export type TftProfileProgressTrackingFilterV3 = {
  queue: TftQueue;
};

export type TftProfileProgressTrackingV3 = {
  __typename?: 'TftProfileProgressTrackingV3';
  error?: Maybe<TftError>;
  progress?: Maybe<TftProfileQueueProgressV3>;
};

export type TftProfileQueuePerformance = {
  __typename?: 'TftProfileQueuePerformance';
  archetypes?: Maybe<TftProfileArchetypes>;
  augments?: Maybe<TftProfileAugments>;
  averagePlace?: Maybe<Scalars['Float']>;
  averageRound?: Maybe<Scalars['Float']>;
  averageTimeEliminatedSeconds?: Maybe<Scalars['Int']>;
  champions?: Maybe<TftProfileChampions>;
  /** @deprecated deprecated tft mechanic */
  chosens?: Maybe<TftProfileChosenSynergies>;
  damageDealt?: Maybe<Scalars['Int']>;
  games?: Maybe<Scalars['Int']>;
  items?: Maybe<TftProfileItems>;
  losses?: Maybe<Scalars['Int']>;
  lp?: Maybe<Scalars['Int']>;
  puuid?: Maybe<Scalars['Puuid']>;
  queue?: Maybe<TftQueue>;
  rank?: Maybe<SummonerRank>;
  region?: Maybe<Region>;
  set?: Maybe<Scalars['TftSet']>;
  stats?: Maybe<TftProfileStats>;
  synergies?: Maybe<TftProfileSynergies>;
  top1?: Maybe<Scalars['Int']>;
  top1Winrate?: Maybe<Scalars['Float']>;
  top2?: Maybe<Scalars['Int']>;
  top2Winrate?: Maybe<Scalars['Float']>;
  top4?: Maybe<Scalars['Int']>;
  top4Winrate?: Maybe<Scalars['Float']>;
  winrate?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Int']>;
};

export type TftProfileQueuePerformancearchetypesArgs = {
  compositions?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileQueuePerformanceaugmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileQueuePerformancechampionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileQueuePerformancechosensArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileQueuePerformanceitemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileQueuePerformancesynergiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileQueueProgress = {
  __typename?: 'TftProfileQueueProgress';
  entries?: Maybe<Array<TftProfileQueueProgressEntry>>;
  maxValue?: Maybe<Scalars['Int']>;
  minValue?: Maybe<Scalars['Int']>;
  thresholds?: Maybe<Array<TftProfileQueueProgressTreshold>>;
};

export type TftProfileQueueProgressEntry = {
  __typename?: 'TftProfileQueueProgressEntry';
  date?: Maybe<Scalars['TftDateTime']>;
  division?: Maybe<Scalars['String']>;
  lp?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type TftProfileQueueProgressEntryV3 = {
  __typename?: 'TftProfileQueueProgressEntryV3';
  date?: Maybe<Scalars['TftDateTime']>;
  id?: Maybe<Scalars['Int']>;
  lp?: Maybe<TftProfileQueueProgressEntryV3LP>;
  patch?: Maybe<Scalars['String']>;
  placement?: Maybe<Scalars['Int']>;
  queue?: Maybe<TftQueue>;
  traits?: Maybe<Array<TftMatchRegistryTrait>>;
  units?: Maybe<Array<TftMatchRegistryUnit>>;
};

export type TftProfileQueueProgressEntryV3LP = {
  __typename?: 'TftProfileQueueProgressEntryV3LP';
  after?: Maybe<TftProfileQueueProgressEntryV3LPRecord>;
  before?: Maybe<TftProfileQueueProgressEntryV3LPRecord>;
  lpDiff?: Maybe<Scalars['Int']>;
  /** null - no promo, true - promo up, false - promo down */
  promoted?: Maybe<Scalars['Boolean']>;
};

export type TftProfileQueueProgressEntryV3LPRecord = {
  __typename?: 'TftProfileQueueProgressEntryV3LPRecord';
  lp: Scalars['Int'];
  rank: SummonerRank;
  value: Scalars['Int'];
};

export type TftProfileQueueProgressTreshold = {
  __typename?: 'TftProfileQueueProgressTreshold';
  division?: Maybe<Scalars['String']>;
  maxLP?: Maybe<Scalars['Int']>;
  maxValue?: Maybe<Scalars['Int']>;
  minLP?: Maybe<Scalars['Int']>;
  minValue?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['String']>;
};

export type TftProfileQueueProgressV3 = {
  __typename?: 'TftProfileQueueProgressV3';
  entries?: Maybe<Array<TftProfileQueueProgressEntryV3>>;
  maxValue?: Maybe<Scalars['Int']>;
  minValue?: Maybe<Scalars['Int']>;
  pageInfo: PaginationInfo;
  thresholds?: Maybe<Array<TftProfileQueueProgressTreshold>>;
};

export type TftProfileRecentActivity = {
  __typename?: 'TftProfileRecentActivity';
  items?: Maybe<Array<TftProfileRecentActivityItem>>;
};

export type TftProfileRecentActivityItem = {
  __typename?: 'TftProfileRecentActivityItem';
  durationSeconds?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['Timestamp']>;
  won?: Maybe<Scalars['Int']>;
};

export type TftProfileRecentActivityV2 = {
  __typename?: 'TftProfileRecentActivityV2';
  gamesPlayed?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<TftProfileRecentActivityV2Item>>;
  timePlayedSeconds?: Maybe<Scalars['Int']>;
};

export type TftProfileRecentActivityV2Item = {
  __typename?: 'TftProfileRecentActivityV2Item';
  date?: Maybe<Scalars['TftDateTime']>;
  gamesPlayed?: Maybe<Scalars['Int']>;
  losses?: Maybe<Scalars['Int']>;
  timePlayedSeconds?: Maybe<Scalars['Int']>;
  winrate?: Maybe<Scalars['Float']>;
  wins?: Maybe<Scalars['Int']>;
};

export type TftProfileRecentSummary = {
  __typename?: 'TftProfileRecentSummary';
  games?: Maybe<Scalars['Int']>;
  items?: Maybe<TftProfileItems>;
  placement?: Maybe<Array<Scalars['Int']>>;
  synergies?: Maybe<TftProfileSynergies>;
  top1?: Maybe<Scalars['Int']>;
  top1Winrate?: Maybe<Scalars['Float']>;
  top4?: Maybe<Scalars['Int']>;
  top4Winrate?: Maybe<Scalars['Float']>;
};

export type TftProfileStats = {
  __typename?: 'TftProfileStats';
  archetypes?: Maybe<TftProfileArchetypes>;
  augments?: Maybe<TftProfileAugments>;
  champions?: Maybe<TftProfileChampions>;
  items?: Maybe<TftProfileItems>;
  matches?: Maybe<TftMatchesInfiniteScroll>;
  patches?: Maybe<TftProfilePatches>;
  placementDistribution?: Maybe<TftProfilePlacementDistribution>;
  puuid?: Maybe<Scalars['Puuid']>;
  queue?: Maybe<TftQueue>;
  /**
   * Deprecated
   * @deprecated Use `recentActivityV2`.
   */
  recentActivity?: Maybe<TftProfileRecentActivity>;
  recentActivityV2?: Maybe<TftProfileRecentActivityV2>;
  recentSummary?: Maybe<TftProfileRecentSummary>;
  region?: Maybe<Region>;
  set?: Maybe<Scalars['TftSet']>;
  synergies?: Maybe<TftProfileSynergies>;
};

export type TftProfileStatsarchetypesArgs = {
  compositions?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatsaugmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatschampionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatsitemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatsmatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatsrecentActivityV2Args = {
  dateFrom?: InputMaybe<Scalars['TftDateTime']>;
};

export type TftProfileStatsrecentSummaryArgs = {
  items?: InputMaybe<Scalars['Int']>;
  synergies?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatssynergiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftProfileStatsFilter = {
  champion?: InputMaybe<Array<Scalars['String']>>;
  dateFrom?: InputMaybe<Scalars['TftDateTime']>;
  patch?: InputMaybe<Array<Scalars['String']>>;
  queue?: InputMaybe<TftQueue>;
  synergy?: InputMaybe<Array<Scalars['String']>>;
};

export type TftProfileSynergies = {
  __typename?: 'TftProfileSynergies';
  items?: Maybe<Array<TftProfileSynergyStat>>;
};

export type TftProfileSynergy = {
  __typename?: 'TftProfileSynergy';
  slug?: Maybe<Scalars['String']>;
  style?: Maybe<TftProfileSynergyStyle>;
};

export type TftProfileSynergyStat = {
  __typename?: 'TftProfileSynergyStat';
  averagePlace?: Maybe<Scalars['Float']>;
  games?: Maybe<Scalars['Int']>;
  gamesBronze?: Maybe<Scalars['Int']>;
  gamesChromatic?: Maybe<Scalars['Int']>;
  gamesGold?: Maybe<Scalars['Int']>;
  gamesOrange?: Maybe<Scalars['Int']>;
  gamesSilver?: Maybe<Scalars['Int']>;
  lpGained?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  top4Games?: Maybe<Scalars['Int']>;
  top4Percent?: Maybe<Scalars['Float']>;
};

export enum TftProfileSynergyStyle {
  BRONZE = 'BRONZE',
  CHROMATIC = 'CHROMATIC',
  GOLD = 'GOLD',
  NO_STYLE = 'NO_STYLE',
  ORANGE = 'ORANGE',
  SILVER = 'SILVER',
}

export type TftProfileUnit = {
  __typename?: 'TftProfileUnit';
  slug?: Maybe<Scalars['String']>;
};

export type TftPublicCompositionsFilter = {
  carryChampion?: InputMaybe<Array<Scalars['String']>>;
  champion?: InputMaybe<Array<Scalars['String']>>;
  coreChampion?: InputMaybe<Array<Scalars['String']>>;
  createdAtFrom?: InputMaybe<Scalars['TftDateTime']>;
  id?: InputMaybe<Array<Scalars['ID']>>;
  idNotEqual?: InputMaybe<Array<Scalars['ID']>>;
  isExported?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Array<Scalars['String']>>;
  patch?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['TftSet']>>;
  synergy?: InputMaybe<Array<Scalars['String']>>;
  tierV2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAtFrom?: InputMaybe<Scalars['TftDateTime']>;
  userId?: InputMaybe<Array<Scalars['ID']>>;
};

export type TftPublicCompositionsInfiniteScroll = {
  __typename?: 'TftPublicCompositionsInfiniteScroll';
  errors?: Maybe<Array<TftError>>;
  items?: Maybe<Array<TftComposition>>;
  pageInfo?: Maybe<TftInfiniteScrollPageInfo>;
};

/** Available compositions sorting options. */
export enum TftPublicCompositionsSort {
  /** Sort by createdAt ascending. */
  CREATED_AT_ASC = 'CREATED_AT_ASC',
  /** Sort by createdAt descending. */
  CREATED_AT_DESC = 'CREATED_AT_DESC',
  /** Sort by rating ascending. */
  RATING_ASC = 'RATING_ASC',
  /** Sort by rating descending. */
  RATING_DESC = 'RATING_DESC',
  /** Sort by tier ascending. */
  TIER_ASC = 'TIER_ASC',
  /** Sort by tier descending. */
  TIER_DESC = 'TIER_DESC',
  /** Sort by updatedAt ascending. */
  UPDATED_AT_ASC = 'UPDATED_AT_ASC',
  /** Sort by updatedAt descending. */
  UPDATED_AT_DESC = 'UPDATED_AT_DESC',
}

export type TftPublishCompositionsInput = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  isPublished: Scalars['Boolean'];
};

export type TftPublishCompositionsPayload = {
  __typename?: 'TftPublishCompositionsPayload';
  affected?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<TftError>>;
  myCompositions?: Maybe<TftMyCompositionsInfiniteScroll>;
  publicCompositions?: Maybe<TftPublicCompositionsInfiniteScroll>;
};

export type TftPublishCompositionsPayloadmyCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMyCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMyCompositionsSort>>;
};

export type TftPublishCompositionsPayloadpublicCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftPublicCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftPublicCompositionsSort>>;
};

export type TftQuery = {
  __typename?: 'TftQuery';
  /** Get composition by id. */
  composition: TftCompositionPayload;
  /** Get composition by slug. */
  compositionBySlug: TftCompositionPayload;
  /** Guides */
  guides?: Maybe<TftQueryCompositionGuides>;
  /** @deprecated Leaderboard was removed from the website */
  leaderboard?: Maybe<TftLeaderboardPagination>;
  /** @deprecated Use `matchV2`. */
  match?: Maybe<TftMatch>;
  matchV2?: Maybe<TftMatch>;
  /**
   * Get meta compositions.
   * Payload is structured for infinite scroll.
   */
  metaCompositions?: Maybe<TftMetaCompositionsInfiniteScroll>;
  /** Metrics */
  metrics?: Maybe<TftMetrics>;
  /**
   * Get TFT user-created compositions.
   * Payload is structured for infinite scroll.
   */
  myCompositions?: Maybe<TftMyCompositionsInfiniteScroll>;
  profile?: Maybe<Array<TftProfilePayload>>;
  profileByUsername?: Maybe<Array<TftProfilePayload>>;
  /**
   * Get public compositions.
   * Payload is structured for infinite scroll.
   */
  publicCompositions?: Maybe<TftPublicCompositionsInfiniteScroll>;
  /** Get recommended compositions. */
  recommendedCompositions?: Maybe<TftRecommendedCompositionsInfiniteScroll>;
  search: TftSearchPayload;
};

export type TftQuerycompositionArgs = {
  id: Scalars['ID'];
};

export type TftQuerycompositionBySlugArgs = {
  slug: Scalars['String'];
};

export type TftQueryleaderboardArgs = {
  filter?: InputMaybe<TftLeaderboardFilter>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type TftQuerymatchArgs = {
  id: Scalars['Int'];
  region: Region;
};

export type TftQuerymatchV2Args = {
  filter: TftMatchFilter;
};

export type TftQuerymetaCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMetaCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMetaCompositionsSort>>;
};

export type TftQuerymyCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMyCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMyCompositionsSort>>;
};

export type TftQueryprofileArgs = {
  filter?: InputMaybe<Array<TftProfileFilter>>;
};

export type TftQueryprofileByUsernameArgs = {
  filter?: InputMaybe<Array<TftProfileByUsernameFilter>>;
};

export type TftQuerypublicCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftPublicCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftPublicCompositionsSort>>;
};

export type TftQueryrecommendedCompositionsArgs = {
  filter: TftRecommendedCompositionsFilter;
};

export type TftQuerysearchArgs = {
  input: TftSearchInput;
};

export type TftQueryCompositionGuides = {
  __typename?: 'TftQueryCompositionGuides';
  /** Get guide for a composition */
  get?: Maybe<TftGetCompositionGuidePayload>;
};

export type TftQueryCompositionGuidesgetArgs = {
  filter: TftGetCompositionGuideFilter;
};

/**
 * TFT queue (aka game type)
 * http://static.developer.riotgames.com/docs/lol/queues.json
 */
export enum TftQueue {
  DOUBLE_UP = 'DOUBLE_UP',
  HYPER_ROLL = 'HYPER_ROLL',
  NORMAL = 'NORMAL',
  RANKED = 'RANKED',
  SET_REVIVAL = 'SET_REVIVAL',
  SOUL_BRAWL = 'SOUL_BRAWL',
}

export enum TftRecommendedCompositionGameStage {
  ANY = 'ANY',
  EARLY = 'EARLY',
  LATE = 'LATE',
  MID = 'MID',
}

export type TftRecommendedCompositionsFilter = {
  augment?: InputMaybe<Array<Scalars['String']>>;
  champion?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the game stage for calculating recommendations. Available only for recommendations based on champions. */
  gameStage?: InputMaybe<TftRecommendedCompositionGameStage>;
  item?: InputMaybe<Array<Scalars['String']>>;
  patch?: InputMaybe<Array<Scalars['String']>>;
  set: Scalars['TftSet'];
};

export type TftRecommendedCompositionsInfiniteScroll = {
  __typename?: 'TftRecommendedCompositionsInfiniteScroll';
  errors?: Maybe<Array<TftError>>;
  items?: Maybe<Array<TftComposition>>;
};

export type TftRefreshProfileInput = {
  gameName?: InputMaybe<Scalars['String']>;
  region: Region;
  /** DEPRECATED. Use gameName and tagLine instead. */
  summonerName?: InputMaybe<Scalars['String']>;
  tagLine?: InputMaybe<Scalars['String']>;
};

export type TftRefreshProfilesInput = {
  inputs?: InputMaybe<Array<TftRefreshProfileInput>>;
  source?: InputMaybe<TftRequestSource>;
};

export type TftRefreshProfilesPayload = {
  __typename?: 'TftRefreshProfilesPayload';
  errors?: Maybe<Array<Maybe<TftError>>>;
  /**
   * An array of Base64-encoded JSON strings containing the data required for listening to
   * profile refresh notifications in Firestore.
   */
  notificationsDetails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum TftRegion {
  ALL = 'ALL',
  BR = 'BR',
  EUNE = 'EUNE',
  EUW = 'EUW',
  JP = 'JP',
  KR = 'KR',
  LAN = 'LAN',
  LAS = 'LAS',
  ME = 'ME',
  NA = 'NA',
  OCE = 'OCE',
  PBE = 'PBE',
  PH = 'PH',
  RU = 'RU',
  SG = 'SG',
  TH = 'TH',
  TR = 'TR',
  TW = 'TW',
  /** @deprecated(reason: "Use `Region` instead") */
  UNKNOWN = 'UNKNOWN',
  VN = 'VN',
}

export enum TftRequestSource {
  POSTGAME = 'POSTGAME',
  PREGAME = 'PREGAME',
  WEB = 'WEB',
}

export type TftSearchInput = {
  region: Region;
  text: Scalars['String'];
};

export type TftSearchPayload = {
  __typename?: 'TftSearchPayload';
  profiles?: Maybe<Array<TftSearchProfile>>;
  region?: Maybe<Region>;
  text?: Maybe<Scalars['String']>;
};

export type TftSearchPayloadprofilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type TftSearchProfile = {
  __typename?: 'TftSearchProfile';
  profile?: Maybe<TftProfile>;
  puuid?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
};

export type TftSearchProfileprofileArgs = {
  set?: InputMaybe<Scalars['TftSet']>;
};

/**
 * Summoned unit.
 * Always is linked to champion that summons it.
 * Could not be placed in composition without linked champion.
 *
 * Squidex is used as a source of truth.
 * https://squidex.mobalytics.gg/app/tft-v1/content/champions-summoned-units-v1
 */
export type TftSummon = {
  __typename?: 'TftSummon';
  champion?: Maybe<TftChampion>;
  items?: Maybe<Array<TftItem>>;
  slug: Scalars['String'];
};

/** Summoned unit by another champion in a composition. */
export type TftSummonInput = {
  items?: InputMaybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type TftSummoner = {
  __typename?: 'TftSummoner';
  accountId?: Maybe<Scalars['String']>;
  gameName?: Maybe<Scalars['String']>;
  isUpdating?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  mobaUuid?: Maybe<Scalars['String']>;
  profileIcon?: Maybe<Scalars['Int']>;
  puuid?: Maybe<Scalars['Puuid']>;
  region?: Maybe<Region>;
  summonerId?: Maybe<Scalars['String']>;
  /** DEPRECATED. Use gameName and tagLine instead. */
  summonerName?: Maybe<Scalars['String']>;
  tagLine?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['TftDateTime']>;
};

/** Summoner not found */
export type TftSummonerNotFoundError = TftError & {
  __typename?: 'TftSummonerNotFoundError';
  message?: Maybe<Scalars['String']>;
  /** Deprecated: Use riotId instead */
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Region>;
  riotId?: Maybe<Scalars['String']>;
};

/**
 * Synergy for a composition.
 * Must have a type, slug and value.
 * Value is calculated by addition of synergies of unique champions
 * in composition plus chosen synergy modificator.
 *
 * Squidex is used as a source of truth.
 * https://squidex.mobalytics.gg/app/tft-v1/content/synergies-v1
 */
export type TftSynergy = {
  __typename?: 'TftSynergy';
  slug: Scalars['String'];
  type?: Maybe<TftSynergyType>;
  value?: Maybe<Scalars['Int']>;
};

/** Each champion has class and origin. Both of them could create synergy for composition. */
export enum TftSynergyType {
  TFT_CLASS = 'TFT_CLASS',
  TFT_ORIGIN = 'TFT_ORIGIN',
}

export enum TftTier {
  BRONZE = 'BRONZE',
  CHALLENGER = 'CHALLENGER',
  DIAMOND = 'DIAMOND',
  EMERALD = 'EMERALD',
  GOLD = 'GOLD',
  GRANDMASTER = 'GRANDMASTER',
  IRON = 'IRON',
  MASTER = 'MASTER',
  PLATINUM = 'PLATINUM',
  SILVER = 'SILVER',
}

export type TftTopChampionsPerItem = {
  __typename?: 'TftTopChampionsPerItem';
  champions?: Maybe<Array<TftChampion>>;
  item: TftItem;
};

export type TftTopChampionsPerItemFilter = {
  set?: InputMaybe<Scalars['TftSet']>;
};

export type TftUpdateCompositionGuideAlternativeChampionInput = {
  alternative: Array<Scalars['String']>;
  base: Array<Scalars['String']>;
};

export type TftUpdateCompositionGuideAlternativeChampionWithItemsInput = {
  items?: InputMaybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
};

export type TftUpdateCompositionGuideAlternativeChampionsInput = {
  alternatives: Array<TftUpdateCompositionGuideAlternativeChampionInput>;
  compositionId: Scalars['ID'];
};

export type TftUpdateCompositionGuideAlternativeItemsInput = {
  alternatives: Array<TftUpdateCompositionGuideAlternativeChampionWithItemsInput>;
  compositionId: Scalars['ID'];
};

export type TftUpdateCompositionGuideAugmentsInput = {
  augments?: InputMaybe<Array<Scalars['String']>>;
  compositionId: Scalars['ID'];
};

export type TftUpdateCompositionGuideCarouselInput = {
  compositionId: Scalars['ID'];
  items?: InputMaybe<Array<Scalars['String']>>;
};

export type TftUpdateCompositionGuideDeleteVideoInput = {
  compositionId: Scalars['ID'];
};

export type TftUpdateCompositionGuideGamePlanInput = {
  advice: Scalars['String'];
  compositionId: Scalars['ID'];
  formation: TftCompositionFormationInput;
  type: TftCompositionGuideGamePlanType;
};

export type TftUpdateCompositionGuideInput = {
  compositionId: Scalars['ID'];
  tips?: InputMaybe<Scalars['String']>;
  whenToMake: Scalars['String'];
};

export type TftUpdateCompositionGuideLegendInput = {
  compositionId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
};

export type TftUpdateCompositionGuidePayload = {
  __typename?: 'TftUpdateCompositionGuidePayload';
  errors?: Maybe<Array<Maybe<TftError>>>;
  guide?: Maybe<TftCompositionGuide>;
  guideId?: Maybe<Scalars['ID']>;
};

export type TftUpdateCompositionGuideUpdateVideoInput = {
  compositionId: Scalars['ID'];
  isPremium?: InputMaybe<Scalars['Boolean']>;
  previewURL?: InputMaybe<Scalars['String']>;
  videoURL: Scalars['String'];
};

export type TftUpdateCompositionInput = {
  description?: InputMaybe<Scalars['String']>;
  difficulty: Scalars['String'];
  formation: TftCompositionFormationInput;
  id: Scalars['ID'];
  name: Scalars['String'];
  /**
   * Patch is optional only for backward compatibility.
   * It is recommended to set patch proprety.
   * Set to the current patch by default.
   */
  patch?: InputMaybe<Scalars['String']>;
  playstyle?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['String']>;
};

export type TftUpdateCompositionPayload = {
  __typename?: 'TftUpdateCompositionPayload';
  errors?: Maybe<Array<Maybe<TftError>>>;
  myCompositions?: Maybe<TftMyCompositionsInfiniteScroll>;
  publicCompositions?: Maybe<TftPublicCompositionsInfiniteScroll>;
  record?: Maybe<TftComposition>;
  recordId?: Maybe<Scalars['ID']>;
};

export type TftUpdateCompositionPayloadmyCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftMyCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftMyCompositionsSort>>;
};

export type TftUpdateCompositionPayloadpublicCompositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TftPublicCompositionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<TftPublicCompositionsSort>>;
};

/**
 * User is an author of TFT composition.
 * Could have zero to many compositions.
 */
export type TftUser = {
  __typename?: 'TftUser';
  compositions?: Maybe<Array<TftComposition>>;
  gameName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  profile?: Maybe<TftProfile>;
  region?: Maybe<Region>;
  summoner?: Maybe<TftSummoner>;
  /** DEPRECATED. Use gameName/tagLine instead. */
  summonerName?: Maybe<Scalars['String']>;
  tagLine?: Maybe<Scalars['String']>;
};

/**
 * User is an author of TFT composition.
 * Could have zero to many compositions.
 */
export type TftUserprofileArgs = {
  set: Scalars['TftSet'];
};

export type TftVoteForCompositionInput = {
  id: Scalars['ID'];
  vote: TftCompositionVote;
};

export type TftVoteForCompositionPayload = {
  __typename?: 'TftVoteForCompositionPayload';
  error?: Maybe<TftError>;
};

export type TheBazaarDocumentCmWidgetBoardCreatorV1 = NgfDocumentContent & {
  __typename?: 'TheBazaarDocumentCmWidgetBoardCreatorV1';
  data: TheBazaarDocumentCmWidgetBoardCreatorV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type TheBazaarDocumentCmWidgetBoardCreatorV1Data = NgfDocumentContentData & {
  __typename?: 'TheBazaarDocumentCmWidgetBoardCreatorV1Data';
  cards?: Maybe<Array<Maybe<TheBazaarItemData>>>;
  description: NgfDocumentRichTextContent;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle: NgfDocumentRichTextContent;
  title: Scalars['String'];
};

export type TheBazaarDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'TheBazaarDocumentCmWidgetV1';
  data: TheBazaarDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type TheBazaarDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'TheBazaarDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TheBazaarDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | TheBazaarDocumentCmWidgetBoardCreatorV1
  | TheBazaarDocumentCmWidgetV1;

export type TheBazaarDocumentSeason = NgfDocumentSeason & {
  __typename?: 'TheBazaarDocumentSeason';
  slug: Scalars['String'];
};

export type TheBazaarDocumentTags = NgfDocumentTags & {
  __typename?: 'TheBazaarDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type TheBazaarDocumentsMutation = {
  __typename?: 'TheBazaarDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: TheBazaarStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: TheBazaarStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: TheBazaarStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: TheBazaarStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: TheBazaarUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: TheBazaarUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: TheBazaarUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: TheBazaarUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: TheBazaarUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: TheBazaarUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: TheBazaarWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: TheBazaarWikiDocumentUpdatePayload;
};

export type TheBazaarDocumentsMutationstructDocumentCreateArgs = {
  input: TheBazaarStructDocumentCreateInput;
};

export type TheBazaarDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type TheBazaarDocumentsMutationstructDocumentSetStatusArgs = {
  input: TheBazaarStructDocumentSetStatusInput;
};

export type TheBazaarDocumentsMutationstructDocumentUpdateArgs = {
  input: TheBazaarStructDocumentUpdateInput;
};

export type TheBazaarDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: TheBazaarUserGeneratedDocumentCreateInput;
};

export type TheBazaarDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: TheBazaarUserGeneratedDocumentSetFavoriteInput;
};

export type TheBazaarDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: TheBazaarUserGeneratedDocumentSetFeaturedInput;
};

export type TheBazaarDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type TheBazaarDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: TheBazaarUserGeneratedDocumentSetStatusInput;
};

export type TheBazaarDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: TheBazaarUserGeneratedDocumentUpdateInput;
};

export type TheBazaarDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type TheBazaarDocumentsMutationwikiDocumentUpdateArgs = {
  input: TheBazaarWikiDocumentUpdateInput;
};

export type TheBazaarDocumentsQuery = {
  __typename?: 'TheBazaarDocumentsQuery';
  previewDocumentContent: TheBazaarPreviewDocumentContentPayload;
  structDocumentBySlug: TheBazaarStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: TheBazaarUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: TheBazaarUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: TheBazaarUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: TheBazaarUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: TheBazaarTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: TheBazaarWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type TheBazaarDocumentsQuerypreviewDocumentContentArgs = {
  input: TheBazaarPreviewDocumentContentInput;
};

export type TheBazaarDocumentsQuerystructDocumentBySlugArgs = {
  input: TheBazaarStructDocumentInputBySlug;
};

export type TheBazaarDocumentsQuerystructDocumentsArgs = {
  input: TheBazaarStructDocumentsInput;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: TheBazaarUserGeneratedDocumentInputById;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: TheBazaarUserGeneratedDocumentInputBySlug;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: TheBazaarTemplateDocumentInput;
};

export type TheBazaarDocumentsQueryuserGeneratedDocumentsArgs = {
  input: TheBazaarUserGeneratedDocumentsListInput;
  page: TheBazaarUserGeneratedDocumentsListPage;
};

export type TheBazaarDocumentsQuerywikiDocumentArgs = {
  input: TheBazaarWikiDocumentInput;
};

export type TheBazaarDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<TheBazaarWikiDocumentsListInput>;
  page: TheBazaarWikiDocumentsListPage;
};

export type TheBazaarEnchantments = {
  __typename?: 'TheBazaarEnchantments';
  descriptions?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export enum TheBazaarEntitiesEnum {
  heroes = 'heroes',
  items = 'items',
  skills = 'skills',
}

export type TheBazaarEntityObject = NGFEntityObject & {
  __typename?: 'TheBazaarEntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<TheBazaarGameEntity>;
  enumType?: Maybe<TheBazaarEntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TheBazaarGameEntity = {
  slug: Scalars['String'];
};

export type TheBazaarHero = TheBazaarGameEntity & {
  __typename?: 'TheBazaarHero';
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type TheBazaarHeroesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type TheBazaarHeroesResult = {
  __typename?: 'TheBazaarHeroesResult';
  data?: Maybe<Array<TheBazaarHero>>;
  error?: Maybe<TheBazaarStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type TheBazaarItem = TheBazaarGameEntity & {
  __typename?: 'TheBazaarItem';
  ammo?: Maybe<Scalars['String']>;
  cooldown?: Maybe<Scalars['String']>;
  critchance?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<Scalars['String']>>;
  enchantments?: Maybe<Array<TheBazaarEnchantments>>;
  heroes?: Maybe<Array<TheBazaarHero>>;
  heroesSlugs?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lifesteal?: Maybe<Scalars['String']>;
  multicast?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  tierStats?: Maybe<Array<TheBazaarTierStats>>;
};

export type TheBazaarItemData = {
  __typename?: 'TheBazaarItemData';
  icon?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['String'];
  slug: Scalars['String'];
};

export type TheBazaarItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type TheBazaarItemsResult = {
  __typename?: 'TheBazaarItemsResult';
  data?: Maybe<Array<TheBazaarItem>>;
  error?: Maybe<TheBazaarStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type TheBazaarMutation = {
  __typename?: 'TheBazaarMutation';
  documents?: Maybe<TheBazaarDocumentsMutation>;
  id: Scalars['ID'];
};

export enum TheBazaarPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarPreviewDocumentContentInput = {
  content: Scalars['TheBazaarDocumentContentInputBase64Json'];
};

export type TheBazaarPreviewDocumentContentPayload = {
  __typename?: 'TheBazaarPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<TheBazaarDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<TheBazaarPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarProfile = NgfProfile & {
  __typename?: 'TheBazaarProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type TheBazaarProfileuserGeneratedDocumentsArgs = {
  input: TheBazaarUserGeneratedDocumentsListInput;
  page: TheBazaarUserGeneratedDocumentsListPage;
};

export type TheBazaarProfilePayload = {
  __typename?: 'TheBazaarProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<TheBazaarProfile>;
};

export type TheBazaarProfilesQuery = {
  __typename?: 'TheBazaarProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: TheBazaarProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type TheBazaarProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type TheBazaarQuery = {
  __typename?: 'TheBazaarQuery';
  documents?: Maybe<TheBazaarDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<TheBazaarProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  theBazaarStaticData?: Maybe<TheBazaarTheBazaarStaticDataQuery>;
};

export type TheBazaarSkill = TheBazaarGameEntity & {
  __typename?: 'TheBazaarSkill';
  descriptions?: Maybe<Array<Scalars['String']>>;
  heroes?: Maybe<Array<TheBazaarHero>>;
  heroesSlugs?: Maybe<Array<Scalars['String']>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  tierStats?: Maybe<Array<TheBazaarTierStats>>;
};

export type TheBazaarSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type TheBazaarSkillsResult = {
  __typename?: 'TheBazaarSkillsResult';
  data?: Maybe<Array<TheBazaarSkill>>;
  error?: Maybe<TheBazaarStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum TheBazaarStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type TheBazaarStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'TheBazaarStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<TheBazaarDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: TheBazaarStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum TheBazaarStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TheBazaarStructDocumentCreateInput = {
  document: Scalars['TheBazaarStructDocumentInputBase64Json'];
};

export type TheBazaarStructDocumentCreatePayload = {
  __typename?: 'TheBazaarStructDocumentCreatePayload';
  data?: Maybe<TheBazaarStructDocument>;
  error?: Maybe<TheBazaarStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarStructDocumentData = NgfStructDocumentData & {
  __typename?: 'TheBazaarStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: TheBazaarDocumentSeason;
  tags?: Maybe<TheBazaarDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum TheBazaarStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type TheBazaarStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TheBazaarStructDocumentPayload = {
  __typename?: 'TheBazaarStructDocumentPayload';
  data?: Maybe<TheBazaarStructDocument>;
  error?: Maybe<TheBazaarStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type TheBazaarStructDocumentSetSeoPayload = {
  __typename?: 'TheBazaarStructDocumentSetSeoPayload';
  data?: Maybe<TheBazaarStructDocument>;
  error?: Maybe<TheBazaarStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type TheBazaarStructDocumentSetStatusPayload = {
  __typename?: 'TheBazaarStructDocumentSetStatusPayload';
  data?: Maybe<TheBazaarStructDocument>;
  error?: Maybe<TheBazaarStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarStructDocumentUpdateInput = {
  document: Scalars['TheBazaarStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type TheBazaarStructDocumentUpdatePayload = {
  __typename?: 'TheBazaarStructDocumentUpdatePayload';
  data?: Maybe<TheBazaarStructDocument>;
  error?: Maybe<TheBazaarStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type TheBazaarTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'TheBazaarTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<TheBazaarDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: TheBazaarTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type TheBazaarTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'TheBazaarTemplateDocumentData';
  buildVariants?: Maybe<TheBazaarUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: TheBazaarDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum TheBazaarTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarTemplateDocumentInput = {
  type: Scalars['String'];
};

export type TheBazaarTemplateDocumentPayload = {
  __typename?: 'TheBazaarTemplateDocumentPayload';
  data?: Maybe<TheBazaarTemplateDocument>;
  error?: Maybe<TheBazaarTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarTheBazaarStaticDataQuery = {
  __typename?: 'TheBazaarTheBazaarStaticDataQuery';
  theBazaarHeroes: TheBazaarHeroesResult;
  theBazaarItems: TheBazaarItemsResult;
  theBazaarSkills: TheBazaarSkillsResult;
};

export type TheBazaarTheBazaarStaticDataQuerytheBazaarHeroesArgs = {
  filter?: InputMaybe<TheBazaarHeroesFilter>;
};

export type TheBazaarTheBazaarStaticDataQuerytheBazaarItemsArgs = {
  filter?: InputMaybe<TheBazaarItemsFilter>;
};

export type TheBazaarTheBazaarStaticDataQuerytheBazaarSkillsArgs = {
  filter?: InputMaybe<TheBazaarSkillsFilter>;
};

export type TheBazaarTierStats = {
  __typename?: 'TheBazaarTierStats';
  ammo?: Maybe<Scalars['Int']>;
  cooldown?: Maybe<Scalars['Float']>;
  critchance?: Maybe<Scalars['Int']>;
  descriptions?: Maybe<Array<Scalars['String']>>;
  lifesteal?: Maybe<Scalars['Int']>;
  multicast?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['String']>;
};

export type TheBazaarUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'TheBazaarUGDocumentGenericBuilder';
  slots?: Maybe<Array<TheBazaarUGDocumentGenericBuilderSlot>>;
};

export type TheBazaarUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'TheBazaarUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<TheBazaarEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type TheBazaarUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'TheBazaarUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<TheBazaarDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: TheBazaarUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<TheBazaarDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type TheBazaarUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'TheBazaarUserGeneratedDocumentBuildVariant';
  genericBuilder: TheBazaarUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type TheBazaarUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'TheBazaarUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<TheBazaarUserGeneratedDocumentBuildVariant>>;
};

export enum TheBazaarUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TheBazaarUserGeneratedDocumentCreateInput = {
  document: Scalars['TheBazaarUserGeneratedDocumentInputBase64Json'];
};

export type TheBazaarUserGeneratedDocumentCreatePayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentCreatePayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'TheBazaarUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<TheBazaarUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: TheBazaarDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum TheBazaarUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type TheBazaarUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TheBazaarUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TheBazaarUserGeneratedDocumentPayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentPayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type TheBazaarUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TheBazaarUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type TheBazaarUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type TheBazaarUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type TheBazaarUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type TheBazaarUserGeneratedDocumentUpdateInput = {
  document: Scalars['TheBazaarUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type TheBazaarUserGeneratedDocumentUpdatePayload = {
  __typename?: 'TheBazaarUserGeneratedDocumentUpdatePayload';
  data?: Maybe<TheBazaarUserGeneratedDocument>;
  error?: Maybe<TheBazaarUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type TheBazaarUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type TheBazaarWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'TheBazaarWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<TheBazaarDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: TheBazaarWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<TheBazaarDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type TheBazaarWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'TheBazaarWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: TheBazaarEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum TheBazaarWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type TheBazaarWikiDocumentPayload = {
  __typename?: 'TheBazaarWikiDocumentPayload';
  data?: Maybe<TheBazaarWikiDocument>;
  error?: Maybe<TheBazaarWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type TheBazaarWikiDocumentSetSeoPayload = {
  __typename?: 'TheBazaarWikiDocumentSetSeoPayload';
  data?: Maybe<TheBazaarWikiDocument>;
  error?: Maybe<TheBazaarWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum TheBazaarWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type TheBazaarWikiDocumentUpdateInput = {
  document: Scalars['TheBazaarWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type TheBazaarWikiDocumentUpdatePayload = {
  __typename?: 'TheBazaarWikiDocumentUpdatePayload';
  data?: Maybe<TheBazaarWikiDocument>;
  error?: Maybe<TheBazaarWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type TheBazaarWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type TheBazaarWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type TreasuryFlowActivatedStep = {
  __typename?: 'TreasuryFlowActivatedStep';
  activatedAt?: Maybe<Scalars['TreasuryFlowTime']>;
  id: Scalars['ID'];
};

export type TreasuryFlowActivatedStepOrError = TreasuryFlowActivatedStep | TreasuryFlowGenericError;

export type TreasuryFlowAvailableStep = {
  __typename?: 'TreasuryFlowAvailableStep';
  availableAfter?: Maybe<Scalars['TreasuryFlowTimeDuration']>;
  expiresAt?: Maybe<Scalars['TreasuryFlowTime']>;
  id: Scalars['ID'];
  /**
   * When the step was first shown to the user, recorded by markStepShown. Null if never recorded — steps whose showing is not tracked stay null forever.
   * An activated step always counts as shown.
   */
  shownAt?: Maybe<Scalars['TreasuryFlowTime']>;
};

export type TreasuryFlowAvailableStepFilter = {
  flowID: Scalars['ID'];
};

export type TreasuryFlowAvailableStepOrError = TreasuryFlowAvailableStep | TreasuryFlowGenericError;

export type TreasuryFlowError = {
  message?: Maybe<Scalars['String']>;
};

export type TreasuryFlowGenericError = TreasuryFlowError & {
  __typename?: 'TreasuryFlowGenericError';
  message?: Maybe<Scalars['String']>;
};

export type TreasuryFlowInfo = {
  info?: Maybe<Array<TreasuryFlowInfoData>>;
};

export type TreasuryFlowInfoData = {
  __typename?: 'TreasuryFlowInfoData';
  couponID: Scalars['String'];
  interval: TreasuryFlowPlanInterval;
  planID: Scalars['String'];
};

export type TreasuryFlowInfoFilter = {
  flowID: Scalars['ID'];
  game: Scalars['String'];
};

export type TreasuryFlowInfoGeneral = TreasuryFlowInfo & {
  __typename?: 'TreasuryFlowInfoGeneral';
  info?: Maybe<Array<TreasuryFlowInfoData>>;
};

export type TreasuryFlowMutation = {
  __typename?: 'TreasuryFlowMutation';
  /** Activate the available step and get the next available step, null when the flow is finished. Activation implies the step was shown to the user */
  activateStep?: Maybe<TreasuryFlowAvailableStepOrError>;
  /** Record that the available step was shown to the user without activating it; the step stays available and is returned with shownAt set. Only the currently available step can be marked. Idempotent: repeat calls succeed and keep the first shownAt */
  markStepShown?: Maybe<TreasuryFlowAvailableStepOrError>;
};

export type TreasuryFlowMutationactivateStepArgs = {
  flowID: Scalars['ID'];
  stepID: Scalars['ID'];
};

export type TreasuryFlowMutationmarkStepShownArgs = {
  flowID: Scalars['ID'];
  stepID: Scalars['ID'];
};

/** Billing interval of the offered plan */
export enum TreasuryFlowPlanInterval {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export type TreasuryFlowPreviousStepFilter = {
  flowID: Scalars['ID'];
};

export type TreasuryFlowQuery = {
  __typename?: 'TreasuryFlowQuery';
  /**
   * Get the step the user can act on now: the first step in the flow's order that is not activated yet and whose prerequisites pass.
   * A step blocked only by a time requirement is still returned, with availableAfter carrying the remaining wait.
   * Null when the flow is finished, disabled, or not applicable to the user.
   */
  availableStep?: Maybe<TreasuryFlowAvailableStepOrError>;
  /** Get information specific for a particular flow and game. Flow information is user-agnostic */
  flowInfo?: Maybe<TreasuryFlowInfo>;
  /** Get the last activated step of the flow. Null if the user has not activated any step yet */
  previousStep?: Maybe<TreasuryFlowActivatedStepOrError>;
};

export type TreasuryFlowQueryavailableStepArgs = {
  filter?: InputMaybe<TreasuryFlowAvailableStepFilter>;
};

export type TreasuryFlowQueryflowInfoArgs = {
  filter?: InputMaybe<TreasuryFlowInfoFilter>;
};

export type TreasuryFlowQuerypreviousStepArgs = {
  filter?: InputMaybe<TreasuryFlowPreviousStepFilter>;
};

export type TreasuryMutation = {
  __typename?: 'TreasuryMutation';
  flow?: Maybe<TreasuryFlowMutation>;
  id: Scalars['ID'];
  payments?: Maybe<TreasuryPaymentsMutation>;
};

export type TreasuryPaymentBundleFilter = {
  selectedPlan?: InputMaybe<TreasuryPaymentSelectedPlan>;
  selectedPrices?: InputMaybe<Array<TreasuryPaymentSelectedPrice>>;
};

export type TreasuryPaymentCustomerAction =
  | TreasuryPaymentCustomerActionCancelSubscription
  | TreasuryPaymentCustomerActionChangeSubscription
  | TreasuryPaymentCustomerActionCreateSubscription
  | TreasuryPaymentCustomerActionRenewSubscription
  | TreasuryPaymentCustomerActionUseTrial;

export type TreasuryPaymentCustomerActionCancelSubscription = {
  __typename?: 'TreasuryPaymentCustomerActionCancelSubscription';
  isAllowed: Scalars['Boolean'];
};

export type TreasuryPaymentCustomerActionChangeSubscription = {
  __typename?: 'TreasuryPaymentCustomerActionChangeSubscription';
  isAllowed: Scalars['Boolean'];
  product: TreasuryPaymentsProduct;
};

export type TreasuryPaymentCustomerActionCreateSubscription = {
  __typename?: 'TreasuryPaymentCustomerActionCreateSubscription';
  isAllowed: Scalars['Boolean'];
  product: TreasuryPaymentsProduct;
};

export type TreasuryPaymentCustomerActionRenewSubscription = {
  __typename?: 'TreasuryPaymentCustomerActionRenewSubscription';
  isAllowed: Scalars['Boolean'];
  product: TreasuryPaymentsProduct;
};

export type TreasuryPaymentCustomerActionUseTrial = {
  __typename?: 'TreasuryPaymentCustomerActionUseTrial';
  isAllowed: Scalars['Boolean'];
  product: TreasuryPaymentsProduct;
};

export type TreasuryPaymentSelectedPlan = {
  coupon?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type TreasuryPaymentSelectedPrice = {
  id: Scalars['String'];
};

export type TreasuryPaymentSubscriptionCheckoutItem = {
  coupon?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
};

/** Apply coupon to a payment input */
export type TreasuryPaymentsApplyCouponInput = {
  /** Coupon ID or promo code */
  couponName: Scalars['String'];
  /** Payment plan ids to apply the coupon */
  planIds: Array<Scalars['ID']>;
};

/** Apply coupon to a payment payload */
export type TreasuryPaymentsApplyCouponPayload = {
  __typename?: 'TreasuryPaymentsApplyCouponPayload';
  /** Errors that may occur during the mutation */
  errors?: Maybe<Array<TreasuryPaymentsError>>;
  /** Payment plans with the coupon applied */
  plans?: Maybe<Array<TreasuryPaymentsPlan>>;
};

export type TreasuryPaymentsApplyCouponToActiveSubscriptionPayload = {
  __typename?: 'TreasuryPaymentsApplyCouponToActiveSubscriptionPayload';
  error?: Maybe<TreasuryPaymentsError>;
  subscription?: Maybe<TreasuryPaymentsSubscription>;
};

/** The error returned when given parameters are invalid */
export type TreasuryPaymentsBadRequestError = TreasuryPaymentsError & {
  __typename?: 'TreasuryPaymentsBadRequestError';
  /** Details about the error */
  details?: Maybe<Scalars['String']>;
  /** The error message */
  message?: Maybe<Scalars['String']>;
  /** Parameter name */
  parameter?: Maybe<Scalars['String']>;
};

export type TreasuryPaymentsBillingAddress = {
  __typename?: 'TreasuryPaymentsBillingAddress';
  /** The billing city of the customer */
  city: Scalars['String'];
  /** The billing country of the customer */
  country: Scalars['String'];
  /** The billing address line 1 of the customer */
  line1: Scalars['String'];
  /** The billing address line 2 of the customer */
  line2: Scalars['String'];
  /** The billing state of the customer */
  state: Scalars['String'];
  /** The billing zip code of the customer */
  zip: Scalars['String'];
};

/** The billing info information of the customer. */
export type TreasuryPaymentsBillingInfo = {
  __typename?: 'TreasuryPaymentsBillingInfo';
  /** Paypal billing info */
  paypal?: Maybe<TreasuryPaymentsPayPal>;
  /** Stripe billing info */
  stripe?: Maybe<TreasuryPaymentsStripe>;
  /** Stripe payment method info */
  stripePaymentMethod?: Maybe<TreasuryPaymentsStripePaymentMethod>;
};

export type TreasuryPaymentsBillingInfoOrError = TreasuryPaymentsBillingInfo | TreasuryPaymentsUnknownError;

export type TreasuryPaymentsBundle = {
  __typename?: 'TreasuryPaymentsBundle';
  basePrice: TreasuryPaymentsMoney;
  description?: Maybe<Scalars['String']>;
  finalPrice: TreasuryPaymentsMoney;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  plan?: Maybe<TreasuryPaymentsPlan>;
  prices?: Maybe<Array<TreasuryPaymentsPrice>>;
};

/** Cancel subscription input */
export type TreasuryPaymentsCancelSubscriptionInput = {
  /** Unique identifier of a subscription to be cancelled */
  subscriptionId: Scalars['ID'];
};

/** Cancel subscription payload */
export type TreasuryPaymentsCancelSubscriptionPayload = {
  __typename?: 'TreasuryPaymentsCancelSubscriptionPayload';
  /** Error */
  error?: Maybe<TreasuryPaymentsError>;
  /** Cancelled subscription ID */
  id?: Maybe<Scalars['ID']>;
  /** Subscription that was cancelled */
  subscription?: Maybe<TreasuryPaymentsSubscription>;
};

export type TreasuryPaymentsCard = {
  __typename?: 'TreasuryPaymentsCard';
  /** The customer's card last 4 digits */
  last4: Scalars['String'];
  /** The customer's card name */
  name: Scalars['String'];
};

/** Change subscription input */
export type TreasuryPaymentsChangeSubscriptionInput = {
  /** Coupon ID or promo code */
  couponName?: InputMaybe<Scalars['String']>;
  /** New desired plan */
  planId: Scalars['ID'];
  /** Product abbreviation from the ngf-configuration products list, e.g. "d4", "battle-pass". Exactly one of game and productAbbreviation must be set */
  productAbbreviation?: InputMaybe<Scalars['String']>;
};

/** Change subscription plan payload */
export type TreasuryPaymentsChangeSubscriptionPayload = {
  __typename?: 'TreasuryPaymentsChangeSubscriptionPayload';
  /** Error */
  error?: Maybe<TreasuryPaymentsError>;
  /** Payment intent secret for 3D Secure for instant payment */
  paymentIntentSecret?: Maybe<Scalars['String']>;
  /** Setup intent secret for 3D Secure, for using when trial, and no instant payment needed */
  setupIntentSecret?: Maybe<Scalars['String']>;
  /** The updated subscription */
  subscription?: Maybe<TreasuryPaymentsSubscription>;
};

export type TreasuryPaymentsCheckoutInput = {
  oneTimeItems?: InputMaybe<Array<TreasuryPaymentsCheckoutItem>>;
  provider: TreasuryPaymentsProvider;
  subscriptionItem?: InputMaybe<TreasuryPaymentSubscriptionCheckoutItem>;
};

export type TreasuryPaymentsCheckoutItem = {
  priceId: Scalars['String'];
};

export type TreasuryPaymentsCheckoutPayload = {
  __typename?: 'TreasuryPaymentsCheckoutPayload';
  /**
   *  Currently only for stripe, a secret needed to render the payment form.
   * It is created during creation of stripe checkout session via Stripe API.
   */
  clientSecret?: Maybe<Scalars['String']>;
  error?: Maybe<TreasuryPaymentsError>;
  /** Subscription if one was purchased during checkout. */
  subscription?: Maybe<TreasuryPaymentsSubscription>;
  /** Total amount of money we are going to charge from the user */
  totalAmount?: Maybe<TreasuryPaymentsMoney>;
};

/** Coupon that can be applied to a payment to get a discount by user */
export type TreasuryPaymentsCoupon = {
  __typename?: 'TreasuryPaymentsCoupon';
  /** Coupon discount. Can be a percentage or an amount */
  discount: TreasuryPaymentsCouponDiscount;
  /** Coupon ID or promo code */
  name: Scalars['String'];
};

/** Discount that can be applied to a payment to get a discount by user */
export type TreasuryPaymentsCouponDiscount =
  | TreasuryPaymentsCouponDiscountAmount
  | TreasuryPaymentsCouponDiscountPercentage;

/** Discount that can be applied to a payment to get a discount by user */
export type TreasuryPaymentsCouponDiscountAmount = {
  __typename?: 'TreasuryPaymentsCouponDiscountAmount';
  /** Amount of discount */
  amount: TreasuryPaymentsMoney;
};

/** Discount that can be applied to a payment to get a discount by user */
export type TreasuryPaymentsCouponDiscountPercentage = {
  __typename?: 'TreasuryPaymentsCouponDiscountPercentage';
  /** Percentage of discount */
  percentage: Scalars['Float'];
};

/** Input to get plans with applied queries */
export type TreasuryPaymentsCouponPlansFilter = {
  /** Coupon ID or promo code */
  couponName: Scalars['String'];
  /** Filter plans by the availability of a trial */
  hasTrial?: InputMaybe<Scalars['Boolean']>;
  /** Product abbreviation from the ngf-configuration products list, e.g. "d4", "battle-pass". Exactly one of game and productAbbreviation must be set */
  productAbbreviation?: InputMaybe<Scalars['String']>;
};

/** Create subscription input */
export type TreasuryPaymentsCreateSubscriptionInput = {
  /** Coupon ID or promo code */
  couponName?: InputMaybe<Scalars['String']>;
  /** Plan that this subscription is associated with */
  planId: Scalars['ID'];
  /** Product abbreviation from the ngf-configuration products list, e.g. "d4", "battle-pass". Exactly one of game and productAbbreviation must be set */
  productAbbreviation?: InputMaybe<Scalars['String']>;
  /** The payment provider that this subscription is associated with */
  provider: TreasuryPaymentsProvider;
  /** Payment provider token */
  token?: InputMaybe<Scalars['String']>;
};

/** Create subscription payload */
export type TreasuryPaymentsCreateSubscriptionPayload = {
  __typename?: 'TreasuryPaymentsCreateSubscriptionPayload';
  /** Get a customer for authorized user */
  customer: TreasuryPaymentsCustomerOrError;
  /** Error */
  error?: Maybe<TreasuryPaymentsError>;
  /** Subscription id */
  id?: Maybe<Scalars['ID']>;
  /** Payment intent secret for 3D Secure for instant payment */
  paymentIntentSecret?: Maybe<Scalars['String']>;
  /** Setup intent secret for 3D Secure, for using when trial, and no instant payment needed */
  setupIntentSecret?: Maybe<Scalars['String']>;
  /** The created subscription */
  subscription?: Maybe<TreasuryPaymentsSubscription>;
};

/** Customer stores information about a user's subscription status and payment history. */
export type TreasuryPaymentsCustomer = {
  __typename?: 'TreasuryPaymentsCustomer';
  /** Actions that can be performed on the customer. */
  allowedActions?: Maybe<Array<TreasuryPaymentCustomerAction>>;
  /** Billing information associated with the customer. */
  billingInfo?: Maybe<TreasuryPaymentsBillingInfoOrError>;
  /** The ID of the customer. */
  id: Scalars['ID'];
  /**
   * Payment history associated with the customer.
   * Default sort is by createdAt descending.
   */
  paymentHistory: Array<TreasuryPaymentsPaymentOrError>;
  /**
   * Subscriptions associated with the customer.
   * Default sort is by createdAt descending.
   */
  subscriptions: Array<TreasuryPaymentsSubscriptionOrError>;
  /** Indicates if customer has a trial. */
  trial?: Maybe<TreasuryPaymentsCustomerTrialOrError>;
  /** The user associated with the customer. */
  user: User;
};

/** Customer stores information about a user's subscription status and payment history. */
export type TreasuryPaymentsCustomerallowedActionsArgs = {
  filter: TreasuryPaymentsCustomerActionsFilter;
};

/** Customer stores information about a user's subscription status and payment history. */
export type TreasuryPaymentsCustomersubscriptionsArgs = {
  filter?: InputMaybe<TreasuryPaymentsSubscriptionFilter>;
};

export type TreasuryPaymentsCustomerActionsFilter = {
  /** Product abbreviation from the ngf-configuration products list, e.g. "d4", "battle-pass". Exactly one of game and productAbbreviation must be set */
  productAbbreviation?: InputMaybe<Scalars['String']>;
};

/** Result of querying for a customer. */
export type TreasuryPaymentsCustomerOrError =
  | TreasuryPaymentsCustomer
  | TreasuryPaymentsUnauthenticatedError
  | TreasuryPaymentsUnknownError;

/** Customer payload */
export type TreasuryPaymentsCustomerPayload = {
  __typename?: 'TreasuryPaymentsCustomerPayload';
  /** Customer info payload */
  customer?: Maybe<TreasuryPaymentsCustomer>;
  /** Error that may occur during the mutation */
  error?: Maybe<TreasuryPaymentsError>;
};

/** A customer trial. */
export type TreasuryPaymentsCustomerTrial = {
  __typename?: 'TreasuryPaymentsCustomerTrial';
  /** Time when the trial will expire/has expired. */
  expirationDate: Scalars['TreasuryPaymentsTime'];
  /** The ID of the trial. */
  id: Scalars['ID'];
  /** Indicates if the trial is active. */
  isActive: Scalars['Boolean'];
  /** Time when the trial was started. */
  startDate: Scalars['TreasuryPaymentsTime'];
  /** Subscription associated with the trial. */
  subscription: TreasuryPaymentsSubscriptionOrError;
};

/** Result of querying for a customer trial. */
export type TreasuryPaymentsCustomerTrialOrError = TreasuryPaymentsCustomerTrial | TreasuryPaymentsUnknownError;

/** Delete billing info input */
export type TreasuryPaymentsDeleteBillingInfoInput = {
  provider: TreasuryPaymentsProvider;
};

/** Delete billing info payload */
export type TreasuryPaymentsDeleteBillingInfoPayload = {
  __typename?: 'TreasuryPaymentsDeleteBillingInfoPayload';
  /** Is customer info deleted */
  deleteCustomerInfo: Scalars['Boolean'];
  /** Error that may occur during the mutation */
  error?: Maybe<TreasuryPaymentsError>;
};

export type TreasuryPaymentsDigitalProduct = {
  __typename?: 'TreasuryPaymentsDigitalProduct';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  plans?: Maybe<Array<TreasuryPaymentsPlan>>;
  prices?: Maybe<Array<TreasuryPaymentsPrice>>;
  type: TreasuryPaymentsProductType;
};

/** The error interface for the TreasuryPayments API */
export type TreasuryPaymentsError = {
  /** The error message */
  message?: Maybe<Scalars['String']>;
};

/**
 * Deprecated: frozen list of games, new games are not added here.
 * Use the productAbbreviation string input fields; they accept the products listed in ngf-configuration.
 */
export enum TreasuryPaymentsGame {
  /**
   * Battle pass is not a game but a section of site from which a user can be redirected to the payments page.
   * @deprecated Not a game: Battle Pass price context, to be replaced by a separate placement input
   */
  BATTLE_PASS = 'BATTLE_PASS',
  /**
   * NGF Borderlands 4
   * @deprecated Use productAbbreviation
   */
  BORDERLANDS_4 = 'BORDERLANDS_4',
  /** @deprecated Use productAbbreviation */
  DEADLOCK = 'DEADLOCK',
  /**
   * Destiny 2
   * @deprecated Use productAbbreviation
   */
  DESTINY_2 = 'DESTINY_2',
  /**
   * Diablo 4
   * @deprecated Use productAbbreviation
   */
  DIABLO_4 = 'DIABLO_4',
  /**
   * Elden Ring Nightreign
   * @deprecated Use productAbbreviation
   */
  ELDEN_RING_NIGHTREIGN = 'ELDEN_RING_NIGHTREIGN',
  /**
   * Endfield
   * @deprecated Use productAbbreviation
   */
  ENDFIELD = 'ENDFIELD',
  /** @deprecated Use productAbbreviation */
  EXAMPLE_GAME = 'EXAMPLE_GAME',
  /**
   * Genshin Impact
   * @deprecated Use productAbbreviation
   */
  GI = 'GI',
  /**
   * NGF Hades 2
   * @deprecated Use productAbbreviation
   */
  HADES_2 = 'HADES_2',
  /**
   * League of Legends
   * @deprecated Use productAbbreviation
   */
  LOL = 'LOL',
  /**
   * Marathon
   * @deprecated Use productAbbreviation
   */
  MARATHON = 'MARATHON',
  /**
   * Marvel Rivals
   * @deprecated Use productAbbreviation
   */
  MARVEL_RIVALS = 'MARVEL_RIVALS',
  /**
   * Monster Hunter Wilds
   * @deprecated Use productAbbreviation
   */
  MHW = 'MHW',
  /**
   * NGF News
   * @deprecated Use productAbbreviation
   */
  NEWS = 'NEWS',
  /**
   * Neverness to Everness
   * @deprecated Use productAbbreviation
   */
  NTE = 'NTE',
  /**
   * Overwatch
   * @deprecated Use productAbbreviation
   */
  OVERWATCH = 'OVERWATCH',
  /**
   * Path of Exile
   * @deprecated Use productAbbreviation
   */
  POE = 'POE',
  /** @deprecated Use productAbbreviation */
  POE_2 = 'POE_2',
  /**
   * Riftbound
   * @deprecated Use productAbbreviation
   */
  RIFTBOUND = 'RIFTBOUND',
  /**
   * Slay the Spire 2
   * @deprecated Use productAbbreviation
   */
  STS2 = 'STS2',
  /**
   * Teamfight Tactics
   * @deprecated Use productAbbreviation
   */
  TFT = 'TFT',
  /** @deprecated Use productAbbreviation */
  THE_BAZAAR = 'THE_BAZAAR',
  /**
   * Valorant
   * @deprecated Use productAbbreviation
   */
  VALORANT = 'VALORANT',
  /**
   * World of Warcraft: Forever
   * @deprecated Use productAbbreviation
   */
  WOWFOR = 'WOWFOR',
  /**
   * 2XKO
   * @deprecated Use productAbbreviation
   */
  XKO = 'XKO',
  /**
   * Zenless Zone Zero
   * @deprecated Use productAbbreviation
   */
  ZZZ = 'ZZZ',
}

/**
 * Money type. This is a custom scalar type that represents a monetary value
 * https://www.martinfowler.com/eaaCatalog/money.html
 */
export type TreasuryPaymentsMoney = {
  __typename?: 'TreasuryPaymentsMoney';
  /** Smallest currency unit. For example, cents for USD */
  amount: Scalars['Int'];
  /** Currency code. For example, USD for US dollars */
  currency: Scalars['String'];
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutation = {
  __typename?: 'TreasuryPaymentsMutation';
  /** Apply coupon to current active subscription */
  applyCouponToActiveSubscription: TreasuryPaymentsApplyCouponToActiveSubscriptionPayload;
  /** Cancel subscription */
  cancelSubscription: TreasuryPaymentsCancelSubscriptionPayload;
  /** Change subscription plan */
  changeSubscription: TreasuryPaymentsChangeSubscriptionPayload;
  /** Checkout a number of items. Supports one-time payments */
  checkout?: Maybe<TreasuryPaymentsCheckoutPayload>;
  /** Create subscription */
  createSubscription: TreasuryPaymentsCreateSubscriptionPayload;
  /** Delete billing info */
  deleteBillingInfo?: Maybe<TreasuryPaymentsCustomerPayload>;
  /** Returns Stripe setup intent secret to be used for updating billing info */
  prepareUpdateBillingInfo?: Maybe<TreasuryPaymentsPrepareUpdateBillingInfoPayload>;
  /** Renew subscription */
  renewSubscription: TreasuryPaymentsRenewSubscriptionPayload;
  /** Update billing info */
  updateBillingInfo?: Maybe<TreasuryPaymentsUpdateBillingInfoPayload>;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationapplyCouponToActiveSubscriptionArgs = {
  coupon: Scalars['String'];
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationcancelSubscriptionArgs = {
  input: TreasuryPaymentsCancelSubscriptionInput;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationchangeSubscriptionArgs = {
  input: TreasuryPaymentsChangeSubscriptionInput;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationcheckoutArgs = {
  input?: InputMaybe<TreasuryPaymentsCheckoutInput>;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationcreateSubscriptionArgs = {
  input: TreasuryPaymentsCreateSubscriptionInput;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationdeleteBillingInfoArgs = {
  input: TreasuryPaymentsDeleteBillingInfoInput;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationrenewSubscriptionArgs = {
  input: TreasuryPaymentsRenewSubscriptionInput;
};

/** Mutations list for Treasury Payments */
export type TreasuryPaymentsMutationupdateBillingInfoArgs = {
  input: TreasuryPaymentsUpdateBillingInfoInput;
};

export type TreasuryPaymentsPayPal = {
  __typename?: 'TreasuryPaymentsPayPal';
  /** The customer's PayPal email */
  email: Scalars['String'];
};

/** A payment is a transaction between a customer and a provider. */
export type TreasuryPaymentsPayment = {
  __typename?: 'TreasuryPaymentsPayment';
  /** Amount of payment */
  amount: TreasuryPaymentsMoney;
  /** The date and time when the payment was created. */
  date: Scalars['TreasuryPaymentsTime'];
  /** The unique identifier of the payment. */
  id: Scalars['ID'];
  /** Product that the payment is for. */
  product: TreasuryPaymentsProduct;
};

export type TreasuryPaymentsPaymentError = TreasuryPaymentsError & {
  __typename?: 'TreasuryPaymentsPaymentError';
  /** Payment error code */
  code: TreasuryPaymentsPaymentErrorCode;
  /** The error message */
  message: Scalars['String'];
};

export enum TreasuryPaymentsPaymentErrorCode {
  /** Error code for generic decline (lost or stolen card, insufficient funds) */
  DECLINED_CARD = 'DECLINED_CARD',
  /** Error code for expired card date */
  EXPIRED_CARD = 'EXPIRED_CARD',
  /** Error code for incorrect card number */
  INCORRECT_CARD_NUMBER = 'INCORRECT_CARD_NUMBER',
  /** Error code for incorrect cvc code */
  INCORRECT_CVC = 'INCORRECT_CVC',
  /** Error code for insufficient funds */
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  /** Error code for a customer without an attached payment method; attach one first */
  NO_PAYMENT_METHOD = 'NO_PAYMENT_METHOD',
  /** Error code for processing error decline */
  PROCESSING_ERROR = 'PROCESSING_ERROR',
}

/** Payment query result. */
export type TreasuryPaymentsPaymentOrError = TreasuryPaymentsPayment | TreasuryPaymentsUnknownError;

/** Input for subscription on payment received events */
export type TreasuryPaymentsPaymentReceivedInput = {
  /** Filter by subscription id */
  subscriptionId?: InputMaybe<Array<Scalars['ID']>>;
};

/** A plan that a customer can subscribe to */
export type TreasuryPaymentsPlan = {
  __typename?: 'TreasuryPaymentsPlan';
  /** The coupon applied to the plan */
  appliedCoupon?: Maybe<TreasuryPaymentsCoupon>;
  /** The proration that was applied to plan's price */
  appliedProration?: Maybe<TreasuryPaymentsMoney>;
  /** The base price of the plan */
  basePrice: TreasuryPaymentsMoney;
  /** The total discount applied to the plan; null when there is no discount */
  finalDiscount?: Maybe<TreasuryPaymentsMoney>;
  /** The final price of the plan (considering the coupon) */
  finalPrice: TreasuryPaymentsMoney;
  /** The ID of the plan */
  id: Scalars['ID'];
  /** The interval of the plan billing */
  interval: TreasuryPaymentsPlanInterval;
  /** The number of intervals between each billing */
  intervalCount: Scalars['Int'];
  /**
   * Indicates if the plan is the best choice for the customer
   * @deprecated rendering options moved to viewOptions
   */
  isBestChoice: Scalars['Boolean'];
  /** Human readable name of the plan */
  name: Scalars['String'];
  /** The price of the plan per month */
  pricePerMonth: TreasuryPaymentsMoney;
  /**
   * Product type of the plan
   * @deprecated No longer supported
   */
  product: TreasuryPaymentsProduct;
  /** Product of the plan */
  productV2: TreasuryPaymentsDigitalProduct;
  /** Human readable profit of the plan */
  profit: Scalars['String'];
  /** Indicates if the plan has a trial */
  trial?: Maybe<TreasuryPaymentsTrialOrError>;
  /** Options for showing plan to the clients */
  viewOptions?: Maybe<PlanViewOptions>;
};

/** The interval of the plan billing */
export enum TreasuryPaymentsPlanInterval {
  /** The plan is billed on daily basis */
  DAILY = 'DAILY',
  /** The plan is billed on monthly basis */
  MONTHLY = 'MONTHLY',
  /** The plan is billed on yearly basis */
  YEARLY = 'YEARLY',
}

/** The result of a plans query */
export type TreasuryPaymentsPlanOrError =
  | TreasuryPaymentsBadRequestError
  | TreasuryPaymentsPlan
  | TreasuryPaymentsUnknownError;

/** Filter to be used when querying for plans */
export type TreasuryPaymentsPlansFilter = {
  /** Filter plans by the availability of a trial */
  hasTrial?: InputMaybe<Scalars['Boolean']>;
  /** Product abbreviation from the ngf-configuration products list, e.g. "d4"; not used for filtering yet */
  productAbbreviation?: InputMaybe<Scalars['String']>;
};

export type TreasuryPaymentsPrepareUpdateBillingInfoError =
  | TreasuryPaymentsUnauthenticatedError
  | TreasuryPaymentsUnknownError;

export type TreasuryPaymentsPrepareUpdateBillingInfoPayload = {
  __typename?: 'TreasuryPaymentsPrepareUpdateBillingInfoPayload';
  /** Customer info payload */
  customer?: Maybe<TreasuryPaymentsCustomer>;
  /** Error that may occur during the mutation */
  error?: Maybe<TreasuryPaymentsPrepareUpdateBillingInfoError>;
  /** Setup intent secret for updating billing info using Stripe elements */
  setupIntentSecret?: Maybe<Scalars['String']>;
};

export type TreasuryPaymentsPrice = {
  __typename?: 'TreasuryPaymentsPrice';
  /** The base price of the product */
  basePrice: TreasuryPaymentsMoney;
  id: Scalars['String'];
  /** @deprecated use product name/description */
  name?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  product: TreasuryPaymentsDigitalProduct;
  /** Product which is selling by this price */
  productV2: TreasuryProduct;
};

export enum TreasuryPaymentsProduct {
  /** @deprecated No longer supported */
  AD_FREE = 'AD_FREE',
  /** @deprecated No longer supported */
  BATTLE_PASS = 'BATTLE_PASS',
  /** @deprecated No longer supported */
  PLUS = 'PLUS',
  /** @deprecated No longer supported */
  XP_BOOSTER = 'XP_BOOSTER',
}

export enum TreasuryPaymentsProductType {
  AD_FREE = 'AD_FREE',
  BATTLE_PASS = 'BATTLE_PASS',
  PLUS = 'PLUS',
  XP_BOOSTER = 'XP_BOOSTER',
}

export type TreasuryPaymentsProductsFilter = {
  type?: InputMaybe<TreasuryPaymentsProductType>;
};

export type TreasuryPaymentsProductsPayload = {
  __typename?: 'TreasuryPaymentsProductsPayload';
  /** @deprecated No longer supported */
  data?: Maybe<Array<TreasuryPaymentsDigitalProduct>>;
  dataV2?: Maybe<Array<TreasuryProduct>>;
  error?: Maybe<TreasuryPaymentsError>;
};

/** Provides a list of payment providers that can be used for payments. */
export enum TreasuryPaymentsProvider {
  /** Braintree is a payment provider that allows for paypal payments. */
  BRAINTREE = 'BRAINTREE',
  /** Stripe is a payment provider that allows for credit card payments. */
  STRIPE = 'STRIPE',
}

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQuery = {
  __typename?: 'TreasuryPaymentsQuery';
  /** Bundles that are available to purchase with currently selected items */
  bundles?: Maybe<Array<TreasuryPaymentsBundle>>;
  /** Get a customer for authorized user */
  customer?: Maybe<TreasuryPaymentsCustomerOrError>;
  /** List of plans with applied coupon */
  plansWithCoupon?: Maybe<TreasuryPaymentsApplyCouponPayload>;
  /** Get specific product */
  product: TreasuryProductPayload;
  /**
   * Get specific product by it's ID
   * @deprecated No longer supported
   */
  productById?: Maybe<TreasuryPaymentsDigitalProduct>;
  /** List of available products */
  products: TreasuryPaymentsProductsPayload;
  /** List of of trials available */
  trials: Array<TreasuryPaymentsTrialOrError>;
};

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQuerybundlesArgs = {
  filter?: InputMaybe<TreasuryPaymentBundleFilter>;
};

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQueryplansWithCouponArgs = {
  filter: TreasuryPaymentsCouponPlansFilter;
};

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQueryproductArgs = {
  filter: TreasuryProductFilter;
};

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQueryproductByIdArgs = {
  id: Scalars['String'];
};

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQueryproductsArgs = {
  filter?: InputMaybe<TreasuryPaymentsProductsFilter>;
};

/** Queries list for Treasury Payments */
export type TreasuryPaymentsQuerytrialsArgs = {
  filter?: InputMaybe<TreasuryPaymentsTrialsFilter>;
};

/** Renew subscription input */
export type TreasuryPaymentsRenewSubscriptionInput = {
  /** Coupon ID or promo code */
  couponName?: InputMaybe<Scalars['String']>;
  /** New desired plan */
  planId: Scalars['ID'];
  /** Product abbreviation from the ngf-configuration products list, e.g. "d4", "battle-pass". Exactly one of game and productAbbreviation must be set */
  productAbbreviation?: InputMaybe<Scalars['String']>;
  /** Provider of the payment method to renew with. Defaults to the current subscription's provider. */
  provider?: InputMaybe<TreasuryPaymentsProvider>;
};

/** Renew subscription payload */
export type TreasuryPaymentsRenewSubscriptionPayload = {
  __typename?: 'TreasuryPaymentsRenewSubscriptionPayload';
  /** Error */
  error?: Maybe<TreasuryPaymentsError>;
  /** Payment intent secret for 3D Secure for instant payment */
  paymentIntentSecret?: Maybe<Scalars['String']>;
  /** Setup intent secret for 3D Secure, for using when trial, and no instant payment needed */
  setupIntentSecret?: Maybe<Scalars['String']>;
  /** The updated subscription */
  subscription?: Maybe<TreasuryPaymentsSubscription>;
};

export type TreasuryPaymentsStripe = {
  __typename?: 'TreasuryPaymentsStripe';
  billing: TreasuryPaymentsBillingAddress;
  card: TreasuryPaymentsCard;
};

export type TreasuryPaymentsStripePaymentMethod = {
  __typename?: 'TreasuryPaymentsStripePaymentMethod';
  /** Human-readable payment method name */
  displayName: Scalars['String'];
  /** Stripe payment method type */
  type: Scalars['String'];
};

/** Subscription is a recurring payment */
export type TreasuryPaymentsSubscription = {
  __typename?: 'TreasuryPaymentsSubscription';
  /** Time when the subscription was created */
  createdAt: Scalars['TreasuryPaymentsTime'];
  /** The customer who owns this subscription */
  customer: TreasuryPaymentsCustomerOrError;
  /** Unique identifier */
  id: Scalars['ID'];
  /** Next payment amount */
  nextPaymentAmount?: Maybe<TreasuryPaymentsMoney>;
  /** Next payment date */
  nextPaymentDate?: Maybe<Scalars['TreasuryPaymentsTime']>;
  /**
   * Payment history for this subscription
   * Default sort is by createdAt descending.
   */
  paymentHistory: Array<TreasuryPaymentsPaymentOrError>;
  /** Plan that this subscription is associated with */
  plan: TreasuryPaymentsPlan;
  /** The payment provider that this subscription is associated with */
  provider: TreasuryPaymentsProvider;
  /** State of the subscription */
  state: TreasuryPaymentsSubscriptionState;
  /** Trial associated with this subscription */
  trial?: Maybe<TreasuryPaymentsCustomerTrialOrError>;
};

/** Event that occurred on a subscription */
export enum TreasuryPaymentsSubscriptionChangedEvent {
  SUBSCRIPTION_ACTIVATED = 'SUBSCRIPTION_ACTIVATED',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  SUBSCRIPTION_CREATED = 'SUBSCRIPTION_CREATED',
  SUBSCRIPTION_DELETED = 'SUBSCRIPTION_DELETED',
  SUBSCRIPTION_PAYMENT_RECEIVED = 'SUBSCRIPTION_PAYMENT_RECEIVED',
  SUBSCRIPTION_WENT_PAST_DUE = 'SUBSCRIPTION_WENT_PAST_DUE',
}

/** Input for subscription on subscription changed events */
export type TreasuryPaymentsSubscriptionChangedInput = {
  /** Filter by subscription id */
  subscriptionId?: InputMaybe<Array<Scalars['ID']>>;
};

/** Payload for subscription changed events */
export type TreasuryPaymentsSubscriptionChangedPayload = {
  __typename?: 'TreasuryPaymentsSubscriptionChangedPayload';
  /** The customer associated with the subscription */
  customer: TreasuryPaymentsCustomerOrError;
  /** The event that occurred */
  event: TreasuryPaymentsSubscriptionChangedEvent;
  /** The subscription that was changed */
  subscription: TreasuryPaymentsSubscription;
};

/** Subscription filter */
export type TreasuryPaymentsSubscriptionFilter = {
  state?: InputMaybe<Array<TreasuryPaymentsSubscriptionState>>;
};

/** Subscription query result */
export type TreasuryPaymentsSubscriptionOrError = TreasuryPaymentsSubscription | TreasuryPaymentsUnknownError;

/** Subscription state */
export enum TreasuryPaymentsSubscriptionState {
  /** Subscription is active */
  ACTIVE = 'ACTIVE',
  /** Subscription is canceled */
  CANCELED = 'CANCELED',
  /** Subscription is deleted */
  DELETED = 'DELETED',
  /** Subscription is past due on the last payment */
  PAST_DUE = 'PAST_DUE',
  /** Subscription is waiting for the first payment */
  PENDING = 'PENDING',
  /** Subscription is in trial period */
  TRIAL = 'TRIAL',
}

/** A trial is a period of time during which a plan is available for free */
export type TreasuryPaymentsTrial = {
  __typename?: 'TreasuryPaymentsTrial';
  /** Duration of the trial */
  duration: Scalars['TreasuryPaymentsDuration'];
  /** The unique identifier of the trial */
  id: Scalars['ID'];
  /** Is trial available to use */
  isAvailable: Scalars['Boolean'];
  /** The plan that the trial is for */
  plan: TreasuryPaymentsPlanOrError;
};

/** The result of a trials query */
export type TreasuryPaymentsTrialOrError = TreasuryPaymentsTrial | TreasuryPaymentsUnknownError;

/** Filter for trials query. */
export type TreasuryPaymentsTrialsFilter = {
  /** Filter by availability of the trial */
  isAvailable?: InputMaybe<Scalars['Boolean']>;
};

/** The error returned when a user is not authenticated */
export type TreasuryPaymentsUnauthenticatedError = TreasuryPaymentsError & {
  __typename?: 'TreasuryPaymentsUnauthenticatedError';
  /** The error message */
  message?: Maybe<Scalars['String']>;
};

/** The error returned when a required argument is missing */
export type TreasuryPaymentsUnknownError = TreasuryPaymentsError & {
  __typename?: 'TreasuryPaymentsUnknownError';
  /** The error message */
  message?: Maybe<Scalars['String']>;
};

/** Update billing info input */
export type TreasuryPaymentsUpdateBillingInfoInput = {
  provider: TreasuryPaymentsProvider;
  token: Scalars['String'];
};

export type TreasuryPaymentsUpdateBillingInfoPayload = {
  __typename?: 'TreasuryPaymentsUpdateBillingInfoPayload';
  /** Customer info payload */
  customer?: Maybe<TreasuryPaymentsCustomer>;
  /** Error that may occur during the mutation */
  error?: Maybe<TreasuryPaymentsError>;
  /** Setup intent secret for 3D Secure, for using when trial, and no instant payment needed */
  setupIntentSecret?: Maybe<Scalars['String']>;
};

export type TreasuryProduct = {
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type TreasuryProductAdFree = TreasuryProduct & {
  __typename?: 'TreasuryProductAdFree';
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  plans?: Maybe<Array<TreasuryPaymentsPlan>>;
};

export type TreasuryProductBattlePass = TreasuryProduct & {
  __typename?: 'TreasuryProductBattlePass';
  addons?: Maybe<Array<TreasuryProduct>>;
  bundles?: Maybe<Array<TreasuryPaymentsBundle>>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<TreasuryPaymentsPrice>>;
};

export type TreasuryProductFilter = {
  id?: InputMaybe<Scalars['ID']>;
};

export type TreasuryProductPayload = {
  __typename?: 'TreasuryProductPayload';
  data?: Maybe<TreasuryProduct>;
  error?: Maybe<TreasuryPaymentsError>;
};

export type TreasuryProductPlus = TreasuryProduct & {
  __typename?: 'TreasuryProductPlus';
  bundles?: Maybe<Array<TreasuryPaymentsBundle>>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  plans?: Maybe<Array<TreasuryPaymentsPlan>>;
};

export type TreasuryProductXPBooster = TreasuryProduct & {
  __typename?: 'TreasuryProductXPBooster';
  battlePass: TreasuryProductBattlePass;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<TreasuryPaymentsPrice>>;
};

export type TreasuryQuery = {
  __typename?: 'TreasuryQuery';
  flow?: Maybe<TreasuryFlowQuery>;
  id: Scalars['ID'];
  payments?: Maybe<TreasuryPaymentsQuery>;
};

export type Twitch = {
  __typename?: 'Twitch';
  live?: Maybe<Scalars['Boolean']>;
  login?: Maybe<Scalars['String']>;
};

/**
 * Data related to mobalytics user profiles.
 * Note that part of the data is private and can be accessed only by the user himself (logged in user).
 * For other users only public data is returned, private fields are going to be null.
 */
export type User = {
  __typename?: 'User';
  /**
   *  Part of the attributes are private. Privacy checks are done by the backend,
   * even if requested by the client - private attributes are not returned.
   */
  attributes?: Maybe<Array<AccountsUserAttribute>>;
  /** Game accounts the user is logged into: Riot, Steam, GGG, etc. */
  connectedGameAccounts?: Maybe<Array<AccountsConnectedProvider>>;
  /** Social media accounts the user is logged into: Twitch, Discord, Google, etc. */
  connectedSocialAccounts?: Maybe<Array<AccountsConnectedProvider>>;
  createdAt: Scalars['AccountsDateTime'];
  /** Customer stores information about a user's subscription status and payment history. */
  customer: TreasuryPaymentsCustomerOrError;
  /** The name that the user wants to display in the account */
  displayName: Scalars['String'];
  /** Email is a private field. */
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Links that the user specified in the settings: youtube, discord, twitch, etc. */
  socialLinks?: Maybe<Array<AccountsSocialLink>>;
  twitchLive?: Maybe<Twitch>;
  updatedAt: Scalars['AccountsDateTime'];
  /** Username is a public field. */
  username: Scalars['String'];
};

/**
 * Data related to mobalytics user profiles.
 * Note that part of the data is private and can be accessed only by the user himself (logged in user).
 * For other users only public data is returned, private fields are going to be null.
 */
export type UserattributesArgs = {
  filter?: InputMaybe<AccountsUserAttributesFilter>;
};

export type UserBattlePass = {
  __typename?: 'UserBattlePass';
  battlePassId: Scalars['UUID'];
  updatedAt: Scalars['Timestamp'];
  userId: Scalars['UUID'];
  xp: Scalars['Int64'];
};

export type UserBattlePassInput = {
  battlePassId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type UserBattlePassResponse = {
  __typename?: 'UserBattlePassResponse';
  eventLog?: Maybe<EventLogResponse>;
  userBattlePass?: Maybe<UserBattlePass>;
};

export type UserBattlePassResponseeventLogArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ValorantNgfDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'ValorantNgfDocumentCmWidgetV1';
  data: ValorantNgfDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type ValorantNgfDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'ValorantNgfDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ValorantNgfDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | ValorantNgfDocumentCmWidgetV1;

export type ValorantNgfDocumentSeason = NgfDocumentSeason & {
  __typename?: 'ValorantNgfDocumentSeason';
  slug: Scalars['String'];
};

export type ValorantNgfDocumentTags = NgfDocumentTags & {
  __typename?: 'ValorantNgfDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type ValorantNgfDocumentsMutation = {
  __typename?: 'ValorantNgfDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: ValorantNgfStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: ValorantNgfStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: ValorantNgfStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: ValorantNgfStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: ValorantNgfUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: ValorantNgfUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: ValorantNgfUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: ValorantNgfUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: ValorantNgfUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: ValorantNgfUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: ValorantNgfWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: ValorantNgfWikiDocumentUpdatePayload;
};

export type ValorantNgfDocumentsMutationstructDocumentCreateArgs = {
  input: ValorantNgfStructDocumentCreateInput;
};

export type ValorantNgfDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type ValorantNgfDocumentsMutationstructDocumentSetStatusArgs = {
  input: ValorantNgfStructDocumentSetStatusInput;
};

export type ValorantNgfDocumentsMutationstructDocumentUpdateArgs = {
  input: ValorantNgfStructDocumentUpdateInput;
};

export type ValorantNgfDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: ValorantNgfUserGeneratedDocumentCreateInput;
};

export type ValorantNgfDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: ValorantNgfUserGeneratedDocumentSetFavoriteInput;
};

export type ValorantNgfDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: ValorantNgfUserGeneratedDocumentSetFeaturedInput;
};

export type ValorantNgfDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type ValorantNgfDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: ValorantNgfUserGeneratedDocumentSetStatusInput;
};

export type ValorantNgfDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: ValorantNgfUserGeneratedDocumentUpdateInput;
};

export type ValorantNgfDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type ValorantNgfDocumentsMutationwikiDocumentUpdateArgs = {
  input: ValorantNgfWikiDocumentUpdateInput;
};

export type ValorantNgfDocumentsQuery = {
  __typename?: 'ValorantNgfDocumentsQuery';
  previewDocumentContent: ValorantNgfPreviewDocumentContentPayload;
  structDocumentBySlug: ValorantNgfStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: ValorantNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: ValorantNgfUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: ValorantNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: ValorantNgfUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: ValorantNgfTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: ValorantNgfWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type ValorantNgfDocumentsQuerypreviewDocumentContentArgs = {
  input: ValorantNgfPreviewDocumentContentInput;
};

export type ValorantNgfDocumentsQuerystructDocumentBySlugArgs = {
  input: ValorantNgfStructDocumentInputBySlug;
};

export type ValorantNgfDocumentsQuerystructDocumentsArgs = {
  input: ValorantNgfStructDocumentsInput;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: ValorantNgfUserGeneratedDocumentInputById;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: ValorantNgfUserGeneratedDocumentInputBySlug;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: ValorantNgfTemplateDocumentInput;
};

export type ValorantNgfDocumentsQueryuserGeneratedDocumentsArgs = {
  input: ValorantNgfUserGeneratedDocumentsListInput;
  page: ValorantNgfUserGeneratedDocumentsListPage;
};

export type ValorantNgfDocumentsQuerywikiDocumentArgs = {
  input: ValorantNgfWikiDocumentInput;
};

export type ValorantNgfDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<ValorantNgfWikiDocumentsListInput>;
  page: ValorantNgfWikiDocumentsListPage;
};

export type ValorantNgfEntityObject = NGFEntityObject & {
  __typename?: 'ValorantNgfEntityObject';
  color?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ValorantNgfMutation = {
  __typename?: 'ValorantNgfMutation';
  documents?: Maybe<ValorantNgfDocumentsMutation>;
  id: Scalars['ID'];
};

export enum ValorantNgfPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfPreviewDocumentContentInput = {
  content: Scalars['ValorantNgfDocumentContentInputBase64Json'];
};

export type ValorantNgfPreviewDocumentContentPayload = {
  __typename?: 'ValorantNgfPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<ValorantNgfDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<ValorantNgfPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfProfile = NgfProfile & {
  __typename?: 'ValorantNgfProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type ValorantNgfProfileuserGeneratedDocumentsArgs = {
  input: ValorantNgfUserGeneratedDocumentsListInput;
  page: ValorantNgfUserGeneratedDocumentsListPage;
};

export type ValorantNgfProfilePayload = {
  __typename?: 'ValorantNgfProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<ValorantNgfProfile>;
};

export type ValorantNgfProfilesQuery = {
  __typename?: 'ValorantNgfProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: ValorantNgfProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type ValorantNgfProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type ValorantNgfQuery = {
  __typename?: 'ValorantNgfQuery';
  documents?: Maybe<ValorantNgfDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<ValorantNgfProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
};

export type ValorantNgfStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'ValorantNgfStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<ValorantNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ValorantNgfStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum ValorantNgfStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ValorantNgfStructDocumentCreateInput = {
  document: Scalars['ValorantNgfStructDocumentInputBase64Json'];
};

export type ValorantNgfStructDocumentCreatePayload = {
  __typename?: 'ValorantNgfStructDocumentCreatePayload';
  data?: Maybe<ValorantNgfStructDocument>;
  error?: Maybe<ValorantNgfStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfStructDocumentData = NgfStructDocumentData & {
  __typename?: 'ValorantNgfStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ValorantNgfDocumentSeason;
  tags?: Maybe<ValorantNgfDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum ValorantNgfStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type ValorantNgfStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ValorantNgfStructDocumentPayload = {
  __typename?: 'ValorantNgfStructDocumentPayload';
  data?: Maybe<ValorantNgfStructDocument>;
  error?: Maybe<ValorantNgfStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ValorantNgfStructDocumentSetSeoPayload = {
  __typename?: 'ValorantNgfStructDocumentSetSeoPayload';
  data?: Maybe<ValorantNgfStructDocument>;
  error?: Maybe<ValorantNgfStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type ValorantNgfStructDocumentSetStatusPayload = {
  __typename?: 'ValorantNgfStructDocumentSetStatusPayload';
  data?: Maybe<ValorantNgfStructDocument>;
  error?: Maybe<ValorantNgfStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfStructDocumentUpdateInput = {
  document: Scalars['ValorantNgfStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type ValorantNgfStructDocumentUpdatePayload = {
  __typename?: 'ValorantNgfStructDocumentUpdatePayload';
  data?: Maybe<ValorantNgfStructDocument>;
  error?: Maybe<ValorantNgfStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type ValorantNgfTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'ValorantNgfTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<ValorantNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: ValorantNgfTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type ValorantNgfTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'ValorantNgfTemplateDocumentData';
  buildVariants?: Maybe<ValorantNgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ValorantNgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum ValorantNgfTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfTemplateDocumentInput = {
  type: Scalars['String'];
};

export type ValorantNgfTemplateDocumentPayload = {
  __typename?: 'ValorantNgfTemplateDocumentPayload';
  data?: Maybe<ValorantNgfTemplateDocument>;
  error?: Maybe<ValorantNgfTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'ValorantNgfUGDocumentGenericBuilder';
  slots?: Maybe<Array<ValorantNgfUGDocumentGenericBuilderSlot>>;
};

export type ValorantNgfUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'ValorantNgfUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<ValorantNgfEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type ValorantNgfUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'ValorantNgfUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<ValorantNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ValorantNgfUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<ValorantNgfDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type ValorantNgfUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'ValorantNgfUserGeneratedDocumentBuildVariant';
  genericBuilder: ValorantNgfUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type ValorantNgfUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'ValorantNgfUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<ValorantNgfUserGeneratedDocumentBuildVariant>>;
};

export enum ValorantNgfUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ValorantNgfUserGeneratedDocumentCreateInput = {
  document: Scalars['ValorantNgfUserGeneratedDocumentInputBase64Json'];
};

export type ValorantNgfUserGeneratedDocumentCreatePayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentCreatePayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'ValorantNgfUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<ValorantNgfUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ValorantNgfDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum ValorantNgfUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type ValorantNgfUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ValorantNgfUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ValorantNgfUserGeneratedDocumentPayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentPayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type ValorantNgfUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ValorantNgfUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type ValorantNgfUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ValorantNgfUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type ValorantNgfUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ValorantNgfUserGeneratedDocumentUpdateInput = {
  document: Scalars['ValorantNgfUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type ValorantNgfUserGeneratedDocumentUpdatePayload = {
  __typename?: 'ValorantNgfUserGeneratedDocumentUpdatePayload';
  data?: Maybe<ValorantNgfUserGeneratedDocument>;
  error?: Maybe<ValorantNgfUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type ValorantNgfUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type ValorantNgfWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'ValorantNgfWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<ValorantNgfDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ValorantNgfWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<ValorantNgfDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type ValorantNgfWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'ValorantNgfWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: ValorantNgfEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum ValorantNgfWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ValorantNgfWikiDocumentPayload = {
  __typename?: 'ValorantNgfWikiDocumentPayload';
  data?: Maybe<ValorantNgfWikiDocument>;
  error?: Maybe<ValorantNgfWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ValorantNgfWikiDocumentSetSeoPayload = {
  __typename?: 'ValorantNgfWikiDocumentSetSeoPayload';
  data?: Maybe<ValorantNgfWikiDocument>;
  error?: Maybe<ValorantNgfWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ValorantNgfWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ValorantNgfWikiDocumentUpdateInput = {
  document: Scalars['ValorantNgfWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type ValorantNgfWikiDocumentUpdatePayload = {
  __typename?: 'ValorantNgfWikiDocumentUpdatePayload';
  data?: Maybe<ValorantNgfWikiDocument>;
  error?: Maybe<ValorantNgfWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValorantNgfWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type ValorantNgfWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type WidgetMeta = {
  __typename?: 'WidgetMeta';
  description: Scalars['String'];
  displayName: Scalars['String'];
  fullDescription?: Maybe<Scalars['String']>;
  type: NgfWidgetMetaType;
  typeName: Scalars['String'];
};

export type WowforAbilities = WowforGameEntity & {
  __typename?: 'WowforAbilities';
  castTime?: Maybe<Scalars['String']>;
  class?: Maybe<WowforClasses>;
  cooldown?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  petFamilies?: Maybe<Array<WowforPetFamilies>>;
  races?: Maybe<Array<WowforRaces>>;
  range?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type WowforAbilitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforAbilitiesResult = {
  __typename?: 'WowforAbilitiesResult';
  data?: Maybe<Array<WowforAbilities>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforClasses = WowforGameEntity & {
  __typename?: 'WowforClasses';
  abilities?: Maybe<Array<WowforAbilities>>;
  armorProficiencies?: Maybe<Array<Scalars['String']>>;
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  resource?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Scalars['String']>>;
  slug: Scalars['String'];
  talentTrees?: Maybe<Array<WowforTalentTrees>>;
  weaponSkills?: Maybe<Array<Scalars['String']>>;
};

export type WowforClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforClassesResult = {
  __typename?: 'WowforClassesResult';
  data?: Maybe<Array<WowforClasses>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforConsumables = WowforGameEntity & {
  __typename?: 'WowforConsumables';
  allowableClasses?: Maybe<Array<WowforClasses>>;
  bonding?: Maybe<Scalars['String']>;
  buyPrice?: Maybe<Scalars['String']>;
  clientDeprecated?: Maybe<Scalars['String']>;
  createdByPlans?: Maybe<Array<WowforPlans>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  effects?: Maybe<Array<WowforConsumablesEffects>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemClass?: Maybe<WowforItemClasses>;
  itemLevel?: Maybe<Scalars['String']>;
  itemSubclass?: Maybe<WowforItemSubclasses>;
  maxCount?: Maybe<Scalars['String']>;
  maxStack?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quality?: Maybe<WowforItemQualities>;
  requiredLevel?: Maybe<Scalars['String']>;
  requiredSpell?: Maybe<WowforSpells>;
  sellPrice?: Maybe<Scalars['String']>;
  slot?: Maybe<WowforItemSlots>;
  slug: Scalars['String'];
  vendorStackCount?: Maybe<Scalars['String']>;
};

export type WowforConsumablesEffects = {
  __typename?: 'WowforConsumablesEffects';
  slotIndex?: Maybe<Scalars['String']>;
  spell?: Maybe<WowforSpells>;
  triggerType?: Maybe<Scalars['String']>;
};

export type WowforConsumablesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforConsumablesResult = {
  __typename?: 'WowforConsumablesResult';
  data?: Maybe<Array<WowforConsumables>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'WowforDocumentCmWidgetV1';
  data: WowforDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type WowforDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'WowforDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type WowforDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | WowforDocumentCmWidgetV1
  | WowforDocumentStWidgetTalentCalculatorV1
  | WowforDocumentUgWidgetSkillTreeV1;

export type WowforDocumentSeason = NgfDocumentSeason & {
  __typename?: 'WowforDocumentSeason';
  slug: Scalars['String'];
};

export type WowforDocumentStWidgetTalentCalculatorV1 = NgfDocumentContent & {
  __typename?: 'WowforDocumentStWidgetTalentCalculatorV1';
  data: WowforDocumentStWidgetTalentCalculatorV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type WowforDocumentStWidgetTalentCalculatorV1Data = NgfDocumentContentData & {
  __typename?: 'WowforDocumentStWidgetTalentCalculatorV1Data';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  tag: NgfUserGeneratedDocumentsDiscoveryTag;
  talentTrees?: Maybe<Array<WowforTalentTrees>>;
  title: Scalars['String'];
};

export type WowforDocumentTags = NgfDocumentTags & {
  __typename?: 'WowforDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type WowforDocumentUgWidgetSkillTreeV1 = NgfDocumentContent & {
  __typename?: 'WowforDocumentUgWidgetSkillTreeV1';
  data: WowforDocumentUgWidgetSkillTreeV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type WowforDocumentUgWidgetSkillTreeV1Data = NgfDocumentContentData & {
  __typename?: 'WowforDocumentUgWidgetSkillTreeV1Data';
  description?: Maybe<NgfDocumentRichTextContent>;
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  subTitle?: Maybe<NgfDocumentRichTextContent>;
  title: Scalars['String'];
};

export type WowforDocumentsMutation = {
  __typename?: 'WowforDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: WowforStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: WowforStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: WowforStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: WowforStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: WowforUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: WowforUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: WowforUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: WowforUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: WowforUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: WowforUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: WowforWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: WowforWikiDocumentUpdatePayload;
};

export type WowforDocumentsMutationstructDocumentCreateArgs = {
  input: WowforStructDocumentCreateInput;
};

export type WowforDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type WowforDocumentsMutationstructDocumentSetStatusArgs = {
  input: WowforStructDocumentSetStatusInput;
};

export type WowforDocumentsMutationstructDocumentUpdateArgs = {
  input: WowforStructDocumentUpdateInput;
};

export type WowforDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: WowforUserGeneratedDocumentCreateInput;
};

export type WowforDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: WowforUserGeneratedDocumentSetFavoriteInput;
};

export type WowforDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: WowforUserGeneratedDocumentSetFeaturedInput;
};

export type WowforDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type WowforDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: WowforUserGeneratedDocumentSetStatusInput;
};

export type WowforDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: WowforUserGeneratedDocumentUpdateInput;
};

export type WowforDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type WowforDocumentsMutationwikiDocumentUpdateArgs = {
  input: WowforWikiDocumentUpdateInput;
};

export type WowforDocumentsQuery = {
  __typename?: 'WowforDocumentsQuery';
  previewDocumentContent: WowforPreviewDocumentContentPayload;
  structDocumentBySlug: WowforStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: WowforUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: WowforUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: WowforUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: WowforUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: WowforTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: WowforWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type WowforDocumentsQuerypreviewDocumentContentArgs = {
  input: WowforPreviewDocumentContentInput;
};

export type WowforDocumentsQuerystructDocumentBySlugArgs = {
  input: WowforStructDocumentInputBySlug;
};

export type WowforDocumentsQuerystructDocumentsArgs = {
  input: WowforStructDocumentsInput;
};

export type WowforDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: WowforUserGeneratedDocumentInputById;
};

export type WowforDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: WowforUserGeneratedDocumentInputBySlug;
};

export type WowforDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type WowforDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type WowforDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type WowforDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type WowforDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: WowforTemplateDocumentInput;
};

export type WowforDocumentsQueryuserGeneratedDocumentsArgs = {
  input: WowforUserGeneratedDocumentsListInput;
  page: WowforUserGeneratedDocumentsListPage;
};

export type WowforDocumentsQuerywikiDocumentArgs = {
  input: WowforWikiDocumentInput;
};

export type WowforDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<WowforWikiDocumentsListInput>;
  page: WowforWikiDocumentsListPage;
};

export enum WowforEntitiesEnum {
  abilities = 'abilities',
  classes = 'classes',
  consumables = 'consumables',
  gearSets = 'gearSets',
  itemClasses = 'itemClasses',
  itemQualities = 'itemQualities',
  itemSlots = 'itemSlots',
  itemStats = 'itemStats',
  itemSubclasses = 'itemSubclasses',
  items = 'items',
  petFamilies = 'petFamilies',
  plans = 'plans',
  professions = 'professions',
  races = 'races',
  racials = 'racials',
  reagents = 'reagents',
  roles = 'roles',
  spellSchools = 'spellSchools',
  spells = 'spells',
  talentTrees = 'talentTrees',
  talents = 'talents',
}

export type WowforEntityObject = NGFEntityObject & {
  __typename?: 'WowforEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<WowforGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type WowforGameEntity = {
  slug: Scalars['String'];
};

export type WowforGearSets = WowforGameEntity & {
  __typename?: 'WowforGearSets';
  bonuses?: Maybe<Array<WowforGearSetsBonuses>>;
  classes?: Maybe<Array<WowforClasses>>;
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  itemLevelMax?: Maybe<Scalars['String']>;
  itemLevelMin?: Maybe<Scalars['String']>;
  itemSubclass?: Maybe<WowforItemSubclasses>;
  items?: Maybe<Array<WowforItems>>;
  name: Scalars['String'];
  pieceCount?: Maybe<Scalars['String']>;
  requiredLevel?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type WowforGearSetsBonuses = {
  __typename?: 'WowforGearSetsBonuses';
  description?: Maybe<Scalars['String']>;
  pieces?: Maybe<Scalars['String']>;
  spellId?: Maybe<Scalars['String']>;
};

export type WowforGearSetsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforGearSetsResult = {
  __typename?: 'WowforGearSetsResult';
  data?: Maybe<Array<WowforGearSets>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItemClasses = WowforGameEntity & {
  __typename?: 'WowforItemClasses';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforItemClassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforItemClassesResult = {
  __typename?: 'WowforItemClassesResult';
  data?: Maybe<Array<WowforItemClasses>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItemQualities = WowforGameEntity & {
  __typename?: 'WowforItemQualities';
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforItemQualitiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforItemQualitiesResult = {
  __typename?: 'WowforItemQualitiesResult';
  data?: Maybe<Array<WowforItemQualities>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItemSlots = WowforGameEntity & {
  __typename?: 'WowforItemSlots';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforItemSlotsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforItemSlotsResult = {
  __typename?: 'WowforItemSlotsResult';
  data?: Maybe<Array<WowforItemSlots>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItemStats = WowforGameEntity & {
  __typename?: 'WowforItemStats';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforItemStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforItemStatsResult = {
  __typename?: 'WowforItemStatsResult';
  data?: Maybe<Array<WowforItemStats>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItemSubclasses = WowforGameEntity & {
  __typename?: 'WowforItemSubclasses';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  itemClass?: Maybe<WowforItemClasses>;
  name: Scalars['String'];
  slug: Scalars['String'];
  subclassIndex?: Maybe<Scalars['String']>;
  verboseName?: Maybe<Scalars['String']>;
};

export type WowforItemSubclassesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforItemSubclassesResult = {
  __typename?: 'WowforItemSubclassesResult';
  data?: Maybe<Array<WowforItemSubclasses>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItems = WowforGameEntity & {
  __typename?: 'WowforItems';
  allowableClasses?: Maybe<Array<WowforClasses>>;
  allowableRaces?: Maybe<Array<WowforRaces>>;
  armor?: Maybe<Scalars['String']>;
  bonding?: Maybe<Scalars['String']>;
  buyPrice?: Maybe<Scalars['String']>;
  createdByPlans?: Maybe<Array<WowforPlans>>;
  damage?: Maybe<Array<WowforItemsDamage>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  effects?: Maybe<Array<WowforItemsEffects>>;
  gearSet?: Maybe<WowforGearSets>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemClass?: Maybe<WowforItemClasses>;
  itemLevel?: Maybe<Scalars['String']>;
  itemSubclass?: Maybe<WowforItemSubclasses>;
  maxStack?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quality?: Maybe<WowforItemQualities>;
  requiredLevel?: Maybe<Scalars['String']>;
  requiredSpell?: Maybe<WowforSpells>;
  sellPrice?: Maybe<Scalars['String']>;
  slot?: Maybe<WowforItemSlots>;
  slug: Scalars['String'];
  speed?: Maybe<Scalars['String']>;
  stats?: Maybe<Array<WowforItemsStats>>;
  vendorStackCount?: Maybe<Scalars['String']>;
};

export type WowforItemsDamage = {
  __typename?: 'WowforItemsDamage';
  maxDamage?: Maybe<Scalars['String']>;
  minDamage?: Maybe<Scalars['String']>;
  school?: Maybe<WowforSpellSchools>;
};

export type WowforItemsEffects = {
  __typename?: 'WowforItemsEffects';
  slotIndex?: Maybe<Scalars['String']>;
  spell?: Maybe<WowforSpells>;
  triggerType?: Maybe<Scalars['String']>;
};

export type WowforItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforItemsResult = {
  __typename?: 'WowforItemsResult';
  data?: Maybe<Array<WowforItems>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforItemsStats = {
  __typename?: 'WowforItemsStats';
  amount?: Maybe<Scalars['String']>;
  stat?: Maybe<WowforItemStats>;
};

export type WowforMutation = {
  __typename?: 'WowforMutation';
  documents?: Maybe<WowforDocumentsMutation>;
  id: Scalars['ID'];
};

export type WowforPetFamilies = WowforGameEntity & {
  __typename?: 'WowforPetFamilies';
  class?: Maybe<WowforClasses>;
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforPetFamiliesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforPetFamiliesResult = {
  __typename?: 'WowforPetFamiliesResult';
  data?: Maybe<Array<WowforPetFamilies>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforPlans = WowforGameEntity & {
  __typename?: 'WowforPlans';
  buyPrice?: Maybe<Scalars['String']>;
  craftSpell?: Maybe<WowforSpells>;
  createsConsumable?: Maybe<WowforConsumables>;
  createsCount?: Maybe<Scalars['String']>;
  createsItem?: Maybe<WowforItems>;
  createsReagent?: Maybe<WowforReagents>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemSubclass?: Maybe<WowforItemSubclasses>;
  name: Scalars['String'];
  profession?: Maybe<WowforProfessions>;
  quality?: Maybe<WowforItemQualities>;
  reagents?: Maybe<Array<WowforPlansReagents>>;
  requiredSkillRank?: Maybe<Scalars['String']>;
  requiredSpell?: Maybe<WowforSpells>;
  sellPrice?: Maybe<Scalars['String']>;
  skillRankGreen?: Maybe<Scalars['String']>;
  skillRankGrey?: Maybe<Scalars['String']>;
  skillRankYellow?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type WowforPlansFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforPlansReagents = {
  __typename?: 'WowforPlansReagents';
  count?: Maybe<Scalars['String']>;
  reagent?: Maybe<WowforReagents>;
};

export type WowforPlansResult = {
  __typename?: 'WowforPlansResult';
  data?: Maybe<Array<WowforPlans>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum WowforPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforPreviewDocumentContentInput = {
  content: Scalars['WowforDocumentContentInputBase64Json'];
};

export type WowforPreviewDocumentContentPayload = {
  __typename?: 'WowforPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<WowforDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<WowforPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforProfessions = WowforGameEntity & {
  __typename?: 'WowforProfessions';
  category?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforProfessionsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforProfessionsResult = {
  __typename?: 'WowforProfessionsResult';
  data?: Maybe<Array<WowforProfessions>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforProfile = NgfProfile & {
  __typename?: 'WowforProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type WowforProfileuserGeneratedDocumentsArgs = {
  input: WowforUserGeneratedDocumentsListInput;
  page: WowforUserGeneratedDocumentsListPage;
};

export type WowforProfilePayload = {
  __typename?: 'WowforProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<WowforProfile>;
};

export type WowforProfilesQuery = {
  __typename?: 'WowforProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: WowforProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type WowforProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type WowforQuery = {
  __typename?: 'WowforQuery';
  documents?: Maybe<WowforDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<WowforProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<WowforStaticDataQuery>;
};

export type WowforRaces = WowforGameEntity & {
  __typename?: 'WowforRaces';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  racials?: Maybe<Array<WowforRacials>>;
  slug: Scalars['String'];
};

export type WowforRacesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforRacesResult = {
  __typename?: 'WowforRacesResult';
  data?: Maybe<Array<WowforRaces>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforRacials = WowforGameEntity & {
  __typename?: 'WowforRacials';
  cooldown?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  race?: Maybe<WowforRaces>;
  slug: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type WowforRacialsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforRacialsResult = {
  __typename?: 'WowforRacialsResult';
  data?: Maybe<Array<WowforRacials>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforReagents = WowforGameEntity & {
  __typename?: 'WowforReagents';
  bonding?: Maybe<Scalars['String']>;
  buyPrice?: Maybe<Scalars['String']>;
  createdByPlans?: Maybe<Array<WowforPlans>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemClass?: Maybe<WowforItemClasses>;
  itemLevel?: Maybe<Scalars['String']>;
  itemSubclass?: Maybe<WowforItemSubclasses>;
  maxStack?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quality?: Maybe<WowforItemQualities>;
  sellPrice?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  usedInPlans?: Maybe<Array<WowforPlans>>;
};

export type WowforReagentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforReagentsResult = {
  __typename?: 'WowforReagentsResult';
  data?: Maybe<Array<WowforReagents>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforRoles = WowforGameEntity & {
  __typename?: 'WowforRoles';
  classes?: Maybe<Array<Scalars['String']>>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforRolesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforRolesResult = {
  __typename?: 'WowforRolesResult';
  data?: Maybe<Array<WowforRoles>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforSpellSchools = WowforGameEntity & {
  __typename?: 'WowforSpellSchools';
  deprecated: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WowforSpellSchoolsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforSpellSchoolsResult = {
  __typename?: 'WowforSpellSchoolsResult';
  data?: Maybe<Array<WowforSpellSchools>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforSpells = WowforGameEntity & {
  __typename?: 'WowforSpells';
  auraDescription?: Maybe<Scalars['String']>;
  castTime?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  dispelType?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  equippedItemClass?: Maybe<WowforItemClasses>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxDuration?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  powerType?: Maybe<Scalars['String']>;
  procChance?: Maybe<Scalars['String']>;
  rangeMax?: Maybe<Scalars['String']>;
  rangeMin?: Maybe<Scalars['String']>;
  schools?: Maybe<Array<WowforSpellSchools>>;
  slug: Scalars['String'];
  spellLevel?: Maybe<Scalars['String']>;
};

export type WowforSpellsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforSpellsResult = {
  __typename?: 'WowforSpellsResult';
  data?: Maybe<Array<WowforSpells>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export enum WowforStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type WowforStaticDataGroups = {
  __typename?: 'WowforStaticDataGroups';
  abilities: WowforAbilitiesResult;
  classes: WowforClassesResult;
  consumables: WowforConsumablesResult;
  gearSets: WowforGearSetsResult;
  itemClasses: WowforItemClassesResult;
  itemQualities: WowforItemQualitiesResult;
  itemSlots: WowforItemSlotsResult;
  itemStats: WowforItemStatsResult;
  itemSubclasses: WowforItemSubclassesResult;
  items: WowforItemsResult;
  petFamilies: WowforPetFamiliesResult;
  plans: WowforPlansResult;
  professions: WowforProfessionsResult;
  races: WowforRacesResult;
  racials: WowforRacialsResult;
  reagents: WowforReagentsResult;
  roles: WowforRolesResult;
  spellSchools: WowforSpellSchoolsResult;
  spells: WowforSpellsResult;
  talentTrees: WowforTalentTreesResult;
  talents: WowforTalentsResult;
};

export type WowforStaticDataGroupsabilitiesArgs = {
  filter?: InputMaybe<WowforAbilitiesFilter>;
};

export type WowforStaticDataGroupsclassesArgs = {
  filter?: InputMaybe<WowforClassesFilter>;
};

export type WowforStaticDataGroupsconsumablesArgs = {
  filter?: InputMaybe<WowforConsumablesFilter>;
};

export type WowforStaticDataGroupsgearSetsArgs = {
  filter?: InputMaybe<WowforGearSetsFilter>;
};

export type WowforStaticDataGroupsitemClassesArgs = {
  filter?: InputMaybe<WowforItemClassesFilter>;
};

export type WowforStaticDataGroupsitemQualitiesArgs = {
  filter?: InputMaybe<WowforItemQualitiesFilter>;
};

export type WowforStaticDataGroupsitemSlotsArgs = {
  filter?: InputMaybe<WowforItemSlotsFilter>;
};

export type WowforStaticDataGroupsitemStatsArgs = {
  filter?: InputMaybe<WowforItemStatsFilter>;
};

export type WowforStaticDataGroupsitemSubclassesArgs = {
  filter?: InputMaybe<WowforItemSubclassesFilter>;
};

export type WowforStaticDataGroupsitemsArgs = {
  filter?: InputMaybe<WowforItemsFilter>;
};

export type WowforStaticDataGroupspetFamiliesArgs = {
  filter?: InputMaybe<WowforPetFamiliesFilter>;
};

export type WowforStaticDataGroupsplansArgs = {
  filter?: InputMaybe<WowforPlansFilter>;
};

export type WowforStaticDataGroupsprofessionsArgs = {
  filter?: InputMaybe<WowforProfessionsFilter>;
};

export type WowforStaticDataGroupsracesArgs = {
  filter?: InputMaybe<WowforRacesFilter>;
};

export type WowforStaticDataGroupsracialsArgs = {
  filter?: InputMaybe<WowforRacialsFilter>;
};

export type WowforStaticDataGroupsreagentsArgs = {
  filter?: InputMaybe<WowforReagentsFilter>;
};

export type WowforStaticDataGroupsrolesArgs = {
  filter?: InputMaybe<WowforRolesFilter>;
};

export type WowforStaticDataGroupsspellSchoolsArgs = {
  filter?: InputMaybe<WowforSpellSchoolsFilter>;
};

export type WowforStaticDataGroupsspellsArgs = {
  filter?: InputMaybe<WowforSpellsFilter>;
};

export type WowforStaticDataGroupstalentTreesArgs = {
  filter?: InputMaybe<WowforTalentTreesFilter>;
};

export type WowforStaticDataGroupstalentsArgs = {
  filter?: InputMaybe<WowforTalentsFilter>;
};

export type WowforStaticDataQuery = {
  __typename?: 'WowforStaticDataQuery';
  groups: WowforStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type WowforStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'WowforStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<WowforDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: WowforStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum WowforStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type WowforStructDocumentCreateInput = {
  document: Scalars['WowforStructDocumentInputBase64Json'];
};

export type WowforStructDocumentCreatePayload = {
  __typename?: 'WowforStructDocumentCreatePayload';
  data?: Maybe<WowforStructDocument>;
  error?: Maybe<WowforStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforStructDocumentData = NgfStructDocumentData & {
  __typename?: 'WowforStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: WowforDocumentSeason;
  tags?: Maybe<WowforDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum WowforStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type WowforStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type WowforStructDocumentPayload = {
  __typename?: 'WowforStructDocumentPayload';
  data?: Maybe<WowforStructDocument>;
  error?: Maybe<WowforStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type WowforStructDocumentSetSeoPayload = {
  __typename?: 'WowforStructDocumentSetSeoPayload';
  data?: Maybe<WowforStructDocument>;
  error?: Maybe<WowforStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type WowforStructDocumentSetStatusPayload = {
  __typename?: 'WowforStructDocumentSetStatusPayload';
  data?: Maybe<WowforStructDocument>;
  error?: Maybe<WowforStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforStructDocumentUpdateInput = {
  document: Scalars['WowforStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type WowforStructDocumentUpdatePayload = {
  __typename?: 'WowforStructDocumentUpdatePayload';
  data?: Maybe<WowforStructDocument>;
  error?: Maybe<WowforStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type WowforTalentTrees = WowforGameEntity & {
  __typename?: 'WowforTalentTrees';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  class?: Maybe<WowforClasses>;
  deprecated: Scalars['Boolean'];
  grid?: Maybe<Array<WowforTalentTreesGrid>>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  orderIndex?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type WowforTalentTreesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforTalentTreesGrid = {
  __typename?: 'WowforTalentTreesGrid';
  column?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  talent?: Maybe<WowforTalents>;
};

export type WowforTalentTreesResult = {
  __typename?: 'WowforTalentTreesResult';
  data?: Maybe<Array<WowforTalentTrees>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforTalents = WowforGameEntity & {
  __typename?: 'WowforTalents';
  class?: Maybe<WowforClasses>;
  column?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  maxRank?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  requiredPoints?: Maybe<Scalars['String']>;
  requiredTalent?: Maybe<WowforTalents>;
  requiredTalentRank?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  substitutions?: Maybe<Array<WowforTalentsSubstitutions>>;
  talentTree?: Maybe<WowforTalentTrees>;
};

export type WowforTalentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type WowforTalentsResult = {
  __typename?: 'WowforTalentsResult';
  data?: Maybe<Array<WowforTalents>>;
  error?: Maybe<WowforStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type WowforTalentsSubstitutions = {
  __typename?: 'WowforTalentsSubstitutions';
  key?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Scalars['String']>>;
};

export type WowforTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'WowforTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<WowforDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: WowforTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type WowforTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'WowforTemplateDocumentData';
  buildVariants?: Maybe<WowforUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: WowforDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum WowforTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforTemplateDocumentInput = {
  type: Scalars['String'];
};

export type WowforTemplateDocumentPayload = {
  __typename?: 'WowforTemplateDocumentPayload';
  data?: Maybe<WowforTemplateDocument>;
  error?: Maybe<WowforTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'WowforUGDocumentGenericBuilder';
  slots?: Maybe<Array<WowforUGDocumentGenericBuilderSlot>>;
};

export type WowforUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'WowforUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<WowforEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type WowforUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'WowforUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<WowforDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: WowforUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<WowforDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type WowforUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'WowforUserGeneratedDocumentBuildVariant';
  genericBuilder: WowforUGDocumentGenericBuilder;
  id: Scalars['ID'];
  talentTree?: Maybe<WowforUserGeneratedDocumentBuildVariantTalentTree>;
};

export type WowforUserGeneratedDocumentBuildVariantTalentTree = {
  __typename?: 'WowforUserGeneratedDocumentBuildVariantTalentTree';
  branches?: Maybe<Array<WowforUserGeneratedDocumentBuildVariantTalentTreeBranch>>;
  description?: Maybe<NgfDocumentRichTextContent>;
};

export type WowforUserGeneratedDocumentBuildVariantTalentTreeBranch = {
  __typename?: 'WowforUserGeneratedDocumentBuildVariantTalentTreeBranch';
  branch: WowforTalentTrees;
  talents?: Maybe<Array<WowforUserGeneratedDocumentBuildVariantTalentTreeBranchTalent>>;
};

export type WowforUserGeneratedDocumentBuildVariantTalentTreeBranchTalent = {
  __typename?: 'WowforUserGeneratedDocumentBuildVariantTalentTreeBranchTalent';
  column?: Maybe<Scalars['Int']>;
  maxRank?: Maybe<Scalars['Int']>;
  rank: Scalars['Int'];
  requiredPoints?: Maybe<Scalars['Int']>;
  requiredTalent?: Maybe<WowforTalents>;
  row?: Maybe<Scalars['Int']>;
  talent: WowforTalents;
};

export type WowforUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'WowforUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<WowforUserGeneratedDocumentBuildVariant>>;
};

export enum WowforUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type WowforUserGeneratedDocumentCreateInput = {
  document: Scalars['WowforUserGeneratedDocumentInputBase64Json'];
};

export type WowforUserGeneratedDocumentCreatePayload = {
  __typename?: 'WowforUserGeneratedDocumentCreatePayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'WowforUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<WowforUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: WowforDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum WowforUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type WowforUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type WowforUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type WowforUserGeneratedDocumentPayload = {
  __typename?: 'WowforUserGeneratedDocumentPayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type WowforUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'WowforUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type WowforUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type WowforUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'WowforUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type WowforUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'WowforUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type WowforUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'WowforUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type WowforUserGeneratedDocumentUpdateInput = {
  document: Scalars['WowforUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type WowforUserGeneratedDocumentUpdatePayload = {
  __typename?: 'WowforUserGeneratedDocumentUpdatePayload';
  data?: Maybe<WowforUserGeneratedDocument>;
  error?: Maybe<WowforUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type WowforUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type WowforWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'WowforWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<WowforDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: WowforWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<WowforDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type WowforWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'WowforWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: WowforEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum WowforWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type WowforWikiDocumentPayload = {
  __typename?: 'WowforWikiDocumentPayload';
  data?: Maybe<WowforWikiDocument>;
  error?: Maybe<WowforWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type WowforWikiDocumentSetSeoPayload = {
  __typename?: 'WowforWikiDocumentSetSeoPayload';
  data?: Maybe<WowforWikiDocument>;
  error?: Maybe<WowforWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum WowforWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type WowforWikiDocumentUpdateInput = {
  document: Scalars['WowforWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type WowforWikiDocumentUpdatePayload = {
  __typename?: 'WowforWikiDocumentUpdatePayload';
  data?: Maybe<WowforWikiDocument>;
  error?: Maybe<WowforWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type WowforWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type WowforWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type XkoCharacters = XkoGameEntity & {
  __typename?: 'XkoCharacters';
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  playstyle?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type XkoCharactersFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type XkoCharactersResult = {
  __typename?: 'XkoCharactersResult';
  data?: Maybe<Array<XkoCharacters>>;
  error?: Maybe<XkoStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type XkoDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'XkoDocumentCmWidgetV1';
  data: XkoDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type XkoDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'XkoDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type XkoDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | XkoDocumentCmWidgetV1;

export type XkoDocumentSeason = NgfDocumentSeason & {
  __typename?: 'XkoDocumentSeason';
  slug: Scalars['String'];
};

export type XkoDocumentTags = NgfDocumentTags & {
  __typename?: 'XkoDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type XkoDocumentsMutation = {
  __typename?: 'XkoDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: XkoStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: XkoStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: XkoStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: XkoStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: XkoUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: XkoUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: XkoUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: XkoUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: XkoUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: XkoUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: XkoWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: XkoWikiDocumentUpdatePayload;
};

export type XkoDocumentsMutationstructDocumentCreateArgs = {
  input: XkoStructDocumentCreateInput;
};

export type XkoDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type XkoDocumentsMutationstructDocumentSetStatusArgs = {
  input: XkoStructDocumentSetStatusInput;
};

export type XkoDocumentsMutationstructDocumentUpdateArgs = {
  input: XkoStructDocumentUpdateInput;
};

export type XkoDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: XkoUserGeneratedDocumentCreateInput;
};

export type XkoDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: XkoUserGeneratedDocumentSetFavoriteInput;
};

export type XkoDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: XkoUserGeneratedDocumentSetFeaturedInput;
};

export type XkoDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type XkoDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: XkoUserGeneratedDocumentSetStatusInput;
};

export type XkoDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: XkoUserGeneratedDocumentUpdateInput;
};

export type XkoDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type XkoDocumentsMutationwikiDocumentUpdateArgs = {
  input: XkoWikiDocumentUpdateInput;
};

export type XkoDocumentsQuery = {
  __typename?: 'XkoDocumentsQuery';
  previewDocumentContent: XkoPreviewDocumentContentPayload;
  structDocumentBySlug: XkoStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: XkoUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: XkoUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: XkoUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: XkoUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: XkoTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: XkoWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type XkoDocumentsQuerypreviewDocumentContentArgs = {
  input: XkoPreviewDocumentContentInput;
};

export type XkoDocumentsQuerystructDocumentBySlugArgs = {
  input: XkoStructDocumentInputBySlug;
};

export type XkoDocumentsQuerystructDocumentsArgs = {
  input: XkoStructDocumentsInput;
};

export type XkoDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: XkoUserGeneratedDocumentInputById;
};

export type XkoDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: XkoUserGeneratedDocumentInputBySlug;
};

export type XkoDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type XkoDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type XkoDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type XkoDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type XkoDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: XkoTemplateDocumentInput;
};

export type XkoDocumentsQueryuserGeneratedDocumentsArgs = {
  input: XkoUserGeneratedDocumentsListInput;
  page: XkoUserGeneratedDocumentsListPage;
};

export type XkoDocumentsQuerywikiDocumentArgs = {
  input: XkoWikiDocumentInput;
};

export type XkoDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<XkoWikiDocumentsListInput>;
  page: XkoWikiDocumentsListPage;
};

export enum XkoEntitiesEnum {
  characters = 'characters',
  fuses = 'fuses',
  inputs = 'inputs',
}

export type XkoEntityObject = NGFEntityObject & {
  __typename?: 'XkoEntityObject';
  color?: Maybe<Scalars['String']>;
  entityV2?: Maybe<XkoGameEntity>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type XkoFuses = XkoGameEntity & {
  __typename?: 'XkoFuses';
  color?: Maybe<Scalars['String']>;
  deprecated: Scalars['Boolean'];
  effect?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type XkoFusesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type XkoFusesResult = {
  __typename?: 'XkoFusesResult';
  data?: Maybe<Array<XkoFuses>>;
  error?: Maybe<XkoStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type XkoGameEntity = {
  slug: Scalars['String'];
};

export type XkoInputs = XkoGameEntity & {
  __typename?: 'XkoInputs';
  deprecated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type XkoInputsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<PageInput>;
  slug?: InputMaybe<OneOfString>;
  status?: InputMaybe<StaticDataEntityStatusInput>;
};

export type XkoInputsResult = {
  __typename?: 'XkoInputsResult';
  data?: Maybe<Array<XkoInputs>>;
  error?: Maybe<XkoStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
};

export type XkoMutation = {
  __typename?: 'XkoMutation';
  documents?: Maybe<XkoDocumentsMutation>;
  id: Scalars['ID'];
};

export enum XkoPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoPreviewDocumentContentInput = {
  content: Scalars['XkoDocumentContentInputBase64Json'];
};

export type XkoPreviewDocumentContentPayload = {
  __typename?: 'XkoPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<XkoDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<XkoPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoProfile = NgfProfile & {
  __typename?: 'XkoProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type XkoProfileuserGeneratedDocumentsArgs = {
  input: XkoUserGeneratedDocumentsListInput;
  page: XkoUserGeneratedDocumentsListPage;
};

export type XkoProfilePayload = {
  __typename?: 'XkoProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<XkoProfile>;
};

export type XkoProfilesQuery = {
  __typename?: 'XkoProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: XkoProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type XkoProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type XkoQuery = {
  __typename?: 'XkoQuery';
  documents?: Maybe<XkoDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<XkoProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<XkoStaticDataQuery>;
};

export enum XkoStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type XkoStaticDataGroups = {
  __typename?: 'XkoStaticDataGroups';
  characters: XkoCharactersResult;
  fuses: XkoFusesResult;
  inputs: XkoInputsResult;
};

export type XkoStaticDataGroupscharactersArgs = {
  filter?: InputMaybe<XkoCharactersFilter>;
};

export type XkoStaticDataGroupsfusesArgs = {
  filter?: InputMaybe<XkoFusesFilter>;
};

export type XkoStaticDataGroupsinputsArgs = {
  filter?: InputMaybe<XkoInputsFilter>;
};

export type XkoStaticDataQuery = {
  __typename?: 'XkoStaticDataQuery';
  groups: XkoStaticDataGroups;
  metadata: StaticDataMetadata;
};

export type XkoStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'XkoStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<XkoDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: XkoStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum XkoStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type XkoStructDocumentCreateInput = {
  document: Scalars['XkoStructDocumentInputBase64Json'];
};

export type XkoStructDocumentCreatePayload = {
  __typename?: 'XkoStructDocumentCreatePayload';
  data?: Maybe<XkoStructDocument>;
  error?: Maybe<XkoStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoStructDocumentData = NgfStructDocumentData & {
  __typename?: 'XkoStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: XkoDocumentSeason;
  tags?: Maybe<XkoDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum XkoStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type XkoStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type XkoStructDocumentPayload = {
  __typename?: 'XkoStructDocumentPayload';
  data?: Maybe<XkoStructDocument>;
  error?: Maybe<XkoStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type XkoStructDocumentSetSeoPayload = {
  __typename?: 'XkoStructDocumentSetSeoPayload';
  data?: Maybe<XkoStructDocument>;
  error?: Maybe<XkoStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type XkoStructDocumentSetStatusPayload = {
  __typename?: 'XkoStructDocumentSetStatusPayload';
  data?: Maybe<XkoStructDocument>;
  error?: Maybe<XkoStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoStructDocumentUpdateInput = {
  document: Scalars['XkoStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type XkoStructDocumentUpdatePayload = {
  __typename?: 'XkoStructDocumentUpdatePayload';
  data?: Maybe<XkoStructDocument>;
  error?: Maybe<XkoStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type XkoTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'XkoTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<XkoDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: XkoTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type XkoTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'XkoTemplateDocumentData';
  buildVariants?: Maybe<XkoUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: XkoDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum XkoTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoTemplateDocumentInput = {
  type: Scalars['String'];
};

export type XkoTemplateDocumentPayload = {
  __typename?: 'XkoTemplateDocumentPayload';
  data?: Maybe<XkoTemplateDocument>;
  error?: Maybe<XkoTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'XkoUGDocumentGenericBuilder';
  slots?: Maybe<Array<XkoUGDocumentGenericBuilderSlot>>;
};

export type XkoUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'XkoUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<XkoEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type XkoUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'XkoUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<XkoDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: XkoUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<XkoDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type XkoUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'XkoUserGeneratedDocumentBuildVariant';
  genericBuilder: XkoUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type XkoUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'XkoUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<XkoUserGeneratedDocumentBuildVariant>>;
};

export enum XkoUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type XkoUserGeneratedDocumentCreateInput = {
  document: Scalars['XkoUserGeneratedDocumentInputBase64Json'];
};

export type XkoUserGeneratedDocumentCreatePayload = {
  __typename?: 'XkoUserGeneratedDocumentCreatePayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'XkoUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<XkoUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: XkoDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum XkoUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type XkoUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type XkoUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type XkoUserGeneratedDocumentPayload = {
  __typename?: 'XkoUserGeneratedDocumentPayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type XkoUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'XkoUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type XkoUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type XkoUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'XkoUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type XkoUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'XkoUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type XkoUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'XkoUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type XkoUserGeneratedDocumentUpdateInput = {
  document: Scalars['XkoUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type XkoUserGeneratedDocumentUpdatePayload = {
  __typename?: 'XkoUserGeneratedDocumentUpdatePayload';
  data?: Maybe<XkoUserGeneratedDocument>;
  error?: Maybe<XkoUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type XkoUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type XkoWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'XkoWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<XkoDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: XkoWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<XkoDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type XkoWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'XkoWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: XkoEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum XkoWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type XkoWikiDocumentPayload = {
  __typename?: 'XkoWikiDocumentPayload';
  data?: Maybe<XkoWikiDocument>;
  error?: Maybe<XkoWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type XkoWikiDocumentSetSeoPayload = {
  __typename?: 'XkoWikiDocumentSetSeoPayload';
  data?: Maybe<XkoWikiDocument>;
  error?: Maybe<XkoWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum XkoWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type XkoWikiDocumentUpdateInput = {
  document: Scalars['XkoWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type XkoWikiDocumentUpdatePayload = {
  __typename?: 'XkoWikiDocumentUpdatePayload';
  data?: Maybe<XkoWikiDocument>;
  error?: Maybe<XkoWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type XkoWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type XkoWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type ZzzAgent = ZzzGameEntity & {
  __typename?: 'ZzzAgent';
  agentSkillSlugs?: Maybe<Array<Scalars['String']>>;
  agentSkills?: Maybe<Array<ZzzAgentSkill>>;
  ascensionMaterials?: Maybe<Array<ZzzAscensionMaterials>>;
  attackType?: Maybe<ZzzAttackType>;
  attackTypeSlug?: Maybe<Scalars['String']>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  camp?: Maybe<ZzzCamp>;
  campSlug?: Maybe<Scalars['String']>;
  defaultLevel?: Maybe<Scalars['String']>;
  elementType?: Maybe<ZzzElementType>;
  elementTypeSlug?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leveledStats?: Maybe<Array<ZzzLeveledStats>>;
  mindscapeCinema?: Maybe<Array<ZzzMindscapeCinema>>;
  mindscapeCinemaSlugs?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  portraitIconUrl?: Maybe<Scalars['String']>;
  rarity?: Maybe<ZzzRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  typeOfEntity?: Maybe<Scalars['String']>;
  weaponType?: Maybe<ZzzWeaponType>;
  weaponTypeSlug?: Maybe<Scalars['String']>;
};

export type ZzzAgentSkill = ZzzGameEntity & {
  __typename?: 'ZzzAgentSkill';
  agent?: Maybe<ZzzAgent>;
  agentSkillType?: Maybe<ZzzAgentSkillType>;
  agentSkillTypeSlug?: Maybe<Scalars['String']>;
  agentSlug?: Maybe<Scalars['String']>;
  defaultLevel?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leveledDescriptions?: Maybe<Array<ZzzLeveledDescriptions>>;
  leveledSkillAttributes?: Maybe<Array<ZzzLeveledSkillAttributes>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzAgentSkillType = ZzzGameEntity & {
  __typename?: 'ZzzAgentSkillType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzAgentSkillTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzAgentSkillTypesResult = {
  __typename?: 'ZzzAgentSkillTypesResult';
  data?: Maybe<Array<ZzzAgentSkillType>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzAgentSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzAgentSkillsResult = {
  __typename?: 'ZzzAgentSkillsResult';
  data?: Maybe<Array<ZzzAgentSkill>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzAgentsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzAgentsResult = {
  __typename?: 'ZzzAgentsResult';
  data?: Maybe<Array<ZzzAgent>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzAscensionMaterials = {
  __typename?: 'ZzzAscensionMaterials';
  level?: Maybe<Scalars['String']>;
  materials?: Maybe<Array<ZzzAscensionMaterialsMaterials>>;
};

export type ZzzAscensionMaterialsMaterials = {
  __typename?: 'ZzzAscensionMaterialsMaterials';
  item?: Maybe<ZzzItem>;
  itemSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ZzzAttackType = ZzzGameEntity & {
  __typename?: 'ZzzAttackType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzAttackTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzAttackTypesResult = {
  __typename?: 'ZzzAttackTypesResult';
  data?: Maybe<Array<ZzzAttackType>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzBangboo = ZzzGameEntity & {
  __typename?: 'ZzzBangboo';
  ascensionMaterials?: Maybe<Array<ZzzAscensionMaterials>>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  bangbooSkillSlugs?: Maybe<Array<Scalars['String']>>;
  bangbooSkills?: Maybe<Array<ZzzBangboosSkill>>;
  defaultLevel?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leveledStats?: Maybe<Array<ZzzLeveledStats>>;
  name: Scalars['String'];
  rarity?: Maybe<ZzzRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  typeOfEntity?: Maybe<Scalars['String']>;
};

export type ZzzBangbooSkillType = ZzzGameEntity & {
  __typename?: 'ZzzBangbooSkillType';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzBangbooSkillTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzBangbooSkillTypesResult = {
  __typename?: 'ZzzBangbooSkillTypesResult';
  data?: Maybe<Array<ZzzBangbooSkillType>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzBangboosFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzBangboosResult = {
  __typename?: 'ZzzBangboosResult';
  data?: Maybe<Array<ZzzBangboo>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzBangboosSkill = ZzzGameEntity & {
  __typename?: 'ZzzBangboosSkill';
  bangboo?: Maybe<ZzzBangboo>;
  bangbooSkillType?: Maybe<ZzzBangbooSkillType>;
  bangbooSkillTypeSlug?: Maybe<Scalars['String']>;
  bangbooSlug?: Maybe<Scalars['String']>;
  defaultLevel?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leveledDescriptions?: Maybe<Array<ZzzLeveledDescriptions>>;
  leveledSkillAttributes?: Maybe<Array<ZzzLeveledSkillAttributes>>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzBangboosSkillsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzBangboosSkillsResult = {
  __typename?: 'ZzzBangboosSkillsResult';
  data?: Maybe<Array<ZzzBangboosSkill>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzCamp = ZzzGameEntity & {
  __typename?: 'ZzzCamp';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzCampsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzCampsResult = {
  __typename?: 'ZzzCampsResult';
  data?: Maybe<Array<ZzzCamp>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzDocumentCmWidgetV1 = NgfDocumentContent & {
  __typename?: 'ZzzDocumentCmWidgetV1';
  data: ZzzDocumentCmWidgetV1Data;
  id: Scalars['ID'];
  meta: NgfDocumentContentMeta;
};

export type ZzzDocumentCmWidgetV1Data = NgfDocumentContentData & {
  __typename?: 'ZzzDocumentCmWidgetV1Data';
  border: Scalars['String'];
  content: Scalars['NgfDocumentWidgetRichTextContentJson'];
  focusMode?: Maybe<NgfDocumentContentDataFocusMode>;
  isStickyInEditingMode: Scalars['Boolean'];
  isStickyInViewMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type ZzzDocumentContent =
  | NgfDocumentCmSectionAuto1V1
  | NgfDocumentCmSectionAuto3V1
  | NgfDocumentCmSectionAuto400V1
  | NgfDocumentCmSectionVideoAdV1
  | NgfDocumentCmWidgetCardGridV1
  | NgfDocumentCmWidgetCardGridV2
  | NgfDocumentCmWidgetCommentsV1
  | NgfDocumentCmWidgetContentVariantsV1
  | NgfDocumentCmWidgetCrossPageTabBarV1
  | NgfDocumentCmWidgetDiscoveryPersonalFeedV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV1
  | NgfDocumentCmWidgetDiscoveryPreviewCompactV2
  | NgfDocumentCmWidgetDiscoveryPreviewV1
  | NgfDocumentCmWidgetDiscoveryPreviewV2
  | NgfDocumentCmWidgetDisplayAdsV1
  | NgfDocumentCmWidgetDocumentsFeedV1
  | NgfDocumentCmWidgetDocumentsFeedV2
  | NgfDocumentCmWidgetErrorV1
  | NgfDocumentCmWidgetGameDataCardGridV1
  | NgfDocumentCmWidgetGameDataCardGridV2
  | NgfDocumentCmWidgetMapV1
  | NgfDocumentCmWidgetPromoBannerHorizontalV1
  | NgfDocumentCmWidgetPromoBannerNetboardV1
  | NgfDocumentCmWidgetRichTextSimplifiedV1
  | NgfDocumentCmWidgetRichTextSimplifiedV2
  | NgfDocumentCmWidgetRichTextV1
  | NgfDocumentCmWidgetRichTextV2
  | NgfDocumentCmWidgetStrengthsAndWeaknessesV1
  | NgfDocumentCmWidgetTableOfContentV1
  | NgfDocumentCmWidgetTierListMakerV1
  | NgfDocumentCmWidgetUGTierListV1
  | NgfDocumentCmWidgetUGTierListV2
  | NgfDocumentCmWidgetVideoV1
  | NgfDocumentCmWidgetVideoV2
  | NgfDocumentCmWidgetWikiDiscoveryDetailedV1
  | NgfDocumentStWidgetDocumentsDiscoveryV1
  | NgfDocumentStWidgetHeaderV1
  | NgfDocumentStWidgetHeaderV2
  | NgfDocumentStWidgetHomePageHeaderV1
  | NgfDocumentStWidgetHomePageHeaderV2
  | NgfDocumentStWidgetLinksGridManualV1
  | NgfDocumentStWidgetLinksGridManualV2
  | NgfDocumentUgWidgetBuilderV1
  | NgfDocumentUgWidgetHeaderV1
  | NgfDocumentWkSectionSlotV1
  | ZzzDocumentCmWidgetV1;

export type ZzzDocumentSeason = NgfDocumentSeason & {
  __typename?: 'ZzzDocumentSeason';
  slug: Scalars['String'];
};

export type ZzzDocumentTags = NgfDocumentTags & {
  __typename?: 'ZzzDocumentTags';
  data?: Maybe<Array<NgfDocumentTag>>;
};

export type ZzzDocumentsMutation = {
  __typename?: 'ZzzDocumentsMutation';
  /** Create operation creates a new document with the provided data and content. */
  structDocumentCreate: ZzzStructDocumentCreatePayload;
  /** SEO operation affects only document.seo field. */
  structDocumentSetSeo: ZzzStructDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  structDocumentSetStatus: ZzzStructDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  structDocumentUpdate: ZzzStructDocumentUpdatePayload;
  /** Create operation creates a new document with the provided data and content. */
  userGeneratedDocumentCreate: ZzzUserGeneratedDocumentCreatePayload;
  /** Status operation affects only document.favorites field. */
  userGeneratedDocumentSetFavorite: ZzzUserGeneratedDocumentSetFavoritePayload;
  /** Status operation affects only document.featured field. */
  userGeneratedDocumentSetFeatured: ZzzUserGeneratedDocumentSetFeaturedPayload;
  /** SEO operation affects only document.seo field. */
  userGeneratedDocumentSetSeo: ZzzUserGeneratedDocumentSetSeoPayload;
  /** Status operation affects only document.status field. */
  userGeneratedDocumentSetStatus: ZzzUserGeneratedDocumentSetStatusPayload;
  /** Update operation affects only document.data and document.content fields. */
  userGeneratedDocumentUpdate: ZzzUserGeneratedDocumentUpdatePayload;
  /** Updates wiki SEO. Affects only document.seo field. */
  wikiDocumentSetSeo: ZzzWikiDocumentSetSeoPayload;
  /** Wiki update operation affects only document.data and document.content fields. */
  wikiDocumentUpdate: ZzzWikiDocumentUpdatePayload;
};

export type ZzzDocumentsMutationstructDocumentCreateArgs = {
  input: ZzzStructDocumentCreateInput;
};

export type ZzzDocumentsMutationstructDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type ZzzDocumentsMutationstructDocumentSetStatusArgs = {
  input: ZzzStructDocumentSetStatusInput;
};

export type ZzzDocumentsMutationstructDocumentUpdateArgs = {
  input: ZzzStructDocumentUpdateInput;
};

export type ZzzDocumentsMutationuserGeneratedDocumentCreateArgs = {
  input: ZzzUserGeneratedDocumentCreateInput;
};

export type ZzzDocumentsMutationuserGeneratedDocumentSetFavoriteArgs = {
  input: ZzzUserGeneratedDocumentSetFavoriteInput;
};

export type ZzzDocumentsMutationuserGeneratedDocumentSetFeaturedArgs = {
  input: ZzzUserGeneratedDocumentSetFeaturedInput;
};

export type ZzzDocumentsMutationuserGeneratedDocumentSetSeoArgs = {
  input: NgfDocumentSetSeoInput;
};

export type ZzzDocumentsMutationuserGeneratedDocumentSetStatusArgs = {
  input: ZzzUserGeneratedDocumentSetStatusInput;
};

export type ZzzDocumentsMutationuserGeneratedDocumentUpdateArgs = {
  input: ZzzUserGeneratedDocumentUpdateInput;
};

export type ZzzDocumentsMutationwikiDocumentSetSeoArgs = {
  input: NgfWikiDocumentSetSeoInput;
};

export type ZzzDocumentsMutationwikiDocumentUpdateArgs = {
  input: ZzzWikiDocumentUpdateInput;
};

export type ZzzDocumentsQuery = {
  __typename?: 'ZzzDocumentsQuery';
  previewDocumentContent: ZzzPreviewDocumentContentPayload;
  structDocumentBySlug: ZzzStructDocumentPayload;
  structDocumentWidgets: NgfStructDocumentWidgetsPayload;
  structDocuments: NgfStructDocumentsListPayload;
  userGeneratedDocumentById: ZzzUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlug: ZzzUserGeneratedDocumentPayload;
  /** @deprecated Use userGeneratedDocumentBySlugifiedNameV2, which requires the document type. */
  userGeneratedDocumentBySlugifiedName: ZzzUserGeneratedDocumentPayload;
  userGeneratedDocumentBySlugifiedNameV2: ZzzUserGeneratedDocumentPayload;
  userGeneratedDocumentGroups: NgfUserGeneratedDocumentGroupsPayload;
  userGeneratedDocumentTagGroups: NgfUserGeneratedDocumentTagGroupsPayload;
  userGeneratedDocumentTemplate: ZzzTemplateDocumentPayload;
  userGeneratedDocumentTypes: NgfUserGeneratedDocumentTypesPayload;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
  wikiDocument: ZzzWikiDocumentPayload;
  wikiDocumentType: NgfWikiDocumentTypePayload;
  wikiDocuments: NgfWikiDocumentsListPayload;
};

export type ZzzDocumentsQuerypreviewDocumentContentArgs = {
  input: ZzzPreviewDocumentContentInput;
};

export type ZzzDocumentsQuerystructDocumentBySlugArgs = {
  input: ZzzStructDocumentInputBySlug;
};

export type ZzzDocumentsQuerystructDocumentsArgs = {
  input: ZzzStructDocumentsInput;
};

export type ZzzDocumentsQueryuserGeneratedDocumentByIdArgs = {
  input: ZzzUserGeneratedDocumentInputById;
};

export type ZzzDocumentsQueryuserGeneratedDocumentBySlugArgs = {
  input: ZzzUserGeneratedDocumentInputBySlug;
};

export type ZzzDocumentsQueryuserGeneratedDocumentBySlugifiedNameArgs = {
  input: NgfUserGeneratedDocumentInputBySlugifiedName;
};

export type ZzzDocumentsQueryuserGeneratedDocumentBySlugifiedNameV2Args = {
  input: NgfUserGeneratedDocumentInputBySlugifiedNameV2;
};

export type ZzzDocumentsQueryuserGeneratedDocumentGroupsArgs = {
  input: NgfUserGeneratedDocumentGroupsInput;
};

export type ZzzDocumentsQueryuserGeneratedDocumentTagGroupsArgs = {
  input?: InputMaybe<NgfUserGeneratedDocumentTagGroupsInput>;
};

export type ZzzDocumentsQueryuserGeneratedDocumentTemplateArgs = {
  input: ZzzTemplateDocumentInput;
};

export type ZzzDocumentsQueryuserGeneratedDocumentsArgs = {
  input: ZzzUserGeneratedDocumentsListInput;
  page: ZzzUserGeneratedDocumentsListPage;
};

export type ZzzDocumentsQuerywikiDocumentArgs = {
  input: ZzzWikiDocumentInput;
};

export type ZzzDocumentsQuerywikiDocumentsArgs = {
  input?: InputMaybe<ZzzWikiDocumentsListInput>;
  page: ZzzWikiDocumentsListPage;
};

export type ZzzDriveDisc = ZzzGameEntity & {
  __typename?: 'ZzzDriveDisc';
  fourPieceBonusDescription?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  twoPieceBonusDescription?: Maybe<Scalars['String']>;
  typeOfEntity?: Maybe<Scalars['String']>;
};

export type ZzzDriveDiscsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzDriveDiscsResult = {
  __typename?: 'ZzzDriveDiscsResult';
  data?: Maybe<Array<ZzzDriveDisc>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzElementType = ZzzGameEntity & {
  __typename?: 'ZzzElementType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzElementTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzElementTypesResult = {
  __typename?: 'ZzzElementTypesResult';
  data?: Maybe<Array<ZzzElementType>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export enum ZzzEntitiesEnum {
  agentSkillTypes = 'agentSkillTypes',
  agentSkills = 'agentSkills',
  agents = 'agents',
  attackTypes = 'attackTypes',
  bangbooSkillTypes = 'bangbooSkillTypes',
  bangboos = 'bangboos',
  bangboosSkills = 'bangboosSkills',
  camps = 'camps',
  driveDiscs = 'driveDiscs',
  elementTypes = 'elementTypes',
  items = 'items',
  mindscapeCinemas = 'mindscapeCinemas',
  rarities = 'rarities',
  refinements = 'refinements',
  skillAttributes = 'skillAttributes',
  stats = 'stats',
  weaponTypes = 'weaponTypes',
  weapons = 'weapons',
}

export type ZzzEntityObject = NGFEntityObject & {
  __typename?: 'ZzzEntityObject';
  color?: Maybe<Scalars['String']>;
  entity?: Maybe<ZzzGameEntity>;
  enumType?: Maybe<ZzzEntitiesEnum>;
  iconUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ZzzGameEntity = {
  slug: Scalars['String'];
};

export type ZzzItem = ZzzGameEntity & {
  __typename?: 'ZzzItem';
  backgroundColorHex?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  rarity?: Maybe<ZzzRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  typeOfEntity?: Maybe<Scalars['String']>;
};

export type ZzzItemsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzItemsResult = {
  __typename?: 'ZzzItemsResult';
  data?: Maybe<Array<ZzzItem>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzLeveledDescriptions = {
  __typename?: 'ZzzLeveledDescriptions';
  level?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ZzzLeveledSkillAttributes = {
  __typename?: 'ZzzLeveledSkillAttributes';
  level?: Maybe<Scalars['String']>;
  leveledSkillAttributesValues?: Maybe<Array<ZzzLeveledSkillAttributesValue>>;
};

export type ZzzLeveledSkillAttributesValue = {
  __typename?: 'ZzzLeveledSkillAttributesValue';
  skillAttribute?: Maybe<ZzzSkillAttribute>;
  skillAttributeSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ZzzLeveledStats = {
  __typename?: 'ZzzLeveledStats';
  level?: Maybe<Scalars['String']>;
  leveledStatsValues?: Maybe<Array<ZzzLeveledStatsLeveledStatsValues>>;
};

export type ZzzLeveledStatsLeveledStatsValues = {
  __typename?: 'ZzzLeveledStatsLeveledStatsValues';
  stat?: Maybe<ZzzStat>;
  statSlug?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ZzzMindscapeCinema = ZzzGameEntity & {
  __typename?: 'ZzzMindscapeCinema';
  agent?: Maybe<ZzzAgent>;
  agentSlug?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzMindscapeCinemasFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzMindscapeCinemasResult = {
  __typename?: 'ZzzMindscapeCinemasResult';
  data?: Maybe<Array<ZzzMindscapeCinema>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzMutation = {
  __typename?: 'ZzzMutation';
  documents?: Maybe<ZzzDocumentsMutation>;
  id: Scalars['ID'];
};

export enum ZzzPreviewDocumentContentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzPreviewDocumentContentInput = {
  content: Scalars['ZzzDocumentContentInputBase64Json'];
};

export type ZzzPreviewDocumentContentPayload = {
  __typename?: 'ZzzPreviewDocumentContentPayload';
  /** @deprecated Use dataV2 */
  data?: Maybe<ZzzDocumentContent>;
  dataV2?: Maybe<NgfDocumentContent>;
  error?: Maybe<ZzzPreviewDocumentContentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzProfile = NgfProfile & {
  __typename?: 'ZzzProfile';
  author?: Maybe<NgfDocumentAuthor>;
  userGeneratedDocuments: NgfUserGeneratedDocumentsListPayload;
};

export type ZzzProfileuserGeneratedDocumentsArgs = {
  input: ZzzUserGeneratedDocumentsListInput;
  page: ZzzUserGeneratedDocumentsListPage;
};

export type ZzzProfilePayload = {
  __typename?: 'ZzzProfilePayload';
  error?: Maybe<NgfProfileError>;
  errorMessage?: Maybe<Scalars['String']>;
  profile?: Maybe<ZzzProfile>;
};

export type ZzzProfilesQuery = {
  __typename?: 'ZzzProfilesQuery';
  creators: NgfCreatorsPayload;
  pageConfig: NgfProfilePageConfigPayload;
  userProfile: ZzzProfilePayload;
  userProfiles: NgfUserProfilesPayload;
};

export type ZzzProfilesQueryuserProfileArgs = {
  input: NgfProfileInput;
};

export type ZzzQuery = {
  __typename?: 'ZzzQuery';
  documents?: Maybe<ZzzDocumentsQuery>;
  id: Scalars['ID'];
  permissions: NgfUserPermissions;
  profiles?: Maybe<ZzzProfilesQuery>;
  settings?: Maybe<NgfGameSettings>;
  staticData?: Maybe<ZzzStaticDataQuery>;
};

export type ZzzRaritiesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzRaritiesResult = {
  __typename?: 'ZzzRaritiesResult';
  data?: Maybe<Array<ZzzRarity>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzRarity = ZzzGameEntity & {
  __typename?: 'ZzzRarity';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzRefinement = ZzzGameEntity & {
  __typename?: 'ZzzRefinement';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzRefinementsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzRefinementsResult = {
  __typename?: 'ZzzRefinementsResult';
  data?: Maybe<Array<ZzzRefinement>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzSkillAttribute = ZzzGameEntity & {
  __typename?: 'ZzzSkillAttribute';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzSkillAttributesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzSkillAttributesResult = {
  __typename?: 'ZzzSkillAttributesResult';
  data?: Maybe<Array<ZzzSkillAttribute>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzStat = ZzzGameEntity & {
  __typename?: 'ZzzStat';
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export enum ZzzStaticDataError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
}

export type ZzzStaticDataQuery = {
  __typename?: 'ZzzStaticDataQuery';
  zzzAgentSkillTypes: ZzzAgentSkillTypesResult;
  zzzAgentSkills: ZzzAgentSkillsResult;
  zzzAgents: ZzzAgentsResult;
  zzzAttackTypes: ZzzAttackTypesResult;
  zzzBangbooSkillTypes: ZzzBangbooSkillTypesResult;
  zzzBangboos: ZzzBangboosResult;
  zzzBangboosSkills: ZzzBangboosSkillsResult;
  zzzCamps: ZzzCampsResult;
  zzzDriveDiscs: ZzzDriveDiscsResult;
  zzzElementTypes: ZzzElementTypesResult;
  zzzItems: ZzzItemsResult;
  zzzMindscapeCinemas: ZzzMindscapeCinemasResult;
  zzzRarities: ZzzRaritiesResult;
  zzzRefinements: ZzzRefinementsResult;
  zzzSkillAttributes: ZzzSkillAttributesResult;
  zzzStats: ZzzStatsResult;
  zzzWeaponTypes: ZzzWeaponTypesResult;
  zzzWeapons: ZzzWeaponsResult;
};

export type ZzzStaticDataQueryzzzAgentSkillTypesArgs = {
  filter?: InputMaybe<ZzzAgentSkillTypesFilter>;
};

export type ZzzStaticDataQueryzzzAgentSkillsArgs = {
  filter?: InputMaybe<ZzzAgentSkillsFilter>;
};

export type ZzzStaticDataQueryzzzAgentsArgs = {
  filter?: InputMaybe<ZzzAgentsFilter>;
};

export type ZzzStaticDataQueryzzzAttackTypesArgs = {
  filter?: InputMaybe<ZzzAttackTypesFilter>;
};

export type ZzzStaticDataQueryzzzBangbooSkillTypesArgs = {
  filter?: InputMaybe<ZzzBangbooSkillTypesFilter>;
};

export type ZzzStaticDataQueryzzzBangboosArgs = {
  filter?: InputMaybe<ZzzBangboosFilter>;
};

export type ZzzStaticDataQueryzzzBangboosSkillsArgs = {
  filter?: InputMaybe<ZzzBangboosSkillsFilter>;
};

export type ZzzStaticDataQueryzzzCampsArgs = {
  filter?: InputMaybe<ZzzCampsFilter>;
};

export type ZzzStaticDataQueryzzzDriveDiscsArgs = {
  filter?: InputMaybe<ZzzDriveDiscsFilter>;
};

export type ZzzStaticDataQueryzzzElementTypesArgs = {
  filter?: InputMaybe<ZzzElementTypesFilter>;
};

export type ZzzStaticDataQueryzzzItemsArgs = {
  filter?: InputMaybe<ZzzItemsFilter>;
};

export type ZzzStaticDataQueryzzzMindscapeCinemasArgs = {
  filter?: InputMaybe<ZzzMindscapeCinemasFilter>;
};

export type ZzzStaticDataQueryzzzRaritiesArgs = {
  filter?: InputMaybe<ZzzRaritiesFilter>;
};

export type ZzzStaticDataQueryzzzRefinementsArgs = {
  filter?: InputMaybe<ZzzRefinementsFilter>;
};

export type ZzzStaticDataQueryzzzSkillAttributesArgs = {
  filter?: InputMaybe<ZzzSkillAttributesFilter>;
};

export type ZzzStaticDataQueryzzzStatsArgs = {
  filter?: InputMaybe<ZzzStatsFilter>;
};

export type ZzzStaticDataQueryzzzWeaponTypesArgs = {
  filter?: InputMaybe<ZzzWeaponTypesFilter>;
};

export type ZzzStaticDataQueryzzzWeaponsArgs = {
  filter?: InputMaybe<ZzzWeaponsFilter>;
};

export type ZzzStatsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzStatsResult = {
  __typename?: 'ZzzStatsResult';
  data?: Maybe<Array<ZzzStat>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzStructDocument = NgfDocument &
  NgfStructDocument &
  NgfStructDocumentMetadata & {
    __typename?: 'ZzzStructDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<ZzzDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ZzzStructDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    status: NgfStructDocumentStatus;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export enum ZzzStructDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ZzzStructDocumentCreateInput = {
  document: Scalars['ZzzStructDocumentInputBase64Json'];
};

export type ZzzStructDocumentCreatePayload = {
  __typename?: 'ZzzStructDocumentCreatePayload';
  data?: Maybe<ZzzStructDocument>;
  error?: Maybe<ZzzStructDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzStructDocumentData = NgfStructDocumentData & {
  __typename?: 'ZzzStructDocumentData';
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ZzzDocumentSeason;
  tags?: Maybe<ZzzDocumentTags>;
  tierLists: NgfDocumentTierListData;
};

export enum ZzzStructDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type ZzzStructDocumentInputBySlug = {
  /** Slug is unique human readable identifier of a struct document. */
  slug: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ZzzStructDocumentPayload = {
  __typename?: 'ZzzStructDocumentPayload';
  data?: Maybe<ZzzStructDocument>;
  error?: Maybe<ZzzStructDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzStructDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ZzzStructDocumentSetSeoPayload = {
  __typename?: 'ZzzStructDocumentSetSeoPayload';
  data?: Maybe<ZzzStructDocument>;
  error?: Maybe<ZzzStructDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzStructDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzStructDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfStructDocumentStatus;
};

export type ZzzStructDocumentSetStatusPayload = {
  __typename?: 'ZzzStructDocumentSetStatusPayload';
  data?: Maybe<ZzzStructDocument>;
  error?: Maybe<ZzzStructDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzStructDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzStructDocumentUpdateInput = {
  document: Scalars['ZzzStructDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type ZzzStructDocumentUpdatePayload = {
  __typename?: 'ZzzStructDocumentUpdatePayload';
  data?: Maybe<ZzzStructDocument>;
  error?: Maybe<ZzzStructDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzStructDocumentsInput = {
  statuses: Array<NgfStructDocumentStatus>;
};

export type ZzzTemplateDocument = NgfTemplateDocument &
  NgfTemplateDocumentMetadata & {
    __typename?: 'ZzzTemplateDocument';
    /** @deprecated Use contentV2 */
    content: Array<ZzzDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    data: ZzzTemplateDocumentData;
    type: Scalars['String'];
    typeData: NgfDocumentType;
  };

export type ZzzTemplateDocumentData = NgfTemplateDocumentData & {
  __typename?: 'ZzzTemplateDocumentData';
  buildVariants?: Maybe<ZzzUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ZzzDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum ZzzTemplateDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzTemplateDocumentInput = {
  type: Scalars['String'];
};

export type ZzzTemplateDocumentPayload = {
  __typename?: 'ZzzTemplateDocumentPayload';
  data?: Maybe<ZzzTemplateDocument>;
  error?: Maybe<ZzzTemplateDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzUGDocumentGenericBuilder = NgfBuildVariantGenericBuilder & {
  __typename?: 'ZzzUGDocumentGenericBuilder';
  slots?: Maybe<Array<ZzzUGDocumentGenericBuilderSlot>>;
};

export type ZzzUGDocumentGenericBuilderSlot = NgfBuildVariantGenericBuilderSlot & {
  __typename?: 'ZzzUGDocumentGenericBuilderSlot';
  gameEntity?: Maybe<ZzzEntityObject>;
  gameSlotSlug: Scalars['String'];
};

export type ZzzUserGeneratedDocument = NgfDocument &
  NgfUserGeneratedDocument &
  NgfUserGeneratedDocumentMetadata & {
    __typename?: 'ZzzUserGeneratedDocument';
    author: NgfDocumentAuthor;
    category: NgfDocumentCategory;
    comments?: Maybe<NgfDocumentComments>;
    /** @deprecated Use contentV2 */
    content: Array<ZzzDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ZzzUserGeneratedDocumentData;
    documentDescriptor: DocumentDescriptor;
    favorites: NgfDocumentFavorites;
    featured?: Maybe<NgfDocumentFeatured>;
    firstPublishedAt?: Maybe<Scalars['NgfDateTime']>;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slugifiedName?: Maybe<Scalars['String']>;
    status: NgfUserGeneratedDocumentStatus;
    tags?: Maybe<ZzzDocumentTags>;
    type: Scalars['String'];
    typeData: NgfDocumentType;
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type ZzzUserGeneratedDocumentBuildVariant = NgfUserGeneratedDocumentDataBuildVariant & {
  __typename?: 'ZzzUserGeneratedDocumentBuildVariant';
  genericBuilder: ZzzUGDocumentGenericBuilder;
  id: Scalars['ID'];
};

export type ZzzUserGeneratedDocumentBuildVariants = NgfUserGeneratedDocumentDataBuildVariants & {
  __typename?: 'ZzzUserGeneratedDocumentBuildVariants';
  values?: Maybe<Array<ZzzUserGeneratedDocumentBuildVariant>>;
};

export enum ZzzUserGeneratedDocumentCreateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ZzzUserGeneratedDocumentCreateInput = {
  document: Scalars['ZzzUserGeneratedDocumentInputBase64Json'];
};

export type ZzzUserGeneratedDocumentCreatePayload = {
  __typename?: 'ZzzUserGeneratedDocumentCreatePayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentCreateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzUserGeneratedDocumentData = NgfUserGeneratedDocumentData & {
  __typename?: 'ZzzUserGeneratedDocumentData';
  backgroundImage?: Maybe<Scalars['String']>;
  buildVariants?: Maybe<ZzzUserGeneratedDocumentBuildVariants>;
  childrenIds: Array<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp1?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported */
  gameSpecificProp2?: Maybe<Scalars['Int']>;
  /** @deprecated No longer supported */
  gameSpecificProp3?: Maybe<Scalars['Boolean']>;
  /** @deprecated No longer supported */
  gameSpecificProp4?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** @deprecated Season functionality is no longer used */
  season: ZzzDocumentSeason;
  tierLists: NgfDocumentTierListData;
};

export enum ZzzUserGeneratedDocumentError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
}

export type ZzzUserGeneratedDocumentInputById = {
  /** Unique identifier of a document. Either id or slug is required to get content document. */
  id: Scalars['ID'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ZzzUserGeneratedDocumentInputBySlug = {
  /** Unique human readable identifier of a document. Either id or slug is required to get content document. */
  slug: Scalars['String'];
  /** Document type. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ZzzUserGeneratedDocumentPayload = {
  __typename?: 'ZzzUserGeneratedDocumentPayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzUserGeneratedDocumentSetFavoriteError {
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzUserGeneratedDocumentSetFavoriteInput = {
  id: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
};

export type ZzzUserGeneratedDocumentSetFavoritePayload = {
  __typename?: 'ZzzUserGeneratedDocumentSetFavoritePayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentSetFavoriteError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzUserGeneratedDocumentSetFeaturedError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ZzzUserGeneratedDocumentSetFeaturedInput = {
  documentSlug: Scalars['String'];
  id: Scalars['ID'];
  status: NgfDocumentFeaturedStatus;
};

export type ZzzUserGeneratedDocumentSetFeaturedPayload = {
  __typename?: 'ZzzUserGeneratedDocumentSetFeaturedPayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentSetFeaturedError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzUserGeneratedDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ZzzUserGeneratedDocumentSetSeoPayload = {
  __typename?: 'ZzzUserGeneratedDocumentSetSeoPayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzUserGeneratedDocumentSetStatusError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzUserGeneratedDocumentSetStatusInput = {
  id: Scalars['ID'];
  status: NgfUserGeneratedDocumentStatus;
};

export type ZzzUserGeneratedDocumentSetStatusPayload = {
  __typename?: 'ZzzUserGeneratedDocumentSetStatusPayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentSetStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzUserGeneratedDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  UNIQUE_VIOLATION = 'UNIQUE_VIOLATION',
}

export type ZzzUserGeneratedDocumentUpdateInput = {
  document: Scalars['ZzzUserGeneratedDocumentInputBase64Json'];
  id: Scalars['ID'];
};

export type ZzzUserGeneratedDocumentUpdatePayload = {
  __typename?: 'ZzzUserGeneratedDocumentUpdatePayload';
  data?: Maybe<ZzzUserGeneratedDocument>;
  error?: Maybe<ZzzUserGeneratedDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzUserGeneratedDocumentsListInput = {
  /**
   * If specified, filters by author id.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorId?: InputMaybe<Scalars['ID']>;
  /**
   * If specified, filters by author's profile name.
   * Note: This field is ignored when input is used to list documents via the user profile node.
   */
  authorProfileName?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document status. Specified as list because we have a case when we need to filter by both DRAFT and PUBLISHED statuses. */
  documentStatus?: InputMaybe<Array<NgfUserGeneratedDocumentStatus>>;
  /** If specified, filters by document featured status. */
  featuredStatuses?: InputMaybe<Array<NgfDocumentFeaturedStatus>>;
  /** If specified, filters by document ids. */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If specified, filters documents that were added to favorites by the current user. */
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  /**
   * If set to true, returns only documents authored by users the current user follows.
   * Ignored for anonymous requests.
   */
  isFollowing?: InputMaybe<Scalars['Boolean']>;
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** If specified, filters by document the timeframe when document been published. */
  publishedTimeframe?: InputMaybe<NgfUserGeneratedDocumentsDiscoveryPublishedTimeframe>;
  /** If specified, filters by document season or "current-season" keyword. If "current-season" is passed, the current season will be used. */
  seasonSlug?: InputMaybe<Scalars['String']>;
  /** If set to true, returns documents with non-empty slugifiedName. */
  slugNameIsFilled?: InputMaybe<Scalars['Boolean']>;
  /**
   * If specified, filters by document slugs - human readable version of document id.
   * Slug can be defined only for featured documents, like document ids, they must be unique on game level.
   */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfUserGeneratedDocumentsDiscoverySortingOption>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
  /**
   * If specified, filters by document type.
   * 'profile-default-tab' is a special const, allows to request docs without specifying particular type.
   */
  type?: InputMaybe<Scalars['String']>;
};

export type ZzzUserGeneratedDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};

export type ZzzWeapon = ZzzGameEntity & {
  __typename?: 'ZzzWeapon';
  ascensionMaterials?: Maybe<Array<ZzzAscensionMaterials>>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  defaultLevel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  flavorText?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leveledStats?: Maybe<Array<ZzzLeveledStats>>;
  name: Scalars['String'];
  rarity?: Maybe<ZzzRarity>;
  raritySlug?: Maybe<Scalars['String']>;
  refinement?: Maybe<ZzzRefinement>;
  refinementSlug?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  typeOfEntity?: Maybe<Scalars['String']>;
  weaponType?: Maybe<ZzzWeaponType>;
  weaponTypeSlug?: Maybe<Scalars['String']>;
};

export type ZzzWeaponType = ZzzGameEntity & {
  __typename?: 'ZzzWeaponType';
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type ZzzWeaponTypesFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzWeaponTypesResult = {
  __typename?: 'ZzzWeaponTypesResult';
  data?: Maybe<Array<ZzzWeaponType>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzWeaponsFilter = {
  id?: InputMaybe<OneOfString>;
  name?: InputMaybe<OneOfString>;
  page?: InputMaybe<Page>;
  slug?: InputMaybe<OneOfString>;
};

export type ZzzWeaponsResult = {
  __typename?: 'ZzzWeaponsResult';
  data?: Maybe<Array<ZzzWeapon>>;
  error?: Maybe<ZzzStaticDataError>;
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<Pagination>;
  version?: Maybe<Scalars['String']>;
};

export type ZzzWikiDocument = NgfDocument &
  NgfWikiDocument &
  NgfWikiDocumentMetadata & {
    __typename?: 'ZzzWikiDocument';
    category: NgfDocumentCategory;
    /** @deprecated Use contentV2 */
    content: Array<ZzzDocumentContent>;
    contentV2: Array<NgfDocumentContent>;
    createdAt: Scalars['NgfDateTime'];
    data: ZzzWikiDocumentData;
    documentDescriptor: DocumentDescriptor;
    id: Scalars['ID'];
    /** @deprecated Use permissions from the root object */
    permissions?: Maybe<NgfDocumentPermissions>;
    seo?: Maybe<NgfDocumentSeo>;
    slug: Scalars['String'];
    tags?: Maybe<ZzzDocumentTags>;
    type: Scalars['String'];
    updatedAt: Scalars['NgfDateTime'];
    version: Scalars['Int'];
  };

export type ZzzWikiDocumentData = NgfWikiDocumentData & {
  __typename?: 'ZzzWikiDocumentData';
  category?: Maybe<NgfDocumentCategory>;
  childrenIds: Array<Scalars['String']>;
  crossLinking?: Maybe<NgfWikiDocumentCrossLinking>;
  name: Scalars['String'];
  staticDataEntityV2: ZzzEntityObject;
  tierLists: NgfDocumentTierListData;
};

export enum ZzzWikiDocumentError {
  INTERNAL = 'INTERNAL',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzWikiDocumentInput = {
  /** Unique identifier of a static data entity slug. */
  slug: Scalars['String'];
  /** Identifier of a static data type slug. */
  type: Scalars['String'];
  widgetsOverride?: InputMaybe<Array<NgfCommonWidgetsOverride>>;
};

export type ZzzWikiDocumentPayload = {
  __typename?: 'ZzzWikiDocumentPayload';
  data?: Maybe<ZzzWikiDocument>;
  error?: Maybe<ZzzWikiDocumentError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzWikiDocumentSetSeoError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
}

export type ZzzWikiDocumentSetSeoPayload = {
  __typename?: 'ZzzWikiDocumentSetSeoPayload';
  data?: Maybe<ZzzWikiDocument>;
  error?: Maybe<ZzzWikiDocumentSetSeoError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ZzzWikiDocumentUpdateError {
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL = 'INTERNAL',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
}

export type ZzzWikiDocumentUpdateInput = {
  document: Scalars['ZzzWikiDocumentInputBase64Json'];
  id: Scalars['String'];
};

export type ZzzWikiDocumentUpdatePayload = {
  __typename?: 'ZzzWikiDocumentUpdatePayload';
  data?: Maybe<ZzzWikiDocument>;
  error?: Maybe<ZzzWikiDocumentUpdateError>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ZzzWikiDocumentsListInput = {
  /** If specified, filters by name of the document. */
  name?: InputMaybe<Scalars['String']>;
  /** Defines the way output list is sorted. */
  sortBy?: InputMaybe<NgfWikiDocumentsDiscoverySortingOption>;
  staticDataTypes?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, filters by document tags. */
  tags?: InputMaybe<Array<NgfDocumentWidgetDocumentsDiscoveryInputTagV1>>;
};

export type ZzzWikiDocumentsListPage = {
  /**
   * If specified, filters out document before the specified cursor (forward cursor direction).
   * Backward cursor pagination is not supported as we currently don't have use cases for it.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /** Limits the number of items in response. */
  limit: Scalars['Int'];
};
